import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule, InjectionToken, Injectable, Optional, Inject, forwardRef, Directive, HostListener, Pipe, ContentChild, LOCALE_ID, ViewChild, SkipSelf, ContentChildren, QueryList, ViewEncapsulation, ChangeDetectionStrategy, ErrorHandler, TemplateRef, HostBinding } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DecimalPipe, CurrencyPipe, registerLocaleData, DatePipe, APP_BASE_HREF, DOCUMENT, Location } from '@angular/common';
import { mergeMap, catchError, finalize, map, debounceTime, publishReplay, refCount, filter, switchMap, takeWhile, delay, defaultIfEmpty, tap, shareReplay } from 'rxjs/operators';
import equal from 'deep-equal';
import { createPatch, applyPatch } from 'rfc6902';
import * as i1$1 from '@angular/common/http';
import { HttpErrorResponse, HttpHeaders, HttpParams, HttpClientModule } from '@angular/common/http';
import { of, Subject, ReplaySubject, Observable, BehaviorSubject, noop, forkJoin, iif, interval, combineLatest, takeUntil, from } from 'rxjs';
import * as i1$2 from '@angular/forms';
import { UntypedFormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators, NG_VALIDATORS } from '@angular/forms';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import * as i3 from 'ngx-dropzone';
import { NgxDropzoneModule } from 'ngx-dropzone';
import vanillaMasker from 'vanilla-masker';
import moment$1 from 'moment-mini';
import * as Clipboard from 'clipboard';
import localePt from '@angular/common/locales/pt';
import * as i1$3 from '@angular/platform-browser';
import { BrowserModule, By } from '@angular/platform-browser';
import * as i1$4 from '@angular/router';
import { NavigationEnd, RouterModule, NavigationStart, NavigationCancel, NavigationError, ActivatedRoute, Router } from '@angular/router';
import * as i6 from 'ng-recaptcha';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import * as CryptoJS from 'crypto-js';
import Keycloak from 'keycloak-js';
import { isValid, util } from 'valid.js';
import Handsontable from 'handsontable';
import * as i6$1 from 'ngx-infinite-scroll';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TaskListModalComponent } from '@elotech/angular-components/components/task-list-modal';
import { io } from 'socket.io-client';
import steps from '@elotech/arc/src/assets/components/onboarding/oxy.js';
import Shepherd from 'shepherd.js';
import * as i3$1 from 'ngx-angular-query-builder';
import { NgxAngularQueryBuilderModule } from 'ngx-angular-query-builder';
import { LRUCache } from 'lru-fast';
import { TestBed } from '@angular/core/testing';
import { SpyLocation } from '@angular/common/testing';

class AccordionItemComponent {
    constructor() {
        this.obj = {};
        this.disableClick = false;
        this.hasPermission = true;
        this.onChangeGroupSelected = new EventEmitter();
        this.confirmButtons = new EventEmitter();
        this.addButtons = new EventEmitter();
    }
    clickOnConfirmButtons(indice) {
        this.confirmButtons.emit({ indice });
    }
    changeGroupSelected(indice) {
        this.onChangeGroupSelected.emit({ indice });
    }
    clickOnAddButton(indice, event) {
        event.stopPropagation();
        this.addButtons.emit({ indice });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: AccordionItemComponent, selector: "elo-accordion-item", inputs: { obj: "obj", disableClick: "disableClick", hasPermission: "hasPermission" }, outputs: { onChangeGroupSelected: "onChangeGroupSelected", confirmButtons: "confirmButtons", addButtons: "addButtons" }, ngImport: i0, template: "<div class=\"advtree-header\" (click)=\"changeGroupSelected(obj.indice)\">\n  <div class=\"advtree-title\">\n    <span class=\"id hint module-color top-left\">#\n      <div class=\"hint-content\">\n        #{{obj.indice}} - {{obj.itemSelected ? obj.itemSelected : obj.titleDefault }}\n      </div>\n    </span>\n    <span class=\"title\">{{obj.itemSelected ? obj.itemSelected : obj.titleDefault }}</span>\n  </div>\n\n  <div class=\"advtree-actions\">\n    <button id=\"btnAdvtreeAdd\" class=\"btn circle\" *ngIf=\"!obj.isEditing && hasPermission\" (click)=\"clickOnAddButton(obj.indice, $event)\">\n      <i class=\"fa fa-plus\"></i>\n      <div class=\"btn-actions-label\">\n        Adicionar\n      </div>\n    </button>\n  </div>\n\n</div>\n<ng-content></ng-content>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-accordion-item', template: "<div class=\"advtree-header\" (click)=\"changeGroupSelected(obj.indice)\">\n  <div class=\"advtree-title\">\n    <span class=\"id hint module-color top-left\">#\n      <div class=\"hint-content\">\n        #{{obj.indice}} - {{obj.itemSelected ? obj.itemSelected : obj.titleDefault }}\n      </div>\n    </span>\n    <span class=\"title\">{{obj.itemSelected ? obj.itemSelected : obj.titleDefault }}</span>\n  </div>\n\n  <div class=\"advtree-actions\">\n    <button id=\"btnAdvtreeAdd\" class=\"btn circle\" *ngIf=\"!obj.isEditing && hasPermission\" (click)=\"clickOnAddButton(obj.indice, $event)\">\n      <i class=\"fa fa-plus\"></i>\n      <div class=\"btn-actions-label\">\n        Adicionar\n      </div>\n    </button>\n  </div>\n\n</div>\n<ng-content></ng-content>\n" }]
        }], propDecorators: { obj: [{
                type: Input
            }], disableClick: [{
                type: Input
            }], hasPermission: [{
                type: Input
            }], onChangeGroupSelected: [{
                type: Output
            }], confirmButtons: [{
                type: Output
            }], addButtons: [{
                type: Output
            }] } });

class AccordionComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: AccordionComponent, selector: "elo-accordion", ngImport: i0, template: "<div class=\"advtree\">\n    <div class=\"advtree-container\">\n        <ng-content></ng-content>\n    </div>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-accordion', template: "<div class=\"advtree\">\n    <div class=\"advtree-container\">\n        <ng-content></ng-content>\n    </div>\n</div>\n" }]
        }] });

class PanelComponent {
    constructor() {
        this.pbNone = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PanelComponent, selector: "elo-panel", inputs: { title: "title", hasTable: "hasTable", hasForm: "hasForm", pbNone: "pbNone" }, ngImport: i0, template: "<div class=\"panel\" [ngClass]=\"{'table': hasTable, 'panel-form' : hasForm}\">\n  <h2 class=\"panel-title\" *ngIf=\"title\">\n    {{title}}\n  </h2>\n  <div class=\"panel-body\" [class.pb-none]=\"pbNone\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-panel', template: "<div class=\"panel\" [ngClass]=\"{'table': hasTable, 'panel-form' : hasForm}\">\n  <h2 class=\"panel-title\" *ngIf=\"title\">\n    {{title}}\n  </h2>\n  <div class=\"panel-body\" [class.pb-none]=\"pbNone\">\n    <ng-content></ng-content>\n  </div>\n</div>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], hasTable: [{
                type: Input
            }], hasForm: [{
                type: Input
            }], pbNone: [{
                type: Input
            }] } });

class PanelModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PanelModule, declarations: [PanelComponent], imports: [CommonModule], exports: [PanelComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [PanelComponent],
                    declarations: [PanelComponent]
                }]
        }] });

class FormLabelColumnComponent {
    constructor() {
        this.hintPosition = 'left';
        this.hintIconLeftAlign = false;
        this.linkTitle = '';
        this.showLink = false;
        this.icon = 'fa-question-circle';
        this.onClickLink = new EventEmitter();
        this.offsetClass = '';
    }
    ngOnInit() {
        if (this.offset && this.offset.length > 0) {
            this.offsetClass = `col-md-offset-${this.offset}`;
        }
    }
    clickLink() {
        this.onClickLink.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormLabelColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FormLabelColumnComponent, selector: "elo-form-label-column", inputs: { label: "label", color: "color", column: "column", offset: "offset", hintMessage: "hintMessage", hintPosition: "hintPosition", hintIconLeftAlign: "hintIconLeftAlign", linkTitle: "linkTitle", showLink: "showLink", icon: "icon" }, outputs: { onClickLink: "onClickLink" }, ngImport: i0, template: "<div class=\"col-md-{{column}} {{offsetClass}}\">\n  <div class=\"form-group\">\n    <label class=\"label\" [style.color]=\"color\">\n      {{ !hintIconLeftAlign ? label : '' }}\n      <i *ngIf=\"hintMessage\" class=\"hint fa {{icon}} clean module-color sm inline {{hintPosition}}\">\n        <div class=\"hint-content\" [innerHTML]=\"hintMessage\"></div>\n      </i>\n      {{ hintIconLeftAlign ? label : ''}}\n\n      <a (click)=\"clickLink()\" class=\"pull-right\" *ngIf=\"showLink\">\n        <u id=\"linkTitle\">{{linkTitle}}</u>\n      </a>\n    </label>\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [":host ::ng-deep .hint:not(.input).sm{height:0px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormLabelColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-form-label-column', template: "<div class=\"col-md-{{column}} {{offsetClass}}\">\n  <div class=\"form-group\">\n    <label class=\"label\" [style.color]=\"color\">\n      {{ !hintIconLeftAlign ? label : '' }}\n      <i *ngIf=\"hintMessage\" class=\"hint fa {{icon}} clean module-color sm inline {{hintPosition}}\">\n        <div class=\"hint-content\" [innerHTML]=\"hintMessage\"></div>\n      </i>\n      {{ hintIconLeftAlign ? label : ''}}\n\n      <a (click)=\"clickLink()\" class=\"pull-right\" *ngIf=\"showLink\">\n        <u id=\"linkTitle\">{{linkTitle}}</u>\n      </a>\n    </label>\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [":host ::ng-deep .hint:not(.input).sm{height:0px}\n"] }]
        }], propDecorators: { label: [{
                type: Input
            }], color: [{
                type: Input
            }], column: [{
                type: Input
            }], offset: [{
                type: Input
            }], hintMessage: [{
                type: Input
            }], hintPosition: [{
                type: Input
            }], hintIconLeftAlign: [{
                type: Input
            }], linkTitle: [{
                type: Input
            }], showLink: [{
                type: Input
            }], icon: [{
                type: Input
            }], onClickLink: [{
                type: Output
            }] } });

class FormLabelColumnModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormLabelColumnModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FormLabelColumnModule, declarations: [FormLabelColumnComponent], imports: [CommonModule], exports: [FormLabelColumnComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormLabelColumnModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormLabelColumnModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [FormLabelColumnComponent],
                    exports: [FormLabelColumnComponent]
                }]
        }] });

class AccordionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AccordionModule, declarations: [AccordionComponent,
            AccordionItemComponent], imports: [CommonModule,
            FormLabelColumnModule,
            PanelModule], exports: [AccordionComponent,
            AccordionItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionModule, imports: [CommonModule,
            FormLabelColumnModule,
            PanelModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormLabelColumnModule,
                        PanelModule
                    ],
                    declarations: [
                        AccordionComponent,
                        AccordionItemComponent
                    ],
                    exports: [
                        AccordionComponent,
                        AccordionItemComponent
                    ],
                    providers: []
                }]
        }] });

/**
 * Created by douglas on 17/06/2016.
 */
class PageParameters {
    static newPage(size) {
        return new PageParameters(size, 0, 'ASC');
    }
    constructor(size, page, sort) {
        this.size = 5;
        this.page = 1;
        this.sort = '';
        this.sortWithTranslation = '';
        this.size = size;
        this.page = page;
        this.sort = sort;
    }
    toUrlParameters() {
        let urlParameters = `size=${this.size}`;
        if (this.page) {
            urlParameters += `&page=${this.page}`;
        }
        if (this.sort) {
            urlParameters += `&sort=${this.sortWithTranslation ? this.sortWithTranslation : this.sort}`;
        }
        return urlParameters;
    }
}

const deepCopy = (object) => {
    return JSON.parse(JSON.stringify(object));
};
const deepEqual = equal;

const operationOrder = [1, 0, 2];
var JsonUpdateOperation;
(function (JsonUpdateOperation) {
    JsonUpdateOperation[JsonUpdateOperation["ADD"] = 0] = "ADD";
    JsonUpdateOperation[JsonUpdateOperation["REPLACE"] = 1] = "REPLACE";
    JsonUpdateOperation[JsonUpdateOperation["REMOVE"] = 2] = "REMOVE";
})(JsonUpdateOperation || (JsonUpdateOperation = {}));
class JsonUpdatePartial {
    static replace(value, path) {
        return JsonUpdatePartial.of(JsonUpdateOperation.REPLACE, value, path);
    }
    static add(value, path) {
        return JsonUpdatePartial.of(JsonUpdateOperation.ADD, value, path);
    }
    static remove(value, path) {
        return JsonUpdatePartial.of(JsonUpdateOperation.REMOVE, value, path);
    }
    static of(operation, value, path) {
        if (!path) {
            return null;
        }
        const jsonPartial = new JsonUpdatePartial();
        jsonPartial.op = operation;
        jsonPartial.path = path;
        jsonPartial.value = value;
        if (jsonPartial.op === JsonUpdateOperation.REMOVE) {
            jsonPartial.value = undefined;
        }
        return jsonPartial;
    }
    compare(other) {
        const order = operationOrder[this.op.valueOf()];
        const orderOther = operationOrder[other.op.valueOf()];
        if (order > orderOther) {
            return -1;
        }
        else if (order < orderOther) {
            return 1;
        }
        let compare = 0;
        if (this.op === JsonUpdateOperation.REMOVE) {
            compare = other.path.localeCompare(this.path, 'en-US');
        }
        else {
            compare = this.path.localeCompare(other.path);
        }
        if (compare === 0 && this.value) {
            return this.value.localeCompare(other.value);
        }
        return compare;
    }
}

// @dynamic
class StringUtils {
    static { this.idPattern = /\[\d+\]/g; }
    static { this.uuidPattern = /\[[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}\]/g; }
    static onlyLetters(value) {
        if (value) {
            let result = '';
            let matches = value.match(/[A-z]/g);
            if (matches) {
                matches.forEach(str => result += str);
            }
            return result;
        }
        return value;
    }
    static capitalizeEachWord(phrase) {
        if (!phrase) {
            return '';
        }
        return phrase.split(' ').map((word) => word.toUpperCase()[0] + word.slice(1)).join(' ');
    }
    static toLowerCaseFirstLetter(word) {
        if (!word) {
            return '';
        }
        return word.charAt(0).toLowerCase() + word.substring(1);
    }
    static join(values, delimiter) {
        return values.reduce((prev, current) => {
            if (prev && current) {
                return `${prev} ${delimiter} ${current}`;
            }
            else if (prev) {
                return prev;
            }
            else {
                return current;
            }
        });
    }
    static removeAccent(value) {
        const accents = `ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž´\`~^[]{}!@#$%¨&*()-=+'"/\\`;
        const accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
        value.split('');
        let strAccentsOut = [];
        let strAccentsLen = value.length;
        for (let y = 0; y < strAccentsLen; y++) {
            if (accents.indexOf(value[y]) !== -1) {
                strAccentsOut[y] = accentsOut.substr(accents.indexOf(value[y]), 1);
            }
            else {
                strAccentsOut[y] = value[y];
            }
        }
        return strAccentsOut.join('');
    }
    static removeSpecialCharacters(value) {
        if (!value) {
            return;
        }
        let re = /\[|\]|{|}|\(|\)|~|\^|%|¨|#|`|"|&|/gi;
        return value.replace(re, '');
    }
    static replaceAll(target, search, replacement) {
        return target.split(search).join(replacement);
    }
    static countOccurrence(target, search) {
        let count = 0;
        for (let i = 0; target.length > i; i++) {
            if (target.charAt(i) === search) {
                count++;
            }
        }
        return count;
    }
    static getArrayId(input) {
        let match = input.match(StringUtils.idPattern);
        return match ? match.join(',') : '';
    }
    static removeArrayId(input) {
        return StringUtils.replaceAll(input, StringUtils.idPattern, '');
    }
    static removeArrayUUID(input) {
        return StringUtils.replaceAll(input, StringUtils.uuidPattern, '');
    }
    static getArrayUUID(input) {
        let match = input.match(StringUtils.uuidPattern);
        return match ? match.join(',') : '';
    }
}

class NumberUtils {
    static isNumeric(value) {
        return (value - parseFloat(value) + 1) >= 0;
    }
    static onlyNumbers(value) {
        if (value) {
            return value.replace(/\D/g, '');
        }
        return value;
    }
    static toFixedTrunc(value, n = 2) {
        const f = Math.pow(10, n);
        return (Math.trunc(value * f) / f).toFixed(n);
    }
    static round(value, decimals = 2) {
        const exponential = 'e';
        return Number(Math.round(value + exponential + decimals) + exponential + '-' + decimals);
    }
    static isSameValue(value1, value2, error = 0.001) {
        return Math.abs(NumberUtils.round(value1) - NumberUtils.round(value2)) <= error;
    }
    static sumValue(value1, value2, round = 2) {
        return NumberUtils.round(NumberUtils.round(value1, round) + NumberUtils.round(value2, round), round);
    }
    static sumArray(array, propertyName = '', round = 2) {
        let total = 0;
        array.forEach(item => total = NumberUtils.sumValue(total, propertyName ? item[propertyName] || 0 : item || 0, round));
        return total;
    }
    static calculePercentage(value, percentage) {
        const valueRound = NumberUtils.round(value);
        const percentageRound = NumberUtils.round(percentage);
        return NumberUtils.round(valueRound * percentageRound / 100);
    }
    static calculePercentageValue(value, valueTotal) {
        if (NumberUtils.isSameValue(valueTotal, 0)) {
            return 0;
        }
        return NumberUtils.round((value / valueTotal) * 100);
    }
    static coalesce(value) {
        if (value) {
            return value;
        }
        return 0;
    }
    static abbreviateNumber(value) {
        let newValue = parseInt(value);
        if (newValue >= 1000 || newValue <= -1000) {
            let suffixes = ['', 'Mil', 'Mi', 'Bi', 'Ti'];
            let suffixNum = Math.floor(('' + newValue).length / 3);
            newValue = parseFloat((suffixNum !== 0 ? (newValue / Math.pow(1000, suffixNum)) : newValue));
            if (newValue > -1 && newValue < 1) {
                newValue = newValue * 1000;
                suffixNum--;
            }
            newValue = parseInt(newValue) + ' ' + suffixes[suffixNum];
        }
        return newValue;
    }
}

const CONTAINS_OPERATION = 1;
const EQUAL_OPERATION = 2;
const NOT_EQUAL_OPERATION = 3;
const GREATER_OPERATION = 4;
const LESS_OPERATION = 5;
const GREATER_OR_EQUAL_OPERATION = 6;
const LESS_OR_EQUAL_OPERATION = 7;
const STARTS_WITH_OPERATION = 8;
const ENDS_WITH_OPERATION = 9;
const NOT_CONTAINS_OPERATION = 10;
const CONTAINED_IN_OPERATION = 11;
const NOT_CONTAINED_IN_OPERATION = 12;
const CONTAINS_CAPTION = 'Contém';
const NOT_CONTAINS_CAPTION = 'Não contém';
const STARTS_WITH_CAPTION = 'Inicia com';
const ENDS_WITH_CAPTION = 'Termina com';
const CONTAINED_IN_CAPTION = 'Contido em';
const NOT_CONTAINED_IN_CAPTION = 'Não contido em';

class OperatorsFilter {
    getOperatorsByType() {
        const operatorsByType = new Map();
        operatorsByType.set(['String'], this.getOperation(CONTAINS_OPERATION));
        operatorsByType.set(['String'], this.getOperation(NOT_CONTAINS_OPERATION));
        operatorsByType.set(['String'], this.getOperation(STARTS_WITH_OPERATION));
        operatorsByType.set(['String'], this.getOperation(ENDS_WITH_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'String', 'LocalDate', 'LocalDateTime', 'Enum', 'Boolean', 'Integer'], this.getOperation(EQUAL_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'String', 'LocalDate', 'LocalDateTime', 'Enum', 'Boolean', 'Integer'], this.getOperation(NOT_EQUAL_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'LocalDate', 'Date', 'LocalTime', 'LocalDateTime', 'Integer'], this.getOperation(GREATER_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'LocalDate', 'Date', 'LocalTime', 'LocalDateTime', 'Integer'], this.getOperation(LESS_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'LocalDate', 'Date', 'LocalDateTime', 'Integer'], this.getOperation(GREATER_OR_EQUAL_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'LocalDate', 'Date', 'LocalDateTime', 'Integer'], this.getOperation(LESS_OR_EQUAL_OPERATION));
        operatorsByType.set(['Long', 'Integer', 'String', 'UUID'], this.getOperation(CONTAINED_IN_OPERATION));
        operatorsByType.set(['Long', 'Integer', 'String', 'UUID'], this.getOperation(NOT_CONTAINED_IN_OPERATION));
        return operatorsByType;
    }
    getFilterItemByType() {
        const filterItemByType = new Map();
        filterItemByType.set(['Long'], 'text');
        filterItemByType.set(['BigDecimal'], 'number');
        filterItemByType.set(['Double'], 'number');
        filterItemByType.set(['String'], 'text');
        filterItemByType.set(['LocalDate'], 'date');
        filterItemByType.set(['Date'], 'date');
        filterItemByType.set(['LocalDateTime'], 'dateTime');
        filterItemByType.set(['LocalTime'], 'time');
        filterItemByType.set(['Enum'], '');
        filterItemByType.set(['Boolean'], '');
        filterItemByType.set(['Integer'], 'text');
        filterItemByType.set(['UUID'], 'text');
        return filterItemByType;
    }
    getOperation(id) {
        const operation = this.getOperations().get(id);
        return operation ? { ...operation, id: id } : null;
    }
    getOperations() {
        const operations = new Map();
        operations.set(CONTAINS_OPERATION, { caption: CONTAINS_CAPTION, value: '==' });
        operations.set(NOT_CONTAINS_OPERATION, { caption: NOT_CONTAINS_CAPTION, value: '!=' });
        operations.set(EQUAL_OPERATION, { caption: 'Igual', value: '==' });
        operations.set(NOT_EQUAL_OPERATION, { caption: 'Diferente', value: '!=' });
        operations.set(GREATER_OPERATION, { caption: 'Maior', value: '>' });
        operations.set(LESS_OPERATION, { caption: 'Menor', value: '<' });
        operations.set(GREATER_OR_EQUAL_OPERATION, { caption: 'Maior ou Igual', value: '>=' });
        operations.set(LESS_OR_EQUAL_OPERATION, { caption: 'Menor ou Igual', value: '<=' });
        operations.set(STARTS_WITH_OPERATION, { caption: STARTS_WITH_CAPTION, value: '==' });
        operations.set(ENDS_WITH_OPERATION, { caption: ENDS_WITH_CAPTION, value: '==' });
        operations.set(CONTAINED_IN_OPERATION, { caption: CONTAINED_IN_CAPTION, value: '=ci=' });
        operations.set(NOT_CONTAINED_IN_OPERATION, { caption: NOT_CONTAINED_IN_CAPTION, value: '=nci=' });
        return operations;
    }
}
const operatorsFilter = new OperatorsFilter();

const PIPE_ENCODED = '%7C';
class SearchFilter {
    constructor() {
        this.useQueryParams = true;
        this.strFiltroPage = '';
        this.urlOriginal = '';
    }
    setUseQueryParams(useQueryParams) {
        this.useQueryParams = useQueryParams;
    }
    onFilter(filters, location, activatedRoute, routerService, changeLocation) {
        return this.onFilterCallback(filters, location, activatedRoute, routerService, null, changeLocation);
    }
    onFilterCallback(filters, location, activatedRoute, routerService, callback, changeLocation) {
        this.attrFilters(filters);
        if (callback) {
            callback(filters);
        }
        if (!this.urlOriginal) {
            this.urlOriginal = location.path(true);
            if (this.hasFilter(activatedRoute) && this.useQueryParams) {
                const urlObj = new URL(this.urlOriginal, window.location.origin);
                urlObj.searchParams.delete('filter');
                this.urlOriginal = urlObj.pathname + urlObj.search;
            }
        }
        if (changeLocation) {
            if (filters?.length > 0 && this.useQueryParams) {
                const signal = this.urlOriginal.includes('?') ? '&' : '?';
                const newUrl = this.urlOriginal + signal + 'filter=' + this.serializeFilters(filters);
                location.replaceState(newUrl);
                routerService.setCurrentRoute(newUrl);
            }
            else {
                location.replaceState(this.urlOriginal);
                routerService.setCurrentRoute(this.urlOriginal);
            }
        }
        return this.strFiltroPage;
    }
    handleModel(model, fieldsToDisplay) {
        this.fieldsModels = [];
        if (model && model.fields) {
            for (let i = 0; i < fieldsToDisplay.length; i++) {
                this.addFieldModel(model, fieldsToDisplay[i]);
            }
        }
        return this.fieldsModels;
    }
    attrFilters(filters) {
        let strfiltro = '';
        for (let filter in filters) {
            if (strfiltro !== '') {
                strfiltro = strfiltro + ' and ';
            }
            const operator = operatorsFilter.getOperations().get(filters[filter].op);
            let searchValue = filters[filter].value;
            switch (operator.caption) {
                case CONTAINS_CAPTION:
                case NOT_CONTAINS_CAPTION:
                    searchValue = '*' + StringUtils.removeSpecialCharacters(searchValue) + '*';
                    break;
                case STARTS_WITH_CAPTION:
                    searchValue = StringUtils.removeSpecialCharacters(searchValue) + '*';
                    break;
                case ENDS_WITH_CAPTION:
                    searchValue = '*' + StringUtils.removeSpecialCharacters(searchValue);
            }
            if (this.hasWhiteSpaces(searchValue) && ![CONTAINED_IN_CAPTION, NOT_CONTAINED_IN_CAPTION].includes(operator.caption)) {
                searchValue = `"${searchValue}"`;
            }
            switch (operator.caption) {
                case CONTAINED_IN_CAPTION:
                case NOT_CONTAINED_IN_CAPTION:
                    strfiltro += this.getContainedInFilter(filters[filter].field, searchValue, operator.caption);
                    break;
                default:
                    strfiltro += filters[filter].field + operator.value + searchValue;
            }
        }
        this.strFiltroPage = strfiltro;
        return this.strFiltroPage;
    }
    serializeFilters(filters) {
        return filters.map(filter => {
            if ([CONTAINED_IN_OPERATION, NOT_CONTAINED_IN_OPERATION].includes(filter.op)) {
                filter.value = StringUtils.replaceAll(filter.value, ',', PIPE_ENCODED);
            }
            return `${filter.field};${filter.op};${filter.value}`;
        }).toString();
    }
    addFieldModel(model, fieldsToDisplay, caption) {
        let modelField = model.fields[fieldsToDisplay];
        if (modelField) {
            this.pushFieldModel(caption, modelField);
        }
        else {
            let fieldsSplit = fieldsToDisplay.split('.');
            if (fieldsSplit[0] === fieldsToDisplay) {
                this.pushFieldModel('', {
                    ...model, fieldFullPath: `${model.fieldName}.${fieldsToDisplay}`,
                    calculatedModel: true
                });
            }
            else {
                let modelFieldChild = model.fields[fieldsSplit[0]];
                let fieldsToSplitNexLevel = fieldsSplit.splice(1, fieldsSplit.length);
                let fieldToDisplayChild = fieldsToSplitNexLevel.join('.');
                if (modelFieldChild) {
                    this.addFieldModel(modelFieldChild, fieldToDisplayChild, modelFieldChild.caption);
                }
            }
        }
    }
    pushFieldModel(caption, modelField) {
        this.fieldsModels.push({
            caption: caption ? `${caption} ${modelField.caption}` : modelField.caption,
            dataType: modelField.dataType,
            fieldPath: modelField.calculatedModel ? modelField.fieldPath : modelField.fieldFullPath,
            enumOptions: modelField.enumOptions,
            isEnum: this.isEnum(modelField),
            booleanOptions: modelField.booleanOptions,
            isBoolean: modelField.dataType === 'Boolean' ? true : false,
            isCalculatedModel: modelField.calculatedModel,
            fieldName: modelField.fieldFullPath,
            removeDot: modelField.removeDot || false
        });
    }
    isEnum(modelField) {
        return modelField.enumOptions ? modelField.enumOptions.length > 0 : false;
    }
    hasWhiteSpaces(value) {
        return value.indexOf && value.indexOf(' ') >= 0;
    }
    hasFilter(activatedRoute) {
        return activatedRoute.snapshot.queryParams && activatedRoute.snapshot.queryParams['filter'];
    }
    getContainedInFilter(field, searchValue, operator) {
        const BETWEEN_REGEX = new RegExp(/^(\d+-\d+)$/);
        const UUID_REGEX = new RegExp(/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/);
        let betweenList = [];
        let inList = [];
        let retorno = '';
        searchValue.split(',').forEach(item => {
            if (BETWEEN_REGEX.test(item) && !UUID_REGEX.test(item)) {
                betweenList.push(item);
            }
            else {
                inList.push((NumberUtils.isNumeric(item) || UUID_REGEX.test(item)) ? item : `"${item.trim()}"`);
            }
        });
        if (inList.length > 0) {
            if (operator === CONTAINED_IN_CAPTION) {
                retorno += `${field}=in=(${inList.join(',')})`;
            }
            else {
                retorno += `${field}=out=(${inList.join(',')})`;
            }
        }
        if (betweenList.length > 0) {
            betweenList.forEach(item => {
                let interval = item.split('-');
                if (retorno.length > 0) {
                    if (operator === CONTAINED_IN_CAPTION) {
                        retorno += ' or ';
                    }
                    else {
                        retorno += ' and ';
                    }
                }
                if (operator === CONTAINED_IN_CAPTION) {
                    retorno += `(${field}>=${interval[0]} and ${field}<=${interval[1]})`;
                }
                else {
                    retorno += `(${field}<${interval[0]} or ${field}>${interval[1]})`;
                }
            });
        }
        return `(${retorno})`;
    }
}

class RevisionCompare {
    constructor(path, current, before, after, operation) {
        this.path = path;
        this.current = current;
        this.before = before;
        this.after = after;
        this.operation = operation;
    }
}

class JsonUtil {
    static removeNullKeys(obj) {
        if (obj) {
            for (let propName in obj) {
                if (obj[propName] === null || typeof obj[propName] === 'undefined' || obj[propName] === '') {
                    delete obj[propName];
                }
                else if (Array.isArray(obj[propName])) {
                    let arrayValue = obj[propName];
                    arrayValue.forEach(obj => JsonUtil.removeNullKeys(obj));
                }
                else if (typeof obj[propName] === 'object' && !Array.isArray(obj[propName])) {
                    JsonUtil.removeNullKeys(obj[propName]);
                    if (Object.keys(obj[propName]).length === 0) {
                        delete obj[propName];
                    }
                }
            }
        }
        return obj;
    }
    static orderArraysById(obj) {
        if (obj) {
            for (let propName in obj) {
                if (Array.isArray(obj[propName])) {
                    obj[propName].sort((a, b) => {
                        const valueA = JsonUtil.coalesce(a['id']);
                        const valueB = JsonUtil.coalesce(b['id']);
                        if (valueA < valueB) {
                            return -1;
                        }
                        if (valueA > valueB) {
                            return 1;
                        }
                        return 0;
                    });
                    obj[propName].forEach(e => JsonUtil.orderArraysById(e));
                }
            }
        }
    }
    static flattern(input) {
        let result = {};
        JsonUtil.recurse(input, '', result);
        return result;
    }
    static recurse(current, property, result) {
        if (Object(current) !== current) {
            result[property] = current;
        }
        else if (Array.isArray(current)) {
            // eslint-disable-next-line no-var
            for (var i = 0, j = current.length; i < j; i++) {
                JsonUtil.recurse(current[i], `${property}[${current[i].id ? current[i].id : i}]`, result);
            }
            if (j === 0)
                result[property] = [];
        }
        else {
            let isEmpty = true;
            for (let p in current) {
                isEmpty = false;
                let prop = property ? property + '.' + p : p;
                prop = StringUtils.removeArrayUUID(prop);
                prop = StringUtils.removeArrayId(prop);
                prop = StringUtils.replaceAll(prop, ' ', '');
                JsonUtil.recurse(current[p], property ? property + ' .' + p : p, result);
            }
            if (isEmpty && property)
                result[property] = {};
        }
    }
    static compareJson(before, after) {
        const result = {};
        if (Object.is(before, after)) {
            return undefined;
        }
        if (!after || typeof after !== 'object') {
            return after;
        }
        Object.keys(before || {}).concat(Object.keys(after || {})).forEach(key => {
            if (after[key] !== before[key] && !Object.is(before[key], after[key])) {
                result[key] = after[key];
            }
            if (typeof after[key] === 'object' && typeof before[key] === 'object') {
                const value = JsonUtil.compareJson(before[key], after[key]);
                if (value !== undefined) {
                    result[key] = value;
                }
            }
        });
        return result;
    }
    static replaceKeyWithFieldModel(json, fieldsModel) {
        let result = {};
        let jsonFlatted = this.flattern(json);
        Object.keys(jsonFlatted).forEach(oldJsonKey => {
            let id = `${StringUtils.getArrayUUID(oldJsonKey)}${StringUtils.getArrayId(oldJsonKey)}`;
            let cleanedKey = StringUtils.replaceAll(StringUtils.removeArrayId(StringUtils.removeArrayUUID(oldJsonKey)), ' ', '');
            let newJsonKey = new SearchFilter().handleModel(fieldsModel, [cleanedKey]);
            if (newJsonKey && newJsonKey.length === 1) {
                result[`${newJsonKey[0].caption} ${id}`] = jsonFlatted[oldJsonKey];
            }
            else {
                result[`${newJsonKey} ${id}`] = jsonFlatted[oldJsonKey];
            }
        });
        return result;
    }
    static findCaptionForKeyOnJson(key, modelObj) {
        if (modelObj.fields[key].caption) {
            return modelObj.fields[key].caption;
        }
        else {
            this.findCaptionForKeyOnJson(key, modelObj);
        }
    }
    static getComparisonsFromJson(before, after) {
        let flatterBefore = JsonUtil.flattern(before);
        let flatterAfter = JsonUtil.flattern(after);
        let comparison = JsonUtil.compareJson(flatterBefore, flatterAfter);
        let comparisons = [];
        Object.keys(comparison).forEach((key) => {
            if (Array.isArray(flatterBefore[key]) && flatterBefore[key].length === 0 && !flatterAfter[key]) {
                return;
            }
            if (Array.isArray(flatterAfter[key]) && flatterAfter[key].length === 0 && !flatterBefore[key]) {
                return;
            }
            if (Array.isArray(flatterAfter[key]) && flatterAfter[key].length === 0 && Array.isArray(flatterAfter[key]) && flatterAfter[key].length === 0) {
                return;
            }
            let typeRevision = '';
            if (comparison[key] && !flatterBefore[key]) {
                typeRevision = 'add';
            }
            else if (flatterBefore[key] && !flatterAfter[key]) {
                typeRevision = 'remove';
            }
            else {
                typeRevision = 'update';
            }
            if (!JsonUtil.pathIsUndefinedOrNull(key)) {
                comparison[key] = JsonUtil.replaceBooleanTrueForStringSim(JsonUtil.replaceBooleanFalseForStringNao(JsonUtil.returnEmptyIfUndefined(comparison, key)));
                flatterBefore[key] = JsonUtil.replaceBooleanTrueForStringSim(JsonUtil.replaceBooleanFalseForStringNao(JsonUtil.returnEmptyIfUndefined(flatterBefore, key)));
                flatterAfter[key] = JsonUtil.replaceBooleanTrueForStringSim(JsonUtil.replaceBooleanFalseForStringNao(JsonUtil.returnEmptyIfUndefined(flatterAfter, key)));
                comparisons.push(new RevisionCompare(key, comparison[key], flatterBefore[key], flatterAfter[key], typeRevision));
            }
        });
        return comparisons;
    }
    static pathIsUndefinedOrNull(obj) {
        return obj.trim() === 'undefined' || obj.trim() === '';
    }
    static replaceBooleanTrueForStringSim(obj) {
        return obj === true ? 'Sim' : obj;
    }
    static replaceBooleanFalseForStringNao(obj) {
        return obj === false ? 'Não' : obj;
    }
    static returnEmptyIfUndefined(obj, key) {
        return obj[key] !== undefined ? obj[key] : '';
    }
    static coalesce(value) {
        if (!value) {
            return Number.MAX_VALUE;
        }
        return Number.parseInt(value);
    }
}

const MIN_PATH = 3;
class JsonPatchUtil {
    static getOpByString(op) {
        switch (op) {
            case 'add':
                return JsonUpdateOperation.ADD;
            case 'replace':
                return JsonUpdateOperation.REPLACE;
            case 'remove':
                return JsonUpdateOperation.REMOVE;
            default:
                throw 'not found op';
        }
    }
    static compare(originalObject, actualObject) {
        let copyOriginalObject = deepCopy(originalObject);
        let copyActualObject = deepCopy(actualObject);
        let originalObjCopy = JSON.parse(JSON.stringify(copyOriginalObject));
        JsonUtil.orderArraysById(originalObjCopy);
        JsonUtil.orderArraysById(copyActualObject);
        JsonPatchUtil.adjustRemovedFromArray(originalObjCopy, copyActualObject);
        let patches = createPatch(originalObjCopy, copyActualObject);
        let patchesAdapters = [];
        let originalToPatch = JSON.parse(JSON.stringify(originalObjCopy));
        let patchesArrayReplace = [];
        patches.forEach(patch => {
            let patchesArrayReplaceFilter = patchesArrayReplace.filter(p => patch.path.startsWith(p.path));
            if (patchesArrayReplaceFilter.length === 0 || patch.op !== 'replace') {
                let patchAdapt = JsonPatchUtil.adaptPath(originalToPatch, copyActualObject, patch, patchesArrayReplace);
                if (patchAdapt) {
                    patchesAdapters.push(patchAdapt);
                }
            }
        });
        patchesAdapters = JsonPatchUtil.adaptArrayReplace(patchesAdapters, patchesArrayReplace);
        return patchesAdapters.sort((a, b) => a.compare(b));
    }
    static adaptArrayReplace(patchesAdapters, patchesArrayReplace) {
        patchesArrayReplace.forEach(patchArrayReplace => {
            patchesAdapters = patchesAdapters.filter(patch => !patch.path.startsWith(`${patchArrayReplace.path}/`));
            let path = patchArrayReplace.path.slice(0, patchArrayReplace.path.lastIndexOf('/'));
            patchesAdapters.push(JsonUpdatePartial.of(JsonUpdateOperation.REMOVE, undefined, `${path}/${patchArrayReplace.id}`));
            patchesAdapters.push(JsonUpdatePartial.of(JsonUpdateOperation.ADD, patchArrayReplace.obj, path));
        });
        patchesAdapters.forEach(patch => {
            if (patch.value instanceof Object) {
                patch.value = JSON.stringify(patch.value);
            }
        });
        return patchesAdapters;
    }
    static adaptPath(originalObject, actualObject, patch, patchesArrayReplace) {
        let newPath = '';
        let current = originalObject;
        let currentActual = actualObject;
        let path = patch.path.split('/');
        for (let i = 0; i < path.length; i++) {
            let part = path[i];
            if (current && part !== '') {
                let newPart = part;
                if (Array.isArray(current)) {
                    let arrayCurrent = current;
                    current = arrayCurrent[parseInt(part)];
                    if (currentActual) {
                        currentActual = currentActual[parseInt(part)];
                    }
                    if (current) {
                        newPart = current.id || part;
                        if (patch.op !== 'add' && path[i + 1] === 'id' && current.id) {
                            newPart = part;
                            const patchOnReplace = newPath + '/' + newPart;
                            if (patchesArrayReplace.filter(pr => patchOnReplace.startsWith(pr.path)).length === 0) {
                                patchesArrayReplace.push({ id: current.id, obj: currentActual, path: patchOnReplace });
                            }
                        }
                        else if (patch.op === 'add' && currentActual instanceof Object && !path[i + 1]) {
                            newPart = '';
                        }
                    }
                    else {
                        newPart = '';
                    }
                }
                else {
                    current = current[part];
                    if (currentActual) {
                        currentActual = currentActual[part];
                    }
                }
                if (newPart !== '') {
                    newPath = newPath + '/' + newPart;
                }
            }
        }
        if (Array.isArray(current) && !currentActual) {
            return null;
        }
        applyPatch(originalObject, [patch]);
        const isEmpty = patch.value === null || typeof patch.value === 'undefined' || patch.value === '';
        const patchResult = JsonUpdatePartial.of(JsonPatchUtil.getOpByString(isEmpty ? 'remove' : patch.op), patch.value, newPath);
        return patchResult;
    }
    static adjustRemovedFromArray(originalObject, actualObject) {
        if (!(originalObject instanceof Object)) {
            return;
        }
        for (let key in originalObject) {
            let value = originalObject[key];
            if (Array.isArray(value)) {
                const otherArray = actualObject[key] ? actualObject[key] : [];
                const arrayRemoved = value.filter(obj => otherArray.filter(objOther => obj.id === objOther.id && obj.id).length === 0);
                if (arrayRemoved.length > 0) {
                    const newArray = [];
                    value.forEach(e => {
                        if (arrayRemoved.indexOf(e) < 0) {
                            newArray.push(e);
                        }
                    });
                    arrayRemoved.forEach(e => newArray.push(e));
                    originalObject[key] = newArray;
                }
                value = originalObject[key];
                value.forEach(e => {
                    const otherValue = otherArray.filter(otherObj => otherObj.id === e.id && e.id)[0];
                    if (otherValue) {
                        JsonPatchUtil.adjustRemovedFromArray(e, otherValue);
                    }
                });
            }
            else if (actualObject[key]) {
                JsonPatchUtil.adjustRemovedFromArray(value, actualObject[key]);
            }
        }
    }
}

const APPLICATION_JSON_PATCH = 'application/json-patch+json';

const HttpClientInterceptorToken = new InjectionToken('HttpClientInterceptorToken');

const HTTP_ERROR_LIST = [
    { codigo: 400, descricao: 'Requisição inválida' },
    { codigo: 401, descricao: 'Não autorizado' },
    { codigo: 402, descricao: 'Pagamento necessário' },
    { codigo: 403, descricao: 'Proibido' },
    { codigo: 404, descricao: 'Não encontrado' },
    { codigo: 405, descricao: 'Método não permitido' },
    { codigo: 406, descricao: 'Não Aceitável' },
    { codigo: 407, descricao: 'Autenticação de proxy necessária' },
    { codigo: 408, descricao: 'Tempo de requisição esgotou (Timeout)' },
    { codigo: 409, descricao: 'Conflito' },
    { codigo: 410, descricao: 'Gone' },
    { codigo: 411, descricao: 'comprimento necessário' },
    { codigo: 412, descricao: 'Pré-condição falhou' },
    { codigo: 413, descricao: 'Entidade de solicitação muito grande' },
    { codigo: 414, descricao: 'Pedido-URI Too Long' },
    { codigo: 415, descricao: 'Tipo de mídia não suportado' },
    { codigo: 416, descricao: 'Solicitada de Faixa Não Satisfatória' },
    { codigo: 417, descricao: 'Falha na expectativa' },
    { codigo: 418, descricao: 'Eu sou um bule de chá' },
    { codigo: 422, descricao: 'Entidade improcessável (WebDAV) (RFC codigo: 4918)' },
    { codigo: 423, descricao: 'Fechado (WebDAV) (RFC codigo: 4918)' },
    { codigo: 424, descricao: 'Falha de Dependência (WebDAV) (RFC codigo: 4918)' },
    { codigo: 425, descricao: 'coleção não ordenada (RFC 3648)' },
    { codigo: 426, descricao: 'Upgrade Obrigatório (RFC 2817)' },
    { codigo: 450, descricao: 'bloqueados pelo Controle de Pais do Windows' },
    { codigo: 499, descricao: 'cliente fechou Pedido (utilizado em ERPs/VPSA)' },
    { codigo: 500, descricao: 'Erro interno do servidor (Internal Server Error)' },
    { codigo: 501, descricao: 'Não implementado (Not implemented)' },
    { codigo: 502, descricao: 'Bad Gateway' },
    { codigo: 503, descricao: 'Serviço indisponível (Service Unavailable)' },
    { codigo: 504, descricao: 'Gateway Time-Out' },
    { codigo: 505, descricao: 'HTTP Version not supported' },
    { codigo: 506, descricao: 'VARIANT_ALSO_NEGOTIATES' },
    { codigo: 507, descricao: 'INSUFFICIENT_STORAGE' },
    { codigo: 508, descricao: 'LOOP_DETECTED' },
    { codigo: 509, descricao: 'BANDWIDTH_LIMIT_EXCEEDED' },
    { codigo: 510, descricao: 'NOT_EXTENDED' },
    { codigo: 511, descricao: 'NETWORK_AUTHENTICATION_REQUIRED' },
];

class HttpError {
    static fromServer(errorFromServer) {
        this.throwError(errorFromServer);
    }
    static isError(codigo) {
        let errorFiltered = HTTP_ERROR_LIST.filter((httpError) => {
            return httpError.codigo === codigo;
        });
        return errorFiltered.length > 0;
    }
    static getErrorMessage(codigo) {
        let errorFiltered = HTTP_ERROR_LIST.filter((httpError) => {
            return httpError.codigo === codigo;
        });
        return errorFiltered[0].descricao;
    }
    static async throwErrorBlob(errorFromServer) {
        let error = JSON.parse(await errorFromServer.text());
        if (error.timestamp) {
            const finalDate = new Date(Date.parse(error.timestamp));
            error.timestamp = finalDate;
        }
        HttpError.fromServer(error);
    }
    static throwError(errorFromServer) {
        const httpError = new HttpError(errorFromServer.message, errorFromServer.status, errorFromServer.error);
        httpError.timestamp = errorFromServer.timestamp;
        httpError.exception = errorFromServer.exception;
        httpError.path = errorFromServer.path;
        httpError.detail = errorFromServer.detail;
        httpError.violations = errorFromServer.violations;
        throw httpError;
    }
    constructor(message, status, error) {
        this.violations = [];
        this.message = message;
        this.error = error;
        this.status = status;
    }
}

const SERVER_ERROR = 'Desculpe, isso não está funcionando corretamente. Agora sabemos sobre esse erro e estamos trabalhando para corrigi-lo!';
const CONNECTION_ERROR = 'Erro de conexão com o servidor';
const STATUS_401_MESSAGE = 'Não autorizado';
const STATUS_401 = 401;
class HttpClientUtils {
    static addUrlParameter(url, parameter) {
        let signParameters = '?';
        if (url.includes('?')) {
            signParameters = '&';
        }
        return url + signParameters + parameter;
    }
    static async handleError(error) {
        if (error instanceof HttpErrorResponse) {
            if (error.status === STATUS_401) {
                throw new HttpError(STATUS_401_MESSAGE, error.status, error);
            }
            else {
                if (HttpClientUtils.hasContentTypeJson(error)) {
                    if (error.error instanceof Blob) {
                        await HttpError.throwErrorBlob(error.error);
                    }
                    else {
                        throw HttpError.fromServer(typeof (error.error) === 'string' ? JSON.parse(error.error) : error.error);
                    }
                }
                else {
                    if (error.error?.toString().includes('</html>')) {
                        throw new HttpError(SERVER_ERROR, error.status, error.error);
                    }
                    else {
                        throw new HttpError(error.error && !(error.error instanceof ErrorEvent) ? error.error : CONNECTION_ERROR, error.status);
                    }
                }
            }
        }
        throw new HttpError(CONNECTION_ERROR, 0, error);
    }
    static buildUrlWithBase(httpParams, urlBase) {
        let mountUrl = `${urlBase}${httpParams.resource}`;
        if (httpParams.id) {
            mountUrl += `/${httpParams.id}`;
        }
        if (httpParams.search) {
            let search = httpParams.search;
            try {
                search = decodeURIComponent(httpParams.search);
            }
            catch (error) {
                console.error('Erro ao realizar decode do search', error);
            }
            mountUrl = HttpClientUtils.addUrlParameter(mountUrl, `search=${encodeURIComponent(search.replace(/\n|\r/g, ''))}`);
        }
        if (httpParams.fields) {
            mountUrl = HttpClientUtils.addUrlParameter(mountUrl, `fields=${httpParams.fields}`);
        }
        if (httpParams.page) {
            mountUrl = HttpClientUtils.addUrlParameter(mountUrl, httpParams.page.toUrlParameters());
        }
        return mountUrl;
    }
    static buildUrl(httpParams, urlResolver) {
        let urlBase = httpParams.requestOrigin ? urlResolver.getUrlOrigin() :
            urlResolver.getUrlResolved(httpParams.location);
        return HttpClientUtils.buildUrlWithBase(httpParams, urlBase);
    }
    static getHeaders(extraHeaders) {
        let headers = new HttpHeaders().append('Content-Type', 'application/json');
        if (extraHeaders) {
            extraHeaders.keys().forEach(keyExtra => headers = headers.set(keyExtra, extraHeaders.get(keyExtra)));
        }
        return headers;
    }
    static handleResponse(httpParams, response) {
        if (httpParams.observeResponse) {
            return response;
        }
        return response.body;
    }
    static addToken(httpParams, token) {
        httpParams.headersExtra = httpParams.headersExtra.append('Authorization', 'Bearer ' + token);
    }
    static hasContentTypeJson(response) {
        if (response.headers && response.headers.has('Content-Type')) {
            return response.headers.get('Content-Type').indexOf('json') >= 0;
        }
        return false;
    }
}

/**
 * Classe base para as aplicações definirem sua URL, sendo utilizada através da injeção de dependência.
 * @example
 * class UrlResolverContabilidade extends UrlResolver {
 *    constructor() {
 *      super('contabilidade-api');
 *    }
 * }
 * ...
 * { provide: UrlResolver, useClass: UrlResolverContabilidade }
 */
class UrlResolver {
    constructor(url, urlUserInfo = '') {
        this.url = url;
        this.urlUserInfo = urlUserInfo;
    }
    getUrlResolved(location) {
        if (location) {
            return `${this.getRootUrl(this.url)}${location}`;
        }
        return this.url;
    }
    getUrlOrigin() {
        return window.location.origin;
    }
    getUrlUserInfo() {
        return this.urlUserInfo;
    }
    getRootUrl(url) {
        if (url.includes('http')) {
            return url.toString().replace(/^(.*\/\/[^\/?#]*).*$/, '$1');
        }
        return '';
    }
}

class HttpClient {
    constructor(http, urlResolver, interceptors) {
        this.http = http;
        this.urlResolver = urlResolver;
        this.interceptors = interceptors;
    }
    get(httpParams) {
        httpParams.requestMethod = 'GET';
        return this.request(httpParams);
    }
    post(httpParams) {
        httpParams.requestMethod = 'POST';
        return this.request(httpParams);
    }
    put(httpParams) {
        httpParams.requestMethod = 'PUT';
        return this.request(httpParams);
    }
    patch(httpParams) {
        httpParams.requestMethod = 'PATCH';
        return this.request(httpParams);
    }
    del(httpParams) {
        httpParams.requestMethod = 'DELETE';
        return this.request(httpParams);
    }
    request(httpParams) {
        if (!httpParams.headersExtra) {
            httpParams.headersExtra = new HttpHeaders();
        }
        let observableChain = of(httpParams);
        let interceptorsInstances = this.getInterceptors();
        for (let i = 0; i < interceptorsInstances.length; i++) {
            let interceptorInstance = interceptorsInstances[i];
            if (interceptorInstance.interceptRequest) {
                observableChain = observableChain.pipe(mergeMap(params => interceptorInstance.interceptRequest(params)));
            }
        }
        observableChain = observableChain.pipe(mergeMap(params => this.internalRequest(params)));
        for (let i = 0; i < interceptorsInstances.length; i++) {
            let interceptorInstance = interceptorsInstances[i];
            if (interceptorInstance.interceptResponse) {
                observableChain = observableChain.pipe(mergeMap(response => interceptorInstance.interceptResponse(httpParams, response)));
            }
            if (interceptorInstance.catchError) {
                observableChain = observableChain.pipe(catchError(e => interceptorInstance.catchError(httpParams, e)));
            }
            if (interceptorInstance.finally) {
                observableChain = observableChain.pipe(finalize(() => interceptorInstance.finally(httpParams)));
            }
        }
        return observableChain.pipe(map(response => HttpClientUtils.handleResponse(httpParams, response)), catchError(async (error) => await HttpClientUtils.handleError(error)));
    }
    getInterceptors() {
        if (this.interceptors) {
            return this.interceptors;
        }
        return [];
    }
    internalRequest(httpParams) {
        if (httpParams.requestMethod === 'GET'
            || httpParams.requestMethod === 'DELETE') {
            return this.http.request(httpParams.requestMethod, HttpClientUtils.buildUrl(httpParams, this.urlResolver), {
                headers: HttpClientUtils.getHeaders(httpParams.headersExtra),
                observe: 'response',
                responseType: httpParams.responseType
            });
        }
        if (httpParams.requestMethod === 'POST'
            || httpParams.requestMethod === 'PUT'
            || httpParams.requestMethod === 'PATCH') {
            if (httpParams.requestMethod === 'PATCH') {
                httpParams.headersExtra = httpParams.headersExtra.set('Content-Type', APPLICATION_JSON_PATCH);
            }
            let headers = HttpClientUtils.getHeaders(httpParams.headersExtra);
            if (httpParams.body instanceof FormData) {
                headers = headers.delete('Content-Type');
            }
            return this.http.request(httpParams.requestMethod, HttpClientUtils.buildUrl(httpParams, this.urlResolver), {
                headers: headers,
                observe: 'response',
                body: httpParams.body,
                responseType: httpParams.responseType
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HttpClient, deps: [{ token: i1$1.HttpClient }, { token: UrlResolver }, { token: HttpClientInterceptorToken, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HttpClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HttpClient, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: UrlResolver }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [HttpClientInterceptorToken]
                }] }] });

const PAGE_SIZE = 15;
class EntityService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.fields = [];
        this.ignoreFields = false;
    }
    findOne(id, fields) {
        return this.httpClient.get({
            resource: `${this.resource}`,
            id: `${id}`,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    post(entity, fields) {
        return this.httpClient.post({
            resource: `${this.resource}`,
            body: entity,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    patch(id, patches, fields) {
        return this.httpClient.patch({
            resource: `${this.resource}`,
            body: patches, id: id ? `${id}` : null,
            fields: this.calculeFields(fields),
            location: this.location,
            headersExtra: this.headerExra
        });
    }
    put(id, entity, fields) {
        return this.httpClient.put({
            resource: `${this.resource}`,
            body: entity,
            id: `${id}`,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    remove(id) {
        return this.httpClient.del({
            resource: `${this.resource}`,
            id: `${id}`,
            location: this.location
        });
    }
    print(filter, fields, page) {
        return this.httpClient.get({
            resource: `${this.resource}/report?${page.toUrlParameters()}`,
            responseType: 'text',
            fields: fields,
            search: this.buildSearch(filter),
            location: this.location
        }).pipe(map(html => {
            return URL.createObjectURL(new Blob([html], { type: 'text/html' }));
        }));
    }
    newTemplate() {
        return this.httpClient.get({
            resource: `${this.resource}/template`,
            location: this.location
        });
    }
    findAllUnlimited(fields, pageRequest = new PageParameters(9999)) {
        const requestParams = {
            resource: `${this.resource}`,
            page: pageRequest,
            fields: this.calculeFields(fields),
            location: this.location
        };
        return this.httpClient.get(requestParams).pipe(map(page => page.content));
    }
    findAll(page, search, fields, disableSpinner) {
        return this.httpClient.get({
            resource: `${this.resource}`,
            page: page,
            search: this.buildSearch(search),
            disableSpinner: disableSpinner,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    findToAutoComplete(search, fields, sort = 'id,asc') {
        return this.findAll(new PageParameters(PAGE_SIZE, 0, sort), search, fields, true);
    }
    loadFieldModels(fields = '') {
        return this.httpClient.get({
            resource: `${this.resource}/model`,
            fields: fields
        });
    }
    getFields() {
        return this.fields;
    }
    defaultSearch() {
        return null;
    }
    postOrPatch(entity, entityBefore) {
        if (entity.id) {
            return this.patch(entity.id, JsonPatchUtil.compare(JsonUtil.removeNullKeys(entityBefore), JsonUtil.removeNullKeys(entity)));
        }
        else {
            return this.post(entity);
        }
    }
    calculeFields(fields) {
        if (this.ignoreFields) {
            return null;
        }
        return fields || this.fields.toString();
    }
    buildSearch(search) {
        let defaultSearch = this.defaultSearch();
        if (!search && !defaultSearch) {
            return undefined;
        }
        let finalSearch = '';
        if (defaultSearch) {
            finalSearch += defaultSearch;
            finalSearch += search ? ' and ' : '';
        }
        finalSearch += search ? search : '';
        return finalSearch;
    }
    findToOptions(searchValue) {
        throw new Error('Method not implemented.');
    }
    objToOption(item) {
        throw new Error('Method not implemented.');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntityService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntityService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntityService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

class AppConfigService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.resource = '/api/app-info';
    }
    getUsuarioPadrao() {
        const requestParams = {
            resource: `${this.resource}/usuario`
        };
        return this.httpClient.get(requestParams);
    }
    getExercicios(entidade) {
        const requestParams = {
            resource: `${this.resource}/exercicios/${entidade.id}`
        };
        return this.httpClient.get(requestParams);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppConfigService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppConfigService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppConfigService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

class AssertUtilsApp {
    static assert(value, description) {
        if (!value) {
            throw new Error('Assert fails ' + description);
        }
    }
}

var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["positive"] = 0] = "positive";
    NotificationType[NotificationType["negative"] = 1] = "negative";
    NotificationType[NotificationType["neutral"] = 2] = "neutral";
})(NotificationType || (NotificationType = {}));

class EloNotificationService {
    constructor() {
        this.notificationSource = new Subject();
        this.notificationObservers = this.notificationSource.asObservable();
    }
    success(title, content, routeOwner) {
        this.notificationSource.next({ title: title, content: content, type: NotificationType.positive, routeOwner: routeOwner });
    }
    error(title, content, routeOwner) {
        this.notificationSource.next({ title: title, content: content, type: NotificationType.negative, routeOwner: routeOwner });
    }
    errorObject(title, error, routeOwner) {
        if (error.violations && error.violations.length > 0) {
            error.violations.forEach((violation) => {
                let message = `${violation.fieldName} ${violation.message}`;
                this.notificationSource.next({
                    title: title,
                    content: message.trim(),
                    type: NotificationType.negative,
                    routeOwner: routeOwner
                });
            });
        }
        else {
            this.error(title, error.message, routeOwner);
        }
    }
    info(title, content, routeOwner) {
        this.notificationSource.next({ title: title, content: content, type: NotificationType.neutral, routeOwner: routeOwner });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNotificationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNotificationService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNotificationService, decorators: [{
            type: Injectable
        }] });

class BaseHref {
    static { this.COOKIE_KEY = 'BASE_HREF'; }
    static { this.COOKIE_KEY_UUID = 'BASE_HREF_UUID'; }
    static getRegExp(projectName = '') {
        return RegExp(`${projectName}\/(e([0-9]+|[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})m([0-9]+)a([0-9]+))`);
    }
    static setup(projectName) {
        const windowLocal = WindowService.getWindow();
        const { pathname, search } = window.location;
        const baseHref = BaseHref.extract();
        if (pathname.includes(projectName) &&
            !BaseHref.getRegExp(projectName).test(pathname)) {
            let newPath = pathname.replace(projectName, `${projectName}/${baseHref.value}`);
            if (!!search && !newPath.includes(search)) {
                newPath = `${newPath}${search}`;
            }
            windowLocal.history.replaceState({}, '', newPath);
        }
        return `/${projectName}/${baseHref.value}/`;
    }
    static extract() {
        const pathName = WindowService.getWindow().location.pathname;
        const baseHreftRegExp = BaseHref.getRegExp();
        if (baseHreftRegExp.test(pathName)) {
            const groups = baseHreftRegExp.exec(pathName);
            const idEntidade = this.isEntidadeUUID(groups[2]) ? groups[2] : Number(groups[2]);
            return new BaseHref(idEntidade, Number(groups[3]), Number(groups[4]));
        }
        return new BaseHref().copy(Cookie.get(BaseHref.COOKIE_KEY));
    }
    static testCurrPath() {
        return BaseHref.getRegExp().test(WindowService.getWindow().location.pathname);
    }
    constructor(entidade = 0, mes = new Date().getMonth() + 1, ano = new Date().getFullYear()) {
        this.entidade = entidade;
        this.mes = mes;
        this.ano = ano;
    }
    get value() {
        return `e${this.entidade}m${this.mes}a${this.ano}`;
    }
    change(isIdEntidadeUUID = false) {
        const pathName = WindowService.getWindow().location.pathname;
        const urlParams = WindowService.getWindow().location.search;
        Cookie.set(isIdEntidadeUUID ? BaseHref.COOKIE_KEY_UUID : BaseHref.COOKIE_KEY, JSON.stringify(this), 7, '/', window.location.hostname);
        WindowService.getWindow().history.replaceState({}, '', `${pathName.replace(BaseHref.getRegExp().exec(pathName)[1], this.value)}${urlParams}`);
        WindowService.getWindow().location.reload();
    }
    static isEntidadeUUID(entidadeId = 0) {
        const UUID_REGEX = `[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}`;
        return RegExp(UUID_REGEX).test(entidadeId.toString());
    }
    copy(json) {
        if (json) {
            let jsonObj = JSON.parse(json);
            for (let prop in jsonObj) {
                this[prop] = jsonObj[prop];
            }
        }
        return this;
    }
}

class WindowService {
    static getWindow() {
        return window;
    }
    getHref() {
        return window.location.href;
    }
    openTab(url) {
        return window.open(url, '_blank');
    }
    openTabWithContext(projectName, url) {
        return window.open(`/${projectName}/${BaseHref.extract().value}${url}`, '_blank');
    }
    getUserAgent() {
        return navigator.userAgent;
    }
    downloadBlob(url, fileName) {
        const link = document.createElement('a');
        document.body.appendChild(link);
        link.id = 'blobElement';
        link.style = 'display: none';
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
    }
    refresh() {
        window.location.reload();
    }
    usingSSL() {
        return /^https.*/.test(window.location.protocol);
    }
    base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        let sliceSize = 1024;
        let byteCharacters = atob(base64Data);
        let bytesLength = byteCharacters.length;
        let slicesCount = Math.ceil(bytesLength / sliceSize);
        let byteArrays = new Array(slicesCount);
        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            let begin = sliceIndex * sliceSize;
            let end = Math.min(begin + sliceSize, bytesLength);
            let bytes = new Array(end - begin);
            for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WindowService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WindowService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WindowService, decorators: [{
            type: Injectable
        }] });

class ArquivoComponent {
    constructor(notificationService, windowService) {
        this.notificationService = notificationService;
        this.windowService = windowService;
        this.canRemove = true;
        this.canDownload = true;
        this.canView = true;
        this.canAdd = true;
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.form, 'form');
        AssertUtilsApp.assert(this.service, 'service not found');
        AssertUtilsApp.assert(this.filePath, 'filePath');
        AssertUtilsApp.assert(this.arrayPropertyName, 'arrayPropertyName');
    }
    onView(arquivoSelecionado) {
        this.service.gerarUrlParaDownload(arquivoSelecionado?.arquivo?.fullPath, arquivoSelecionado?.arquivo?.nome).subscribe((response) => {
            fetch(response.urlAssinada)
                .then(data => data.blob())
                .then(blob => {
                const file = new Blob([blob], { type: arquivoSelecionado?.arquivo?.mimeType });
                const fileURL = URL.createObjectURL(file);
                this.windowService.openTab(fileURL);
            })
                .catch(error => this.notificationService.error('Erro!', 'Não foi possível encontrar o arquivo - ' + error.message));
        });
    }
    onDownload(arquivoSelecionado) {
        this.service.gerarUrlParaDownload(arquivoSelecionado?.arquivo?.fullPath, arquivoSelecionado?.arquivo?.nome).subscribe((response) => {
            this.windowService.downloadBlob(response.urlAssinada, arquivoSelecionado?.arquivo?.nome);
        });
    }
    onSelect(event) {
        if (!this.canAdd) {
            return;
        }
        if (event?.addedFiles?.length > 0) {
            event.addedFiles.forEach((file) => {
                if (this.form.get(this.arrayPropertyName).value
                    .some(a => a?.arquivo?.nome === file.name)) {
                    return this.notificationService.error('Atenção!', 'Esse arquivo já foi inserido.');
                }
                this.notificationService.info('Atenção!', 'Adicionando arquivo');
                this.service.gerarUrlParaUpload(this.filePath, file.name, file.type)
                    .subscribe((arquivoUrl) => {
                    this.service.enviarArquivoS3(file, arquivoUrl.urlAssinada)
                        .subscribe(() => {
                        const arquivo = {
                            nome: file.name,
                            mimeType: file.type,
                            tamanhoArquivo: file.size,
                            fullPath: arquivoUrl.fullPath,
                            dataCriacao: arquivoUrl.dataCriacao
                        };
                        this.service.post(arquivo).subscribe((arquivoSaved) => this.form.get(this.arrayPropertyName)
                            .push(new UntypedFormControl({ arquivo: arquivoSaved })));
                        this.form.markAsDirty();
                    }, error => this.notificationService.error('Erro!', 'Não foi possível salvar o arquivo - ' + error.message));
                });
            });
        }
    }
    onRemove(index) {
        this.form.get(this.arrayPropertyName).removeAt(index);
        this.form.markAsDirty();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArquivoComponent, deps: [{ token: EloNotificationService }, { token: WindowService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ArquivoComponent, selector: "arquivo-component", inputs: { canRemove: "canRemove", canDownload: "canDownload", canView: "canView", canAdd: "canAdd", service: "service", form: "form", arrayPropertyName: "arrayPropertyName", filePath: "filePath" }, ngImport: i0, template: "<div class=\"dragdrop\">\n  <ngx-dropzone (change)=\"onSelect($event)\" style=\"all: unset\" *ngIf=\"canAdd\">\n\n    <div tabindex=\"0\" class=\"dropzone\">\n\n      <div class=\"dragdrop-space\" data-message=\"Clique ou arraste arquivos aqui.\">\n        <input id=\"anexos\" type=\"file\" style=\"display:none\" multiple aria-label=\"Campo para anexar arquivos\" />\n      </div>\n\n    </div>\n\n  </ngx-dropzone>\n\n  <div class=\"dropzone\" id=\"nenhumArquivo\" *ngIf=\"!canAdd && !form?.get(arrayPropertyName)?.value?.length\">\n    <div class=\"dragdrop-space\" data-message=\"Nenhum arquivo encontrado.\"></div>\n  </div>\n\n  <ul>\n\n    <li class=\"col-md-12\" *ngFor=\"let arq of form?.get(arrayPropertyName)?.value;let  i = index\">\n\n      <div class=\"dragdrop-item\">\n\n        <div class=\"name\">{{ arq?.arquivo?.nome ? arq?.arquivo?.nome : 'Arquivo sem nome' }}</div>\n        <div class=\"buttons\">\n\n          <button id=\"buttonOnView\" type=\"button\" class=\"btn circle\" (click)=\"onView(arq)\" *ngIf=\"canView\">\n            <i class=\"fa fa-eye\"></i>\n            <div class=\"btn-actions-label\">Visualizar</div>\n          </button>\n\n          <button id=\"buttonOnDownload\" type=\"button\" class=\"btn circle\" (click)=\"onDownload(arq)\" *ngIf=\"canDownload\">\n            <i class=\"fa fa-download\"></i>\n            <div class=\"btn-actions-label\">Download</div>\n          </button>\n\n          <button id=\"buttonOnRemove\" type=\"button\" class=\"btn circle\" (click)=\"onRemove(i)\" *ngIf=\"canRemove\">\n            <i class=\"fa fa-trash\"></i>\n            <div class=\"btn-actions-label\">Excluir</div>\n          </button>\n\n        </div>\n\n      </div>\n    </li>\n\n  </ul>\n\n</div>", dependencies: [{ kind: "component", type: i3.NgxDropzoneComponent, selector: "ngx-dropzone, [ngx-dropzone]", inputs: ["accept", "disabled", "multiple", "maxFileSize", "expandable", "disableClick", "processDirectoryDrop", "id", "aria-label", "aria-labelledby", "aria-describedby"], outputs: ["change"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArquivoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arquivo-component', template: "<div class=\"dragdrop\">\n  <ngx-dropzone (change)=\"onSelect($event)\" style=\"all: unset\" *ngIf=\"canAdd\">\n\n    <div tabindex=\"0\" class=\"dropzone\">\n\n      <div class=\"dragdrop-space\" data-message=\"Clique ou arraste arquivos aqui.\">\n        <input id=\"anexos\" type=\"file\" style=\"display:none\" multiple aria-label=\"Campo para anexar arquivos\" />\n      </div>\n\n    </div>\n\n  </ngx-dropzone>\n\n  <div class=\"dropzone\" id=\"nenhumArquivo\" *ngIf=\"!canAdd && !form?.get(arrayPropertyName)?.value?.length\">\n    <div class=\"dragdrop-space\" data-message=\"Nenhum arquivo encontrado.\"></div>\n  </div>\n\n  <ul>\n\n    <li class=\"col-md-12\" *ngFor=\"let arq of form?.get(arrayPropertyName)?.value;let  i = index\">\n\n      <div class=\"dragdrop-item\">\n\n        <div class=\"name\">{{ arq?.arquivo?.nome ? arq?.arquivo?.nome : 'Arquivo sem nome' }}</div>\n        <div class=\"buttons\">\n\n          <button id=\"buttonOnView\" type=\"button\" class=\"btn circle\" (click)=\"onView(arq)\" *ngIf=\"canView\">\n            <i class=\"fa fa-eye\"></i>\n            <div class=\"btn-actions-label\">Visualizar</div>\n          </button>\n\n          <button id=\"buttonOnDownload\" type=\"button\" class=\"btn circle\" (click)=\"onDownload(arq)\" *ngIf=\"canDownload\">\n            <i class=\"fa fa-download\"></i>\n            <div class=\"btn-actions-label\">Download</div>\n          </button>\n\n          <button id=\"buttonOnRemove\" type=\"button\" class=\"btn circle\" (click)=\"onRemove(i)\" *ngIf=\"canRemove\">\n            <i class=\"fa fa-trash\"></i>\n            <div class=\"btn-actions-label\">Excluir</div>\n          </button>\n\n        </div>\n\n      </div>\n    </li>\n\n  </ul>\n\n</div>" }]
        }], ctorParameters: () => [{ type: EloNotificationService }, { type: WindowService }], propDecorators: { canRemove: [{
                type: Input
            }], canDownload: [{
                type: Input
            }], canView: [{
                type: Input
            }], canAdd: [{
                type: Input
            }], service: [{
                type: Input
            }], form: [{
                type: Input
            }], arrayPropertyName: [{
                type: Input
            }], filePath: [{
                type: Input
            }] } });

class ArquivoModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArquivoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ArquivoModule, declarations: [ArquivoComponent], imports: [NgxDropzoneModule,
            CommonModule], exports: [ArquivoComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArquivoModule, imports: [NgxDropzoneModule,
            CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArquivoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        NgxDropzoneModule,
                        CommonModule
                    ],
                    declarations: [ArquivoComponent],
                    exports: [ArquivoComponent]
                }]
        }] });

class ArvoreAvancadaChildrenSummaryComponent {
    constructor() {
        this.onEdition = new EventEmitter();
        this.onSelecion = new EventEmitter();
        this.onDeletion = new EventEmitter();
    }
    get summaries() {
        return this.children.map(c => c.summary);
    }
    onEdit(event, resume) {
        if (event)
            event.stopPropagation();
        this.onEdition.emit(resume);
    }
    selectNode(event, summary) {
        if (event)
            event.stopPropagation();
        let found = this.children.find(child => child.summary === summary);
        if (found) {
            this.onSelecion.emit(found);
        }
    }
    emitOnDelete(event, summary) {
        if (event)
            event.stopPropagation();
        this.onDeletion.emit(summary);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaChildrenSummaryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ArvoreAvancadaChildrenSummaryComponent, selector: "arvore-avancada-children-resume", inputs: { children: "children" }, outputs: { onEdition: "onEdition", onSelecion: "onSelecion", onDeletion: "onDeletion" }, ngImport: i0, template: `
    <ul class="list ">
      <ng-container *ngFor="let summary of summaries; let i = index">
        <li (click)="selectNode($event, summary)">
          <div class="description">{{summary}}</div>
          <div class="btn-actions">
            <button id="btnEdit-{{i}}" type="button" class="btn circle" (click)="onEdit($event, summary)">
              <i class="fa fa-pencil"></i>
              <div class="btn-actions-label">Editar</div>
            </button>
            <button id="btnRemove-{{i}}" type="button" class="btn circle" (click)="emitOnDelete($event, summary)">
              <i class="fa fa-trash"></i>
              <div class="btn-actions-label">Remover</div>
            </button>
          </div>
        </li>
      </ng-container>
    </ul>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaChildrenSummaryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'arvore-avancada-children-resume',
                    template: `
    <ul class="list ">
      <ng-container *ngFor="let summary of summaries; let i = index">
        <li (click)="selectNode($event, summary)">
          <div class="description">{{summary}}</div>
          <div class="btn-actions">
            <button id="btnEdit-{{i}}" type="button" class="btn circle" (click)="onEdit($event, summary)">
              <i class="fa fa-pencil"></i>
              <div class="btn-actions-label">Editar</div>
            </button>
            <button id="btnRemove-{{i}}" type="button" class="btn circle" (click)="emitOnDelete($event, summary)">
              <i class="fa fa-trash"></i>
              <div class="btn-actions-label">Remover</div>
            </button>
          </div>
        </li>
      </ng-container>
    </ul>
  `
                }]
        }], propDecorators: { children: [{
                type: Input
            }], onEdition: [{
                type: Output
            }], onSelecion: [{
                type: Output
            }], onDeletion: [{
                type: Output
            }] } });

class ArvoreAvancadaNodeFormComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaNodeFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ArvoreAvancadaNodeFormComponent, selector: "arvore-avancada-node-form", inputs: { node: "node" }, ngImport: i0, template: `
    <ng-container *ngTemplateOutlet="node?.formTemplate; context:{ node: node }"></ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaNodeFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'arvore-avancada-node-form',
                    template: `
    <ng-container *ngTemplateOutlet="node?.formTemplate; context:{ node: node }"></ng-container>
  `
                }]
        }], propDecorators: { node: [{
                type: Input
            }] } });

class ArvoreAvancadaNodeHeaderComponent {
    constructor() {
        this.showActions = false;
        this.onHeadClick = new EventEmitter();
    }
    set content(levelHeader) {
        this.headerActions = levelHeader.headerActions;
        this.levelNumber = levelHeader.levelNumber;
        this.levelName = levelHeader.levelName;
        this.hint = levelHeader.hint;
    }
    headClick(node) {
        this.onHeadClick.emit(node);
    }
    ngOnInit() {
        this.content = this.node.header;
    }
    ngOnChanges(changes) {
        this.content = changes['node'].currentValue.header;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaNodeHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ArvoreAvancadaNodeHeaderComponent, selector: "arvore-avancada-node-header", inputs: { showActions: "showActions", node: "node" }, outputs: { onHeadClick: "onHeadClick" }, usesOnChanges: true, ngImport: i0, template: `
    <input type="radio" aria-label="Seletor item árvore" class="advtree-selector" name="advtree-selector" (click)="headClick(node)"/>
    <div class="advtree-header" (click)="headClick(node)">
      <div class="advtree-title">
        <span class="id hint module-color top-left">{{levelNumber}}
            <div class="hint-content" *ngIf="hint">{{hint}}</div>
        </span>
        <span class="title">{{node.summary}}</span>
      </div>
      <div class="advtree-actions" *ngIf="showActions">
        <ng-container *ngTemplateOutlet="headerActions; context: {node: node}">
        </ng-container>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaNodeHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'arvore-avancada-node-header',
                    template: `
    <input type="radio" aria-label="Seletor item árvore" class="advtree-selector" name="advtree-selector" (click)="headClick(node)"/>
    <div class="advtree-header" (click)="headClick(node)">
      <div class="advtree-title">
        <span class="id hint module-color top-left">{{levelNumber}}
            <div class="hint-content" *ngIf="hint">{{hint}}</div>
        </span>
        <span class="title">{{node.summary}}</span>
      </div>
      <div class="advtree-actions" *ngIf="showActions">
        <ng-container *ngTemplateOutlet="headerActions; context: {node: node}">
        </ng-container>
      </div>
    </div>
  `
                }]
        }], propDecorators: { showActions: [{
                type: Input
            }], node: [{
                type: Input
            }], onHeadClick: [{
                type: Output
            }] } });

class ArvoreAvancadaNodeComponent {
    constructor() {
        this.onSelection = new EventEmitter();
        this.showActions = false;
        this.onEdition = new EventEmitter();
        this.onDeletion = new EventEmitter();
        this.onHeadClick = new EventEmitter();
        this.checked = false;
    }
    headClick(node) {
        this.onHeadClick.emit(node);
    }
    emitirSelecionado(node) {
        this.onSelection.emit(node);
    }
    onEditionThen(summary) {
        const found = this._findNode(summary);
        this.onEdition.emit(found);
    }
    onDeletionThen(summary) {
        this.onDeletion.emit(this._findNode(summary));
    }
    _findNode(summary) {
        let found = this.node.children.find(child => child.summary === summary);
        if (found) {
            return found;
        }
        else {
            throw 'Registro não foi encontrado';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaNodeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ArvoreAvancadaNodeComponent, selector: "arvore-avancada-node", inputs: { node: "node", showActions: "showActions", formNode: "formNode" }, outputs: { onSelection: "onSelection", onEdition: "onEdition", onDeletion: "onDeletion", onHeadClick: "onHeadClick" }, ngImport: i0, template: `
    <arvore-avancada-node-header [node]="node"
                                 [showActions]="showActions"
                                 (onHeadClick)="headClick($event)"> 
    </arvore-avancada-node-header>
    <div class="advtree-content">
      <ng-container *ngIf="(formNode | async) as form;else list">
        <arvore-avancada-node-form *ngIf="node.expanded === true"
                                   [node]="form">
        </arvore-avancada-node-form>
      </ng-container>
      <ng-template #list>
        <arvore-avancada-children-resume [children]="node.children"
                                         (onEdition)="onEditionThen($event)"
                                         (onSelecion)="emitirSelecionado($event)"
                                         (onDeletion)="onDeletionThen($event)">
        </arvore-avancada-children-resume>
      </ng-template>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ArvoreAvancadaNodeHeaderComponent, selector: "arvore-avancada-node-header", inputs: ["showActions", "node"], outputs: ["onHeadClick"] }, { kind: "component", type: ArvoreAvancadaNodeFormComponent, selector: "arvore-avancada-node-form", inputs: ["node"] }, { kind: "component", type: ArvoreAvancadaChildrenSummaryComponent, selector: "arvore-avancada-children-resume", inputs: ["children"], outputs: ["onEdition", "onSelecion", "onDeletion"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaNodeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'arvore-avancada-node',
                    template: `
    <arvore-avancada-node-header [node]="node"
                                 [showActions]="showActions"
                                 (onHeadClick)="headClick($event)"> 
    </arvore-avancada-node-header>
    <div class="advtree-content">
      <ng-container *ngIf="(formNode | async) as form;else list">
        <arvore-avancada-node-form *ngIf="node.expanded === true"
                                   [node]="form">
        </arvore-avancada-node-form>
      </ng-container>
      <ng-template #list>
        <arvore-avancada-children-resume [children]="node.children"
                                         (onEdition)="onEditionThen($event)"
                                         (onSelecion)="emitirSelecionado($event)"
                                         (onDeletion)="onDeletionThen($event)">
        </arvore-avancada-children-resume>
      </ng-template>
    </div>
  `
                }]
        }], propDecorators: { node: [{
                type: Input
            }], onSelection: [{
                type: Output
            }], showActions: [{
                type: Input
            }], onEdition: [{
                type: Output
            }], onDeletion: [{
                type: Output
            }], onHeadClick: [{
                type: Output
            }], formNode: [{
                type: Input
            }] } });

class ArvoreAvancadaComponent {
    constructor() {
        this.onSelection = new EventEmitter();
        this.onEdition = new EventEmitter();
        this.onDeletion = new EventEmitter();
        this.onHeadClick = new EventEmitter();
    }
    onDeletionThen(node) {
        this.onDeletion.emit(node);
    }
    headClick(node) {
        this.onHeadClick.emit(node);
    }
    onEditionThen(node) {
        this.onEdition.emit(node);
    }
    emitirSelecionado(node) {
        this.onSelection.emit(node);
    }
    get visibleNodes() {
        return this._getAllNodes().filter(node => node.visible);
    }
    _getAllNodes() {
        let allNodes = [];
        this.nodes.forEach(node => {
            allNodes = [...allNodes, node, ...this._mapChildren(node)];
        });
        return allNodes;
    }
    _mapChildren(node) {
        let result = [];
        if (node.children.length > 0) {
            node.children.forEach(child => {
                result = [...result, child, ...this._mapChildren(child)];
            });
        }
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ArvoreAvancadaComponent, selector: "arvore-avancada", inputs: { nodes: "nodes", formNode: "formNode" }, outputs: { onSelection: "onSelection", onEdition: "onEdition", onDeletion: "onDeletion", onHeadClick: "onHeadClick" }, ngImport: i0, template: `
    <div class="advtree">
      <div class="advtree-container">
        <arvore-avancada-node class="advtree-item" [ngClass]="{'checked': node.expanded}"
                              *ngFor="let node of visibleNodes"
                              [node]="node"
                              [formNode]="formNode"
                              [showActions]="true"
                              (onEdition)="onEditionThen($event)"
                              (onSelection)="emitirSelecionado($event)"
                              (onDeletion)="onDeletionThen($event)"
                              (onHeadClick)="headClick($event)">
        </arvore-avancada-node>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: ArvoreAvancadaNodeComponent, selector: "arvore-avancada-node", inputs: ["node", "showActions", "formNode"], outputs: ["onSelection", "onEdition", "onDeletion", "onHeadClick"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'arvore-avancada',
                    template: `
    <div class="advtree">
      <div class="advtree-container">
        <arvore-avancada-node class="advtree-item" [ngClass]="{'checked': node.expanded}"
                              *ngFor="let node of visibleNodes"
                              [node]="node"
                              [formNode]="formNode"
                              [showActions]="true"
                              (onEdition)="onEditionThen($event)"
                              (onSelection)="emitirSelecionado($event)"
                              (onDeletion)="onDeletionThen($event)"
                              (onHeadClick)="headClick($event)">
        </arvore-avancada-node>
      </div>
    </div>
  `
                }]
        }], propDecorators: { nodes: [{
                type: Input
            }], formNode: [{
                type: Input
            }], onSelection: [{
                type: Output
            }], onEdition: [{
                type: Output
            }], onDeletion: [{
                type: Output
            }], onHeadClick: [{
                type: Output
            }] } });

class ArvoreAvancadaModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaModule, declarations: [ArvoreAvancadaComponent,
            ArvoreAvancadaNodeComponent,
            ArvoreAvancadaNodeHeaderComponent,
            ArvoreAvancadaNodeFormComponent,
            ArvoreAvancadaChildrenSummaryComponent], imports: [CommonModule,
            FormsModule], exports: [ArvoreAvancadaComponent,
            ArvoreAvancadaNodeComponent,
            ArvoreAvancadaNodeHeaderComponent,
            ArvoreAvancadaNodeFormComponent,
            ArvoreAvancadaChildrenSummaryComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaModule, imports: [CommonModule,
            FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArvoreAvancadaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                    ],
                    declarations: [
                        ArvoreAvancadaComponent,
                        ArvoreAvancadaNodeComponent,
                        ArvoreAvancadaNodeHeaderComponent,
                        ArvoreAvancadaNodeFormComponent,
                        ArvoreAvancadaChildrenSummaryComponent,
                    ],
                    exports: [
                        ArvoreAvancadaComponent,
                        ArvoreAvancadaNodeComponent,
                        ArvoreAvancadaNodeHeaderComponent,
                        ArvoreAvancadaNodeFormComponent,
                        ArvoreAvancadaChildrenSummaryComponent,
                    ]
                }]
        }] });

class ObjectUtilService {
    findIndexInSelection(selection, entity) {
        let index = -1;
        if (selection) {
            for (let i = 0; i < selection.length; i++) {
                if (this.equals(entity, selection[i])) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    }
    equals(obj1, obj2) {
        if (obj1 === null && obj2 === null) {
            return true;
        }
        if (obj1 === null || obj2 === null) {
            return false;
        }
        if (obj1 === obj2) {
            return true;
        }
        if (typeof obj1 === 'object' && typeof obj2 === 'object') {
            if (obj1['id'] && obj2['id']) {
                if (obj1['id'] === obj2['id']) {
                    return true;
                }
            }
            for (let p in obj1) {
                if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
                    return false;
                }
                switch (typeof (obj1[p])) {
                    case 'object':
                        if (!this.equals(obj1[p], obj2[p])) {
                            return false;
                        }
                        break;
                    case 'function':
                        if (typeof (obj2[p]) === 'undefined' || (p !== 'compare' && obj1[p].toString() !== obj2[p].toString())) {
                            return false;
                        }
                        break;
                    default:
                        if (obj1[p] !== obj2[p]) {
                            return false;
                        }
                        break;
                }
            }
            for (let prop in obj2) {
                if (typeof (obj1[prop]) === 'undefined') {
                    return false;
                }
            }
            return true;
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ObjectUtilService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ObjectUtilService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ObjectUtilService, decorators: [{
            type: Injectable
        }] });

/**
 * @ToDo implementar name e value
 */
class EloCheckboxComponent {
    constructor() {
        this.label = '';
        this.checkAllowed = true;
        this.titleCheckboxDisallowed = 'Seleção não permitida';
        this.onClick = new EventEmitter();
    }
    clickCheckbox(event) {
        if (this.enable()) {
            this.checked = !this.checked;
            let eloCheckboxEvent = { originalEvent: event, checked: this.checked };
            this.onClick.emit(eloCheckboxEvent);
        }
    }
    enable() {
        return !this.disabled;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloCheckboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloCheckboxComponent, selector: "elo-checkbox", inputs: { id: "id", label: "label", checkAllowed: "checkAllowed", titleCheckboxDisallowed: "titleCheckboxDisallowed", checked: "checked", disabled: "disabled" }, outputs: { onClick: "onClick" }, ngImport: i0, template: `
  <div *ngIf="checkAllowed" class="checkbox-container">
    <input class="checkbox-item-input input-checkbox" id="{{id}}_input_checkbox" type="checkbox" [checked]="checked" (click)="clickCheckbox($event)"
      [disabled]="disabled">
    <label class="checkbox-item-label" for="{{id}}_input_checkbox">{{label}}</label>
  </div>
  <em *ngIf="!checkAllowed" class="fa fa-ban" style="color: #da0e0e" title="{{titleCheckboxDisallowed}}"></em>
`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloCheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-checkbox',
                    template: `
  <div *ngIf="checkAllowed" class="checkbox-container">
    <input class="checkbox-item-input input-checkbox" id="{{id}}_input_checkbox" type="checkbox" [checked]="checked" (click)="clickCheckbox($event)"
      [disabled]="disabled">
    <label class="checkbox-item-label" for="{{id}}_input_checkbox">{{label}}</label>
  </div>
  <em *ngIf="!checkAllowed" class="fa fa-ban" style="color: #da0e0e" title="{{titleCheckboxDisallowed}}"></em>
`
                }]
        }], propDecorators: { id: [{
                type: Input
            }], label: [{
                type: Input
            }], checkAllowed: [{
                type: Input
            }], titleCheckboxDisallowed: [{
                type: Input
            }], checked: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onClick: [{
                type: Output
            }] } });

class ButtonSelectOneComponent {
    constructor() {
        this.onClick = new EventEmitter();
    }
    buttonClick(event) {
        if (this.enable()) {
            this.clicked = !this.clicked;
            let buttonSelectOneEvent = { originalEvent: event, clicked: this.clicked };
            this.onClick.emit(buttonSelectOneEvent);
        }
    }
    enable() {
        return !this.disabled;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonSelectOneComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ButtonSelectOneComponent, selector: "button-select", inputs: { title: "title", clicked: "clicked", disabled: "disabled" }, outputs: { onClick: "onClick" }, ngImport: i0, template: `<div class="btn-actions">
                <div class="btn-actions-inner">
                  <button class="btn ng-star-inserted" type="button" (click)="buttonClick($event)">
                    <i class="fa fa-plus"></i>
                    <div class="btn-actions-label">
                      Adicionar
                    </div>
                  </button>
                </div>
             </div>
            `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonSelectOneComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'button-select',
                    template: `<div class="btn-actions">
                <div class="btn-actions-inner">
                  <button class="btn ng-star-inserted" type="button" (click)="buttonClick($event)">
                    <i class="fa fa-plus"></i>
                    <div class="btn-actions-label">
                      Adicionar
                    </div>
                  </button>
                </div>
             </div>
            `
                }]
        }], propDecorators: { title: [{
                type: Input
            }], clicked: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onClick: [{
                type: Output
            }] } });

const FOCUS_REMOVER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FocusRemoverDirective),
    multi: true
};
class FocusRemoverDirective {
    constructor(elRef) {
        this.elRef = elRef;
        this.removeAutoFocus = true;
    }
    onClick() {
        if (this.removeAutoFocus) {
            this.elRef.nativeElement.blur();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FocusRemoverDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FocusRemoverDirective, selector: "[removeAutoFocus]", inputs: { removeAutoFocus: "removeAutoFocus" }, host: { listeners: { "click": "onClick()" } }, providers: [FOCUS_REMOVER_VALUE_ACCESSOR], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FocusRemoverDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[removeAutoFocus]',
                    providers: [FOCUS_REMOVER_VALUE_ACCESSOR]
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { removeAutoFocus: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * Pipe para formatar numeros na formatação do Brasil (usando . e , nos lugares corretos)
 */
class DecimalFormatPipe {
    transform(value, digits) {
        if (value === null || value === undefined) {
            return '';
        }
        let currencyPipe = new DecimalPipe('pt');
        let newValue = currencyPipe.transform(value, digits);
        return newValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DecimalFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DecimalFormatPipe, name: "decimalformat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DecimalFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'decimalformat'
                }]
        }] });

// @dynamic
class MaskUtils {
    static { this.CPF = 11; }
    static formatCPF(value) {
        value = MaskUtils.replaceCaracteres(value);
        if (value) {
            return vanillaMasker.toPattern(value, '999.999.999-999');
        }
        return value;
    }
    static formatCNPJ(value) {
        value = MaskUtils.replaceCaracteres(value);
        if (value) {
            return vanillaMasker.toPattern(value, '99.999.999/9999-99');
        }
        return value;
    }
    static formatCnpjCpf(value) {
        value = MaskUtils.replaceCaracteres(value);
        if (value) {
            if (value.length <= MaskUtils.CPF) {
                return this.formatCPF(value);
            }
            else {
                return this.formatCNPJ(value);
            }
        }
        return value;
    }
    static formatDias(value) {
        if (value) {
            let pattern = String(value)
                .replace(/[0-9]/g, '9')
                .replace('.', ',') + ' Dia(s)';
            return vanillaMasker.toPattern(value, { pattern: pattern, placeholder: '' });
        }
    }
    static formatPercentual(value) {
        if (value) {
            let pattern = String(value)
                .replace(/[0-9]/g, '9')
                .replace(/\./g, ',');
            return vanillaMasker.toPattern(value, { pattern: `${pattern} %`, placeholder: '0' });
        }
    }
    static formatHora(value) {
        if (value) {
            let pattern = String(value)
                .replace(/[0-9]/g, '9')
                .replace('.', ':');
            return vanillaMasker.toPattern(value, { pattern: pattern, placeholder: '0' });
        }
    }
    static formatCEP(value) {
        value = MaskUtils.replaceCaracteres(value);
        if (value) {
            return vanillaMasker.toPattern(value, '99999-999');
        }
        return value;
    }
    static replaceCaracteres(value) {
        let valueStr = String(value);
        return valueStr.replace(/[\.|\-|\/|(|)|\s]/g, '');
    }
    static formatMoney(value, isOnlyDecimal = false) {
        let valueStr = String(value);
        if (isOnlyDecimal && !valueStr.includes('.')) {
            valueStr = valueStr.concat('.00');
        }
        if (isOnlyDecimal && valueStr.includes('.')) {
            const decimalPart = valueStr.split('.')[1];
            if (decimalPart.length === 1) {
                valueStr = valueStr.concat('0');
            }
        }
        return vanillaMasker.toMoney(valueStr);
    }
    static formatCompetencia(value) {
        return vanillaMasker.toPattern(value, '99/9999');
    }
    static formatTelefoneCelular(value) {
        if (!value) {
            return value;
        }
        else if (value.length === 10) {
            return vanillaMasker.toPattern(value, '(99) 9999-9999');
        }
        else if (value.length === 11) {
            return vanillaMasker.toPattern(value, '(99) 99999-9999');
        }
    }
    static formatByPattern(value, pattern) {
        return vanillaMasker.toPattern(value, pattern.replace(/#/g, 'S'));
    }
}

class CnpjCpfPipe {
    transform(value) {
        return MaskUtils.formatCnpjCpf(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnpjCpfPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnpjCpfPipe, name: "cnpjCpf" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnpjCpfPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cnpjCpf'
                }]
        }] });

const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto',
    'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
class MonthUtils {
    static getMonthName(month) {
        return monthNames[month - 1];
    }
    static getMonths() {
        return monthNames;
    }
}

const FROM_FORMAT = 'YYYY-MM-DD';
const TO_FORMAT = 'DD/MM/YYYY';
const DIA_1 = 1;
const DIA_30 = 30;
const SABADO = 6;
const DOMINGO = 0;
const moment = moment$1;
// @dynamic
class DateUtils {
    static getFormatHtml5() {
        return moment.HTML5_FMT.DATETIME_LOCAL_SECONDS;
    }
    static format(value, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        const formater = moment(value, fromFormat);
        formater.utcOffset(0);
        if (formater.isValid()) {
            return formater.format(toFormat);
        }
        return '';
    }
    static differenceBetweenDays(dataInicio, dataFim) {
        let a = moment(dataInicio);
        let b = moment(dataFim);
        let diffDays = b.diff(a, 'days');
        return diffDays;
    }
    static differenceBetweenMonths(dataInicio, dataFim) {
        let a = moment(dataInicio);
        let b = moment(dataFim);
        let diffMonths = b.diff(a, 'months');
        return diffMonths;
    }
    static differenceBetweenYear(dataInicio, dataFim) {
        let a = moment(dataInicio);
        let b = moment(dataFim);
        let diffMonths = b.diff(a, 'years');
        return diffMonths;
    }
    static now(fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment().toDate(), fromFormat, toFormat);
    }
    static getDateFromString(value, fromFormat = FROM_FORMAT) {
        return moment(value, fromFormat).toDate();
    }
    static getMonthName(month) {
        return MonthUtils.getMonthName(month);
    }
    static smallerDate(dateSelected, date = new Date()) {
        return moment(date, TO_FORMAT).isAfter(dateSelected);
    }
    static isAfterOrEquals(dateSelected, date = new Date()) {
        return moment(date, TO_FORMAT).isSameOrBefore(dateSelected);
    }
    static isBeforeOrEquals(dateSelected, date = new Date()) {
        return moment(date, TO_FORMAT).isSameOrAfter(dateSelected);
    }
    static isDaySmallerDate(dateSelected, date = new Date()) {
        return moment(date, FROM_FORMAT).startOf('day').isAfter(dateSelected);
    }
    static greaterDate(dateSelected, date = new Date()) {
        return moment(date, TO_FORMAT).isBefore(dateSelected);
    }
    static nowHour() {
        return moment().format('HH:mm');
    }
    static addDays(date, daysToAdd, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).add(daysToAdd, 'days'), fromFormat, toFormat);
    }
    static addMonths(date, monthsToAdd, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).add(monthsToAdd, 'months'), fromFormat, toFormat);
    }
    static addYears(date, yearsToAdd, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).add(yearsToAdd, 'years'), fromFormat, toFormat);
    }
    static removeDays(date, daysToRemove, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).subtract(daysToRemove, 'days'), fromFormat, toFormat);
    }
    static removeMonths(date, monthsToRemove, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).subtract(monthsToRemove, 'months'), fromFormat, toFormat);
    }
    static removeYears(date, yearsToRemove, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).subtract(yearsToRemove, 'years'), fromFormat, toFormat);
    }
    static dateTimeFormat(date, hour) {
        return [date, hour].join('T');
    }
    static dateTimeFormatFilter(date) {
        let array = date.split('T');
        return `${this.format(array[0])} - ${array[1]}Hs`;
    }
    static dateStartYear(year) {
        if (year) {
            return `${year}-01-01`;
        }
        else {
            return `${new Date().getFullYear()}-01-01`;
        }
    }
    static dateEndYear(year) {
        if (year) {
            return `${year}-12-31`;
        }
        else {
            return `${new Date().getFullYear()}-12-31`;
        }
    }
    static dateStartMonthYear(date) {
        const dateMoment = moment(date);
        return this.specificDate({ yyyy: dateMoment.year(), mm: dateMoment.month() + 1, dd: 1 });
    }
    static dateEndMonthYear(date) {
        const dateMoment = moment(date);
        return this.specificDate({ yyyy: dateMoment.year(), mm: dateMoment.month() + 1, dd: dateMoment.daysInMonth() });
    }
    static lastDate(month, year) {
        return this.lastMonthDate(new Date(year, month, 1));
    }
    static lastMonthDateMoment(month, year) {
        const daysInMonth = moment(this.lastDate(month, year)).daysInMonth();
        return this.specificDate({ yyyy: year, mm: month + 1, dd: daysInMonth });
    }
    static lastMonthDate(date) {
        if (!date)
            return;
        const year = moment(date).year();
        const month = moment(date).month();
        const daysInMonth = moment(date).daysInMonth();
        return new Date(year, month, daysInMonth);
    }
    static firstDate(month, year) {
        return new Date(year, month, 1);
    }
    static specificDate(dateParam) {
        const date = this.now();
        const { yyyy, mm, dd } = dateParam;
        const [day, month, year] = date.split('/');
        const specificDate = [
            dd || day,
            mm || month,
            yyyy || year
        ].join('-');
        return this.format(specificDate, TO_FORMAT, FROM_FORMAT);
    }
    static getMaxDate(dates) {
        if (dates.length) {
            return DateUtils.format(moment.max(...dates.map(d => moment(d))).toDate(), TO_FORMAT, FROM_FORMAT);
        }
    }
    static getYearByDate(date) {
        if (!date)
            return;
        return moment(date).year();
    }
    static isValid(date) {
        return moment(date).isValid();
    }
    static isWeekend(date) {
        const dayOfWeek = this.getDateFromString(date).getDay();
        return SABADO === dayOfWeek || DOMINGO === dayOfWeek;
    }
    static formatToUTC(value, format) {
        return moment.utc(value, format);
    }
}

const DATEVIEWFORMAT = 'DD/MM/YYYY';
const DATEMODELFORMAT = 'YYYY-MM-DD';
class DateFormatPipe {
    transform(value, viewFormat = DATEVIEWFORMAT, modelFormat = DATEMODELFORMAT) {
        return DateUtils.format(value, modelFormat, viewFormat);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DateFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DateFormatPipe, name: "dateformat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DateFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateformat'
                }]
        }] });

const DATEHOURVIEWFORMAT = 'DD/MM/YYYY HH:mm';
const DATEHOURMODELFORMAT = 'YYYY-MM-DDTHH:mm:ss';
class DateHourFormatPipe {
    transform(value, viewFormat = DATEHOURVIEWFORMAT, modelFormat = DATEHOURMODELFORMAT) {
        const date = DateUtils.formatToUTC(value, DATEHOURMODELFORMAT);
        if (date.isValid()) {
            return date.format(DATEHOURVIEWFORMAT);
        }
        return '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DateHourFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DateHourFormatPipe, name: "datehourformat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DateHourFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'datehourformat'
                }]
        }] });

class EloDataTableRowComponent {
    constructor() {
        this.isQuickViewOpener = false;
        this.selectionModeId = '';
        this.isEditing = {};
        this.index = 0;
        this.rowDoubleClickFunction = null;
        this.visibleRadioWhenFunction = null;
    }
    onRowDoubleClick(object) {
        if (this.rowDoubleClickFunction) {
            this.rowDoubleClickFunction(object);
        }
        else {
            this.table.rowDoubleClick(object);
        }
    }
    onVisibleWhenAttribute(object) {
        return this.visibleRadioWhenFunction ? this.visibleRadioWhenFunction(object) : true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloDataTableRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloDataTableRowComponent, selector: "[elo-row]", inputs: { table: "table", objects: "objects", colSpanActions: "colSpanActions", isQuickViewOpener: "isQuickViewOpener", selectionModeId: "selectionModeId", index: "index", rowDoubleClickFunction: "rowDoubleClickFunction", visibleRadioWhenFunction: "visibleRadioWhenFunction" }, ngImport: i0, template: "<ng-container *ngFor=\"let object of objects; index as i\">\n  <tr id=\"{{'table-line_' + i }}\" [class.highlight]=\"object?.highlight\" [class.warning]=\"object?.warning\"\n    [class.success]=\"object?.success\" [class.error]=\"object?.error\" [class.rowSelected]=\"object?.quickSelected\"\n    [class.reduced]=\"table.manyActions\" (dblclick)=\"onRowDoubleClick(object)\">\n    <td *ngIf=\"table.isMultipleSelectionMode()\" class=\"column-checkbox\">\n      <elo-checkbox id=\"{{object.id ? (selectionModeId + object.id + '_' + i) : selectionModeId + i }}\"\n        [checkAllowed]=\"table.checkAllowed(object)\" [checked]=\"table.isSelected(object)\"\n        [titleCheckboxDisallowed]=\"table.titleCheckboxDisallowed\" (onClick)=\"table.clickCheckBox(object)\"\n        [disabled]=\"table.checkDisabled(object)\">\n      </elo-checkbox>\n    </td>\n    \n    <td *ngIf=\"table.isRadioSelectionMode()\">\n      <input (change)=\"table.clickRadioButton(object)\" class=\"radioinput\" name=\"select-radio\" type=\"radio\" value=\"object\" *ngIf=\"onVisibleWhenAttribute(object)\"\n        [checked]=\"table.isSelected(object)\" />\n    </td>\n\n    <td *ngFor=\"let column of table.eloColumns; let isLast = last;\" [hidden]=\"column.hidden || column.hiddenTableData\"\n      [attr.colspan]=\"isLast ? table.getLastColumnColspan(column) : column.col\" class=\"{{column.class}}\"\n      [ngClass]=\" column.isDecimal ? 'right': ''\" [ngStyle]=\"isLast ? table.getLastColumnStyle(column) : {}\" \n      [style]=\"column.columnStyle\">\n      <b class=\"td-label\">{{column.header}}</b>\n      <span class=\"td-content {{column.class}}\" \n        *ngIf=\"!column.isEditable && !column.isDecimal && !column.isPercentual && !column.isDate && !column.isCnpjCpf && !column.isBoolean && !column.cellTemplate && !column.isDateTime && !column.samp\">{{table?.getValue(object,\n        column.field, column.enumOptions)}}</span>\n      <samp class=\"td-content {{column.class}}\"\n        *ngIf=\"column.samp\">{{table?.getValue(object, column.field,\n        column.enumOptions)}}</samp>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isDecimal && !column.isPercentual && !column.cellTemplate\">{{table?.getValue(object,\n        column.field) | decimalformat: column.digits\n        ? column.digits : \"1.2-2\" }}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isDecimal && column.isPercentual && !column.cellTemplate\">{{table?.getValue(object,\n        column.field) | decimalformat: column.digits\n        ? column.digits : \"1.2-2\" }}%</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isDate && !column.cellTemplate\">{{table?.getValue(object, column.field) |\n        dateformat}}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && !column.isDate && !column.cellTemplate && column.isDateTime\">{{table?.getValue(object,\n        column.field) | datehourformat}}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isCnpjCpf && !column.cellTemplate\">{{table?.getValue(object, column.field) |\n        cnpjCpf}}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isBoolean && !column.cellTemplate\">{{table?.getValue(object, column.field) |\n        dateformat}}</span>\n      <span class=\"td-content {{column.class}}\" *ngIf=\"column.cellTemplate\" [ngTemplateOutlet]=\"column.cellTemplate\"\n        [ngTemplateOutletContext]=\"{column: column, object: object, index: i}\"></span>\n    </td>\n    <td *ngIf=\"table.haveAction()\" [attr.colspan]=\"colSpanActions\" [class.quickViewOpener]=\"isQuickViewOpener\"\n      class=\"has-btn-actions\">\n      <div class=\"btn-actions\" *ngIf=\"table.tableActionVisibleTo(object).length\">\n        <div class=\"btn-actions-inner\">\n          <ng-container *ngFor=\"let action of table.tableActionVisibleTo(object);let i = index\"\n            [ngSwitch]=\"action.type\">\n            <button *ngSwitchCase=\"action.complex()\" class=\"btn\" [removeAutoFocus]=\"action.removeAutoFocus\"\n              [class.error]=\"object?.error && action.showError\" id=\"{{action.id}}_{{i}}\" [class.links]=\"action.hasLinks\"\n              type=\"button\" (click)=\"action.clickIconButton(object)\"\n              (mouseenter)=\"action.hoverIconButton({event: $event, object: object})\">\n              <i class=\"{{action.icon}}\"></i>\n              <div class=\"btn-actions-label\" *ngIf=\"!action.hasLinks\">\n                {{action.title}}\n              </div>\n              <div class=\"btn-actions-label\" *ngIf=\"action.hasLinks\">\n                <a href=\"javascript:void(0)\" *ngFor=\"let link of action.getLinks(object)\"\n                  (click)=\"action.clickLink(object, link)\">{{link}}</a>\n              </div>\n            </button>\n\n            <a *ngSwitchCase=\"action.link()\" href=\"{{action.buildHRef(object)}}\" class=\"btn center\" target=\"_blank\"\n              rel=\"noopener noreferrer\">\n              <i class=\"fa fa-print\" style=\"line-height: 21px\"></i>\n              <div class=\"btn-actions-label\">{{ action.title }}</div>\n            </a>\n          </ng-container>\n        </div>\n      </div>\n    </td>\n\n    <td *ngIf=\"table.isSingleSelectionMode()\">\n      <button-select (click)=\"table.clickSelectOne(object)\">\n        Adicionar\n      </button-select>\n    </td>\n  </tr>\n  <tr class=\"child-table\" *ngIf=\"object?.expand\">\n    <td [attr.colspan]=\"table.columnCount\">\n      <div [ngTemplateOutlet]=\"table.expandTemplate\" [ngTemplateOutletContext]=\"{object: object}\"></div>\n    </td>\n  </tr>\n</ng-container>", styles: [".radioinput:checked{background-color:#358a34;border-color:#358a34}.radioinput{appearance:none;height:15px;border-radius:50%;border-color:#358a34}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: EloCheckboxComponent, selector: "elo-checkbox", inputs: ["id", "label", "checkAllowed", "titleCheckboxDisallowed", "checked", "disabled"], outputs: ["onClick"] }, { kind: "component", type: ButtonSelectOneComponent, selector: "button-select", inputs: ["title", "clicked", "disabled"], outputs: ["onClick"] }, { kind: "directive", type: FocusRemoverDirective, selector: "[removeAutoFocus]", inputs: ["removeAutoFocus"] }, { kind: "pipe", type: DecimalFormatPipe, name: "decimalformat" }, { kind: "pipe", type: CnpjCpfPipe, name: "cnpjCpf" }, { kind: "pipe", type: DateFormatPipe, name: "dateformat" }, { kind: "pipe", type: DateHourFormatPipe, name: "datehourformat" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloDataTableRowComponent, decorators: [{
            type: Component,
            args: [{ selector: '[elo-row]', template: "<ng-container *ngFor=\"let object of objects; index as i\">\n  <tr id=\"{{'table-line_' + i }}\" [class.highlight]=\"object?.highlight\" [class.warning]=\"object?.warning\"\n    [class.success]=\"object?.success\" [class.error]=\"object?.error\" [class.rowSelected]=\"object?.quickSelected\"\n    [class.reduced]=\"table.manyActions\" (dblclick)=\"onRowDoubleClick(object)\">\n    <td *ngIf=\"table.isMultipleSelectionMode()\" class=\"column-checkbox\">\n      <elo-checkbox id=\"{{object.id ? (selectionModeId + object.id + '_' + i) : selectionModeId + i }}\"\n        [checkAllowed]=\"table.checkAllowed(object)\" [checked]=\"table.isSelected(object)\"\n        [titleCheckboxDisallowed]=\"table.titleCheckboxDisallowed\" (onClick)=\"table.clickCheckBox(object)\"\n        [disabled]=\"table.checkDisabled(object)\">\n      </elo-checkbox>\n    </td>\n    \n    <td *ngIf=\"table.isRadioSelectionMode()\">\n      <input (change)=\"table.clickRadioButton(object)\" class=\"radioinput\" name=\"select-radio\" type=\"radio\" value=\"object\" *ngIf=\"onVisibleWhenAttribute(object)\"\n        [checked]=\"table.isSelected(object)\" />\n    </td>\n\n    <td *ngFor=\"let column of table.eloColumns; let isLast = last;\" [hidden]=\"column.hidden || column.hiddenTableData\"\n      [attr.colspan]=\"isLast ? table.getLastColumnColspan(column) : column.col\" class=\"{{column.class}}\"\n      [ngClass]=\" column.isDecimal ? 'right': ''\" [ngStyle]=\"isLast ? table.getLastColumnStyle(column) : {}\" \n      [style]=\"column.columnStyle\">\n      <b class=\"td-label\">{{column.header}}</b>\n      <span class=\"td-content {{column.class}}\" \n        *ngIf=\"!column.isEditable && !column.isDecimal && !column.isPercentual && !column.isDate && !column.isCnpjCpf && !column.isBoolean && !column.cellTemplate && !column.isDateTime && !column.samp\">{{table?.getValue(object,\n        column.field, column.enumOptions)}}</span>\n      <samp class=\"td-content {{column.class}}\"\n        *ngIf=\"column.samp\">{{table?.getValue(object, column.field,\n        column.enumOptions)}}</samp>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isDecimal && !column.isPercentual && !column.cellTemplate\">{{table?.getValue(object,\n        column.field) | decimalformat: column.digits\n        ? column.digits : \"1.2-2\" }}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isDecimal && column.isPercentual && !column.cellTemplate\">{{table?.getValue(object,\n        column.field) | decimalformat: column.digits\n        ? column.digits : \"1.2-2\" }}%</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isDate && !column.cellTemplate\">{{table?.getValue(object, column.field) |\n        dateformat}}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && !column.isDate && !column.cellTemplate && column.isDateTime\">{{table?.getValue(object,\n        column.field) | datehourformat}}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isCnpjCpf && !column.cellTemplate\">{{table?.getValue(object, column.field) |\n        cnpjCpf}}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isBoolean && !column.cellTemplate\">{{table?.getValue(object, column.field) |\n        dateformat}}</span>\n      <span class=\"td-content {{column.class}}\" *ngIf=\"column.cellTemplate\" [ngTemplateOutlet]=\"column.cellTemplate\"\n        [ngTemplateOutletContext]=\"{column: column, object: object, index: i}\"></span>\n    </td>\n    <td *ngIf=\"table.haveAction()\" [attr.colspan]=\"colSpanActions\" [class.quickViewOpener]=\"isQuickViewOpener\"\n      class=\"has-btn-actions\">\n      <div class=\"btn-actions\" *ngIf=\"table.tableActionVisibleTo(object).length\">\n        <div class=\"btn-actions-inner\">\n          <ng-container *ngFor=\"let action of table.tableActionVisibleTo(object);let i = index\"\n            [ngSwitch]=\"action.type\">\n            <button *ngSwitchCase=\"action.complex()\" class=\"btn\" [removeAutoFocus]=\"action.removeAutoFocus\"\n              [class.error]=\"object?.error && action.showError\" id=\"{{action.id}}_{{i}}\" [class.links]=\"action.hasLinks\"\n              type=\"button\" (click)=\"action.clickIconButton(object)\"\n              (mouseenter)=\"action.hoverIconButton({event: $event, object: object})\">\n              <i class=\"{{action.icon}}\"></i>\n              <div class=\"btn-actions-label\" *ngIf=\"!action.hasLinks\">\n                {{action.title}}\n              </div>\n              <div class=\"btn-actions-label\" *ngIf=\"action.hasLinks\">\n                <a href=\"javascript:void(0)\" *ngFor=\"let link of action.getLinks(object)\"\n                  (click)=\"action.clickLink(object, link)\">{{link}}</a>\n              </div>\n            </button>\n\n            <a *ngSwitchCase=\"action.link()\" href=\"{{action.buildHRef(object)}}\" class=\"btn center\" target=\"_blank\"\n              rel=\"noopener noreferrer\">\n              <i class=\"fa fa-print\" style=\"line-height: 21px\"></i>\n              <div class=\"btn-actions-label\">{{ action.title }}</div>\n            </a>\n          </ng-container>\n        </div>\n      </div>\n    </td>\n\n    <td *ngIf=\"table.isSingleSelectionMode()\">\n      <button-select (click)=\"table.clickSelectOne(object)\">\n        Adicionar\n      </button-select>\n    </td>\n  </tr>\n  <tr class=\"child-table\" *ngIf=\"object?.expand\">\n    <td [attr.colspan]=\"table.columnCount\">\n      <div [ngTemplateOutlet]=\"table.expandTemplate\" [ngTemplateOutletContext]=\"{object: object}\"></div>\n    </td>\n  </tr>\n</ng-container>", styles: [".radioinput:checked{background-color:#358a34;border-color:#358a34}.radioinput{appearance:none;height:15px;border-radius:50%;border-color:#358a34}\n"] }]
        }], ctorParameters: () => [], propDecorators: { table: [{
                type: Input
            }], objects: [{
                type: Input
            }], colSpanActions: [{
                type: Input
            }], isQuickViewOpener: [{
                type: Input
            }], selectionModeId: [{
                type: Input
            }], index: [{
                type: Input
            }], rowDoubleClickFunction: [{
                type: Input
            }], visibleRadioWhenFunction: [{
                type: Input
            }] } });

class EloDatatableComponent {
    constructor(eloObjectUtilService) {
        this.eloObjectUtilService = eloObjectUtilService;
        this.emptyMessage = 'Não foram encontrados resultados, adicione registros clicando em + .';
        /**
         * Informar selecionModeId único quando selectionMode for 'multiple' e houver mais de 1 grupo de checkbox
         */
        this.selectionModeId = '';
        /**
         * Irá emitir o elemento selecionado
         */
        this.onClickCheckbox = new EventEmitter();
        /**
         * Irá emitir o elemento selecionado
         */
        this.onClickRadioButton = new EventEmitter();
        /**
         * Emit o click do botão de selecionar apenas um item da linha
         */
        this.onSelectOne = new EventEmitter();
        /**
         * Ira emitir todos os elementos selecionados
         */
        this.onModifySelection = new EventEmitter();
        /**
         * Deve ser setada para que funcione a ordenação no click do header
         */
        this.onTableHeadClick = new EventEmitter();
        /**
         * Deve ser setada para true caso a grid tenha ordenação pela coluna do header
         */
        this.sortable = false;
        this.isQuickViewOpener = false;
        this.manyActions = false;
        this.onInputChange = new EventEmitter();
        this.rowDoubleClickFunction = null;
        this.visibleRadioWhenFunction = null;
        this.onRowDoubleClick = new EventEmitter();
        this.enableScrollX = false;
        this.textTransform = 'capitalize';
        this.headerFixo = false;
        this.showHeader = true;
        this.selectionModeWithFooter = true;
        this.eloColumns = [];
        this.eloTableActions = [];
        this.eloHeaderActions = [];
    }
    get expandTemplate() {
        if (this.childExpandTemplate) {
            return this.childExpandTemplate;
        }
        return this.paramExpandTemplate;
    }
    addColumn(column) {
        let columnFound = this.eloColumns.find(col => col.field === column.field);
        if (columnFound) {
            columnFound.field = column.field;
            columnFound.header = column.header;
            columnFound.isDecimal = column.isDecimal;
            columnFound.isDate = column.isDate;
            columnFound.enumOptions = column.enumOptions;
        }
        else {
            this.eloColumns.push(column);
        }
    }
    addTableActions(tableActions) {
        this.eloTableActions.push(tableActions);
    }
    addTableActionsAt(tableActions, index) {
        this.eloTableActions.splice(index, 0, tableActions);
    }
    addHeaderActions(headerActions) {
        this.eloHeaderActions.push(headerActions);
    }
    isMultipleSelectionMode() {
        return this.selectionMode === 'multiple';
    }
    isSingleSelectionMode() {
        return this.selectionMode === 'single';
    }
    isRadioSelectionMode() {
        return this.selectionMode === 'radio';
    }
    clickSelectAll() {
        this.selectAll();
        this.onModifySelection.emit(this.selection);
    }
    clickHeaderTable(column) {
        if (this.sortable && column.sortable) {
            this.onTableHeadClick.emit(column.field);
        }
    }
    get columnCount() {
        let count;
        this.selectionMode === 'multiple' ? count = 1 : count = 0;
        this.eloColumns.forEach(column => {
            count += 1;
        });
        return count + 1;
    }
    selectAll() {
        if (!this.isAllSelected()) {
            this.selection = this.selectableObjects();
        }
        else {
            this.selection = [];
        }
    }
    selectableObjects() {
        if (this.values) {
            return this.values.filter((obj) => {
                if (this.checkboxDisabledWhenFunction) {
                    return !this.checkboxDisabledWhenFunction(obj);
                }
                if (this.fieldShowCheckbox) {
                    return obj[this.fieldShowCheckbox];
                }
                return true;
            });
        }
    }
    clickCheckBox(entity) {
        this.handleSelection(entity);
        entity.selected = this.isSelected(entity);
        this.onClickCheckbox.emit(entity);
    }
    clickSelectOne(entity) {
        this.handleSelection(entity);
        this.onSelectOne.emit(entity);
    }
    clickRadioButton(entity) {
        this.handleSelection(entity);
        this.onClickRadioButton.emit(entity);
    }
    rowDoubleClick(entity) {
        if (this.rowDoubleClickFunction) {
            this.rowDoubleClickFunction(entity);
        }
        this.onRowDoubleClick.emit(entity);
    }
    handleSelection(entity) {
        let selectionIndex = this.eloObjectUtilService.findIndexInSelection(this.selection, entity);
        this.selection = this.selection || [];
        if (selectionIndex !== -1) { // se está no array, remove
            this.selection.splice(selectionIndex, 1);
        }
        else { // se não está, adiciona ao array dos selecionados
            this.selection.push(entity);
        }
        this.onModifySelection.emit(this.selection);
    }
    isSelected(entity) {
        return this.eloObjectUtilService.findIndexInSelection(this.selection, entity) !== -1;
    }
    isAllSelected() {
        return this.selection && this.selectableObjects() && (this.selection.length === this.selectableObjects().length);
    }
    checkAllowed(object) {
        if (object && this.fieldShowCheckbox) {
            return object[this.fieldShowCheckbox];
        }
        return true;
    }
    checkDisabled(object) {
        if (object && this.checkboxDisabledWhenFunction) {
            return this.checkboxDisabledWhenFunction(object);
        }
        return false;
    }
    tableActionVisibleTo(object) {
        return this.eloTableActionsVisibles.filter(action => {
            if (action.visibleWhenFunction) {
                return action.visibleWhenFunction(object, action);
            }
            return action.visibleWhenAttribute === '' || object[action.visibleWhenAttribute];
        });
    }
    get eloTableActionsVisibles() {
        return this.eloTableActions.filter(action => action.visible);
    }
    haveAction() {
        return this.eloTableActionsVisibles.length > 0 || this.eloHeaderActions.length > 0;
    }
    haveHeaderAction() {
        return this.eloHeaderActions.length > 0 || (this.eloTableActionsVisibles.length > 0 && !this.enableScrollX);
    }
    enableHeaderActionColspan() {
        return this.haveAction() && this.eloHeaderActions.length > 1 && !this.enableScrollX;
    }
    getValue(obj, field, enumOptions) {
        let value = obj;
        field.split('.').forEach(fieldPart => {
            if (!value) {
                return;
            }
            value = value[fieldPart];
        });
        if (enumOptions && enumOptions.length > 0) {
            const optionFound = enumOptions.find(option => option.codigo === value);
            if (optionFound) {
                return optionFound.descricao;
            }
        }
        if (typeof value === 'boolean') {
            return value ? 'Sim' : 'Não';
        }
        return value;
    }
    getSort(column, order) {
        return this.pageParameters.sort
            && this.pageParameters.sort.indexOf(`${column},${order}`) !== -1;
    }
    getLastHeaderStyle(column) {
        return ((column.isDecimal || column.headerAlign === 'right')
            && this.haveHeaderAction() && this.eloHeaderActions.length > 1) ?
            { 'padding-right': '25px' } : {};
    }
    getLastColumnStyle(column) {
        return ((column.isDecimal || column.headerAlign === 'right')
            && this.haveHeaderAction() && this.eloHeaderActions.length > 1) ?
            { 'padding-right': '25px' } : column.dataStyle;
    }
    getLastColumnColspan(column) {
        const col = column.col || 1;
        return (this.haveHeaderAction() && this.eloHeaderActions.length > 1) ? col + 1 : col;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloDatatableComponent, deps: [{ token: ObjectUtilService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloDatatableComponent, selector: "elo-datatable", inputs: { values: "values", paramExpandTemplate: "paramExpandTemplate", emptyMessage: "emptyMessage", selection: "selection", selectionMode: "selectionMode", selectionModeId: "selectionModeId", fieldShowCheckbox: "fieldShowCheckbox", checkboxDisabledWhenFunction: "checkboxDisabledWhenFunction", titleCheckboxDisallowed: "titleCheckboxDisallowed", sortable: "sortable", pageParameters: "pageParameters", class: "class", colSpanActions: "colSpanActions", isQuickViewOpener: "isQuickViewOpener", manyActions: "manyActions", classEmptyMessage: "classEmptyMessage", rowDoubleClickFunction: "rowDoubleClickFunction", visibleRadioWhenFunction: "visibleRadioWhenFunction", enableScrollX: "enableScrollX", textTransform: "textTransform", headerFixo: "headerFixo", showHeader: "showHeader", selectionModeWithFooter: "selectionModeWithFooter" }, outputs: { onClickCheckbox: "onClickCheckbox", onClickRadioButton: "onClickRadioButton", onSelectOne: "onSelectOne", onModifySelection: "onModifySelection", onTableHeadClick: "onTableHeadClick", onInputChange: "onInputChange", onRowDoubleClick: "onRowDoubleClick" }, queries: [{ propertyName: "dataTableFooter", first: true, predicate: ["dataTableFooter"], descendants: true }, { propertyName: "dataTableSubtitles", first: true, predicate: ["dataTableSubtitles"], descendants: true }, { propertyName: "childExpandTemplate", first: true, predicate: ["dataTableExpand"], descendants: true }], ngImport: i0, template: "<div class=\"table table-responsive\" [class.has-header-button]=\"eloHeaderActions?.length === 0\">\n  <div class=\"panel-table-outer\">\n    <ng-content></ng-content>\n    <table class=\"panel-table {{class}}\" [ngClass]=\"headerFixo ? 'fixed' : ''\">\n      <thead [hidden]=\"!values?.length || !showHeader\">\n        <tr>\n          <th *ngIf=\"isMultipleSelectionMode()\" class=\"column-checkbox\">\n            <elo-checkbox id=\"{{selectionModeId}}_header\" (onClick)=\"clickSelectAll()\" [checked]=\"isAllSelected()\">\n            </elo-checkbox>\n          </th>\n\n          <th *ngIf=\"isRadioSelectionMode()\"></th>\n\n          <th *ngFor=\"let column of eloColumns; let isLast = last;\" (click)=\"clickHeaderTable(column)\"\n            [style]=\"'text-transform: '+ textTransform +';'\" [class.right]=\"column.isDecimal\"\n            [class.asc]=\"sortable && getSort(column.field,'asc')\"\n            [class.desc]=\"sortable && getSort(column.field,'desc')\"\n            [class.sortable]=\"sortable && column.sortable && pageParameters.sort.indexOf('column.field') === -1\"\n            [ngClass]=\"column.headerAlign\" [ngStyle]=\"isLast ? getLastHeaderStyle(column) : column.headerStyle\"\n            [hidden]=\"column.hidden || column.hiddenTableData\" [attr.colspan]=\"column.col\">\n            <span *ngIf=\"!column.headerTemplate\" [textContent]=\"column.header\"></span>\n            <span *ngIf=\"column.headerTemplate\" [ngTemplateOutlet]=\"column.headerTemplate\"\n              [ngTemplateOutletContext]=\"{column: column}\"></span>\n          </th>\n\n          <th style=\"width: 8%\" *ngIf=\"isSingleSelectionMode()\">\n            Selecione\n          </th>\n\n          <ng-container *ngIf=\"haveHeaderAction()\">\n            <ng-container *ngIf=\"eloHeaderActions.length > 1;else headerButton\">\n              <th class=\"many-header-buttons\"><i class=\"fa fa-ellipsis-v many-header-buttons-icon\"></i>\n                <div class=\"many-header-buttons-options\">\n                  <ng-container *ngFor=\"let headerAction of eloHeaderActions\">\n                    <ng-container *ngIf=\"headerAction.template; else defaultHeaderButton\">\n                      <ng-container *ngTemplateOutlet=\"headerAction.template\"></ng-container>\n                    </ng-container>\n                    <ng-template #defaultHeaderButton>\n                      <div class=\"header-button\" key=\"header-actions\">\n                        <div class=\"btn-actions\">\n                          <div class=\"btn-actions-inner\">\n                            <button type=\"button\" id=\"{{headerAction.id}}\" class=\"btn circle\"\n                              (click)=\"headerAction.clickIconButton($event)\">\n                              <i class=\"{{headerAction.icon}}\"></i>\n                              <div class=\"btn-actions-label\">\n                                {{headerAction.description}}\n                              </div>\n                            </button>\n                          </div>\n                        </div>\n                      </div>\n                    </ng-template>\n                  </ng-container>\n                </div>\n              </th>\n            </ng-container>\n          </ng-container>\n          <ng-template #headerButton>\n            <ng-container *ngIf=\"eloHeaderActions[0]?.template; else defaultHeaderButton\">\n              <ng-container *ngTemplateOutlet=\"eloHeaderActions[0].template\"></ng-container>\n            </ng-container>\n            <ng-template #defaultHeaderButton>\n              <th class=\"header-button\" key=\"header-actions\">\n                <div class=\"btn-actions\" *ngIf=\"eloHeaderActions[0] as headerAction\">\n                  <div class=\"btn-actions-inner\">\n                    <button type=\"button\" id=\"{{headerAction.id}}\" class=\"btn circle\"\n                      (click)=\"headerAction.clickIconButton($event)\">\n                      <i class=\"{{headerAction.icon}}\"></i>\n                      <div class=\"btn-actions-label\">\n                        {{headerAction.description}}\n                      </div>\n                    </button>\n                  </div>\n                </div>\n              </th>\n            </ng-template>\n          </ng-template>\n\n          <th *ngIf=\"enableHeaderActionColspan()\" class=\"has-btn-actions\"></th>\n        </tr>\n      </thead>\n\n      <tbody elo-row #row [objects]=\"values\" [colSpanActions]=\"colSpanActions\" [isQuickViewOpener]=\"isQuickViewOpener\"\n        [selectionModeId]=\"selectionModeId\" [rowDoubleClickFunction]=\"rowDoubleClickFunction\" [table]=\"this\"\n        [visibleRadioWhenFunction]=\"visibleRadioWhenFunction\">\n      </tbody>\n\n      <tfoot [hidden]=\"values?.length == 0\">\n        <tr *ngIf=\"dataTableFooter\">\n          <ng-container *ngTemplateOutlet=\"dataTableFooter\"></ng-container>\n        </tr>\n        <tr *ngIf=\"selectionModeWithFooter && isMultipleSelectionMode()\">\n          <td>\n            <elo-checkbox id=\"{{selectionModeId}}_footer\" (onClick)=\"clickSelectAll()\" [checked]=\"isAllSelected()\">\n            </elo-checkbox>\n          </td>\n\n          <td [hidden]=\"column.hidden\" *ngFor=\"let column of eloColumns\" [attr.colspan]=\"column.col\"></td>\n\n          <td *ngIf=\"haveAction()\" class=\"has-btn-actions\"></td>\n        </tr>\n      </tfoot>\n\n      <tbody id=\"message-error\" *ngIf=\"!values || values.length == 0\">\n        <tr>\n          <td class=\"center\" colspan=\"100%\">\n            <span class={{classEmptyMessage}} id=\"idEmptyMessageDataTable\">\n              {{emptyMessage}}\n            </span>\n          </td>\n        </tr>\n      </tbody>\n\n    </table>\n\n    <div *ngIf=\"dataTableSubtitles\" class=\"subtitles\">\n      <ng-container *ngTemplateOutlet=\"dataTableSubtitles\"></ng-container>\n    </div>\n\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: EloCheckboxComponent, selector: "elo-checkbox", inputs: ["id", "label", "checkAllowed", "titleCheckboxDisallowed", "checked", "disabled"], outputs: ["onClick"] }, { kind: "component", type: EloDataTableRowComponent, selector: "[elo-row]", inputs: ["table", "objects", "colSpanActions", "isQuickViewOpener", "selectionModeId", "index", "rowDoubleClickFunction", "visibleRadioWhenFunction"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloDatatableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-datatable', template: "<div class=\"table table-responsive\" [class.has-header-button]=\"eloHeaderActions?.length === 0\">\n  <div class=\"panel-table-outer\">\n    <ng-content></ng-content>\n    <table class=\"panel-table {{class}}\" [ngClass]=\"headerFixo ? 'fixed' : ''\">\n      <thead [hidden]=\"!values?.length || !showHeader\">\n        <tr>\n          <th *ngIf=\"isMultipleSelectionMode()\" class=\"column-checkbox\">\n            <elo-checkbox id=\"{{selectionModeId}}_header\" (onClick)=\"clickSelectAll()\" [checked]=\"isAllSelected()\">\n            </elo-checkbox>\n          </th>\n\n          <th *ngIf=\"isRadioSelectionMode()\"></th>\n\n          <th *ngFor=\"let column of eloColumns; let isLast = last;\" (click)=\"clickHeaderTable(column)\"\n            [style]=\"'text-transform: '+ textTransform +';'\" [class.right]=\"column.isDecimal\"\n            [class.asc]=\"sortable && getSort(column.field,'asc')\"\n            [class.desc]=\"sortable && getSort(column.field,'desc')\"\n            [class.sortable]=\"sortable && column.sortable && pageParameters.sort.indexOf('column.field') === -1\"\n            [ngClass]=\"column.headerAlign\" [ngStyle]=\"isLast ? getLastHeaderStyle(column) : column.headerStyle\"\n            [hidden]=\"column.hidden || column.hiddenTableData\" [attr.colspan]=\"column.col\">\n            <span *ngIf=\"!column.headerTemplate\" [textContent]=\"column.header\"></span>\n            <span *ngIf=\"column.headerTemplate\" [ngTemplateOutlet]=\"column.headerTemplate\"\n              [ngTemplateOutletContext]=\"{column: column}\"></span>\n          </th>\n\n          <th style=\"width: 8%\" *ngIf=\"isSingleSelectionMode()\">\n            Selecione\n          </th>\n\n          <ng-container *ngIf=\"haveHeaderAction()\">\n            <ng-container *ngIf=\"eloHeaderActions.length > 1;else headerButton\">\n              <th class=\"many-header-buttons\"><i class=\"fa fa-ellipsis-v many-header-buttons-icon\"></i>\n                <div class=\"many-header-buttons-options\">\n                  <ng-container *ngFor=\"let headerAction of eloHeaderActions\">\n                    <ng-container *ngIf=\"headerAction.template; else defaultHeaderButton\">\n                      <ng-container *ngTemplateOutlet=\"headerAction.template\"></ng-container>\n                    </ng-container>\n                    <ng-template #defaultHeaderButton>\n                      <div class=\"header-button\" key=\"header-actions\">\n                        <div class=\"btn-actions\">\n                          <div class=\"btn-actions-inner\">\n                            <button type=\"button\" id=\"{{headerAction.id}}\" class=\"btn circle\"\n                              (click)=\"headerAction.clickIconButton($event)\">\n                              <i class=\"{{headerAction.icon}}\"></i>\n                              <div class=\"btn-actions-label\">\n                                {{headerAction.description}}\n                              </div>\n                            </button>\n                          </div>\n                        </div>\n                      </div>\n                    </ng-template>\n                  </ng-container>\n                </div>\n              </th>\n            </ng-container>\n          </ng-container>\n          <ng-template #headerButton>\n            <ng-container *ngIf=\"eloHeaderActions[0]?.template; else defaultHeaderButton\">\n              <ng-container *ngTemplateOutlet=\"eloHeaderActions[0].template\"></ng-container>\n            </ng-container>\n            <ng-template #defaultHeaderButton>\n              <th class=\"header-button\" key=\"header-actions\">\n                <div class=\"btn-actions\" *ngIf=\"eloHeaderActions[0] as headerAction\">\n                  <div class=\"btn-actions-inner\">\n                    <button type=\"button\" id=\"{{headerAction.id}}\" class=\"btn circle\"\n                      (click)=\"headerAction.clickIconButton($event)\">\n                      <i class=\"{{headerAction.icon}}\"></i>\n                      <div class=\"btn-actions-label\">\n                        {{headerAction.description}}\n                      </div>\n                    </button>\n                  </div>\n                </div>\n              </th>\n            </ng-template>\n          </ng-template>\n\n          <th *ngIf=\"enableHeaderActionColspan()\" class=\"has-btn-actions\"></th>\n        </tr>\n      </thead>\n\n      <tbody elo-row #row [objects]=\"values\" [colSpanActions]=\"colSpanActions\" [isQuickViewOpener]=\"isQuickViewOpener\"\n        [selectionModeId]=\"selectionModeId\" [rowDoubleClickFunction]=\"rowDoubleClickFunction\" [table]=\"this\"\n        [visibleRadioWhenFunction]=\"visibleRadioWhenFunction\">\n      </tbody>\n\n      <tfoot [hidden]=\"values?.length == 0\">\n        <tr *ngIf=\"dataTableFooter\">\n          <ng-container *ngTemplateOutlet=\"dataTableFooter\"></ng-container>\n        </tr>\n        <tr *ngIf=\"selectionModeWithFooter && isMultipleSelectionMode()\">\n          <td>\n            <elo-checkbox id=\"{{selectionModeId}}_footer\" (onClick)=\"clickSelectAll()\" [checked]=\"isAllSelected()\">\n            </elo-checkbox>\n          </td>\n\n          <td [hidden]=\"column.hidden\" *ngFor=\"let column of eloColumns\" [attr.colspan]=\"column.col\"></td>\n\n          <td *ngIf=\"haveAction()\" class=\"has-btn-actions\"></td>\n        </tr>\n      </tfoot>\n\n      <tbody id=\"message-error\" *ngIf=\"!values || values.length == 0\">\n        <tr>\n          <td class=\"center\" colspan=\"100%\">\n            <span class={{classEmptyMessage}} id=\"idEmptyMessageDataTable\">\n              {{emptyMessage}}\n            </span>\n          </td>\n        </tr>\n      </tbody>\n\n    </table>\n\n    <div *ngIf=\"dataTableSubtitles\" class=\"subtitles\">\n      <ng-container *ngTemplateOutlet=\"dataTableSubtitles\"></ng-container>\n    </div>\n\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: ObjectUtilService }], propDecorators: { values: [{
                type: Input
            }], dataTableFooter: [{
                type: ContentChild,
                args: ['dataTableFooter']
            }], dataTableSubtitles: [{
                type: ContentChild,
                args: ['dataTableSubtitles']
            }], childExpandTemplate: [{
                type: ContentChild,
                args: ['dataTableExpand']
            }], paramExpandTemplate: [{
                type: Input
            }], emptyMessage: [{
                type: Input
            }], selection: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], selectionModeId: [{
                type: Input
            }], fieldShowCheckbox: [{
                type: Input
            }], checkboxDisabledWhenFunction: [{
                type: Input
            }], titleCheckboxDisallowed: [{
                type: Input
            }], onClickCheckbox: [{
                type: Output
            }], onClickRadioButton: [{
                type: Output
            }], onSelectOne: [{
                type: Output
            }], onModifySelection: [{
                type: Output
            }], onTableHeadClick: [{
                type: Output
            }], sortable: [{
                type: Input
            }], pageParameters: [{
                type: Input
            }], class: [{
                type: Input
            }], colSpanActions: [{
                type: Input
            }], isQuickViewOpener: [{
                type: Input
            }], manyActions: [{
                type: Input
            }], onInputChange: [{
                type: Output
            }], classEmptyMessage: [{
                type: Input
            }], rowDoubleClickFunction: [{
                type: Input
            }], visibleRadioWhenFunction: [{
                type: Input
            }], onRowDoubleClick: [{
                type: Output
            }], enableScrollX: [{
                type: Input
            }], textTransform: [{
                type: Input
            }], headerFixo: [{
                type: Input
            }], showHeader: [{
                type: Input
            }], selectionModeWithFooter: [{
                type: Input
            }] } });

class EloColumnComponent {
    constructor(table) {
        this.table = table;
        this.headerAlign = 'left';
        this.isPercentual = false;
        this.isEditable = false;
        this.isEditing = false;
        /**
         * Esconder ou não a coluna
         * Por padrão é mostrada
         */
        this.hidden = false;
        /**
         * Esconder ou não a tag <td> da table
         * Por padrão é mostrada
         */
        this.hiddenTableData = false;
        this.sortable = true;
        this.samp = false;
        this.dataTable = table;
    }
    ngOnInit() {
        this.dataTable.addColumn(this);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloColumnComponent, deps: [{ token: EloDatatableComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloColumnComponent, selector: "elo-column", inputs: { field: "field", header: "header", headerAlign: "headerAlign", isDecimal: "isDecimal", isPercentual: "isPercentual", digits: "digits", isDate: "isDate", isDateTime: "isDateTime", isCnpjCpf: "isCnpjCpf", enumOptions: "enumOptions", col: "col", class: "class", isEditable: "isEditable", isEditing: "isEditing", dataTable: "dataTable", hidden: "hidden", hiddenTableData: "hiddenTableData", sortable: "sortable", samp: "samp", headerStyle: "headerStyle", dataStyle: "dataStyle" }, queries: [{ propertyName: "cellTemplate", first: true, predicate: ["dataTableCell"], descendants: true }, { propertyName: "headerTemplate", first: true, predicate: ["dataTableHeader"], descendants: true }, { propertyName: "validationMessageTemplate", first: true, predicate: ["validationMessage"], descendants: true }], ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-column',
                    template: ''
                }]
        }], ctorParameters: () => [{ type: EloDatatableComponent }], propDecorators: { field: [{
                type: Input
            }], header: [{
                type: Input
            }], headerAlign: [{
                type: Input
            }], isDecimal: [{
                type: Input
            }], isPercentual: [{
                type: Input
            }], digits: [{
                type: Input
            }], isDate: [{
                type: Input
            }], isDateTime: [{
                type: Input
            }], isCnpjCpf: [{
                type: Input
            }], enumOptions: [{
                type: Input
            }], col: [{
                type: Input
            }], cellTemplate: [{
                type: ContentChild,
                args: ['dataTableCell']
            }], headerTemplate: [{
                type: ContentChild,
                args: ['dataTableHeader']
            }], validationMessageTemplate: [{
                type: ContentChild,
                args: ['validationMessage']
            }], class: [{
                type: Input
            }], isEditable: [{
                type: Input
            }], isEditing: [{
                type: Input
            }], dataTable: [{
                type: Input
            }], hidden: [{
                type: Input
            }], hiddenTableData: [{
                type: Input
            }], sortable: [{
                type: Input
            }], samp: [{
                type: Input
            }], headerStyle: [{
                type: Input
            }], dataStyle: [{
                type: Input
            }] } });

class AssinaturaSelectorComponent {
    constructor() {
        this.onSelectAssinatura = new EventEmitter();
        this.assinaturas = [];
        this.assinaturasPadrao = [];
    }
    ngOnInit() {
        if (this.assinaturaService) {
            this.loadAssinaturaList();
        }
    }
    loadAssinaturaList() {
        this.assinaturaService.findAtivos().subscribe(list => {
            this.assinaturas = list;
            this.assinaturasPadrao = [];
            list.forEach(element => {
                if (element.padrao) {
                    this.assinaturasPadrao.push(element);
                }
            });
            this.selectAssinatura(this.assinaturasPadrao);
        });
    }
    selectAssinatura(selecionados) {
        this.assinaturasPadrao = selecionados;
        this.onSelectAssinatura.emit(this.assinaturasPadrao.map((assinatura) => assinatura.id).join('-'));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AssinaturaSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: AssinaturaSelectorComponent, selector: "assinatura-selector", inputs: { assinaturaService: "assinaturaService" }, outputs: { onSelectAssinatura: "onSelectAssinatura" }, ngImport: i0, template: "<div class=\"mt-sm\">\n  <elo-panel title=\"Assinaturas\" [hasForm]=\"true\">\n    <elo-datatable selectionModeId=\"assinaturas\" [emptyMessage]=\"'N\u00E3o foi encontrado assinaturas.'\" id=\"assinaturas\"\n      selectionMode=\"multiple\" [values]=\"assinaturas\" (onModifySelection)=\"selectAssinatura($event)\"\n      [selection]=\"assinaturasPadrao\" [class]=\"'fancy fixed'\">\n      <elo-column field=\"cargo.descricao\" header=\"Cargo\"></elo-column>\n      <elo-column field=\"pessoa\" header=\"Nome\"></elo-column>\n    </elo-datatable>\n  </elo-panel>\n</div>\n", dependencies: [{ kind: "component", type: PanelComponent, selector: "elo-panel", inputs: ["title", "hasTable", "hasForm", "pbNone"] }, { kind: "component", type: EloDatatableComponent, selector: "elo-datatable", inputs: ["values", "paramExpandTemplate", "emptyMessage", "selection", "selectionMode", "selectionModeId", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "titleCheckboxDisallowed", "sortable", "pageParameters", "class", "colSpanActions", "isQuickViewOpener", "manyActions", "classEmptyMessage", "rowDoubleClickFunction", "visibleRadioWhenFunction", "enableScrollX", "textTransform", "headerFixo", "showHeader", "selectionModeWithFooter"], outputs: ["onClickCheckbox", "onClickRadioButton", "onSelectOne", "onModifySelection", "onTableHeadClick", "onInputChange", "onRowDoubleClick"] }, { kind: "component", type: EloColumnComponent, selector: "elo-column", inputs: ["field", "header", "headerAlign", "isDecimal", "isPercentual", "digits", "isDate", "isDateTime", "isCnpjCpf", "enumOptions", "col", "class", "isEditable", "isEditing", "dataTable", "hidden", "hiddenTableData", "sortable", "samp", "headerStyle", "dataStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AssinaturaSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'assinatura-selector', template: "<div class=\"mt-sm\">\n  <elo-panel title=\"Assinaturas\" [hasForm]=\"true\">\n    <elo-datatable selectionModeId=\"assinaturas\" [emptyMessage]=\"'N\u00E3o foi encontrado assinaturas.'\" id=\"assinaturas\"\n      selectionMode=\"multiple\" [values]=\"assinaturas\" (onModifySelection)=\"selectAssinatura($event)\"\n      [selection]=\"assinaturasPadrao\" [class]=\"'fancy fixed'\">\n      <elo-column field=\"cargo.descricao\" header=\"Cargo\"></elo-column>\n      <elo-column field=\"pessoa\" header=\"Nome\"></elo-column>\n    </elo-datatable>\n  </elo-panel>\n</div>\n" }]
        }], propDecorators: { assinaturaService: [{
                type: Input
            }], onSelectAssinatura: [{
                type: Output
            }] } });

class EloHeaderActionsComponent {
    constructor(table) {
        this.table = table;
        this.visible = true;
        this.id = Date.now().toString();
        /**
         * Irá emitir o elemento da linha selecionada
         */
        this.onClickIconButton = new EventEmitter();
        table.addHeaderActions(this);
    }
    clickIconButton(object) {
        this.onClickIconButton.emit(object);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloHeaderActionsComponent, deps: [{ token: EloDatatableComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloHeaderActionsComponent, selector: "elo-header-actions", inputs: { icon: "icon", visible: "visible", id: "id", description: "description", template: "template" }, outputs: { onClickIconButton: "onClickIconButton" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloHeaderActionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-header-actions',
                    template: ''
                }]
        }], ctorParameters: () => [{ type: EloDatatableComponent }], propDecorators: { icon: [{
                type: Input
            }], visible: [{
                type: Input
            }], id: [{
                type: Input
            }], description: [{
                type: Input
            }], template: [{
                type: Input
            }], onClickIconButton: [{
                type: Output
            }] } });

var EloTableActionType;
(function (EloTableActionType) {
    EloTableActionType[EloTableActionType["complex"] = 1] = "complex";
    EloTableActionType[EloTableActionType["link"] = 2] = "link";
})(EloTableActionType || (EloTableActionType = {}));
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class EloTableAction {
    constructor() {
        this.visible = true;
        /**
         * Nome do atributo do objeto que é booleano, se true exibe o table action
         * Caso não seja booleano, está submisso as regras do javascript, por exemplo:
         *
         * number = 0 isso é false
         * null = false
         * undefined = false
         *
         */
        this.visibleWhenAttribute = '';
    }
    complex() {
        return EloTableActionType.complex;
    }
    link() {
        return EloTableActionType.link;
    }
    addOn(table) {
        if (table) {
            table.addTableActions(this);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableAction, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: EloTableAction, inputs: { icon: "icon", visible: "visible", title: "title", id: "id", visibleWhenAttribute: "visibleWhenAttribute", visibleWhenFunction: "visibleWhenFunction" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableAction, decorators: [{
            type: Directive
        }], propDecorators: { icon: [{
                type: Input
            }], visible: [{
                type: Input
            }], title: [{
                type: Input
            }], id: [{
                type: Input
            }], visibleWhenAttribute: [{
                type: Input
            }], visibleWhenFunction: [{
                type: Input
            }] } });

class EloTableActionLinkComponent extends EloTableAction {
    get type() {
        return EloTableActionType.link;
    }
    constructor(table) {
        super();
        this.table = table;
        this.onBuildHRef = new EventEmitter();
        this.addOn(table);
    }
    buildHRef(value) {
        let href = '';
        let buildHrefEvent = {
            href: href,
            object: value
        };
        this.onBuildHRef.emit(buildHrefEvent);
        return buildHrefEvent.href;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableActionLinkComponent, deps: [{ token: EloDatatableComponent, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloTableActionLinkComponent, selector: "elo-table-action-link", outputs: { onBuildHRef: "onBuildHRef" }, usesInheritance: true, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableActionLinkComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-table-action-link',
                    template: ''
                }]
        }], ctorParameters: () => [{ type: EloDatatableComponent, decorators: [{
                    type: Optional
                }] }], propDecorators: { onBuildHRef: [{
                type: Output
            }] } });

class EloTableActionsComponent extends EloTableAction {
    constructor(table) {
        super();
        this.table = table;
        this.showError = false;
        this.hasLinks = false;
        this.quickViewOpener = false;
        this.removeAutoFocus = false;
        /**
         * Irá emitir o elemento da linha selecionada
         */
        this.onClickLink = new EventEmitter();
        this.onClickIconButton = new EventEmitter();
        this.onHoverIconButton = new EventEmitter();
        this.addOn(table);
    }
    get type() {
        return EloTableActionType.complex;
    }
    clickIconButton(object) {
        this.onClickIconButton.emit(object);
    }
    hoverIconButton(object) {
        this.onHoverIconButton.emit(object);
    }
    clickLink(object, link) {
        object.link = link;
        this.onClickLink.emit(object);
    }
    getLinks(object) {
        if (this.links) {
            return this.links;
        }
        if (this.linksFunction) {
            return this.linksFunction(object);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableActionsComponent, deps: [{ token: EloDatatableComponent, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloTableActionsComponent, selector: "elo-table-actions", inputs: { showError: "showError", hasLinks: "hasLinks", links: "links", linksFunction: "linksFunction", quickViewOpener: "quickViewOpener", removeAutoFocus: "removeAutoFocus" }, outputs: { onClickLink: "onClickLink", onClickIconButton: "onClickIconButton", onHoverIconButton: "onHoverIconButton" }, usesInheritance: true, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableActionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-table-actions',
                    template: ''
                }]
        }], ctorParameters: () => [{ type: EloDatatableComponent, decorators: [{
                    type: Optional
                }] }], propDecorators: { showError: [{
                type: Input
            }], hasLinks: [{
                type: Input
            }], links: [{
                type: Input
            }], linksFunction: [{
                type: Input
            }], quickViewOpener: [{
                type: Input
            }], removeAutoFocus: [{
                type: Input
            }], onClickLink: [{
                type: Output
            }], onClickIconButton: [{
                type: Output
            }], onHoverIconButton: [{
                type: Output
            }] } });

class EloTableSubtitleComponent {
    constructor() {
        this.type = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableSubtitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloTableSubtitleComponent, selector: "elo-table-subtitle", inputs: { type: "type" }, ngImport: i0, template: `
    <div class="subtitle {{type}}">
      <ng-content></ng-content>
    </div>
`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableSubtitleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-table-subtitle',
                    template: `
    <div class="subtitle {{type}}">
      <ng-content></ng-content>
    </div>
`
                }]
        }], ctorParameters: () => [], propDecorators: { type: [{
                type: Input
            }] } });

class DomHandlerService {
    addClass(element, className) {
        if (element.classList) {
            element.classList.add(className);
        }
        else {
            element.className += ' ' + className;
        }
    }
    addMultipleClasses(element, className) {
        if (element.classList) {
            let styles = className.split(' ');
            for (let i = 0; i < styles.length; i++) {
                element.classList.add(styles[i]);
            }
        }
        else {
            let styles = className.split(' ');
            for (let i = 0; i < styles.length; i++) {
                element.className += ' ' + styles[i];
            }
        }
    }
    removeClass(element, className) {
        if (element.classList) {
            element.classList.remove(className);
        }
        else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }
    hasClass(element, className) {
        if (element.classList) {
            return element.classList.contains(className);
        }
        else {
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
        }
    }
    find(element, selector) {
        return element.querySelectorAll(selector);
    }
    findSingle(element, selector) {
        return element.querySelector(selector);
    }
    index(element) {
        let children = element.parentNode.childNodes;
        let num = 0;
        for (let i = 0; i < children.length; i++) {
            if (children[i] === element)
                return num;
            if (children[i].nodeType === 1)
                num++;
        }
        return -1;
    }
    getUserAgent() {
        return navigator.userAgent;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DomHandlerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DomHandlerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DomHandlerService, decorators: [{
            type: Injectable
        }] });

class MaskFormatDirective {
    set maskFormat(value) {
        this._maskFormat = value;
        if (this.formControlName) {
            this.attrValue(this.formControlName.value);
        }
    }
    constructor(formControlName, elementRef) {
        this.formControlName = formControlName;
        this.elementRef = elementRef;
    }
    onBlur() {
        if (!this.formControlName) {
            this.elementRef.nativeElement.value = this.toPattern(MaskUtils.replaceCaracteres(this.elementRef.nativeElement.value));
        }
    }
    ngOnInit() {
        if (this.formControlName) {
            this.subscription = this.formControlName.valueChanges.subscribe(value => this.attrValue(value));
            this.attrValue(this.formControlName.value);
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    attrValue(value) {
        if (this._maskFormat) {
            let beforeValue = MaskUtils.replaceCaracteres(value);
            let maskedValue = this.toPattern(beforeValue);
            if (value) {
                let selectionEnd = this.elementRef.nativeElement.selectionEnd;
                selectionEnd += maskedValue.length - beforeValue.length;
                this.formControlName.valueAccessor.writeValue(maskedValue);
                if (this.formControlName.value !== MaskUtils.replaceCaracteres(maskedValue)) {
                    this.formControlName.control.setValue(MaskUtils.replaceCaracteres(maskedValue));
                }
                setTimeout(() => this.elementRef.nativeElement.setSelectionRange(selectionEnd, selectionEnd), 0);
            }
        }
    }
    toPattern(value) {
        let formats = this._maskFormat.split('|');
        let formatToUse = '';
        let formatFilter = formats.filter(format => MaskUtils.replaceCaracteres(format).length >= value.length);
        if (formatFilter.length > 0) {
            formatToUse = formatFilter[0];
        }
        else {
            formatToUse = formats[formats.length - 1];
        }
        return MaskUtils.formatByPattern(value, formatToUse);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MaskFormatDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: MaskFormatDirective, selector: "[maskFormat]", inputs: { maskFormat: "maskFormat" }, host: { listeners: { "blur": "onBlur()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MaskFormatDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[maskFormat]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }], propDecorators: { maskFormat: [{
                type: Input
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

class CepDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '99999-999';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CepDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CepDirective, selector: "[cep]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CepDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[cep]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }] });

class ClipboardDirective {
    constructor(elmRef) {
        this.elmRef = elmRef;
        this.onSuccess = new EventEmitter();
        this.onError = new EventEmitter();
    }
    ngOnInit() {
        let option = !!this.targetElm ? { target: () => this.targetElm } : { text: () => this.clipboardContent };
        this.clipboard = new Clipboard(this.elmRef.nativeElement, option);
        this.clipboard.on('success', () => this.onSuccess.emit(true));
        this.clipboard.on('error', () => this.onError.emit(true));
    }
    ngOnDestroy() {
        if (this.clipboard) {
            this.clipboard.destroy();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClipboardDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ClipboardDirective, selector: "[clipboard]", inputs: { targetElm: "targetElm", clipboardContent: "clipboardContent" }, outputs: { onSuccess: "onSuccess", onError: "onError" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClipboardDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[clipboard]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { targetElm: [{
                type: Input
            }], clipboardContent: [{
                type: Input
            }], onSuccess: [{
                type: Output
            }], onError: [{
                type: Output
            }] } });

class CnpjCpfDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '999.999.999-99|99.999.999/9999-99';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnpjCpfDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnpjCpfDirective, selector: "[cnpjCpf]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnpjCpfDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[cnpjCpf]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }] });

class CnpjDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '99.999.999/9999-99';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnpjDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnpjDirective, selector: "[cnpj]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnpjDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[cnpj]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }] });

class Competencia {
    constructor(mes, ano) {
        this.mes = mes;
        this.ano = ano;
    }
}

class CompetenciaUtils {
    /**
     * Função utilizada para retornar o mês da competência passada por parâmetro
     * * @param  competencia no formato 012016 (MMYYYY)
     * @param  competencia
     */
    static getMesDaCompetencia(competencia) {
        if (!competencia) {
            return null;
        }
        return competencia.toString().substring(0, 2);
    }
    /**
     * Função utilizada para retornar o mês da competência passada por parâmetro
     * @param  competencia no formato 012016 (MMYYYY)
     * @returns
     */
    static getAnoDaCompetencia(competencia) {
        if (!competencia) {
            return null;
        }
        return competencia.toString().substring(2, 6);
    }
    /**
     * Função utilizada para retornar a competência de uma data
     * * @param date
     */
    static getCompetenciaFromDate(date) {
        if (!date) {
            return null;
        }
        return new Competencia(date.getMonth() + 1, date.getFullYear());
    }
}

var KEY_CODE;
(function (KEY_CODE) {
    KEY_CODE[KEY_CODE["UP_ARROW"] = 38] = "UP_ARROW";
    KEY_CODE[KEY_CODE["DOWN_ARROW"] = 40] = "DOWN_ARROW";
})(KEY_CODE || (KEY_CODE = {}));
class CompetenciaDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '99/9999';
        this.elementRef.nativeElement.setAttribute('autocomplete', 'off');
    }
    keyEvent(event) {
        if (event.keyCode === KEY_CODE.UP_ARROW) {
            this.increment();
        }
        if (event.keyCode === KEY_CODE.DOWN_ARROW) {
            this.decrement();
        }
    }
    getAnoAtual() {
        let currentDate = new Date();
        return currentDate.getFullYear();
    }
    increment() {
        let mes = parseInt(CompetenciaUtils.getMesDaCompetencia(this.formControlName.control.value));
        let ano = parseInt(CompetenciaUtils.getAnoDaCompetencia(this.formControlName.control.value));
        ano = !ano ? this.getAnoAtual() : ano;
        if (isNaN(mes)) {
            mes = 1;
        }
        else {
            if (mes >= 12) {
                mes = 0;
                ano++;
            }
            mes++;
        }
        let mesString = this.formatarMes(mes);
        mesString = mesString + ano;
        this.escreverNovoValor(mesString);
    }
    decrement() {
        let mes = parseInt(CompetenciaUtils.getMesDaCompetencia(this.formControlName.control.value));
        let ano = parseInt(CompetenciaUtils.getAnoDaCompetencia(this.formControlName.control.value));
        ano = !ano ? this.getAnoAtual() : ano;
        if (isNaN(mes)) {
            mes = 1;
        }
        else {
            if (mes === 1) {
                mes = 13;
                ano--;
            }
            mes--;
        }
        let mesString = this.formatarMes(mes);
        mesString = mesString + ano;
        this.escreverNovoValor(mesString);
    }
    escreverNovoValor(novoValor) {
        this.formControlName.valueAccessor.writeValue(novoValor);
        this.formControlName.control.setValue(novoValor);
    }
    formatarMes(mes) {
        if (isNaN(mes)) {
            return '01';
        }
        return mes < 10 ? '0' + mes : '' + mes;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CompetenciaDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CompetenciaDirective, selector: "[competencia]", host: { listeners: { "keyup": "keyEvent($event)" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CompetenciaDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[competencia]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }], propDecorators: { keyEvent: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

class CpfDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '999.999.999-99';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CpfDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CpfDirective, selector: "[cpf]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CpfDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[cpf]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }] });

class InputManager {
    constructor(htmlInputElement) {
        this.htmlInputElement = htmlInputElement;
    }
    setCursorAt(position) {
        if (this.htmlInputElement.setSelectionRange) {
            this.htmlInputElement.focus();
            this.htmlInputElement.setSelectionRange(position, position);
        }
        else if (this.htmlInputElement.createTextRange) {
            let textRange = this.htmlInputElement.createTextRange();
            textRange.collapse(true);
            textRange.moveEnd('character', position);
            textRange.moveStart('character', position);
            textRange.select();
        }
    }
    updateValueAndCursor(newRawValue, oldLength, selectionStart) {
        this.rawValue = newRawValue;
        let newLength = newRawValue.length;
        selectionStart = selectionStart - (oldLength - newLength);
        this.setCursorAt(selectionStart);
    }
    get canInputMoreNumbers() {
        let haventReachedMaxLength = !(this.rawValue.length >= this.htmlInputElement.maxLength && this.htmlInputElement.maxLength >= 0);
        let selectionStart = this.inputSelection.selectionStart;
        let selectionEnd = this.inputSelection.selectionEnd;
        let haveNumberSelected = (selectionStart !== selectionEnd &&
            this.htmlInputElement.value.substring(selectionStart, selectionEnd).match(/\d/)) ? true : false;
        let startWithZero = (this.htmlInputElement.value.substring(0, 1) === '0');
        return haventReachedMaxLength || haveNumberSelected || startWithZero;
    }
    get inputSelection() {
        let selectionStart = 0;
        let selectionEnd = 0;
        if (typeof this.htmlInputElement.selectionStart === 'number' && typeof this.htmlInputElement.selectionEnd === 'number') {
            selectionStart = this.htmlInputElement.selectionStart;
            selectionEnd = this.htmlInputElement.selectionEnd;
        }
        else {
            let range = document.selection.createRange();
            if (range && range.parentElement() === this.htmlInputElement) {
                let lenght = this.htmlInputElement.value.length;
                let normalizedValue = this.htmlInputElement.value.replace(/\r\n/g, '\n');
                let startRange = this.htmlInputElement.createTextRange();
                startRange.moveToBookmark(range.getBookmark());
                let endRange = this.htmlInputElement.createTextRange();
                endRange.collapse(false);
                if (startRange.compareEndPoints('StartToEnd', endRange) > -1) {
                    selectionStart = selectionEnd = lenght;
                }
                else {
                    selectionStart = -startRange.moveStart('character', -lenght);
                    selectionStart += normalizedValue.slice(0, selectionStart).split('\n').length - 1;
                    if (startRange.compareEndPoints('EndToEnd', endRange) > -1) {
                        selectionEnd = lenght;
                    }
                    else {
                        selectionEnd = -startRange.moveEnd('character', -lenght);
                        selectionEnd += normalizedValue.slice(0, selectionEnd).split('\n').length - 1;
                    }
                }
            }
        }
        return {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    }
    get rawValue() {
        return this.htmlInputElement && this.htmlInputElement.value;
    }
    set rawValue(value) {
        this._storedRawValue = value;
        if (this.htmlInputElement) {
            this.htmlInputElement.value = value;
        }
    }
    get storedRawValue() {
        return this._storedRawValue;
    }
}

class InputService {
    constructor(htmlInputElement, options) {
        this.htmlInputElement = htmlInputElement;
        this.options = options;
        this.inputManager = new InputManager(this.htmlInputElement);
    }
    addNumber(keyCode) {
        if (!this.rawValue) {
            this.rawValue = this.applyMask(false, '');
        }
        let keyChar = String.fromCharCode(keyCode);
        let selectionStart = this.inputSelection.selectionStart;
        let selectionEnd = this.inputSelection.selectionEnd;
        this.rawValue = this.rawValue.substring(0, selectionStart) + keyChar + this.rawValue.substring(selectionEnd, this.rawValue.length);
        this.updateFieldValue(selectionStart + 1);
    }
    applyMask(isNumber, rawValue) {
        let { allowNegative, precision, prefix, suffix, decimal, thousands, applyMask } = this.options;
        if (applyMask) {
            return this.doMask(isNumber, rawValue);
        }
        let onlyNumbers;
        if (isNumber) {
            onlyNumbers = rawValue.replace('.', decimal).replace(/[^0-9,]/g, '');
        }
        else {
            onlyNumbers = rawValue.replace(/[^0-9,]/g, '');
        }
        if (!onlyNumbers) {
            return '';
        }
        if (onlyNumbers.includes(decimal)) {
            const parts = onlyNumbers.split(decimal);
            const decimalPart = parts[1] || '';
            onlyNumbers = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + decimal + decimalPart.substring(0, precision);
        }
        else {
            onlyNumbers = onlyNumbers.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        }
        let isZero = rawValue === '0';
        let operator = (rawValue.indexOf('-') > -1 && allowNegative && !isZero) ? '-' : '';
        return operator + prefix + onlyNumbers + suffix;
    }
    doMask(isNumber, rawValue) {
        let { allowNegative, decimal, precision, prefix, suffix, thousands } = this.options;
        rawValue = isNumber ? Number(rawValue).toFixed(precision) : rawValue;
        let onlyNumbers = rawValue.replace(/[^0-9]/g, '');
        if (!onlyNumbers) {
            return '';
        }
        let integerPart = onlyNumbers.slice(0, onlyNumbers.length - precision).replace(/^0*/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        if (integerPart === '') {
            integerPart = '0';
        }
        let newRawValue = integerPart;
        let decimalPart = onlyNumbers.slice(onlyNumbers.length - precision);
        if (precision > 0) {
            decimalPart = '0'.repeat(precision - decimalPart.length) + decimalPart;
            newRawValue += decimal + decimalPart;
        }
        let isZero = parseInt(integerPart) === 0 && (parseInt(decimalPart) === 0 || decimalPart === '');
        let operator = (rawValue.indexOf('-') > -1 && allowNegative && !isZero) ? '-' : '';
        return operator + prefix + newRawValue + suffix;
    }
    clearMask(rawValue) {
        if (rawValue === null) {
            return null;
        }
        let value = rawValue.replace(this.options.prefix, '').replace(this.options.suffix, '');
        if (this.options.thousands) {
            value = value.replace(new RegExp('\\' + this.options.thousands, 'g'), '');
        }
        if (this.options.decimal) {
            value = value.replace(this.options.decimal, '.');
        }
        return parseFloat(value);
    }
    changeToNegative() {
        if (this.options.allowNegative && this.rawValue !== '' && this.rawValue.charAt(0) !== '-' && this.value !== 0) {
            this.rawValue = '-' + this.rawValue;
        }
    }
    changeToPositive() {
        this.rawValue = this.rawValue.replace('-', '');
    }
    removeNumber(keyCode) {
        let selectionEnd = this.inputSelection.selectionEnd;
        let selectionStart = this.inputSelection.selectionStart;
        if (selectionStart > this.rawValue.length - this.options.suffix.length) {
            selectionEnd = this.rawValue.length - this.options.suffix.length;
            selectionStart = this.rawValue.length - this.options.suffix.length;
        }
        selectionEnd = keyCode === 46 || keyCode === 63272 ? selectionEnd + 1 : selectionEnd;
        selectionStart = keyCode === 8 ? selectionStart - 1 : selectionStart;
        this.rawValue = this.rawValue.substring(0, selectionStart) + this.rawValue.substring(selectionEnd, this.rawValue.length);
        this.updateFieldValue(selectionStart);
    }
    updateFieldValue(selectionStart) {
        let newRawValue = this.applyMask(false, this.rawValue || '');
        selectionStart = selectionStart === undefined ? this.rawValue.length : selectionStart;
        this.inputManager.updateValueAndCursor(newRawValue, this.rawValue.length, selectionStart);
    }
    updateOptions(options) {
        let value = this.value;
        this.options = options;
        this.value = value;
    }
    get canInputMoreNumbers() {
        return this.inputManager.canInputMoreNumbers;
    }
    get inputSelection() {
        return this.inputManager.inputSelection;
    }
    get rawValue() {
        return this.inputManager.rawValue;
    }
    set rawValue(value) {
        this.inputManager.rawValue = value;
    }
    get storedRawValue() {
        return this.inputManager.storedRawValue;
    }
    get value() {
        return this.clearMask(this.rawValue);
    }
    set value(value) {
        this.rawValue = this.applyMask(true, '' + value);
    }
}

class InputHandler {
    constructor(htmlInputElement, options) {
        this.inputService = new InputService(htmlInputElement, options);
        this.htmlInputElement = htmlInputElement;
    }
    handleCut(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        setTimeout(() => {
            this.inputService.updateFieldValue();
            this.setValue(this.inputService.value);
            this.updateModel();
        }, 0);
    }
    handleInput(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        let keyCode = this.inputService.rawValue.charCodeAt(this.inputService.rawValue.length - 1);
        let rawValueLength = this.inputService.rawValue.length;
        let rawValueSelectionEnd = this.inputService.inputSelection.selectionEnd;
        let storedRawValueLength = this.inputService.storedRawValue.length;
        this.inputService.rawValue = this.inputService.storedRawValue;
        if (rawValueLength !== rawValueSelectionEnd || Math.abs(rawValueLength - storedRawValueLength) !== 1) {
            this.setCursorPosition(event);
            return;
        }
        if (rawValueLength < storedRawValueLength) {
            if (this.inputService.value !== 0) {
                this.inputService.removeNumber(8);
            }
            else {
                this.setValue(null);
            }
        }
        if (rawValueLength > storedRawValueLength) {
            switch (keyCode) {
                case 43:
                    this.inputService.changeToPositive();
                    break;
                case 45:
                    this.inputService.changeToNegative();
                    break;
                default:
                    if (!this.inputService.canInputMoreNumbers || (isNaN(this.inputService.value) && String.fromCharCode(keyCode).match(/\d/) === null)) {
                        return;
                    }
                    this.inputService.addNumber(keyCode);
            }
        }
        this.setCursorPosition(event);
        this.updateModel();
    }
    handleKeydown(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        let keyCode = event.which || event.charCode || event.keyCode;
        if (keyCode === 8 || keyCode === 46 || keyCode === 63272) {
            event.preventDefault();
            let selectionRangeLength = Math.abs(this.inputService.inputSelection.selectionEnd - this.inputService.inputSelection.selectionStart);
            if (selectionRangeLength === this.inputService.rawValue.length || this.inputService.value === 0) {
                this.setValue(null);
                this.updateModel();
            }
            if (selectionRangeLength === 0 && !isNaN(this.inputService.value)) {
                this.inputService.removeNumber(keyCode);
                this.updateModel();
            }
            this.updateModel();
        }
    }
    handleKeypress(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        let keyCode = event.which || event.charCode || event.keyCode;
        if (keyCode === undefined || [9, 13].indexOf(keyCode) !== -1 || this.isArrowEndHomeKeyInFirefox(event)) {
            return;
        }
        switch (keyCode) {
            case 43:
                this.inputService.changeToPositive();
                break;
            case 45:
                this.inputService.changeToNegative();
                break;
            default:
                if (this.inputService.canInputMoreNumbers && (!isNaN(this.inputService.value) || String.fromCharCode(keyCode).match(/\d/) !== null)) {
                    this.inputService.addNumber(keyCode);
                }
        }
        event.preventDefault();
        this.updateModel();
    }
    handlePaste(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        setTimeout(() => {
            this.inputService.updateFieldValue();
            this.setValue(this.inputService.value);
            this.updateModel();
        }, 1);
    }
    updateModel() {
        if (isNaN(this.inputService.value)) {
            this.onModelChange(null);
        }
        else {
            this.onModelChange(this.inputService.value);
        }
    }
    updateOptions(options) {
        this.inputService.updateOptions(options);
    }
    getOnModelChange() {
        return this.onModelChange;
    }
    setOnModelChange(callbackFunction) {
        this.onModelChange = callbackFunction;
    }
    getOnModelTouched() {
        return this.onModelTouched;
    }
    setOnModelTouched(callbackFunction) {
        this.onModelTouched = callbackFunction;
    }
    setValue(value) {
        this.inputService.value = value;
    }
    isArrowEndHomeKeyInFirefox(event) {
        if ([35, 36, 37, 38, 39, 40].indexOf(event.keyCode) !== -1 && (event.charCode === undefined || event.charCode === 0)) {
            return true;
        }
        return false;
    }
    setCursorPosition(event) {
        setTimeout(() => {
            event.target.setSelectionRange(event.target.value.length, event.target.value.length);
        }, 0);
    }
}

const CURRENCY_MASK_CONFIG = new InjectionToken('currency.mask.config');
const CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CurrencyMaskDirective),
    multi: true
};
class CurrencyMaskDirective {
    constructor(currencyMaskConfig, elementRef, keyValueDiffers) {
        this.currencyMaskConfig = currencyMaskConfig;
        this.elementRef = elementRef;
        this.keyValueDiffers = keyValueDiffers;
        this.options = {};
        this.optionsTemplate = {
            align: 'right',
            allowNegative: true,
            allowZero: true,
            decimal: '.',
            precision: 2,
            prefix: '$ ',
            suffix: '',
            thousands: ',',
            applyMask: true
        };
        if (this.currencyMaskConfig) {
            this.optionsTemplate = this.currencyMaskConfig;
        }
        this.keyValueDiffer = this.keyValueDiffers.find({}).create();
    }
    ngAfterViewInit() {
        this.elementRef.nativeElement.style.textAlign = this.options.align ? this.options.align : this.optionsTemplate.align;
    }
    ngDoCheck() {
        if (this.keyValueDiffer.diff(this.options)) {
            this.elementRef.nativeElement.style.textAlign = this.options.align ? this.options.align : this.optionsTemplate.align;
            this.inputHandler.updateOptions(Object.assign({}, this.optionsTemplate, this.options));
        }
    }
    ngOnInit() {
        this.inputHandler = new InputHandler(this.elementRef.nativeElement, Object.assign({}, this.optionsTemplate, this.options));
    }
    handleBlur(event) {
        this.inputHandler.getOnModelTouched().apply(event);
    }
    handleCut(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleCut(event);
        }
    }
    handleInput(event) {
        if (this.isChromeAndroid()) {
            this.inputHandler.handleInput(event);
        }
    }
    handleKeydown(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleKeydown(event);
        }
    }
    handleKeypress(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleKeypress(event);
        }
    }
    handlePaste(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handlePaste(event);
        }
    }
    isChromeAndroid() {
        return /chrome/i.test(navigator.userAgent) && /android/i.test(navigator.userAgent);
    }
    registerOnChange(callbackFunction) {
        this.inputHandler.setOnModelChange(callbackFunction);
    }
    registerOnTouched(callbackFunction) {
        this.inputHandler.setOnModelTouched(callbackFunction);
    }
    setDisabledState(value) {
        this.elementRef.nativeElement.disabled = value;
    }
    writeValue(value) {
        this.inputHandler.setValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyMaskDirective, deps: [{ token: CURRENCY_MASK_CONFIG, optional: true }, { token: i0.ElementRef }, { token: i0.KeyValueDiffers }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CurrencyMaskDirective, selector: "[currencyMask]", inputs: { options: "options" }, host: { listeners: { "blur": "handleBlur($event)", "cut": "handleCut($event)", "input": "handleInput($event)", "keydown": "handleKeydown($event)", "keypress": "handleKeypress($event)", "paste": "handlePaste($event)" } }, providers: [CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[currencyMask]',
                    providers: [CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR]
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [CURRENCY_MASK_CONFIG]
                }] }, { type: i0.ElementRef }, { type: i0.KeyValueDiffers }], propDecorators: { options: [{
                type: Input
            }], handleBlur: [{
                type: HostListener,
                args: ['blur', ['$event']]
            }], handleCut: [{
                type: HostListener,
                args: ['cut', ['$event']]
            }], handleInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }], handleKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], handleKeypress: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }], handlePaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }] } });

class DisableControlDirective {
    constructor(ngControl) {
        this.ngControl = ngControl;
        this.disableControl = false;
    }
    ngOnChanges(changes) {
        if (changes['disableControl']) {
            const action = this.disableControl ? 'disable' : 'enable';
            this.ngControl.control[action]();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DisableControlDirective, deps: [{ token: i1$2.NgControl }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: DisableControlDirective, selector: "[disableControl]", inputs: { disableControl: "disableControl" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DisableControlDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[disableControl]' }]
        }], ctorParameters: () => [{ type: i1$2.NgControl }], propDecorators: { disableControl: [{
                type: Input
            }] } });

class DoubleClickCopyDirective {
    constructor(element) {
        this.element = element;
        this.onCopy = new EventEmitter();
    }
    onDblClick() {
        const selection = getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.element.nativeElement);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        this.onCopy.emit(range);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DoubleClickCopyDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: DoubleClickCopyDirective, selector: "[doubleClickCopy]", outputs: { onCopy: "onCopy" }, host: { listeners: { "dblclick": "onDblClick($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DoubleClickCopyDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[doubleClickCopy]' }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { onCopy: [{
                type: Output
            }], onDblClick: [{
                type: HostListener,
                args: ['dblclick', ['$event']]
            }] } });

const ELODECIMAL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EloDecimalDirective),
    multi: true
};
const customCurrencyMaskConfig$1 = {
    align: 'right',
    allowNegative: false,
    allowZero: true,
    decimal: ',',
    precision: 2,
    prefix: '',
    suffix: '',
    thousands: '.',
    applyMask: true
};
class EloDecimalDirective extends CurrencyMaskDirective {
    constructor(elementRef, keyValueDiffers) {
        super(customCurrencyMaskConfig$1, elementRef, keyValueDiffers);
        this.textAlign = 'right';
        this.allowNegative = false;
        this.suffix = '';
        this.prefix = '';
        this.precision = 2;
    }
    ngOnInit() {
        this.options.allowNegative = this.allowNegative;
        this.options.suffix = this.suffix;
        this.options.prefix = this.prefix;
        this.options.precision = this.precision;
        this.options.align = this.textAlign;
        super.ngOnInit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloDecimalDirective, deps: [{ token: i0.ElementRef }, { token: i0.KeyValueDiffers }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: EloDecimalDirective, selector: "[eloDecimal]", inputs: { textAlign: "textAlign", allowNegative: "allowNegative", suffix: "suffix", prefix: "prefix", precision: "precision" }, providers: [ELODECIMAL_VALUE_ACCESSOR], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloDecimalDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[eloDecimal]',
                    providers: [ELODECIMAL_VALUE_ACCESSOR]
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.KeyValueDiffers }], propDecorators: { textAlign: [{
                type: Input
            }], allowNegative: [{
                type: Input
            }], suffix: [{
                type: Input
            }], prefix: [{
                type: Input
            }], precision: [{
                type: Input
            }] } });

const ELONUMBER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EloNumberDirective),
    multi: true
};
const customCurrencyMaskConfig = {
    align: 'right',
    allowNegative: false,
    allowZero: true,
    decimal: ',',
    precision: 0,
    prefix: '',
    suffix: '',
    thousands: '.',
    applyMask: false
};
class EloNumberDirective extends CurrencyMaskDirective {
    constructor(elementRef, keyValueDiffers) {
        super(customCurrencyMaskConfig, elementRef, keyValueDiffers);
        this.allowNegative = false;
        this.prefix = '';
        this.suffix = '';
        this.align = 'right';
        this.precision = 0;
        this.thousands = '.';
    }
    ngOnInit() {
        this.options.allowNegative = this.allowNegative;
        this.options.prefix = this.prefix;
        this.options.suffix = this.suffix;
        this.options.align = this.align;
        this.options.precision = this.precision;
        this.options.thousands = this.thousands;
        super.ngOnInit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNumberDirective, deps: [{ token: i0.ElementRef }, { token: i0.KeyValueDiffers }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: EloNumberDirective, selector: "[eloNumber]", inputs: { allowNegative: "allowNegative", prefix: "prefix", suffix: "suffix", align: "align", precision: "precision", thousands: "thousands" }, providers: [ELONUMBER_VALUE_ACCESSOR], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNumberDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[eloNumber]',
                    providers: [ELONUMBER_VALUE_ACCESSOR]
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.KeyValueDiffers }], propDecorators: { allowNegative: [{
                type: Input
            }], prefix: [{
                type: Input
            }], suffix: [{
                type: Input
            }], align: [{
                type: Input
            }], precision: [{
                type: Input
            }], thousands: [{
                type: Input
            }] } });

class AutofocusDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
        setTimeout(() => {
            this.elementRef.nativeElement.focus();
        }, 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutofocusDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: AutofocusDirective, selector: "[eloAutoFocus]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutofocusDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[eloAutoFocus]' }]
        }], ctorParameters: () => [{ type: i0.ElementRef }] });

const ERRO_MINUTOS = {
    mensagemGenerica: {
        mensagem: 'Os minutos precisam ser menores que 60'
    }
};
const ERRO_ZERO = {
    mensagemGenerica: {
        mensagem: 'As horas precisam ser maior que zero'
    }
};
const ERRO_TAMANHO = {
    'minlength': {
        requiredLength: 4
    }
};
class HoraLancamentoDirective {
    constructor(_elementRef, _control) {
        this._elementRef = _elementRef;
        this._control = _control;
    }
    ngOnInit() {
        this._control.valueChanges.subscribe(val => {
            if (val && this.validateLenght(val)) {
                this.validateMinutos(val);
                this.validateZero(val);
            }
        });
    }
    onEvent($event) {
        if ($event?.inputType?.includes('delete')) {
            return;
        }
        let val = this._handle(this._elementRef.nativeElement.value);
        val = val.replace(/\s/g, '');
        val = val.replace(/[^0-9:]/g, '');
        this._control.control.setValue(val, { emitEvent: false });
    }
    validateMinutos(val) {
        if (val.length === 5) {
            if (this.minutosIncorretos(val, 3)) {
                this._control.control.setErrors(ERRO_MINUTOS);
            }
        }
        else if (val.length === 6) {
            if (this.minutosIncorretos(val, 4)) {
                this._control.control.setErrors(ERRO_MINUTOS);
            }
        }
    }
    minutosIncorretos(val, indiceMinutos) {
        return parseInt(val.split('')[indiceMinutos]) > 5;
    }
    validateLenght(val) {
        if (val.trim().length < 5) {
            this._control.control.setErrors(ERRO_TAMANHO);
            return false;
        }
        else {
            return true;
        }
    }
    _handle(val) {
        if (!val) {
            return val;
        }
        let arr = val.split('');
        if (this.maiorQueTresSemDoisPontos(arr)) {
            arr = this.adicionarDoisPontos(arr);
        }
        let indiceDoisPontos = arr.indexOf(':');
        if (this.possuiMaisDeDoisElementosADireitaDosDoisPontos(arr, indiceDoisPontos)) {
            arr = this.trocarDoisPontosPeloElementoAEsquerda(arr, indiceDoisPontos);
        }
        if (this.doisPontosEmPosicaoErrada(arr)) {
            this.removerDoisPontos(arr);
            arr = this.adicionarDoisPontos(arr);
        }
        this.removerElementosExtras(arr);
        return arr.join('');
    }
    removerDoisPontos(arr) {
        while (arr.includes(':')) {
            arr.splice(arr.indexOf(':'), 1);
        }
    }
    adicionarDoisPontos(arr) {
        if (arr.length < 5) {
            arr = this.adicionarDoisPontosNaPosicao(arr, 3);
        }
        else {
            arr = this.adicionarDoisPontosNaPosicao(arr, 4);
        }
        return arr;
    }
    trocarDoisPontosPeloElementoAEsquerda(arr, indiceDoisPontos) {
        let arrSwap = arr.splice(indiceDoisPontos, 2);
        arr = [
            ...arr.slice(0, indiceDoisPontos),
            arrSwap[1],
            arrSwap[0],
            ...arr.slice(indiceDoisPontos)
        ];
        return arr;
    }
    possuiMaisDeDoisElementosADireitaDosDoisPontos(arr, indiceDoisPonstos) {
        return arr.includes(':')
            && arr.slice(indiceDoisPonstos + 1).length > 2;
    }
    removerElementosExtras(arr) {
        while (arr.length > 6) {
            arr.pop();
        }
    }
    adicionarDoisPontosNaPosicao(arr, posicao) {
        return [...arr.slice(0, posicao - 1), ':', ...arr.slice(posicao - 1)];
    }
    maiorQueTresSemDoisPontos(arr) {
        return arr.length > 3 && !arr.includes(':');
    }
    doisPontosEmPosicaoErrada(arr) {
        if (arr.includes(':')) {
            let qntdEncontradao = 0;
            let len = arr.length;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === ':') {
                    qntdEncontradao++;
                    if (len <= 5 && i !== 2) {
                        return true;
                    }
                    else if (i !== 3) {
                        return true;
                    }
                }
            }
            return qntdEncontradao > 1;
        }
        return true;
    }
    validateZero(val) {
        if (parseInt(val.replace(/[:]/, '')) === 0) {
            this._control.control.setErrors(ERRO_ZERO);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HoraLancamentoDirective, deps: [{ token: i0.ElementRef }, { token: i1$2.NgControl }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: HoraLancamentoDirective, selector: "[horaLancamento]", host: { listeners: { "input": "onEvent($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HoraLancamentoDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[horaLancamento]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.NgControl }], propDecorators: { onEvent: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

class HoraDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '99:99';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HoraDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: HoraDirective, selector: "[hora]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HoraDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[hora]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }] });

class NativeElementManager {
    constructor(element) {
        this.element = element;
    }
    acceptableInput() {
        return this.element.validity.valid || this.element.validity.valueMissing || this.element.validity.stepMismatch;
    }
    elementValue() {
        return String(this.element.value);
    }
    setValue(value) {
        this.element.value = value;
    }
}
class NonNegativeDirective {
    constructor(formControlName, elementRef) {
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.validValue = '';
        this.setElementManager(new NativeElementManager(this.elementRef.nativeElement));
    }
    setElementManager(elementManager) {
        this.elementManager = elementManager;
    }
    validateValue(value) {
        if (value === undefined || value === null) {
            return false;
        }
        return /^[0-9]*$/.test(value);
    }
    focusListener() {
        this.validValue = this.elementManager.elementValue();
    }
    inputListener() {
        if (this.elementManager.acceptableInput()) {
            this.sanitizeValue(this.elementManager.elementValue());
        }
        this.updateValue();
    }
    sanitizeValue(value) {
        let newValue = value.replace('.', '');
        if (this.validateValue(newValue)) {
            this.validValue = newValue;
        }
    }
    updateValue() {
        if (this.formControlName) {
            this.formControlName.control.setValue(this.validValue);
        }
        else {
            if (this.elementManager.elementValue() !== this.validValue) {
                this.elementManager.setValue(this.validValue);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NonNegativeDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NonNegativeDirective, selector: "[nonNegative]", host: { listeners: { "focus": "focusListener()", "input": "inputListener()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NonNegativeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[nonNegative]'
                }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }], propDecorators: { focusListener: [{
                type: HostListener,
                args: ['focus']
            }], inputListener: [{
                type: HostListener,
                args: ['input']
            }] } });

class PlacaDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = 'AAA-9999';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PlacaDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: PlacaDirective, selector: "[placa]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PlacaDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[placa]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }] });

class PreventMultiClickDirective {
    constructor(el) {
        this.el = el;
        this.debounceTime = 500;
        this.clicks = new Subject();
    }
    ngOnInit() {
        this.subscription = this.clicks.pipe(debounceTime(500)).subscribe(() => {
            this.el.nativeElement.attributes.removeNamedItem('disabled');
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    clickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(true);
        this.el.nativeElement.setAttribute('disabled', true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreventMultiClickDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: PreventMultiClickDirective, selector: "[preventMultiClick]", inputs: { debounceTime: "debounceTime" }, host: { listeners: { "click": "clickEvent($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreventMultiClickDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[preventMultiClick]' }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { debounceTime: [{
                type: Input
            }], clickEvent: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class SelectOnFocusDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    onFocus() {
        this.elementRef.nativeElement.select();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectOnFocusDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SelectOnFocusDirective, selector: "[selectOnFocus]", host: { listeners: { "focus": "onFocus()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectOnFocusDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[selectOnFocus]' }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { onFocus: [{
                type: HostListener,
                args: ['focus']
            }] } });

class SingleClickButtonDirective {
    constructor(el) {
        this.el = el;
    }
    onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.el.nativeElement.setAttribute('disabled', true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SingleClickButtonDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SingleClickButtonDirective, selector: "[singleClickButton]", host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SingleClickButtonDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[singleClickButton]' }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class TelefoneDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '(99) 9999-9999|(99) 9-9999-9999';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TelefoneDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: TelefoneDirective, selector: "[telefone]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TelefoneDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[telefone]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }] });

class ZeroWhenEmptyDirective {
    constructor(formControl) {
        this.formControl = formControl;
    }
    onBlur() {
        if (!this.formControl.value || this.formControl.value.toString().trim().length <= 0) {
            this.formControl.valueAccessor.writeValue(0);
            this.formControl.control.setValue(0, { emitEvent: false });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ZeroWhenEmptyDirective, deps: [{ token: i1$2.NgControl }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ZeroWhenEmptyDirective, selector: "[zeroWhenEmpty]", host: { listeners: { "blur": "onBlur()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ZeroWhenEmptyDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[zeroWhenEmpty]' }]
        }], ctorParameters: () => [{ type: i1$2.NgControl }], propDecorators: { onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

class DirectivesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DirectivesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DirectivesModule, declarations: [CnpjCpfDirective, CpfDirective, CnpjDirective, NonNegativeDirective, CepDirective,
            ClipboardDirective, DoubleClickCopyDirective, MaskFormatDirective, AutofocusDirective, TelefoneDirective,
            SelectOnFocusDirective, CurrencyMaskDirective, EloDecimalDirective, EloNumberDirective, CompetenciaDirective, ZeroWhenEmptyDirective, PlacaDirective,
            HoraDirective, HoraLancamentoDirective, FocusRemoverDirective, DisableControlDirective, SingleClickButtonDirective, PreventMultiClickDirective], exports: [CnpjCpfDirective, CpfDirective, CnpjDirective, NonNegativeDirective, CepDirective,
            ClipboardDirective, DoubleClickCopyDirective, MaskFormatDirective, AutofocusDirective, TelefoneDirective,
            SelectOnFocusDirective, CurrencyMaskDirective, EloDecimalDirective, EloNumberDirective, CompetenciaDirective, ZeroWhenEmptyDirective, PlacaDirective,
            HoraDirective, HoraLancamentoDirective, FocusRemoverDirective, DisableControlDirective, SingleClickButtonDirective, PreventMultiClickDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DirectivesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DirectivesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnpjCpfDirective, CpfDirective, CnpjDirective, NonNegativeDirective, CepDirective,
                        ClipboardDirective, DoubleClickCopyDirective, MaskFormatDirective, AutofocusDirective, TelefoneDirective,
                        SelectOnFocusDirective, CurrencyMaskDirective, EloDecimalDirective, EloNumberDirective, CompetenciaDirective, ZeroWhenEmptyDirective, PlacaDirective,
                        HoraDirective, HoraLancamentoDirective, FocusRemoverDirective, DisableControlDirective, SingleClickButtonDirective, PreventMultiClickDirective],
                    exports: [CnpjCpfDirective, CpfDirective, CnpjDirective, NonNegativeDirective, CepDirective,
                        ClipboardDirective, DoubleClickCopyDirective, MaskFormatDirective, AutofocusDirective, TelefoneDirective,
                        SelectOnFocusDirective, CurrencyMaskDirective, EloDecimalDirective, EloNumberDirective, CompetenciaDirective, ZeroWhenEmptyDirective, PlacaDirective,
                        HoraDirective, HoraLancamentoDirective, FocusRemoverDirective, DisableControlDirective, SingleClickButtonDirective, PreventMultiClickDirective]
                }]
        }] });

class BooleanTextPipe {
    transform(value) {
        if (value) {
            return 'Sim';
        }
        return 'Não';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BooleanTextPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: BooleanTextPipe, name: "booleanText" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BooleanTextPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'booleanText'
                }]
        }] });

class CapitalizePipe {
    // transform(value: any, args: any[]): any {
    // }
    transform(txt) {
        if (!txt) {
            return;
        }
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CapitalizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CapitalizePipe, name: "capitalize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CapitalizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'capitalize'
                }]
        }] });

class CepPipe {
    transform(value) {
        return value ? MaskUtils.formatCEP(value) : value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CepPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CepPipe, name: "cep" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CepPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cep'
                }]
        }] });

class CountdownPipe {
    transform(text, args) {
        let maxLength = args || 140;
        let length = text ? text.length : 0;
        return (maxLength - length);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CountdownPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CountdownPipe, name: "countdown", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CountdownPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'countdown',
                    pure: false
                }]
        }] });

/**
 Pipe para formatar valores monetários, no formato do real
 */
class CurrencyFormatPipe {
    transform(value, currencyCode = 'BRL', display, digits) {
        if (value === null || value === undefined) {
            return '';
        }
        let currencyPipe = new CurrencyPipe('pt');
        let newValue = currencyPipe.transform(value, currencyCode, display ? display : 'symbol', digits);
        return newValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CurrencyFormatPipe, name: "currencyformat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'currencyformat'
                }]
        }] });

/**
 Pipe para formatar valores em percentual
 */
class DiasFormatPipe {
    transform(value, currencyCode = 'BRL', display, digits) {
        if (value === null || value === undefined) {
            return '';
        }
        return value.toFixed(2).toString().replace('.', ',') + ' Dia(s)';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DiasFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DiasFormatPipe, name: "diasformat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DiasFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'diasformat'
                }]
        }] });

class DiasPorExtensoPipe {
    transform(value) {
        value = value === undefined ? 0 : value;
        value = +value;
        if (Number.isNaN(value)) {
            return '#ValorNaoNumerico';
        }
        return value === 1 ? `${value} dia` : `${value} dias`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DiasPorExtensoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DiasPorExtensoPipe, name: "diasPorExtenso" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DiasPorExtensoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'diasPorExtenso'
                }]
        }] });

class FilterPipe {
    /**
     * Filtra o array de acordo com o termo de pesquisa, utilizado em objetos que possuem atributos para pesquisa
     *
     * @param items array que será transformado
     *
     * @param searchTerm termo de pesquisa que será levado em conta para filtrar o array
     *
     * @param path caminho do objeto que deseja filtrar, exemplo: item.descricao
     *
     * @param isFormArray booleano que deve ser informado caso o array seja um formArray,
     *    pois é necessário fazer uma desestruturação na propriedade value, que é o array.
     *    Geralmente utilizado em table editable, default: false
     */
    transform(items, searchTerm, path, isFormArray = false) {
        if (!items) {
            return [];
        }
        if (!searchTerm) {
            return items;
        }
        return isFormArray
            ? items.filter(({ value }) => this.applyFilter(path, value, searchTerm))
            : items.filter(value => this.applyFilter(path, value, searchTerm));
    }
    resolve(path, obj) {
        let value = '';
        const filterValues = path.split('|');
        for (let filterValue of filterValues) {
            value += filterValue.split('.').reduce((prev, curr) => prev ? prev[curr] : null, obj);
        }
        return value;
    }
    applyFilter(path, value, searchTerm) {
        return this.resolve(path, value)
            .toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FilterPipe, name: "filter" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'filter'
                }]
        }] });

/**
 Pipe para formatar valores em percentual
 */
class PercentageFormatPipe {
    transform(value, currencyCode = 'BRL', display, digits) {
        if (value === null || value === undefined) {
            return '';
        }
        return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(value) + '%';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PercentageFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PercentageFormatPipe, name: "percentageformat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PercentageFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'percentageformat'
                }]
        }] });

class SafeUrlPipe {
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
    }
    transform(url) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SafeUrlPipe, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SafeUrlPipe, name: "safe" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SafeUrlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safe'
                }]
        }], ctorParameters: () => [{ type: i1$3.DomSanitizer }] });

class SimNaoPipe {
    transform(value) {
        if (value === 'S' || value === '1') {
            return 'Sim';
        }
        return 'Não';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SimNaoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SimNaoPipe, name: "simNao" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SimNaoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'simNao'
                }]
        }] });

class SubTipoPipe {
    transform(value) {
        if ('P' === value) {
            return 'Positiva';
        }
        if ('N' === value) {
            return 'Negativa';
        }
        if ('X' === value) {
            return 'Positiva com efeito de negativa';
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SubTipoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SubTipoPipe, name: "subTipo" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SubTipoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'subTipo'
                }]
        }] });

class TelefonePipe {
    transform(value) {
        return MaskUtils.formatTelefoneCelular(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TelefonePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TelefonePipe, name: "telefone" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TelefonePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'telefone'
                }]
        }] });

class TimeAgoPipe {
    constructor() {
        this.currentDate = null;
    }
    transform(value) {
        if (!value) {
            return 'a muito tempo atrás';
        }
        let dateNow = this.currentDate ? Date.parse(this.currentDate) : Date.now();
        let dateParse = Date.parse(value);
        let time = (dateNow - dateParse) / 1000;
        if (time < 10) {
            return 'agora mesmo';
        }
        const divider = [60, 60, 24, 30, 12];
        const stringValue = [' segundo', ' minuto', ' hora', ' dia', ' mês', ' ano'];
        let i;
        for (i = 0; Math.floor(time / divider[i]) > 0; i++) {
            time /= divider[i];
        }
        const plural = Math.floor(time) > 1 ? 's' : '';
        if (plural && stringValue[i] === ' mês') {
            return Math.floor(time) + ' meses atrás';
        }
        return Math.floor(time) + stringValue[i] + plural + ' atrás';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TimeAgoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TimeAgoPipe, name: "timeago" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TimeAgoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'timeago'
                }]
        }] });

registerLocaleData(localePt);
class PipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PipeModule, declarations: [CurrencyFormatPipe, DecimalFormatPipe, SubTipoPipe, CnpjCpfPipe, DateFormatPipe,
            BooleanTextPipe, CepPipe, CapitalizePipe, CountdownPipe, DateHourFormatPipe, SimNaoPipe, FilterPipe,
            DiasPorExtensoPipe, PercentageFormatPipe, DiasFormatPipe, TelefonePipe, SafeUrlPipe, TimeAgoPipe], imports: [CommonModule], exports: [CurrencyFormatPipe, DecimalFormatPipe, SubTipoPipe, CnpjCpfPipe, DateFormatPipe,
            BooleanTextPipe, CepPipe, CapitalizePipe, CountdownPipe, DateHourFormatPipe, SimNaoPipe, FilterPipe,
            DiasPorExtensoPipe, PercentageFormatPipe, DiasFormatPipe, TelefonePipe, SafeUrlPipe, TimeAgoPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PipeModule, providers: [
            { provide: LOCALE_ID, useValue: 'pt-BR' }
        ], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [CurrencyFormatPipe, DecimalFormatPipe, SubTipoPipe, CnpjCpfPipe, DateFormatPipe,
                        BooleanTextPipe, CepPipe, CapitalizePipe, CountdownPipe, DateHourFormatPipe, SimNaoPipe, FilterPipe,
                        DiasPorExtensoPipe, PercentageFormatPipe, DiasFormatPipe, TelefonePipe, SafeUrlPipe, TimeAgoPipe],
                    exports: [CurrencyFormatPipe, DecimalFormatPipe, SubTipoPipe, CnpjCpfPipe, DateFormatPipe,
                        BooleanTextPipe, CepPipe, CapitalizePipe, CountdownPipe, DateHourFormatPipe, SimNaoPipe, FilterPipe,
                        DiasPorExtensoPipe, PercentageFormatPipe, DiasFormatPipe, TelefonePipe, SafeUrlPipe, TimeAgoPipe],
                    providers: [
                        { provide: LOCALE_ID, useValue: 'pt-BR' }
                    ]
                }]
        }] });

class ButtonSelectOneModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonSelectOneModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ButtonSelectOneModule, declarations: [ButtonSelectOneComponent], imports: [CommonModule, FormsModule], exports: [ButtonSelectOneComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonSelectOneModule, imports: [CommonModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonSelectOneModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [ButtonSelectOneComponent],
                    exports: [ButtonSelectOneComponent]
                }]
        }] });

class EloCheckboxModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloCheckboxModule, declarations: [EloCheckboxComponent], imports: [CommonModule, FormsModule], exports: [EloCheckboxComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloCheckboxModule, imports: [CommonModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [EloCheckboxComponent],
                    exports: [EloCheckboxComponent]
                }]
        }] });

class AbstractAuthHttp {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AbstractAuthHttp, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AbstractAuthHttp }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AbstractAuthHttp, decorators: [{
            type: Injectable
        }] });

class PanelExpansiveComponent {
    constructor(authHttp) {
        this.authHttp = authHttp;
        this.collapsed = false;
        this.title = 'Título obrigatório!';
        this.hasTable = false;
        this.hasForm = true;
        this.expansive = true;
        this.showButton = false;
        this.disabledButton = false;
        this.hideButtonNovo = false;
        this.titleButtonNovo = 'Novo';
        this.enableScrollX = false;
        this.isInsideTab = false;
        this.collapsedCookie = false;
        this.error = false;
        this.onExpand = new EventEmitter();
        this.onNewItem = new EventEmitter();
    }
    openToggle() {
        if (this.collapsedCookie) {
            Cookie.set(this.getKey, 'expanded');
        }
        else {
            this.collapsed = false;
        }
        if (!this.collapsed || this.getCookieValue === 'expanded') {
            this.onExpand.emit();
        }
    }
    closeToggle() {
        if (this.collapsedCookie) {
            Cookie.set(this.getKey, this.getCookieValue === 'expanded' ? 'notExpanded' : 'expanded');
        }
        else {
            this.collapsed = !this.collapsed;
        }
    }
    newButton(event) {
        event.stopPropagation();
        this.collapsed = false;
        this.onNewItem.emit();
    }
    get getKey() {
        return 'panel_expansive_' + this.authHttp.getUsuarioInfo().username;
    }
    get getCookieValue() {
        return Cookie.get(this.getKey);
    }
    get isOpen() {
        return this.collapsedCookie ? this.getCookieValue === 'expanded' : !this.collapsed;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelExpansiveComponent, deps: [{ token: AbstractAuthHttp }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PanelExpansiveComponent, selector: "elo-panel-expansive", inputs: { collapsed: "collapsed", title: "title", hasTable: "hasTable", hasForm: "hasForm", expansive: "expansive", showButton: "showButton", disabledButton: "disabledButton", hideButtonNovo: "hideButtonNovo", titleButtonNovo: "titleButtonNovo", extraButtons: "extraButtons", enableScrollX: "enableScrollX", isInsideTab: "isInsideTab", collapsedCookie: "collapsedCookie", error: "error" }, outputs: { onExpand: "onExpand", onNewItem: "onNewItem" }, ngImport: i0, template: "<div class=\"panel\"\n  [ngClass]=\"{'open': isOpen,'':collapsed,'table':hasTable,'panel-form':hasForm, 'expansible':expansive}\">\n  <span class=\"dropdown-arrow\" (click)=\"closeToggle()\"></span>\n  <div *ngIf=\"title\" class=\"panel-title\" [class.inside-tab]=\"isInsideTab\" (click)=\"openToggle()\"\n    style=\"cursor: default !important\" [class.negative-color]=\"error\">\n    {{title}}\n    <button id=\"buttonNovo\" class=\"btn circle pull-right module-color\" type=\"button\"\n      *ngIf=\"showButton && !hideButtonNovo\" [disabled]=\"disabledButton\" (click)=\"newButton($event)\">\n      <em class=\"fa fa-plus\"></em>\n      <div class=\"btn-actions-label\">\n        {{titleButtonNovo}}\n      </div>\n    </button>\n    <ng-container [ngTemplateOutlet]=\"extraButtons\" *ngIf=\"showButton && extraButtons\"></ng-container>\n  </div>\n  <div id=\"content\" class=\"panel-body {{ enableScrollX ? 'scroll-x' : '' }}\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelExpansiveComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-panel-expansive', template: "<div class=\"panel\"\n  [ngClass]=\"{'open': isOpen,'':collapsed,'table':hasTable,'panel-form':hasForm, 'expansible':expansive}\">\n  <span class=\"dropdown-arrow\" (click)=\"closeToggle()\"></span>\n  <div *ngIf=\"title\" class=\"panel-title\" [class.inside-tab]=\"isInsideTab\" (click)=\"openToggle()\"\n    style=\"cursor: default !important\" [class.negative-color]=\"error\">\n    {{title}}\n    <button id=\"buttonNovo\" class=\"btn circle pull-right module-color\" type=\"button\"\n      *ngIf=\"showButton && !hideButtonNovo\" [disabled]=\"disabledButton\" (click)=\"newButton($event)\">\n      <em class=\"fa fa-plus\"></em>\n      <div class=\"btn-actions-label\">\n        {{titleButtonNovo}}\n      </div>\n    </button>\n    <ng-container [ngTemplateOutlet]=\"extraButtons\" *ngIf=\"showButton && extraButtons\"></ng-container>\n  </div>\n  <div id=\"content\" class=\"panel-body {{ enableScrollX ? 'scroll-x' : '' }}\">\n    <ng-content></ng-content>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: AbstractAuthHttp }], propDecorators: { collapsed: [{
                type: Input
            }], title: [{
                type: Input
            }], hasTable: [{
                type: Input
            }], hasForm: [{
                type: Input
            }], expansive: [{
                type: Input
            }], showButton: [{
                type: Input
            }], disabledButton: [{
                type: Input
            }], hideButtonNovo: [{
                type: Input
            }], titleButtonNovo: [{
                type: Input
            }], extraButtons: [{
                type: Input
            }], enableScrollX: [{
                type: Input
            }], isInsideTab: [{
                type: Input
            }], collapsedCookie: [{
                type: Input
            }], error: [{
                type: Input
            }], onExpand: [{
                type: Output
            }], onNewItem: [{
                type: Output
            }] } });

class PanelExpansiveModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelExpansiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PanelExpansiveModule, declarations: [PanelExpansiveComponent], imports: [CommonModule], exports: [PanelExpansiveComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelExpansiveModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PanelExpansiveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [PanelExpansiveComponent],
                    declarations: [PanelExpansiveComponent]
                }]
        }] });

class EloRadioButtonComponent {
    constructor() {
        this.selectAllowed = true;
        this.titleRadioButtonDisallowed = 'Seleção não permitida';
        this.selected = false;
        this.disabled = false;
        this.onClick = new EventEmitter();
    }
    selectRadio(event) {
        if (this.enable()) {
            this.selected = !this.selected;
            let eloRadioButtonEvent = { originalEvent: event, checked: this.selected };
            this.onClick.emit(eloRadioButtonEvent);
        }
    }
    enable() {
        return !this.disabled;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloRadioButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloRadioButtonComponent, selector: "elo-radiobutton", inputs: { selectAllowed: "selectAllowed", titleRadioButtonDisallowed: "titleRadioButtonDisallowed", selected: "selected", disabled: "disabled" }, outputs: { onClick: "onClick" }, ngImport: i0, template: `
    <input *ngIf="selectAllowed" type="radio" [checked]="selected" (click)="selectRadio($event)">
    <em *ngIf="!selectAllowed" class="fa fa-ban" style="color: #da0e0e" title="{{titleRadioButtonDisallowed}}"></em>
`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloRadioButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-radiobutton',
                    template: `
    <input *ngIf="selectAllowed" type="radio" [checked]="selected" (click)="selectRadio($event)">
    <em *ngIf="!selectAllowed" class="fa fa-ban" style="color: #da0e0e" title="{{titleRadioButtonDisallowed}}"></em>
`
                }]
        }], propDecorators: { selectAllowed: [{
                type: Input
            }], titleRadioButtonDisallowed: [{
                type: Input
            }], selected: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onClick: [{
                type: Output
            }] } });

class EloRadioButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloRadioButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloRadioButtonModule, declarations: [EloRadioButtonComponent], imports: [CommonModule, FormsModule], exports: [EloRadioButtonComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloRadioButtonModule, imports: [CommonModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloRadioButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [EloRadioButtonComponent],
                    exports: [EloRadioButtonComponent]
                }]
        }] });

class EloDatatableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloDatatableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloDatatableModule, declarations: [EloDatatableComponent,
            EloColumnComponent,
            EloTableActionsComponent,
            EloTableActionLinkComponent,
            EloHeaderActionsComponent,
            EloDataTableRowComponent,
            EloTableSubtitleComponent], imports: [CommonModule,
            PanelModule,
            PanelExpansiveModule,
            FormsModule,
            ReactiveFormsModule,
            EloCheckboxModule,
            EloRadioButtonModule,
            ButtonSelectOneModule,
            PipeModule,
            DirectivesModule], exports: [EloDatatableComponent,
            EloColumnComponent,
            EloTableActionsComponent,
            EloHeaderActionsComponent,
            EloTableActionLinkComponent,
            EloTableSubtitleComponent,
            EloCheckboxModule,
            EloRadioButtonModule,
            ButtonSelectOneModule,
            PipeModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloDatatableModule, providers: [DomHandlerService, ObjectUtilService, EloDatatableComponent], imports: [CommonModule,
            PanelModule,
            PanelExpansiveModule,
            FormsModule,
            ReactiveFormsModule,
            EloCheckboxModule,
            EloRadioButtonModule,
            ButtonSelectOneModule,
            PipeModule,
            DirectivesModule, EloCheckboxModule,
            EloRadioButtonModule,
            ButtonSelectOneModule,
            PipeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloDatatableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PanelModule,
                        PanelExpansiveModule,
                        FormsModule,
                        ReactiveFormsModule,
                        EloCheckboxModule,
                        EloRadioButtonModule,
                        ButtonSelectOneModule,
                        PipeModule,
                        DirectivesModule
                    ],
                    declarations: [
                        EloDatatableComponent,
                        EloColumnComponent,
                        EloTableActionsComponent,
                        EloTableActionLinkComponent,
                        EloHeaderActionsComponent,
                        EloDataTableRowComponent,
                        EloTableSubtitleComponent
                    ],
                    exports: [
                        EloDatatableComponent,
                        EloColumnComponent,
                        EloTableActionsComponent,
                        EloHeaderActionsComponent,
                        EloTableActionLinkComponent,
                        EloTableSubtitleComponent,
                        EloCheckboxModule,
                        EloRadioButtonModule,
                        ButtonSelectOneModule,
                        PipeModule
                    ],
                    providers: [DomHandlerService, ObjectUtilService, EloDatatableComponent]
                }]
        }] });

class AssinaturaSelectorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AssinaturaSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AssinaturaSelectorModule, declarations: [AssinaturaSelectorComponent], imports: [CommonModule,
            PanelModule,
            EloDatatableModule], exports: [AssinaturaSelectorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AssinaturaSelectorModule, imports: [CommonModule,
            PanelModule,
            EloDatatableModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AssinaturaSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PanelModule,
                        EloDatatableModule,
                    ],
                    declarations: [AssinaturaSelectorComponent],
                    exports: [AssinaturaSelectorComponent]
                }]
        }] });

const GROUP_ADMIN = 'Administradores';
const isUserAdmin = (user) => {
    if (user && user.grupos) {
        return user.grupos.filter(grupo => grupo.nome === GROUP_ADMIN).length > 0;
    }
    return false;
};
class Usuario {
}
class UsuarioTrocaSenha {
}

const KEYCLOAK_AUTH_RESOURCES_CONFIG = new InjectionToken('keycloak-auth-resources.config');
const AUTH_RESOURCES_CONFIG = new InjectionToken('auth-resources.config');
const AUTH_RESOURCES_CONFIG_UNICO = {
    urlApi: '/api/authenticate',
    urlMe: '/api/usuarios/me',
    fieldsMe: 'id,usuario,email,nome,cargo,matricula,modulos.modulo.id,modulos.modulo.descricao,' +
        'modulos.modulo.path,modulos.modulo.url,grupos.nome,usuarioRecursos.nome',
    urlFormDefault: 'login/auth',
    tokenKey: 'authorization',
    hostDev: 'http://juggernaut.elotech.localnet',
    app: 'unico'
};
const AUTH_RESOURCES_CONFIG_ISS = {
    urlApi: '/api/authentication/login',
    urlX509Api: '/api/authentication/x509login',
    urlMe: '/api/usuarios/me',
    fieldsMe: 'nome,username',
    urlFormDefault: 'auth',
    tokenKey: 'authorization_iss',
    hostDev: 'http://localhost:4200',
    app: 'iss'
};
const AUTH_RESOURCES_CONFIG_PORTAL_SERVICOS = {
    urlApi: '/api/authenticate',
    urlMe: '/api/acesso-web/me',
    fieldsMe: 'id,cpf,nome,rg,orgaoEmissor,ufEmissor,identificacaoProfissional,tipoConselho,administrador,ativo,dataCadastro',
    urlFormDefault: 'autenticacao',
    tokenKey: 'authorization_ps',
    hostDev: 'http://localhost:4200',
    app: 'ps'
};

const permissions = [
    { 'recurso': 'AGENCIA_READ', 'route': 'agencias' },
    { 'recurso': 'AGENCIA_CREATE', 'route': 'agencias/new' },
    { 'recurso': 'AGENCIA_UPDATE', 'route': 'agencias/:id' },
    { 'recurso': 'BAIRRO_READ', 'route': 'bairros' },
    { 'recurso': 'BAIRRO_CREATE', 'route': 'bairros/new' },
    { 'recurso': 'BAIRRO_UPDATE', 'route': 'bairros/:id' },
    { 'recurso': 'LOGRADOURO_READ', 'route': 'logradouros' },
    { 'recurso': 'LOGRADOURO_CREATE', 'route': 'logradouros/new' },
    { 'recurso': 'LOGRADOURO_UPDATE', 'route': 'logradouros/:id' },
    { 'recurso': 'BANCO_READ', 'route': 'bancos' },
    { 'recurso': 'BANCO_CREATE', 'route': 'bancos/new' },
    { 'recurso': 'BANCO_UPDATE', 'route': 'bancos/:id' },
    { 'recurso': 'CIDADE_READ', 'route': 'cidades' },
    { 'recurso': 'CIDADE_CREATE', 'route': 'cidades/new' },
    { 'recurso': 'CIDADE_UPDATE', 'route': 'cidades/:id' },
    { 'recurso': 'ENTIDADE_READ', 'route': 'entidades' },
    { 'recurso': 'ENTIDADE_CREATE', 'route': 'entidades/new' },
    { 'recurso': 'ENTIDADE_UPDATE', 'route': 'entidades/:id' },
    { 'recurso': 'PAIS_READ', 'route': 'paises' },
    { 'recurso': 'PAIS_CREATE', 'route': 'paises/new' },
    { 'recurso': 'PAIS_UPDATE', 'route': 'paises/:id' },
    { 'recurso': 'PESSOA_READ', 'route': 'pessoas' },
    { 'recurso': 'PESSOA_CREATE', 'route': 'pessoas/new' },
    { 'recurso': 'PESSOA_UPDATE', 'route': 'pessoas/:id' },
    { 'recurso': 'UF_READ', 'route': 'ufs' },
    { 'recurso': 'UF_CREATE', 'route': 'ufs/new' },
    { 'recurso': 'UF_UPDATE', 'route': 'ufs/:id' },
    { 'recurso': 'MODULO_READ', 'route': 'cadastromodulos' },
    { 'recurso': 'MODULO_CREATE', 'route': 'cadastromodulos/new' },
    { 'recurso': 'MODULO_UPDATE', 'route': 'cadastromodulos/:id' },
    { 'recurso': 'USUARIO_READ', 'route': 'usuarios' },
    { 'recurso': 'USUARIO_CREATE', 'route': 'usuarios/new' },
    { 'recurso': 'USUARIO_UPDATE', 'route': 'usuarios/:id' },
    { 'recurso': 'GRUPO_READ', 'route': 'grupos' },
    { 'recurso': 'GRUPO_CREATE', 'route': 'grupos/new' },
    { 'recurso': 'GRUPO_UPDATE', 'route': 'grupos/:id' },
    { 'recurso': 'UNIFICACAO_CREATE', 'route': 'batch' },
    { 'recurso': 'VALIDACAO_BANCO_READ', 'route': 'db_validate' },
    { 'recurso': 'ENTRADA_READ', 'route': 'entrada' },
    { 'recurso': 'ENTRADA_CREATE', 'route': 'entrada/new' },
    { 'recurso': 'ENTRADA_UPDATE', 'route': 'entrada/:id' },
    { 'recurso': 'ENTRADA_READ', 'route': 'entrada/:idView/view' },
    { 'recurso': 'SAIDA_READ', 'route': 'saida' },
    { 'recurso': 'SAIDA_CREATE', 'route': 'saida/new' },
    { 'recurso': 'SAIDA_UPDATE', 'route': 'saida/:id' },
    { 'recurso': 'SAIDA_READ', 'route': 'saida/:idView/view' },
    { 'recurso': 'LOTE_READ', 'route': 'lotes' },
    { 'recurso': 'LOTE_CREATE', 'route': 'lotes/new' },
    { 'recurso': 'LOTE_UPDATE', 'route': 'lotes/:id' },
    { 'recurso': 'LOTE_READ', 'route': 'lotes/:idView/view' },
    { 'recurso': 'REQUISICAO_APROVACAO', 'route': 'requisicoes/:id/aprovar' },
    { 'recurso': 'REQUISICAO_READ', 'route': 'requisicoes' },
    { 'recurso': 'REQUISICAO_CREATE', 'route': 'requisicoes/new' },
    { 'recurso': 'REQUISICAO_UPDATE', 'route': 'requisicoes/:id' },
    { 'recurso': 'REQUISICAO_READ', 'route': 'requisicoes/:idView/view' },
    { 'recurso': 'CONSULTA_SALDO_READ', 'route': 'consulta-saldo' },
    { 'recurso': 'AGENDAMENTO_ENTREGA_READ', 'route': 'agendamento-entrega' },
    {
        'recurso': 'AGENDAMENTO_ENTREGA_CREATE',
        'route': 'agendamento-entrega/new'
    },
    {
        'recurso': 'AGENDAMENTO_ENTREGA_UPDATE',
        'route': 'agendamento-entrega/:id'
    },
    {
        'recurso': 'AGENDAMENTO_ENTREGA_READ',
        'route': 'agendamento-entrega/:idView/view'
    },
    { 'recurso': 'CENTRO_CUSTO_READ', 'route': 'centroscusto' },
    { 'recurso': 'CENTRO_CUSTO_CREATE', 'route': 'centroscusto/new' },
    { 'recurso': 'CENTRO_CUSTO_UPDATE', 'route': 'centroscusto/:id' },
    { 'recurso': 'DOCA_ENTREGA_READ', 'route': 'docas-entrega' },
    { 'recurso': 'DOCA_ENTREGA_CREATE', 'route': 'docas-entrega/new' },
    { 'recurso': 'DOCA_ENTREGA_UPDATE', 'route': 'docas-entrega/:id' },
    { 'recurso': 'EMPENHO_BLOQUEADO_READ', 'route': 'empenhos-bloqueado' },
    { 'recurso': 'EMPENHO_BLOQUEADO_CREATE', 'route': 'empenhos-bloqueado/new' },
    { 'recurso': 'EMPENHO_BLOQUEADO_UPDATE', 'route': 'empenhos-bloqueado/:id' },
    { 'recurso': 'EXERCICIO_READ', 'route': 'exercicios' },
    { 'recurso': 'EXERCICIO_CREATE', 'route': 'exercicios/new' },
    { 'recurso': 'EXERCICIO_UPDATE', 'route': 'exercicios/:id' },
    { 'recurso': 'FABRICANTE_READ', 'route': 'fabricantes' },
    { 'recurso': 'FABRICANTE_CREATE', 'route': 'fabricantes/new' },
    { 'recurso': 'FABRICANTE_UPDATE', 'route': 'fabricantes/:id' },
    { 'recurso': 'ITEM_READ', 'route': 'itens' },
    { 'recurso': 'ITEM_CREATE', 'route': 'itens/new' },
    { 'recurso': 'ITEM_UPDATE', 'route': 'itens/:id' },
    { 'recurso': 'MODELO_CLASSIFICACAO_READ', 'route': 'modelos' },
    { 'recurso': 'MODELO_CLASSIFICACAO_CREATE', 'route': 'modelos/new' },
    { 'recurso': 'MODELO_CLASSIFICACAO_UPDATE', 'route': 'modelos/:id' },
    { 'recurso': 'NATUREZA_DESPESA_READ', 'route': 'naturezas-despesa' },
    { 'recurso': 'NATUREZA_DESPESA_CREATE', 'route': 'naturezas-despesa/new' },
    { 'recurso': 'NATUREZA_DESPESA_UPDATE', 'route': 'naturezas-despesa/:id' },
    { 'recurso': 'PALETE_READ', 'route': 'paletes' },
    { 'recurso': 'PALETE_CREATE', 'route': 'paletes/new' },
    { 'recurso': 'PALETE_UPDATE', 'route': 'paletes/:id' },
    { 'recurso': 'TIPO_CENTRO_CUSTO_READ', 'route': 'tipos-centro-custo' },
    { 'recurso': 'TIPO_CENTRO_CUSTO_CREATE', 'route': 'tipos-centro-custo/new' },
    { 'recurso': 'TIPO_CENTRO_CUSTO_UPDATE', 'route': 'tipos-centro-custo/:id' },
    { 'recurso': 'TIPO_ITEM_READ', 'route': 'tipos-itens' },
    { 'recurso': 'TIPO_ITEM_CREATE', 'route': 'tipos-itens/new' },
    { 'recurso': 'TIPO_ITEM_UPDATE', 'route': 'tipos-itens/:id' },
    { 'recurso': 'TIPO_MOVIMENTACAO_READ', 'route': 'tipos-movimento' },
    { 'recurso': 'TIPO_MOVIMENTACAO_CREATE', 'route': 'tipos-movimento/new' },
    { 'recurso': 'TIPO_MOVIMENTACAO_UPDATE', 'route': 'tipos-movimento/:id' },
    { 'recurso': 'UNIDADE_MEDIDA_READ', 'route': 'unidade-medida' },
    { 'recurso': 'UNIDADE_MEDIDA_CREATE', 'route': 'unidade-medida/new' },
    { 'recurso': 'UNIDADE_MEDIDA_UPDATE', 'route': 'unidade-medida/:id' },
    {
        'recurso': 'RELATORIO_BALANCO_REQUISICAO_READ',
        'route': 'relatorio-balanco-requisicao'
    },
    { 'recurso': 'RELATORIO_REQUISICAO_READ', 'route': 'relatorio-requisicao' },
    {
        'recurso': 'RELATORIO_SALDO_REQUISICAO_READ',
        'route': 'relatorio-saldo-requisitar'
    },
    {
        'recurso': 'RELATORIO_ITEM_FORNECEDOR_READ',
        'route': 'consulta-item-fornecedor'
    },
    { 'recurso': 'DEVOLUCAO_READ', 'route': 'devolucoes' },
    { 'recurso': 'DEVOLUCAO_CREATE', 'route': 'devolucoes/new' },
    { 'recurso': 'DEVOLUCAO_UPDATE', 'route': 'devolucoes/:id' },
    { 'recurso': 'MOVIMENTACAO_READ', 'route': 'relatorio-consumo' },
    { 'recurso': 'TRANSFERENCIA_READ', 'route': 'transferencia' },
    { 'recurso': 'TRANSFERENCIA_CREATE', 'route': 'transferencia/new' },
    { 'recurso': 'TRANSFERENCIA_UPDATE', 'route': 'transferencia/:id' },
    { 'recurso': 'TRANSFERENCIA_READ', 'route': 'transferencia/:idView/view' },
    {
        'recurso': 'CONFIGURACAO_PERMISSAO_USUARIO',
        'route': 'permissao/centro-custo/:username'
    },
    { 'recurso': 'CONFIGURACAO_PERMISSAO_USUARIO', 'route': 'permissao' },
    { 'recurso': 'FRACIONAR_ITEM', 'route': 'fraciona-items' },
    { 'recurso': 'RELATORIO_POSICAO_ESTOQUE', 'route': 'posicao-de-estoque' },
    { 'recurso': 'INVENTARIO_READ', 'route': 'inventarios' },
    { 'recurso': 'INVENTARIO_READ', 'route': 'inventarios/:id/view' },
    { 'recurso': 'INVENTARIO_UPDATE', 'route': 'inventarios/:id' },
    { 'recurso': 'INVENTARIO_CREATE', 'route': 'inventarios/new' },
    { 'recurso': 'ROTA_ENTREGA_READ', 'route': 'rotas-entrega' },
    { 'recurso': 'ROTA_ENTREGA_UPDATE', 'route': 'rotas-entrega/:id' },
    { 'recurso': 'ROTA_ENTREGA_CREATE', 'route': 'rotas-entrega/new' },
    { 'recurso': 'PARAMETRO_ITEM', 'route': 'parametro-itens' },
    { 'recurso': 'COMISSAO_READ', 'route': 'comissoes' },
    { 'recurso': 'COMISSAO_UPDATE', 'route': 'comissoes/:id' },
    { 'recurso': 'COMISSAO_CREATE', 'route': 'comissoes/new' },
    { 'recurso': 'FRACIONA_ITENS_READ', 'route': 'fraciona-itens' },
    { 'recurso': 'CLASSIFICACAO_READ', 'route': 'classificacoes' },
    { 'recurso': 'CLASSIFICACAO_UPDATE', 'route': 'classificacoes/:id' },
    { 'recurso': 'CLASSIFICACAO_CREATE', 'route': 'classificacoes/new' },
    { 'recurso': 'REMANEJO_LOTE_READ', 'route': 'remanejo-lotes' },
    { 'recurso': 'CONTROLE_COTA_READ', 'route': 'itens-centro-consumo' },
    { 'recurso': 'CONTROLE_COTA_UPDATE', 'route': 'itens-centro-consumo/:id' },
    { 'recurso': 'CONTROLE_COTA_CREATE', 'route': 'itens-centro-consumo/new' },
    { 'recurso': 'RELATORIO_CONTROLE_COTA', 'route': 'relatorio-consumo-anual' },
    {
        'recurso': 'REENVIAR_MOVIMENTACAO_CUSTOS',
        'route': 'reenviar-movimentacao-saida'
    },
    { 'recurso': 'IMPRESSAO_ETIQUETAS_READ', 'route': 'impressao-etiquetas' },
    {
        'recurso': 'PONTO_PEDIDO_READ',
        'route': 'dashboard-item-ponto-pedido'
    },
    { 'recurso': 'CONSULTA_ALOCADOR', 'route': 'consulta-alocador' },
    { 'recurso': 'CONSULTA_CENTRO_OBJETO', 'route': 'consulta-centro-objeto' },
    { 'recurso': 'OBJETO_CUSTO', 'route': 'objeto-custo' },
    { 'recurso': 'OBJETO_CUSTO_CREATE', 'route': 'objeto-custo/new' },
    { 'recurso': 'OBJETO_CUSTO_UPDATE', 'route': 'objeto-custo/:id' },
    { 'recurso': 'DIVISOR', 'route': 'divisor' },
    { 'recurso': 'DIVISOR_CREATE', 'route': 'divisor/new' },
    { 'recurso': 'DIVISOR_UPDATE', 'route': 'divisor/:id' },
    { 'recurso': 'CUSTOS_CENTRO_CUSTO', 'route': 'centro-custo' },
    { 'recurso': 'VISAO_CUSTO', 'route': 'visao-custo' },
    { 'recurso': 'VISAO_CUSTO', 'route': 'visao-custo/preview/:id/:inicio/:fim' },
    { 'recurso': 'VISAO_CUSTO_CREATE', 'route': 'visao-custo/new' },
    { 'recurso': 'VISAO_CUSTO_UPDATE', 'route': 'visao-custo/:id' },
    { 'recurso': 'ALOCADOR_CUSTO', 'route': 'alocador' },
    { 'recurso': 'ALOCADOR_CUSTO_CREATE', 'route': 'alocador/new' },
    { 'recurso': 'ALOCADOR_CUSTO_UPDATE', 'route': 'alocador/:id' },
    { 'recurso': 'TIPO_CUSTO', 'route': 'tipo-custo' },
    { 'recurso': 'TIPO_CUSTO_CREATE', 'route': 'tipo-custo/new' },
    { 'recurso': 'TIPO_CUSTO_UPDATE', 'route': 'tipo-custo/:id' },
    { 'recurso': 'CUSTOS_UNIDADE_MEDIDA', 'route': 'unidade-medida' },
    { 'recurso': 'CUSTOS_UNIDADE_MEDIDA_CREATE', 'route': 'unidade-medida/new' },
    { 'recurso': 'CUSTOS_UNIDADE_MEDIDA_UPDATE', 'route': 'unidade-medida/:id' },
    { 'recurso': 'DASHBOARD_CUSTOS', 'route': 'dashboard-custos' },
    { 'recurso': 'DASHBOARD_CUSTOS_CREATE', 'route': 'dashboard-custos/new' },
    { 'recurso': 'DASHBOARD_CUSTOS_UPDATE', 'route': 'dashboard-custos/:id' },
    {
        'recurso': 'LANCAMENTO_INTEGRACAO',
        'route': 'lancamento-integracao/:idView/view'
    },
    { 'recurso': 'LANCAMENTO_INTEGRACAO', 'route': 'lancamento-integracao' },
    { 'recurso': 'PPA', 'route': 'ppa' },
    { 'recurso': 'PPA_CREATE', 'route': 'ppa/new' },
    { 'recurso': 'PPA_UPDATE', 'route': 'ppa/:id' },
    { 'recurso': 'VERSAO', 'route': 'versao' },
    { 'recurso': 'VERSAO_CREATE', 'route': 'versao/new' },
    { 'recurso': 'VERSAO_UPDATE', 'route': 'versao/:id' },
    { 'recurso': 'VERSAO_UPDATE', 'route': 'aprovar-versao' },
    { 'recurso': 'EMENDA_PARLAMENTAR', 'route': 'emenda-parlamentar' },
    { 'recurso': 'EMENDA_PARLAMENTAR_CREATE', 'route': 'emenda-parlamentar/new' },
    { 'recurso': 'EMENDA_PARLAMENTAR_UPDATE', 'route': 'emenda-parlamentar/:id' },
    { 'recurso': 'MACRO_OBJETIVO', 'route': 'macro-objetivo' },
    { 'recurso': 'MACRO_OBJETIVO_CREATE', 'route': 'macro-objetivo/new' },
    { 'recurso': 'MACRO_OBJETIVO_UPDATE', 'route': 'macro-objetivo/:id' },
    { 'recurso': 'PUBLICO_ALVO', 'route': 'publico-alvo' },
    { 'recurso': 'PUBLICO_ALVO_CREATE', 'route': 'publico-alvo/new' },
    { 'recurso': 'PUBLICO_ALVO_UPDATE', 'route': 'publico-alvo/:id' },
    { 'recurso': 'CONFIGURACAO_PARAMETRO', 'route': 'configuracao-parametro' },
    {
        'recurso': 'CONFIGURACAO_PARAMETRO_CREATE',
        'route': 'configuracao-parametro/new'
    },
    {
        'recurso': 'CONFIGURACAO_PARAMETRO_UPDATE',
        'route': 'configuracao-parametro/:id'
    },
    { 'recurso': 'RECEITA', 'route': 'receita' },
    { 'recurso': 'RECEITA_CREATE', 'route': 'receita/new' },
    { 'recurso': 'RECEITA_UPDATE', 'route': 'receita/:id' },
    { 'recurso': 'RECEITA_PADRAO_TCE', 'route': 'receita-padrao-tce' },
    { 'recurso': 'RECEITA_PADRAO_TCE_CREATE', 'route': 'receita-padrao-tce/new' },
    { 'recurso': 'RECEITA_PADRAO_TCE_UPDATE', 'route': 'receita-padrao-tce/:id' },
    { 'recurso': 'ESTIMATIVA_RECEITA', 'route': 'estimativa-receita' },
    { 'recurso': 'ESTIMATIVA_RECEITA_CREATE', 'route': 'estimativa-receita' },
    {
        'recurso': 'ESTIMATIVA_RECEITA_UPDATE',
        'route': 'estimativa-receita/edit'
    },
    { 'recurso': 'SUBFUNCAO', 'route': 'subfuncoes' },
    { 'recurso': 'SUBFUNCAO_CREATE', 'route': 'subfuncoes/new' },
    { 'recurso': 'SUBFUNCAO_UPDATE', 'route': 'subfuncoes/:id' },
    { 'recurso': 'FONTE_RECURSO', 'route': 'fonte-recurso' },
    { 'recurso': 'FONTE_RECURSO_CREATE', 'route': 'fonte-recurso/new' },
    { 'recurso': 'FONTE_RECURSO_UPDATE', 'route': 'fonte-recurso/:id' },
    { 'recurso': 'CONFIGURACAO_PARAMETRO', 'route': 'configuracao-parametros' },
    {
        'recurso': 'CONFIGURACAO_PARAMETRO_CREATE',
        'route': 'configuracao-parametros/new'
    },
    {
        'recurso': 'CONFIGURACAO_PARAMETRO_UPDATE',
        'route': 'configuracao-parametros/:id'
    },
    { 'recurso': 'ACOES', 'route': 'acao-detalhada' },
    { 'recurso': 'ACOES_CREATE', 'route': 'acao-detalhada/new' },
    { 'recurso': 'ACOES_UPDATE', 'route': 'acao-detalhada/:id' },
    { 'recurso': 'DESPESA_PADRAO_TCE', 'route': 'despesa-padrao-tce' },
    { 'recurso': 'DESPESA_PADRAO_TCE_CREATE', 'route': 'despesa-padrao-tce/new' },
    { 'recurso': 'DESPESA_PADRAO_TCE_UPDATE', 'route': 'despesa-padrao-tce/:id' },
    { 'recurso': 'DESPESA', 'route': 'despesa' },
    { 'recurso': 'DESPESA_CREATE', 'route': 'despesa/new' },
    { 'recurso': 'DESPESA_UPDATE', 'route': 'despesa/:id' },
    { 'recurso': 'DOTACAO', 'route': 'dotacao' },
    { 'recurso': 'DOTACAO_CREATE', 'route': 'dotacao/new' },
    { 'recurso': 'DOTACAO_UPDATE', 'route': 'dotacao/:id' },
    { 'recurso': 'LDO_VARIAVEL', 'route': 'ldo-variavel' },
    { 'recurso': 'LDO_VARIAVEL_UPDATE', 'route': 'ldo-variavel/:id' },
    { 'recurso': 'LOA_RECEITA', 'route': 'loa-receitas' },
    { 'recurso': 'LOA_RECEITA_CREATE', 'route': 'loa-receitas/:id/edit' },
    { 'recurso': 'LOA_RECEITA_UPDATE', 'route': 'loa-receitas/:id' },
    { 'recurso': 'LOA_VERSAO', 'route': 'loa-versao' },
    { 'recurso': 'LOA_VERSAO_CREATE', 'route': 'loa-versao/new' },
    { 'recurso': 'LOA_VERSAO_UPDATE', 'route': 'loa-versao/:id' },
    { 'recurso': 'LDO_VERSAO', 'route': 'ldo-versao' },
    { 'recurso': 'LDO_VERSAO_CREATE', 'route': 'ldo-versao/new' },
    { 'recurso': 'LDO_VERSAO_UPDATE', 'route': 'ldo-versao/:id' },
    { 'recurso': 'CONSULTA_PPA_DESPESA', 'route': 'consulta-ppa-despesa' },
    { 'recurso': 'CONSULTA_LOA_RECEITA', 'route': 'consulta-loa-receita' },
    { 'recurso': 'CONSULTA_ESTIMATIVA', 'route': 'consulta-estimativa-receita' },
    { 'recurso': 'CONSULTA_DOTACAO', 'route': 'consulta-loa-dotacao' },
    { 'recurso': 'DESPESA_PADRAO_TCE', 'route': 'importar-despesa-padrao' }
];

class UsuarioInfoUtils {
    static usuarioInfoHasDefined(usuarioInfo) {
        return usuarioInfo && usuarioInfo.entidadePadrao && usuarioInfo.exercicioPadrao && usuarioInfo.mesPadrao;
    }
    static usuarioInfoHasDefinedOrcamento(usuarioInfo) {
        return usuarioInfo && usuarioInfo.entidadePadrao && usuarioInfo.exercicioPadrao;
    }
    static getEntidadePrincipal(usuarioInfo) {
        if (usuarioInfo.entidadePadrao) {
            return usuarioInfo.entidadePadrao;
        }
        if (usuarioInfo.entidades && usuarioInfo.entidades.length > 0) {
            let entidade = usuarioInfo.entidades.find(ent => ent.principal);
            if (!entidade) {
                entidade = usuarioInfo.entidades[0];
            }
            return entidade;
        }
        return null;
    }
    static getModuloPrincipal(usuarioInfo, moduloSuggest) {
        if (usuarioInfo.modulos && usuarioInfo.modulos.length > 0) {
            let modulo;
            if (moduloSuggest) {
                modulo = usuarioInfo.modulos.find(mod => mod.id === moduloSuggest);
            }
            else {
                modulo = usuarioInfo.modulos.find(mod => mod.principal);
            }
            if (!modulo) {
                modulo = usuarioInfo.modulos[0];
            }
            return modulo;
        }
        return null;
    }
}

const DAYS_EXPIRES_REMEMBER = 10;
const ELOTECH_DOMAIN = '.elotech.localnet';
const MODULO_KEY = 'modulo';
class AuthParams {
    constructor(authResourcesConfig) {
        this.authResourcesConfig = authResourcesConfig;
        this.onLoginSource = new ReplaySubject();
        this.onLoginObservers = this.onLoginSource.asObservable();
        this.moduloFromUrl = '--';
        this.usuarioInfoMemory = null;
        this.tokenKey = this.authResourcesConfig.tokenKey;
        this.moduloFromUrl = this.getModuloFromUrl();
        if (this.isLogged()) {
            this.onLoginSource.next(true);
        }
    }
    isLogged() {
        return Cookie.get(this.tokenKey) !== null;
    }
    getToken() {
        return Cookie.get(this.tokenKey);
    }
    setLogged(token, rememberMe) {
        let days = rememberMe ? DAYS_EXPIRES_REMEMBER : 0;
        Cookie.set(this.tokenKey, token, days, '/', this.getDomain());
        this.onLoginSource.next(true);
    }
    logout() {
        Cookie.set(this.tokenKey, Cookie.get(this.tokenKey), -1, '/', this.getDomain());
        this.usuarioInfoMemory = null;
        this.onLoginSource.next(false);
    }
    setUsuarioInfo(usuarioInfo, useConfig = true) {
        this.usuarioInfoMemory = usuarioInfo;
        if (!this.usuarioInfoMemory.entidadePadrao) {
            if (this.usuarioInfoMemory.entidades) {
                this.usuarioInfoMemory.entidadePadrao = usuarioInfo.entidades.find(entidade => entidade.principal);
            }
        }
        if (BaseHref.testCurrPath() && this.usuarioInfoMemory.entidadePadrao && this.usuarioInfoMemory.entidades.length > 0) {
            const baseHrefFromUrl = BaseHref.extract();
            if (baseHrefFromUrl.entidade === 0 || !useConfig
                || (BaseHref.isEntidadeUUID(this.usuarioInfoMemory.entidadePadrao.id) && NumberUtils.isNumeric(baseHrefFromUrl.entidade))) {
                const baseHref = new BaseHref(this.usuarioInfoMemory.entidadePadrao.id, this.usuarioInfoMemory.mesPadrao, this.usuarioInfoMemory.exercicioPadrao);
                if (BaseHref.isEntidadeUUID(this.usuarioInfoMemory.entidadePadrao.id)) {
                    baseHref.change(true);
                }
                else {
                    baseHref.change();
                }
            }
            else {
                // eslint-disable-next-line
                this.usuarioInfoMemory.entidadePadrao = usuarioInfo.entidades.find(entidade => entidade.id == baseHrefFromUrl.entidade);
                this.usuarioInfoMemory.exercicioPadrao = baseHrefFromUrl.ano;
                this.usuarioInfoMemory.mesPadrao = baseHrefFromUrl.mes;
            }
        }
    }
    getUsuarioInfo() {
        return this.usuarioInfoMemory;
    }
    hasUsuarioInfo() {
        return this.usuarioInfoMemory !== null;
    }
    getModuloFromUrl() {
        const locationSearch = this.getLocationSearch().replace('?', '');
        return new HttpParams({ fromString: locationSearch }).get(MODULO_KEY);
    }
    getLocationSearch() {
        return window.location.search;
    }
    getInitialModuloFromUrl() {
        return this.moduloFromUrl;
    }
    getActualModulo() {
        if (this.hasUsuarioInfo()) {
            return UsuarioInfoUtils.getModuloPrincipal(this.getUsuarioInfo(), this.getInitialModuloFromUrl());
        }
        return null;
    }
    getDomain() {
        let domain = window.location.hostname;
        if (domain.includes(ELOTECH_DOMAIN)) {
            domain = ELOTECH_DOMAIN;
        }
        return domain;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthParams, deps: [{ token: AUTH_RESOURCES_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthParams }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthParams, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }] });

const BASE_URL = '/';
const REDIRECT_PARAM = 'redirect';
class AuthHttp {
    constructor(httpClient, router, authParams, authResourcesConfig) {
        this.httpClient = httpClient;
        this.router = router;
        this.authParams = authParams;
        this.authResourcesConfig = authResourcesConfig;
        this.lastUrl = BASE_URL;
    }
    getUsuario() {
        return this.getUsuarioLogado().toPromise();
    }
    login(user) {
        return this.internalLogin(this.authResourcesConfig.urlApi, user);
    }
    x509Login(user) {
        return this.internalLogin(this.authResourcesConfig.urlX509Api, user);
    }
    getUsuarioLogado() {
        const requestParams = {
            resource: this.authResourcesConfig.urlMe,
            fields: this.authResourcesConfig.fieldsMe,
            disableSpinner: true
        };
        if (!this.usuarioLogado) {
            this.usuarioLogado = this.httpClient.get(requestParams)
                .pipe(publishReplay(1), refCount());
        }
        return this.usuarioLogado;
    }
    getX509Token(providerUrl) {
        let originCall = !/https?:\/\/.*/.test(providerUrl);
        const requestParams = {
            resource: originCall ? '/x509-auth-provider/auth' : '/auth',
            location: providerUrl,
            disableSpinner: true,
            requestOrigin: originCall,
        };
        return this.httpClient.get(requestParams);
    }
    goToAuthForm(url) {
        this.setLastUrl();
        if (this.authResourcesConfig.urlForm) {
            if (!this.router.url.startsWith(this.authResourcesConfig.urlForm)) {
                this.router.navigateByUrl(this.authResourcesConfig.urlForm);
            }
        }
        else {
            let urlForm = this.authResourcesConfig.isDev ? `${this.authResourcesConfig.hostDev}/${this.authResourcesConfig.urlFormDefault}` :
                `${window.location.origin}/${this.authResourcesConfig.urlFormDefault}`;
            urlForm += `?${REDIRECT_PARAM}=${url ? url : window.location.href}`;
            this.redirect(urlForm);
        }
    }
    goToLastUrl() {
        const redirectUrl = this.getRedirectUrl();
        if (redirectUrl) {
            this.redirect(redirectUrl);
        }
        else {
            this.router.navigateByUrl(this.lastUrl);
        }
    }
    goToAuthFormIfExists(url) {
        if (this.authResourcesConfig.urlForm) {
            this.goToAuthForm(url);
        }
        else {
            this.logoutAndGoToAuthForm();
        }
    }
    logoutAndGoToAuthForm() {
        this.logout();
        this.goToAuthForm();
        this.setLastUrl(BASE_URL);
    }
    getLastUrl() {
        return this.lastUrl;
    }
    logout() {
        this.usuarioLogado = null;
        this.authParams.logout();
    }
    isLogged() {
        return this.authParams.isLogged();
    }
    isAdmin() {
        return this.getUsuarioLogado().pipe(map(user => {
            return isUserAdmin(user);
        }));
    }
    isAdminUser(usuario) {
        return isUserAdmin(usuario);
    }
    setLastUrl(url) {
        let urlToCompare = url ? url : window.location.pathname;
        if (urlToCompare === this.authResourcesConfig.urlForm) {
            this.lastUrl = BASE_URL;
        }
        else {
            this.lastUrl = urlToCompare.replace(this.getHref(), BASE_URL);
        }
    }
    redirect(url) {
        window.location.href = url;
    }
    getPermissionsByRole(role) {
        return this.getUsuarioLogado().pipe(map((user) => user.recursos.filter((recurso) => recurso.toUpperCase().startsWith(role.toUpperCase()))));
    }
    hasPermissionByRoute(route) {
        if (!route) {
            return of(true);
        }
        const searchRoute = route.startsWith('/') ? route.replace('/', '') : route;
        const permissaoRota = permissions.find(p => p.route === searchRoute);
        return this.getUsuarioLogado().pipe(map(usuario => {
            if (!permissaoRota) {
                return true;
            }
            else if (usuario.recursos) {
                return usuario.recursos.includes(permissaoRota.recurso);
            }
        }));
    }
    getRedirectUrl() {
        return this.router.parseUrl(window.location.search).queryParams[REDIRECT_PARAM];
    }
    getHref() {
        let base = document.getElementsByTagName('base')[0];
        if (base) {
            return base.getAttribute('href');
        }
    }
    setUsuarioInfo(usuarioInfo, useConfig = false) {
        this.authParams.setUsuarioInfo({ ...usuarioInfo }, useConfig);
    }
    getUsuarioInfo() {
        return this.authParams.getUsuarioInfo();
    }
    internalLogin(urlApi, user) {
        return this.httpClient.post({ resource: urlApi, body: user })
            .pipe(map((response) => {
            this.authParams.setLogged(response.id_token, user.rememberMe);
            return response;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthHttp, deps: [{ token: HttpClient }, { token: i1$4.Router }, { token: AuthParams }, { token: AUTH_RESOURCES_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthHttp }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthHttp, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }, { type: i1$4.Router }, { type: AuthParams }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }] });

class AccessRecoveryComponent {
    constructor() {
        this.placeholder = 'Nome de Usuário';
        this.onRecovery = new EventEmitter();
        this.onBack = new EventEmitter();
    }
    recovery() {
        this.onRecovery.emit(this.form.getRawValue());
    }
    back() {
        this.onBack.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccessRecoveryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: AccessRecoveryComponent, selector: "access-recovery", inputs: { form: "form", placeholder: "placeholder" }, outputs: { onRecovery: "onRecovery", onBack: "onBack" }, ngImport: i0, template: "<form class=\"login-form\" [formGroup]=\"form\">\n\n  <div class=\"login-form-group\">\n\n    <input id=\"user\" class=\"user\" type=\"text\" [placeholder]=\"placeholder\" formControlName=\"username\">\n\n    <button id=\"btnRecovery\" class=\"btn send-btn\"\n            [disabled]=\"form.invalid\"\n            (click)=\"recovery()\">\n      Recuperar\n    </button>\n\n  </div>\n\n  <div class=\"login-form-list\">\n    <a id=\"btnBack\" href=\"javascript:void(0)\" (click)=\"back()\">\n      Voltar\n    </a>\n  </div>\n\n</form>\n", dependencies: [{ kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccessRecoveryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'access-recovery', template: "<form class=\"login-form\" [formGroup]=\"form\">\n\n  <div class=\"login-form-group\">\n\n    <input id=\"user\" class=\"user\" type=\"text\" [placeholder]=\"placeholder\" formControlName=\"username\">\n\n    <button id=\"btnRecovery\" class=\"btn send-btn\"\n            [disabled]=\"form.invalid\"\n            (click)=\"recovery()\">\n      Recuperar\n    </button>\n\n  </div>\n\n  <div class=\"login-form-list\">\n    <a id=\"btnBack\" href=\"javascript:void(0)\" (click)=\"back()\">\n      Voltar\n    </a>\n  </div>\n\n</form>\n" }]
        }], propDecorators: { form: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], onRecovery: [{
                type: Output
            }], onBack: [{
                type: Output
            }] } });

class NewPasswordComponent {
    constructor() {
        this.onSave = new EventEmitter();
        this.onBack = new EventEmitter();
    }
    save() {
        this.onSave.emit(this.form.getRawValue());
    }
    back() {
        this.onBack.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NewPasswordComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NewPasswordComponent, selector: "new-password", inputs: { form: "form" }, outputs: { onSave: "onSave", onBack: "onBack" }, ngImport: i0, template: "<form class=\"login-form\" [formGroup]=\"form\">\n\n  <div class=\"login-form-group\">\n\n    <div class=\"form-group\">\n      <label for=\"password\" class=\"label\">Nova Senha</label>\n      <input id=\"password\" class=\"password\" type=\"password\" formControlName=\"password\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"confirm-password\" class=\"label\">Confirmar Senha</label>\n      <input id=\"confirm-password\" class=\"password\" type=\"password\" formControlName=\"confirmPassword\">\n    </div>\n\n    <button id=\"btnSaveNewPassword\" class=\"btn send-btn\" [disabled]=\"form.invalid\" (click)=\"save()\">\n      Salvar\n    </button>\n\n  </div>\n\n  <div class=\"login-form-list\">\n    <a href=\"javascript:void(0)\" (click)=\"back()\">\n      Ir para login\n    </a>\n  </div>\n\n</form>\n", dependencies: [{ kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NewPasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'new-password', template: "<form class=\"login-form\" [formGroup]=\"form\">\n\n  <div class=\"login-form-group\">\n\n    <div class=\"form-group\">\n      <label for=\"password\" class=\"label\">Nova Senha</label>\n      <input id=\"password\" class=\"password\" type=\"password\" formControlName=\"password\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"confirm-password\" class=\"label\">Confirmar Senha</label>\n      <input id=\"confirm-password\" class=\"password\" type=\"password\" formControlName=\"confirmPassword\">\n    </div>\n\n    <button id=\"btnSaveNewPassword\" class=\"btn send-btn\" [disabled]=\"form.invalid\" (click)=\"save()\">\n      Salvar\n    </button>\n\n  </div>\n\n  <div class=\"login-form-list\">\n    <a href=\"javascript:void(0)\" (click)=\"back()\">\n      Ir para login\n    </a>\n  </div>\n\n</form>\n" }]
        }], propDecorators: { form: [{
                type: Input
            }], onSave: [{
                type: Output
            }], onBack: [{
                type: Output
            }] } });

class RecoveryMessageComponent {
    constructor() {
        this.onClick = new EventEmitter();
    }
    click() {
        this.onClick.emit(this.recovery.showComponentAfterOk);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecoveryMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: RecoveryMessageComponent, selector: "recovery-message", inputs: { recovery: "recovery" }, outputs: { onClick: "onClick" }, ngImport: i0, template: "<div class=\"login-form\">\n\n  <div class=\"login-form-group\">\n\n    <p>{{recovery.message}}</p>\n\n    <button id=\"btnRecoveryMessageOk\" class=\"btn send-btn\" (click)=\"click()\">\n      Ok\n    </button>\n  </div>\n\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecoveryMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'recovery-message', template: "<div class=\"login-form\">\n\n  <div class=\"login-form-group\">\n\n    <p>{{recovery.message}}</p>\n\n    <button id=\"btnRecoveryMessageOk\" class=\"btn send-btn\" (click)=\"click()\">\n      Ok\n    </button>\n  </div>\n\n</div>\n" }]
        }], propDecorators: { recovery: [{
                type: Input
            }], onClick: [{
                type: Output
            }] } });

class AuthenticationComponent {
    constructor(_fb, _authHttp, _windowService, activatedRoute) {
        this._fb = _fb;
        this._authHttp = _authHttp;
        this._windowService = _windowService;
        this.activatedRoute = activatedRoute;
        this.showLoginForm = false;
        this.showAccessRecoveryForm = false;
        this.showNewPasswordForm = false;
        this.showRecoveryMessageComponent = false;
        this.placeholder = 'Nome de Usuário';
    }
    ngOnInit() {
        this.resetCode = this.activatedRoute.snapshot.queryParams['reset'];
        if (this.resetCode && this.resetCode.length > 0) {
            this.showNewPasswordComponent();
        }
        else {
            this.showLoginForm = true;
            this.showCaptcha = false;
            this.form = this._fb.group({
                username: ['', Validators.required],
                password: ['', Validators.required],
                tipo: ['USUARIO'],
                captcha: [''],
                rememberMe: [false],
            });
            this.validateUser();
        }
    }
    showLoginComponent() {
        this.showAccessRecoveryForm = false;
        this.showNewPasswordForm = false;
        this.showLoginForm = true;
        this.showCaptcha = false;
        this.form = this._fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            tipo: ['USUARIO'],
            captcha: [''],
            rememberMe: [false],
        });
        this.validateUser();
    }
    showRecuperarAcesso() {
        this.showLoginForm = false;
        this.showNewPasswordForm = false;
        this.showAccessRecoveryForm = true;
        this.form = this._fb.group({
            username: [null, Validators.required],
        });
    }
    showNewPasswordComponent() {
        this.showAccessRecoveryForm = false;
        this.showLoginForm = false;
        this.showNewPasswordForm = true;
        this.form = this._fb.group({
            resetCode: [this.resetCode, Validators.required],
            password: [null, Validators.required],
            confirmPassword: [null, Validators.required],
        });
    }
    onSubmit(user) {
        this.error = '';
        this._authHttp.login(user).subscribe(() => this.handleSuccess(), (e) => this.handleError(e));
    }
    doX509Login() {
        let providerUrl = this.form.get('username').value;
        if (!/https?:\/\/.*/.test(providerUrl)) {
            providerUrl = 'https://auth.iss.elotech.com.br:8443';
        }
        this._authHttp.getX509Token(providerUrl).subscribe((token) => {
            let user = {
                x509Token: token,
            };
            this._authHttp.x509Login(user).subscribe(() => this.handleSuccess(), (e) => this.handleError(e));
        }, (e) => this.handleError(e));
    }
    handleSuccess() {
        this._authHttp.goToLastUrl();
    }
    goCadastro() {
        this._authHttp.redirect(window.location.href.split('/auth')[0] + '/usuario');
    }
    handleError(error) {
        this.error = error.message;
        if (error.status === 401) {
            this.error = 'Usuário ou senha incorretos.';
            if (this.showCaptcha) {
                this.form.get('captcha').reset();
            }
        }
        else if (error.status === 418) {
            this.showCaptcha = true;
        }
        else if (error.status === 500) {
            this.error = 'Usuário ou senha incorretos.';
        }
        else {
            throw error;
        }
    }
    accessRecovery(object) {
        this.authenticationService.passwordRecovery(object).subscribe(() => {
            this.showDialogWithMessage('Enviamos um e-mail com as instruções para criar uma nova senha.', 'login');
        }, (error) => {
            this.showDialogWithMessage(error.message, 'recovery');
        });
    }
    saveNewPassword(object) {
        this.authenticationService.resetPassword(object).subscribe(() => {
            this.showDialogWithMessage('Senha alterada com sucesso', 'login');
        }, (error) => {
            this.showDialogWithMessage(error.message, 'new-password');
        });
    }
    showDialogWithMessage(message, showComponentAfterOk) {
        this.showRecoveryMessageComponent = true;
        this.showLoginForm = false;
        this.showAccessRecoveryForm = false;
        this.showNewPasswordForm = false;
        this.recovery = {
            message: message,
            showComponentAfterOk: showComponentAfterOk,
        };
    }
    recoveryOk(showComponentAfterOk) {
        this.showRecoveryMessageComponent = false;
        switch (showComponentAfterOk) {
            case 'recovery':
                this.showRecuperarAcesso();
                break;
            case 'new-password':
                this.showNewPasswordComponent();
                break;
            default:
                this.showLoginComponent();
                break;
        }
    }
    isFormValid() {
        if (!this.showCaptcha) {
            return true;
        }
        return this.form.get('captcha').value !== '';
    }
    hasX509Auth() {
        return this.x509Auth && this._windowService.usingSSL();
    }
    validateUser() {
        if (this._authHttp.isLogged()) {
            this._authHttp.isAdmin().subscribe((admin) => (this.isAdmin = admin), () => this._authHttp.logout());
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthenticationComponent, deps: [{ token: i1$2.UntypedFormBuilder }, { token: AuthHttp }, { token: WindowService }, { token: i1$4.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: AuthenticationComponent, selector: "user-authentication", inputs: { urlBrasao: "urlBrasao", entidadeCidade: "entidadeCidade", inputRecoveryPlaceholder: "inputRecoveryPlaceholder", authenticationService: "authenticationService", showCaptcha: "showCaptcha", x509Auth: "x509Auth", placeholder: "placeholder" }, ngImport: i0, template: "<section class=\"login modal open\">\n  <div class=\"login-outer\">\n    <div class=\"login-inner\">\n      <div class=\"login-box\">\n        <header class=\"login-header\">\n          <figure>\n            <img src=\"{{ urlBrasao }}\" />\n          </figure>\n\n          <figure>\n            <img\n              onerror=\"this.style.display='none'\"\n              src=\"img/common/login_logo.jpg\"\n            />\n          </figure>\n\n          <img src=\"img/common/logo_oxy_login.png\" alt=\"Logo Oxy Login\" />\n          <h2 class=\"login-city-name typography-size-20px typography-medium\">\n            {{ entidadeCidade?.cidade?.descricao }}\n          </h2>\n        </header>\n\n        <div *ngIf=\"showLoginForm\">\n          <form\n            class=\"login-form\"\n            [formGroup]=\"form\"\n            (ngSubmit)=\"onSubmit(form.value)\"\n          >\n            <div class=\"login-form-group\">\n              <div class=\"error-message mb-xs\" *ngIf=\"error\">\n                <i class=\"fa fa-times-circle icon\"></i>\n                {{ error }}\n              </div>\n\n              <input\n                id=\"user\"\n                type=\"text\"\n                [ngClass]=\"error ? 'error user' : 'user'\"\n                [placeholder]=\"placeholder\"\n                formControlName=\"username\"\n              />\n              <input\n                id=\"password\"\n                type=\"password\"\n                [ngClass]=\"error ? 'error password' : 'password'\"\n                placeholder=\"Senha\"\n                formControlName=\"password\"\n              />\n              <select\n                id=\"select-filter\"\n                name=\"select-filter\"\n                formControlName=\"tipo\"\n              >\n                <option selected [value]=\"'USUARIO'\">Usu\u00E1rio</option>\n                <option [value]=\"'ELOTECH'\">Elotech</option>\n              </select>\n              `\n              <div *ngIf=\"showCaptcha\">\n                <re-captcha id=\"captcha\" formControlName=\"captcha\"></re-captcha>\n              </div>\n\n              <div>\n                <button\n                  id=\"btn-login\"\n                  class=\"send-btn\"\n                  [class.disabled]=\"!isFormValid()\"\n                >\n                  Entrar\n                </button>\n              </div>\n\n              <div class=\"login-form-list\">\n                <a\n                  (click)=\"goCadastro()\"\n                  href=\"javascript:void(0)\"\n                  *ngIf=\"authenticationService\"\n                >\n                  Crie sua conta\n                </a>\n\n                <a\n                  id=\"recovery-password\"\n                  href=\"javascript:void(0)\"\n                  (click)=\"showRecuperarAcesso()\"\n                  *ngIf=\"authenticationService\"\n                >\n                  Esqueceu sua senha?\n                </a>\n              </div>\n\n              <div class=\"login-form-list\">\n                <input\n                  type=\"checkbox\"\n                  class=\"input-checkbox\"\n                  id=\"rememberme\"\n                  formControlName=\"rememberMe\"\n                />\n                <label for=\"rememberme\">Continuar conectado</label>\n              </div>\n\n              <div *ngIf=\"hasX509Auth()\">\n                <p class=\"divider\">ou conecte-se com</p>\n                <button\n                  id=\"x509Login\"\n                  type=\"button\"\n                  class=\"certificado\"\n                  (click)=\"doX509Login()\"\n                >\n                  <i class=\"fa fa-lock\"></i>\n                  Certificado\n                </button>\n              </div>\n            </div>\n          </form>\n        </div>\n\n        <div *ngIf=\"showAccessRecoveryForm\">\n          <access-recovery\n            [placeholder]=\"inputRecoveryPlaceholder\"\n            [form]=\"form\"\n            (onRecovery)=\"accessRecovery($event)\"\n            (onBack)=\"showLoginComponent()\"\n          ></access-recovery>\n        </div>\n\n        <div *ngIf=\"showNewPasswordForm\">\n          <new-password\n            [form]=\"form\"\n            (onSave)=\"saveNewPassword($event)\"\n            (onBack)=\"showLoginComponent()\"\n          ></new-password>\n        </div>\n\n        <div *ngIf=\"showRecoveryMessageComponent\">\n          <recovery-message\n            [recovery]=\"recovery\"\n            (onClick)=\"recoveryOk($event)\"\n          ></recovery-message>\n        </div>\n\n        <footer class=\"login-box-footer\">\n          <img\n            src=\"img/common/logo-footer-new.png\"\n            alt=\"Logo Tecnologia Elotech\"\n          />\n        </footer>\n      </div>\n    </div>\n  </div>\n</section>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i6.RecaptchaComponent, selector: "re-captcha", inputs: ["id", "siteKey", "theme", "type", "size", "tabIndex", "badge", "errorMode"], outputs: ["resolved", "error", "errored"], exportAs: ["reCaptcha"] }, { kind: "directive", type: i6.RecaptchaValueAccessorDirective, selector: "re-captcha[formControlName],re-captcha[formControl],re-captcha[ngModel]" }, { kind: "component", type: AccessRecoveryComponent, selector: "access-recovery", inputs: ["form", "placeholder"], outputs: ["onRecovery", "onBack"] }, { kind: "component", type: NewPasswordComponent, selector: "new-password", inputs: ["form"], outputs: ["onSave", "onBack"] }, { kind: "component", type: RecoveryMessageComponent, selector: "recovery-message", inputs: ["recovery"], outputs: ["onClick"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthenticationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'user-authentication', template: "<section class=\"login modal open\">\n  <div class=\"login-outer\">\n    <div class=\"login-inner\">\n      <div class=\"login-box\">\n        <header class=\"login-header\">\n          <figure>\n            <img src=\"{{ urlBrasao }}\" />\n          </figure>\n\n          <figure>\n            <img\n              onerror=\"this.style.display='none'\"\n              src=\"img/common/login_logo.jpg\"\n            />\n          </figure>\n\n          <img src=\"img/common/logo_oxy_login.png\" alt=\"Logo Oxy Login\" />\n          <h2 class=\"login-city-name typography-size-20px typography-medium\">\n            {{ entidadeCidade?.cidade?.descricao }}\n          </h2>\n        </header>\n\n        <div *ngIf=\"showLoginForm\">\n          <form\n            class=\"login-form\"\n            [formGroup]=\"form\"\n            (ngSubmit)=\"onSubmit(form.value)\"\n          >\n            <div class=\"login-form-group\">\n              <div class=\"error-message mb-xs\" *ngIf=\"error\">\n                <i class=\"fa fa-times-circle icon\"></i>\n                {{ error }}\n              </div>\n\n              <input\n                id=\"user\"\n                type=\"text\"\n                [ngClass]=\"error ? 'error user' : 'user'\"\n                [placeholder]=\"placeholder\"\n                formControlName=\"username\"\n              />\n              <input\n                id=\"password\"\n                type=\"password\"\n                [ngClass]=\"error ? 'error password' : 'password'\"\n                placeholder=\"Senha\"\n                formControlName=\"password\"\n              />\n              <select\n                id=\"select-filter\"\n                name=\"select-filter\"\n                formControlName=\"tipo\"\n              >\n                <option selected [value]=\"'USUARIO'\">Usu\u00E1rio</option>\n                <option [value]=\"'ELOTECH'\">Elotech</option>\n              </select>\n              `\n              <div *ngIf=\"showCaptcha\">\n                <re-captcha id=\"captcha\" formControlName=\"captcha\"></re-captcha>\n              </div>\n\n              <div>\n                <button\n                  id=\"btn-login\"\n                  class=\"send-btn\"\n                  [class.disabled]=\"!isFormValid()\"\n                >\n                  Entrar\n                </button>\n              </div>\n\n              <div class=\"login-form-list\">\n                <a\n                  (click)=\"goCadastro()\"\n                  href=\"javascript:void(0)\"\n                  *ngIf=\"authenticationService\"\n                >\n                  Crie sua conta\n                </a>\n\n                <a\n                  id=\"recovery-password\"\n                  href=\"javascript:void(0)\"\n                  (click)=\"showRecuperarAcesso()\"\n                  *ngIf=\"authenticationService\"\n                >\n                  Esqueceu sua senha?\n                </a>\n              </div>\n\n              <div class=\"login-form-list\">\n                <input\n                  type=\"checkbox\"\n                  class=\"input-checkbox\"\n                  id=\"rememberme\"\n                  formControlName=\"rememberMe\"\n                />\n                <label for=\"rememberme\">Continuar conectado</label>\n              </div>\n\n              <div *ngIf=\"hasX509Auth()\">\n                <p class=\"divider\">ou conecte-se com</p>\n                <button\n                  id=\"x509Login\"\n                  type=\"button\"\n                  class=\"certificado\"\n                  (click)=\"doX509Login()\"\n                >\n                  <i class=\"fa fa-lock\"></i>\n                  Certificado\n                </button>\n              </div>\n            </div>\n          </form>\n        </div>\n\n        <div *ngIf=\"showAccessRecoveryForm\">\n          <access-recovery\n            [placeholder]=\"inputRecoveryPlaceholder\"\n            [form]=\"form\"\n            (onRecovery)=\"accessRecovery($event)\"\n            (onBack)=\"showLoginComponent()\"\n          ></access-recovery>\n        </div>\n\n        <div *ngIf=\"showNewPasswordForm\">\n          <new-password\n            [form]=\"form\"\n            (onSave)=\"saveNewPassword($event)\"\n            (onBack)=\"showLoginComponent()\"\n          ></new-password>\n        </div>\n\n        <div *ngIf=\"showRecoveryMessageComponent\">\n          <recovery-message\n            [recovery]=\"recovery\"\n            (onClick)=\"recoveryOk($event)\"\n          ></recovery-message>\n        </div>\n\n        <footer class=\"login-box-footer\">\n          <img\n            src=\"img/common/logo-footer-new.png\"\n            alt=\"Logo Tecnologia Elotech\"\n          />\n        </footer>\n      </div>\n    </div>\n  </div>\n</section>\n" }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }, { type: AuthHttp }, { type: WindowService }, { type: i1$4.ActivatedRoute }], propDecorators: { urlBrasao: [{
                type: Input
            }], entidadeCidade: [{
                type: Input
            }], inputRecoveryPlaceholder: [{
                type: Input
            }], authenticationService: [{
                type: Input
            }], showCaptcha: [{
                type: Input
            }], x509Auth: [{
                type: Input
            }], placeholder: [{
                type: Input
            }] } });

class AuthenticationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthenticationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AuthenticationModule, declarations: [AuthenticationComponent, AccessRecoveryComponent, NewPasswordComponent,
            RecoveryMessageComponent], imports: [CommonModule, FormsModule, ReactiveFormsModule, RecaptchaModule,
            RecaptchaFormsModule], exports: [AuthenticationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthenticationModule, providers: [
            WindowService,
            {
                provide: RECAPTCHA_SETTINGS,
                useValue: {
                    siteKey: '6Lf0QX8UAAAAAKji3EmHWAa1qYdGd9_Mr_Pavi5O',
                },
            },
        ], imports: [CommonModule, FormsModule, ReactiveFormsModule, RecaptchaModule,
            RecaptchaFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthenticationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, ReactiveFormsModule, RecaptchaModule,
                        RecaptchaFormsModule],
                    declarations: [AuthenticationComponent, AccessRecoveryComponent, NewPasswordComponent,
                        RecoveryMessageComponent],
                    exports: [AuthenticationComponent],
                    providers: [
                        WindowService,
                        {
                            provide: RECAPTCHA_SETTINGS,
                            useValue: {
                                siteKey: '6Lf0QX8UAAAAAKji3EmHWAa1qYdGd9_Mr_Pavi5O',
                            },
                        },
                    ]
                }]
        }] });

const INVALID_VALUE = '#INVALID&VALUE#';
function autoCompleteValidator(c) {
    return (c.value === INVALID_VALUE) ? {
        'Valor inválido': {
            valid: false
        }
    } : null;
}
class AutoCompleteComponent {
    constructor(authResourcesConfig, renderer, elementRef) {
        this.authResourcesConfig = authResourcesConfig;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.multiplo = false;
        this.multipleSelected = [];
        this.onChangeMultipleValue = new EventEmitter();
        this.options = [];
        this.placeholder = '';
        this.noResultsMessage = 'Nenhum resultado.';
        this.urlCreate = '';
        this.onChangeValue = new EventEmitter();
        this.onSearchModal = new EventEmitter();
        this.searchModal = false;
        this.isDisabled = false;
        this.findToOptions = null;
        this.objToOption = null;
        this.objToOptionViewMultiple = null;
        this.debounceTime = 200;
        this.autoSelect = false;
        this.isEnabledCreateRecord = false;
        this.descriptionNewRecord = null;
        this.validateDeps = false;
        this.onInsertButton = new EventEmitter();
        this.onCreateRecord = new EventEmitter();
        this.emptyRecord = false;
        this.removeDot = false;
        this.showItens = false;
        this.loading = false;
        this.selectedIndex = 0;
        this.lastSubscription = null;
        this.onValueChange = new Subject();
        this.removeDotIfNecessary = (searchValue) => {
            if (this.removeDot) {
                searchValue = StringUtils.replaceAll(searchValue, '.', '');
            }
            return searchValue;
        };
        this.onChange = () => null;
    }
    validServiceOrMethods() {
        if (this.options.length === 0 && !this.service && (!this.findToOptions || !this.objToOption)) {
            AssertUtilsApp.assert(this.service, 'service not found in autoComplete');
            AssertUtilsApp.assert(this.findToOptions, 'findToOptions not found in autoComplete');
            AssertUtilsApp.assert(this.objToOption, 'objToOption not found in autoComplete');
        }
    }
    objToOptionMultiple(value) {
        if (this.objToOptionViewMultiple) {
            return this.objToOptionViewMultiple(value);
        }
        return this.objToOption(value);
    }
    ngOnInit() {
        this.unRegisterGlobalClick = this.renderer.listen('body', 'click', (event) => {
            if (!this.elementRef.nativeElement.contains(event.target)) {
                this.showItens = false;
            }
        });
        if (!('__karma__' in window) || this.validateDeps) {
            this.validServiceOrMethods();
        }
        if (this.service) {
            this.findToOptions = (searchValue) => this.service.findToOptions(this.removeDotIfNecessary(searchValue));
            this.objToOption = (item) => this.service.objToOption(item);
            if (this.autoSelect) {
                setTimeout(() => {
                    this.service.findToOptions('').pipe(filter(data => !!data)).subscribe(data => {
                        this.dataFromService = data;
                        this.dataFromService.forEach(obj => this.options.push(this.objToOption(obj)));
                        if (this.dataFromService.length === 1) {
                            this.value = this.objToOption(data[0]);
                        }
                    });
                }, 100);
            }
        }
        this.onValueChange.pipe(debounceTime(this.debounceTime))
            .subscribe(value => {
            if (this.lastSubscription && !this.lastSubscription.closed) {
                this.lastSubscription.unsubscribe();
            }
            if (!value) {
                this.onChange(null);
            }
            this.loading = true;
            this.lastSubscription = this.findToOptions(this.sanitizeValue(this.internalValue))
                .subscribe(data => {
                this.handleData(data);
                this.loading = false;
            }, err => {
                this.loading = false;
                throw err;
            });
        });
    }
    ngOnDestroy() {
        this.unRegisterGlobalClick();
    }
    setDescriptionNewRecordAction() {
        if (this.descriptionNewRecord) {
            return 'Incluir ' + this.descriptionNewRecord;
        }
        else {
            return 'Incluir cadastro';
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    get value() {
        return this.internalValue;
    }
    set value(value) {
        this.internalValue = value;
        if (this.findToOptions) {
            if (this.options.indexOf(this.internalValue) >= 0) {
                this.attrToModel();
            }
            else {
                this.onValueChange.next(this.internalValue ? this.internalValue : null);
            }
        }
        else {
            this.attrToModel();
        }
    }
    get noResults() {
        if (this.findToOptions) {
            return this.options.length === 0 && this.lastSubscription && this.lastSubscription.closed;
        }
        return this.options.length === 0;
    }
    onClickClear() {
        if (!this.isDisabled) {
            this.value = '';
            this.onChange(null);
            this.onChangeValue.emit(null);
        }
    }
    writeValue(obj) {
        if (this.objToOption) {
            if (obj) {
                this.internalValue = this.objToOption(obj);
            }
            else {
                this.internalValue = '';
            }
        }
        else {
            this.internalValue = obj;
        }
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    onFocus() {
        if (!this.hasValue()) {
            this.onValueChange.next(this.internalValue);
        }
    }
    onKeyDown(event) {
        if (this.options.length > 0) {
            if ((event.key === 'Tab' || event.key === 'Enter') && this.showItens) {
                event.preventDefault();
                this.onSelect(this.options[this.selectedIndex]);
                if (this.observer)
                    this.observer.disconnect();
            }
            else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                if (event.key === 'ArrowUp') {
                    this.selectedIndex--;
                }
                else {
                    this.selectedIndex++;
                }
                if (this.selectedIndex < 0) {
                    this.selectedIndex = 0;
                }
                else if (this.selectedIndex === this.options.length) {
                    this.selectedIndex = this.options.length - 1;
                }
                if (this.showItens) {
                    this.observer = new MutationObserver(mutations => {
                        mutations.forEach(() => {
                            this._scrollIntoView(this.listOption.nativeElement, document.querySelector('#autocomplete-container li.selected'));
                        });
                    });
                    this.observer.observe(document.querySelector('#autocomplete-container li.selected'), {
                        attributes: true
                    });
                }
            }
            else if (event.key === 'Escape') {
                this.showItens = false;
                if (this.observer)
                    this.observer.disconnect();
            }
        }
    }
    onSelect(option) {
        this.value = option;
        this.showItens = false;
        this.onChangeValue.emit(this.value);
        this.addToMultiplo(option);
    }
    addToMultiplo(option) {
        if (!this.multiplo) {
            return;
        }
        if (this.multiplo && option) {
            const found = this.multipleSelected.find(op => this.objToOption(op) === option);
            if (!found) {
                const index = this.options.indexOf(option);
                if (index !== -1) {
                    const object = this.dataFromService[index];
                    this.multipleSelected.push(object);
                    this.onChangeMultipleValue.emit(this.multipleSelected);
                }
            }
            this.value = '';
        }
    }
    removeItemFromMultiplo(option) {
        if (option) {
            this.multipleSelected = this.multipleSelected
                .filter(op => {
                if (op && op.id && option.id) {
                    return op.id !== option.id;
                }
                if (op && op.uuid && option.uuid) {
                    return op.uuid !== option.uuid;
                }
                return JSON.stringify(op) !== JSON.stringify(option);
            });
            this.onChangeMultipleValue.emit(this.multipleSelected);
        }
    }
    hasValue() {
        return !!this.internalValue;
    }
    openCreate(event) {
        event.preventDefault();
        window.open(this.authResourcesConfig.isDev ? `${this.authResourcesConfig.hostDev}${this.urlCreate}` : `${window.location.origin}${this.urlCreate}`);
    }
    openCreateModal() {
        this.onCreateRecord.emit(this.value);
    }
    hasUrlCreate() {
        return this.urlCreate.length > 0;
    }
    onClickSearch() {
        this.onSearchModal.emit();
    }
    _isDocumentElement(el) {
        return [document.documentElement, document.body, window].indexOf(el) > -1;
    }
    _scrollTo(el, top) {
        if (this._isDocumentElement(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    sanitizeValue(value) {
        const replaceValues = [
            { value: '%', replace: '\%25' },
            { value: '*', replace: '\*' },
            { value: '[', replace: '\%5B' },
            { value: ']', replace: '\%5D' },
            { value: '"', replace: '' },
            { value: '\\', replace: '%5C' },
            { value: '#', replace: '%23' },
            { value: '&', replace: '%26' }
        ];
        if (this.removeDot) {
            replaceValues.push({ value: '.', replace: '' });
        }
        let valueChange = value;
        replaceValues.forEach(r => valueChange = valueChange.split(r.value).join(r.replace));
        return valueChange;
    }
    _scrollIntoView(parentElement, childFocusedElement) {
        const parentRect = parentElement.getBoundingClientRect();
        const focusedRect = childFocusedElement.getBoundingClientRect();
        const overScroll = childFocusedElement.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > parentRect.bottom) {
            this._scrollTo(parentElement, Math.min(childFocusedElement.offsetTop +
                childFocusedElement.clientHeight -
                parentElement.offsetHeight +
                overScroll, parentElement.scrollHeight));
        }
        else if (focusedRect.top - overScroll < parentRect.top) {
            this._scrollTo(parentElement, Math.max(childFocusedElement.offsetTop - overScroll, 0));
        }
    }
    attrToModel() {
        if ((this.options.indexOf(this.internalValue) >= 0) || (!this.internalValue)) {
            if (this.dataFromService && this.internalValue) {
                this.onChange(this.dataFromService[this.options.indexOf(this.internalValue)]);
            }
            else {
                this.onChange(this.internalValue ? this.internalValue : null);
            }
        }
        else {
            this.onChange(INVALID_VALUE);
        }
    }
    handleData(data) {
        this.dataFromService = data;
        this.options = [];
        this.dataFromService.forEach(obj => this.options.push(this.objToOption(obj)));
        this.attrToModel();
        this.showItens = this.options.length > 0 || this.isEnabledCreateRecord;
        this.selectedIndex = 0;
        this.listOption.nativeElement.scrollTop = 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutoCompleteComponent, deps: [{ token: AUTH_RESOURCES_CONFIG }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: AutoCompleteComponent, selector: "elo-autocomplete", inputs: { multiplo: "multiplo", multipleSelected: "multipleSelected", id: "id", options: "options", error: "error", service: "service", placeholder: "placeholder", noResultsMessage: "noResultsMessage", urlCreate: "urlCreate", searchModal: "searchModal", isDisabled: "isDisabled", findToOptions: "findToOptions", objToOption: "objToOption", objToOptionViewMultiple: "objToOptionViewMultiple", debounceTime: "debounceTime", autoSelect: "autoSelect", isEnabledCreateRecord: "isEnabledCreateRecord", descriptionNewRecord: "descriptionNewRecord", validateDeps: "validateDeps", insertIcon: "insertIcon", extraInfos: "extraInfos", emptyRecord: "emptyRecord", removeDot: "removeDot" }, outputs: { onChangeMultipleValue: "onChangeMultipleValue", onChangeValue: "onChangeValue", onSearchModal: "onSearchModal", onInsertButton: "onInsertButton", onCreateRecord: "onCreateRecord" }, providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: AutoCompleteComponent },
            { provide: NG_VALIDATORS, multi: true, useValue: autoCompleteValidator }
        ], viewQueries: [{ propertyName: "listOption", first: true, predicate: ["listOption"], descendants: true, static: true }], ngImport: i0, template: "<div id=\"autocomplete-container\">\n  <div *ngIf=\"multiplo && multipleSelected && multipleSelected.length > 0\" class=\"multiple\">\n    <button class=\"btn positive round interactive inline full-xs option\"\n      [title]=\"'Remover: ' + this.objToOptionMultiple(item)\" *ngFor=\"let item of multipleSelected\"\n      (click)=\"removeItemFromMultiplo(item)\">{{this.objToOptionMultiple(item)}}</button>\n  </div>\n\n  <input id=\"{{id}}_input\" [ngClass]=\"{'autocomplete-input': true, 'required_with_button': searchModal}\"\n    [class.error]=\"error\" type=\"text\" (click)=\"onFocus()\" (focus)=\"onFocus()\" [(ngModel)]=\"value\"\n    (keydown)=\"onKeyDown($event)\" [placeholder]=\"placeholder\" [disabled]=\"isDisabled\" autocomplete=\"off\"\n    autocorrect=\"off\" spellcheck=\"off\" [class.loading]=\"loading\"\n    [class.has-input-icon]=\"(searchModal || hasValue()) && !isDisabled && !loading\">\n\n  <i class=\"fa fa-circle-o-notch spinner\" *ngIf=\"loading\"></i>\n\n  <ng-content></ng-content>\n\n  <i class=\"fa fa-search input-icon\" id=\"search\" *ngIf=\"searchModal && !isDisabled && !loading\"\n    (click)=\"onClickSearch()\"></i>\n  <i id=\"{{id}}_clearItem\" class=\"fa fa-times input-icon\" aria-hidden=\"true\" (click)=\"onClickClear()\"\n    *ngIf=\"hasValue()  && !loading\"></i>\n\n  <div class=\"autocomplete\" [class.open]=\"showItens\" #listOption>\n    <li *ngIf=\"(!options || options.length === 0) && emptyRecord\"\n        class=\"autocomplete-item\"\n        id=\"option_empty\">\n        {{noResultsMessage}}\n    </li>\n    <div *ngIf=\"showItens\">\n      <li *ngIf=\"isEnabledCreateRecord\" class=\"autocomplete-item item-new\" (click)=\"openCreateModal()\">\n        <em class=\"fa fa-plus-circle\"></em>{{setDescriptionNewRecordAction()}}\n      </li>\n      <li *ngFor=\"let option of options; let i = index\" class=\"autocomplete-item\" [class.selected]=\"i == selectedIndex\"\n        (click)=\"onSelect(option)\" id=\"option_{{i}}\">\n        {{option}}\n        <div id=\"extra-info-{{i}}\"class=\"extra-info split-letter right\" attr.data-letter=\"{{extraInfos[i][0]}}\" *ngIf=\"extraInfos && extraInfos[i] && extraInfos[i][0]\">\n          <p>{{extraInfos[i]}}</p>\n        </div>\n      </li>\n    </div>\n  </div>\n\n  <div class=\"help-message\" *ngIf=\"!emptyRecord && (noResults && (!isEnabledCreateRecord || hasUrlCreate()))\">\n    {{noResultsMessage}}\n    <a *ngIf=\"hasUrlCreate()\" href=\"#\" (click)=\"openCreate($event)\">Clique aqui para cadastrar.</a>\n  </div>\n\n</div>\n", styles: [".error{border:1px solid red}.multiple{max-height:98px;overflow:scroll}.multiple,.option{margin-bottom:2px;font-size:10px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutoCompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-autocomplete', providers: [
                        { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: AutoCompleteComponent },
                        { provide: NG_VALIDATORS, multi: true, useValue: autoCompleteValidator }
                    ], template: "<div id=\"autocomplete-container\">\n  <div *ngIf=\"multiplo && multipleSelected && multipleSelected.length > 0\" class=\"multiple\">\n    <button class=\"btn positive round interactive inline full-xs option\"\n      [title]=\"'Remover: ' + this.objToOptionMultiple(item)\" *ngFor=\"let item of multipleSelected\"\n      (click)=\"removeItemFromMultiplo(item)\">{{this.objToOptionMultiple(item)}}</button>\n  </div>\n\n  <input id=\"{{id}}_input\" [ngClass]=\"{'autocomplete-input': true, 'required_with_button': searchModal}\"\n    [class.error]=\"error\" type=\"text\" (click)=\"onFocus()\" (focus)=\"onFocus()\" [(ngModel)]=\"value\"\n    (keydown)=\"onKeyDown($event)\" [placeholder]=\"placeholder\" [disabled]=\"isDisabled\" autocomplete=\"off\"\n    autocorrect=\"off\" spellcheck=\"off\" [class.loading]=\"loading\"\n    [class.has-input-icon]=\"(searchModal || hasValue()) && !isDisabled && !loading\">\n\n  <i class=\"fa fa-circle-o-notch spinner\" *ngIf=\"loading\"></i>\n\n  <ng-content></ng-content>\n\n  <i class=\"fa fa-search input-icon\" id=\"search\" *ngIf=\"searchModal && !isDisabled && !loading\"\n    (click)=\"onClickSearch()\"></i>\n  <i id=\"{{id}}_clearItem\" class=\"fa fa-times input-icon\" aria-hidden=\"true\" (click)=\"onClickClear()\"\n    *ngIf=\"hasValue()  && !loading\"></i>\n\n  <div class=\"autocomplete\" [class.open]=\"showItens\" #listOption>\n    <li *ngIf=\"(!options || options.length === 0) && emptyRecord\"\n        class=\"autocomplete-item\"\n        id=\"option_empty\">\n        {{noResultsMessage}}\n    </li>\n    <div *ngIf=\"showItens\">\n      <li *ngIf=\"isEnabledCreateRecord\" class=\"autocomplete-item item-new\" (click)=\"openCreateModal()\">\n        <em class=\"fa fa-plus-circle\"></em>{{setDescriptionNewRecordAction()}}\n      </li>\n      <li *ngFor=\"let option of options; let i = index\" class=\"autocomplete-item\" [class.selected]=\"i == selectedIndex\"\n        (click)=\"onSelect(option)\" id=\"option_{{i}}\">\n        {{option}}\n        <div id=\"extra-info-{{i}}\"class=\"extra-info split-letter right\" attr.data-letter=\"{{extraInfos[i][0]}}\" *ngIf=\"extraInfos && extraInfos[i] && extraInfos[i][0]\">\n          <p>{{extraInfos[i]}}</p>\n        </div>\n      </li>\n    </div>\n  </div>\n\n  <div class=\"help-message\" *ngIf=\"!emptyRecord && (noResults && (!isEnabledCreateRecord || hasUrlCreate()))\">\n    {{noResultsMessage}}\n    <a *ngIf=\"hasUrlCreate()\" href=\"#\" (click)=\"openCreate($event)\">Clique aqui para cadastrar.</a>\n  </div>\n\n</div>\n", styles: [".error{border:1px solid red}.multiple{max-height:98px;overflow:scroll}.multiple,.option{margin-bottom:2px;font-size:10px}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }, { type: i0.Renderer2 }, { type: i0.ElementRef }], propDecorators: { multiplo: [{
                type: Input
            }], multipleSelected: [{
                type: Input
            }], onChangeMultipleValue: [{
                type: Output
            }], id: [{
                type: Input
            }], options: [{
                type: Input
            }], error: [{
                type: Input
            }], service: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], noResultsMessage: [{
                type: Input
            }], urlCreate: [{
                type: Input
            }], onChangeValue: [{
                type: Output
            }], onSearchModal: [{
                type: Output
            }], searchModal: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], findToOptions: [{
                type: Input
            }], objToOption: [{
                type: Input
            }], objToOptionViewMultiple: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], autoSelect: [{
                type: Input
            }], isEnabledCreateRecord: [{
                type: Input
            }], descriptionNewRecord: [{
                type: Input
            }], validateDeps: [{
                type: Input
            }], insertIcon: [{
                type: Input
            }], onInsertButton: [{
                type: Output
            }], onCreateRecord: [{
                type: Output
            }], extraInfos: [{
                type: Input
            }], emptyRecord: [{
                type: Input
            }], removeDot: [{
                type: Input
            }], listOption: [{
                type: ViewChild,
                args: ['listOption', { static: true }]
            }] } });

class AutoCompleteModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutoCompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AutoCompleteModule, declarations: [AutoCompleteComponent], imports: [CommonModule, FormsModule], exports: [AutoCompleteComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutoCompleteModule, imports: [CommonModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutoCompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    exports: [AutoCompleteComponent],
                    declarations: [AutoCompleteComponent]
                }]
        }] });

class CanDeactivateGuard {
    constructor() {
        this.eventEmitter = new EventEmitter();
    }
    canDeactivate(component) {
        if (component.form && component.form.dirty) {
            const subject = new Subject();
            this.eventEmitter.next(subject);
            return subject.asObservable();
        }
        return of(true);
    }
    getEventEmitter() {
        return this.eventEmitter;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CanDeactivateGuard, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CanDeactivateGuard }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CanDeactivateGuard, decorators: [{
            type: Injectable
        }] });

class DialogComponent {
    constructor() {
        this.show = false;
        this.showCancel = true;
        /**
        * @param classType positive, negative, neutral or warning
        */
        this.classType = 'neutral';
        this.tittleCancel = 'Cancelar';
        this.tittleOk = 'Ok';
        this.title = '';
        this.disableOkButton = false;
        this.debounceTime = 0;
        this.onOkEvent = new EventEmitter();
        this.onCancelEvent = new EventEmitter();
    }
    onOk() {
        this.onOkEvent.emit();
    }
    onCancel() {
        this.onCancelEvent.emit();
    }
    onDoNothing() { return; }
    handleKeyboardEvent(event) {
        if (event.code === 'Escape' && this.show && this.showCancel) {
            this.onCancel();
        }
        if (event.key === 'Enter' && this.show) {
            this.onOk();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DialogComponent, selector: "elo-dialog", inputs: { show: "show", showCancel: "showCancel", classType: "classType", tittleCancel: "tittleCancel", tittleOk: "tittleOk", title: "title", disableOkButton: "disableOkButton", debounceTime: "debounceTime" }, outputs: { onOkEvent: "onOkEvent", onCancelEvent: "onCancelEvent" }, host: { listeners: { "document:keydown": "handleKeyboardEvent($event)" } }, ngImport: i0, template: "<div id=\"dialogConfirm\" *ngIf=\"show\" class=\"dialoguebox alt {{classType}} open\">\n\n  <div class=\"alt-box\">\n    <div class=\"alt-box-content\">\n      <div class=\"row\">\n        <div class=\"col-md-12 form-group\">\n          <h3 *ngIf=\"title\" class=\"title\">{{ title }} </h3>\n        </div>\n      </div>\n      <div id=\"content\" class=\"row\">\n        <div class=\"col-md-12\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n\n      <div class=\"alt-footer right\">\n        <button type=\"button\" *ngIf=\"showCancel\" id=\"btCancel\" class=\"btn neutral inline\"\n          (click)=\"onCancel()\" singleClickButton>{{tittleCancel}}</button>\n        <button *ngIf=\"!debounceTime;else debounceButton\" eloAutoFocus type=\"button\" id=\"btOk\" class=\"btn positive inline {{disableOkButton ? 'disabled' : ''}}\"\n          (click)=\"disableOkButton ? onDoNothing() : onOk()\">{{tittleOk}}</button>\n        <ng-template #debounceButton>\n          <button eloAutoFocus type=\"button\" id=\"btOk\" class=\"btn positive inline {{disableOkButton ? 'disabled' : ''}}\"\n            preventMultiClick [debounceTime]=\"debounceTime\" (click)=\"disableOkButton ? onDoNothing() : onOk()\">{{tittleOk}}</button>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n\n</div>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: AutofocusDirective, selector: "[eloAutoFocus]" }, { kind: "directive", type: SingleClickButtonDirective, selector: "[singleClickButton]" }, { kind: "directive", type: PreventMultiClickDirective, selector: "[preventMultiClick]", inputs: ["debounceTime"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-dialog', template: "<div id=\"dialogConfirm\" *ngIf=\"show\" class=\"dialoguebox alt {{classType}} open\">\n\n  <div class=\"alt-box\">\n    <div class=\"alt-box-content\">\n      <div class=\"row\">\n        <div class=\"col-md-12 form-group\">\n          <h3 *ngIf=\"title\" class=\"title\">{{ title }} </h3>\n        </div>\n      </div>\n      <div id=\"content\" class=\"row\">\n        <div class=\"col-md-12\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n\n      <div class=\"alt-footer right\">\n        <button type=\"button\" *ngIf=\"showCancel\" id=\"btCancel\" class=\"btn neutral inline\"\n          (click)=\"onCancel()\" singleClickButton>{{tittleCancel}}</button>\n        <button *ngIf=\"!debounceTime;else debounceButton\" eloAutoFocus type=\"button\" id=\"btOk\" class=\"btn positive inline {{disableOkButton ? 'disabled' : ''}}\"\n          (click)=\"disableOkButton ? onDoNothing() : onOk()\">{{tittleOk}}</button>\n        <ng-template #debounceButton>\n          <button eloAutoFocus type=\"button\" id=\"btOk\" class=\"btn positive inline {{disableOkButton ? 'disabled' : ''}}\"\n            preventMultiClick [debounceTime]=\"debounceTime\" (click)=\"disableOkButton ? onDoNothing() : onOk()\">{{tittleOk}}</button>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n\n</div>" }]
        }], propDecorators: { show: [{
                type: Input
            }], showCancel: [{
                type: Input
            }], classType: [{
                type: Input
            }], tittleCancel: [{
                type: Input
            }], tittleOk: [{
                type: Input
            }], title: [{
                type: Input
            }], disableOkButton: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], onOkEvent: [{
                type: Output
            }], onCancelEvent: [{
                type: Output
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class BackConfirmComponent {
    constructor(_canDeactivateGuard) {
        this._canDeactivateGuard = _canDeactivateGuard;
        this.showBackConfirm = false;
        this.handleCanDeactivateSubject = new Subject();
    }
    ngOnInit() {
        this.handleCanDeactivateRoute();
    }
    handleCanDeactivateRoute() {
        this._canDeactivateGuard.getEventEmitter().subscribe((subject) => {
            this.showBackConfirm = true;
            this.handleCanDeactivateSubject = subject;
        });
    }
    allowRouteChange() {
        this.showBackConfirm = false;
        this.handleCanDeactivateSubject.next(true);
    }
    cancelBackConfirm() {
        this.showBackConfirm = false;
        this.handleCanDeactivateSubject.next(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BackConfirmComponent, deps: [{ token: CanDeactivateGuard }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: BackConfirmComponent, selector: "back-confirm-component", ngImport: i0, template: "<elo-dialog [show]=\"showBackConfirm\" (onOkEvent)=\"allowRouteChange()\" (onCancelEvent)=\"cancelBackConfirm()\">\n  Os dados n\u00E3o salvos ser\u00E3o perdidos. Continuar?\n</elo-dialog>\n", dependencies: [{ kind: "component", type: DialogComponent, selector: "elo-dialog", inputs: ["show", "showCancel", "classType", "tittleCancel", "tittleOk", "title", "disableOkButton", "debounceTime"], outputs: ["onOkEvent", "onCancelEvent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BackConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'back-confirm-component', template: "<elo-dialog [show]=\"showBackConfirm\" (onOkEvent)=\"allowRouteChange()\" (onCancelEvent)=\"cancelBackConfirm()\">\n  Os dados n\u00E3o salvos ser\u00E3o perdidos. Continuar?\n</elo-dialog>\n" }]
        }], ctorParameters: () => [{ type: CanDeactivateGuard }] });

class DialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DialogModule, declarations: [DialogComponent], imports: [CommonModule, DirectivesModule], exports: [DialogComponent, CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DialogModule, imports: [CommonModule, DirectivesModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, DirectivesModule],
                    exports: [DialogComponent, CommonModule],
                    declarations: [DialogComponent]
                }]
        }] });

class BackConfirmModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BackConfirmModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: BackConfirmModule, declarations: [BackConfirmComponent], imports: [DialogModule], exports: [BackConfirmComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BackConfirmModule, providers: [
            CanDeactivateGuard
        ], imports: [DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BackConfirmModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        DialogModule
                    ],
                    declarations: [
                        BackConfirmComponent
                    ],
                    providers: [
                        CanDeactivateGuard
                    ],
                    exports: [
                        BackConfirmComponent
                    ]
                }]
        }] });

class BlobPopupExecutorFactory {
}

class BlobPopupService {
    constructor(blobPopupExecutorFactory) {
        this.blobPopupExecutorFactory = blobPopupExecutorFactory;
        this.paramsCache = new Map();
    }
    encodeParams(params) {
        let strParams = JSON.stringify(params);
        if (!this.paramsCache.has(strParams)) {
            let b64 = CryptoJS.AES.encrypt(strParams, this.buildEncodePassword()).toString();
            let e64 = CryptoJS.enc.Base64.parse(b64);
            this.paramsCache.set(strParams, e64.toString(CryptoJS.enc.Hex));
        }
        return this.paramsCache.get(strParams);
    }
    decodeParams(encodedParams) {
        let reb64 = CryptoJS.enc.Hex.parse(encodedParams);
        let bytes = reb64.toString(CryptoJS.enc.Base64);
        let strParams = CryptoJS.AES.decrypt(bytes, this.buildEncodePassword()).toString(CryptoJS.enc.Utf8);
        return JSON.parse(strParams);
    }
    execute(routeSnapshot) {
        return new Observable(observer => {
            let executor = this.blobPopupExecutorFactory.getExecutorById(routeSnapshot.params['executor']);
            if (!executor) {
                observer.next('/page-not-found');
                return;
            }
            let params = this.loadParams(routeSnapshot, executor.requireEncodedParams).then(params => {
                executor.execute(params).subscribe(blob => observer.next(blob));
            }).catch(error => {
                observer.next('/page-blocked');
            });
        });
    }
    buildEncodePassword() {
        return '3l0tech#';
    }
    loadParams(routeSnapshot, requireEncodecParams) {
        return new Promise((resolve, reject) => {
            let encodedParams = routeSnapshot.params['params'];
            if (encodedParams) {
                resolve(this.decodeParams(encodedParams));
            }
            else if (requireEncodecParams) {
                reject('Encoded params required.');
            }
            resolve(routeSnapshot.queryParams);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlobPopupService, deps: [{ token: BlobPopupExecutorFactory }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlobPopupService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlobPopupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: BlobPopupExecutorFactory }] });

class BlobPopupComponent {
    constructor(_route, service) {
        this._route = _route;
        this.service = service;
        this.showDiv = true;
    }
    ngOnInit() {
        this.service.execute(this._route.snapshot).subscribe(blob => {
            this.showDiv = false;
            document.querySelector('iframe').src = blob;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlobPopupComponent, deps: [{ token: i1$4.ActivatedRoute }, { token: BlobPopupService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: BlobPopupComponent, selector: "elo-blob-popup", ngImport: i0, template: "<div *ngIf=\"showDiv\" class=\"blob content-loader spin\">\n  <div class=\"content-loader-inner\">\n    <div class=\"item-a\"></div>\n    <div class=\"item-b\"></div>\n  </div>\n  <h4>Carregando...</h4>\n</div>\n\n<div class=\"container-white\">\n  <iframe src=\"\" type=\"application/pdf\" id=\"iframe\" width=\"100%\" height=\"100%\"\n  class=\"container-fill\">\n  </iframe>\n</div>\n", styles: [".container-white{position:fixed;z-index:999998;width:100%;height:100%;overflow:show;margin:auto;inset:0;background:#fff}.container-fill{overflow:auto;width:100%;height:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlobPopupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-blob-popup', template: "<div *ngIf=\"showDiv\" class=\"blob content-loader spin\">\n  <div class=\"content-loader-inner\">\n    <div class=\"item-a\"></div>\n    <div class=\"item-b\"></div>\n  </div>\n  <h4>Carregando...</h4>\n</div>\n\n<div class=\"container-white\">\n  <iframe src=\"\" type=\"application/pdf\" id=\"iframe\" width=\"100%\" height=\"100%\"\n  class=\"container-fill\">\n  </iframe>\n</div>\n", styles: [".container-white{position:fixed;z-index:999998;width:100%;height:100%;overflow:show;margin:auto;inset:0;background:#fff}.container-fill{overflow:auto;width:100%;height:100%}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.ActivatedRoute }, { type: BlobPopupService }] });

class BlobPopupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlobPopupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: BlobPopupModule, declarations: [BlobPopupComponent], imports: [CommonModule], exports: [BlobPopupComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlobPopupModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlobPopupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [BlobPopupComponent],
                    exports: [BlobPopupComponent]
                }]
        }] });

class BlockContentComponent {
    constructor() {
        this.valid = true;
        this.active = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: BlockContentComponent, selector: "elo-block-content", inputs: { title: "title", valid: "valid", active: "active", message: "message" }, ngImport: i0, template: "<div [ngClass]=\"{'row block-content': true, 'active': active, 'error': !valid}\">\n    <div class=\"col-sm-2\">\n        <div class=\"message-area\">{{message}}</div>\n    </div>\n    <div class=\"col-sm-6\">\n        <div class=\"title\">\n            {{title}}\n        </div>\n        <div class=\"content\">\n            <ng-content></ng-content>\n        </div>\n    </div>\n</div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-block-content', template: "<div [ngClass]=\"{'row block-content': true, 'active': active, 'error': !valid}\">\n    <div class=\"col-sm-2\">\n        <div class=\"message-area\">{{message}}</div>\n    </div>\n    <div class=\"col-sm-6\">\n        <div class=\"title\">\n            {{title}}\n        </div>\n        <div class=\"content\">\n            <ng-content></ng-content>\n        </div>\n    </div>\n</div>" }]
        }], propDecorators: { title: [{
                type: Input
            }], valid: [{
                type: Input
            }], active: [{
                type: Input
            }], message: [{
                type: Input
            }] } });

class BlockContentModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockContentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: BlockContentModule, declarations: [BlockContentComponent], imports: [CommonModule], exports: [BlockContentComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockContentModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockContentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [BlockContentComponent],
                    declarations: [BlockContentComponent]
                }]
        }] });

class RouterService {
    constructor(router) {
        this.router = router;
        this.previousRoute = null;
        this.currentRoute = null;
        if (router && router.events) {
            router.events.subscribe(event => this.handleNavigationEvent(event));
        }
    }
    setCurrentRoute(route) {
        this.currentRoute = route;
    }
    setPreviousRoute(route) {
        this.previousRoute = route;
    }
    getPreviousRoute() {
        return this.previousRoute;
    }
    navigateByUrl(url, extras) {
        this.router.navigateByUrl(url, extras);
    }
    getCurrentRoute() {
        return this.currentRoute;
    }
    handleNavigationEvent(event) {
        if (event instanceof NavigationEnd) {
            this.previousRoute = this.currentRoute;
            this.currentRoute = event.url;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RouterService, deps: [{ token: i1$4.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RouterService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RouterService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$4.Router }] });

class NavigateUtils {
    getQueryParams(url) {
        if (!url) {
            return '';
        }
        const urls = url.split('?');
        if (urls.length) {
            if (urls.length <= 1) {
                return '';
            }
            else {
                return Object.assign(urls[1].split('&'));
            }
        }
    }
    getKey(param) {
        const params = param.split('=');
        return params && params.length === 2 ? params[0] : '';
    }
    getValue(param) {
        const params = param.split('=');
        return params && params.length === 2 ? params[1] : '';
    }
    createQueryParamsFromParams(params) {
        const queryParams = {};
        if (params) {
            params.forEach(param => {
                const key = this.getKey(param);
                const value = this.getValue(param);
                if (key && value) {
                    queryParams[key] = decodeURI(value);
                }
            });
        }
        return queryParams;
    }
    updateParams(url, params) {
        const queryParam = this.createQueryParamsFromParams(this.getQueryParams(url));
        if (params && params.length > 0) {
            params.forEach(p => queryParam[p.param] = p.value);
            Object.keys(queryParam).forEach((key) => !queryParam[key] && delete queryParam[key]);
        }
        return queryParam;
    }
    updateUrlParams(params, router) {
        const updatedParams = this.updateParams(router.url, params);
        if (Object.keys(updatedParams).length) {
            router.navigate([], { queryParams: updatedParams });
        }
    }
    createParamFromStringArray(array, form) {
        const params = [];
        array.forEach(param => {
            params.push({ param: param, value: form.get(param).value });
        });
        return params;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NavigateUtils, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NavigateUtils }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NavigateUtils, decorators: [{
            type: Injectable
        }] });

class BreadcrumbComponent {
    constructor(router, activatedRoute, routerService, navigateUtils) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.routerService = routerService;
        this.navigateUtils = navigateUtils;
        this.homeLabel = 'Início';
        this.homeUrl = 'home';
        this.urlsToLabels = [];
        this.routes = [];
        this.labelsAnalisadas = [];
        this.qtdNiveis = 0;
        this.urlsWithIds = [];
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.attrRoute(this.activatedRoute.root);
        }, 0);
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((nav) => {
            this.resetarRotasIfChangeDomain(nav);
            this.qtdNiveis = 0;
            this.contarNiveisBreadcrumb(this.activatedRoute.root);
            this.labelsAnalisadas = [];
            this.attrRoute(this.activatedRoute.root);
        });
    }
    onClick(route) {
        if (route.iframe) {
            route.onClick();
        }
    }
    resetarRotasIfChangeDomain(nav) {
        const navUrlSplited = nav.url.split('/');
        const navUrlDomain = navUrlSplited[1];
        if (this.routes && !this.routes.find(r => navUrlDomain === r.url)) {
            this.routes = [];
        }
    }
    contarNiveisBreadcrumb(route) {
        for (let child of route.children) {
            this.qtdNiveis++;
            this.contarNiveisBreadcrumb(child);
        }
    }
    attrRoute(route) {
        for (let child of route.children) {
            let url = child.snapshot.url.map(segment => segment.path).join('/');
            let urlRoot = '';
            if (this.routes.length > 0) {
                urlRoot = `${this.routes
                    .map(r => r.url)
                    .reduce((p, c) => `${p}/${c}`)}/`;
            }
            if (url && url !== '/' && url !== this.homeUrl) {
                const label = this.findLabelIfExists(url, child);
                const routeByLabel = this.routes.find(r => r.label === label);
                const queryParams = this.findQueryParams();
                this.labelsAnalisadas.push(label);
                if (!routeByLabel) {
                    const INICIO = 1;
                    this.routes.push({
                        url: urlRoot + url,
                        label: label,
                        icon: this.findIconIfExists(url),
                        queryParams: queryParams,
                        ordinal: this.labelsAnalisadas.length + INICIO
                    });
                }
                else {
                    this.updateParamsIfUltimoNivel(queryParams, routeByLabel);
                }
            }
            this.attrRoute(child);
        }
        this.removeRotasNaoAnalisadas();
    }
    updateParamsIfUltimoNivel(queryParams, route) {
        const isUltimoNivel = this.qtdNiveis === route.ordinal;
        const isBreadcrumbAumentando = this.routes.length < this.qtdNiveis;
        if (isUltimoNivel && isBreadcrumbAumentando) {
            route.queryParams = queryParams;
        }
    }
    removeRotasNaoAnalisadas() {
        this.routes = this.routes.filter(r => this.labelsAnalisadas.find(label => label === r.label));
    }
    findQueryParams() {
        if (this.routerService.getPreviousRoute()) {
            const queryParams = this.navigateUtils.getQueryParams(this.routerService.getPreviousRoute());
            return this.navigateUtils.createQueryParamsFromParams(queryParams);
        }
        return '';
    }
    findLabelIfExists(url, route) {
        this.urlsWithIds = deepCopy(this.urlsToLabels);
        let isTypeId = url.replace(/[^0-9]/g, '');
        let uuid = url.match(/\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/);
        if (uuid && uuid.length > 0) {
            isTypeId = uuid[0];
        }
        if (isTypeId) {
            this.urlsWithIds.map(urlToLabel => {
                urlToLabel.url = !!urlToLabel.url && urlToLabel.url.replace(':id', isTypeId);
            });
        }
        let found = this.findUrl(url);
        if (found) {
            found = this.urlsToLabels[this.urlsWithIds.indexOf(found)];
            return found.labelResolver ? found.labelResolver(route) : found.label;
        }
        return 'Detalhes';
    }
    findIconIfExists(url) {
        const found = this.findUrl(url);
        if (found && found.icon) {
            return found.icon;
        }
        return 'fa fa-files-o iconmoon';
    }
    findUrl(url) {
        const params = this.activatedRoute.snapshot.queryParams;
        if (Object.keys(params).length && isNaN(url) && url !== 'new') {
            let sameUrl = this.urlsWithIds.filter(value => value.url === url && value.params && value.params.queryParams);
            let rotaFound = sameUrl.find(value => {
                let p1 = this.getParamUsingKeys(value.params.queryParams, value.params.paramsKey);
                let p2 = this.getParamUsingKeys(params, value.params.paramsKey);
                return deepEqual(p1, p2);
            });
            return rotaFound ?? this.urlsWithIds.find(urlToLabel => urlToLabel.url === url);
        }
        else {
            return this.urlsWithIds.find(urlToLabel => urlToLabel.url === url);
        }
    }
    getParamUsingKeys(params, key) {
        if (key) {
            return params[key];
        }
        return params;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbComponent, deps: [{ token: i1$4.Router }, { token: i1$4.ActivatedRoute }, { token: RouterService }, { token: NavigateUtils }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: BreadcrumbComponent, selector: "elo-breadcrumb", inputs: { homeLabel: "homeLabel", homeUrl: "homeUrl", urlsToLabels: "urlsToLabels" }, queries: [{ propertyName: "botoesDireita", first: true, predicate: ["botoesDireita"], descendants: true }], ngImport: i0, template: "<nav aria-label=\"Breadcrumbs\" class=\"nav-breadcrumbs\" id=\"idBreadcrumbs\">\n  <ol>\n    <li><a routerLink=\"\" [attr.aria-current]=\"routes.length === 0? 'page': null\">\n        <i class=\"fa fa-home\"></i><span>{{homeLabel}}</span></a></li>\n\n    <li *ngFor=\"let route of routes; let isLast = last;\">\n      <ng-container *ngIf=\"isLast; else notLast\">\n        <a [attr.aria-current]=\"routes[routes.length-1]===route? 'page': null\">\n          <i class={{route.icon}}></i><span>{{route.label}}</span></a>\n      </ng-container>\n\n      <ng-template #notLast>\n        <a (click)=\"onClick(route)\" [routerLink]=\"route.url\" [queryParams]=\"route.queryParams\"\n          [attr.aria-current]=\"routes[routes.length-1]===route? 'page': null\">\n          <i class={{route.icon}}></i><span>{{route.label}}</span></a>\n      </ng-template>\n    </li>\n\n  </ol>\n  <div class=\"nav-buttons\" role=\"group\">\n    <ng-container *ngTemplateOutlet=\"botoesDireita\"></ng-container>\n  </div>\n</nav>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$4.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-breadcrumb', template: "<nav aria-label=\"Breadcrumbs\" class=\"nav-breadcrumbs\" id=\"idBreadcrumbs\">\n  <ol>\n    <li><a routerLink=\"\" [attr.aria-current]=\"routes.length === 0? 'page': null\">\n        <i class=\"fa fa-home\"></i><span>{{homeLabel}}</span></a></li>\n\n    <li *ngFor=\"let route of routes; let isLast = last;\">\n      <ng-container *ngIf=\"isLast; else notLast\">\n        <a [attr.aria-current]=\"routes[routes.length-1]===route? 'page': null\">\n          <i class={{route.icon}}></i><span>{{route.label}}</span></a>\n      </ng-container>\n\n      <ng-template #notLast>\n        <a (click)=\"onClick(route)\" [routerLink]=\"route.url\" [queryParams]=\"route.queryParams\"\n          [attr.aria-current]=\"routes[routes.length-1]===route? 'page': null\">\n          <i class={{route.icon}}></i><span>{{route.label}}</span></a>\n      </ng-template>\n    </li>\n\n  </ol>\n  <div class=\"nav-buttons\" role=\"group\">\n    <ng-container *ngTemplateOutlet=\"botoesDireita\"></ng-container>\n  </div>\n</nav>" }]
        }], ctorParameters: () => [{ type: i1$4.Router }, { type: i1$4.ActivatedRoute }, { type: RouterService }, { type: NavigateUtils }], propDecorators: { homeLabel: [{
                type: Input
            }], homeUrl: [{
                type: Input
            }], urlsToLabels: [{
                type: Input
            }], botoesDireita: [{
                type: ContentChild,
                args: ['botoesDireita']
            }] } });

class BreadcrumbModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbModule, declarations: [BreadcrumbComponent], imports: [CommonModule, RouterModule], exports: [BreadcrumbComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbModule, providers: [NavigateUtils], imports: [CommonModule, RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule],
                    providers: [NavigateUtils],
                    exports: [BreadcrumbComponent],
                    declarations: [BreadcrumbComponent]
                }]
        }] });

class SectionService {
    constructor() {
        this.sections = [];
    }
    registerContent(section) {
        if (!this.sections.find(s => s.route === section.route)) {
            this.sections.push(section);
        }
    }
    getContents() {
        return this.sections;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionService, decorators: [{
            type: Injectable
        }] });

class IFrameStore {
    constructor() {
        this._hasIframe = new BehaviorSubject(false);
    }
    set hasIframe(val) {
        this._hasIframe.next(val);
    }
    get hasIframeObservable() {
        return this._hasIframe.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IFrameStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IFrameStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IFrameStore, decorators: [{
            type: Injectable
        }] });

class SidebarService {
    constructor() {
        this.onChangeSidebars = new Subject();
        this.sidebarsTree = [];
        this.onChangeObservable = this.onChangeSidebars.asObservable();
    }
    set sidebars(sidebars) {
        this.sidebarsTree = sidebars;
        this.onChangeSidebars.next(sidebars);
    }
    get sidebars() {
        return this.sidebarsTree;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

const CLASS_FLOATING_BUTTON = '.btn-save';
class SectionComponent {
    get icon() {
        if (this.startedNavigation) {
            return 'fa fa-spinner fa-pulse fa-3x fa-fw';
        }
        let sidebarItem = this.findSidebarItem(this.sidebarTree);
        if (sidebarItem) {
            return sidebarItem.icon;
        }
        return 'fa fa-frown-o';
    }
    get caption() {
        if (this.startedNavigation) {
            return 'Carregando...';
        }
        let sidebarItem = this.findSidebarItem(this.sidebarTree);
        if (sidebarItem) {
            return sidebarItem.name;
        }
        return 'Não Encontrado';
    }
    constructor(router, elt, service, iframeParams, authResourcesConfig, sidebarService) {
        this.router = router;
        this.elt = elt;
        this.service = service;
        this.iframeParams = iframeParams;
        this.authResourcesConfig = authResourcesConfig;
        this.sidebarService = sidebarService;
        this.enabled = true;
        this.urlsToLabels = [];
        this.fullScreen = false;
        this.hideHeader = false;
        this.route = '';
        this.startedNavigation = false;
        this.sidebarTree = [];
        this.router.events.subscribe(event => this.handleRouteEvent(event));
    }
    ngOnInit() {
        this.sidebarSubscription = this.sidebarService.onChangeObservable.subscribe(sidebars => {
            this.sidebarTree = sidebars;
        });
    }
    ngOnDestroy() {
        this.sidebarSubscription.unsubscribe();
    }
    handleRouteEvent(event) {
        if (event instanceof NavigationEnd) {
            this.startedNavigation = false;
            this.route = event.urlAfterRedirects.replace('/', '');
            setTimeout(() => this.hasFloatingButton =
                this.elt.nativeElement.querySelectorAll(CLASS_FLOATING_BUTTON).length > 0, 100);
        }
        else if (event instanceof NavigationStart) {
            this.startedNavigation = true;
        }
        else if (event instanceof NavigationCancel || event instanceof NavigationError) {
            this.startedNavigation = false;
        }
    }
    matchSidebar(sidebar, considerQueryParams) {
        const posicaoBarra = this.route.indexOf('/');
        const posicaoInicioParams = this.route.indexOf('?');
        let contextRoute = this.route ? this.route : this.getCurrentLocation();
        if (contextRoute.startsWith(`${this.authResourcesConfig.app}/`)) {
            contextRoute = contextRoute.replace(`${this.authResourcesConfig.app}/`, '');
        }
        if (posicaoBarra > 0 && posicaoInicioParams > 0) {
            if (posicaoBarra < posicaoInicioParams) {
                contextRoute = this.route.substring(0, posicaoBarra);
            }
            else {
                contextRoute = this.route.substring(0, posicaoInicioParams);
            }
        }
        else if (posicaoBarra > 0) {
            contextRoute = this.route.substring(0, posicaoBarra);
        }
        else if (posicaoInicioParams > 0) {
            contextRoute = this.route.substring(0, posicaoInicioParams);
        }
        if (considerQueryParams) {
            return this.matchSideBarQueryParams(sidebar, contextRoute);
        }
        else {
            return contextRoute === sidebar.route;
        }
    }
    internalFindSidebarItem(sidebarTree, considerQueryParams) {
        if (sidebarTree) {
            for (let i = 0; i < sidebarTree.length; i++) {
                if (this.matchSidebar(sidebarTree[i], considerQueryParams)) {
                    return sidebarTree[i];
                }
                let sidebarFound = this.internalFindSidebarItem(sidebarTree[i].items, considerQueryParams);
                if (sidebarFound) {
                    return sidebarFound;
                }
            }
        }
    }
    findSidebarItem(sidebarTree) {
        let sidebarFound = this.internalFindSidebarItem(sidebarTree, true);
        if (!sidebarFound) {
            sidebarFound = this.internalFindSidebarItem(sidebarTree, false);
        }
        if (sidebarFound) {
            return sidebarFound;
        }
        else {
            return this.service.getContents().find(s => this.route.startsWith(s.route));
        }
    }
    getCurrentLocation() {
        return window.location.pathname.replace('/', '');
    }
    matchSideBarQueryParams(sidebar, contextRoute) {
        if (sidebar.params) {
            const queryParams = sidebar.params['queryParams'];
            if (queryParams) {
                let matchParams = true;
                Object.keys(queryParams).forEach(key => {
                    const paramValue = queryParams[key];
                    matchParams = matchParams && this.route.includes(key.concat('='.concat(paramValue)));
                });
                return contextRoute === sidebar.route && matchParams;
            }
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionComponent, deps: [{ token: i1$4.Router }, { token: i0.ElementRef }, { token: SectionService }, { token: IFrameStore }, { token: AUTH_RESOURCES_CONFIG }, { token: SidebarService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SectionComponent, selector: "main-section", inputs: { toggled: "toggled", enabled: "enabled", enabledBreadcrumb: "enabledBreadcrumb", urlsToLabels: "urlsToLabels", fullScreen: "fullScreen", hideHeader: "hideHeader" }, queries: [{ propertyName: "botoesBreadcrumb", first: true, predicate: ["botoesBreadcrumb"], descendants: true }], viewQueries: [{ propertyName: "breadCrumb", first: true, predicate: BreadcrumbComponent, descendants: true }], ngImport: i0, template: "<section [ngStyle]=\"{'padding-bottom': hasFloatingButton ? '80px' : '0px'}\" [class.main-content]=\"enabled\"\n  [class.sidebar-toggle]=\"toggled && enabled\" [class.fullScreen]=\"fullScreen\"\n  [class.has-iframe]=\"this.iframeParams?.hasIframeObservable | async\">\n\n  <header class=\"main-content-header\" *ngIf=\"enabled && !hideHeader\">\n    <article class=\"page-name-outer\" *ngIf=\"!enabledBreadcrumb\">\n      <i class=\"{{icon}}\"\n        [ngStyle]=\"startedNavigation && {'border': 'none', 'width': '20px', 'height': '20px', 'padding': '0', 'margin': '5.5px'}\"></i>\n      <h2 class=\"page-name\" id=\"window-title\">\n        {{caption}}\n      </h2>\n      <ng-content select=\"[title-content]\"></ng-content>\n    </article>\n    <elo-breadcrumb [urlsToLabels]=\"urlsToLabels\" *ngIf=\"enabledBreadcrumb\">\n      <ng-template #botoesDireita>\n        <ng-container *ngTemplateOutlet=\"botoesBreadcrumb\"></ng-container>\n      </ng-template>\n    </elo-breadcrumb>\n  </header>\n\n  <ng-content></ng-content>\n</section>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: BreadcrumbComponent, selector: "elo-breadcrumb", inputs: ["homeLabel", "homeUrl", "urlsToLabels"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'main-section', template: "<section [ngStyle]=\"{'padding-bottom': hasFloatingButton ? '80px' : '0px'}\" [class.main-content]=\"enabled\"\n  [class.sidebar-toggle]=\"toggled && enabled\" [class.fullScreen]=\"fullScreen\"\n  [class.has-iframe]=\"this.iframeParams?.hasIframeObservable | async\">\n\n  <header class=\"main-content-header\" *ngIf=\"enabled && !hideHeader\">\n    <article class=\"page-name-outer\" *ngIf=\"!enabledBreadcrumb\">\n      <i class=\"{{icon}}\"\n        [ngStyle]=\"startedNavigation && {'border': 'none', 'width': '20px', 'height': '20px', 'padding': '0', 'margin': '5.5px'}\"></i>\n      <h2 class=\"page-name\" id=\"window-title\">\n        {{caption}}\n      </h2>\n      <ng-content select=\"[title-content]\"></ng-content>\n    </article>\n    <elo-breadcrumb [urlsToLabels]=\"urlsToLabels\" *ngIf=\"enabledBreadcrumb\">\n      <ng-template #botoesDireita>\n        <ng-container *ngTemplateOutlet=\"botoesBreadcrumb\"></ng-container>\n      </ng-template>\n    </elo-breadcrumb>\n  </header>\n\n  <ng-content></ng-content>\n</section>" }]
        }], ctorParameters: () => [{ type: i1$4.Router }, { type: i0.ElementRef }, { type: SectionService }, { type: IFrameStore }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }, { type: SidebarService }], propDecorators: { toggled: [{
                type: Input
            }], enabled: [{
                type: Input
            }], enabledBreadcrumb: [{
                type: Input
            }], urlsToLabels: [{
                type: Input
            }], fullScreen: [{
                type: Input
            }], hideHeader: [{
                type: Input
            }], botoesBreadcrumb: [{
                type: ContentChild,
                args: ['botoesBreadcrumb']
            }], breadCrumb: [{
                type: ViewChild,
                args: [BreadcrumbComponent]
            }] } });

class BreadcrumbIframeService {
    createBreadcrumb(section) {
        WindowService.getWindow().onmessage = (element) => {
            this.setRoutesBreadcrumb(section, element);
        };
    }
    setRoutesBreadcrumb(section, element) {
        const routes = section?.breadCrumb?.routes;
        const iframeSrc = this.iframeSelector()?.src;
        if (element?.data?.query && element?.data?.query?.name !== undefined) {
            let urlRoot = '';
            if (routes.length > 0) {
                urlRoot = `${routes.map(r => r.url).reduce((p, c) => `${p}/${c}`)}/`;
            }
            if (element.data.query.name === 'default') {
                if (routes.length > 1) {
                    routes.pop();
                }
                return;
            }
            routes[routes.length - 1].iframe = true;
            routes[routes.length - 1].onClick = () => {
                let iframeElement = this.iframeSelector();
                iframeElement.src = iframeSrc;
                routes.pop();
            };
            this.createRoutes(routes, urlRoot, element);
        }
    }
    createRoutes(routes, urlRoot, element) {
        let iconBreadcrumb = 'fa fa-search';
        if (element.data.query.name === 'Novo') {
            iconBreadcrumb = 'fa fa-plus';
        }
        if (element.data.query.name === 'Detalhes') {
            iconBreadcrumb = 'fa fa-edit';
        }
        routes.push({
            url: urlRoot,
            label: element.data.query.name,
            icon: iconBreadcrumb,
            queryParams: '',
            ordinal: routes.length + 1,
        });
    }
    iframeSelector() {
        return document.querySelector('iframe');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbIframeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbIframeService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbIframeService, decorators: [{
            type: Injectable
        }] });

class CadastroUnicoComponent {
    constructor(section, breadcrumbIframe) {
        this.section = section;
        this.breadcrumbIframe = breadcrumbIframe;
        this.height = '80vh';
        this.route = '';
        this.breadcrumbIframe.createBreadcrumb(this.section);
    }
    ngOnInit() {
        this.getSummedContext();
        this.setUnicoUrl();
    }
    setUnicoUrl() {
        if (!this.url) {
            this.url = `${this.origin}/unico/${this.contextSummedUp}/${this.getUnicoRoute()}?iframe=true`;
        }
    }
    getSummedContext() {
        let splitContext = BaseHref.extract();
        this.contextSummedUp = `e${splitContext.entidade}m${splitContext.mes}a${splitContext.ano}`;
    }
    getUnicoRoute() {
        let deconstructedRoute = this.route.split('-');
        if (deconstructedRoute.length > 2) {
            deconstructedRoute.shift();
            return deconstructedRoute.join('-');
        }
        return deconstructedRoute[1];
    }
    get origin() {
        return WindowService.getWindow().location.origin;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CadastroUnicoComponent, deps: [{ token: SectionComponent }, { token: BreadcrumbIframeService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CadastroUnicoComponent, selector: "cadastro-unico", inputs: { height: "height", route: "route", url: "url" }, ngImport: i0, template: "<div [ngStyle]=\"{'height': height}\">\n  <iframe [src]=\"url | safe\" *ngIf=\"url\" id=\"iframe\"></iframe>\n</div>", styles: ["#iframe{width:100%;height:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: SafeUrlPipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CadastroUnicoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cadastro-unico', template: "<div [ngStyle]=\"{'height': height}\">\n  <iframe [src]=\"url | safe\" *ngIf=\"url\" id=\"iframe\"></iframe>\n</div>", styles: ["#iframe{width:100%;height:100%}\n"] }]
        }], ctorParameters: () => [{ type: SectionComponent }, { type: BreadcrumbIframeService }], propDecorators: { height: [{
                type: Input
            }], route: [{
                type: Input
            }], url: [{
                type: Input
            }] } });

class CadastroUnicoModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CadastroUnicoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CadastroUnicoModule, declarations: [CadastroUnicoComponent], imports: [CommonModule, PipeModule], exports: [CadastroUnicoComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CadastroUnicoModule, providers: [WindowService, BreadcrumbIframeService], imports: [CommonModule, PipeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CadastroUnicoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PipeModule],
                    exports: [CadastroUnicoComponent],
                    declarations: [CadastroUnicoComponent],
                    providers: [WindowService, BreadcrumbIframeService]
                }]
        }] });

class CalendarDate {
    constructor(day, _month, year, isMonthOfSelectedDate, _calendarDateColor) {
        this.day = day;
        this._month = _month;
        this.year = year;
        this.isMonthOfSelectedDate = isMonthOfSelectedDate;
        this._calendarDateColor = _calendarDateColor;
    }
    calendarIsEqualTo(calendarDateToCompare) {
        return this.dayIsEqualTo(calendarDateToCompare.day)
            && this.monthIsEqualTo(calendarDateToCompare._month)
            && this.yearIsEqualTo(calendarDateToCompare.year);
    }
    dayIsEqualTo(dayToCompare) {
        return this.day == dayToCompare;
    }
    monthIsEqualTo(monthToCompare) {
        return this._month == monthToCompare;
    }
    yearIsEqualTo(yearToCompare) {
        return this.year == yearToCompare;
    }
    set calendarDateColor(calendarDateColor) {
        this._calendarDateColor = calendarDateColor;
    }
    get calendarDateColor() {
        return this._calendarDateColor;
    }
    get month() {
        return this._month;
    }
    get monthValue() {
        return this.month + 1;
    }
    toSpecificDate() {
        return DateUtils.specificDate({
            yyyy: this.year,
            mm: this.monthValue,
            dd: this.day
        });
    }
}

var CalendarColor;
(function (CalendarColor) {
    CalendarColor["DEFAULT"] = "";
    CalendarColor["SELECTED"] = "selected";
    CalendarColor["NEUTRAL"] = "neutral";
    CalendarColor["NEGATIVE"] = "negative";
})(CalendarColor || (CalendarColor = {}));
const WEEK = 6;
const VIEWFORMAT = 'DD/MM/YYYY';
class CalendarComponent {
    constructor() {
        this.changeYear = true;
        this.subtitles = [];
        this.multiple = false;
        this.selectedMultiple = [];
        this.visible = false;
        this.viewFormat = VIEWFORMAT;
        this.show = true;
        this.onTop = false;
        this.onRight = false;
        this.locale = {
            dayNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto',
                'Setembro', 'Outubro', 'Novembro', 'Dezembro']
        };
        this.onSelectDate = new EventEmitter();
        this.onGenerateCalendar = new EventEmitter();
        this.days = [];
        this.date = moment$1();
    }
    set selectedDate(value) {
        if (value) {
            this.date = moment$1(value, this.viewFormat, true);
        }
        else {
            this.date = moment$1();
        }
        if (this.days.length) {
            this.generateCalendarForSelectDateMonth();
        }
    }
    get month() {
        return this.date.month();
    }
    get year() {
        return this.date.year();
    }
    get day() {
        return this.date.date();
    }
    ngOnInit() {
        this.generateCalendarForSelectDateMonth();
        if (this.updateCalendar) {
            this.updateCalendar.subscribe(() => this.generateCalendarForSelectDateMonth());
        }
    }
    ngOnDestroy() {
        if (this.updateCalendar) {
            this.updateCalendar.unsubscribe();
        }
    }
    isAbleToChangeYear(yearToCompare) {
        if (this.changeYear) {
            return true;
        }
        const baseYear = this.year;
        return baseYear === yearToCompare;
    }
    nextMonth() {
        const newDate = this.date.clone().add(1, 'month');
        if (!this.isAbleToChangeYear(newDate.year())) {
            return;
        }
        this.date = newDate;
        this.selectedDate = this.date.format(this.viewFormat);
    }
    prevMonth() {
        const newDate = this.date.clone().subtract(1, 'month');
        if (!this.isAbleToChangeYear(newDate.year())) {
            return;
        }
        this.date = newDate;
        this.selectedDate = this.date.format(this.viewFormat);
    }
    nextYear() {
        if (!this.changeYear) {
            return;
        }
        this.date.add(1, 'year');
        this.selectedDate = this.date.format(this.viewFormat);
    }
    prevYear() {
        if (!this.changeYear) {
            return;
        }
        this.date.subtract(1, 'year');
        this.selectedDate = this.date.format(this.viewFormat);
    }
    selectDate(selectedCalendarDate) {
        if (!this.isAbleToChangeYear(selectedCalendarDate.year)) {
            return;
        }
        if (this.multiple) {
            this.selectMultiple(selectedCalendarDate);
        }
        else {
            this.date.set({
                year: selectedCalendarDate.year,
                month: selectedCalendarDate.month,
                date: selectedCalendarDate.day
            });
        }
        this.generateCalendarForSelectDateMonth();
        this.onSelectDate.emit(this.date.format(this.viewFormat));
    }
    selectMultiple(selectedCalendarDate) {
        const index = this.selectedMultiple.findIndex(calendarDate => calendarDate.calendarIsEqualTo(selectedCalendarDate));
        if (index === -1) {
            this.selectedMultiple.push(selectedCalendarDate);
        }
        else {
            this.selectedMultiple.splice(index, 1);
        }
    }
    generateCalendarForSelectDateMonth() {
        this.days = [];
        const startDay = this.date.clone().startOf('month');
        startDay.subtract(startDay.weekday(), 'days');
        const endDay = this.date.clone().endOf('month');
        endDay.add(WEEK - endDay.weekday(), 'days');
        while (startDay.isSameOrBefore(endDay)) {
            const calendarDate = new CalendarDate(startDay.date(), startDay.month(), startDay.year(), startDay.month() === this.month, this.defineSelectedDate(startDay) ? CalendarColor.SELECTED : CalendarColor.DEFAULT);
            this.days.push(calendarDate);
            startDay.add(1, 'days');
        }
        this.onGenerateCalendar.emit({
            calendarDates: this.days,
            baseMonth: this.month,
            baseYear: this.year
        });
    }
    defineSelectedDate(currentDate) {
        const currentDateFormatted = currentDate.format(this.viewFormat);
        if (this.multiple) {
            return this.selectedMultiple.some(calendarDate => currentDateFormatted === moment$1(calendarDate.toSpecificDate(), FROM_FORMAT).format(this.viewFormat));
        }
        else {
            return currentDateFormatted === this.date.format(this.viewFormat);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CalendarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CalendarComponent, selector: "elo-calendar", inputs: { changeYear: "changeYear", extraElement: "extraElement", subtitles: "subtitles", multiple: "multiple", selectedMultiple: "selectedMultiple", visible: "visible", viewFormat: "viewFormat", show: "show", onTop: "onTop", onRight: "onRight", selectedDate: "selectedDate", locale: "locale", updateCalendar: "updateCalendar" }, outputs: { onSelectDate: "onSelectDate", onGenerateCalendar: "onGenerateCalendar" }, ngImport: i0, template: "<div class=\"datepicker\" [class.visible]=\"visible\" [class.open]=\"show\" [class.top]=\"onTop\" [class.right]=\"onRight\">\n\t<div class=\"datepicker-header\" style=\"display: flex;flex-direction: column\">\n\t  <div>\n\t\t  <div class=\"datepicker-header-year\">\n        <em *ngIf=\"changeYear\" class=\"fa fa-chevron-left\" (click)=\"prevYear()\"></em>\n        <b class=\"year-number\">{{year}}</b>\n        <em *ngIf=\"changeYear\" class=\"fa fa-chevron-right\" (click)=\"nextYear()\"></em>\n\t\t  </div>\n\t\t  <div class=\"datepicker-header-month\">\n        <em class=\"fa fa-chevron-left\" (click)=\"prevMonth()\"></em>\n        <b class=\"month-name\">{{locale.monthNames[month]}}</b>\n        <em class=\"fa fa-chevron-right\" (click)=\"nextMonth()\"></em>\n\t\t  </div>\n    </div>\n\n    <div style=\"height: 100%;display: flex;justify-content: center;align-items: center;\" *ngIf=\"visible && extraElement\">\n      <ng-container [ngTemplateOutlet]=\"extraElement\"></ng-container>\n    </div>\n\t</div>\n\n\t<ul class=\"datepicker-calendar\">\n\t\t<ul class=\"datepicker-calendar-header\">\n\t\t\t<li class=\"item\" *ngFor=\"let weekDay of locale.dayNames\">{{weekDay}}</li>\n\t\t</ul>\n\t\t<li *ngFor=\"let dayCalendar of days\" (click)=\"selectDate(dayCalendar)\" class=\"item\"\n      [class.not-this-month]=\"!dayCalendar.isMonthOfSelectedDate\"\n\t\t\t[ngClass]=\"dayCalendar.calendarDateColor\">\n\t\t\t{{dayCalendar.day}}</li>\n\t</ul>\n\t<div class=\"subtitles\" *ngIf=\"subtitles.length\">\n\t  <div *ngFor=\"let subtitle of subtitles\" class=\"subtitle large\"[ngClass]=\"subtitle.subtitleColor\">\n\t    {{subtitle.descricao}}\n\t  </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CalendarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-calendar', template: "<div class=\"datepicker\" [class.visible]=\"visible\" [class.open]=\"show\" [class.top]=\"onTop\" [class.right]=\"onRight\">\n\t<div class=\"datepicker-header\" style=\"display: flex;flex-direction: column\">\n\t  <div>\n\t\t  <div class=\"datepicker-header-year\">\n        <em *ngIf=\"changeYear\" class=\"fa fa-chevron-left\" (click)=\"prevYear()\"></em>\n        <b class=\"year-number\">{{year}}</b>\n        <em *ngIf=\"changeYear\" class=\"fa fa-chevron-right\" (click)=\"nextYear()\"></em>\n\t\t  </div>\n\t\t  <div class=\"datepicker-header-month\">\n        <em class=\"fa fa-chevron-left\" (click)=\"prevMonth()\"></em>\n        <b class=\"month-name\">{{locale.monthNames[month]}}</b>\n        <em class=\"fa fa-chevron-right\" (click)=\"nextMonth()\"></em>\n\t\t  </div>\n    </div>\n\n    <div style=\"height: 100%;display: flex;justify-content: center;align-items: center;\" *ngIf=\"visible && extraElement\">\n      <ng-container [ngTemplateOutlet]=\"extraElement\"></ng-container>\n    </div>\n\t</div>\n\n\t<ul class=\"datepicker-calendar\">\n\t\t<ul class=\"datepicker-calendar-header\">\n\t\t\t<li class=\"item\" *ngFor=\"let weekDay of locale.dayNames\">{{weekDay}}</li>\n\t\t</ul>\n\t\t<li *ngFor=\"let dayCalendar of days\" (click)=\"selectDate(dayCalendar)\" class=\"item\"\n      [class.not-this-month]=\"!dayCalendar.isMonthOfSelectedDate\"\n\t\t\t[ngClass]=\"dayCalendar.calendarDateColor\">\n\t\t\t{{dayCalendar.day}}</li>\n\t</ul>\n\t<div class=\"subtitles\" *ngIf=\"subtitles.length\">\n\t  <div *ngFor=\"let subtitle of subtitles\" class=\"subtitle large\"[ngClass]=\"subtitle.subtitleColor\">\n\t    {{subtitle.descricao}}\n\t  </div>\n  </div>\n</div>\n" }]
        }], propDecorators: { changeYear: [{
                type: Input
            }], extraElement: [{
                type: Input
            }], subtitles: [{
                type: Input
            }], multiple: [{
                type: Input
            }], selectedMultiple: [{
                type: Input
            }], visible: [{
                type: Input
            }], viewFormat: [{
                type: Input
            }], show: [{
                type: Input
            }], onTop: [{
                type: Input
            }], onRight: [{
                type: Input
            }], selectedDate: [{
                type: Input
            }], locale: [{
                type: Input
            }], onSelectDate: [{
                type: Output
            }], onGenerateCalendar: [{
                type: Output
            }], updateCalendar: [{
                type: Input
            }] } });

class CalendarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CalendarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CalendarModule, declarations: [CalendarComponent], imports: [CommonModule], exports: [CalendarComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CalendarModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CalendarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [CalendarComponent],
                    exports: [CalendarComponent]
                }]
        }] });

// @dynamic
class FormUtils {
    static equals(prop) {
        return (obj1, obj2) => {
            if (!obj1 || !obj2) {
                return false;
            }
            return obj1[prop] === obj2[prop];
        };
    }
    /**
     * Marca todos os controls do Form como dirty
     * @param formGroup - formGroup a ser validado
     */
    static markFormGroupDirty(formGroup) {
        Object.values(formGroup.controls).forEach(control => {
            if (control.invalid) {
                control.markAsDirty();
                control.updateValueAndValidity();
                if (control.controls) {
                    this.markFormGroupDirty(control);
                }
            }
        });
    }
    static clearArray(objArray) {
        while (objArray.length > 0) {
            objArray.removeAt(0);
        }
    }
}

const fieldNameRespostaDefault = 'respostas';
const fieldNameGruposDefault = 'grupos';
const limparGrupos = (gruposFormArray) => {
    gruposFormArray.controls.splice(0, gruposFormArray.length);
    gruposFormArray.reset();
};
const initGruposRespostaForm = (form, formBuilder, gruposResposta, fieldNameGrupos = fieldNameGruposDefault) => {
    const gruposFormArray = form.get(fieldNameGrupos);
    limparGrupos(gruposFormArray);
    gruposResposta?.forEach((gr) => {
        gruposFormArray.push(gr?.id &&
            formBuilder.group({
                id: [gr.id],
                descricao: [gr.descricao],
                ativo: [gr.ativo || false],
                [fieldNameRespostaDefault]: formBuilder.array(gr.respostas?.map((r) => formBuilder.group({
                    id: [r.id],
                    campo: [r.campo],
                    referencia: [r.referencia],
                    valor: [r.valor],
                    alternativa: [r.alternativa],
                })) || []),
            }));
    });
};
const buildRespostasFromGrupoRespostaDTO = (values) => {
    const respostas = [];
    const reducedForm = values.reduce((acc, current) => {
        acc[current.id] = current;
        return acc;
    }, {});
    const toResposta = (r) => ({
        id: r.id,
        campo: r.campo,
        valor: r.valor,
        alternativa: r.alternativa,
    });
    Object.values(reducedForm).forEach((gr) => respostas.push(...gr.respostas.map(toResposta)));
    return respostas;
};
const limparRespostas = (respostasFormArray) => {
    respostasFormArray.controls.splice(0, respostasFormArray.length);
    respostasFormArray.reset();
};
const changeRespostasEntityFormArray = (formBuilder, form, fieldNameResposta, fieldNameGrupos) => {
    const respostasFormArray = form.get(fieldNameResposta);
    limparRespostas(respostasFormArray);
    const respostas = buildRespostasFromGrupoRespostaDTO(form.get(fieldNameGrupos).value);
    respostas.forEach((r) => {
        respostasFormArray.push(formBuilder.group({
            id: [r.id],
            campo: [r.campo],
            valor: [r.valor],
            alternativa: [r.alternativa],
        }));
    });
};

var CampoTipoEnum;
(function (CampoTipoEnum) {
    CampoTipoEnum["TEXTO"] = "TEXTO";
    CampoTipoEnum["INTEIRO"] = "INTEIRO";
    CampoTipoEnum["DECIMAL"] = "DECIMAL";
    CampoTipoEnum["DATA"] = "DATA";
    CampoTipoEnum["MULTIPLA_ESCOLHA"] = "MULTIPLA_ESCOLHA";
})(CampoTipoEnum || (CampoTipoEnum = {}));
var TipoValidacaoEnum;
(function (TipoValidacaoEnum) {
    TipoValidacaoEnum["OBRIGATORIO_SE_PRESENTE"] = "OBRIGATORIO_SE_PRESENTE";
    TipoValidacaoEnum["OBRIGATORIO_SE_AUSENTE"] = "OBRIGATORIO_SE_AUSENTE";
    TipoValidacaoEnum["PROIBIDO_SE_PRESENTE"] = "PROIBIDO_SE_PRESENTE";
    TipoValidacaoEnum["PROIBIDO_SE_AUSENTE"] = "PROIBIDO_SE_AUSENTE";
    TipoValidacaoEnum["OBRIGATORIO_SE_IGUAL"] = "OBRIGATORIO_SE_IGUAL";
    TipoValidacaoEnum["PROIBIDO_SE_IGUAL"] = "PROIBIDO_SE_IGUAL";
})(TipoValidacaoEnum || (TipoValidacaoEnum = {}));

const isCampoObrigatorioValorSemResposta = (resposta) => {
    return (resposta.campo.tipo !== CampoTipoEnum.MULTIPLA_ESCOLHA &&
        resposta.campo.obrigatorio &&
        resposta.campo.ativo &&
        !resposta.valor);
};
const isCampoObrigatorioMultiplaEscolhaSemResposta = (resposta) => {
    return (resposta.campo.tipo === CampoTipoEnum.MULTIPLA_ESCOLHA &&
        resposta.campo.obrigatorio &&
        resposta.campo.ativo &&
        (!resposta.alternativa || !resposta.alternativa?.ativo));
};
const getMessageCampoObrigatorio = (campo) => {
    return `${campo.descricao} é obrigatório`;
};
const suffixNameElementCampoValor = 'valor';
const suffixNameElementCampoMultiplaEscolha = 'alternativa.id';
const setErrorOnFieldByTipo = (resposta, mensagem) => {
    const mensagemGenerica = {
        valid: false,
        mensagem,
    };
    const campo = resposta.get('campo').value;
    if (campo.tipo === CampoTipoEnum.MULTIPLA_ESCOLHA) {
        resposta.get('alternativa').setErrors({
            mensagemGenerica,
        });
    }
    else {
        resposta.get('valor').setErrors({
            mensagemGenerica,
        });
    }
};
const setNullOnError = (resposta) => {
    const campo = resposta.get('campo').value;
    if (campo.tipo === CampoTipoEnum.MULTIPLA_ESCOLHA) {
        resposta.get('alternativa').setErrors(null);
    }
    else {
        resposta.get('valor').setErrors(null);
    }
};
const validateCamposDinamicos = (form, fieldNameGrupos) => {
    const grupos = form?.get(fieldNameGrupos);
    grupos?.controls.forEach((grupo) => {
        const respostas = grupo.get(fieldNameRespostaDefault);
        respostas?.controls.forEach((resposta) => {
            if (!resposta.value?.campo) {
                return;
            }
            if (isCampoObrigatorioValorSemResposta(resposta.value)) {
                setErrorOnFieldByTipo(resposta, getMessageCampoObrigatorio(resposta.value.campo));
            }
            else if (isCampoObrigatorioMultiplaEscolhaSemResposta(resposta.value)) {
                setErrorOnFieldByTipo(resposta, getMessageCampoObrigatorio(resposta.value.campo));
            }
            else if (resposta.value.campo.validacoes?.length > 0) {
                const validationError = resposta.value.campo.validacoes.reduce((error, validation) => {
                    return (error ??
                        validadoresGrupoResposta[validation.tipo](respostas.value, resposta.value, validation));
                }, undefined);
                if (validationError) {
                    setErrorOnFieldByTipo(resposta, validationError);
                }
                else {
                    setNullOnError(resposta);
                }
            }
            else {
                setNullOnError(resposta);
            }
        });
    });
};
const respostaToFlat = (resposta) => ({
    descricao: resposta.campo.descricao,
    campoDependente: resposta.campo.identificador,
    valor: resposta.valor,
    alternativa: resposta.alternativa,
    alternativaAtiva: resposta.alternativa?.ativo || false,
    tipoCampo: resposta.campo.tipo,
    campoAtivo: resposta.campo.ativo,
});
const formatStringToDisplayDate = (date) => {
    const newDate = typeof date === 'string' ? new Date(date) : date;
    if (newDate) {
        return DateUtils.format(newDate);
    }
    return newDate;
};
const formatValor = (respostaBase, validacao) => {
    if (respostaBase.tipoCampo === CampoTipoEnum.DATA) {
        return formatStringToDisplayDate(validacao.valor);
    }
    return validacao.valor;
};
const getRespostaDinamica = (respostas, nomeCampo) => {
    const match = respostas.find((resposta) => resposta.campo.identificador === nomeCampo);
    return match ? respostaToFlat(match) : undefined;
};
const validatorBuilder = (innerValidator) => (respostas, resposta, validacao) => {
    const respostaDependente = getRespostaDinamica(respostas, validacao.campoDependente);
    if (!respostaDependente?.campoAtivo) {
        return;
    }
    return innerValidator({
        resposta: respostaToFlat(resposta),
        respostaBase: respostaDependente,
        validacao,
    });
};
const validadoresGrupoResposta = {
    OBRIGATORIO_SE_AUSENTE: validatorBuilder(({ resposta, respostaBase }) => {
        if (!resposta.valor &&
            !resposta.alternativa &&
            !respostaBase.valor &&
            (!respostaBase.alternativa || !respostaBase.alternativaAtiva)) {
            return `O campo '${resposta.descricao}' deve estar respondido se o campo '${respostaBase.descricao}' não estiver.`;
        }
    }),
    PROIBIDO_SE_AUSENTE: validatorBuilder(({ resposta, respostaBase }) => {
        if ((resposta.valor || resposta.alternativa) &&
            !respostaBase.valor &&
            (!respostaBase.alternativa || !respostaBase.alternativaAtiva)) {
            return `O campo '${resposta.descricao}' não deve estar respondido se o campo '${respostaBase.descricao}' não estiver.`;
        }
    }),
    OBRIGATORIO_SE_PRESENTE: validatorBuilder(({ resposta, respostaBase }) => {
        if (!resposta.valor &&
            !resposta.alternativa &&
            (respostaBase.valor ||
                (respostaBase.alternativaAtiva && respostaBase.alternativa))) {
            return `O campo '${resposta.descricao}' deve estar respondido se o campo '${respostaBase.descricao}' estiver.`;
        }
    }),
    PROIBIDO_SE_PRESENTE: validatorBuilder(({ resposta, respostaBase }) => {
        if ((resposta.valor || resposta.alternativa) &&
            (respostaBase.valor ||
                (respostaBase.alternativaAtiva && respostaBase.alternativa))) {
            return `O campo '${resposta.descricao}' não pode estar respondido se o campo '${respostaBase.descricao}' estiver.`;
        }
    }),
    OBRIGATORIO_SE_IGUAL: validatorBuilder(({ resposta, respostaBase, validacao }) => {
        const valorParaValidacao = respostaBase.valor
            ? respostaBase.valor
            : String(respostaBase?.alternativa?.codigo);
        if (!resposta.valor &&
            !resposta.alternativa &&
            ((respostaBase.alternativa?.id && respostaBase.alternativaAtiva) ||
                !respostaBase.alternativa?.id) &&
            `${validacao.valor}` === `${valorParaValidacao}`) {
            return `O campo '${resposta.descricao}' é obrigatório se o campo '${respostaBase.descricao}' for igual a ${formatValor(respostaBase, validacao)}.`;
        }
    }),
    PROIBIDO_SE_IGUAL: validatorBuilder(({ resposta, respostaBase, validacao }) => {
        const valorParaValidacao = respostaBase.valor
            ? respostaBase.valor
            : String(respostaBase?.alternativa?.codigo);
        if ((resposta.valor || resposta.alternativa) &&
            ((respostaBase.alternativa?.id && respostaBase.alternativaAtiva) ||
                !respostaBase.alternativa?.id) &&
            `${validacao.valor}` === `${valorParaValidacao}`) {
            return `O campo '${resposta.descricao}' é proibido se o campo '${respostaBase.descricao}' for igual a ${formatValor(respostaBase, validacao)}.`;
        }
    }),
};

class FormControlValidationMsgDirective {
    constructor(formControlName, renderer, elementRef) {
        this.formControlName = formControlName;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.MODELO_MASCARA_REGEX = '^[#.]+$';
        this.CNH_MINIMA_REGEX = '^[A-E]+$';
        this.CONTAINED_IN_REGEX = '^\d+(,\d+|(\d+-\d+))*$';
        this.mapTranslate = new Map();
        this.children = [];
        this.hasTouched = false;
        this.mapTranslate.set('required', () => '(requerido) ');
        this.mapTranslate.set('minlength', (obj) => `(tamanho mínimo ${obj.requiredLength}) `);
        this.mapTranslate.set('maxlength', (obj) => `(tamanho máximo ${obj.requiredLength}) `);
        this.mapTranslate.set('min', (obj) => `(valor mínimo ${obj.min}) `);
        this.mapTranslate.set('max', (obj) => `(valor máximo ${obj.max}) `);
        this.mapTranslate.set('pattern', (obj) => this.buildPatternMessageValidator(obj.requiredPattern));
        this.mapTranslate.set('email', () => `(email inválido) `);
        this.mapTranslate.set('url', () => `(url inválida) `);
        this.mapTranslate.set('competencia', () => `(competência inválida)`);
        this.mapTranslate.set('competencia-minima', (obj) => `(competência mínima ${obj})`);
        this.mapTranslate.set('competencia-maxima', (obj) => `(competência máxima ${obj})`);
        this.mapTranslate.set('maxvalue', (obj) => `(valor máximo ${obj})`);
        this.mapTranslate.set('minvalue', (obj) => `(valor mínimo ${obj})`);
        this.mapTranslate.set('maxdate', (obj) => `(data máxima ${obj})`);
        this.mapTranslate.set('mindate', (obj) => `(data mínima ${obj})`);
        this.mapTranslate.set('dataCompetencia', (obj) => `(data fora da competência) `);
        this.mapTranslate.set('competenciaAberta', (obj) => `(competência está fechada) `);
        this.mapTranslate.set('differentValue', message => `(${message}) `);
        this.mapTranslate.set('sameValue', message => `(${message}) `);
        this.mapTranslate.set('valorMaior', (obj) => `(valor maior que ${obj})`);
        this.mapTranslate.set('vazio', (obj) => `(valor ${obj} está vazio)`);
        this.mapTranslate.set('validateDate', () => `(data inválida)`);
        this.mapTranslate.set('somaValor', (obj) => `A soma dos valores deve ser igual a ${obj.value}`);
        this.mapTranslate.set('conflictDate', () => `(conflito entre datas)`);
        this.mapTranslate.set('validateDateNotSmaller', (obj) => `(data mínima ${obj.dataMinima})`);
        this.mapTranslate.set('validateDateNotGreater', (obj) => `(data máxima ${obj.dataMaxima})`);
        this.mapTranslate.set('validateHourNotSmaller', (obj) => `(hora mínima ${obj.horaMinima})`);
        this.mapTranslate.set('validateDateNotGreaterYear', (obj) => `(ano deve ser igual a ${obj.yearMaximo})`);
        this.mapTranslate.set('codigoJaUtilizado', (obj) => `(código ${obj.codigo} já utilizado)`);
        this.mapTranslate.set('mensagemGenerica', (obj) => `${obj.mensagem}`);
        this.mapTranslate.set('[#.]+', () => 'Mensagem custom');
        this.mapTranslate.set('cnpj_invalid', () => '(CNPJ inválido)');
        this.mapTranslate.set('isCompetenciaAberta', (message) => `(${message}) `);
        this.mapTranslate.set('isExercicioValid', (message) => `(${message}) `);
        this.mapTranslate.set('dateNotWeekend', () => `(data não pode ser no fim de semana)`);
        this.mapTranslate.set('isSameCompetencia', (message) => `(${message}) `);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.removeErrorsMessages();
        this.destroyNode(this.msgElement);
        if (this.hintElement) {
            this.destroyNode(this.hintElement);
        }
        this.renderer.removeChild(this.elementRef.nativeElement.parentNode, this.msgElement);
    }
    ngOnInit() {
        if (!this.formControlName) {
            this.formControlName = this.formControlAttr;
        }
        this.createMessageElement();
        if (this.formControlName.status === 'INVALID' && (this.formControlName.touched || this.formControlName.dirty)) {
            this.addErrorsMessages();
        }
        this.subscription = this.formControlName.statusChanges.subscribe(status => {
            this.removeErrorsMessages();
            if (status === 'INVALID' && (this.hasTouched || this.formControlName.dirty)) {
                this.addErrorsMessages();
            }
        });
    }
    addErrorIfNecessary() {
        this.removeErrorsMessages();
        if (this.formControlName.invalid) {
            this.addErrorsMessages();
        }
    }
    onBlur(event) {
        this.hasTouched = true;
        this.addErrorIfNecessary();
    }
    createMessageElement() {
        this.msgElement = this.renderer.createElement('p');
        this.renderer.addClass(this.msgElement, 'help-message');
        this.renderer.appendChild(this.elementRef.nativeElement.parentNode, this.msgElement);
    }
    removeErrorsMessages() {
        this.children.forEach(child => {
            this.renderer.removeChild(this.msgElement, child);
        });
        this.children = [];
    }
    addErrorsMessages() {
        Object.keys(this.formControlName.errors).forEach(key => {
            let keyTranslated = `(${key}) `;
            if (this.mapTranslate.has(key)) {
                keyTranslated = this.mapTranslate.get(key)(this.formControlName.errors[key]);
            }
            const child = document.createTextNode(keyTranslated);
            this.children.push(child);
            this.renderer.appendChild(this.msgElement, child);
            this.renderHintError(this.formControlName.errors[key]['hintMessage']);
        });
    }
    destroyNode(node) {
        if (this.renderer.destroyNode instanceof Function) {
            this.renderer.destroyNode(node);
        }
    }
    buildPatternMessageValidator(requiredPattern) {
        const msg = '(padrão requerido';
        switch (requiredPattern) {
            case this.MODELO_MASCARA_REGEX:
                return `${msg} #.##.###)`;
            case this.CNH_MINIMA_REGEX:
                return `(A,B,C,D,E,AB)`;
            case this.CONTAINED_IN_REGEX:
                return `${msg} # | #,#... | #,#...,#-# | #-#)`;
            default:
                return `${msg} ${requiredPattern})`;
        }
    }
    renderHintError(hintMessage) {
        if (!hintMessage) {
            return;
        }
        this.hintElement = this.renderer.createElement('div');
        ['hint', 'fa-exclamation-circle', 'clean', 'inline', 'negative', 'sm'].forEach(x => this.renderer.addClass(this.hintElement, x));
        const divHintContent = this.renderer.createElement('div');
        this.renderer.addClass(divHintContent, 'hint-content');
        this.renderer.appendChild(this.hintElement, divHintContent);
        this.renderer.appendChild(divHintContent, document.createTextNode(hintMessage));
        this.renderer.appendChild(this.msgElement, this.hintElement);
        this.children.push(this.hintElement);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormControlValidationMsgDirective, deps: [{ token: i1$2.FormControlName, optional: true }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FormControlValidationMsgDirective, selector: "[formControlValidationMsg]", inputs: { formControlAttr: "formControlAttr" }, host: { listeners: { "blur": "onBlur($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormControlValidationMsgDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[formControlValidationMsg]' }]
        }], ctorParameters: () => [{ type: i1$2.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i0.Renderer2 }, { type: i0.ElementRef }], propDecorators: { formControlAttr: [{
                type: Input
            }], onBlur: [{
                type: HostListener,
                args: ['blur', ['$event']]
            }] } });

class CamposDinamicosRespostasComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.suffixNameElementCampoValor = 'valor';
        this.getTipoCampoFromEnum = {
            TEXTO: 'text',
            INTEIRO: 'text',
            DECIMAL: 'text',
            DATA: 'date',
            MULTIPLA_ESCOLHA: 'select',
        };
    }
    ngOnInit() {
        this.changeRespostasEntity();
    }
    ngAfterViewInit() {
        validateCamposDinamicos(this.form, this.fieldNameGrupos);
    }
    changeRespostasEntity() {
        changeRespostasEntityFormArray(this.formBuilder, this.form, this.fieldNameResposta, this.fieldNameGrupos);
    }
    compareWith() {
        return FormUtils.equals('id');
    }
    getAlternativasAtivas(alternativas) {
        return alternativas.filter((a) => a.ativo);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosRespostasComponent, deps: [{ token: i1$2.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CamposDinamicosRespostasComponent, selector: "campos-dinamicos-respostas", inputs: { form: "form", grupoForm: "grupoForm", fieldNameResposta: "fieldNameResposta", fieldNameGrupos: "fieldNameGrupos", indexGrupoResposta: "indexGrupoResposta" }, ngImport: i0, template: "<div\n  [formGroup]=\"grupoForm\"\n  class=\"row\"\n  *ngIf=\"\n    grupoForm.get('respostas')?.value &&\n    grupoForm.get('respostas').value.length > 0\n  \"\n>\n  <div class=\"flex wrap align-items-left mb-xs\">\n    <div formArrayName=\"respostas\">\n      <div\n        id=\"respostas_{{ form?.get('id')?.value }}\"\n        *ngFor=\"\n          let resposta of grupoForm.get('respostas')['controls'];\n          let i = index\n        \"\n      >\n        <div [formGroupName]=\"i\" *ngIf=\"!!resposta.value?.campo?.ativo\">\n          <elo-form-label-column\n            label=\"{{ resposta.value?.campo.descricao }}\"\n            column=\"3\"\n          >\n            <div\n              *ngIf=\"\n                resposta.value?.campo.tipo === 'TEXTO' ||\n                resposta.value?.campo.tipo === 'DATA'\n              \"\n            >\n              <input\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                type=\"{{ getTipoCampoFromEnum[resposta.value?.campo.tipo] }}\"\n                formControlName=\"valor\"\n                formControlValidationMsg\n                (blur)=\"changeRespostasEntity()\"\n              />\n            </div>\n            <div *ngIf=\"resposta.value?.campo.tipo === 'INTEIRO'\">\n              <input\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                type=\"{{ getTipoCampoFromEnum[resposta.value?.campo.tipo] }}\"\n                formControlName=\"valor\"\n                formControlValidationMsg\n                eloNumber\n                (blur)=\"changeRespostasEntity()\"\n              />\n            </div>\n            <div *ngIf=\"resposta.value?.campo.tipo === 'DECIMAL'\">\n              <input\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                type=\"{{ getTipoCampoFromEnum[resposta.value?.campo.tipo] }}\"\n                formControlName=\"valor\"\n                formControlValidationMsg\n                eloDecimal\n                (blur)=\"changeRespostasEntity()\"\n              />\n            </div>\n            <div *ngIf=\"resposta.value?.campo.tipo === 'MULTIPLA_ESCOLHA'\">\n              <select\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                formControlName=\"alternativa\"\n                formControlValidationMsg\n                (change)=\"changeRespostasEntity()\"\n                [compareWith]=\"compareWith()\"\n              >\n                <option [ngValue]=\"\"></option>\n                <option\n                  *ngFor=\"\n                    let a of getAlternativasAtivas(\n                      resposta.value?.campo.alternativas\n                    )\n                  \"\n                  [ngValue]=\"a\"\n                >\n                  {{ a?.codigo }} - {{ a?.descricao }}\n                </option>\n              </select>\n            </div>\n          </elo-form-label-column>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: FormControlValidationMsgDirective, selector: "[formControlValidationMsg]", inputs: ["formControlAttr"] }, { kind: "component", type: FormLabelColumnComponent, selector: "elo-form-label-column", inputs: ["label", "color", "column", "offset", "hintMessage", "hintPosition", "hintIconLeftAlign", "linkTitle", "showLink", "icon"], outputs: ["onClickLink"] }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i1$2.FormGroupName, selector: "[formGroupName]", inputs: ["formGroupName"] }, { kind: "directive", type: i1$2.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: EloDecimalDirective, selector: "[eloDecimal]", inputs: ["textAlign", "allowNegative", "suffix", "prefix", "precision"] }, { kind: "directive", type: EloNumberDirective, selector: "[eloNumber]", inputs: ["allowNegative", "prefix", "suffix", "align", "precision", "thousands"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosRespostasComponent, decorators: [{
            type: Component,
            args: [{ selector: 'campos-dinamicos-respostas', template: "<div\n  [formGroup]=\"grupoForm\"\n  class=\"row\"\n  *ngIf=\"\n    grupoForm.get('respostas')?.value &&\n    grupoForm.get('respostas').value.length > 0\n  \"\n>\n  <div class=\"flex wrap align-items-left mb-xs\">\n    <div formArrayName=\"respostas\">\n      <div\n        id=\"respostas_{{ form?.get('id')?.value }}\"\n        *ngFor=\"\n          let resposta of grupoForm.get('respostas')['controls'];\n          let i = index\n        \"\n      >\n        <div [formGroupName]=\"i\" *ngIf=\"!!resposta.value?.campo?.ativo\">\n          <elo-form-label-column\n            label=\"{{ resposta.value?.campo.descricao }}\"\n            column=\"3\"\n          >\n            <div\n              *ngIf=\"\n                resposta.value?.campo.tipo === 'TEXTO' ||\n                resposta.value?.campo.tipo === 'DATA'\n              \"\n            >\n              <input\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                type=\"{{ getTipoCampoFromEnum[resposta.value?.campo.tipo] }}\"\n                formControlName=\"valor\"\n                formControlValidationMsg\n                (blur)=\"changeRespostasEntity()\"\n              />\n            </div>\n            <div *ngIf=\"resposta.value?.campo.tipo === 'INTEIRO'\">\n              <input\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                type=\"{{ getTipoCampoFromEnum[resposta.value?.campo.tipo] }}\"\n                formControlName=\"valor\"\n                formControlValidationMsg\n                eloNumber\n                (blur)=\"changeRespostasEntity()\"\n              />\n            </div>\n            <div *ngIf=\"resposta.value?.campo.tipo === 'DECIMAL'\">\n              <input\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                type=\"{{ getTipoCampoFromEnum[resposta.value?.campo.tipo] }}\"\n                formControlName=\"valor\"\n                formControlValidationMsg\n                eloDecimal\n                (blur)=\"changeRespostasEntity()\"\n              />\n            </div>\n            <div *ngIf=\"resposta.value?.campo.tipo === 'MULTIPLA_ESCOLHA'\">\n              <select\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                formControlName=\"alternativa\"\n                formControlValidationMsg\n                (change)=\"changeRespostasEntity()\"\n                [compareWith]=\"compareWith()\"\n              >\n                <option [ngValue]=\"\"></option>\n                <option\n                  *ngFor=\"\n                    let a of getAlternativasAtivas(\n                      resposta.value?.campo.alternativas\n                    )\n                  \"\n                  [ngValue]=\"a\"\n                >\n                  {{ a?.codigo }} - {{ a?.descricao }}\n                </option>\n              </select>\n            </div>\n          </elo-form-label-column>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }], propDecorators: { form: [{
                type: Input
            }], grupoForm: [{
                type: Input
            }], fieldNameResposta: [{
                type: Input
            }], fieldNameGrupos: [{
                type: Input
            }], indexGrupoResposta: [{
                type: Input
            }] } });

class CamposDinamicosViewComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CamposDinamicosViewComponent, selector: "campos-dinamicos-view-component", inputs: { gruposRespostas: "gruposRespostas" }, ngImport: i0, template: "<div *ngIf=\"gruposRespostas && gruposRespostas.length > 0\">\n  <div *ngFor=\"let grupo of gruposRespostas; let i = index\">\n    <div id=\"grupo_{{ grupo.id }}\" *ngIf=\"!!grupo.ativo\">\n      <div class=\"row mt-xs\">\n        <div class=\"col-md-12\">\n          <b class=\"dd-title\"> {{ grupo.descricao }} </b>\n        </div>\n      </div>\n      <div class=\"mt-xs\" *ngIf=\"grupo.respostas.length > 0\">\n        <ng-container>\n          <div class=\"panel table\">\n            <div class=\"panel-body pb-none\">\n              <elo-datatable\n                [values]=\"grupo.respostas\"\n                [class]=\"'fancy fixed'\"\n                [emptyMessage]=\"'Sem registros'\"\n              >\n                <elo-column field=\"campo.codigo\" header=\"C\u00F3digo\"></elo-column>\n                <elo-column\n                  field=\"campo.descricao\"\n                  header=\"Descri\u00E7\u00E3o\"\n                ></elo-column>\n                <elo-column field=\"valorResposta\" header=\"Valor Resposta\">\n                  <ng-template #dataTableCell let-object=\"object\">\n                    <p *ngIf=\"object?.campo?.tipo === 'TEXTO'\">\n                      {{ object.valor }}\n                    </p>\n                    <p *ngIf=\"object?.campo?.tipo === 'INTEIRO'\">\n                      {{ object.valor }}\n                    </p>\n                    <p *ngIf=\"object?.campo?.tipo === 'DECIMAL'\">\n                      {{ object.valor | decimalformat: '1.2-2' }}\n                    </p>\n                    <p *ngIf=\"object?.campo?.tipo === 'DATA'\">\n                      {{ object.valor | dateformat }}\n                    </p>\n                    <div *ngIf=\"object?.campo?.tipo === 'MULTIPLA_ESCOLHA'\">\n                      {{ object.alternativa.codigo }} -\n                      {{ object.alternativa.descricao }}\n                    </div>\n                  </ng-template>\n                </elo-column>\n              </elo-datatable>\n            </div>\n          </div>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "component", type: EloDatatableComponent, selector: "elo-datatable", inputs: ["values", "paramExpandTemplate", "emptyMessage", "selection", "selectionMode", "selectionModeId", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "titleCheckboxDisallowed", "sortable", "pageParameters", "class", "colSpanActions", "isQuickViewOpener", "manyActions", "classEmptyMessage", "rowDoubleClickFunction", "visibleRadioWhenFunction", "enableScrollX", "textTransform", "headerFixo", "showHeader", "selectionModeWithFooter"], outputs: ["onClickCheckbox", "onClickRadioButton", "onSelectOne", "onModifySelection", "onTableHeadClick", "onInputChange", "onRowDoubleClick"] }, { kind: "component", type: EloColumnComponent, selector: "elo-column", inputs: ["field", "header", "headerAlign", "isDecimal", "isPercentual", "digits", "isDate", "isDateTime", "isCnpjCpf", "enumOptions", "col", "class", "isEditable", "isEditing", "dataTable", "hidden", "hiddenTableData", "sortable", "samp", "headerStyle", "dataStyle"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: DecimalFormatPipe, name: "decimalformat" }, { kind: "pipe", type: DateFormatPipe, name: "dateformat" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'campos-dinamicos-view-component', template: "<div *ngIf=\"gruposRespostas && gruposRespostas.length > 0\">\n  <div *ngFor=\"let grupo of gruposRespostas; let i = index\">\n    <div id=\"grupo_{{ grupo.id }}\" *ngIf=\"!!grupo.ativo\">\n      <div class=\"row mt-xs\">\n        <div class=\"col-md-12\">\n          <b class=\"dd-title\"> {{ grupo.descricao }} </b>\n        </div>\n      </div>\n      <div class=\"mt-xs\" *ngIf=\"grupo.respostas.length > 0\">\n        <ng-container>\n          <div class=\"panel table\">\n            <div class=\"panel-body pb-none\">\n              <elo-datatable\n                [values]=\"grupo.respostas\"\n                [class]=\"'fancy fixed'\"\n                [emptyMessage]=\"'Sem registros'\"\n              >\n                <elo-column field=\"campo.codigo\" header=\"C\u00F3digo\"></elo-column>\n                <elo-column\n                  field=\"campo.descricao\"\n                  header=\"Descri\u00E7\u00E3o\"\n                ></elo-column>\n                <elo-column field=\"valorResposta\" header=\"Valor Resposta\">\n                  <ng-template #dataTableCell let-object=\"object\">\n                    <p *ngIf=\"object?.campo?.tipo === 'TEXTO'\">\n                      {{ object.valor }}\n                    </p>\n                    <p *ngIf=\"object?.campo?.tipo === 'INTEIRO'\">\n                      {{ object.valor }}\n                    </p>\n                    <p *ngIf=\"object?.campo?.tipo === 'DECIMAL'\">\n                      {{ object.valor | decimalformat: '1.2-2' }}\n                    </p>\n                    <p *ngIf=\"object?.campo?.tipo === 'DATA'\">\n                      {{ object.valor | dateformat }}\n                    </p>\n                    <div *ngIf=\"object?.campo?.tipo === 'MULTIPLA_ESCOLHA'\">\n                      {{ object.alternativa.codigo }} -\n                      {{ object.alternativa.descricao }}\n                    </div>\n                  </ng-template>\n                </elo-column>\n              </elo-datatable>\n            </div>\n          </div>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], propDecorators: { gruposRespostas: [{
                type: Input
            }] } });

class CamposDinamicosComponent {
    constructor() {
        this.fieldNameResposta = fieldNameRespostaDefault;
        this.fieldNameGrupos = fieldNameGruposDefault;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CamposDinamicosComponent, selector: "campos-dinamicos-component", inputs: { fieldNameResposta: "fieldNameResposta", fieldNameGrupos: "fieldNameGrupos", form: "form" }, ngImport: i0, template: "<div *ngIf=\"!!form?.get(fieldNameGrupos)\">\n  <form [formGroup]=\"form\">\n    <div formArrayName=\"{{ fieldNameGrupos }}\">\n      <div\n        *ngFor=\"\n          let grupo of form.get(fieldNameGrupos)['controls'];\n          let i = index\n        \"\n      >\n        <div\n          id=\"grupo_{{ grupo.value?.id }}\"\n          [formGroupName]=\"i\"\n          *ngIf=\"!!grupo.value?.ativo\"\n        >\n          <div class=\"row mt-xs\">\n            <div class=\"col-md-12\">\n              <b class=\"dd-title\"> {{ grupo.value?.descricao }} </b>\n            </div>\n          </div>\n          <campos-dinamicos-respostas\n            [form]=\"form\"\n            [grupoForm]=\"grupo\"\n            [indexGrupoResposta]=\"i\"\n            [fieldNameResposta]=\"fieldNameResposta\"\n            [fieldNameGrupos]=\"fieldNameGrupos\"\n          ></campos-dinamicos-respostas>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n", dependencies: [{ kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormGroupName, selector: "[formGroupName]", inputs: ["formGroupName"] }, { kind: "directive", type: i1$2.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CamposDinamicosRespostasComponent, selector: "campos-dinamicos-respostas", inputs: ["form", "grupoForm", "fieldNameResposta", "fieldNameGrupos", "indexGrupoResposta"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosComponent, decorators: [{
            type: Component,
            args: [{ selector: 'campos-dinamicos-component', template: "<div *ngIf=\"!!form?.get(fieldNameGrupos)\">\n  <form [formGroup]=\"form\">\n    <div formArrayName=\"{{ fieldNameGrupos }}\">\n      <div\n        *ngFor=\"\n          let grupo of form.get(fieldNameGrupos)['controls'];\n          let i = index\n        \"\n      >\n        <div\n          id=\"grupo_{{ grupo.value?.id }}\"\n          [formGroupName]=\"i\"\n          *ngIf=\"!!grupo.value?.ativo\"\n        >\n          <div class=\"row mt-xs\">\n            <div class=\"col-md-12\">\n              <b class=\"dd-title\"> {{ grupo.value?.descricao }} </b>\n            </div>\n          </div>\n          <campos-dinamicos-respostas\n            [form]=\"form\"\n            [grupoForm]=\"grupo\"\n            [indexGrupoResposta]=\"i\"\n            [fieldNameResposta]=\"fieldNameResposta\"\n            [fieldNameGrupos]=\"fieldNameGrupos\"\n          ></campos-dinamicos-respostas>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n" }]
        }], propDecorators: { fieldNameResposta: [{
                type: Input
            }], fieldNameGrupos: [{
                type: Input
            }], form: [{
                type: Input
            }] } });

class FormControlValidationMsgModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormControlValidationMsgModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FormControlValidationMsgModule, declarations: [FormControlValidationMsgDirective], exports: [FormControlValidationMsgDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormControlValidationMsgModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormControlValidationMsgModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormControlValidationMsgDirective],
                    exports: [FormControlValidationMsgDirective]
                }]
        }] });

const MODELFORMAT = 'YYYY-MM-DD';
const INVALID_DATE$1 = 'Invalid date';
const ONLY_NUMBERS_BAR_REGEX = /[^\/0-9\]]|[aA-zZ]/g;
function datePickerValidator(c) {
    return (c.value === INVALID_DATE$1) ? {
        validateDate: {
            valid: false
        }
    } : null;
}
class DatePickerComponent {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.viewFormat = VIEWFORMAT;
        this.modelFormat = MODELFORMAT;
        this.disable = false;
        this.showCalendar = false;
        this.onTop = false;
        this.onRight = false;
        this.date = '';
        this.onChange = () => null;
    }
    get value() {
        return this.date;
    }
    set value(value) {
        const valueWithRegex = value.replace(ONLY_NUMBERS_BAR_REGEX, '');
        if (value !== valueWithRegex) {
            value = valueWithRegex;
            this.input.nativeElement.value = value;
        }
        this.date = value;
        if (!this.date) {
            this.onChange('');
        }
        else if (!this.isDateComplete()) {
            this.date = this.formatPartialDate(this.date, this.viewFormat);
            this.onChange('Invalid date');
        }
        else {
            this.onChange(moment(this.date, this.viewFormat, true).format(this.modelFormat));
        }
    }
    writeValue(obj) {
        if (obj) {
            this.date = moment(obj, this.modelFormat).format(this.viewFormat);
        }
        else {
            this.date = null;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    getDateToCalendar() {
        const dateToCalendar = moment(this.value, this.viewFormat, true);
        if (dateToCalendar.isValid()) {
            return dateToCalendar.format(this.viewFormat);
        }
        return '';
    }
    onClickInput() {
        if (!this.disable) {
            let heightDocument = window.innerHeight;
            heightDocument = heightDocument - 36; // footer height
            let heightDatepicker = 280;
            let datePicker = document.querySelector('#' + this.id + ' .datepicker');
            if (datePicker && datePicker.classList && !datePicker.classList.contains('open')) {
                datePicker.setAttribute('style', 'height: ' + heightDatepicker +
                    'px; position: fixed; display: block; margin-top: -' +
                    window.pageYOffset + 'px; opacity: 1;');
                let datepickerOffsetLeft = datePicker.offsetLeft + datePicker.offsetWidth;
                let datepickerOffsetTop = datePicker.offsetTop;
                datePicker.setAttribute('style', 'position: absolute;margin-top: 0;');
                if (datepickerOffsetTop + heightDatepicker > heightDocument) {
                    this.onTop = true;
                }
                else {
                    this.onTop = false;
                }
                if (window.innerWidth < datepickerOffsetLeft) {
                    this.onRight = true;
                }
                else {
                    this.onRight = false;
                }
            }
            this.showCalendar = !this.showCalendar;
        }
    }
    onSelectDate(date) {
        this.value = date;
        this.showCalendar = false;
    }
    ngOnInit() {
        this.unRegisterGlobalClick = this.renderer.listen('body', 'click', (event) => {
            this.closeCalendarGlobal(event);
        });
        this.input.nativeElement.disabled = this.disable;
    }
    ngOnDestroy() {
        if (this.unRegisterGlobalClick) {
            this.unRegisterGlobalClick();
        }
    }
    onKeyDown(event) {
        if (event.key === 'Tab') {
            this.showCalendar = false;
        }
    }
    closeCalendarGlobal(event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.showCalendar = false;
        }
    }
    isDateComplete() {
        return this.date.length === this.viewFormat.length;
    }
    formatPartialDate(dateParam, viewFormatParam) {
        const separator = viewFormatParam[viewFormatParam.search(/\W/)];
        const qtdSeparatorDate = StringUtils.countOccurrence(dateParam, separator);
        const qtdSeparatorFormat = StringUtils.countOccurrence(viewFormatParam, separator);
        if (qtdSeparatorDate !== qtdSeparatorFormat) {
            dateParam = StringUtils.replaceAll(dateParam, separator, '');
            for (let i = 0; i < dateParam.length; i++) {
                if (viewFormatParam[i + 1] === separator && dateParam[i + 1] !== separator) {
                    dateParam = [dateParam.slice(0, i + 1), separator, dateParam.slice(i + 1)].join('');
                }
            }
        }
        return dateParam;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DatePickerComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DatePickerComponent, selector: "elo-datepicker", inputs: { viewFormat: "viewFormat", modelFormat: "modelFormat", id: "id", disable: "disable" }, providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: DatePickerComponent },
            { provide: NG_VALIDATORS, multi: true, useValue: datePickerValidator }
        ], viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true, static: true }], ngImport: i0, template: "<input #input id=\"{{id}}_input\" type=\"text\" class=\"has-input-icon\" [(ngModel)]=\"value\" (click)=\"onClickInput()\"\n    [maxlength]=\"viewFormat.length\" (keydown)=\"onKeyDown($event)\" [disabled]=\"disable\" autocomplete=\"off\">\n<i class=\"fa fa-calendar input-icon\" aria-hidden=\"true\" (click)=\"onClickInput()\"></i>\n<elo-calendar #calendar [show]=\"showCalendar\" [onTop]=\"onTop\" [onRight]=\"onRight && showCalendar\"\n    [selectedDate]=\"getDateToCalendar()\" (onSelectDate)=\"onSelectDate($event)\"></elo-calendar>", dependencies: [{ kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: CalendarComponent, selector: "elo-calendar", inputs: ["changeYear", "extraElement", "subtitles", "multiple", "selectedMultiple", "visible", "viewFormat", "show", "onTop", "onRight", "selectedDate", "locale", "updateCalendar"], outputs: ["onSelectDate", "onGenerateCalendar"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-datepicker', providers: [
                        { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: DatePickerComponent },
                        { provide: NG_VALIDATORS, multi: true, useValue: datePickerValidator }
                    ], template: "<input #input id=\"{{id}}_input\" type=\"text\" class=\"has-input-icon\" [(ngModel)]=\"value\" (click)=\"onClickInput()\"\n    [maxlength]=\"viewFormat.length\" (keydown)=\"onKeyDown($event)\" [disabled]=\"disable\" autocomplete=\"off\">\n<i class=\"fa fa-calendar input-icon\" aria-hidden=\"true\" (click)=\"onClickInput()\"></i>\n<elo-calendar #calendar [show]=\"showCalendar\" [onTop]=\"onTop\" [onRight]=\"onRight && showCalendar\"\n    [selectedDate]=\"getDateToCalendar()\" (onSelectDate)=\"onSelectDate($event)\"></elo-calendar>" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { viewFormat: [{
                type: Input
            }], modelFormat: [{
                type: Input
            }], id: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], disable: [{
                type: Input
            }] } });

class DatePickerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DatePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DatePickerModule, declarations: [DatePickerComponent], imports: [FormsModule, CalendarModule], exports: [DatePickerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DatePickerModule, imports: [FormsModule, CalendarModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DatePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, CalendarModule],
                    declarations: [DatePickerComponent],
                    exports: [DatePickerComponent]
                }]
        }] });

class CrudFormComponent {
    static { this.NEW_ID = 'new'; }
    constructor(activatedRoute, location, eloNotificationService, routerService, windowService) {
        this.activatedRoute = activatedRoute;
        this.location = location;
        this.eloNotificationService = eloNotificationService;
        this.routerService = routerService;
        this.windowService = windowService;
        this.caption = '';
        this.showFormButtons = true;
        this.callServiceFunction = null;
        this.onAttrEntity = new EventEmitter();
        this.onAttrBeforeEntity = new EventEmitter();
        this.onChangeState = new EventEmitter();
        this.useTemplate = false;
        this.enablePut = false;
        this.backOnSave = false;
        this.enableSecurityExit = false;
        // route usada na exclusão da carga de dados/back quando a tela esta embutida no modal
        this.routeOwner = '';
        this.forcePost = false;
        this.emitEvent = false;
        this.embedded = false;
        this.initializeDirty = false;
        this.ignorePreviousRoute = false;
        this.isInsertMode = true;
        this.showBackConfirm = false;
        this.formValid = true;
        this.handleException = (error) => { throw error; };
    }
    loadEntity(id) {
        if (this.sameRouteOwner && id && id !== CrudFormComponent.NEW_ID) {
            this.isInsertMode = false;
            let fn;
            if (this.callServiceFunction) {
                fn = this.callServiceFunction(id);
            }
            else {
                fn = this.entityService.findOne(id);
            }
            fn.subscribe(entity => this.attrEntity(entity));
        }
        else if (this.useTemplate) {
            AssertUtilsApp.assert(this.entityService.newTemplate, 'entity service newTemplate not found');
            this.entityService.newTemplate().subscribe(template => this.attrEntityUseTemplate(template));
        }
    }
    attrEntityUseTemplate(entity) {
        this.attrEntity(entity);
        if (this.initializeDirty) {
            this.form.markAsDirty();
        }
    }
    attrEntity(entity) {
        this.form.reset(entity, { emitEvent: this.emitEvent });
        this.onAttrEntity.emit(entity);
        this.beforeEditEntity = deepCopy(entity);
        this.onAttrBeforeEntity.emit(this.beforeEditEntity);
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.entityService, 'entity service');
        AssertUtilsApp.assert(this.form, 'form');
        this.sameRouteOwner = this.isSameRouteOwner();
        if (this.embedded) {
            AssertUtilsApp.assert(this.embeddedEntityId, 'embeddedEntityId must be set');
            this.loadEntity(this.embeddedEntityId);
        }
        else {
            this.loadEntity(this.activatedRoute.snapshot.params['id']);
        }
        this.subscribeRequestSave();
        if (this.requestBack) {
            this.requestBack.subscribe(() => this.back());
        }
        this.form.statusChanges.subscribe(status => this.formValid = status === 'VALID');
    }
    subscribeRequestSave() {
        if (this.requestSave) {
            this.requestSave.subscribe(() => {
                if (!this.form.pristine) {
                    this.save(this.form.getRawValue());
                }
            });
        }
    }
    attrEntityAfterSave(entity) {
        if (this.embedded) {
            this.embeddedBack();
        }
        else {
            if (this.isInsertMode && !this.backOnSave && this.sameRouteOwner) {
                this.location.replaceState(this.location.path(true).replace('new', encodeURIComponent(entity.id)));
            }
            this.isInsertMode = false;
            this.onChangeState.emit(this.isInsertMode);
            const entityToAttr = entity ? entity : this.form.value;
            this.attrEntity(entityToAttr);
            this.eloNotificationService.success(this.caption, 'Salvo(a) com sucesso', this.routeOwner);
            if (this.backOnSave && this.sameRouteOwner) {
                this.back();
            }
        }
    }
    save(entityToSave) {
        if (this.form.invalid) {
            return;
        }
        if (!this.isInsertMode && !this.forcePost) {
            if (this.form.pristine) {
                this.attrEntityAfterSave(entityToSave);
            }
            else if (this.enablePut) {
                this.isDisabled = true;
                this.entityService.put(entityToSave.id, JsonUtil.removeNullKeys(entityToSave)).
                    pipe(finalize(() => this.isDisabled = false)).subscribe(entity => this.attrEntityAfterSave(entity), error => this.handleException(error));
            }
            else {
                this.isDisabled = true;
                this.entityService.patch(entityToSave.id, JsonPatchUtil.compare(JsonUtil.removeNullKeys(this.beforeEditEntity), JsonUtil.removeNullKeys(entityToSave))).
                    pipe(finalize(() => this.isDisabled = false))
                    .subscribe(entity => this.attrEntityAfterSave(entity), error => this.handleException(error));
            }
        }
        else {
            this.isDisabled = true;
            this.entityService.post(JsonUtil.removeNullKeys(entityToSave)).
                pipe(finalize(() => this.isDisabled = false)).subscribe(entity => this.attrEntityAfterSave(entity), error => this.handleException(error));
        }
    }
    embeddedBack() {
        if (this.embeddedOnClose) {
            this.embeddedOnClose();
        }
    }
    back() {
        if (this.routerService.getPreviousRoute() && !this.ignorePreviousRoute) {
            this.location.back();
        }
        else {
            const urlList = this.location.path().split('/')[1];
            this.routerService.navigateByUrl(`/${urlList}`, this.navigationExtras);
        }
    }
    openSecurityAlert($event) {
        if (this.enableSecurityExit && !this.form.pristine) {
            $event.returnValue = true;
        }
    }
    isSameRouteOwner() {
        return this.windowService.getHref().includes(this.routeOwner);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormComponent, deps: [{ token: i1$4.ActivatedRoute }, { token: i1.Location }, { token: EloNotificationService }, { token: RouterService }, { token: WindowService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudFormComponent, selector: "elo-crudform", inputs: { caption: "caption", form: "form", showFormButtons: "showFormButtons", entityService: "entityService", callServiceFunction: "callServiceFunction", useTemplate: "useTemplate", enablePut: "enablePut", backOnSave: "backOnSave", requestSave: "requestSave", requestBack: "requestBack", requestUpdateBeforeEntity: "requestUpdateBeforeEntity", enableSecurityExit: "enableSecurityExit", routeOwner: "routeOwner", forcePost: "forcePost", emitEvent: "emitEvent", embedded: "embedded", embeddedEntityId: "embeddedEntityId", embeddedOnClose: "embeddedOnClose", initializeDirty: "initializeDirty", ignorePreviousRoute: "ignorePreviousRoute", navigationExtras: "navigationExtras", beforeEditEntity: "beforeEditEntity", handleException: "handleException" }, outputs: { onAttrEntity: "onAttrEntity", onAttrBeforeEntity: "onAttrBeforeEntity", onChangeState: "onChangeState" }, host: { listeners: { "window:beforeunload": "openSecurityAlert($event)" } }, ngImport: i0, template: "<back-confirm-component></back-confirm-component>\n<div>\n  <form [formGroup]=\"form\" autocomplete=\"off\" (ngSubmit)=\"save(form.getRawValue())\">\n    <input autocomplete=\"false\" name=\"hidden\" type=\"text\" style=\"display:none;\">\n    <ng-content select=\"[inputs]\"></ng-content>\n    <div id=\"buttons\" class=\"btn-save\" *ngIf=\"!embedded && showFormButtons\">\n      <button id=\"save\" class=\"btn positive\" [disabled]=\"isDisabled\"></button>\n    </div>\n    <div id=\"embeddedButtons\" class=\"align-group mt-xs mb-xs\" *ngIf=\"embedded && showFormButtons\">\n      <button id=\"btnEmbbededSave\" type=\"button\" class=\"btn positive inline icon-left\"\n        (click)=\"save(form.getRawValue())\">\n        <em class=\"fa fa-check\"></em>Adicionar\n      </button>\n\n      <button id=\"btnEmbeddedCancel\" type=\"button\" class=\"btn negative inline icon-right\" (click)=\"embeddedBack()\">\n        <em class=\"fa fa-times\"></em>Cancelar\n      </button>\n    </div>\n  </form>\n</div>", dependencies: [{ kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: BackConfirmComponent, selector: "back-confirm-component" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-crudform', template: "<back-confirm-component></back-confirm-component>\n<div>\n  <form [formGroup]=\"form\" autocomplete=\"off\" (ngSubmit)=\"save(form.getRawValue())\">\n    <input autocomplete=\"false\" name=\"hidden\" type=\"text\" style=\"display:none;\">\n    <ng-content select=\"[inputs]\"></ng-content>\n    <div id=\"buttons\" class=\"btn-save\" *ngIf=\"!embedded && showFormButtons\">\n      <button id=\"save\" class=\"btn positive\" [disabled]=\"isDisabled\"></button>\n    </div>\n    <div id=\"embeddedButtons\" class=\"align-group mt-xs mb-xs\" *ngIf=\"embedded && showFormButtons\">\n      <button id=\"btnEmbbededSave\" type=\"button\" class=\"btn positive inline icon-left\"\n        (click)=\"save(form.getRawValue())\">\n        <em class=\"fa fa-check\"></em>Adicionar\n      </button>\n\n      <button id=\"btnEmbeddedCancel\" type=\"button\" class=\"btn negative inline icon-right\" (click)=\"embeddedBack()\">\n        <em class=\"fa fa-times\"></em>Cancelar\n      </button>\n    </div>\n  </form>\n</div>" }]
        }], ctorParameters: () => [{ type: i1$4.ActivatedRoute }, { type: i1.Location }, { type: EloNotificationService }, { type: RouterService }, { type: WindowService }], propDecorators: { caption: [{
                type: Input
            }], form: [{
                type: Input,
                args: [{ required: true }]
            }], showFormButtons: [{
                type: Input
            }], entityService: [{
                type: Input
            }], callServiceFunction: [{
                type: Input
            }], onAttrEntity: [{
                type: Output
            }], onAttrBeforeEntity: [{
                type: Output
            }], onChangeState: [{
                type: Output
            }], useTemplate: [{
                type: Input
            }], enablePut: [{
                type: Input
            }], backOnSave: [{
                type: Input
            }], requestSave: [{
                type: Input
            }], requestBack: [{
                type: Input
            }], requestUpdateBeforeEntity: [{
                type: Input
            }], enableSecurityExit: [{
                type: Input
            }], routeOwner: [{
                type: Input
            }], forcePost: [{
                type: Input
            }], emitEvent: [{
                type: Input
            }], embedded: [{
                type: Input
            }], embeddedEntityId: [{
                type: Input
            }], embeddedOnClose: [{
                type: Input
            }], initializeDirty: [{
                type: Input
            }], ignorePreviousRoute: [{
                type: Input
            }], navigationExtras: [{
                type: Input
            }], beforeEditEntity: [{
                type: Input
            }], handleException: [{
                type: Input
            }], openSecurityAlert: [{
                type: HostListener,
                args: ['window:beforeunload', ['$event']]
            }] } });

const resolvePath = (object, path, defaultValue) => path
    .split('.')
    .reduce((o, p) => o ? o[p] : defaultValue, object);
class CrudFormDetailComponent {
    constructor(formBuilder, crudForm, crudFormDetail) {
        this.formBuilder = formBuilder;
        this.crudForm = crudForm;
        this.crudFormDetail = crudFormDetail;
        this.hideListWhenAdd = false;
        this.enableRemove = true;
        this.disableButtonNovo = false;
        this.disableButtonSalvar = false;
        this.panelExpansive = true;
        this.nameBtnSave = 'Adicionar';
        this.visibleWhenFunction = null;
        this.hasLinks = false;
        this.getLinks = null;
        this.beforeSave = null;
        this.visibleWhenFunctionLink = null;
        this.manyActions = false;
        this.quickView = false;
        this.hideButtonNovo = false;
        this.hideButtonUpdate = false;
        this.alwaysShowForm = false;
        this.btnSaveHasFormGroup = false;
        this.isInsideTab = false;
        this.showButtonCancelar = true;
        this.emitEvent = true;
        this.onModifySelection = new EventEmitter();
        this.onChangeValue = new EventEmitter();
        this.onAttrEntity = new EventEmitter();
        this.onGrandChildrenEntity = new EventEmitter();
        this.afterSave = new EventEmitter();
        this.onResetEntity = new EventEmitter();
        this.onView = new EventEmitter();
        this.onIconClicked = new EventEmitter();
        this.showForm = false;
        this.showDelete = false;
        this.indexEdit = -1;
        this.objArrayValues = [];
        this.onEditIndex = (index) => -1;
    }
    ngOnInit() {
        this.reset();
        if (this.crudFormDetail) {
            this.crudFormDetail.onAttrEntity.subscribe(entity => {
                this.loadFormArray(resolvePath(entity, this.arrayPropertyName, []), this.formArray);
            });
            this.crudFormDetail.onGrandChildrenEntity.subscribe(data => {
                this.loadFormArray(resolvePath(data.entity, this.arrayPropertyName, []), data.formGroup.get(this.arrayPropertyName));
            });
            this.crudFormDetail.onResetEntity.subscribe(() => {
                this.loadFormArray([], this.formArray);
            });
        }
        else {
            this.crudForm.onAttrEntity.subscribe(entity => {
                this.loadFormArray(resolvePath(entity, this.arrayPropertyName, []), this.formArray);
            });
        }
    }
    ngAfterContentInit() {
        this.eloTableActions.forEach(tb => this.dataTable.addTableActions(tb));
    }
    onDelete(itemToRemove) {
        this.itemToRemove = itemToRemove;
        this.showDelete = true;
    }
    cancelDelete() {
        this.showDelete = false;
    }
    delete() {
        this.showDelete = false;
        let index = this.formArray.value.indexOf(this.itemToRemove);
        this.formArray.removeAt(index);
        this.formArray.markAsDirty();
        if (this.onChangeValue)
            this.onChangeValue.emit(this.formArray);
    }
    save() {
        if (this.beforeSave)
            this.beforeSave();
        if (this.indexEdit >= 0) {
            let formGroup = this.formArray.at(this.indexEdit);
            formGroup.reset(this.form.value);
            this.objArrayValues[this.indexEdit] = this.form.value;
            this.onGrandChildrenEntity.emit({ formGroup: formGroup, entity: this.form.value });
        }
        else {
            let formGroup = this.formCreate();
            formGroup.reset(this.form.value);
            this.formArray.push(formGroup);
            this.objArrayValues.push(this.form.value);
            this.onGrandChildrenEntity.emit({ entity: this.form.value, formGroup: formGroup });
        }
        if (this.afterSave)
            this.afterSave.emit(this.form.value);
        this.reset();
        this.formArray.markAsDirty();
        this.formArray.updateValueAndValidity();
        if (this.onChangeValue)
            this.onChangeValue.emit(this.formArray);
    }
    cancel() {
        this.reset();
    }
    editItem(item) {
        this.indexEdit = this.formArray.value.indexOf(item);
        this.onEditIndex(this.indexEdit);
        this.form.reset(this.formArray.at(this.indexEdit).value, { emitEvent: this.emitEvent });
        this.showForm = true;
        this.onAttrEntity.emit(this.objArrayValues[this.indexEdit]);
    }
    reset() {
        this.form.reset(this.formCreate().value, { emitEvent: false });
        this.indexEdit = -1;
        this.showForm = false;
        this.onEditIndex(this.indexEdit);
    }
    newItem() {
        this.reset();
        this.onResetEntity.emit();
        this.showForm = true;
    }
    get formArray() {
        if (this.crudFormDetail) {
            return this.crudFormDetail.form.get(this.arrayPropertyName);
        }
        return this.crudForm.form.get(this.arrayPropertyName);
    }
    onClickView(obj) {
        this.onView.emit(obj);
        this.onEditIndex(this.formArray.value.indexOf(obj));
    }
    onClickLink(object) {
        this.onIconClicked.emit(object);
    }
    clickSelect(selection) {
        this.onModifySelection.emit(selection);
    }
    loadFormArray(objArray, formArray) {
        this.objArrayValues = objArray;
        if (this.objArrayValues) {
            while (formArray.length > 0) {
                formArray.removeAt(0);
            }
            this.objArrayValues.forEach(obj => {
                let form = this.formCreate();
                this.onGrandChildrenEntity.emit({ entity: obj, formGroup: form });
                form.reset(obj, { emitEvent: false });
                formArray.push(form);
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormDetailComponent, deps: [{ token: i1$2.UntypedFormBuilder }, { token: CrudFormComponent }, { token: CrudFormDetailComponent, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudFormDetailComponent, selector: "crud-form-detail", inputs: { caption: "caption", form: "form", fieldsToDisplay: "fieldsToDisplay", formCreate: "formCreate", hideButtonNovoAndUpdate: "hideButtonNovoAndUpdate", hideButtonRemove: "hideButtonRemove", hideListWhenAdd: "hideListWhenAdd", arrayPropertyName: "arrayPropertyName", enableRemove: "enableRemove", disableButtonNovo: "disableButtonNovo", disableButtonSalvar: "disableButtonSalvar", panelExpansive: "panelExpansive", nameBtnSave: "nameBtnSave", visibleWhenFunction: "visibleWhenFunction", hasLinks: "hasLinks", getLinks: "getLinks", beforeSave: "beforeSave", visibleWhenFunctionLink: "visibleWhenFunctionLink", manyActions: "manyActions", quickView: "quickView", selectionMode: "selectionMode", selection: "selection", hideButtonNovo: "hideButtonNovo", hideButtonUpdate: "hideButtonUpdate", alwaysShowForm: "alwaysShowForm", extraButtons: "extraButtons", btnSaveHasFormGroup: "btnSaveHasFormGroup", isInsideTab: "isInsideTab", showButtonCancelar: "showButtonCancelar", emitEvent: "emitEvent", onEditIndex: "onEditIndex" }, outputs: { onModifySelection: "onModifySelection", onChangeValue: "onChangeValue", onAttrEntity: "onAttrEntity", onGrandChildrenEntity: "onGrandChildrenEntity", afterSave: "afterSave", onResetEntity: "onResetEntity", onView: "onView", onIconClicked: "onIconClicked" }, queries: [{ propertyName: "eloColumnsTemplate", first: true, predicate: ["eloColumns"], descendants: true }, { propertyName: "eloTableActions", predicate: EloTableActionsComponent, descendants: true }], viewQueries: [{ propertyName: "dataTable", first: true, predicate: EloDatatableComponent, descendants: true, static: true }], ngImport: i0, template: "<elo-dialog [show]=\"showDelete\" (onOkEvent)=\"delete()\" (onCancelEvent)=\"cancelDelete()\">\n  Apagar?\n</elo-dialog>\n\n<elo-panel-expansive [expansive]=\"panelExpansive\" title=\"{{caption}}\" [disabledButton]=\"disableButtonNovo\" [isInsideTab]=\"isInsideTab\"\n  (onNewItem)=\"newItem()\" [showButton]=\"!showForm && !hideButtonNovoAndUpdate\" [hideButtonNovo]=\"hideButtonNovo\"\n  [extraButtons]=\"extraButtons\">\n\n  <div *ngIf=\"showForm || alwaysShowForm\">\n\n    <ng-content select=\"[inputs]\"></ng-content>\n\n    <div class=\"align-group mt-xs mb-xs\">\n      <button id=\"btnSave\" type=\"button\" class=\"btn positive inline icon-left\" (click)=\"save()\"\n        [disabled]=\"(!form.valid || form.pristine) || disableButtonSalvar\" *ngIf=\"!btnSaveHasFormGroup; else formGroupSave\">\n        <em class=\"fa fa-check\"></em>\n        {{nameBtnSave}}\n      </button>\n\n      <ng-template #formGroupSave>\n        <div class=\"form-group\">\n          <button id=\"btnSave\" type=\"button\" class=\"btn positive inline icon-left\" (click)=\"save()\"\n                  [disabled]=\"(!form.valid || form.pristine) || disableButtonSalvar\">\n                  <em class=\"fa fa-check\"></em>\n                  {{nameBtnSave}}\n          </button>\n        </div>\n      </ng-template>\n\n      <button id=\"btnCancel\" type=\"button\" class=\"btn negative inline icon-right\" (click)=\"cancel()\" \n        *ngIf=\"(!alwaysShowForm || (indexEdit !== null && indexEdit >= 0)) && showButtonCancelar\">\n        <em class=\"fa fa-times\"></em>\n        Cancelar\n      </button>\n    </div>\n\n  </div>\n\n  <ng-content select=\"[tableArea]\"></ng-content>\n\n  <div id=\"hiddenDataTable\" style=\"padding-right: 7px;padding-left: 7px\" [hidden]=\"showForm && hideListWhenAdd\">\n    <elo-datatable [values]=\"formArray?.value\" class=\"border striped\" [manyActions]=\"manyActions\"\n      [selectionMode]=\"selectionMode\" (onModifySelection)=\"clickSelect($event)\" [selection]=\"selection\"\n      [isQuickViewOpener]=\"quickView\">\n      <ng-container *ngIf=\"!eloColumnsTemplate\">\n        <elo-column *ngFor=\"let field of fieldsToDisplay\" [field]=\"field.field\" [header]=\"field.header\"\n          [hidden]=\"field.hidden\" [isDecimal]=\"field.isDecimal\" [digits]=\"field.digits\" [isDate]=\"field.isDate\">\n        </elo-column>\n      </ng-container>\n      <ng-container *ngIf=\"eloColumnsTemplate\" [ngTemplateOutlet]=\"eloColumnsTemplate\"\n        [ngTemplateOutletContext]=\"{dataTable: dataTable, fieldsModels: fieldsToDisplay}\">\n      </ng-container>\n      <elo-table-actions [title]=\"'Editar'\" icon='fa fa-pencil' [visible]=\"!hideButtonNovoAndUpdate && !hideButtonUpdate\"\n        [visibleWhenFunction]=\"visibleWhenFunction\" (onClickIconButton)=\"editItem($event)\"></elo-table-actions>\n      <elo-table-actions [title]=\"'Excluir'\" icon='fa fa-trash' [visible]=\"enableRemove\"\n        [visibleWhenFunction]=\"visibleWhenFunction\" (onClickIconButton)=\"onDelete($event)\"></elo-table-actions>\n      <elo-table-actions *ngIf=\"quickView\" [title]=\"'Visualizar'\" icon='fa fa-eye' id=\"idView\"\n        (onClickIconButton)=\"onClickView($event)\">\n      </elo-table-actions>\n      <elo-table-actions [visibleWhenFunction]=\"visibleWhenFunctionLink\" icon='fa fa-list-ul' id=\"idLinks\"\n        (onClickLink)=\"onClickLink($event)\" [linksFunction]=\"getLinks\" [hasLinks]=\"hasLinks\" *ngIf=\"hasLinks\">\n      </elo-table-actions>\n      <ng-content select=\"[actions]\"></ng-content>\n\n    </elo-datatable>\n  </div>\n</elo-panel-expansive>\n", dependencies: [{ kind: "component", type: DialogComponent, selector: "elo-dialog", inputs: ["show", "showCancel", "classType", "tittleCancel", "tittleOk", "title", "disableOkButton", "debounceTime"], outputs: ["onOkEvent", "onCancelEvent"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: EloDatatableComponent, selector: "elo-datatable", inputs: ["values", "paramExpandTemplate", "emptyMessage", "selection", "selectionMode", "selectionModeId", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "titleCheckboxDisallowed", "sortable", "pageParameters", "class", "colSpanActions", "isQuickViewOpener", "manyActions", "classEmptyMessage", "rowDoubleClickFunction", "visibleRadioWhenFunction", "enableScrollX", "textTransform", "headerFixo", "showHeader", "selectionModeWithFooter"], outputs: ["onClickCheckbox", "onClickRadioButton", "onSelectOne", "onModifySelection", "onTableHeadClick", "onInputChange", "onRowDoubleClick"] }, { kind: "component", type: EloColumnComponent, selector: "elo-column", inputs: ["field", "header", "headerAlign", "isDecimal", "isPercentual", "digits", "isDate", "isDateTime", "isCnpjCpf", "enumOptions", "col", "class", "isEditable", "isEditing", "dataTable", "hidden", "hiddenTableData", "sortable", "samp", "headerStyle", "dataStyle"] }, { kind: "component", type: EloTableActionsComponent, selector: "elo-table-actions", inputs: ["showError", "hasLinks", "links", "linksFunction", "quickViewOpener", "removeAutoFocus"], outputs: ["onClickLink", "onClickIconButton", "onHoverIconButton"] }, { kind: "component", type: PanelExpansiveComponent, selector: "elo-panel-expansive", inputs: ["collapsed", "title", "hasTable", "hasForm", "expansive", "showButton", "disabledButton", "hideButtonNovo", "titleButtonNovo", "extraButtons", "enableScrollX", "isInsideTab", "collapsedCookie", "error"], outputs: ["onExpand", "onNewItem"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'crud-form-detail', template: "<elo-dialog [show]=\"showDelete\" (onOkEvent)=\"delete()\" (onCancelEvent)=\"cancelDelete()\">\n  Apagar?\n</elo-dialog>\n\n<elo-panel-expansive [expansive]=\"panelExpansive\" title=\"{{caption}}\" [disabledButton]=\"disableButtonNovo\" [isInsideTab]=\"isInsideTab\"\n  (onNewItem)=\"newItem()\" [showButton]=\"!showForm && !hideButtonNovoAndUpdate\" [hideButtonNovo]=\"hideButtonNovo\"\n  [extraButtons]=\"extraButtons\">\n\n  <div *ngIf=\"showForm || alwaysShowForm\">\n\n    <ng-content select=\"[inputs]\"></ng-content>\n\n    <div class=\"align-group mt-xs mb-xs\">\n      <button id=\"btnSave\" type=\"button\" class=\"btn positive inline icon-left\" (click)=\"save()\"\n        [disabled]=\"(!form.valid || form.pristine) || disableButtonSalvar\" *ngIf=\"!btnSaveHasFormGroup; else formGroupSave\">\n        <em class=\"fa fa-check\"></em>\n        {{nameBtnSave}}\n      </button>\n\n      <ng-template #formGroupSave>\n        <div class=\"form-group\">\n          <button id=\"btnSave\" type=\"button\" class=\"btn positive inline icon-left\" (click)=\"save()\"\n                  [disabled]=\"(!form.valid || form.pristine) || disableButtonSalvar\">\n                  <em class=\"fa fa-check\"></em>\n                  {{nameBtnSave}}\n          </button>\n        </div>\n      </ng-template>\n\n      <button id=\"btnCancel\" type=\"button\" class=\"btn negative inline icon-right\" (click)=\"cancel()\" \n        *ngIf=\"(!alwaysShowForm || (indexEdit !== null && indexEdit >= 0)) && showButtonCancelar\">\n        <em class=\"fa fa-times\"></em>\n        Cancelar\n      </button>\n    </div>\n\n  </div>\n\n  <ng-content select=\"[tableArea]\"></ng-content>\n\n  <div id=\"hiddenDataTable\" style=\"padding-right: 7px;padding-left: 7px\" [hidden]=\"showForm && hideListWhenAdd\">\n    <elo-datatable [values]=\"formArray?.value\" class=\"border striped\" [manyActions]=\"manyActions\"\n      [selectionMode]=\"selectionMode\" (onModifySelection)=\"clickSelect($event)\" [selection]=\"selection\"\n      [isQuickViewOpener]=\"quickView\">\n      <ng-container *ngIf=\"!eloColumnsTemplate\">\n        <elo-column *ngFor=\"let field of fieldsToDisplay\" [field]=\"field.field\" [header]=\"field.header\"\n          [hidden]=\"field.hidden\" [isDecimal]=\"field.isDecimal\" [digits]=\"field.digits\" [isDate]=\"field.isDate\">\n        </elo-column>\n      </ng-container>\n      <ng-container *ngIf=\"eloColumnsTemplate\" [ngTemplateOutlet]=\"eloColumnsTemplate\"\n        [ngTemplateOutletContext]=\"{dataTable: dataTable, fieldsModels: fieldsToDisplay}\">\n      </ng-container>\n      <elo-table-actions [title]=\"'Editar'\" icon='fa fa-pencil' [visible]=\"!hideButtonNovoAndUpdate && !hideButtonUpdate\"\n        [visibleWhenFunction]=\"visibleWhenFunction\" (onClickIconButton)=\"editItem($event)\"></elo-table-actions>\n      <elo-table-actions [title]=\"'Excluir'\" icon='fa fa-trash' [visible]=\"enableRemove\"\n        [visibleWhenFunction]=\"visibleWhenFunction\" (onClickIconButton)=\"onDelete($event)\"></elo-table-actions>\n      <elo-table-actions *ngIf=\"quickView\" [title]=\"'Visualizar'\" icon='fa fa-eye' id=\"idView\"\n        (onClickIconButton)=\"onClickView($event)\">\n      </elo-table-actions>\n      <elo-table-actions [visibleWhenFunction]=\"visibleWhenFunctionLink\" icon='fa fa-list-ul' id=\"idLinks\"\n        (onClickLink)=\"onClickLink($event)\" [linksFunction]=\"getLinks\" [hasLinks]=\"hasLinks\" *ngIf=\"hasLinks\">\n      </elo-table-actions>\n      <ng-content select=\"[actions]\"></ng-content>\n\n    </elo-datatable>\n  </div>\n</elo-panel-expansive>\n" }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }, { type: CrudFormComponent }, { type: CrudFormDetailComponent, decorators: [{
                    type: SkipSelf
                }, {
                    type: Optional
                }] }], propDecorators: { caption: [{
                type: Input
            }], form: [{
                type: Input
            }], fieldsToDisplay: [{
                type: Input
            }], formCreate: [{
                type: Input
            }], hideButtonNovoAndUpdate: [{
                type: Input
            }], hideButtonRemove: [{
                type: Input
            }], hideListWhenAdd: [{
                type: Input
            }], arrayPropertyName: [{
                type: Input
            }], enableRemove: [{
                type: Input
            }], disableButtonNovo: [{
                type: Input
            }], disableButtonSalvar: [{
                type: Input
            }], panelExpansive: [{
                type: Input
            }], nameBtnSave: [{
                type: Input
            }], visibleWhenFunction: [{
                type: Input
            }], hasLinks: [{
                type: Input
            }], getLinks: [{
                type: Input
            }], beforeSave: [{
                type: Input
            }], visibleWhenFunctionLink: [{
                type: Input
            }], manyActions: [{
                type: Input
            }], quickView: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], selection: [{
                type: Input
            }], hideButtonNovo: [{
                type: Input
            }], hideButtonUpdate: [{
                type: Input
            }], alwaysShowForm: [{
                type: Input
            }], extraButtons: [{
                type: Input
            }], btnSaveHasFormGroup: [{
                type: Input
            }], isInsideTab: [{
                type: Input
            }], showButtonCancelar: [{
                type: Input
            }], emitEvent: [{
                type: Input
            }], onModifySelection: [{
                type: Output
            }], onChangeValue: [{
                type: Output
            }], onAttrEntity: [{
                type: Output
            }], onGrandChildrenEntity: [{
                type: Output
            }], afterSave: [{
                type: Output
            }], onResetEntity: [{
                type: Output
            }], onView: [{
                type: Output
            }], onIconClicked: [{
                type: Output
            }], eloColumnsTemplate: [{
                type: ContentChild,
                args: ['eloColumns']
            }], eloTableActions: [{
                type: ContentChildren,
                args: [EloTableActionsComponent, { descendants: true }]
            }], dataTable: [{
                type: ViewChild,
                args: [EloDatatableComponent, { static: true }]
            }], onEditIndex: [{
                type: Input
            }] } });

class CrudFormDetailModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormDetailModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudFormDetailModule, declarations: [CrudFormDetailComponent], imports: [FormsModule, ReactiveFormsModule, DialogModule, EloDatatableModule, PanelExpansiveModule], exports: [CrudFormDetailComponent, FormsModule, ReactiveFormsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormDetailModule, imports: [FormsModule, ReactiveFormsModule, DialogModule, EloDatatableModule, PanelExpansiveModule, FormsModule, ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormDetailModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, ReactiveFormsModule, DialogModule, EloDatatableModule, PanelExpansiveModule],
                    declarations: [CrudFormDetailComponent],
                    exports: [CrudFormDetailComponent, FormsModule, ReactiveFormsModule]
                }]
        }] });

class CamposDinamicosModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosModule, declarations: [CamposDinamicosComponent,
            CamposDinamicosRespostasComponent,
            CamposDinamicosViewComponent], imports: [FormControlValidationMsgModule,
            PanelModule,
            FormLabelColumnModule,
            FormsModule,
            DatePickerModule,
            EloDatatableModule,
            CrudFormDetailModule,
            DialogModule,
            PanelExpansiveModule,
            ReactiveFormsModule,
            DirectivesModule,
            CommonModule], exports: [CamposDinamicosComponent, CamposDinamicosViewComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosModule, imports: [FormControlValidationMsgModule,
            PanelModule,
            FormLabelColumnModule,
            FormsModule,
            DatePickerModule,
            EloDatatableModule,
            CrudFormDetailModule,
            DialogModule,
            PanelExpansiveModule,
            ReactiveFormsModule,
            DirectivesModule,
            CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CamposDinamicosModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormControlValidationMsgModule,
                        PanelModule,
                        FormLabelColumnModule,
                        FormsModule,
                        DatePickerModule,
                        EloDatatableModule,
                        CrudFormDetailModule,
                        DialogModule,
                        PanelExpansiveModule,
                        ReactiveFormsModule,
                        DirectivesModule,
                        CommonModule,
                    ],
                    declarations: [
                        CamposDinamicosComponent,
                        CamposDinamicosRespostasComponent,
                        CamposDinamicosViewComponent,
                    ],
                    exports: [CamposDinamicosComponent, CamposDinamicosViewComponent],
                }]
        }] });

class ChipComponent {
    constructor() {
        this.isCenter = true;
        this.iconPosition = 'left';
        this.chipIcon = '';
    }
    center() {
        return this.isCenter ? ' center' : '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ChipComponent, selector: "chip-component", inputs: { col: "col", text: "text", className: "className", isCenter: "isCenter", iconPosition: "iconPosition", chipIcon: "chipIcon" }, ngImport: i0, template: `
    <div class="col-md-{{col}}">
      <div class="chip-container {{className + center()}} ">
        <span class="{{chipIcon}} chip-icon-{{iconPosition}}"></span>
        <p class="chip-text">{{text}}</p>
      </div>
    </div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChipComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'chip-component',
                    template: `
    <div class="col-md-{{col}}">
      <div class="chip-container {{className + center()}} ">
        <span class="{{chipIcon}} chip-icon-{{iconPosition}}"></span>
        <p class="chip-text">{{text}}</p>
      </div>
    </div>
  `
                }]
        }], propDecorators: { col: [{
                type: Input
            }], text: [{
                type: Input
            }], className: [{
                type: Input
            }], isCenter: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], chipIcon: [{
                type: Input
            }] } });

class ChipModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ChipModule, declarations: [ChipComponent], exports: [ChipComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChipModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ChipComponent,
                    ],
                    exports: [
                        ChipComponent
                    ]
                }]
        }] });

class RolesCache {
    static { this.roles = []; }
    static { this.isLoaded = new BehaviorSubject(false); }
    static create(userRoles) {
        if (userRoles.length && userRoles.length !== 0) {
            this.roles = userRoles.map(role => role.name);
            this.isLoaded.next(true);
        }
        else {
            this.isLoaded.next(false);
        }
    }
    static getAllRoles() {
        if (this.roles.length) {
            return this.roles;
        }
        return [];
    }
}

const initOptions = {
    onLoad: 'login-required'
};
class KeycloakAuthHttp {
    static { this._userInfoPromise = null; }
    constructor(_httpClient, _keycloakAuthResourceConfig, authParams) {
        this._httpClient = _httpClient;
        this._keycloakAuthResourceConfig = _keycloakAuthResourceConfig;
        this.authParams = authParams;
        if (!KeycloakAuthHttp._keycloak) {
            KeycloakAuthHttp._keycloak = new Keycloak(`/painel-api/api/auth/realm-config/${this._keycloakAuthResourceConfig.resource}`);
        }
    }
    getUsuario() {
        return this.getUser();
    }
    isLogged() {
        return KeycloakAuthHttp._keycloak.authenticated;
    }
    hasPermissionByRoute(route) {
        const permissions = this._keycloakAuthResourceConfig.permissions;
        if (!route || !permissions || !permissions.length) {
            return of(true);
        }
        const searchRoute = route.startsWith('/') ? route.replace('/', '') : route;
        const permissaoRota = permissions.find(p => p.route === searchRoute);
        return new Observable(subscriber => {
            RolesCache.isLoaded.subscribe(isLoaded => {
                if (isLoaded) {
                    subscriber.next(permissaoRota &&
                        RolesCache.getAllRoles().includes(permissaoRota.role));
                }
            });
        });
    }
    getPermissionsByRole(role) {
        return of(RolesCache.getAllRoles().filter((roleUsuario) => roleUsuario.toUpperCase().startsWith(role.toUpperCase())));
    }
    logoutAndGoToAuthForm() {
        KeycloakAuthHttp._keycloak.logout();
    }
    getUsuarioLogado() {
        this.getUser().then(usuario => {
            return usuario;
        });
    }
    getUser() {
        if (!KeycloakAuthHttp._userInfoPromise) {
            KeycloakAuthHttp._userInfoPromise = new Promise(resolve => {
                return KeycloakAuthHttp._keycloak.loadUserInfo()
                    .then(userInfo => {
                    resolve(userInfo);
                });
            });
        }
        return KeycloakAuthHttp._userInfoPromise;
    }
    getToken() {
        return KeycloakAuthHttp._keycloak.token;
    }
    refreshToken() {
        return new Promise((resolve, reject) => {
            KeycloakAuthHttp._keycloak
                .updateToken(5)
                .then(refreshed => {
                resolve(refreshed);
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    getTokenParsed() {
        return KeycloakAuthHttp._keycloak.tokenParsed;
    }
    getRealm() {
        return KeycloakAuthHttp._keycloak.realm;
    }
    getEntidade() {
        return (KeycloakAuthHttp._keycloak.idTokenParsed &&
            KeycloakAuthHttp._keycloak.idTokenParsed['entidade']);
    }
    getExercicio() {
        return (KeycloakAuthHttp._keycloak.idTokenParsed &&
            KeycloakAuthHttp._keycloak.idTokenParsed['exercicio']);
    }
    init(options = initOptions) {
        return new Promise((resolve, reject) => {
            KeycloakAuthHttp._keycloak
                .init(options)
                .then((authenticated) => {
                if (authenticated) {
                    resolve(authenticated);
                }
                else {
                    reject();
                }
            }).catch(error => reject(error));
        });
    }
    getModulos() {
        let httpHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.getToken()}`,
            'x-tenant-host': window.location.host
        });
        return this._httpClient.get(`${KeycloakAuthHttp.getAuthUrl()}/usuario/me/modulos`, {
            headers: httpHeader
        });
    }
    getUserProfile() {
        return KeycloakAuthHttp._keycloak.loadUserProfile();
    }
    sobrescreverAttributos(attributes) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.getToken()}`,
            'x-tenant-host': window.location.host
        });
        return this._httpClient.put(`${KeycloakAuthHttp.getAuthUrl()}/usuario/me/attributes`, attributes, { headers });
    }
    isAdmin() {
        throw new Error('Method not implemented.');
    }
    setUsuarioInfo(userInfo) {
        Cookie.set('DATA_OPERACAO', JSON.stringify(userInfo.dataOperacao), 1, '/', window.location.hostname);
        this.authParams.setUsuarioInfo(userInfo);
    }
    getUsuarioInfo() {
        return this.authParams.getUsuarioInfo();
    }
    findAllEntidadesByUsuario(idUsuario) {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.getToken()}`,
            'x-tenant-host': window.location.host
        });
        return this._httpClient.get(`${KeycloakAuthHttp.getAuthUrl()}/usuario/${idUsuario}/entidades`, { headers });
    }
    static getAuthUrl() {
        return `${KeycloakAuthHttp._keycloak.authServerUrl}/realms/${KeycloakAuthHttp._keycloak.realm}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KeycloakAuthHttp, deps: [{ token: i1$1.HttpClient }, { token: KEYCLOAK_AUTH_RESOURCES_CONFIG }, { token: AuthParams }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KeycloakAuthHttp }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KeycloakAuthHttp, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [KEYCLOAK_AUTH_RESOURCES_CONFIG]
                }] }, { type: AuthParams }] });

class ConsultaDinamicaComponent {
    constructor(_keycloak, _breadcrumbIframe, section) {
        this._keycloak = _keycloak;
        this._breadcrumbIframe = _breadcrumbIframe;
        this.section = section;
        this.altura = '80vh';
        this._breadcrumbIframe.createBreadcrumb(this.section);
    }
    ngOnInit() {
        this.entidade = this._keycloak.getUsuarioInfo().entidadePadrao.id;
        this.competenciaAtual = this._keycloak.getUsuarioInfo().mesPadrao;
        this.exercicio = this._keycloak.getUsuarioInfo().exercicioPadrao;
        const origin = WindowService.getWindow().location.origin;
        if (!this.url) {
            this.url = `${origin}/unico/consulta-de-dados-dinamica?iframe=true&modulo=${this.modulo}&entidadeId=${this.entidade}&exercicio=${this.exercicio}&competencia=${this.competenciaAtual}`;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConsultaDinamicaComponent, deps: [{ token: KeycloakAuthHttp }, { token: BreadcrumbIframeService }, { token: SectionComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ConsultaDinamicaComponent, selector: "consulta-dinamica", inputs: { modulo: "modulo", altura: "altura", url: "url" }, ngImport: i0, template: "<div [ngStyle]=\"{'height': altura}\">\n  <iframe [src]=\"url | safe\" *ngIf=\"url\" id=\"iframe\"></iframe>\n</div>\n", styles: ["#iframe{width:100%;height:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: SafeUrlPipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConsultaDinamicaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'consulta-dinamica', template: "<div [ngStyle]=\"{'height': altura}\">\n  <iframe [src]=\"url | safe\" *ngIf=\"url\" id=\"iframe\"></iframe>\n</div>\n", styles: ["#iframe{width:100%;height:100%}\n"] }]
        }], ctorParameters: () => [{ type: KeycloakAuthHttp }, { type: BreadcrumbIframeService }, { type: SectionComponent }], propDecorators: { modulo: [{
                type: Input
            }], altura: [{
                type: Input
            }], url: [{
                type: Input
            }] } });

class ConsultaDinamicaModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConsultaDinamicaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ConsultaDinamicaModule, declarations: [ConsultaDinamicaComponent], imports: [CommonModule, PipeModule], exports: [ConsultaDinamicaComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConsultaDinamicaModule, providers: [WindowService, BreadcrumbIframeService], imports: [CommonModule, PipeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConsultaDinamicaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PipeModule],
                    declarations: [ConsultaDinamicaComponent],
                    exports: [ConsultaDinamicaComponent],
                    providers: [WindowService, BreadcrumbIframeService]
                }]
        }] });

class CrudButtonsComponent {
    constructor() {
        this.backEventEmitter = new EventEmitter();
    }
    back() {
        this.backEventEmitter.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudButtonsComponent, selector: "crud-buttons-component", inputs: { form: "form" }, outputs: { backEventEmitter: "backEventEmitter" }, ngImport: i0, template: "<div id=\"buttons\" class=\"btn-save\">\n  <button id=\"save\" class=\"btn positive\" [disabled]=\"!form.valid || form.pristine\"></button>\n\n  <button id=\"back\" class=\"btn other fa fa-chevron-left\" type=\"button\" (click)=\"back()\">\n  </button>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'crud-buttons-component', template: "<div id=\"buttons\" class=\"btn-save\">\n  <button id=\"save\" class=\"btn positive\" [disabled]=\"!form.valid || form.pristine\"></button>\n\n  <button id=\"back\" class=\"btn other fa fa-chevron-left\" type=\"button\" (click)=\"back()\">\n  </button>\n</div>\n" }]
        }], propDecorators: { backEventEmitter: [{
                type: Output
            }], form: [{
                type: Input
            }] } });

class CrudButtonsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsModule, declarations: [CrudButtonsComponent], imports: [DialogModule], exports: [CrudButtonsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsModule, imports: [DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        DialogModule
                    ],
                    declarations: [
                        CrudButtonsComponent
                    ],
                    exports: [
                        CrudButtonsComponent
                    ]
                }]
        }] });

class CrudButtonsOperationsComponent {
    constructor() {
        this.showDelete = false;
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.onClose, 'onClose event');
        AssertUtilsApp.assert(this.form, 'form');
        AssertUtilsApp.assert(this.service, 'service');
        this.attrValues();
    }
    cancel() {
        this.onClose.emit();
    }
    save() {
        this.service.postOrPatch(this.form.value, this.beforeValue).subscribe(() => this.onClose.emit());
    }
    delete() {
        this.showDelete = true;
    }
    onOkdelete() {
        this.service.remove(this.beforeValue.id).subscribe(() => this.onClose.emit());
        this.showDelete = false;
    }
    onCancelDelete() {
        this.showDelete = false;
    }
    attrValues() {
        if (this.beforeValue) {
            if (this.beforeValue.id) {
                this.form.reset(this.beforeValue);
            }
            else {
                for (let key in this.beforeValue) {
                    let value = this.beforeValue[key];
                    if (value && this.form.get(key)) {
                        this.form.get(key).setValue(value);
                    }
                }
                this.form.reset(this.form.value);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsOperationsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudButtonsOperationsComponent, selector: "crud-buttons-operations", inputs: { onClose: "onClose", form: "form", beforeValue: "beforeValue", service: "service" }, ngImport: i0, template: "<elo-dialog id=\"dialog-delete\" [show]=\"showDelete\" (onOkEvent)=\"onOkdelete()\" (onCancelEvent)=\"onCancelDelete()\">\n  Confirma exclus\u00E3o deste registro?\n</elo-dialog>\n<div class=\"row\">\n  <div class=\"col-md-12 mt-xs\">\n    <button id=\"btnSalvarForm\" type=\"button\" class=\"btn positive inline\" (click)=\"save()\" [disabled]=\"!form.valid || form.pristine\">\n      Salvar\n    </button>\n    <button id=\"btnCancelarForm\" type=\"button\" class=\"btn negative inline\" (click)=\"cancel()\">\n      Cancelar\n    </button>\n    <button id=\"btnExcluirForm\" *ngIf=\"beforeValue?.id\"  type=\"button\" class=\"btn neutral inline\" (click)=\"delete()\">\n      Excluir\n    </button>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DialogComponent, selector: "elo-dialog", inputs: ["show", "showCancel", "classType", "tittleCancel", "tittleOk", "title", "disableOkButton", "debounceTime"], outputs: ["onOkEvent", "onCancelEvent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsOperationsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'crud-buttons-operations', template: "<elo-dialog id=\"dialog-delete\" [show]=\"showDelete\" (onOkEvent)=\"onOkdelete()\" (onCancelEvent)=\"onCancelDelete()\">\n  Confirma exclus\u00E3o deste registro?\n</elo-dialog>\n<div class=\"row\">\n  <div class=\"col-md-12 mt-xs\">\n    <button id=\"btnSalvarForm\" type=\"button\" class=\"btn positive inline\" (click)=\"save()\" [disabled]=\"!form.valid || form.pristine\">\n      Salvar\n    </button>\n    <button id=\"btnCancelarForm\" type=\"button\" class=\"btn negative inline\" (click)=\"cancel()\">\n      Cancelar\n    </button>\n    <button id=\"btnExcluirForm\" *ngIf=\"beforeValue?.id\"  type=\"button\" class=\"btn neutral inline\" (click)=\"delete()\">\n      Excluir\n    </button>\n  </div>\n</div>\n" }]
        }], propDecorators: { onClose: [{
                type: Input
            }], form: [{
                type: Input
            }], beforeValue: [{
                type: Input
            }], service: [{
                type: Input
            }] } });

class CrudButtonsOperationsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsOperationsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsOperationsModule, declarations: [CrudButtonsOperationsComponent], imports: [CommonModule, DialogModule], exports: [CrudButtonsOperationsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsOperationsModule, imports: [CommonModule, DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudButtonsOperationsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, DialogModule],
                    declarations: [CrudButtonsOperationsComponent],
                    exports: [CrudButtonsOperationsComponent]
                }]
        }] });

class CrudDetailInlineComponent {
    set entity(entity) {
        if (entity) {
            this._entity = entity;
            this.loadForm(this._entity, this.form.get(this.arrayPropertyName));
        }
    }
    set orderFunction(functionRef) {
        if (functionRef) {
            this.form.get(this.arrayPropertyName).controls.sort((a, b) => functionRef(a.value, b.value));
        }
    }
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.titleDetails = '';
        this.detailsVisibleWhenAttribute = '';
        this.printVisibleWhenMultipleAttribute = '';
        this.enableRemove = true;
        this.enablePrint = false;
        this.childHasForm = false;
        this.buttonNewLine = true;
        this.lineHighLight = false;
        this.class = '';
        this.maxListLength = '500px';
        this.hasScroll = false;
        this.onDelete = new EventEmitter();
        this.onInsert = new EventEmitter();
        this.onPrint = new EventEmitter();
        this.onAttrForm = new EventEmitter();
        this.visibleWhenFunction = null;
        this.enableScrollX = false;
        this.showDelete = false;
        this.showChildTable = [];
        this.beforeDelete = () => of(true);
        this.createContextItem = (form, index) => ({ form, index });
        this.createContextInsert = () => ({ form: this.formGroupInsert });
    }
    ngOnInit() {
        this.formGroupInsert = this.formCreate();
        AssertUtilsApp.assert(this.form, 'form');
        AssertUtilsApp.assert(this.formCreate, 'formCreate');
        AssertUtilsApp.assert(this.listTemplate, 'listTemplate');
        AssertUtilsApp.assert(this.arrayPropertyName, 'arrayPropertyName');
    }
    enableExcluir(item) {
        if (this.visibleWhenFunction && !this.visibleWhenFunction(item)) {
            return false;
        }
        return this.enableRemove;
    }
    getPrintVisibleWhenMultipleAttributes(item) {
        let printVisible = true;
        if (!item || !this.printVisibleWhenMultipleAttribute) {
            return false;
        }
        this.printVisibleWhenMultipleAttribute.split('|').forEach(atributo => {
            if (!item.get(atributo) || !item.get(atributo).value) {
                printVisible = false;
            }
        });
        return printVisible;
    }
    createContextDetail(formDetail, index) {
        let entityDetail = null;
        if (this._entity) {
            entityDetail = this._entity[this.arrayPropertyName][index];
        }
        return { formDetail, entityDetail };
    }
    delete(index) {
        this.showDelete = true;
        this.indexToDelete = index;
        this.showChildTable[index] = false;
    }
    add() {
        const formToInsert = this.formCreate();
        const value = formToInsert.value;
        formToInsert.reset(this.formGroupInsert.value);
        this.form.get(this.arrayPropertyName).push(formToInsert);
        this.onInsert.emit(this.formGroupInsert.value);
        this.formGroupInsert.reset(value);
        this.form.markAsDirty();
        this.form.updateValueAndValidity();
    }
    onOkDelete() {
        this.beforeDelete(this._entity && this._entity[this.arrayPropertyName][this.indexToDelete]).subscribe(() => this.removeItem(this.indexToDelete));
    }
    removeItem(indexToDelete) {
        if (this._entity && this._entity[this.arrayPropertyName]) {
            this._entity[this.arrayPropertyName].splice(indexToDelete, 1);
        }
        this.showDelete = false;
        this.form.get(this.arrayPropertyName).removeAt(indexToDelete);
        this.form.markAsDirty();
        this.onDelete.emit(this.form.get(this.arrayPropertyName).value);
    }
    onCancelDelete() {
        this.showDelete = false;
    }
    onDetails(index) {
        if (this.showChildTable[index]) {
            this.showChildTable[index] = !this.showChildTable[index];
        }
        else {
            this.showChildTable[index] = true;
        }
    }
    print(item) {
        this.onPrint.emit(item);
    }
    getFormArrayControls() {
        return this.form.get(this.arrayPropertyName).controls;
    }
    loadForm(entity, formArray) {
        const objArray = entity[this.arrayPropertyName];
        if (objArray) {
            const empty = formArray.length === 0;
            while (formArray.length > 0) {
                formArray.removeAt(0);
            }
            objArray.forEach(obj => {
                let form = this.formCreate();
                form.reset(obj, { emitEvent: false });
                this.onAttrForm.emit(form);
                if (empty) {
                    setTimeout(() => formArray.push(form), 0);
                }
                else {
                    formArray.push(form);
                }
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudDetailInlineComponent, deps: [{ token: i1$2.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudDetailInlineComponent, selector: "crud-detail-inline", inputs: { form: "form", arrayPropertyName: "arrayPropertyName", formCreate: "formCreate", listTemplate: "listTemplate", insertTemplate: "insertTemplate", detailTemplate: "detailTemplate", extraButtons: "extraButtons", titleDetails: "titleDetails", detailsVisibleWhenAttribute: "detailsVisibleWhenAttribute", printVisibleWhenMultipleAttribute: "printVisibleWhenMultipleAttribute", enableRemove: "enableRemove", enablePrint: "enablePrint", childHasForm: "childHasForm", buttonNewLine: "buttonNewLine", lineHighLight: "lineHighLight", footerTemplate: "footerTemplate", class: "class", maxListLength: "maxListLength", hasScroll: "hasScroll", visibleWhenFunction: "visibleWhenFunction", enableScrollX: "enableScrollX", entity: "entity", orderFunction: "orderFunction", beforeDelete: "beforeDelete" }, outputs: { onDelete: "onDelete", onInsert: "onInsert", onPrint: "onPrint", onAttrForm: "onAttrForm" }, ngImport: i0, template: "<ng-container *ngIf=\"buttonNewLine\">\n  <ng-container *ngTemplateOutlet=\"insertTemplate;context:createContextInsert()\"></ng-container>\n  <div class=\"row has-not-table\" *ngIf=\"insertTemplate\">\n    <div class=\"col-md-12 col-xs-12\">\n      <div class=\"form-group pull-right\">\n        <button id=\"btnAdd\" class=\"btn module-color icon-left\" type=\"button\" title=\"Adicionar\" (click)=\"add()\"\n          [disabled]=\"!formGroupInsert?.valid || formGroupInsert?.pristine\">\n          <i class=\"fa fa-plus\"></i>\n          Adicionar\n        </button>\n      </div>\n    </div>\n  </div>\n</ng-container>\n\n<div class=\"row\" *ngIf=\"!buttonNewLine\">\n  <ng-container *ngTemplateOutlet=\"insertTemplate;context:createContextInsert()\"></ng-container>\n  <div class=\"col-md-1 pl-none\" *ngIf=\"insertTemplate\">\n    <div class=\"form-group\">\n      <label class=\"label\"></label>\n      <button id=\"btnAdd\" class=\"btn module-color right\" type=\"button\" (click)=\"add()\"\n        [disabled]=\"!formGroupInsert?.valid || formGroupInsert?.pristine\">\n        Adicionar\n      </button>\n    </div>\n  </div>\n</div>\n\n<ng-container>\n  <div class=\"panel table mt-xs\">\n    <div class=\"panel-body {{ enableScrollX ? 'scroll-x' : '' }}\">\n      <ng-container *ngTemplateOutlet=\"crud\"></ng-container>\n    </div>\n    <ng-container [ngTemplateOutlet]=\"footerTemplate\" *ngIf=\"footerTemplate\"></ng-container>\n  </div>\n</ng-container>\n\n<ng-template #crud>\n  <div id=\"tableEditable\" class=\"table-editable panel-table-outer\"\n    [class.fixed]=\"hasScroll\" [hidden]=\"form?.get(arrayPropertyName)?.value.length === 0\" [ngClass]=\"class\">\n\n    <div class=\"table-editable-header hidden-xs\">\n      <ng-content></ng-content>\n    </div>\n\n    <div class=\"table-editable-content\" [ngStyle]=\"hasScroll && {'max-height': maxListLength}\">\n\n      <div [formGroup]=\"form\">\n        <div [formArrayName]=\"arrayPropertyName\">\n          <div *ngFor=\"let item of getFormArrayControls(); let i=index\">\n            <div class=\"row\" [class.striped]=\"i % 2\" [class.reduced]=\"lineHighLight\"\n              id=\"{{arrayPropertyName}}_{{item.get('id')?.value}}\">\n              <ng-container *ngTemplateOutlet=\"listTemplate;context:createContextItem(item, i)\">\n              </ng-container>\n              <div class=\"col-md-1 col-xs-12 column btn-actions\" *ngIf=\"titleDetails || enableRemove || extraButtons\">\n                <div class=\"btn-actions-inner\">\n                  <ng-container *ngTemplateOutlet=\"extraButtons;context:createContextItem(item, i)\"></ng-container>\n\n                  <button id=\"btnDetails\"\n                    *ngIf=\"titleDetails && (detailsVisibleWhenAttribute === '' || item.get(detailsVisibleWhenAttribute).value === true)\"\n                    class=\"btn\" type=\"button\" [title]=\"titleDetails\" (click)=\"onDetails(i)\">\n                    <i class=\"fa fa-chevron-down\"></i>\n                    <div class=\"btn-actions-label\">\n                      {{titleDetails}}\n                    </div>\n                  </button>\n\n                  <button id=\"btnImprimir\" *ngIf=\"getPrintVisibleWhenMultipleAttributes(item)\" class=\"btn\" type=\"button\"\n                    title=\"Imprimir\" (click)=\"print(item)\">\n                    <i class=\"fa fa-print\"></i>\n                    <div class=\"btn-actions-label\">\n                      Imprimir\n                    </div>\n                  </button>\n\n                  <button id=\"btnExcluir\" *ngIf=\"enableExcluir(item)\" class=\"btn\" type=\"button\" title=\"Excluir\"\n                    (click)=\"delete(i)\">\n                    <i class=\"fa fa-trash\"></i>\n                    <div class=\"btn-actions-label\">\n                      Excluir\n                    </div>\n                  </button>\n                </div>\n              </div>\n            </div>\n            <div class=\"child-table\" [class.has-form]=\"childHasForm\" *ngIf=\"titleDetails\" [hidden]=\"!showChildTable[i]\"\n              id=\"child\">\n              <ng-container *ngTemplateOutlet=\"detailTemplate;context:createContextDetail(item, i)\"></ng-container>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n<elo-dialog [show]=\"showDelete\" (onOkEvent)=\"onOkDelete()\" (onCancelEvent)=\"onCancelDelete()\">\n  Apagar?\n</elo-dialog>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: DialogComponent, selector: "elo-dialog", inputs: ["show", "showCancel", "classType", "tittleCancel", "tittleOk", "title", "disableOkButton", "debounceTime"], outputs: ["onOkEvent", "onCancelEvent"] }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudDetailInlineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'crud-detail-inline', template: "<ng-container *ngIf=\"buttonNewLine\">\n  <ng-container *ngTemplateOutlet=\"insertTemplate;context:createContextInsert()\"></ng-container>\n  <div class=\"row has-not-table\" *ngIf=\"insertTemplate\">\n    <div class=\"col-md-12 col-xs-12\">\n      <div class=\"form-group pull-right\">\n        <button id=\"btnAdd\" class=\"btn module-color icon-left\" type=\"button\" title=\"Adicionar\" (click)=\"add()\"\n          [disabled]=\"!formGroupInsert?.valid || formGroupInsert?.pristine\">\n          <i class=\"fa fa-plus\"></i>\n          Adicionar\n        </button>\n      </div>\n    </div>\n  </div>\n</ng-container>\n\n<div class=\"row\" *ngIf=\"!buttonNewLine\">\n  <ng-container *ngTemplateOutlet=\"insertTemplate;context:createContextInsert()\"></ng-container>\n  <div class=\"col-md-1 pl-none\" *ngIf=\"insertTemplate\">\n    <div class=\"form-group\">\n      <label class=\"label\"></label>\n      <button id=\"btnAdd\" class=\"btn module-color right\" type=\"button\" (click)=\"add()\"\n        [disabled]=\"!formGroupInsert?.valid || formGroupInsert?.pristine\">\n        Adicionar\n      </button>\n    </div>\n  </div>\n</div>\n\n<ng-container>\n  <div class=\"panel table mt-xs\">\n    <div class=\"panel-body {{ enableScrollX ? 'scroll-x' : '' }}\">\n      <ng-container *ngTemplateOutlet=\"crud\"></ng-container>\n    </div>\n    <ng-container [ngTemplateOutlet]=\"footerTemplate\" *ngIf=\"footerTemplate\"></ng-container>\n  </div>\n</ng-container>\n\n<ng-template #crud>\n  <div id=\"tableEditable\" class=\"table-editable panel-table-outer\"\n    [class.fixed]=\"hasScroll\" [hidden]=\"form?.get(arrayPropertyName)?.value.length === 0\" [ngClass]=\"class\">\n\n    <div class=\"table-editable-header hidden-xs\">\n      <ng-content></ng-content>\n    </div>\n\n    <div class=\"table-editable-content\" [ngStyle]=\"hasScroll && {'max-height': maxListLength}\">\n\n      <div [formGroup]=\"form\">\n        <div [formArrayName]=\"arrayPropertyName\">\n          <div *ngFor=\"let item of getFormArrayControls(); let i=index\">\n            <div class=\"row\" [class.striped]=\"i % 2\" [class.reduced]=\"lineHighLight\"\n              id=\"{{arrayPropertyName}}_{{item.get('id')?.value}}\">\n              <ng-container *ngTemplateOutlet=\"listTemplate;context:createContextItem(item, i)\">\n              </ng-container>\n              <div class=\"col-md-1 col-xs-12 column btn-actions\" *ngIf=\"titleDetails || enableRemove || extraButtons\">\n                <div class=\"btn-actions-inner\">\n                  <ng-container *ngTemplateOutlet=\"extraButtons;context:createContextItem(item, i)\"></ng-container>\n\n                  <button id=\"btnDetails\"\n                    *ngIf=\"titleDetails && (detailsVisibleWhenAttribute === '' || item.get(detailsVisibleWhenAttribute).value === true)\"\n                    class=\"btn\" type=\"button\" [title]=\"titleDetails\" (click)=\"onDetails(i)\">\n                    <i class=\"fa fa-chevron-down\"></i>\n                    <div class=\"btn-actions-label\">\n                      {{titleDetails}}\n                    </div>\n                  </button>\n\n                  <button id=\"btnImprimir\" *ngIf=\"getPrintVisibleWhenMultipleAttributes(item)\" class=\"btn\" type=\"button\"\n                    title=\"Imprimir\" (click)=\"print(item)\">\n                    <i class=\"fa fa-print\"></i>\n                    <div class=\"btn-actions-label\">\n                      Imprimir\n                    </div>\n                  </button>\n\n                  <button id=\"btnExcluir\" *ngIf=\"enableExcluir(item)\" class=\"btn\" type=\"button\" title=\"Excluir\"\n                    (click)=\"delete(i)\">\n                    <i class=\"fa fa-trash\"></i>\n                    <div class=\"btn-actions-label\">\n                      Excluir\n                    </div>\n                  </button>\n                </div>\n              </div>\n            </div>\n            <div class=\"child-table\" [class.has-form]=\"childHasForm\" *ngIf=\"titleDetails\" [hidden]=\"!showChildTable[i]\"\n              id=\"child\">\n              <ng-container *ngTemplateOutlet=\"detailTemplate;context:createContextDetail(item, i)\"></ng-container>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n<elo-dialog [show]=\"showDelete\" (onOkEvent)=\"onOkDelete()\" (onCancelEvent)=\"onCancelDelete()\">\n  Apagar?\n</elo-dialog>" }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }], propDecorators: { form: [{
                type: Input
            }], arrayPropertyName: [{
                type: Input
            }], formCreate: [{
                type: Input
            }], listTemplate: [{
                type: Input
            }], insertTemplate: [{
                type: Input
            }], detailTemplate: [{
                type: Input
            }], extraButtons: [{
                type: Input
            }], titleDetails: [{
                type: Input
            }], detailsVisibleWhenAttribute: [{
                type: Input
            }], printVisibleWhenMultipleAttribute: [{
                type: Input
            }], enableRemove: [{
                type: Input
            }], enablePrint: [{
                type: Input
            }], childHasForm: [{
                type: Input
            }], buttonNewLine: [{
                type: Input
            }], lineHighLight: [{
                type: Input
            }], footerTemplate: [{
                type: Input
            }], class: [{
                type: Input
            }], maxListLength: [{
                type: Input
            }], hasScroll: [{
                type: Input
            }], onDelete: [{
                type: Output
            }], onInsert: [{
                type: Output
            }], onPrint: [{
                type: Output
            }], onAttrForm: [{
                type: Output
            }], visibleWhenFunction: [{
                type: Input
            }], enableScrollX: [{
                type: Input
            }], entity: [{
                type: Input
            }], orderFunction: [{
                type: Input
            }], beforeDelete: [{
                type: Input
            }] } });

class CrudDetailInlineModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudDetailInlineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudDetailInlineModule, declarations: [CrudDetailInlineComponent], imports: [CommonModule,
            PanelModule,
            DialogModule,
            DirectivesModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule], exports: [CrudDetailInlineComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudDetailInlineModule, imports: [CommonModule,
            PanelModule,
            DialogModule,
            DirectivesModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudDetailInlineModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PanelModule,
                        DialogModule,
                        DirectivesModule,
                        ReactiveFormsModule,
                        FormControlValidationMsgModule
                    ],
                    declarations: [CrudDetailInlineComponent],
                    exports: [CrudDetailInlineComponent]
                }]
        }] });

const INVALID_DATE = 'Invalid date';
// @dynamic
class EloValidators {
    static sameValue(formControlReference) {
        return (control) => {
            const isSame = formControlReference.value === control.value;
            return isSame ? null : { 'sameValue': 'valores diferentes' };
        };
    }
    static differentValue(message, isEquals) {
        return (control) => isEquals(control) ? { 'differentValue': message } : null;
    }
    static lessEqualThan(formControlReference) {
        return (control) => {
            let isLessOrEqual;
            if (control.value) {
                if (typeof control.value === 'string') {
                    isLessOrEqual = +formControlReference.value >= +control.value.replace(',', '.');
                }
                else {
                    isLessOrEqual = +formControlReference.value >= +control.value;
                }
            }
            return isLessOrEqual ? null : { 'lessOrEqualValue': formControlReference.value + ' maior que ' + control.value };
        };
    }
    static greaterThanZero() {
        const ZERO = 0;
        return (control) => {
            return control.value && control.value > ZERO ? null : {
                'valor deve ser maior que 0': true
            };
        };
    }
    static email() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const EMAIL_REGEXP = /^[a-zA-Z0-9-_]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,15})$/;
            const valid = control.value && control.value.length > 0 && EMAIL_REGEXP.test(control.value);
            return valid ? null : { 'email': false };
        };
    }
    static siteUrl() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const URL_REGEXP = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!%\$&'\(\)\*\+,;=.]+$/;
            const valid = control.value && control.value.length > 0 && URL_REGEXP.test(control.value);
            return valid ? null : { 'url': false };
        };
    }
    static competencia() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const COMPETENCIA_REGEXP = /^(0[1-9]|1[012])+(\/?[12][0-9]{3})$/;
            const valid = control.value && control.value.length > 0 && COMPETENCIA_REGEXP.test(control.value);
            return valid ? null : { 'competencia': false };
        };
    }
    static containedInValidator() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const BETWEEN_REGEXP = /^\d+(,\d+|(-\d+))*$/;
            const valid = control.value && control.value.length > 0 && BETWEEN_REGEXP.test(control.value);
            return valid ? null : { 'pattern': false };
        };
    }
    /**
     * Ideal utilizar com o campo input de tipo datetime-local
     */
    static dateTimeNotSmaller(formControlReference) {
        return (control) => {
            const valueReference = formControlReference.value;
            const valueControl = control.value;
            if (valueControl && valueReference) {
                const [dataReference, horaReference] = valueReference.split('T');
                const [dataControl, horaControl] = valueControl.split('T');
                const datasIguais = moment(dataReference).isSame(dataControl);
                const dataInvalida = DateUtils.smallerDate(new Date(dataControl), new Date(dataReference));
                const horaInvalida = horaReference > horaControl;
                if (dataInvalida || (datasIguais && horaInvalida)) {
                    return {
                        validateDateTimeNotSmaller: {
                            valid: false,
                            dataHoraMinima: DateUtils.dateTimeFormat(dataReference, horaReference)
                        }
                    };
                }
                return null;
            }
            return null;
        };
    }
    /*
     * Pega o value do form, e troca o - por / para criar um Date
     *
     * Ideal para utilizar esse Validator em um atributo do form que utilize o componente elo-datepicker
     */
    static dateNotSmaller(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl && valueControlReference) {
                let dataMinima = new Date(valueControlReference.replace(/\-/gi, '/'));
                return DateUtils.smallerDate(new Date(valueControl.replace(/\-/gi, '/')), dataMinima) ?
                    {
                        validateDateNotSmaller: {
                            valid: false,
                            dataMinima: DateUtils.format(dataMinima, 'DD/MM/YYYY')
                        }
                    } : null;
            }
        };
    }
    static dateNotGreater(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl && valueControlReference) {
                let dataMaxima = new Date(valueControlReference.replace(/\-/gi, '/'));
                return DateUtils.greaterDate(new Date(valueControl.replace(/\-/gi, '/')), dataMaxima) ?
                    {
                        validateDateNotGreater: {
                            valid: false,
                            dataMaxima: DateUtils.format(dataMaxima, 'DD/MM/YYYY')
                        }
                    } : null;
            }
        };
    }
    static competenciaNotSmaller(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl && valueControlReference && valueControlReference.inicioCompetencia && valueControl.inicioCompetencia) {
                let dataMinima = new Date(valueControlReference.inicioCompetencia.replace(/\-/gi, '/'));
                return DateUtils.smallerDate(new Date(valueControl.inicioCompetencia.replace(/\-/gi, '/')), dataMinima) ? { 'competencia-minima': DateUtils.format(dataMinima, 'DD/MM/YYYY', 'MM/YYYY') } : null;
            }
        };
    }
    static conditionalValidator(validatorFn, conditionFn, conditionControls = []) {
        return EloValidators.internalConditionalValidator(validatorFn, conditionFn, conditionControls);
    }
    static conditionalValidatorOnField(validatorFn, conditionFn, conditionControls = []) {
        return EloValidators.internalConditionalValidator(validatorFn, conditionFn, conditionControls, true);
    }
    static dateCompetencia(usuarioInfo) {
        return (control) => {
            if (!control.value) {
                return { 'requerido': true };
            }
            if (!usuarioInfo) {
                return { 'competência não configurada': true };
            }
            const date = DateUtils.getDateFromString(control.value);
            if (usuarioInfo.mesPadrao !== date.getMonth() + 1 ||
                usuarioInfo.exercicioPadrao !== date.getFullYear()) {
                return { 'dataCompetencia': false };
            }
            return null;
        };
    }
    static competenciaValidator(usuarioInfo) {
        return (control) => {
            if (!usuarioInfo) {
                return { 'competência não configurada': true };
            }
            if (usuarioInfo.situacaoPadrao !== 'Aberto') {
                return { 'competenciaAberta': false };
            }
            return null;
        };
    }
    /* Valor digitado maior igual ao valor do form */
    static greaterThanEquals(value, customMessage = 'valorMaior') {
        return (control) => {
            return control.value > value ? { [customMessage]: value } : null;
        };
    }
    static smallerThanEquals(value, customMessage = 'menorValor') {
        return (control) => {
            return control.value < value ? { [customMessage]: value } : null;
        };
    }
    static cpfValidator() {
        return (control) => {
            return isValid(control.value, [util.isCpf]) ? null : { 'CPF inválido': true };
        };
    }
    static cnpjValidator() {
        return (control) => {
            return isValid(control.value, [util.isCnpj]) ? null : { 'cnpj_invalid': true };
        };
    }
    static validadeCnhValidator(data) {
        return (control) => {
            const { value } = control;
            let dataSubtract = data
                ? moment(data).subtract(30, 'days').format(FROM_FORMAT)
                : moment().subtract(30, 'days').format(FROM_FORMAT);
            if (value) {
                return moment(value.validadeCNH).isBefore(dataSubtract)
                    ? { 'Motorista com CNH vencida a mais de 30 dias': true }
                    : null;
            }
        };
    }
    static horaQuantityValidator() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const HORA_REGEXP = /^([0-9]+):[0-5][0-9]?$/;
            const valid = control.value && control.value.length > 0 && HORA_REGEXP.test(control.value);
            return valid ? null : { 'mensagemGenerica': { valid: false, mensagem: '(A hora informada é invalida) ' } };
        };
    }
    static horaValidator() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const HORA_REGEXP = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]?$/;
            const valid = control.value && control.value.length > 0 && HORA_REGEXP.test(control.value);
            return valid ? null : { 'hora': false };
        };
    }
    static numberGreaterThan(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl === null || valueControlReference === null)
                return null;
            let result = (valueControl >= valueControlReference);
            return result ? null : { minvalue: valueControlReference };
        };
    }
    static numberLessThan(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl === null || valueControlReference === null)
                return null;
            let result = (valueControl <= valueControlReference);
            return result ? null : { maxvalue: valueControlReference };
        };
    }
    static hourLessThan(formControlReference) {
        return (control) => {
            if (!control.value || !formControlReference.value)
                return null;
            let valueControl = Number(control.value.replace(':', '.'));
            let valueControlReference = Number(formControlReference.value.replace(':', '.'));
            if (valueControl === null || valueControlReference === null)
                return null;
            let result = (valueControl <= valueControlReference);
            return result ? null : { 'maxvalue': formControlReference.value };
        };
    }
    static hourGreaterThan(formControlReference) {
        return (control) => {
            if (!control.value || !formControlReference.value)
                return null;
            let valueControl = Number(control.value.replace(':', '.'));
            let valueControlReference = Number(formControlReference.value.replace(':', '.'));
            if (valueControl === null || valueControlReference === null)
                return null;
            let result = (valueControl >= valueControlReference);
            return result ? null : { minvalue: formControlReference.value };
        };
    }
    static hourNotSmaller(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl && valueControlReference) {
                let dataMinima = new Date('01/01/2018 ' + valueControlReference);
                let dataDigitada = new Date('01/01/2018 ' + valueControl);
                return DateUtils.smallerDate(dataDigitada, dataMinima) ? {
                    validateHourNotSmaller: {
                        valid: false,
                        horaMinima: valueControlReference
                    }
                } : null;
            }
        };
    }
    /**
     * @param control - Espera um control com a data no formato YYYY-MM-DD, ideal quando utilizado com elo-datepicker.
    */
    static dateNotWeekend() {
        return (control) => {
            let valueControl = control.value;
            if (valueControl) {
                return DateUtils.isWeekend(valueControl)
                    ? { dateNotWeekend: { valid: false } }
                    : null;
            }
        };
    }
    static dateNotSmallerDate(data) {
        return (control) => {
            let valueControl = control.value;
            if (valueControl && data) {
                let dataMinima = DateUtils.getDateFromString(data);
                return DateUtils.smallerDate(valueControl, dataMinima)
                    ? {
                        validateDateNotSmaller: {
                            valid: false,
                            dataMinima: DateUtils.format(dataMinima, 'DD/MM/YYYY')
                        }
                    }
                    : null;
            }
        };
    }
    static dayNotSmallerOrEqualsDay(data) {
        return (control) => {
            let valueControl = control.value;
            if (valueControl && data) {
                let dataMinima = DateUtils.getDateFromString(data);
                return DateUtils.isDaySmallerDate(valueControl, dataMinima)
                    ? {
                        validateDateNotSmaller: {
                            valid: false,
                            dataMinima: DateUtils.format(dataMinima, 'DD/MM/YYYY')
                        }
                    }
                    : null;
            }
        };
    }
    static dateNotGreaterDate(data) {
        return (control) => {
            let valueControl = control.value;
            if (valueControl && data) {
                let dataMaxima = DateUtils.getDateFromString(data);
                return DateUtils.greaterDate(new Date(valueControl.replace(/\-/gi, '/')), dataMaxima) ?
                    {
                        validateDateNotGreater: {
                            valid: false,
                            dataMaxima: DateUtils.format(dataMaxima, 'DD/MM/YYYY')
                        }
                    } : null;
            }
        };
    }
    static dateEqualYear(data) {
        return (control) => {
            let valueControl = control.value;
            if (valueControl && data) {
                let dataYear = DateUtils.getDateFromString(data);
                const date = DateUtils.getDateFromString(control.value);
                if (dataYear.getFullYear() !== date.getFullYear()) {
                    return {
                        validateDateNotGreaterYear: {
                            valid: false,
                            yearMaximo: dataYear.getFullYear()
                        }
                    };
                }
                return null;
            }
        };
    }
    static obrigatorioBy(functionRequired) {
        return (control) => {
            if (functionRequired()) {
                return Validators.required(control);
            }
            return null;
        };
    }
    static isNumeric() {
        return (control) => {
            if (control.value?.length > 0 && (!NumberUtils.isNumeric(control.value) || control.value.toString().includes('.') || control.value.toString().includes(' '))) {
                return { 'Valor deve conter apenas números.': '' };
            }
            return null;
        };
    }
    static sumEqual(controlValueBase, formFields, customMessage = 'somaValor') {
        let hasSubscription = false;
        return (control) => {
            if (!hasSubscription) {
                hasSubscription = true;
                controlValueBase.valueChanges.subscribe(() => control.updateValueAndValidity());
            }
            const baseValue = NumberUtils.round(controlValueBase.value);
            let isSumEquals = true;
            control.controls.forEach(innerControl => {
                const sumArray = formFields
                    .map(field => parseFloat(innerControl.get(field).value))
                    .reduce((preview, current) => preview + current);
                isSumEquals = isSumEquals && (NumberUtils.round(sumArray) === baseValue);
            });
            return isSumEquals ? null : { [customMessage]: controlValueBase };
        };
    }
    static sumEqualValue(value, fieldName, customMessage = 'somaValor') {
        return (control) => {
            const sumArray = control.controls.map(form => form.get(fieldName) && form.get(fieldName).value && parseFloat(form.get(fieldName).value))
                .reduce((preview, current) => preview + current, 0);
            return NumberUtils.isSameValue(sumArray, value, 0.001) ? null : { [customMessage]: value };
        };
    }
    static invalidDate() {
        return (control) => {
            return (control.value === INVALID_DATE) ? {
                validateDate: { valid: false }
            } : null;
        };
    }
    static asyncValidatorWrapper(validatorFn) {
        return (control) => {
            if (!control.value || control.pristine) {
                return of(null);
            }
            return validatorFn(control);
        };
    }
    static asyncConditionalValidator(validatorFn, conditionFn, conditionControls = []) {
        return (control) => {
            conditionControls.forEach(ctrl => {
                ctrl.valueChanges.subscribe(() => control.updateValueAndValidity());
            });
            if (conditionFn()) {
                return validatorFn(control);
            }
            return of(null);
        };
    }
    static internalConditionalValidator(validatorFn, conditionFn, conditionControls = [], innerFunction = false) {
        let hasSubscription = false;
        return (control) => {
            if (!hasSubscription) {
                conditionControls.forEach(ctrl => {
                    ctrl.valueChanges.subscribe(() => control.updateValueAndValidity());
                });
                hasSubscription = true;
            }
            if (conditionFn()) {
                return innerFunction ? validatorFn()(control) : validatorFn(control);
            }
            return null;
        };
    }
}

const DROPDOWN_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EloSelectComponent),
    multi: true
};
/**
 * @see https://angular.io/docs/ts/latest/api/forms/index/SelectControlValueAccessor-directive.html
 *
 * If your option values are simple strings, you can bind to the normal value property on the option.
 * If your option values happen to be objects (and you'd like to save the selection in your form as an object), use ngValue
 *
 * Neste componente, não foi utilizado ngValue, pois na época não funcionava.
 * */
class EloSelectComponent {
    constructor() {
        this.selectedValue = null;
        this.onSelectChange = new EventEmitter();
        this.selectedIndex = 0;
    }
    ngOnInit() {
        this.defineSelectedIndex(this.selectedValue);
    }
    set value(index) {
        this.selectedIndex = index;
        this.onSelectChange.emit(this.realValue());
        if (this.onModelChange) {
            this.onModelChange(this.realValue());
        }
    }
    realValue() {
        return this.optionsOfCombo[this.selectedIndex].value;
    }
    get value() {
        return this.selectedIndex;
    }
    get optionsOfCombo() {
        if (this.onModelChange) {
            return [{ label: 'Selecione', value: null }].concat(this.options);
        }
        return this.options;
    }
    writeValue(value) {
        if (value) {
            this.defineSelectedIndex(value);
        }
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onModelTouched = fn;
    }
    defineSelectedIndex(value) {
        if (value) {
            const selectedComparator = this.compareWith || defaultComparator;
            const compararatorFn = (a) => (b) => selectedComparator(a, b);
            const opt = this.optionsOfCombo.filter(compararatorFn(value))[0];
            this.selectedIndex = this.optionsOfCombo.indexOf(opt);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloSelectComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloSelectComponent, selector: "elo-select", inputs: { selectedValue: "selectedValue", options: "options", required: "required", compareWith: "compareWith" }, outputs: { onSelectChange: "onSelectChange" }, providers: [DROPDOWN_VALUE_ACCESSOR], ngImport: i0, template: `
    <select id="select-filter" name="select-filter" [required]="required" [(ngModel)]="value" >
      <option *ngFor="let option of optionsOfCombo; let i = index" [value]="i" >{{option?.label}}</option>
    </select>
`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloSelectComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-select',
                    providers: [DROPDOWN_VALUE_ACCESSOR],
                    template: `
    <select id="select-filter" name="select-filter" [required]="required" [(ngModel)]="value" >
      <option *ngFor="let option of optionsOfCombo; let i = index" [value]="i" >{{option?.label}}</option>
    </select>
`
                }]
        }], propDecorators: { selectedValue: [{
                type: Input
            }], options: [{
                type: Input
            }], required: [{
                type: Input
            }], compareWith: [{
                type: Input
            }], onSelectChange: [{
                type: Output
            }] } });
function defaultComparator(value, opt) {
    return JSON.stringify(opt.value) === JSON.stringify(value);
}

class SearchFilterComponent {
    set fieldsModels(fieldsModels) {
        this._fieldsModels = fieldsModels;
        if (this.form) {
            this.initFilters();
        }
    }
    constructor(fb) {
        this.fb = fb;
        this.operatorsByType = new Map();
        this.filterItemByType = new Map();
        this.filterType = 'text';
        this.enumOptions = [];
        this.booleanOptions = [];
        this.placeHolder = 'Digite o filtro';
        this.classInput = '';
        this.filtersDefaults = [];
        this.clearFilterOnSwitch = false;
        this._fieldsModels = [];
        this.findEntitiesOnInit = true;
        this.onFilter = new EventEmitter();
        this.allowSearch = true;
        this.notHasExtraFilter = true;
        this.defaultValueOperators = new Map();
        this.operatorsByType = operatorsFilter.getOperatorsByType();
        this.filterItemByType = operatorsFilter.getFilterItemByType();
    }
    ngOnChanges() {
        if (this.allowSearch) {
            this.setDefaults();
        }
    }
    ngOnInit() {
        this.initFilters();
        this.setDefaults();
    }
    ngAfterViewInit() {
        let btnWidth = this.btnFiltro.nativeElement.clientWidth;
        this.inputFilter.nativeElement.style.width = 'calc(100% - ' + btnWidth + 'px)';
    }
    initFilterItem() {
        const field = new UntypedFormControl('', Validators.required);
        const operator = new UntypedFormControl('', Validators.required);
        let form = this.fb.group({
            field: field,
            operator: operator,
            value: [],
            valid: [false]
        });
        field.valueChanges.subscribe(value => {
            this.loadFilterOptions(value);
            this.loadFilterItemType(value);
            this.focus();
        });
        form.get('value').setValidators(Validators.compose([Validators.required,
            EloValidators.conditionalValidator(EloValidators.containedInValidator(), () => this.isOperatorContainedIn(operator.value), [operator]),
            EloValidators.conditionalValidator(EloValidators.isNumeric(), () => this.isNumericValue() && this.notIsOperatorContainedIn(operator.value), [operator])]));
        operator.valueChanges.subscribe(operatorValue => {
            this.placeHolder = 'Digite o filtro';
            if (this.isNumericValue()) {
                if (this.isOperatorContainedIn(operatorValue)) {
                    this.placeHolder = 'Digite o filtro (ex: 1 | 1,2,3 | 10-15 | 1,2,3,10-15)';
                }
                else {
                    this.placeHolder = 'Digite o filtro. Somente números.';
                }
            }
        });
        return form;
    }
    filter() {
        if (!this.hasValue()) {
            this.onFilter.emit(this.getFiltersToEmit());
            return;
        }
        let filterActual = this.filterItens.at(0).get('field').value;
        if (filterActual.dataType === 'LocalDateTime') {
            this.formatValueToLocalDateTime();
        }
        if (filterActual.removeDot) {
            this.removeDotsOfValue();
        }
        this.addFormFilter();
        this.onFilter.emit(this.getFiltersToEmit());
        this.focus();
        this.setDefaultSelectedField(false);
    }
    removeDuplicatedFilter() {
        let filterActual = this.filterItens.at(0).get('field').value;
        let operatorActual = this.filterItens.at(0).get('operator').value;
        let filterRepeatedArray = this.filterItens.value.filter((filterItem) => filterItem.valid && (filterItem.field.fieldPath === filterActual.fieldPath && filterItem.operator.value === operatorActual.value));
        filterRepeatedArray.forEach(filterRepeated => {
            let filterIndexToDelete = this.filterItens.value.indexOf(filterRepeated);
            this.filterItens.removeAt(filterIndexToDelete);
        });
    }
    removeFilter(filter) {
        let index = this.filterItens.value.indexOf(filter);
        this.filterItens.removeAt(index);
        let itemDefault = this.filtersDefaults.filter(f => f.field === filter.field.fieldPath)[0];
        let indexDefault = this.filtersDefaults.indexOf(itemDefault);
        if (indexDefault >= 0) {
            this.filtersDefaults.splice(indexDefault, 1);
        }
        this.onFilter.emit(this.getFiltersToEmit());
        this.focus();
    }
    getValidFilter() {
        return this.filterItens.value.filter((filterItem) => filterItem.valid);
    }
    loadFilterOptions(field) {
        this.isEnum = field.isEnum;
        this.isBoolean = field.isBoolean;
        this.isInteger = field.dataType === 'Integer';
        this.isLong = field.dataType === 'Long';
        if (this.isEnum) {
            this.enumOptions = field.enumOptions.map(value => {
                return { label: value.descricao, value: value.codigo };
            });
        }
        if (this.isBoolean) {
            this.booleanOptions = [{ label: 'Sim', value: true }, { label: 'Não', value: false }];
        }
        this.filterOptions = [];
        this.operatorsByType.forEach((value, key) => {
            let fieldType = field.dataType;
            if (this.isEnum) {
                fieldType = 'Enum';
            }
            if (this.isBoolean) {
                fieldType = 'Boolean';
            }
            if (this.isSameType(key, fieldType)) {
                this.filterOptions.push(value);
            }
        });
        this.filterItens.at(0).get('operator').setValue(this.getDefaultValueOperator(field.fieldName));
        this.filterItens.at(0).get('value').setValue('');
    }
    getDefaultValueOperator(fieldName) {
        if (!this.defaultValueOperators?.has(fieldName)) {
            return this.filterOptions[0];
        }
        const operatorId = this.defaultValueOperators.get(fieldName);
        return operatorsFilter.getOperation(operatorId) || this.filterOptions[0];
    }
    focus() {
        setTimeout(() => {
            if (this.filtro && this.filtro.nativeElement) {
                this.filtro.nativeElement.focus();
            }
        });
    }
    loadFilterItemType(field) {
        this.filterItemByType.forEach((value, key) => {
            if (key.indexOf(field.dataType) >= 0) {
                this.filterType = value;
            }
        });
    }
    isDate() {
        return this.filterType === 'date';
    }
    isDateTime() {
        return this.filterType === 'dateTime';
    }
    isTime() {
        return this.filterType === 'time';
    }
    isNumericValue() {
        return this.isInteger || this.isLong;
    }
    isOperatorContainedIn(operatorValue) {
        return operatorValue?.value === '=ci=' || operatorValue?.value === '=nci=';
    }
    getSearchTagValue(filterItem) {
        if (filterItem.field.isEnum) {
            const optionFound = filterItem.field.enumOptions.find(option => option.codigo === filterItem.value);
            if (optionFound) {
                return optionFound.descricao;
            }
        }
        if (filterItem.field.dataType === 'LocalDate') {
            return DateUtils.format(filterItem.value);
        }
        if (filterItem.field.dataType === 'LocalDateTime') {
            return DateUtils.dateTimeFormatFilter(filterItem.value);
        }
        if (filterItem.field.isBoolean) {
            return filterItem.value === true || filterItem.value === 'true' ? 'Sim' : 'Não';
        }
        return filterItem.value;
    }
    compareWith() {
        return FormUtils.equals('id');
    }
    disabledButton() {
        return (this.notHasExtraFilter || this.findEntitiesOnInit) && (!this.getFirstForm().valid || !this.hasValue() || !this.allowSearch);
    }
    getFirstForm() {
        return this.filterItens.at(0);
    }
    hasValue() {
        let value = this.filterItens.at(0).get('value').value;
        return value !== null && value !== undefined && value !== '';
    }
    notIsOperatorContainedIn(operatorValue) {
        return operatorValue.value !== '=ci=' && operatorValue.value !== '=nci=';
    }
    setDefaults() {
        this.addFiltersDefaultsToForm();
        this.setDefaultSelectedField(true);
    }
    isSameType(key, fieldType) {
        return key.indexOf(fieldType) >= 0;
    }
    getFiltersToEmit() {
        return this.getValidFilter().map(f => {
            return {
                field: f.field.fieldPath,
                op: f.operator.id,
                value: f.value,
            };
        });
    }
    setDefaultSelectedField(isLoading) {
        const field = this.filterItens ? this.filterItens.at(0).get('field') : null;
        if (this._fieldsModels && this._fieldsModels.length > 0 && field && !field.value) {
            if (!isLoading && this.filterItens.length > 1) {
                field.setValue(this.filterItens.at(1).get('field').value);
            }
            else {
                const defaultFieldModel = this._fieldsModels.find(m => m.fieldPath === this.defaultField);
                field.setValue(defaultFieldModel || this._fieldsModels[0]);
            }
        }
    }
    addFormFilter() {
        this.removeDuplicatedFilter();
        this.filterItens.at(0).get('valid').setValue(true);
        this.filterItens.insert(0, this.initFilterItem());
    }
    addFiltersDefaultsToForm() {
        if (this.filterItens && this._fieldsModels && this._fieldsModels.length > 0) {
            if (this.clearFilterOnSwitch) {
                this.initFilters();
            }
            this.filtersDefaults.forEach(filter => {
                const formGroup = this.filterItens.at(0);
                const field = this._fieldsModels.filter(m => m.fieldPath === filter.field)[0];
                const op = operatorsFilter.getOperation(filter.op);
                if (field && op) {
                    formGroup.get('field').setValue(field);
                    formGroup.get('operator').setValue(op);
                    formGroup.get('value').setValue(filter.value);
                    this.addFormFilter();
                }
            });
        }
    }
    formatValueToLocalDateTime() {
        const valueActual = this.filterItens.at(0).get('value').value;
        const hour = this.getHour();
        const localDateTime = DateUtils.dateTimeFormat(valueActual, hour);
        this.filterItens.at(0).get('value').setValue(localDateTime);
    }
    getHour() {
        return this.filterHour && this.filterHour.nativeElement.value
            ? this.filterHour.nativeElement.value
            : '12:00';
    }
    removeDotsOfValue() {
        const valueActual = this.filterItens.at(0).get('value').value;
        if (this.filterItens.at(0).get('operator').value?.id === EQUAL_OPERATION) {
            this.filterItens.at(0).get('operator').setValue({ id: STARTS_WITH_OPERATION, caption: STARTS_WITH_CAPTION, value: '==' });
        }
        this.filterItens.at(0).get('value').setValue(StringUtils.replaceAll(valueActual, '.', ''));
    }
    initFilters() {
        this.filterItens = this.fb.array([
            this.initFilterItem()
        ]);
        this.form = this.fb.group({
            filterItens: this.filterItens
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SearchFilterComponent, deps: [{ token: i1$2.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SearchFilterComponent, selector: "search-filter", inputs: { defaultField: "defaultField", classInput: "classInput", filtersDefaults: "filtersDefaults", clearFilterOnSwitch: "clearFilterOnSwitch", fieldsModels: "fieldsModels", findEntitiesOnInit: "findEntitiesOnInit", beforeExtraElement: "beforeExtraElement", allowSearch: "allowSearch", notHasExtraFilter: "notHasExtraFilter", defaultValueOperators: "defaultValueOperators" }, outputs: { onFilter: "onFilter" }, viewQueries: [{ propertyName: "filtro", first: true, predicate: ["valorFiltro"], descendants: true }, { propertyName: "filterHour", first: true, predicate: ["filterHourValue"], descendants: true }, { propertyName: "btnFiltro", first: true, predicate: ["btnFiltro"], descendants: true, static: true }, { propertyName: "inputFilter", first: true, predicate: ["inputFilter"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"panel-table-filter\">\n  <form [formGroup]=\"form\" (ngSubmit)=\"filter()\">\n    <div formArrayName=\"filterItens\">\n      <div [formGroup]=\"getFirstForm()\">\n        <div *ngIf=\"beforeExtraElement\">\n          <ng-container [ngTemplateOutlet]=\"beforeExtraElement\"></ng-container>\n        </div>\n        <div class=\"row\" [ngClass]=\"classInput\">\n          <div class=\"col-sm-3\">\n            <div class=\"form-group\">\n              <select id=\"filter-fields\" type=\"select\" placeholder=\"Campos\" formControlName=\"field\">\n                <option *ngFor=\"let field of _fieldsModels\" [ngValue]=\"field\">{{field.caption}} </option>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <div class=\"form-group\">\n              <select id=\"filter-operators\" type=\"select\" placeholder=\"Op\u00E7\u00F5es\" formControlName=\"operator\"\n                [compareWith]=\"compareWith()\">\n                <option *ngFor=\"let option of filterOptions\" [ngValue]=\"option\"> {{option.caption}}</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-sm-7\">\n            <div class=\"form-group\">\n              <div *ngIf=\"isDateTime()\" class=\"group-datetime\" id=\"dateTime\">\n                <elo-datepicker id=\"valorDate\" #valorFiltro formControlName=\"value\"></elo-datepicker>\n                <div class=\"input-time\">\n                  <input id=\"valorTime\" class=\"has-input-icon\" #filterHourValue type=\"time\" value=\"12:00\" />\n                  <i aria-hidden=\"true\" class=\"fa fa-clock-o input-icon\"></i>\n                </div>\n              </div>\n              <div id=\"inputFilter\" #inputFilter class=\"button-input\">\n                <div *ngIf=\"!isDate() && !isDateTime() && !isEnum && !isBoolean && !isTime()\">\n                  <input id=\"valor\" #valorFiltro type={{filterType}} formControlName=\"value\" formControlValidationMsg\n                    [placeholder]=\"placeHolder\" />\n                </div>\n                <div *ngIf=\"isDate()\">\n                  <elo-datepicker id=\"valorDate\" #valorFiltro formControlName=\"value\"></elo-datepicker>\n                </div>\n                <div *ngIf=\"isTime()\">\n                  <div class=\"input-time\">\n                    <input id=\"valorTime\" type=\"time\" formControlName=\"value\" />\n                  </div>\n                </div>\n                <div *ngIf=\"isEnum\">\n                  <elo-select id=\"valorSelect\" [options]=\"enumOptions\" formControlName=\"value\">\n                  </elo-select>\n                </div>\n                <div *ngIf=\"isBoolean\">\n                  <elo-select id=\"valorSelect\" [options]=\"booleanOptions\" formControlName=\"value\">\n                  </elo-select>\n                </div>\n              </div>\n              <button id=\"btnFilter\" #btnFiltro class=\"btn filter\" [ngClass]=\"{'has-input-datetime': isDateTime()}\"\n                [disabled]=\"disabledButton()\">\n                Filtrar\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"panel-filter-tags\" *ngIf=\"filterItens.length > 0\">\n      <span *ngFor=\"let filterItem of getValidFilter()\" class=\"filter-tag\">{{filterItem.field.caption}}\n        {{filterItem.operator.caption}} {{getSearchTagValue(filterItem)}}<i class=\"fa fa-times remove\"\n          (click)=\"removeFilter(filterItem)\"></i>\n      </span>\n    </div>\n  </form>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i1$2.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { kind: "component", type: DatePickerComponent, selector: "elo-datepicker", inputs: ["viewFormat", "modelFormat", "id", "disable"] }, { kind: "component", type: EloSelectComponent, selector: "elo-select", inputs: ["selectedValue", "options", "required", "compareWith"], outputs: ["onSelectChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SearchFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'search-filter', template: "<div class=\"panel-table-filter\">\n  <form [formGroup]=\"form\" (ngSubmit)=\"filter()\">\n    <div formArrayName=\"filterItens\">\n      <div [formGroup]=\"getFirstForm()\">\n        <div *ngIf=\"beforeExtraElement\">\n          <ng-container [ngTemplateOutlet]=\"beforeExtraElement\"></ng-container>\n        </div>\n        <div class=\"row\" [ngClass]=\"classInput\">\n          <div class=\"col-sm-3\">\n            <div class=\"form-group\">\n              <select id=\"filter-fields\" type=\"select\" placeholder=\"Campos\" formControlName=\"field\">\n                <option *ngFor=\"let field of _fieldsModels\" [ngValue]=\"field\">{{field.caption}} </option>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <div class=\"form-group\">\n              <select id=\"filter-operators\" type=\"select\" placeholder=\"Op\u00E7\u00F5es\" formControlName=\"operator\"\n                [compareWith]=\"compareWith()\">\n                <option *ngFor=\"let option of filterOptions\" [ngValue]=\"option\"> {{option.caption}}</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-sm-7\">\n            <div class=\"form-group\">\n              <div *ngIf=\"isDateTime()\" class=\"group-datetime\" id=\"dateTime\">\n                <elo-datepicker id=\"valorDate\" #valorFiltro formControlName=\"value\"></elo-datepicker>\n                <div class=\"input-time\">\n                  <input id=\"valorTime\" class=\"has-input-icon\" #filterHourValue type=\"time\" value=\"12:00\" />\n                  <i aria-hidden=\"true\" class=\"fa fa-clock-o input-icon\"></i>\n                </div>\n              </div>\n              <div id=\"inputFilter\" #inputFilter class=\"button-input\">\n                <div *ngIf=\"!isDate() && !isDateTime() && !isEnum && !isBoolean && !isTime()\">\n                  <input id=\"valor\" #valorFiltro type={{filterType}} formControlName=\"value\" formControlValidationMsg\n                    [placeholder]=\"placeHolder\" />\n                </div>\n                <div *ngIf=\"isDate()\">\n                  <elo-datepicker id=\"valorDate\" #valorFiltro formControlName=\"value\"></elo-datepicker>\n                </div>\n                <div *ngIf=\"isTime()\">\n                  <div class=\"input-time\">\n                    <input id=\"valorTime\" type=\"time\" formControlName=\"value\" />\n                  </div>\n                </div>\n                <div *ngIf=\"isEnum\">\n                  <elo-select id=\"valorSelect\" [options]=\"enumOptions\" formControlName=\"value\">\n                  </elo-select>\n                </div>\n                <div *ngIf=\"isBoolean\">\n                  <elo-select id=\"valorSelect\" [options]=\"booleanOptions\" formControlName=\"value\">\n                  </elo-select>\n                </div>\n              </div>\n              <button id=\"btnFilter\" #btnFiltro class=\"btn filter\" [ngClass]=\"{'has-input-datetime': isDateTime()}\"\n                [disabled]=\"disabledButton()\">\n                Filtrar\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"panel-filter-tags\" *ngIf=\"filterItens.length > 0\">\n      <span *ngFor=\"let filterItem of getValidFilter()\" class=\"filter-tag\">{{filterItem.field.caption}}\n        {{filterItem.operator.caption}} {{getSearchTagValue(filterItem)}}<i class=\"fa fa-times remove\"\n          (click)=\"removeFilter(filterItem)\"></i>\n      </span>\n    </div>\n  </form>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }], propDecorators: { defaultField: [{
                type: Input
            }], classInput: [{
                type: Input
            }], filtersDefaults: [{
                type: Input
            }], clearFilterOnSwitch: [{
                type: Input
            }], fieldsModels: [{
                type: Input
            }], findEntitiesOnInit: [{
                type: Input
            }], onFilter: [{
                type: Output
            }], filtro: [{
                type: ViewChild,
                args: ['valorFiltro']
            }], filterHour: [{
                type: ViewChild,
                args: ['filterHourValue']
            }], btnFiltro: [{
                type: ViewChild,
                args: ['btnFiltro', { static: true }]
            }], inputFilter: [{
                type: ViewChild,
                args: ['inputFilter', { static: true }]
            }], beforeExtraElement: [{
                type: Input
            }], allowSearch: [{
                type: Input
            }], notHasExtraFilter: [{
                type: Input
            }], defaultValueOperators: [{
                type: Input
            }] } });

class RouterUtils {
    static refreshCurrentPage(router, activatedRoute) {
        router.routeReuseStrategy.shouldReuseRoute = () => false;
        let currentUrl = router.url;
        currentUrl = currentUrl.split('?')[0];
        router.navigateByUrl(currentUrl).then(() => {
            router.navigated = false;
            router.navigate([currentUrl], { queryParams: activatedRoute.snapshot.queryParams });
        });
    }
    static sendToLogs(router, model, label, fields) {
        router.navigate(['/log'], {
            queryParams: {
                model, label, fields: fields.join(',')
            }
        });
    }
}

/**
 * Created by custodio on 07/07/2016.
 */
class PaginationComponent {
    constructor() {
        this.numberOfPages = 0;
        this.pageLinkSize = 5;
        this.highLight = false;
        this.hiddenOnlyPages = false;
        this.pageSize = 20;
        this.totalItens = 0;
        this.elementsOnThePage = 0;
        this.onPageChange = new EventEmitter();
        this.pageNumbers = [];
        this.pageSizes = [5, 10, 15, 20, 30, 40, 50, 100];
        this.currentPage = 1;
        this.allowShowAllItens = false;
    }
    ngOnChanges() {
        this.loadPageNumbers(this.currentPage);
    }
    first(event) {
        this.onChangePageNumber(1, event);
    }
    previous(event) {
        event.preventDefault();
        if (this.canGoPrevious()) {
            this.onChangePageNumber(this.currentPage - 1, event);
        }
    }
    next(event) {
        event.preventDefault();
        if (this.canGoNext()) {
            this.onChangePageNumber(this.currentPage + 1, event);
        }
    }
    last(event) {
        this.onChangePageNumber(this.numberOfPages, event);
    }
    onChangePageSize(value) {
        this.pageSize = value;
        this.currentPage = 1;
        this.emitOnPageChange();
    }
    onChangePageNumber(newCurrentPage, event) {
        event.preventDefault();
        if (this.currentPage !== newCurrentPage) {
            this.loadPageNumbers(newCurrentPage);
            this.currentPage = newCurrentPage;
            this.emitOnPageChange();
        }
    }
    firstElementerOfPage() {
        return this.baseCalculo() + 1;
    }
    lastElementerOfPage() {
        return this.baseCalculo() + this.elementsOnThePage;
    }
    baseCalculo() {
        return ((this.currentPage - 1) * this.pageSize);
    }
    emitOnPageChange() {
        this.onPageChange.emit(new PageParameters(this.pageSize, this.currentPage - 1));
    }
    loadPageNumbers(pageToGo) {
        if (this.pageLinkSize < 3) {
            this.pageLinkSize = 3;
        }
        this.pageNumbers = [];
        const FIRST_PAGE = 1;
        let start = Math.max(FIRST_PAGE, Math.ceil(pageToGo - (this.pageLinkSize / 2)));
        let end = Math.min(this.numberOfPages, (start + this.pageLinkSize - 1));
        if (this.isLastPage(end)) {
            start = Math.max(FIRST_PAGE, end - this.pageLinkSize + 1);
        }
        this.pageNumbers = [];
        for (let i = start; i <= end; i++) {
            this.pageNumbers.push(i);
        }
    }
    isLastPage(end) {
        return end === this.numberOfPages;
    }
    canGoPrevious() {
        return this.currentPage > 1;
    }
    canGoNext() {
        return this.currentPage < this.numberOfPages;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PaginationComponent, selector: "pagination-comp", inputs: { numberOfPages: "numberOfPages", pageLinkSize: "pageLinkSize", highLight: "highLight", hiddenOnlyPages: "hiddenOnlyPages", pageSize: "pageSize", totalItens: "totalItens", elementsOnThePage: "elementsOnThePage", pageSizes: "pageSizes", currentPage: "currentPage", allowShowAllItens: "allowShowAllItens" }, outputs: { onPageChange: "onPageChange" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"panel-pagination\">\n\n  <div class=\"sisters\">\n    <div class=\"number-itens\" *ngIf=\"!hiddenOnlyPages\">\n      <b> Mostrar </b>\n\n      <select id=\"pageSize\" name=\"pageSize\" [ngModel]=\"pageSize\" (ngModelChange)=\"onChangePageSize($event)\">\n        <option *ngIf=\"allowShowAllItens\" [ngValue]=\"9999\">Todos</option>\n        <option *ngFor=\"let c of pageSizes\" [ngValue]=\"c\">{{c}}</option>\n      </select>\n\n      <b> Itens </b>\n    </div> <!-- numberitens -->\n  </div><!-- sisters -->\n\n  <div class=\"sisters\">\n    <ul class=\"panel-pagination-inner\" *ngIf=\"!hiddenOnlyPages && pageSize !== 9999\">\n\n      <li class=\"page-item\" (click)=\"first($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-backward\"></span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"previous($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span aria-hidden=\"true\">&laquo;</span>\n        </a>\n      </li>\n\n      <li *ngFor=\"let p of pageNumbers\" [value]=\"p\" [class.active]=\"p === currentPage\"\n        (click)=\"onChangePageNumber(p,$event)\" class=\"page-item\"><a class=\"page-link\" href=\"#\">{{p}}</a></li>\n\n      <li class=\"page-item\" (click)=\"next($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Next\">\n          <span aria-hidden=\"true\">&raquo;</span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"last($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-forward\"></span>\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"sisters\" *ngIf=\"highLight\">\n    <div class=\"highLight\">\n      {{firstElementerOfPage()}} - {{lastElementerOfPage()}} de {{totalItens}}\n    </div>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pagination-comp', template: "<div class=\"panel-pagination\">\n\n  <div class=\"sisters\">\n    <div class=\"number-itens\" *ngIf=\"!hiddenOnlyPages\">\n      <b> Mostrar </b>\n\n      <select id=\"pageSize\" name=\"pageSize\" [ngModel]=\"pageSize\" (ngModelChange)=\"onChangePageSize($event)\">\n        <option *ngIf=\"allowShowAllItens\" [ngValue]=\"9999\">Todos</option>\n        <option *ngFor=\"let c of pageSizes\" [ngValue]=\"c\">{{c}}</option>\n      </select>\n\n      <b> Itens </b>\n    </div> <!-- numberitens -->\n  </div><!-- sisters -->\n\n  <div class=\"sisters\">\n    <ul class=\"panel-pagination-inner\" *ngIf=\"!hiddenOnlyPages && pageSize !== 9999\">\n\n      <li class=\"page-item\" (click)=\"first($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-backward\"></span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"previous($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span aria-hidden=\"true\">&laquo;</span>\n        </a>\n      </li>\n\n      <li *ngFor=\"let p of pageNumbers\" [value]=\"p\" [class.active]=\"p === currentPage\"\n        (click)=\"onChangePageNumber(p,$event)\" class=\"page-item\"><a class=\"page-link\" href=\"#\">{{p}}</a></li>\n\n      <li class=\"page-item\" (click)=\"next($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Next\">\n          <span aria-hidden=\"true\">&raquo;</span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"last($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-forward\"></span>\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"sisters\" *ngIf=\"highLight\">\n    <div class=\"highLight\">\n      {{firstElementerOfPage()}} - {{lastElementerOfPage()}} de {{totalItens}}\n    </div>\n  </div>\n</div>" }]
        }], propDecorators: { numberOfPages: [{
                type: Input
            }], pageLinkSize: [{
                type: Input
            }], highLight: [{
                type: Input
            }], hiddenOnlyPages: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], totalItens: [{
                type: Input
            }], elementsOnThePage: [{
                type: Input
            }], onPageChange: [{
                type: Output
            }], pageSizes: [{
                type: Input
            }], currentPage: [{
                type: Input
            }], allowShowAllItens: [{
                type: Input
            }] } });

const EMPTY_MESSAGE = 'Não foram encontrados resultados, adicione registros clicando em + .';
class CrudSearchComponent {
    set filters(filters) {
        this.filtersDefaults = filters;
        this.clearFilterOnSwitch = true;
        this.strFiltroPage = this.filtroPesquisa.attrFilters(filters);
        if (this.componentIniciou) {
            this.getEntities(this.strFiltroPage);
        }
    }
    constructor(routerService, router, windowService, location, activatedRoute, authHttp, eloNotificationService) {
        this.routerService = routerService;
        this.router = router;
        this.windowService = windowService;
        this.location = location;
        this.activatedRoute = activatedRoute;
        this.authHttp = authHttp;
        this.eloNotificationService = eloNotificationService;
        this.eventSelected = new EventEmitter();
        this.onClickRadioButton = new EventEmitter();
        this.onSearchFilterObject = new EventEmitter();
        this.shouldReuseFilter = true;
        this.defaultValueOperators = new Map();
        this.sortable = true;
        this.enableRemove = true;
        this.enableRemoveNotRole = false;
        this.messageDialogDelete = 'Apagar?';
        this.showDetailPage = false;
        this.showSearchFilter = true;
        this.enableEdit = true;
        this.enableLogs = true;
        this.enableView = true;
        this.enableCreate = true;
        this.enableTablePrint = true;
        this.removeVisibleWhenAttribute = '';
        this.visibleWhenAttribute = '';
        this.visibleWhenFunction = null;
        this.searchSelect = false;
        this.refreshEmit = null;
        this.changeLocationOnFilter = true;
        this.filterDefault = '';
        this.deleteFunction = null;
        this.editFunction = null;
        this.role = '';
        this.disableSpinner = false;
        this.quickViewOpener = false;
        this.titleNewButton = 'Novo';
        this.manyActions = true;
        this.callServiceFunction = null;
        this.classDataTable = '';
        this.expansivePanel = false;
        this.showButtonPanel = false;
        this.onReceivePage = new EventEmitter();
        this.onNewItem = new EventEmitter();
        this.onSearchEmitFilter = new EventEmitter();
        this.selectionMode = '';
        this.hasLinks = false;
        this.getLinks = null;
        this.visibleWhenFunctionLink = null;
        this.titleButtonNovo = 'Novo';
        this.enableRemoveAll = false;
        this.fixedSizeWhenMultipleSelection = true;
        this.useQueryParams = true;
        this.classInputFilter = '';
        this.onIconClicked = new EventEmitter();
        this.removeAllClicked = new EventEmitter();
        this.customPagesSize = [5, 10, 15, 20, 30, 40, 50, 100];
        this.showDelete = false;
        this.strFiltroPage = '';
        this.clearFilterOnSwitch = false;
        this.pageParameters = PageParameters.newPage(20);
        this.filtersDefaults = [];
        this.componentIniciou = false;
        this.rowDoubleClickFunction = null;
        this.enableDefaultRowDoubleClickFunction = true;
        this.allowSearch = true;
        this.enableScrollX = false;
        this.navigationExtras = { queryParams: null };
        this.showDeleteMessage = true;
        this.listenToRouteChanges = false;
        this.selectionModeId = '';
        this.emptyMessage = EMPTY_MESSAGE;
        this.headerFixo = false;
        this.fieldShowCheckbox = '';
        this.checkboxDisabledWhenFunction = null;
        this.visibleRadioWhenFunction = null;
        this.findEntitiesOnInit = true;
        this.notHasExtraFilter = false;
        this.rowDoubleClickEventEmitter = new EventEmitter();
        this.enableCustomHeader = false;
        this.showAuditInfoButton = false;
        this.showAuditInfoFilters = false;
        this.onAuditInfoButtonClick = new EventEmitter();
        this.selectionModeWithFooter = true;
        this.fieldsAuditInfo = [];
        this.defaultAuditFields = [
            "audit.usuarioAlteracao",
            "audit.usuarioCriacao",
            "audit.dataAlteracao",
            "audit.dataCriacao",
            "usuarioAlteracao",
            "usuarioCriacao",
            "dataAlteracao",
            "dataCriacao"
        ];
        this.filtroPesquisa = new SearchFilter();
    }
    ngOnInit() {
        this.componentIniciou = true;
        if (this.updateFieldsToFilter) {
            this.updateFieldsToFilter.subscribe(fields => {
                this.strFiltroPage = '';
                this.fieldsToFilter = fields;
                this.loadMetamodel();
            });
        }
        AssertUtilsApp.assert(this.entityService, 'entity service');
        AssertUtilsApp.assert(this.entityService.loadFieldModels, 'entity service loadFieldModels not found');
        AssertUtilsApp.assert(this.entityService.findAll, 'entity service findAll not found');
        this.loadFiltersFromQueryParams();
        if (!this.labelModelName) {
            this.labelModelName = this.entityService.entityLabel;
        }
        this.loadMetamodel();
        if (this.orderBy) {
            this.pageParameters.sort = this.orderBy;
        }
        if (this.findEntitiesOnInit) {
            this.getEntities(this.strFiltroPage);
        }
        if (this.refreshEmit) {
            this.refreshEmit.subscribe((id) => {
                id ? this.refreshContentById(id) : this.getEntities(this.strFiltroPage);
            });
        }
        if (this.role !== '') {
            this.verifyPermissions();
        }
        if (this.selectionMode === 'multiple') {
            this.enableDefaultRowDoubleClickFunction = false;
        }
        if (!this.findEntitiesOnInit) {
            this.emptyMessage = 'Clique em filtrar para trazer os resultados.';
        }
        this.rowDoubleClickEventEmitter.subscribe((selected) => this.selectItem(selected));
        if (this.location) {
            this.hasPermissionByRoute();
        }
    }
    ngOnDestroy() {
        if (this.updateFieldsToFilter) {
            this.updateFieldsToFilter.unsubscribe();
        }
    }
    loadMetamodel() {
        this.entityService
            .loadFieldModels(this.getFieldsToModel())
            .subscribe((model) => {
            this.setAuditInfoFilters(model);
            this.setFieldsModels(model);
            if (!this.modelName) {
                this.modelName = model.dataType;
            }
            if (!this.fieldsToDisplayForModelName?.length) {
                this.fieldsToDisplayForModelName = this.fieldsToFilter || this.fieldsToDisplay;
            }
        });
    }
    setAuditInfoFilters({ fields }) {
        const base = fields?.audit?.fields || fields || {};
        const { usuarioAlteracao, usuarioCriacao, dataAlteracao, dataCriacao } = base;
        this.fieldsAuditInfo = [usuarioAlteracao, usuarioCriacao, dataAlteracao, dataCriacao]
            .filter(campo => campo?.fieldFullPath);
    }
    ngAfterContentInit() {
        this.eloTableActions.forEach(tb => this.dataTable.addTableActions(tb));
    }
    onSelected(selected) {
        this.eventSelected.emit(selected);
    }
    selectItem(selected) {
        if (this.rowDoubleClickFunction) {
            this.rowDoubleClickFunction(selected);
        }
        else if (this.enableDefaultRowDoubleClickFunction) {
            this.eventSelected.emit(selected);
        }
    }
    onRowDoubleClick(selected) {
        this.rowDoubleClickEventEmitter.emit(selected);
    }
    clickRadioButton(selected) {
        this.onClickRadioButton.emit(selected);
    }
    onClickLink(object) {
        this.onIconClicked.emit(object);
    }
    onRemoveAllClicked(object) {
        this.removeAllClicked.emit(object);
    }
    getEntities(search) {
        if (this.callServiceFunction) {
            this.onSearchEmitFilter.emit(search);
            this.callServiceFunction(search, this.pageParameters).subscribe((data) => {
                this.crudPage = data;
                this.onReceivePage.emit({ data: this.crudPage, pagination: this.pageParameters });
                this.updateEmptyMessage();
            });
        }
        else {
            const filter = StringUtils.join([search, this.filterDefault], 'and');
            this.onSearchEmitFilter.emit(filter);
            const fieldsToGet = [
                'id',
                ...this.fieldsToDisplay
            ];
            if (this.showAuditInfoButton || this.showAuditInfoFilters) {
                fieldsToGet.push(...this.defaultAuditFields);
            }
            this.entityService
                .findAll(this.pageParameters, filter, fieldsToGet.toString(), this.disableSpinner)
                .subscribe(data => {
                this.crudPage = data;
                this.onReceivePage.emit(this.crudPage);
                this.updateEmptyMessage();
            });
        }
    }
    edit(crud) {
        if (this.editFunction) {
            this.editFunction(crud.id);
        }
        else {
            this.router.navigate([this.crudResource, crud.id], this.navigationExtras);
        }
    }
    view(crud) {
        this.router.navigateByUrl(`${this.crudResource}/${crud.id}/view`);
    }
    onPrint() {
        this.entityService.print(this.strFiltroPage, this.fieldsToPrint ? this.fieldsToPrint.toString() : this.fieldsToDisplay.toString(), this.pageParameters).subscribe(url => {
            const tab = this.windowService.openTab(url);
            if (tab) {
                tab.print();
            }
        });
    }
    viewLogs() {
        RouterUtils.sendToLogs(this.router, this.modelName, this.labelModelName, this.fieldsToDisplayForModelName);
    }
    new() {
        this.router.navigate([this.crudResource, 'new'], this.navigationExtras);
    }
    onPageChange(pageParameters) {
        this.pageParameters.size = pageParameters.size;
        this.pageParameters.page = pageParameters.page;
        this.getEntities(this.strFiltroPage);
    }
    onDelete(itemToRemove) {
        this.itemToRemove = itemToRemove;
        this.showDelete = true;
    }
    cancelDelete() {
        this.showDelete = false;
    }
    delete() {
        this.showDelete = false;
        const deleteFunc = this.deleteFunction ? this.deleteFunction : id => this.entityService.remove(id);
        deleteFunc(this.itemToRemove.id).subscribe(() => {
            this.getEntities(this.strFiltroPage);
            if (this.showDeleteMessage) {
                this.eloNotificationService.success(this.caption, 'Deletado(a) com sucesso');
            }
        });
    }
    onTableHeadClick(column) {
        const order = this.isAscSort(column) ? 'desc' : 'asc';
        this.pageParameters.sort = `${column},${order}`;
        this.pageParameters.sortWithTranslation = `${this.getColumnTranslated(column)},${order}`;
        this.getEntities(this.strFiltroPage);
    }
    onFilter(filters) {
        this.strFiltroPage = this.filtroPesquisa.onFilterCallback(filters, this.location, this.activatedRoute, this.routerService, (filter) => this.onSearchFilterObject.emit(filter), this.changeLocationOnFilter);
        this.pageParameters = PageParameters.newPage(this.pageParameters.size);
        if (this.orderBy) {
            this.pageParameters.sort = this.orderBy;
        }
        this.getEntities(this.strFiltroPage);
    }
    loadFiltersFromQueryParams() {
        this.filtroPesquisa.setUseQueryParams(this.useQueryParams);
        if (this.listenToRouteChanges && this.useQueryParams) {
            this.activatedRoute.queryParams.subscribe(({ filter }) => {
                if (filter) {
                    this.filtersDefaults = this.deserializeFilters(filter);
                    this.strFiltroPage = this.filtroPesquisa.attrFilters(this.filtersDefaults);
                }
            });
        }
        else if (this.hasFilter()) {
            this.filtersDefaults = this.deserializeFilters(this.activatedRoute.snapshot.queryParams['filter']);
            this.strFiltroPage = this.filtroPesquisa.attrFilters(this.filtersDefaults);
        }
    }
    verifyPermissions() {
        this.authHttp.getPermissionsByRole(this.role).subscribe(permissions => {
            this.verifyNew(permissions);
            this.verifyUpdate(permissions);
            this.verifyDelete(permissions);
            this.verifyView(permissions);
            this.verifyLogs(permissions);
        });
    }
    verifyNew(permissions) {
        this.enableCreate = this.enableCreate && permissions.some(p => p.toUpperCase().indexOf('CREATE') >= 0);
    }
    verifyUpdate(permissions) {
        this.enableEdit = this.enableEdit && permissions.some(p => p.toUpperCase().indexOf('UPDATE') >= 0);
    }
    verifyDelete(permissions) {
        this.enableRemove = this.enableRemove && permissions.some(p => p.toUpperCase().indexOf('DELETE') >= 0);
    }
    verifyView(permissions) {
        this.enableView = this.enableView && permissions.some(p => p.toUpperCase().indexOf('VIEW_DETAILS') >= 0);
    }
    verifyLogs(permissions) {
        this.enableLogs =
            this.enableLogs &&
                permissions.some((p) => p.toUpperCase().indexOf('VIEW_LOG') >= 0 ||
                    p.toUpperCase().endsWith('_LOG'));
    }
    hasPermissionByRoute() {
        const currentRoute = this.location.path();
        const pattern = /^\/([a-zA-Z\-]+)/;
        const route = currentRoute.match(pattern);
        if (route) {
            RolesCache.isLoaded.subscribe(isLoaded => {
                if (isLoaded) {
                    this.enableRemove = (this.enableRemove && (RolesCache.getAllRoles().includes(`${route[1]}-delete`) ||
                        RolesCache.getAllRoles().includes(`${this.role}_delete`))) || this.enableRemoveNotRole;
                }
            });
        }
    }
    onNewItemEvent() {
        this.onNewItem.emit();
    }
    isFixedSize() {
        return this.selectionMode === 'multiple' && this.fixedSizeWhenMultipleSelection;
    }
    getFieldsToModel() {
        const fields = [];
        if (this.fieldsToFilter) {
            fields.push(...this.fieldsToFilter);
        }
        if (this.fieldsToDisplay) {
            fields.push(...this.fieldsToDisplay);
        }
        if (this.showAuditInfoButton || this.showAuditInfoFilters) {
            fields.push(...this.defaultAuditFields);
        }
        return Array.from(new Set(fields)).join(',');
    }
    isAscSort(column) {
        return this.pageParameters.sort && this.pageParameters.sort.indexOf(column) !== -1 && this.pageParameters.sort.indexOf('asc') !== -1;
    }
    hasFilter() {
        return this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams['filter'] && this.useQueryParams;
    }
    deserializeFilters(filters) {
        return filters.split(',').map(filter => {
            const arrayValues = filter.split(';');
            if ([CONTAINED_IN_OPERATION, NOT_CONTAINED_IN_OPERATION].includes(parseInt(arrayValues[1]))) {
                arrayValues[2] = StringUtils.replaceAll(arrayValues[2], PIPE_ENCODED, ',');
                arrayValues[2] = StringUtils.replaceAll(arrayValues[2], '|', ',');
            }
            return { field: arrayValues[0], op: parseInt(arrayValues[1]), value: arrayValues[2] };
        });
    }
    setFieldsModels(model) {
        const fieldsToFilter = this.fieldsToFilter ? [...this.fieldsToFilter] : [...this.fieldsToDisplay];
        if (this.showAuditInfoFilters) {
            this.fieldsAuditInfo.forEach(field => fieldsToFilter.push(field.fieldFullPath));
            Object.values(model.fields || {}).forEach(m => {
                if (m.dataType === "AuditInfo" && m.caption === 'audit') {
                    m.caption = '';
                }
            });
        }
        this.fieldsModels = this.filtroPesquisa.handleModel(model, this.fieldsToDisplay);
        this.fieldsModelsFilter = this.filtroPesquisa.handleModel(model, fieldsToFilter);
    }
    getColumnTranslated(column) {
        let founds = this.fieldsModels.filter(f => f.fieldName === column);
        if (founds[0] && founds[0].isCalculatedModel) {
            return founds[0].fieldPath;
        }
        return column;
    }
    getAuditInfo(fieldsAuditInfo) {
        return registro => {
            const historico = fieldsAuditInfo
                ?.map(modelField => {
                let fieldValue = modelField.fieldFullPath
                    .split('.')
                    .reduce((oldField, fieldName) => oldField && oldField[fieldName], registro);
                const date = DateUtils.formatToUTC(fieldValue, DATEHOURMODELFORMAT);
                if (date.isValid()) {
                    fieldValue = date.format(DATEHOURVIEWFORMAT);
                }
                return !!fieldValue && `${modelField.caption}: ${fieldValue}`;
            })
                .filter(f => f);
            if (!historico?.length) {
                return null;
            }
            return historico;
        };
    }
    updateEmptyMessage() {
        if (!this.findEntitiesOnInit) {
            this.emptyMessage = EMPTY_MESSAGE;
        }
    }
    refreshContentById(id) {
        if (!this.crudPage?.content || this.crudPage?.content.length === 0)
            return;
        const indexContent = this.crudPage.content.findIndex(content => content.id === id);
        this.findEntityAndUpdateByIndex(indexContent, id);
    }
    findEntityAndUpdateByIndex(indexContent, idEntity) {
        if (this.isValidIndex(indexContent)) {
            this.entityService.findOne(idEntity, this.fieldsToDisplay.join(','))
                .subscribe(entity => {
                this.crudPage.content[indexContent] = entity;
            });
        }
    }
    isValidIndex(index) {
        return index !== -1;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchComponent, deps: [{ token: RouterService }, { token: i1$4.Router }, { token: WindowService }, { token: i1.Location }, { token: i1$4.ActivatedRoute }, { token: AbstractAuthHttp }, { token: EloNotificationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudSearchComponent, selector: "crud-search", inputs: { shouldReuseFilter: "shouldReuseFilter", caption: "caption", crudResource: "crudResource", entityService: "entityService", fieldsToDisplay: "fieldsToDisplay", fieldsToFilter: "fieldsToFilter", updateFieldsToFilter: "updateFieldsToFilter", defaultValueOperators: "defaultValueOperators", fieldsToPrint: "fieldsToPrint", defaultField: "defaultField", orderBy: "orderBy", sortable: "sortable", enableRemove: "enableRemove", enableRemoveNotRole: "enableRemoveNotRole", messageDialogDelete: "messageDialogDelete", showDetailPage: "showDetailPage", showSearchFilter: "showSearchFilter", enableEdit: "enableEdit", enableLogs: "enableLogs", enableView: "enableView", enableCreate: "enableCreate", enableTablePrint: "enableTablePrint", removeVisibleWhenAttribute: "removeVisibleWhenAttribute", visibleWhenAttribute: "visibleWhenAttribute", visibleWhenFunction: "visibleWhenFunction", searchSelect: "searchSelect", refreshEmit: "refreshEmit", changeLocationOnFilter: "changeLocationOnFilter", filterDefault: "filterDefault", deleteFunction: "deleteFunction", editFunction: "editFunction", role: "role", disableSpinner: "disableSpinner", quickViewOpener: "quickViewOpener", titleNewButton: "titleNewButton", manyActions: "manyActions", callServiceFunction: "callServiceFunction", classDataTable: "classDataTable", expansivePanel: "expansivePanel", showButtonPanel: "showButtonPanel", selection: "selection", selectionMode: "selectionMode", dataTableFooterDynamic: "dataTableFooterDynamic", dataTableSubtitlesDynamic: "dataTableSubtitlesDynamic", hasLinks: "hasLinks", getLinks: "getLinks", visibleWhenFunctionLink: "visibleWhenFunctionLink", titleButtonNovo: "titleButtonNovo", modelName: "modelName", labelModelName: "labelModelName", fieldsToDisplayForModelName: "fieldsToDisplayForModelName", enableRemoveAll: "enableRemoveAll", fixedSizeWhenMultipleSelection: "fixedSizeWhenMultipleSelection", useQueryParams: "useQueryParams", classInputFilter: "classInputFilter", customPagesSize: "customPagesSize", pageParameters: "pageParameters", filters: "filters", beforeExtraElement: "beforeExtraElement", rowDoubleClickFunction: "rowDoubleClickFunction", enableDefaultRowDoubleClickFunction: "enableDefaultRowDoubleClickFunction", allowSearch: "allowSearch", enableScrollX: "enableScrollX", navigationExtras: "navigationExtras", showDeleteMessage: "showDeleteMessage", listenToRouteChanges: "listenToRouteChanges", selectionModeId: "selectionModeId", emptyMessage: "emptyMessage", headerFixo: "headerFixo", fieldShowCheckbox: "fieldShowCheckbox", checkboxDisabledWhenFunction: "checkboxDisabledWhenFunction", visibleRadioWhenFunction: "visibleRadioWhenFunction", findEntitiesOnInit: "findEntitiesOnInit", notHasExtraFilter: "notHasExtraFilter", enableCustomHeader: "enableCustomHeader", customHeaderStyle: "customHeaderStyle", showAuditInfoButton: "showAuditInfoButton", showAuditInfoFilters: "showAuditInfoFilters", selectionModeWithFooter: "selectionModeWithFooter" }, outputs: { eventSelected: "eventSelected", onClickRadioButton: "onClickRadioButton", onSearchFilterObject: "onSearchFilterObject", onReceivePage: "onReceivePage", onNewItem: "onNewItem", onSearchEmitFilter: "onSearchEmitFilter", onIconClicked: "onIconClicked", removeAllClicked: "removeAllClicked", rowDoubleClickEventEmitter: "rowDoubleClickEventEmitter", onAuditInfoButtonClick: "onAuditInfoButtonClick" }, queries: [{ propertyName: "eloColumnsTemplate", first: true, predicate: ["eloColumns"], descendants: true }, { propertyName: "expandTemplate", first: true, predicate: ["dataTableExpand"], descendants: true }, { propertyName: "headers", first: true, predicate: ["eloHeaders"], descendants: true }, { propertyName: "eloTableActions", predicate: EloTableActionsComponent }], viewQueries: [{ propertyName: "dataTable", first: true, predicate: EloDatatableComponent, descendants: true, static: true }, { propertyName: "searchFilter", first: true, predicate: SearchFilterComponent, descendants: true, static: true }], ngImport: i0, template: "<div>\n  <ng-content></ng-content>\n\n  <elo-dialog id=\"dialog-delete\" [show]=\"showDelete\" (onOkEvent)=\"delete()\" (onCancelEvent)=\"cancelDelete()\">\n    <div>{{messageDialogDelete}}</div>\n  </elo-dialog>\n\n  <elo-panel-expansive title=\"{{caption}}\" [hasTable]=\"true\" [hasForm]=\"false\" [expansive]=\"expansivePanel\"\n    [showButton]=\"showButtonPanel\" (onNewItem)=\"onNewItemEvent()\" [titleButtonNovo]=\"titleButtonNovo\"\n    [enableScrollX]=\"enableScrollX\">\n\n    <search-filter *ngIf=\"showSearchFilter\" [filtersDefaults]=\"filtersDefaults\" [fieldsModels]=\"fieldsModelsFilter\"\n      (onFilter)=\"onFilter($event)\" [defaultField]=\"defaultField\" [beforeExtraElement]=\"beforeExtraElement\"\n      [allowSearch]=\"allowSearch\" [classInput]=\"classInputFilter\" [findEntitiesOnInit]=\"findEntitiesOnInit\"\n      [notHasExtraFilter]=\"notHasExtraFilter\" [defaultValueOperators]=\"defaultValueOperators\" [clearFilterOnSwitch]=\"clearFilterOnSwitch\">\n    </search-filter>\n\n    <div class=\"row custom-header\" [style]=\"customHeaderStyle\" *ngIf=\"enableCustomHeader && headers\">\n      <ng-container [ngTemplateOutlet]=\"headers\"></ng-container>\n    </div>\n\n    <elo-datatable [values]=\"crudPage?.content\"\n      [class]=\"'striped fancy ' + (isFixedSize() ? 'fixed ' : '') + classDataTable\" [pageParameters]=\"pageParameters\"\n      [sortable]=\"sortable\" (onTableHeadClick)=\"onTableHeadClick($event)\" [selection]=\"selection\"\n      [selectionMode]=\"selectionMode\" (onModifySelection)=\"onSelected($event)\" (onSelectOne)=\"onSelected($event)\"\n      [isQuickViewOpener]=\"quickViewOpener\" [manyActions]=\"manyActions\" [paramExpandTemplate]=\"expandTemplate\"\n      (onRowDoubleClick)=\"onRowDoubleClick($event)\" [enableScrollX]=\"enableScrollX\" [selectionModeId]=\"selectionModeId\"\n      [emptyMessage]=\"emptyMessage\" [headerFixo]=\"headerFixo\" (onClickRadioButton)=\"clickRadioButton($event)\"\n      [fieldShowCheckbox]=\"fieldShowCheckbox\" [checkboxDisabledWhenFunction]=\"checkboxDisabledWhenFunction\"\n      [visibleRadioWhenFunction]=\"visibleRadioWhenFunction\" [selectionModeWithFooter]=\"selectionModeWithFooter\">\n      <div *ngIf=\"!eloColumnsTemplate\">\n        <elo-column *ngFor=\"let field of fieldsModels\" [enumOptions]=\"field.enumOptions\"\n          [field]=\"field.isCalculatedModel ? field.fieldName : field.fieldPath\" [header]=field.caption\n          [isDate]=\"field.dataType === 'LocalDate'\" [isDateTime]=\"field.dataType === 'LocalDateTime'\"></elo-column>\n      </div>\n      <div *ngIf=\"eloColumnsTemplate\" [ngTemplateOutlet]=\"eloColumnsTemplate\"\n        [ngTemplateOutletContext]=\"{dataTable: dataTable, fieldsModels: fieldsModels}\"></div>\n\n      <ng-template #dataTableFooter>\n        <ng-container [ngTemplateOutlet]=\"dataTableFooterDynamic\"></ng-container>\n      </ng-template>\n\n      <elo-header-actions [id]=\"'removeAll'\" icon='fa fa-trash' description='Remover Todos'\n        (onClickIconButton)=\"onRemoveAllClicked($event)\" *ngIf=\"enableRemoveAll\">\n      </elo-header-actions>\n\n      <elo-header-actions [id]=\"'btn-print'\" icon='fa fa-print' description='Imprimir' (onClickIconButton)=\"onPrint()\"\n        *ngIf=\"enableTablePrint && !searchSelect\"></elo-header-actions>\n\n      <elo-header-actions [id]=\"'log'\" icon='fa fa-history' description='Ver Logs' (onClickIconButton)=\"viewLogs()\"\n        *ngIf=\"modelName && fieldsToDisplayForModelName && labelModelName && enableLogs\">\n      </elo-header-actions>\n\n      <elo-table-actions [title]=\"'Visualizar'\" *ngIf=\"!searchSelect && enableView\" icon=\"fa fa-eye\" id=\"idView\"\n        (onClickIconButton)=\"view($event)\" [visibleWhenAttribute]=\"visibleWhenAttribute\"\n        [visibleWhenFunction]=\"visibleWhenFunction\">\n      </elo-table-actions>\n\n      <elo-table-actions [title]=\"'Editar'\" *ngIf=\"!searchSelect && enableEdit\" icon='fa fa-pencil' id=\"idedit\"\n        (onClickIconButton)=\"edit($event)\" [visibleWhenAttribute]=\"visibleWhenAttribute\"\n        [visibleWhenFunction]=\"visibleWhenFunction\"></elo-table-actions>\n\n      <elo-table-actions id=\"btn-add\" [title]=\"'Adicionar'\" *ngIf=\"searchSelect\" icon='fa fa-plus'\n        (onClickIconButton)=\"onSelected($event)\"></elo-table-actions>\n\n      <elo-table-actions [title]=\"'Remover'\" *ngIf=\"!searchSelect && enableRemove\" icon='fa fa-trash' id=\"idremove\"\n        (onClickIconButton)=\"onDelete($event)\" [visibleWhenAttribute]=\"visibleWhenAttribute\" [removeAutoFocus]=\"true\"\n        [visibleWhenFunction]=\"visibleWhenFunction\"></elo-table-actions>\n\n      <elo-table-actions [visibleWhenFunction]=\"visibleWhenFunctionLink\" icon='fa fa-list-ul' id=\"idLinks\"\n        (onClickLink)=\"onClickLink($event)\" [linksFunction]=\"getLinks\" [hasLinks]=\"hasLinks\" *ngIf=\"hasLinks\">\n      </elo-table-actions>\n\n      <elo-table-actions [visibleWhenFunction]=\"getAuditInfo(fieldsAuditInfo)\" icon=\"fa fa-history\" id=\"idAuditInfo\" \n        (onClickLink)=\"onAuditInfoButtonClick.emit($event)\" [linksFunction]=\"getAuditInfo(fieldsAuditInfo)\" \n        [hasLinks]=\"true\" *ngIf=\"showAuditInfoButton\">\n      </elo-table-actions>\n\n    </elo-datatable>\n\n    <pagination-comp [hidden]=\"crudPage?.content?.length == 0\" [currentPage]=\"crudPage?.number+1\"\n      [numberOfPages]=\"crudPage?.totalPages\" (onPageChange)=\"onPageChange($event)\" [pageSize]=\"pageParameters.size\"\n      [pageSizes]=\"customPagesSize\" [allowShowAllItens]=\"(selectionMode == 'multiple')\"\n      [highLight]=\"showDetailPage\" [totalItens]=\"crudPage?.totalElements\" [elementsOnThePage]=\"crudPage?.numberOfElements\">\n    </pagination-comp>\n\n    <div #dataTableSubtitles class=\"subtitles\">\n      <ng-container *ngTemplateOutlet=\"dataTableSubtitlesDynamic\"></ng-container>\n    </div>\n\n  </elo-panel-expansive>\n\n  <div *ngIf=\"enableCreate\" class=\"btn-save\">\n    <button type=\"button\" title=\"Novo\" id=\"novo\" ref=\"novo\" class=\"btn neutral hint clean module-color\" (click)=\"new()\">\n      <div class=\"hint-content\">\n        {{titleNewButton}}\n      </div>\n    </button>\n  </div>\n</div>\n", dependencies: [{ kind: "component", type: EloDatatableComponent, selector: "elo-datatable", inputs: ["values", "paramExpandTemplate", "emptyMessage", "selection", "selectionMode", "selectionModeId", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "titleCheckboxDisallowed", "sortable", "pageParameters", "class", "colSpanActions", "isQuickViewOpener", "manyActions", "classEmptyMessage", "rowDoubleClickFunction", "visibleRadioWhenFunction", "enableScrollX", "textTransform", "headerFixo", "showHeader", "selectionModeWithFooter"], outputs: ["onClickCheckbox", "onClickRadioButton", "onSelectOne", "onModifySelection", "onTableHeadClick", "onInputChange", "onRowDoubleClick"] }, { kind: "component", type: EloColumnComponent, selector: "elo-column", inputs: ["field", "header", "headerAlign", "isDecimal", "isPercentual", "digits", "isDate", "isDateTime", "isCnpjCpf", "enumOptions", "col", "class", "isEditable", "isEditing", "dataTable", "hidden", "hiddenTableData", "sortable", "samp", "headerStyle", "dataStyle"] }, { kind: "component", type: EloTableActionsComponent, selector: "elo-table-actions", inputs: ["showError", "hasLinks", "links", "linksFunction", "quickViewOpener", "removeAutoFocus"], outputs: ["onClickLink", "onClickIconButton", "onHoverIconButton"] }, { kind: "component", type: EloHeaderActionsComponent, selector: "elo-header-actions", inputs: ["icon", "visible", "id", "description", "template"], outputs: ["onClickIconButton"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: PaginationComponent, selector: "pagination-comp", inputs: ["numberOfPages", "pageLinkSize", "highLight", "hiddenOnlyPages", "pageSize", "totalItens", "elementsOnThePage", "pageSizes", "currentPage", "allowShowAllItens"], outputs: ["onPageChange"] }, { kind: "component", type: DialogComponent, selector: "elo-dialog", inputs: ["show", "showCancel", "classType", "tittleCancel", "tittleOk", "title", "disableOkButton", "debounceTime"], outputs: ["onOkEvent", "onCancelEvent"] }, { kind: "component", type: PanelExpansiveComponent, selector: "elo-panel-expansive", inputs: ["collapsed", "title", "hasTable", "hasForm", "expansive", "showButton", "disabledButton", "hideButtonNovo", "titleButtonNovo", "extraButtons", "enableScrollX", "isInsideTab", "collapsedCookie", "error"], outputs: ["onExpand", "onNewItem"] }, { kind: "component", type: SearchFilterComponent, selector: "search-filter", inputs: ["defaultField", "classInput", "filtersDefaults", "clearFilterOnSwitch", "fieldsModels", "findEntitiesOnInit", "beforeExtraElement", "allowSearch", "notHasExtraFilter", "defaultValueOperators"], outputs: ["onFilter"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'crud-search', template: "<div>\n  <ng-content></ng-content>\n\n  <elo-dialog id=\"dialog-delete\" [show]=\"showDelete\" (onOkEvent)=\"delete()\" (onCancelEvent)=\"cancelDelete()\">\n    <div>{{messageDialogDelete}}</div>\n  </elo-dialog>\n\n  <elo-panel-expansive title=\"{{caption}}\" [hasTable]=\"true\" [hasForm]=\"false\" [expansive]=\"expansivePanel\"\n    [showButton]=\"showButtonPanel\" (onNewItem)=\"onNewItemEvent()\" [titleButtonNovo]=\"titleButtonNovo\"\n    [enableScrollX]=\"enableScrollX\">\n\n    <search-filter *ngIf=\"showSearchFilter\" [filtersDefaults]=\"filtersDefaults\" [fieldsModels]=\"fieldsModelsFilter\"\n      (onFilter)=\"onFilter($event)\" [defaultField]=\"defaultField\" [beforeExtraElement]=\"beforeExtraElement\"\n      [allowSearch]=\"allowSearch\" [classInput]=\"classInputFilter\" [findEntitiesOnInit]=\"findEntitiesOnInit\"\n      [notHasExtraFilter]=\"notHasExtraFilter\" [defaultValueOperators]=\"defaultValueOperators\" [clearFilterOnSwitch]=\"clearFilterOnSwitch\">\n    </search-filter>\n\n    <div class=\"row custom-header\" [style]=\"customHeaderStyle\" *ngIf=\"enableCustomHeader && headers\">\n      <ng-container [ngTemplateOutlet]=\"headers\"></ng-container>\n    </div>\n\n    <elo-datatable [values]=\"crudPage?.content\"\n      [class]=\"'striped fancy ' + (isFixedSize() ? 'fixed ' : '') + classDataTable\" [pageParameters]=\"pageParameters\"\n      [sortable]=\"sortable\" (onTableHeadClick)=\"onTableHeadClick($event)\" [selection]=\"selection\"\n      [selectionMode]=\"selectionMode\" (onModifySelection)=\"onSelected($event)\" (onSelectOne)=\"onSelected($event)\"\n      [isQuickViewOpener]=\"quickViewOpener\" [manyActions]=\"manyActions\" [paramExpandTemplate]=\"expandTemplate\"\n      (onRowDoubleClick)=\"onRowDoubleClick($event)\" [enableScrollX]=\"enableScrollX\" [selectionModeId]=\"selectionModeId\"\n      [emptyMessage]=\"emptyMessage\" [headerFixo]=\"headerFixo\" (onClickRadioButton)=\"clickRadioButton($event)\"\n      [fieldShowCheckbox]=\"fieldShowCheckbox\" [checkboxDisabledWhenFunction]=\"checkboxDisabledWhenFunction\"\n      [visibleRadioWhenFunction]=\"visibleRadioWhenFunction\" [selectionModeWithFooter]=\"selectionModeWithFooter\">\n      <div *ngIf=\"!eloColumnsTemplate\">\n        <elo-column *ngFor=\"let field of fieldsModels\" [enumOptions]=\"field.enumOptions\"\n          [field]=\"field.isCalculatedModel ? field.fieldName : field.fieldPath\" [header]=field.caption\n          [isDate]=\"field.dataType === 'LocalDate'\" [isDateTime]=\"field.dataType === 'LocalDateTime'\"></elo-column>\n      </div>\n      <div *ngIf=\"eloColumnsTemplate\" [ngTemplateOutlet]=\"eloColumnsTemplate\"\n        [ngTemplateOutletContext]=\"{dataTable: dataTable, fieldsModels: fieldsModels}\"></div>\n\n      <ng-template #dataTableFooter>\n        <ng-container [ngTemplateOutlet]=\"dataTableFooterDynamic\"></ng-container>\n      </ng-template>\n\n      <elo-header-actions [id]=\"'removeAll'\" icon='fa fa-trash' description='Remover Todos'\n        (onClickIconButton)=\"onRemoveAllClicked($event)\" *ngIf=\"enableRemoveAll\">\n      </elo-header-actions>\n\n      <elo-header-actions [id]=\"'btn-print'\" icon='fa fa-print' description='Imprimir' (onClickIconButton)=\"onPrint()\"\n        *ngIf=\"enableTablePrint && !searchSelect\"></elo-header-actions>\n\n      <elo-header-actions [id]=\"'log'\" icon='fa fa-history' description='Ver Logs' (onClickIconButton)=\"viewLogs()\"\n        *ngIf=\"modelName && fieldsToDisplayForModelName && labelModelName && enableLogs\">\n      </elo-header-actions>\n\n      <elo-table-actions [title]=\"'Visualizar'\" *ngIf=\"!searchSelect && enableView\" icon=\"fa fa-eye\" id=\"idView\"\n        (onClickIconButton)=\"view($event)\" [visibleWhenAttribute]=\"visibleWhenAttribute\"\n        [visibleWhenFunction]=\"visibleWhenFunction\">\n      </elo-table-actions>\n\n      <elo-table-actions [title]=\"'Editar'\" *ngIf=\"!searchSelect && enableEdit\" icon='fa fa-pencil' id=\"idedit\"\n        (onClickIconButton)=\"edit($event)\" [visibleWhenAttribute]=\"visibleWhenAttribute\"\n        [visibleWhenFunction]=\"visibleWhenFunction\"></elo-table-actions>\n\n      <elo-table-actions id=\"btn-add\" [title]=\"'Adicionar'\" *ngIf=\"searchSelect\" icon='fa fa-plus'\n        (onClickIconButton)=\"onSelected($event)\"></elo-table-actions>\n\n      <elo-table-actions [title]=\"'Remover'\" *ngIf=\"!searchSelect && enableRemove\" icon='fa fa-trash' id=\"idremove\"\n        (onClickIconButton)=\"onDelete($event)\" [visibleWhenAttribute]=\"visibleWhenAttribute\" [removeAutoFocus]=\"true\"\n        [visibleWhenFunction]=\"visibleWhenFunction\"></elo-table-actions>\n\n      <elo-table-actions [visibleWhenFunction]=\"visibleWhenFunctionLink\" icon='fa fa-list-ul' id=\"idLinks\"\n        (onClickLink)=\"onClickLink($event)\" [linksFunction]=\"getLinks\" [hasLinks]=\"hasLinks\" *ngIf=\"hasLinks\">\n      </elo-table-actions>\n\n      <elo-table-actions [visibleWhenFunction]=\"getAuditInfo(fieldsAuditInfo)\" icon=\"fa fa-history\" id=\"idAuditInfo\" \n        (onClickLink)=\"onAuditInfoButtonClick.emit($event)\" [linksFunction]=\"getAuditInfo(fieldsAuditInfo)\" \n        [hasLinks]=\"true\" *ngIf=\"showAuditInfoButton\">\n      </elo-table-actions>\n\n    </elo-datatable>\n\n    <pagination-comp [hidden]=\"crudPage?.content?.length == 0\" [currentPage]=\"crudPage?.number+1\"\n      [numberOfPages]=\"crudPage?.totalPages\" (onPageChange)=\"onPageChange($event)\" [pageSize]=\"pageParameters.size\"\n      [pageSizes]=\"customPagesSize\" [allowShowAllItens]=\"(selectionMode == 'multiple')\"\n      [highLight]=\"showDetailPage\" [totalItens]=\"crudPage?.totalElements\" [elementsOnThePage]=\"crudPage?.numberOfElements\">\n    </pagination-comp>\n\n    <div #dataTableSubtitles class=\"subtitles\">\n      <ng-container *ngTemplateOutlet=\"dataTableSubtitlesDynamic\"></ng-container>\n    </div>\n\n  </elo-panel-expansive>\n\n  <div *ngIf=\"enableCreate\" class=\"btn-save\">\n    <button type=\"button\" title=\"Novo\" id=\"novo\" ref=\"novo\" class=\"btn neutral hint clean module-color\" (click)=\"new()\">\n      <div class=\"hint-content\">\n        {{titleNewButton}}\n      </div>\n    </button>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: RouterService }, { type: i1$4.Router }, { type: WindowService }, { type: i1.Location }, { type: i1$4.ActivatedRoute }, { type: AbstractAuthHttp }, { type: EloNotificationService }], propDecorators: { eventSelected: [{
                type: Output
            }], onClickRadioButton: [{
                type: Output
            }], onSearchFilterObject: [{
                type: Output
            }], shouldReuseFilter: [{
                type: Input
            }], caption: [{
                type: Input
            }], crudResource: [{
                type: Input
            }], entityService: [{
                type: Input
            }], fieldsToDisplay: [{
                type: Input
            }], fieldsToFilter: [{
                type: Input
            }], updateFieldsToFilter: [{
                type: Input
            }], defaultValueOperators: [{
                type: Input
            }], fieldsToPrint: [{
                type: Input
            }], defaultField: [{
                type: Input
            }], orderBy: [{
                type: Input
            }], sortable: [{
                type: Input
            }], enableRemove: [{
                type: Input
            }], enableRemoveNotRole: [{
                type: Input
            }], messageDialogDelete: [{
                type: Input
            }], showDetailPage: [{
                type: Input
            }], showSearchFilter: [{
                type: Input
            }], enableEdit: [{
                type: Input
            }], enableLogs: [{
                type: Input
            }], enableView: [{
                type: Input
            }], enableCreate: [{
                type: Input
            }], enableTablePrint: [{
                type: Input
            }], removeVisibleWhenAttribute: [{
                type: Input
            }], visibleWhenAttribute: [{
                type: Input
            }], visibleWhenFunction: [{
                type: Input
            }], searchSelect: [{
                type: Input
            }], refreshEmit: [{
                type: Input
            }], changeLocationOnFilter: [{
                type: Input
            }], filterDefault: [{
                type: Input
            }], deleteFunction: [{
                type: Input
            }], editFunction: [{
                type: Input
            }], role: [{
                type: Input
            }], disableSpinner: [{
                type: Input
            }], quickViewOpener: [{
                type: Input
            }], titleNewButton: [{
                type: Input
            }], manyActions: [{
                type: Input
            }], callServiceFunction: [{
                type: Input
            }], classDataTable: [{
                type: Input
            }], expansivePanel: [{
                type: Input
            }], showButtonPanel: [{
                type: Input
            }], onReceivePage: [{
                type: Output
            }], onNewItem: [{
                type: Output
            }], onSearchEmitFilter: [{
                type: Output
            }], selection: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], dataTableFooterDynamic: [{
                type: Input
            }], dataTableSubtitlesDynamic: [{
                type: Input
            }], hasLinks: [{
                type: Input
            }], getLinks: [{
                type: Input
            }], visibleWhenFunctionLink: [{
                type: Input
            }], titleButtonNovo: [{
                type: Input
            }], modelName: [{
                type: Input
            }], labelModelName: [{
                type: Input
            }], fieldsToDisplayForModelName: [{
                type: Input
            }], enableRemoveAll: [{
                type: Input
            }], fixedSizeWhenMultipleSelection: [{
                type: Input
            }], useQueryParams: [{
                type: Input
            }], classInputFilter: [{
                type: Input
            }], onIconClicked: [{
                type: Output
            }], removeAllClicked: [{
                type: Output
            }], eloColumnsTemplate: [{
                type: ContentChild,
                args: ['eloColumns']
            }], expandTemplate: [{
                type: ContentChild,
                args: ['dataTableExpand']
            }], customPagesSize: [{
                type: Input
            }], pageParameters: [{
                type: Input
            }], filters: [{
                type: Input
            }], eloTableActions: [{
                type: ContentChildren,
                args: [EloTableActionsComponent]
            }], dataTable: [{
                type: ViewChild,
                args: [EloDatatableComponent, { static: true }]
            }], searchFilter: [{
                type: ViewChild,
                args: [SearchFilterComponent, { static: true }]
            }], beforeExtraElement: [{
                type: Input
            }], rowDoubleClickFunction: [{
                type: Input
            }], enableDefaultRowDoubleClickFunction: [{
                type: Input
            }], allowSearch: [{
                type: Input
            }], enableScrollX: [{
                type: Input
            }], navigationExtras: [{
                type: Input
            }], showDeleteMessage: [{
                type: Input
            }], listenToRouteChanges: [{
                type: Input
            }], selectionModeId: [{
                type: Input
            }], emptyMessage: [{
                type: Input
            }], headerFixo: [{
                type: Input
            }], fieldShowCheckbox: [{
                type: Input
            }], checkboxDisabledWhenFunction: [{
                type: Input
            }], visibleRadioWhenFunction: [{
                type: Input
            }], findEntitiesOnInit: [{
                type: Input
            }], notHasExtraFilter: [{
                type: Input
            }], rowDoubleClickEventEmitter: [{
                type: Output
            }], enableCustomHeader: [{
                type: Input
            }], customHeaderStyle: [{
                type: Input
            }], showAuditInfoButton: [{
                type: Input
            }], showAuditInfoFilters: [{
                type: Input
            }], onAuditInfoButtonClick: [{
                type: Output
            }], headers: [{
                type: ContentChild,
                args: ['eloHeaders']
            }], selectionModeWithFooter: [{
                type: Input
            }] } });

class CrudFormSimpleChildPaginatedComponent {
    constructor() {
        this.fieldsToDisplay = [];
        this.orderBy = '';
        this.checkBoxLabel = '';
        this.filterChild = '';
        this.refreshSearchEmit = new EventEmitter();
        this.internalFilterChild = '';
    }
    addChild(child) {
        this.addChildFunction(child).subscribe(() => this.refreshSearchEmit.emit());
    }
    removeChild(child) {
        this.removeChildFunction(child).subscribe(() => this.refreshSearchEmit.emit());
    }
    allowRemove() {
        return data => this.allowRemoveChildFunction(data);
    }
    allowAdd() {
        return data => !this.allowRemoveChildFunction(data);
    }
    applyFilterChild() {
        if (this.internalFilterChild) {
            this.internalFilterChild = '';
        }
        else {
            this.internalFilterChild = this.filterChild;
        }
        setTimeout(() => this.refreshSearchEmit.emit());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormSimpleChildPaginatedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudFormSimpleChildPaginatedComponent, selector: "crud-form-simple-child-paginated", inputs: { fieldsToDisplay: "fieldsToDisplay", addChildFunction: "addChildFunction", removeChildFunction: "removeChildFunction", allowRemoveChildFunction: "allowRemoveChildFunction", service: "service", orderBy: "orderBy", checkBoxLabel: "checkBoxLabel", filterChild: "filterChild" }, ngImport: i0, template: "<div>\n   <div class=\"row\">\n    <elo-checkbox  [checked]=\"false\"    (onClick)=\"applyFilterChild()\"></elo-checkbox>{{checkBoxLabel}}\n    <crud-search [orderBy]=\"orderBy\" [enableEdit]=\"false\" [fieldsToDisplay]=\"fieldsToDisplay\"\n      [entityService]=\"service\"\n      [filterDefault]=\"internalFilterChild\"\n      [enableCreate]=\"false\"\n      [enableRemove]=\"false\"\n      [disableSpinner]=\"true\"\n      [changeLocationOnFilter]=\"false\"\n      [refreshEmit]=\"refreshSearchEmit\">\n      <elo-table-actions [title]=\"'Remover'\" icon='fa fa-check-circle-o' [visibleWhenFunction]=\"allowRemove()\"\n        (onClickIconButton)=\"removeChild($event)\" >\n      </elo-table-actions>\n      <elo-table-actions [title]=\"'Adicionar'\" icon='fa fa-circle-o' [visibleWhenFunction]=\"allowAdd()\"\n        (onClickIconButton)=\"addChild($event)\" >\n        </elo-table-actions>\n      </crud-search>\n  </div>\n</div>\n", dependencies: [{ kind: "component", type: CrudSearchComponent, selector: "crud-search", inputs: ["shouldReuseFilter", "caption", "crudResource", "entityService", "fieldsToDisplay", "fieldsToFilter", "updateFieldsToFilter", "defaultValueOperators", "fieldsToPrint", "defaultField", "orderBy", "sortable", "enableRemove", "enableRemoveNotRole", "messageDialogDelete", "showDetailPage", "showSearchFilter", "enableEdit", "enableLogs", "enableView", "enableCreate", "enableTablePrint", "removeVisibleWhenAttribute", "visibleWhenAttribute", "visibleWhenFunction", "searchSelect", "refreshEmit", "changeLocationOnFilter", "filterDefault", "deleteFunction", "editFunction", "role", "disableSpinner", "quickViewOpener", "titleNewButton", "manyActions", "callServiceFunction", "classDataTable", "expansivePanel", "showButtonPanel", "selection", "selectionMode", "dataTableFooterDynamic", "dataTableSubtitlesDynamic", "hasLinks", "getLinks", "visibleWhenFunctionLink", "titleButtonNovo", "modelName", "labelModelName", "fieldsToDisplayForModelName", "enableRemoveAll", "fixedSizeWhenMultipleSelection", "useQueryParams", "classInputFilter", "customPagesSize", "pageParameters", "filters", "beforeExtraElement", "rowDoubleClickFunction", "enableDefaultRowDoubleClickFunction", "allowSearch", "enableScrollX", "navigationExtras", "showDeleteMessage", "listenToRouteChanges", "selectionModeId", "emptyMessage", "headerFixo", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "visibleRadioWhenFunction", "findEntitiesOnInit", "notHasExtraFilter", "enableCustomHeader", "customHeaderStyle", "showAuditInfoButton", "showAuditInfoFilters", "selectionModeWithFooter"], outputs: ["eventSelected", "onClickRadioButton", "onSearchFilterObject", "onReceivePage", "onNewItem", "onSearchEmitFilter", "onIconClicked", "removeAllClicked", "rowDoubleClickEventEmitter", "onAuditInfoButtonClick"] }, { kind: "component", type: EloTableActionsComponent, selector: "elo-table-actions", inputs: ["showError", "hasLinks", "links", "linksFunction", "quickViewOpener", "removeAutoFocus"], outputs: ["onClickLink", "onClickIconButton", "onHoverIconButton"] }, { kind: "component", type: EloCheckboxComponent, selector: "elo-checkbox", inputs: ["id", "label", "checkAllowed", "titleCheckboxDisallowed", "checked", "disabled"], outputs: ["onClick"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormSimpleChildPaginatedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'crud-form-simple-child-paginated', template: "<div>\n   <div class=\"row\">\n    <elo-checkbox  [checked]=\"false\"    (onClick)=\"applyFilterChild()\"></elo-checkbox>{{checkBoxLabel}}\n    <crud-search [orderBy]=\"orderBy\" [enableEdit]=\"false\" [fieldsToDisplay]=\"fieldsToDisplay\"\n      [entityService]=\"service\"\n      [filterDefault]=\"internalFilterChild\"\n      [enableCreate]=\"false\"\n      [enableRemove]=\"false\"\n      [disableSpinner]=\"true\"\n      [changeLocationOnFilter]=\"false\"\n      [refreshEmit]=\"refreshSearchEmit\">\n      <elo-table-actions [title]=\"'Remover'\" icon='fa fa-check-circle-o' [visibleWhenFunction]=\"allowRemove()\"\n        (onClickIconButton)=\"removeChild($event)\" >\n      </elo-table-actions>\n      <elo-table-actions [title]=\"'Adicionar'\" icon='fa fa-circle-o' [visibleWhenFunction]=\"allowAdd()\"\n        (onClickIconButton)=\"addChild($event)\" >\n        </elo-table-actions>\n      </crud-search>\n  </div>\n</div>\n" }]
        }], propDecorators: { fieldsToDisplay: [{
                type: Input
            }], addChildFunction: [{
                type: Input
            }], removeChildFunction: [{
                type: Input
            }], allowRemoveChildFunction: [{
                type: Input
            }], service: [{
                type: Input
            }], orderBy: [{
                type: Input
            }], checkBoxLabel: [{
                type: Input
            }], filterChild: [{
                type: Input
            }] } });

class PaginationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PaginationModule, declarations: [PaginationComponent], imports: [CommonModule, FormsModule], exports: [PaginationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginationModule, imports: [CommonModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    exports: [PaginationComponent],
                    declarations: [PaginationComponent]
                }]
        }] });

class EloSelectModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloSelectModule, declarations: [EloSelectComponent], imports: [CommonModule, FormsModule, ReactiveFormsModule], exports: [EloSelectComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloSelectModule, imports: [CommonModule, FormsModule, ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, ReactiveFormsModule],
                    declarations: [EloSelectComponent],
                    exports: [EloSelectComponent],
                    providers: []
                }]
        }] });

class CrudSearchModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchModule, declarations: [CrudSearchComponent, SearchFilterComponent], imports: [EloDatatableModule,
            CommonModule,
            PaginationModule,
            DialogModule,
            PanelExpansiveModule,
            FormsModule,
            ReactiveFormsModule,
            DatePickerModule,
            EloSelectModule], exports: [CrudSearchComponent, CommonModule, SearchFilterComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchModule, providers: [WindowService], imports: [EloDatatableModule,
            CommonModule,
            PaginationModule,
            DialogModule,
            PanelExpansiveModule,
            FormsModule,
            ReactiveFormsModule,
            DatePickerModule,
            EloSelectModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        EloDatatableModule,
                        CommonModule,
                        PaginationModule,
                        DialogModule,
                        PanelExpansiveModule,
                        FormsModule,
                        ReactiveFormsModule,
                        DatePickerModule,
                        EloSelectModule,
                    ],
                    exports: [CrudSearchComponent, CommonModule, SearchFilterComponent],
                    declarations: [CrudSearchComponent, SearchFilterComponent],
                    providers: [WindowService],
                }]
        }] });

class CrudFormSimpleChildPaginatedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormSimpleChildPaginatedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudFormSimpleChildPaginatedModule, declarations: [CrudFormSimpleChildPaginatedComponent], imports: [FormsModule, ReactiveFormsModule, CrudSearchModule, FormLabelColumnModule,
            PanelExpansiveModule, AutoCompleteModule, EloDatatableModule], exports: [CrudFormSimpleChildPaginatedComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormSimpleChildPaginatedModule, imports: [FormsModule, ReactiveFormsModule, CrudSearchModule, FormLabelColumnModule,
            PanelExpansiveModule, AutoCompleteModule, EloDatatableModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormSimpleChildPaginatedModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, ReactiveFormsModule, CrudSearchModule, FormLabelColumnModule,
                        PanelExpansiveModule, AutoCompleteModule, EloDatatableModule],
                    exports: [CrudFormSimpleChildPaginatedComponent],
                    declarations: [CrudFormSimpleChildPaginatedComponent]
                }]
        }] });

class CrudOnePageEditableComponent {
    set entity(entity) {
        if (entity) {
            this.loadForm(entity, this.form.get(this.arrayPropertyName));
        }
    }
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.isReverse = false;
        this.createContextItem = (form, index) => ({ form, index });
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.form, 'form');
        AssertUtilsApp.assert(this.formCreate, 'formCreate');
        AssertUtilsApp.assert(this.itemTemplate, 'itemTemplate');
        AssertUtilsApp.assert(this.arrayPropertyName, 'arrayPropertyName');
    }
    getControls(control) {
        return control.controls;
    }
    loadForm(entity, formArray) {
        const objArray = entity[this.arrayPropertyName];
        if (!this.arrayPropertyNameChild) {
            this.arrayPropertyNameChild = this.arrayPropertyName;
        }
        while (formArray.length > 0) {
            formArray.removeAt(0);
        }
        objArray.forEach(obj => {
            let form = this.formCreate();
            form.patchValue(obj);
            if (this.isReverse) {
                obj[this.arrayPropertyNameChild].slice().reverse().forEach(a => this.addChilds(form, a));
            }
            else {
                obj[this.arrayPropertyNameChild].forEach(a => this.addChilds(form, a));
            }
            formArray.insert(this.form.get(this.arrayPropertyName).value.length, form);
        });
    }
    addChilds(formPai, entity) {
        let formArray = formPai.get(this.arrayPropertyNameChild);
        let formSon = this.formCreate();
        formSon.patchValue(entity);
        formArray.push(formSon);
        if (entity[this.arrayPropertyNameChild] && entity[this.arrayPropertyNameChild].length > 0) {
            if (this.isReverse) {
                entity[this.arrayPropertyNameChild].slice().reverse().forEach(ac => this.addChilds(formSon, ac));
            }
            else {
                entity[this.arrayPropertyNameChild].forEach(ac => this.addChilds(formSon, ac));
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudOnePageEditableComponent, deps: [{ token: i1$2.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudOnePageEditableComponent, selector: "crud-one-page-editable", inputs: { form: "form", title: "title", formCreate: "formCreate", itemTemplate: "itemTemplate", arrayPropertyName: "arrayPropertyName", arrayPropertyNameChild: "arrayPropertyNameChild", isReverse: "isReverse", entity: "entity" }, ngImport: i0, template: "<div class=\"table-editable\" *ngIf=\"form?.get(arrayPropertyName)?.value.length> 0\">\n  <div class=\"table-editable-header hidden-xs\">\n    <ng-content></ng-content>\n  </div>\n\n  <div class=\"table-editable-content\">\n    <ng-template #recursiveList let-controls let-prefix=\"prefix\">\n      <ng-container *ngFor=\"let item of controls; let i = index\">\n        <ng-container *ngIf=\"isReverse; else notReverse\">\n\n          <ng-container *ngIf=\"getControls(item.get(arrayPropertyNameChild))?.length\">\n            <ng-container\n              *ngTemplateOutlet=\"recursiveList; context:{ $implicit: getControls(item.get(arrayPropertyNameChild)), prefix: prefix + i + '.' + arrayPropertyNameChild + '.'  }\">\n            </ng-container>\n          </ng-container>\n          <ng-container *ngTemplateOutlet=\"itemTemplate;context:createContextItem(item, i)\">\n          </ng-container>\n\n        </ng-container>\n        <ng-template #notReverse>\n\n          <ng-container *ngTemplateOutlet=\"itemTemplate;context:createContextItem(item, i)\">\n          </ng-container>\n          <ng-container *ngIf=\"getControls(item.get(arrayPropertyNameChild))?.length\">\n            <ng-container\n              *ngTemplateOutlet=\"recursiveList; context:{ $implicit: getControls(item.get(arrayPropertyNameChild)), prefix: prefix + i + '.' + arrayPropertyNameChild + '.'  }\">\n            </ng-container>\n          </ng-container>\n\n        </ng-template>\n      </ng-container>\n    </ng-template>\n\n    <ng-container\n      *ngTemplateOutlet=\"recursiveList; context:{ $implicit: getControls(form?.get(arrayPropertyName)), prefix: arrayPropertyNameChild + '.' }\">\n    </ng-container>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudOnePageEditableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'crud-one-page-editable', template: "<div class=\"table-editable\" *ngIf=\"form?.get(arrayPropertyName)?.value.length> 0\">\n  <div class=\"table-editable-header hidden-xs\">\n    <ng-content></ng-content>\n  </div>\n\n  <div class=\"table-editable-content\">\n    <ng-template #recursiveList let-controls let-prefix=\"prefix\">\n      <ng-container *ngFor=\"let item of controls; let i = index\">\n        <ng-container *ngIf=\"isReverse; else notReverse\">\n\n          <ng-container *ngIf=\"getControls(item.get(arrayPropertyNameChild))?.length\">\n            <ng-container\n              *ngTemplateOutlet=\"recursiveList; context:{ $implicit: getControls(item.get(arrayPropertyNameChild)), prefix: prefix + i + '.' + arrayPropertyNameChild + '.'  }\">\n            </ng-container>\n          </ng-container>\n          <ng-container *ngTemplateOutlet=\"itemTemplate;context:createContextItem(item, i)\">\n          </ng-container>\n\n        </ng-container>\n        <ng-template #notReverse>\n\n          <ng-container *ngTemplateOutlet=\"itemTemplate;context:createContextItem(item, i)\">\n          </ng-container>\n          <ng-container *ngIf=\"getControls(item.get(arrayPropertyNameChild))?.length\">\n            <ng-container\n              *ngTemplateOutlet=\"recursiveList; context:{ $implicit: getControls(item.get(arrayPropertyNameChild)), prefix: prefix + i + '.' + arrayPropertyNameChild + '.'  }\">\n            </ng-container>\n          </ng-container>\n\n        </ng-template>\n      </ng-container>\n    </ng-template>\n\n    <ng-container\n      *ngTemplateOutlet=\"recursiveList; context:{ $implicit: getControls(form?.get(arrayPropertyName)), prefix: arrayPropertyNameChild + '.' }\">\n    </ng-container>\n  </div>\n</div>" }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }], propDecorators: { form: [{
                type: Input
            }], title: [{
                type: Input
            }], formCreate: [{
                type: Input
            }], itemTemplate: [{
                type: Input
            }], arrayPropertyName: [{
                type: Input
            }], arrayPropertyNameChild: [{
                type: Input
            }], isReverse: [{
                type: Input
            }], entity: [{
                type: Input
            }] } });

class CrudOnePageEditableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudOnePageEditableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudOnePageEditableModule, declarations: [CrudOnePageEditableComponent], imports: [CommonModule,
            ReactiveFormsModule,
            PanelModule,
            DialogModule], exports: [CrudOnePageEditableComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudOnePageEditableModule, imports: [CommonModule,
            ReactiveFormsModule,
            PanelModule,
            DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudOnePageEditableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        PanelModule,
                        DialogModule
                    ],
                    declarations: [CrudOnePageEditableComponent],
                    exports: [CrudOnePageEditableComponent]
                }]
        }] });

class ButtonLogComponent {
    constructor() {
        this.label = 'Ver Logs';
        this.onClick = new EventEmitter();
    }
    onClickButton() {
        this.onClick.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonLogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ButtonLogComponent, selector: "button-log", inputs: { label: "label" }, outputs: { onClick: "onClick" }, ngImport: i0, template: `
    <button id="btnLogs" class="btn circle pull-right" type="button" (click)="onClickButton()">
      <em class="fa fa-history"></em>
      <div class="btn-actions-label">{{ label }}</div>
    </button>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonLogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'button-log',
                    template: `
    <button id="btnLogs" class="btn circle pull-right" type="button" (click)="onClickButton()">
      <em class="fa fa-history"></em>
      <div class="btn-actions-label">{{ label }}</div>
    </button>
  `
                }]
        }], propDecorators: { label: [{
                type: Input
            }], onClick: [{
                type: Output
            }] } });

class ButtonLogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonLogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ButtonLogModule, declarations: [ButtonLogComponent], imports: [CommonModule], exports: [ButtonLogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonLogModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonLogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ButtonLogComponent],
                    exports: [ButtonLogComponent]
                }]
        }] });

class EntityLogService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.nameModel = '';
        this.resource = '/api/log';
    }
    findAll(page, search, fields, disableSpinner) {
        return this.httpClient.get({
            resource: `${this.resource}/${this.nameModel}`,
            page: page,
            search: this.buildSearch(search),
            disableSpinner: disableSpinner,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    compareLog(revisionNumber, id) {
        return this.httpClient.get({
            resource: `${this.resource}/${this.nameModel}/${revisionNumber}/${id}`,
        });
    }
    loadFieldModels() {
        return this.httpClient.get({
            resource: `${this.resource}/${this.nameModel}/model`,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntityLogService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntityLogService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntityLogService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

class SwitchButtonItemComponent {
    constructor() {
        this.selected = false;
        this.isDisabled = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchButtonItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SwitchButtonItemComponent, selector: "elo-switch-button-item", inputs: { title: "title", selected: "selected", value: "value", isDisabled: "isDisabled" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchButtonItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-switch-button-item',
                    template: ''
                }]
        }], propDecorators: { title: [{
                type: Input
            }], selected: [{
                type: Input
            }], value: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }] } });

class SwitchButtonComponent {
    constructor() {
        this.buttons = new QueryList();
        this.onSelected = new EventEmitter();
        this.flat = false;
        this.propertyNameCompare = null;
        this.onChange = noop;
        this.onTouched = noop;
        this.valueBeforeContentInit = null;
    }
    selectButton(button) {
        this.clearSelecteds();
        button.selected = true;
        this.onSelected.emit({ selectedButton: button });
        if (this.onChange) {
            this.onChange(button.value);
        }
    }
    get visibleButtons() {
        return this.buttons.filter(button => button.title !== '');
    }
    writeValue(obj) {
        if (this.buttons.length && obj) {
            this.clearSelecteds();
            this.buttons.filter(btn => JSON.stringify(btn.value) === JSON.stringify(obj)).forEach(btn => btn.selected = true);
        }
        else {
            this.valueBeforeContentInit = obj;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    ngAfterContentInit() {
        if (this.valueBeforeContentInit) {
            this.writeValue(this.valueBeforeContentInit);
        }
    }
    clearSelecteds() {
        this.buttons.forEach(button => button.selected = false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SwitchButtonComponent, selector: "elo-switch-button", inputs: { flat: "flat", propertyNameCompare: "propertyNameCompare" }, outputs: { onSelected: "onSelected" }, providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: SwitchButtonComponent }
        ], queries: [{ propertyName: "buttons", predicate: SwitchButtonItemComponent }], ngImport: i0, template: "<div class=\"switch-buttons\" [class.flat]=\"flat\">\n  <button *ngFor=\"let button of visibleButtons\" (click)=\"selectButton(button)\" class=\"btn\"\n    [class.active]=\"button.selected\" type=\"button\" [disabled]=\"button.isDisabled\">\n    {{button.title}}\n  </button>\n</div>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-switch-button', providers: [
                        { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: SwitchButtonComponent }
                    ], template: "<div class=\"switch-buttons\" [class.flat]=\"flat\">\n  <button *ngFor=\"let button of visibleButtons\" (click)=\"selectButton(button)\" class=\"btn\"\n    [class.active]=\"button.selected\" type=\"button\" [disabled]=\"button.isDisabled\">\n    {{button.title}}\n  </button>\n</div>" }]
        }], propDecorators: { buttons: [{
                type: ContentChildren,
                args: [SwitchButtonItemComponent]
            }], onSelected: [{
                type: Output
            }], flat: [{
                type: Input
            }], propertyNameCompare: [{
                type: Input
            }] } });

class CrudSearchLogComponent {
    constructor(entityLogService, activatedRoute) {
        this.entityLogService = entityLogService;
        this.activatedRoute = activatedRoute;
        this.fieldsToDisplay = [];
        this.visao = 'user';
    }
    ngOnInit() {
        this.setModel();
        this.setFieldsToFilter();
    }
    setModel() {
        this.nameModel = this.activatedRoute.snapshot.queryParams['model'];
        this.entityLogService.nameModel = this.nameModel;
    }
    setFieldsToFilter() {
        this.fieldsToDisplay = ['revisionType', 'userName', 'revisionNumber', 'revisionDate',
            'remoteIpAddress', 'activeView']
            .concat(this.activatedRoute.snapshot.queryParams['fields'].split(','));
    }
    onDetails(object) {
        object.expand = !object.expand;
        if (!object.revision) {
            this.entityLogService.compareLog(object.object.revisionNumber, object.id).subscribe(value => {
                this.entityLogService.loadFieldModels().subscribe(model => {
                    object.comparisonsDev = JsonUtil.getComparisonsFromJson(value.before, value.actual);
                    object.comparisonsUser = JsonUtil.getComparisonsFromJson(JsonUtil.replaceKeyWithFieldModel(value.before, model), JsonUtil.replaceKeyWithFieldModel(value.actual, model));
                });
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchLogComponent, deps: [{ token: EntityLogService }, { token: i1$4.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudSearchLogComponent, selector: "crud-search-log", ngImport: i0, template: "<crud-search crudResource=\"/log\" [fieldsToDisplay]=\"fieldsToDisplay\" [entityService]=\"entityLogService\"\n  [orderBy]=\"'id,asc'\" [enableRemove]=\"false\" [enableEdit]=\"false\" [enableCreate]=\"false\" [enableTablePrint]=\"false\" \n  [enableView]=\"false\" [enableLogs]=\"false\" [showAuditInfoButton]=\"false\" [showAuditInfoFilters]=\"false\"\n  [beforeExtraElement]=\"interfaceUserTecnico\">\n  <ng-template #eloColumns let-dataTable=\"dataTable\">\n    <elo-column [field]=\"'revisionNumber'\" [header]=\"'Revis\u00E3o / C\u00F3digo'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">\n        {{ object?.object?.revisionNumber }}/{{object.id}}\n      </ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'revType'\" [header]=\"'Tipo Movimento'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">\n        <div class=\"col-md-6\">\n          <div class=\"chip-container positive outlined center\" *ngIf=\"object.revType === 'ADD'\">\n            <p class=\"chip-text\">Adi\u00E7\u00E3o</p>\n          </div>\n          <div class=\"chip-container warning outlined center\" *ngIf=\"object.revType === 'MOD'\">\n            <p class=\"chip-text\">Edi\u00E7\u00E3o</p>\n          </div>\n          <div class=\"chip-container negative outlined center\" *ngIf=\"object.revType === 'DEL'\">\n            <p class=\"chip-text\">Remo\u00E7\u00E3o</p>\n          </div>\n        </div>\n\n      </ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'revisionDate'\" [header]=\"'Data'\" [dataTable]=\"dataTable\" [isDateTime]=\"true\">\n      <ng-template #dataTableCell let-object=\"object\">\n        {{ object?.object?.revisionDate | date: \"dd/MM/yyyy HH:mm\" }}\n      </ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'userName'\" [header]=\"'Usu\u00E1rio'\" [dataTable]=\"dataTable\" [isDateTime]=\"true\">\n      <ng-template #dataTableCell let-object=\"object\">{{ object?.object?.userName }}</ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'remoteIpAddress'\" [header]=\"'Ip'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">{{ object?.object?.remoteIpAddress }}</ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'activeView'\" [header]=\"'Tela'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">{{ object?.object?.activeView }}</ng-template>\n    </elo-column>\n\n\n  </ng-template>\n\n  <elo-table-actions title=\"Detalhes\" icon=\"fa fa-chevron-down\" id=\"idDetails\" (onClickIconButton)=\"onDetails($event)\"\n    [removeAutoFocus]=\"true\"></elo-table-actions>\n\n  <ng-template #dataTableExpand let-object=\"object\">\n    <elo-panel>\n      <div class=\"table-editable panel-table-outer\">\n        <div class=\"table-editable-header\">\n          <div class=\"row\">\n            <div class=\"col-md-4 column\"><span> Campo </span></div>\n            <div class=\"col-md-5 column \"><span> Valor Anterior </span></div>\n            <div class=\"col-md-5 column\"><span> Valor Atual </span></div>\n          </div>\n        </div>\n        <div class=\"table-editable-content\" *ngIf=\"visao === 'user'\">\n          <div class=\"row\" *ngFor=\"let compare of object?.comparisonsUser\">\n            <div class=\"column col-md-4\"><span> {{ compare?.path }} </span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.before }}</span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.after }} </span></div>\n          </div>\n        </div>\n        <div class=\"table-editable-content\" *ngIf=\"visao === 'dev'\">\n          <div class=\"row\" *ngFor=\"let compare of object?.comparisonsDev\">\n            <div class=\"column col-md-4\"><span> {{ compare?.path }} </span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.before }}</span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.after }} </span></div>\n          </div>\n        </div>\n      </div>\n    </elo-panel>\n  </ng-template>\n\n</crud-search>\n\n<ng-template #interfaceUserTecnico>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"form-group\">\n        <elo-switch-button [(ngModel)]=\"visao\">\n          <elo-switch-button-item class=\"\" title=\"Usu\u00E1rio\" value=\"user\"></elo-switch-button-item>\n          <elo-switch-button-item title=\"T\u00E9cnico\" value=\"dev\"></elo-switch-button-item>\n        </elo-switch-button>\n      </div>\n    </div>\n  </div>\n</ng-template>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: PanelComponent, selector: "elo-panel", inputs: ["title", "hasTable", "hasForm", "pbNone"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: CrudSearchComponent, selector: "crud-search", inputs: ["shouldReuseFilter", "caption", "crudResource", "entityService", "fieldsToDisplay", "fieldsToFilter", "updateFieldsToFilter", "defaultValueOperators", "fieldsToPrint", "defaultField", "orderBy", "sortable", "enableRemove", "enableRemoveNotRole", "messageDialogDelete", "showDetailPage", "showSearchFilter", "enableEdit", "enableLogs", "enableView", "enableCreate", "enableTablePrint", "removeVisibleWhenAttribute", "visibleWhenAttribute", "visibleWhenFunction", "searchSelect", "refreshEmit", "changeLocationOnFilter", "filterDefault", "deleteFunction", "editFunction", "role", "disableSpinner", "quickViewOpener", "titleNewButton", "manyActions", "callServiceFunction", "classDataTable", "expansivePanel", "showButtonPanel", "selection", "selectionMode", "dataTableFooterDynamic", "dataTableSubtitlesDynamic", "hasLinks", "getLinks", "visibleWhenFunctionLink", "titleButtonNovo", "modelName", "labelModelName", "fieldsToDisplayForModelName", "enableRemoveAll", "fixedSizeWhenMultipleSelection", "useQueryParams", "classInputFilter", "customPagesSize", "pageParameters", "filters", "beforeExtraElement", "rowDoubleClickFunction", "enableDefaultRowDoubleClickFunction", "allowSearch", "enableScrollX", "navigationExtras", "showDeleteMessage", "listenToRouteChanges", "selectionModeId", "emptyMessage", "headerFixo", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "visibleRadioWhenFunction", "findEntitiesOnInit", "notHasExtraFilter", "enableCustomHeader", "customHeaderStyle", "showAuditInfoButton", "showAuditInfoFilters", "selectionModeWithFooter"], outputs: ["eventSelected", "onClickRadioButton", "onSearchFilterObject", "onReceivePage", "onNewItem", "onSearchEmitFilter", "onIconClicked", "removeAllClicked", "rowDoubleClickEventEmitter", "onAuditInfoButtonClick"] }, { kind: "component", type: EloColumnComponent, selector: "elo-column", inputs: ["field", "header", "headerAlign", "isDecimal", "isPercentual", "digits", "isDate", "isDateTime", "isCnpjCpf", "enumOptions", "col", "class", "isEditable", "isEditing", "dataTable", "hidden", "hiddenTableData", "sortable", "samp", "headerStyle", "dataStyle"] }, { kind: "component", type: EloTableActionsComponent, selector: "elo-table-actions", inputs: ["showError", "hasLinks", "links", "linksFunction", "quickViewOpener", "removeAutoFocus"], outputs: ["onClickLink", "onClickIconButton", "onHoverIconButton"] }, { kind: "component", type: SwitchButtonComponent, selector: "elo-switch-button", inputs: ["flat", "propertyNameCompare"], outputs: ["onSelected"] }, { kind: "component", type: SwitchButtonItemComponent, selector: "elo-switch-button-item", inputs: ["title", "selected", "value", "isDisabled"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchLogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'crud-search-log', template: "<crud-search crudResource=\"/log\" [fieldsToDisplay]=\"fieldsToDisplay\" [entityService]=\"entityLogService\"\n  [orderBy]=\"'id,asc'\" [enableRemove]=\"false\" [enableEdit]=\"false\" [enableCreate]=\"false\" [enableTablePrint]=\"false\" \n  [enableView]=\"false\" [enableLogs]=\"false\" [showAuditInfoButton]=\"false\" [showAuditInfoFilters]=\"false\"\n  [beforeExtraElement]=\"interfaceUserTecnico\">\n  <ng-template #eloColumns let-dataTable=\"dataTable\">\n    <elo-column [field]=\"'revisionNumber'\" [header]=\"'Revis\u00E3o / C\u00F3digo'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">\n        {{ object?.object?.revisionNumber }}/{{object.id}}\n      </ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'revType'\" [header]=\"'Tipo Movimento'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">\n        <div class=\"col-md-6\">\n          <div class=\"chip-container positive outlined center\" *ngIf=\"object.revType === 'ADD'\">\n            <p class=\"chip-text\">Adi\u00E7\u00E3o</p>\n          </div>\n          <div class=\"chip-container warning outlined center\" *ngIf=\"object.revType === 'MOD'\">\n            <p class=\"chip-text\">Edi\u00E7\u00E3o</p>\n          </div>\n          <div class=\"chip-container negative outlined center\" *ngIf=\"object.revType === 'DEL'\">\n            <p class=\"chip-text\">Remo\u00E7\u00E3o</p>\n          </div>\n        </div>\n\n      </ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'revisionDate'\" [header]=\"'Data'\" [dataTable]=\"dataTable\" [isDateTime]=\"true\">\n      <ng-template #dataTableCell let-object=\"object\">\n        {{ object?.object?.revisionDate | date: \"dd/MM/yyyy HH:mm\" }}\n      </ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'userName'\" [header]=\"'Usu\u00E1rio'\" [dataTable]=\"dataTable\" [isDateTime]=\"true\">\n      <ng-template #dataTableCell let-object=\"object\">{{ object?.object?.userName }}</ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'remoteIpAddress'\" [header]=\"'Ip'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">{{ object?.object?.remoteIpAddress }}</ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'activeView'\" [header]=\"'Tela'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">{{ object?.object?.activeView }}</ng-template>\n    </elo-column>\n\n\n  </ng-template>\n\n  <elo-table-actions title=\"Detalhes\" icon=\"fa fa-chevron-down\" id=\"idDetails\" (onClickIconButton)=\"onDetails($event)\"\n    [removeAutoFocus]=\"true\"></elo-table-actions>\n\n  <ng-template #dataTableExpand let-object=\"object\">\n    <elo-panel>\n      <div class=\"table-editable panel-table-outer\">\n        <div class=\"table-editable-header\">\n          <div class=\"row\">\n            <div class=\"col-md-4 column\"><span> Campo </span></div>\n            <div class=\"col-md-5 column \"><span> Valor Anterior </span></div>\n            <div class=\"col-md-5 column\"><span> Valor Atual </span></div>\n          </div>\n        </div>\n        <div class=\"table-editable-content\" *ngIf=\"visao === 'user'\">\n          <div class=\"row\" *ngFor=\"let compare of object?.comparisonsUser\">\n            <div class=\"column col-md-4\"><span> {{ compare?.path }} </span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.before }}</span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.after }} </span></div>\n          </div>\n        </div>\n        <div class=\"table-editable-content\" *ngIf=\"visao === 'dev'\">\n          <div class=\"row\" *ngFor=\"let compare of object?.comparisonsDev\">\n            <div class=\"column col-md-4\"><span> {{ compare?.path }} </span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.before }}</span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.after }} </span></div>\n          </div>\n        </div>\n      </div>\n    </elo-panel>\n  </ng-template>\n\n</crud-search>\n\n<ng-template #interfaceUserTecnico>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"form-group\">\n        <elo-switch-button [(ngModel)]=\"visao\">\n          <elo-switch-button-item class=\"\" title=\"Usu\u00E1rio\" value=\"user\"></elo-switch-button-item>\n          <elo-switch-button-item title=\"T\u00E9cnico\" value=\"dev\"></elo-switch-button-item>\n        </elo-switch-button>\n      </div>\n    </div>\n  </div>\n</ng-template>" }]
        }], ctorParameters: () => [{ type: EntityLogService }, { type: i1$4.ActivatedRoute }] });

class TableReportComponent {
    constructor() {
        this.small = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableReportComponent, selector: "elo-table-report", inputs: { visible: "visible", small: "small" }, ngImport: i0, template: "<div class=\"table-report\" [class.small]=\"small\" *ngIf=\"visible\">\n    <ng-content></ng-content>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-table-report', template: "<div class=\"table-report\" [class.small]=\"small\" *ngIf=\"visible\">\n    <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { visible: [{
                type: Input
            }], small: [{
                type: Input
            }] } });

class TableReportGroupComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableReportGroupComponent, selector: "elo-table-report-group", inputs: { label: "label", description: "description", extraLabel: "extraLabel", extraDescription: "extraDescription", hasSubNivel: "hasSubNivel", columnFirstGroup: "columnFirstGroup", columnSecondGroup: "columnSecondGroup" }, ngImport: i0, template: "<ul [class.has-subnivel]=\"hasSubNivel\">\n  <li class=\"group-title col-xs-12\">\n    <div class=\"{{ columnFirstGroup ? columnFirstGroup : 'col-md-10 col-xs-6' }}\">\n      <b>{{label}}</b> {{description}}\n    </div>\n    <div class=\"{{ columnSecondGroup ? 'group-extra ' + columnSecondGroup : 'group-extra col-md-2 col-xs-6 text-right'}}\">\n      <b>{{extraLabel}}</b>{{extraDescription}}\n    </div>\n  </li>\n\n  <ng-content></ng-content>\n</ul>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-table-report-group', template: "<ul [class.has-subnivel]=\"hasSubNivel\">\n  <li class=\"group-title col-xs-12\">\n    <div class=\"{{ columnFirstGroup ? columnFirstGroup : 'col-md-10 col-xs-6' }}\">\n      <b>{{label}}</b> {{description}}\n    </div>\n    <div class=\"{{ columnSecondGroup ? 'group-extra ' + columnSecondGroup : 'group-extra col-md-2 col-xs-6 text-right'}}\">\n      <b>{{extraLabel}}</b>{{extraDescription}}\n    </div>\n  </li>\n\n  <ng-content></ng-content>\n</ul>\n" }]
        }], propDecorators: { label: [{
                type: Input
            }], description: [{
                type: Input
            }], extraLabel: [{
                type: Input
            }], extraDescription: [{
                type: Input
            }], hasSubNivel: [{
                type: Input
            }], columnFirstGroup: [{
                type: Input
            }], columnSecondGroup: [{
                type: Input
            }] } });

class TableReportGroupItensComponent {
    constructor() {
        this.scroll = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportGroupItensComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableReportGroupItensComponent, selector: "elo-table-report-group-itens", inputs: { headers: "headers", scroll: "scroll", maxHeightOnScroll: "maxHeightOnScroll" }, ngImport: i0, template: "<div class=\"row\">\n    <div class=\"col-md-12 hidden-xs\">\n        <div class=\"group-header\" >\n            <div *ngFor=\"let header of headers\" class=\"col-md-{{header.column}} {{header.columnSize}}\">\n                {{header.name}}\n            </div>\n        </div>\n    </div>\n</div>\n<ul class=\"group-itens\" [class.scroll]=\"scroll\" [ngStyle]=\"{'max-height': maxHeightOnScroll ? maxHeightOnScroll : ''}\">\n    <ng-content></ng-content>\n</ul>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportGroupItensComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-table-report-group-itens', template: "<div class=\"row\">\n    <div class=\"col-md-12 hidden-xs\">\n        <div class=\"group-header\" >\n            <div *ngFor=\"let header of headers\" class=\"col-md-{{header.column}} {{header.columnSize}}\">\n                {{header.name}}\n            </div>\n        </div>\n    </div>\n</div>\n<ul class=\"group-itens\" [class.scroll]=\"scroll\" [ngStyle]=\"{'max-height': maxHeightOnScroll ? maxHeightOnScroll : ''}\">\n    <ng-content></ng-content>\n</ul>\n" }]
        }], propDecorators: { headers: [{
                type: Input
            }], scroll: [{
                type: Input
            }], maxHeightOnScroll: [{
                type: Input
            }] } });

class TableReportItemComponent {
    constructor() {
        this.clickable = false;
        this.showError = false;
        this.backgroundColor = undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableReportItemComponent, selector: "elo-table-report-item", inputs: { item: "item", clickable: "clickable", showError: "showError", backgroundColor: "backgroundColor" }, ngImport: i0, template: "<li\n  class=\"group-item\"\n  [class.pointer]=\"clickable\"\n  [class.error]=\"showError\"\n  [style.backgroundColor]=\"backgroundColor\"\n>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div\n        *ngFor=\"let val of item\"\n        class=\"col-md-{{ val.column }} group-column {{ val.columnSize }}\"\n        [attr.data-header]=\"val.dataHeader\"\n        [ngClass]=\"val.blurValue ? 'blur-value' : ''\"\n        [ngClass]=\"val.dataHeader === 'Data' ? 'group-date' : ''\"\n      >\n        <p *ngIf=\"val.isDecimal; else default\">\n          {{ val.value | decimalformat : \"1.2-2\" }}\n        </p>\n        <ng-template #default>\n          <p>{{ val.value }}</p>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n</li>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: DecimalFormatPipe, name: "decimalformat" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportItemComponent, decorators: [{
            type: Component,
            args: [{ selector: "elo-table-report-item", template: "<li\n  class=\"group-item\"\n  [class.pointer]=\"clickable\"\n  [class.error]=\"showError\"\n  [style.backgroundColor]=\"backgroundColor\"\n>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div\n        *ngFor=\"let val of item\"\n        class=\"col-md-{{ val.column }} group-column {{ val.columnSize }}\"\n        [attr.data-header]=\"val.dataHeader\"\n        [ngClass]=\"val.blurValue ? 'blur-value' : ''\"\n        [ngClass]=\"val.dataHeader === 'Data' ? 'group-date' : ''\"\n      >\n        <p *ngIf=\"val.isDecimal; else default\">\n          {{ val.value | decimalformat : \"1.2-2\" }}\n        </p>\n        <ng-template #default>\n          <p>{{ val.value }}</p>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n</li>\n" }]
        }], propDecorators: { item: [{
                type: Input
            }], clickable: [{
                type: Input
            }], showError: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }] } });

class TableReportTotalComponent {
    constructor() {
        this.geral = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportTotalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableReportTotalComponent, selector: "elo-table-report-total", inputs: { columnSize: "columnSize", geral: "geral", totals: "totals" }, ngImport: i0, template: "<div class=\"row\">\n    <div class=\"col-md-12\">\n        <div class=\"total\" [class.geral]=\"geral\">\n            <div class=\"{{columnSize}}\">\n                <div *ngFor=\"let total of totals\" class=\"{{total.columnSize}}\" [attr.data-header]=\"total.dataHeader\">\n                    <b *ngIf=\"total.isDecimal; else default\">{{total.value | decimalformat : \"1.2-2\"}}</b>\n                    <ng-template #default>\n                      <b>{{total.value}}</b>\n                    </ng-template>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: DecimalFormatPipe, name: "decimalformat" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportTotalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-table-report-total', template: "<div class=\"row\">\n    <div class=\"col-md-12\">\n        <div class=\"total\" [class.geral]=\"geral\">\n            <div class=\"{{columnSize}}\">\n                <div *ngFor=\"let total of totals\" class=\"{{total.columnSize}}\" [attr.data-header]=\"total.dataHeader\">\n                    <b *ngIf=\"total.isDecimal; else default\">{{total.value | decimalformat : \"1.2-2\"}}</b>\n                    <ng-template #default>\n                      <b>{{total.value}}</b>\n                    </ng-template>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], propDecorators: { columnSize: [{
                type: Input
            }], geral: [{
                type: Input
            }], totals: [{
                type: Input
            }] } });

class TableReportModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TableReportModule, declarations: [TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportTotalComponent], imports: [CommonModule, PipeModule], exports: [TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportTotalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportModule, imports: [CommonModule, PipeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableReportModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PipeModule],
                    exports: [TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportTotalComponent],
                    declarations: [TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportTotalComponent]
                }]
        }] });

class SwitchButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SwitchButtonModule, declarations: [SwitchButtonComponent, SwitchButtonItemComponent], imports: [CommonModule], exports: [SwitchButtonComponent, SwitchButtonItemComponent, ReactiveFormsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchButtonModule, imports: [CommonModule, ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [SwitchButtonComponent, SwitchButtonItemComponent, ReactiveFormsModule],
                    declarations: [SwitchButtonComponent, SwitchButtonItemComponent]
                }]
        }] });

const routes = [
    { path: '', component: CrudSearchLogComponent }
];
class CrudSearchLogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchLogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchLogModule, declarations: [CrudSearchLogComponent], imports: [i1$4.RouterModule, CommonModule,
            TableReportModule,
            PipeModule,
            PanelModule,
            FormLabelColumnModule,
            FormsModule,
            CrudSearchModule,
            EloDatatableModule,
            SwitchButtonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchLogModule, providers: [EntityLogService], imports: [RouterModule.forChild(routes),
            CommonModule,
            TableReportModule,
            PipeModule,
            PanelModule,
            FormLabelColumnModule,
            FormsModule,
            CrudSearchModule,
            EloDatatableModule,
            SwitchButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudSearchLogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        RouterModule.forChild(routes),
                        CommonModule,
                        TableReportModule,
                        PipeModule,
                        PanelModule,
                        FormLabelColumnModule,
                        FormsModule,
                        CrudSearchModule,
                        EloDatatableModule,
                        SwitchButtonModule
                    ],
                    declarations: [CrudSearchLogComponent],
                    providers: [EntityLogService]
                }]
        }] });

class CrudTreeComponent {
    constructor() {
        this.children = [];
        this.fieldNameSuperior = 'superior';
        this.onRequestChildren = new EventEmitter();
        this.permissionEdit = true;
        this.permissionCreate = true;
        this.permissionRemove = false;
        this.maxLevels = Number.MAX_SAFE_INTEGER;
        this.onRemove = new EventEmitter();
        this.isSelected = false;
        this.isEditing = false;
        this.ctx = { objectSelected: null, onCloseForm: new EventEmitter() };
        this.groups = [];
        this._namesLevels = [];
    }
    set namesLevels(values) {
        this._namesLevels = values;
        for (let i = 0; i < this.groups.length; i++) {
            this.groups[i].titleDefault = this._namesLevels[i];
        }
    }
    ngOnInit() {
        this.onRequestChildren.emit(null);
        this.addGroup(null);
        this.groups[0].isChecked = true;
        this.ctx.onCloseForm.subscribe(() => this.onClose());
    }
    edit(event, object) {
        event.stopPropagation();
        this.objectSelected = object;
        this.ctx.objectSelected = this.objectSelected;
        this.changeToEditMode(true);
    }
    onAddButton() {
        const objectSuperior = this.groups[this.groups.length - 1].object;
        this.objectSelected = {};
        if (objectSuperior) {
            this.objectSelected[this.fieldNameSuperior] = objectSuperior;
        }
        this.ctx.objectSelected = this.objectSelected;
        this.changeToEditMode(true);
    }
    changeToEditMode(value) {
        this.isEditing = value;
        const group = this.groups[this.groups.length - 1];
        group.isEditing = value;
    }
    onChangeGroup(event) {
        this.groups = this.groups.slice(0, event.indice + 1);
        const group = this.groups[this.groups.length - 1];
        this.onRequestChildren.emit(group.object);
        group.itemSelected = false;
        group.titleDefault = this.getTitleDefault(this.groups.length - 1);
        group.isChecked = true;
        group.isEditing = false;
        this.isEditing = false;
    }
    onClose() {
        this.changeToEditMode(false);
        const group = this.groups[this.groups.length - 1];
        this.onRequestChildren.emit(group.object);
    }
    choice(object) {
        if (!this.reachedMaxLevel()) {
            const group = this.groups[this.groups.length - 1];
            group.itemSelected = object.descricao;
            group.isChecked = false;
            group.isEditing = true;
            this.addGroup(object);
            this.onRequestChildren.emit(object);
        }
    }
    reachedMaxLevel() {
        return this.groups.length >= this.maxLevels;
    }
    onClickRemove(event, object) {
        event.stopPropagation();
        this.onRemove.emit(object);
    }
    addGroup(object) {
        this.groups.push({
            indice: this.groups.length,
            titleDefault: this.getTitleDefault(this.groups.length),
            itemSelected: false,
            id: this.groups.length,
            opacity: 1 - this.groups.length * 0.15,
            isChecked: true,
            isEditing: false,
            object: object
        });
    }
    getTitleDefault(index) {
        return this._namesLevels[index] ? this._namesLevels[index] : `Nível ${index + 1}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudTreeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CrudTreeComponent, selector: "crud-tree", inputs: { children: "children", crudTemplateRef: "crudTemplateRef", fieldNameSuperior: "fieldNameSuperior", permissionEdit: "permissionEdit", permissionCreate: "permissionCreate", permissionRemove: "permissionRemove", otherField: "otherField", maxLevels: "maxLevels", namesLevels: "namesLevels" }, outputs: { onRequestChildren: "onRequestChildren", onRemove: "onRemove" }, ngImport: i0, template: "<elo-accordion>\n\n  <elo-accordion-item id=\"accordionItem\" class=\"advtree-item\" [ngClass]=\"{'checked': group.isChecked, 'done': group.itemSelected}\"\n    *ngFor=\"let group of groups\" [obj]=\"group\"\n    [hasPermission]=\"permissionCreate\" (addButtons)=\"onAddButton()\" (onChangeGroupSelected)=\"onChangeGroup($event)\">\n\n    <div class=\"advtree-content\">\n\n      <div id=\"empty-objects\" class=\"info primary icon\" *ngIf=\"children.length === 0 && !isEditing && group.isChecked\">\n        <div class=\"icon\">\n          <em class=\"fa fa-info-circle\"></em></div>\n        <article>\n          <p>N\u00E3o existem itens cadastrados neste n\u00EDvel.</p>\n        </article>\n      </div>\n\n      <ul id=\"list-objects\" class=\"list\" *ngIf=\"!isEditing && children.length > 0\">\n        <li *ngFor=\"let object of children\" (click)=\"choice(object)\">\n\n          <div class=\"description\">{{ object.codigo }} - {{ object.descricao }}\n            <ng-container\n              *ngIf=\"otherField && object[otherField.field] && object[otherField.field][otherField.children]\">\n              - {{object[otherField.field][otherField.children]}}\n            </ng-container>\n          </div>\n\n          <div class=\"btn-actions\">\n            <button class=\"btn circle\" type=\"button\" *ngIf=\"!reachedMaxLevel()\">\n              <i class=\"fa fa-level-up\"></i>\n              <div class=\"btn-actions-label\">\n                Entrar N\u00EDvel\n              </div>\n            </button>\n            <button class=\"btn circle\" *ngIf=\"permissionEdit\" (click)=\"edit($event, object)\">\n              <i class=\"fa fa-pencil\"></i>\n              <div class=\"btn-actions-label\">\n                Editar\n              </div>\n            </button>\n            <button id=\"btnRemove\" *ngIf=\"permissionRemove\" class=\"btn circle\" (click)=\"onClickRemove($event, object)\">\n              <i class=\"fa fa-trash\"></i>\n              <div class=\"btn-actions-label\">\n                Remover\n              </div>\n            </button>\n          </div>\n        </li>\n      </ul>\n\n      <div id=\"form-template\" *ngIf=\"isEditing\">\n        <ng-container *ngTemplateOutlet=\"crudTemplateRef;context:ctx\">\n        </ng-container>\n      </div>\n    </div>\n\n  </elo-accordion-item>\n</elo-accordion>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: AccordionComponent, selector: "elo-accordion" }, { kind: "component", type: AccordionItemComponent, selector: "elo-accordion-item", inputs: ["obj", "disableClick", "hasPermission"], outputs: ["onChangeGroupSelected", "confirmButtons", "addButtons"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudTreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'crud-tree', template: "<elo-accordion>\n\n  <elo-accordion-item id=\"accordionItem\" class=\"advtree-item\" [ngClass]=\"{'checked': group.isChecked, 'done': group.itemSelected}\"\n    *ngFor=\"let group of groups\" [obj]=\"group\"\n    [hasPermission]=\"permissionCreate\" (addButtons)=\"onAddButton()\" (onChangeGroupSelected)=\"onChangeGroup($event)\">\n\n    <div class=\"advtree-content\">\n\n      <div id=\"empty-objects\" class=\"info primary icon\" *ngIf=\"children.length === 0 && !isEditing && group.isChecked\">\n        <div class=\"icon\">\n          <em class=\"fa fa-info-circle\"></em></div>\n        <article>\n          <p>N\u00E3o existem itens cadastrados neste n\u00EDvel.</p>\n        </article>\n      </div>\n\n      <ul id=\"list-objects\" class=\"list\" *ngIf=\"!isEditing && children.length > 0\">\n        <li *ngFor=\"let object of children\" (click)=\"choice(object)\">\n\n          <div class=\"description\">{{ object.codigo }} - {{ object.descricao }}\n            <ng-container\n              *ngIf=\"otherField && object[otherField.field] && object[otherField.field][otherField.children]\">\n              - {{object[otherField.field][otherField.children]}}\n            </ng-container>\n          </div>\n\n          <div class=\"btn-actions\">\n            <button class=\"btn circle\" type=\"button\" *ngIf=\"!reachedMaxLevel()\">\n              <i class=\"fa fa-level-up\"></i>\n              <div class=\"btn-actions-label\">\n                Entrar N\u00EDvel\n              </div>\n            </button>\n            <button class=\"btn circle\" *ngIf=\"permissionEdit\" (click)=\"edit($event, object)\">\n              <i class=\"fa fa-pencil\"></i>\n              <div class=\"btn-actions-label\">\n                Editar\n              </div>\n            </button>\n            <button id=\"btnRemove\" *ngIf=\"permissionRemove\" class=\"btn circle\" (click)=\"onClickRemove($event, object)\">\n              <i class=\"fa fa-trash\"></i>\n              <div class=\"btn-actions-label\">\n                Remover\n              </div>\n            </button>\n          </div>\n        </li>\n      </ul>\n\n      <div id=\"form-template\" *ngIf=\"isEditing\">\n        <ng-container *ngTemplateOutlet=\"crudTemplateRef;context:ctx\">\n        </ng-container>\n      </div>\n    </div>\n\n  </elo-accordion-item>\n</elo-accordion>\n" }]
        }], propDecorators: { children: [{
                type: Input
            }], crudTemplateRef: [{
                type: Input
            }], fieldNameSuperior: [{
                type: Input
            }], onRequestChildren: [{
                type: Output
            }], permissionEdit: [{
                type: Input
            }], permissionCreate: [{
                type: Input
            }], permissionRemove: [{
                type: Input
            }], otherField: [{
                type: Input
            }], maxLevels: [{
                type: Input
            }], onRemove: [{
                type: Output
            }], namesLevels: [{
                type: Input
            }] } });

class CrudTreeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudTreeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudTreeModule, declarations: [CrudTreeComponent], imports: [CommonModule, AccordionModule], exports: [CrudTreeComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudTreeModule, imports: [CommonModule, AccordionModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudTreeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, AccordionModule],
                    declarations: [CrudTreeComponent],
                    exports: [CrudTreeComponent]
                }]
        }] });

class CrudFormModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudFormModule, declarations: [CrudFormComponent], imports: [i1$2.FormsModule, i1$2.ReactiveFormsModule, DialogModule,
            RouterModule,
            BackConfirmModule], exports: [CrudFormComponent,
            FormsModule,
            ReactiveFormsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormModule, providers: [CanDeactivateGuard], imports: [FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
            ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
            DialogModule,
            RouterModule,
            BackConfirmModule, FormsModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
                        ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
                        DialogModule,
                        RouterModule,
                        BackConfirmModule
                    ],
                    declarations: [CrudFormComponent],
                    exports: [
                        CrudFormComponent,
                        FormsModule,
                        ReactiveFormsModule
                    ],
                    providers: [CanDeactivateGuard]
                }]
        }] });

const AVAILABLE_OPTIONS = Object.keys(Handsontable.DefaultSettings);
const AVAILABLE_HOOKS = Handsontable.hooks.getRegistered();
class HotSettingsResolver {
    mergeSettings(component) {
        const isSettingsObject = typeof component['settings'] === 'object';
        const mergedSettings = isSettingsObject ? component['settings'] : {};
        const options = AVAILABLE_HOOKS.concat(AVAILABLE_OPTIONS);
        options.forEach(key => {
            const isHook = AVAILABLE_HOOKS.indexOf(key) > -1;
            let option;
            if (isSettingsObject && isHook) {
                option = component['settings'][key];
            }
            if (component[key] !== void 0) {
                option = component[key];
            }
            if (option === void 0) {
                return;
            }
            else if (typeof option === 'function' && isHook) {
                mergedSettings[key] = function (...args) {
                    return component._ngZone.run(() => {
                        return option.apply(this, args);
                    });
                };
            }
            else {
                mergedSettings[key] = option;
            }
        });
        return mergedSettings;
    }
    prepareChanges(changes) {
        const result = {};
        const parameters = Object.keys(changes);
        parameters.forEach((param) => {
            if (changes.hasOwnProperty(param)) {
                result[param] = changes[param].currentValue;
            }
        });
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotSettingsResolver, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotSettingsResolver }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotSettingsResolver, decorators: [{
            type: Injectable
        }] });

const instances = new Map();
class HotTableRegisterer {
    getInstance(id) {
        return instances.get(id);
    }
    registerInstance(id, instance) {
        return instances.set(id, instance);
    }
    removeInstance(id) {
        return instances.delete(id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotTableRegisterer, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotTableRegisterer }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotTableRegisterer, decorators: [{
            type: Injectable
        }] });

class HotTableComponent {
    constructor(_ngZone, _hotTableRegisterer, _hotSettingsResolver) {
        this._ngZone = _ngZone;
        this._hotTableRegisterer = _hotTableRegisterer;
        this._hotSettingsResolver = _hotSettingsResolver;
        this.columnsComponents = [];
        this.hotId = '';
    }
    ngAfterViewInit() {
        const options = this._hotSettingsResolver.mergeSettings(this);
        if (this.columnsComponents.length > 0) {
            const columns = [];
            this.columnsComponents.forEach((column) => {
                columns.push(this._hotSettingsResolver.mergeSettings(column));
            });
            options['columns'] = columns;
        }
        this._ngZone.runOutsideAngular(() => {
            this.hotInstance = new Handsontable.Core(this.container.nativeElement, options);
            if (this.hotId) {
                this._hotTableRegisterer.registerInstance(this.hotId, this.hotInstance);
            }
            // @ts-ignore
            this.hotInstance.init();
        });
    }
    ngOnChanges(changes) {
        if (this.hotInstance === void 0) {
            return;
        }
        const newOptions = this._hotSettingsResolver.prepareChanges(changes);
        this.updateHotTable(newOptions);
    }
    ngOnDestroy() {
        this._ngZone.runOutsideAngular(() => {
            this.hotInstance.destroy();
        });
        if (this.hotId) {
            this._hotTableRegisterer.removeInstance(this.hotId);
        }
    }
    updateHotTable(newSettings) {
        if (!this.hotInstance) {
            return;
        }
        this._ngZone.runOutsideAngular(() => {
            this.hotInstance.updateSettings(newSettings, false);
        });
    }
    onAfterColumnsChange() {
        if (this.columnsComponents === void 0) {
            return;
        }
        if (this.columnsComponents.length > 0) {
            const columns = [];
            this.columnsComponents.forEach((column) => {
                columns.push(this._hotSettingsResolver.mergeSettings(column));
            });
            const newOptions = {
                columns: columns
            };
            this.updateHotTable(newOptions);
        }
    }
    onAfterColumnsNumberChange() {
        const columns = [];
        if (this.columnsComponents.length > 0) {
            this.columnsComponents.forEach((column) => {
                columns.push(this._hotSettingsResolver.mergeSettings(column));
            });
        }
        this.updateHotTable({ columns });
    }
    addColumn(column) {
        this.columnsComponents.push(column);
        this.onAfterColumnsNumberChange();
    }
    removeColumn(column) {
        const index = this.columnsComponents.indexOf(column);
        this.columnsComponents.splice(index, 1);
        this.onAfterColumnsNumberChange();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotTableComponent, deps: [{ token: i0.NgZone }, { token: HotTableRegisterer }, { token: HotSettingsResolver }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: HotTableComponent, selector: "hot-table", inputs: { settings: "settings", hotId: "hotId", activeHeaderClassName: "activeHeaderClassName", allowEmpty: "allowEmpty", allowHtml: "allowHtml", allowInsertColumn: "allowInsertColumn", allowInsertRow: "allowInsertRow", allowInvalid: "allowInvalid", allowRemoveColumn: "allowRemoveColumn", allowRemoveRow: "allowRemoveRow", autoColumnSize: "autoColumnSize", autoRowSize: "autoRowSize", autoWrapCol: "autoWrapCol", autoWrapRow: "autoWrapRow", bindRowsWithHeaders: "bindRowsWithHeaders", cell: "cell", cells: "cells", checkedTemplate: "checkedTemplate", className: "className", colHeaders: "colHeaders", collapsibleColumns: "collapsibleColumns", columnHeaderHeight: "columnHeaderHeight", columns: "columns", columnSorting: "columnSorting", columnSummary: "columnSummary", colWidths: "colWidths", commentedCellClassName: "commentedCellClassName", comments: "comments", contextMenu: "contextMenu", copyable: "copyable", copyPaste: "copyPaste", correctFormat: "correctFormat", currentColClassName: "currentColClassName", currentHeaderClassName: "currentHeaderClassName", currentRowClassName: "currentRowClassName", customBorders: "customBorders", data: "data", dataSchema: "dataSchema", dateFormat: "dateFormat", defaultDate: "defaultDate", disableVisualSelection: "disableVisualSelection", dragToScroll: "dragToScroll", dropdownMenu: "dropdownMenu", editor: "editor", enterBeginsEditing: "enterBeginsEditing", enterMoves: "enterMoves", fillHandle: "fillHandle", filter: "filter", filteringCaseSensitive: "filteringCaseSensitive", filters: "filters", fixedColumnsLeft: "fixedColumnsLeft", fixedRowsBottom: "fixedRowsBottom", fixedRowsTop: "fixedRowsTop", formulas: "formulas", fragmentSelection: "fragmentSelection", headerTooltips: "headerTooltips", height: "height", hiddenColumns: "hiddenColumns", hiddenRows: "hiddenRows", invalidCellClassName: "invalidCellClassName", label: "label", language: "language", licenseKey: "licenseKey", manualColumnFreeze: "manualColumnFreeze", manualColumnMove: "manualColumnMove", manualColumnResize: "manualColumnResize", manualRowMove: "manualRowMove", manualRowResize: "manualRowResize", maxCols: "maxCols", maxRows: "maxRows", mergeCells: "mergeCells", minCols: "minCols", minRows: "minRows", minSpareCols: "minSpareCols", minSpareRows: "minSpareRows", multiColumnSorting: "multiColumnSorting", nestedHeaders: "nestedHeaders", nestedRows: "nestedRows", noWordWrapClassName: "noWordWrapClassName", numericFormat: "numericFormat", observeChanges: "observeChanges", observeDOMVisibility: "observeDOMVisibility", outsideClickDeselects: "outsideClickDeselects", persistentState: "persistentState", placeholder: "placeholder", placeholderCellClassName: "placeholderCellClassName", preventOverflow: "preventOverflow", preventWheel: "preventWheel", readOnly: "readOnly", readOnlyCellClassName: "readOnlyCellClassName", renderAllRows: "renderAllRows", renderer: "renderer", rowHeaders: "rowHeaders", rowHeaderWidth: "rowHeaderWidth", rowHeights: "rowHeights", search: "search", selectionMode: "selectionMode", selectOptions: "selectOptions", skipColumnOnPaste: "skipColumnOnPaste", skipRowOnPaste: "skipRowOnPaste", sortByRelevance: "sortByRelevance", source: "source", startCols: "startCols", startRows: "startRows", stretchH: "stretchH", strict: "strict", tableClassName: "tableClassName", tabMoves: "tabMoves", title: "title", trimDropdown: "trimDropdown", trimRows: "trimRows", trimWhitespace: "trimWhitespace", type: "type", uncheckedTemplate: "uncheckedTemplate", undo: "undo", validator: "validator", viewportColumnRenderingOffset: "viewportColumnRenderingOffset", viewportRowRenderingOffset: "viewportRowRenderingOffset", visibleRows: "visibleRows", width: "width", wordWrap: "wordWrap", afterAddChild: "afterAddChild", afterAutofill: "afterAutofill", afterBeginEditing: "afterBeginEditing", afterCellMetaReset: "afterCellMetaReset", afterChange: "afterChange", afterChangesObserved: "afterChangesObserved", afterColumnCollapse: "afterColumnCollapse", afterColumnExpand: "afterColumnExpand", afterColumnMove: "afterColumnMove", afterColumnResize: "afterColumnResize", afterColumnSort: "afterColumnSort", afterContextMenuDefaultOptions: "afterContextMenuDefaultOptions", afterContextMenuHide: "afterContextMenuHide", afterContextMenuShow: "afterContextMenuShow", afterCopy: "afterCopy", afterCopyLimit: "afterCopyLimit", afterCreateCol: "afterCreateCol", afterCreateRow: "afterCreateRow", afterCut: "afterCut", afterDeselect: "afterDeselect", afterDestroy: "afterDestroy", afterDetachChild: "afterDetachChild", afterDocumentKeyDown: "afterDocumentKeyDown", afterDrawSelection: "afterDrawSelection", afterDropdownMenuDefaultOptions: "afterDropdownMenuDefaultOptions", afterDropdownMenuHide: "afterDropdownMenuHide", afterDropdownMenuShow: "afterDropdownMenuShow", afterFilter: "afterFilter", afterGetCellMeta: "afterGetCellMeta", afterGetColHeader: "afterGetColHeader", afterGetColumnHeaderRenderers: "afterGetColumnHeaderRenderers", afterGetRowHeader: "afterGetRowHeader", afterGetRowHeaderRenderers: "afterGetRowHeaderRenderers", afterHideColumns: "afterHideColumns", afterHideRows: "afterHideRows", afterInit: "afterInit", afterLanguageChange: "afterLanguageChange", afterListen: "afterListen", afterLoadData: "afterLoadData", afterMergeCells: "afterMergeCells", afterModifyTransformEnd: "afterModifyTransformEnd", afterModifyTransformStart: "afterModifyTransformStart", afterMomentumScroll: "afterMomentumScroll", afterOnCellContextMenu: "afterOnCellContextMenu", afterOnCellCornerDblClick: "afterOnCellCornerDblClick", afterOnCellCornerMouseDown: "afterOnCellCornerMouseDown", afterOnCellMouseDown: "afterOnCellMouseDown", afterOnCellMouseOut: "afterOnCellMouseOut", afterOnCellMouseOver: "afterOnCellMouseOver", afterOnCellMouseUp: "afterOnCellMouseUp", afterPaste: "afterPaste", afterPluginsInitialized: "afterPluginsInitialized", afterRedo: "afterRedo", afterRefreshDimensions: "afterRefreshDimensions", afterRemoveCellMeta: "afterRemoveCellMeta", afterRemoveCol: "afterRemoveCol", afterRemoveRow: "afterRemoveRow", afterRender: "afterRender", afterRenderer: "afterRenderer", afterRowMove: "afterRowMove", afterRowResize: "afterRowResize", afterScrollHorizontally: "afterScrollHorizontally", afterScrollVertically: "afterScrollVertically", afterSelection: "afterSelection", afterSelectionByProp: "afterSelectionByProp", afterSelectionEnd: "afterSelectionEnd", afterSelectionEndByProp: "afterSelectionEndByProp", afterSetCellMeta: "afterSetCellMeta", afterSetDataAtCell: "afterSetDataAtCell", afterSetDataAtRowProp: "afterSetDataAtRowProp", afterSetSourceDataAtCell: "afterSetSourceDataAtCell", afterTrimRow: "afterTrimRow", afterUndo: "afterUndo", afterUnhideColumns: "afterUnhideColumns", afterUnhideRows: "afterUnhideRows", afterUnlisten: "afterUnlisten", afterUnmergeCells: "afterUnmergeCells", afterUntrimRow: "afterUntrimRow", afterUpdateSettings: "afterUpdateSettings", afterValidate: "afterValidate", afterViewportColumnCalculatorOverride: "afterViewportColumnCalculatorOverride", afterViewportRowCalculatorOverride: "afterViewportRowCalculatorOverride", beforeAddChild: "beforeAddChild", beforeAutofill: "beforeAutofill", beforeAutofillInsidePopulate: "beforeAutofillInsidePopulate", beforeCellAlignment: "beforeCellAlignment", beforeChange: "beforeChange", beforeChangeRender: "beforeChangeRender", beforeColumnCollapse: "beforeColumnCollapse", beforeColumnExpand: "beforeColumnExpand", beforeColumnMove: "beforeColumnMove", beforeColumnResize: "beforeColumnResize", beforeColumnSort: "beforeColumnSort", beforeContextMenuSetItems: "beforeContextMenuSetItems", beforeContextMenuShow: "beforeContextMenuShow", beforeCopy: "beforeCopy", beforeCreateCol: "beforeCreateCol", beforeCreateRow: "beforeCreateRow", beforeCut: "beforeCut", beforeDetachChild: "beforeDetachChild", beforeDrawBorders: "beforeDrawBorders", beforeDropdownMenuSetItems: "beforeDropdownMenuSetItems", beforeDropdownMenuShow: "beforeDropdownMenuShow", beforeFilter: "beforeFilter", beforeGetCellMeta: "beforeGetCellMeta", beforeHideColumns: "beforeHideColumns", beforeHideRows: "beforeHideRows", beforeInit: "beforeInit", beforeInitWalkontable: "beforeInitWalkontable", beforeKeyDown: "beforeKeyDown", beforeLanguageChange: "beforeLanguageChange", beforeLoadData: "beforeLoadData", beforeMergeCells: "beforeMergeCells", beforeOnCellContextMenu: "beforeOnCellContextMenu", beforeOnCellMouseDown: "beforeOnCellMouseDown", beforeOnCellMouseOut: "beforeOnCellMouseOut", beforeOnCellMouseOver: "beforeOnCellMouseOver", beforeOnCellMouseUp: "beforeOnCellMouseUp", beforePaste: "beforePaste", beforeRedo: "beforeRedo", beforeRefreshDimensions: "beforeRefreshDimensions", beforeRemoveCellClassNames: "beforeRemoveCellClassNames", beforeRemoveCellMeta: "beforeRemoveCellMeta", beforeRemoveCol: "beforeRemoveCol", beforeRemoveRow: "beforeRemoveRow", beforeRender: "beforeRender", beforeRenderer: "beforeRenderer", beforeRowMove: "beforeRowMove", beforeRowResize: "beforeRowResize", beforeSetCellMeta: "beforeSetCellMeta", beforeSetRangeEnd: "beforeSetRangeEnd", beforeSetRangeStart: "beforeSetRangeStart", beforeSetRangeStartOnly: "beforeSetRangeStartOnly", beforeStretchingColumnWidth: "beforeStretchingColumnWidth", beforeTouchScroll: "beforeTouchScroll", beforeTrimRow: "beforeTrimRow", beforeUndo: "beforeUndo", beforeUnhideColumns: "beforeUnhideColumns", beforeUnhideRows: "beforeUnhideRows", beforeUnmergeCells: "beforeUnmergeCells", beforeUntrimRow: "beforeUntrimRow", beforeValidate: "beforeValidate", beforeValueRender: "beforeValueRender", construct: "construct", init: "init", modifyAutofillRange: "modifyAutofillRange", modifyColHeader: "modifyColHeader", modifyColumnHeaderHeight: "modifyColumnHeaderHeight", modifyColWidth: "modifyColWidth", modifyCopyableRange: "modifyCopyableRange", modifyData: "modifyData", modifyGetCellCoords: "modifyGetCellCoords", modifyRowData: "modifyRowData", modifyRowHeader: "modifyRowHeader", modifyRowHeaderWidth: "modifyRowHeaderWidth", modifyRowHeight: "modifyRowHeight", modifySourceData: "modifySourceData", modifyTransformEnd: "modifyTransformEnd", modifyTransformStart: "modifyTransformStart", persistentStateLoad: "persistentStateLoad", persistentStateReset: "persistentStateReset", persistentStateSave: "persistentStateSave" }, providers: [HotTableRegisterer, HotSettingsResolver], viewQueries: [{ propertyName: "container", first: true, predicate: ["container"], descendants: true }], usesOnChanges: true, ngImport: i0, template: '<div #container [id]="hotId"></div>', isInline: true, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hot-table',
                    template: '<div #container [id]="hotId"></div>',
                    encapsulation: ViewEncapsulation.None,
                    providers: [HotTableRegisterer, HotSettingsResolver],
                }]
        }], ctorParameters: () => [{ type: i0.NgZone }, { type: HotTableRegisterer }, { type: HotSettingsResolver }], propDecorators: { container: [{
                type: ViewChild,
                args: ['container', { static: false }]
            }], settings: [{
                type: Input
            }], hotId: [{
                type: Input
            }], activeHeaderClassName: [{
                type: Input
            }], allowEmpty: [{
                type: Input
            }], allowHtml: [{
                type: Input
            }], allowInsertColumn: [{
                type: Input
            }], allowInsertRow: [{
                type: Input
            }], allowInvalid: [{
                type: Input
            }], allowRemoveColumn: [{
                type: Input
            }], allowRemoveRow: [{
                type: Input
            }], autoColumnSize: [{
                type: Input
            }], autoRowSize: [{
                type: Input
            }], autoWrapCol: [{
                type: Input
            }], autoWrapRow: [{
                type: Input
            }], bindRowsWithHeaders: [{
                type: Input
            }], cell: [{
                type: Input
            }], cells: [{
                type: Input
            }], checkedTemplate: [{
                type: Input
            }], className: [{
                type: Input
            }], colHeaders: [{
                type: Input
            }], collapsibleColumns: [{
                type: Input
            }], columnHeaderHeight: [{
                type: Input
            }], columns: [{
                type: Input
            }], columnSorting: [{
                type: Input
            }], columnSummary: [{
                type: Input
            }], colWidths: [{
                type: Input
            }], commentedCellClassName: [{
                type: Input
            }], comments: [{
                type: Input
            }], contextMenu: [{
                type: Input
            }], copyable: [{
                type: Input
            }], copyPaste: [{
                type: Input
            }], correctFormat: [{
                type: Input
            }], currentColClassName: [{
                type: Input
            }], currentHeaderClassName: [{
                type: Input
            }], currentRowClassName: [{
                type: Input
            }], customBorders: [{
                type: Input
            }], data: [{
                type: Input
            }], dataSchema: [{
                type: Input
            }], dateFormat: [{
                type: Input
            }], defaultDate: [{
                type: Input
            }], disableVisualSelection: [{
                type: Input
            }], dragToScroll: [{
                type: Input
            }], dropdownMenu: [{
                type: Input
            }], editor: [{
                type: Input
            }], enterBeginsEditing: [{
                type: Input
            }], enterMoves: [{
                type: Input
            }], fillHandle: [{
                type: Input
            }], filter: [{
                type: Input
            }], filteringCaseSensitive: [{
                type: Input
            }], filters: [{
                type: Input
            }], fixedColumnsLeft: [{
                type: Input
            }], fixedRowsBottom: [{
                type: Input
            }], fixedRowsTop: [{
                type: Input
            }], formulas: [{
                type: Input
            }], fragmentSelection: [{
                type: Input
            }], headerTooltips: [{
                type: Input
            }], height: [{
                type: Input
            }], hiddenColumns: [{
                type: Input
            }], hiddenRows: [{
                type: Input
            }], invalidCellClassName: [{
                type: Input
            }], label: [{
                type: Input
            }], language: [{
                type: Input
            }], licenseKey: [{
                type: Input
            }], manualColumnFreeze: [{
                type: Input
            }], manualColumnMove: [{
                type: Input
            }], manualColumnResize: [{
                type: Input
            }], manualRowMove: [{
                type: Input
            }], manualRowResize: [{
                type: Input
            }], maxCols: [{
                type: Input
            }], maxRows: [{
                type: Input
            }], mergeCells: [{
                type: Input
            }], minCols: [{
                type: Input
            }], minRows: [{
                type: Input
            }], minSpareCols: [{
                type: Input
            }], minSpareRows: [{
                type: Input
            }], multiColumnSorting: [{
                type: Input
            }], nestedHeaders: [{
                type: Input
            }], nestedRows: [{
                type: Input
            }], noWordWrapClassName: [{
                type: Input
            }], numericFormat: [{
                type: Input
            }], observeChanges: [{
                type: Input
            }], observeDOMVisibility: [{
                type: Input
            }], outsideClickDeselects: [{
                type: Input
            }], persistentState: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], placeholderCellClassName: [{
                type: Input
            }], preventOverflow: [{
                type: Input
            }], preventWheel: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], readOnlyCellClassName: [{
                type: Input
            }], renderAllRows: [{
                type: Input
            }], renderer: [{
                type: Input
            }], rowHeaders: [{
                type: Input
            }], rowHeaderWidth: [{
                type: Input
            }], rowHeights: [{
                type: Input
            }], search: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], selectOptions: [{
                type: Input
            }], skipColumnOnPaste: [{
                type: Input
            }], skipRowOnPaste: [{
                type: Input
            }], sortByRelevance: [{
                type: Input
            }], source: [{
                type: Input
            }], startCols: [{
                type: Input
            }], startRows: [{
                type: Input
            }], stretchH: [{
                type: Input
            }], strict: [{
                type: Input
            }], tableClassName: [{
                type: Input
            }], tabMoves: [{
                type: Input
            }], title: [{
                type: Input
            }], trimDropdown: [{
                type: Input
            }], trimRows: [{
                type: Input
            }], trimWhitespace: [{
                type: Input
            }], type: [{
                type: Input
            }], uncheckedTemplate: [{
                type: Input
            }], undo: [{
                type: Input
            }], validator: [{
                type: Input
            }], viewportColumnRenderingOffset: [{
                type: Input
            }], viewportRowRenderingOffset: [{
                type: Input
            }], visibleRows: [{
                type: Input
            }], width: [{
                type: Input
            }], wordWrap: [{
                type: Input
            }], afterAddChild: [{
                type: Input
            }], afterAutofill: [{
                type: Input
            }], afterBeginEditing: [{
                type: Input
            }], afterCellMetaReset: [{
                type: Input
            }], afterChange: [{
                type: Input
            }], afterChangesObserved: [{
                type: Input
            }], afterColumnCollapse: [{
                type: Input
            }], afterColumnExpand: [{
                type: Input
            }], afterColumnMove: [{
                type: Input
            }], afterColumnResize: [{
                type: Input
            }], afterColumnSort: [{
                type: Input
            }], afterContextMenuDefaultOptions: [{
                type: Input
            }], afterContextMenuHide: [{
                type: Input
            }], afterContextMenuShow: [{
                type: Input
            }], afterCopy: [{
                type: Input
            }], afterCopyLimit: [{
                type: Input
            }], afterCreateCol: [{
                type: Input
            }], afterCreateRow: [{
                type: Input
            }], afterCut: [{
                type: Input
            }], afterDeselect: [{
                type: Input
            }], afterDestroy: [{
                type: Input
            }], afterDetachChild: [{
                type: Input
            }], afterDocumentKeyDown: [{
                type: Input
            }], afterDrawSelection: [{
                type: Input
            }], afterDropdownMenuDefaultOptions: [{
                type: Input
            }], afterDropdownMenuHide: [{
                type: Input
            }], afterDropdownMenuShow: [{
                type: Input
            }], afterFilter: [{
                type: Input
            }], afterGetCellMeta: [{
                type: Input
            }], afterGetColHeader: [{
                type: Input
            }], afterGetColumnHeaderRenderers: [{
                type: Input
            }], afterGetRowHeader: [{
                type: Input
            }], afterGetRowHeaderRenderers: [{
                type: Input
            }], afterHideColumns: [{
                type: Input
            }], afterHideRows: [{
                type: Input
            }], afterInit: [{
                type: Input
            }], afterLanguageChange: [{
                type: Input
            }], afterListen: [{
                type: Input
            }], afterLoadData: [{
                type: Input
            }], afterMergeCells: [{
                type: Input
            }], afterModifyTransformEnd: [{
                type: Input
            }], afterModifyTransformStart: [{
                type: Input
            }], afterMomentumScroll: [{
                type: Input
            }], afterOnCellContextMenu: [{
                type: Input
            }], afterOnCellCornerDblClick: [{
                type: Input
            }], afterOnCellCornerMouseDown: [{
                type: Input
            }], afterOnCellMouseDown: [{
                type: Input
            }], afterOnCellMouseOut: [{
                type: Input
            }], afterOnCellMouseOver: [{
                type: Input
            }], afterOnCellMouseUp: [{
                type: Input
            }], afterPaste: [{
                type: Input
            }], afterPluginsInitialized: [{
                type: Input
            }], afterRedo: [{
                type: Input
            }], afterRefreshDimensions: [{
                type: Input
            }], afterRemoveCellMeta: [{
                type: Input
            }], afterRemoveCol: [{
                type: Input
            }], afterRemoveRow: [{
                type: Input
            }], afterRender: [{
                type: Input
            }], afterRenderer: [{
                type: Input
            }], afterRowMove: [{
                type: Input
            }], afterRowResize: [{
                type: Input
            }], afterScrollHorizontally: [{
                type: Input
            }], afterScrollVertically: [{
                type: Input
            }], afterSelection: [{
                type: Input
            }], afterSelectionByProp: [{
                type: Input
            }], afterSelectionEnd: [{
                type: Input
            }], afterSelectionEndByProp: [{
                type: Input
            }], afterSetCellMeta: [{
                type: Input
            }], afterSetDataAtCell: [{
                type: Input
            }], afterSetDataAtRowProp: [{
                type: Input
            }], afterSetSourceDataAtCell: [{
                type: Input
            }], afterTrimRow: [{
                type: Input
            }], afterUndo: [{
                type: Input
            }], afterUnhideColumns: [{
                type: Input
            }], afterUnhideRows: [{
                type: Input
            }], afterUnlisten: [{
                type: Input
            }], afterUnmergeCells: [{
                type: Input
            }], afterUntrimRow: [{
                type: Input
            }], afterUpdateSettings: [{
                type: Input
            }], afterValidate: [{
                type: Input
            }], afterViewportColumnCalculatorOverride: [{
                type: Input
            }], afterViewportRowCalculatorOverride: [{
                type: Input
            }], beforeAddChild: [{
                type: Input
            }], beforeAutofill: [{
                type: Input
            }], beforeAutofillInsidePopulate: [{
                type: Input
            }], beforeCellAlignment: [{
                type: Input
            }], beforeChange: [{
                type: Input
            }], beforeChangeRender: [{
                type: Input
            }], beforeColumnCollapse: [{
                type: Input
            }], beforeColumnExpand: [{
                type: Input
            }], beforeColumnMove: [{
                type: Input
            }], beforeColumnResize: [{
                type: Input
            }], beforeColumnSort: [{
                type: Input
            }], beforeContextMenuSetItems: [{
                type: Input
            }], beforeContextMenuShow: [{
                type: Input
            }], beforeCopy: [{
                type: Input
            }], beforeCreateCol: [{
                type: Input
            }], beforeCreateRow: [{
                type: Input
            }], beforeCut: [{
                type: Input
            }], beforeDetachChild: [{
                type: Input
            }], beforeDrawBorders: [{
                type: Input
            }], beforeDropdownMenuSetItems: [{
                type: Input
            }], beforeDropdownMenuShow: [{
                type: Input
            }], beforeFilter: [{
                type: Input
            }], beforeGetCellMeta: [{
                type: Input
            }], beforeHideColumns: [{
                type: Input
            }], beforeHideRows: [{
                type: Input
            }], beforeInit: [{
                type: Input
            }], beforeInitWalkontable: [{
                type: Input
            }], beforeKeyDown: [{
                type: Input
            }], beforeLanguageChange: [{
                type: Input
            }], beforeLoadData: [{
                type: Input
            }], beforeMergeCells: [{
                type: Input
            }], beforeOnCellContextMenu: [{
                type: Input
            }], beforeOnCellMouseDown: [{
                type: Input
            }], beforeOnCellMouseOut: [{
                type: Input
            }], beforeOnCellMouseOver: [{
                type: Input
            }], beforeOnCellMouseUp: [{
                type: Input
            }], beforePaste: [{
                type: Input
            }], beforeRedo: [{
                type: Input
            }], beforeRefreshDimensions: [{
                type: Input
            }], beforeRemoveCellClassNames: [{
                type: Input
            }], beforeRemoveCellMeta: [{
                type: Input
            }], beforeRemoveCol: [{
                type: Input
            }], beforeRemoveRow: [{
                type: Input
            }], beforeRender: [{
                type: Input
            }], beforeRenderer: [{
                type: Input
            }], beforeRowMove: [{
                type: Input
            }], beforeRowResize: [{
                type: Input
            }], beforeSetCellMeta: [{
                type: Input
            }], beforeSetRangeEnd: [{
                type: Input
            }], beforeSetRangeStart: [{
                type: Input
            }], beforeSetRangeStartOnly: [{
                type: Input
            }], beforeStretchingColumnWidth: [{
                type: Input
            }], beforeTouchScroll: [{
                type: Input
            }], beforeTrimRow: [{
                type: Input
            }], beforeUndo: [{
                type: Input
            }], beforeUnhideColumns: [{
                type: Input
            }], beforeUnhideRows: [{
                type: Input
            }], beforeUnmergeCells: [{
                type: Input
            }], beforeUntrimRow: [{
                type: Input
            }], beforeValidate: [{
                type: Input
            }], beforeValueRender: [{
                type: Input
            }], construct: [{
                type: Input
            }], init: [{
                type: Input
            }], modifyAutofillRange: [{
                type: Input
            }], modifyColHeader: [{
                type: Input
            }], modifyColumnHeaderHeight: [{
                type: Input
            }], modifyColWidth: [{
                type: Input
            }], modifyCopyableRange: [{
                type: Input
            }], modifyData: [{
                type: Input
            }], modifyGetCellCoords: [{
                type: Input
            }], modifyRowData: [{
                type: Input
            }], modifyRowHeader: [{
                type: Input
            }], modifyRowHeaderWidth: [{
                type: Input
            }], modifyRowHeight: [{
                type: Input
            }], modifySourceData: [{
                type: Input
            }], modifyTransformEnd: [{
                type: Input
            }], modifyTransformStart: [{
                type: Input
            }], persistentStateLoad: [{
                type: Input
            }], persistentStateReset: [{
                type: Input
            }], persistentStateSave: [{
                type: Input
            }] } });

class HotColumnComponent {
    constructor(parentComponent) {
        this.parentComponent = parentComponent;
        this.firstRun = true;
    }
    ngOnInit() {
        this.firstRun = false;
        this.parentComponent.addColumn(this);
    }
    ngOnChanges() {
        if (this.firstRun) {
            return;
        }
        this.parentComponent.onAfterColumnsChange();
    }
    ngOnDestroy() {
        this.parentComponent.removeColumn(this);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotColumnComponent, deps: [{ token: HotTableComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: HotColumnComponent, selector: "hot-column", inputs: { allowEmpty: "allowEmpty", allowHtml: "allowHtml", allowInvalid: "allowInvalid", checkedTemplate: "checkedTemplate", className: "className", columnSorting: "columnSorting", colWidths: "colWidths", commentedCellClassName: "commentedCellClassName", copyable: "copyable", correctFormat: "correctFormat", data: "data", dateFormat: "dateFormat", defaultDate: "defaultDate", editor: "editor", filteringCaseSensitive: "filteringCaseSensitive", invalidCellClassName: "invalidCellClassName", label: "label", language: "language", noWordWrapClassName: "noWordWrapClassName", numericFormat: "numericFormat", placeholder: "placeholder", placeholderCellClassName: "placeholderCellClassName", readOnly: "readOnly", readOnlyCellClassName: "readOnlyCellClassName", renderer: "renderer", selectOptions: "selectOptions", skipColumnOnPaste: "skipColumnOnPaste", sortByRelevance: "sortByRelevance", source: "source", strict: "strict", title: "title", trimDropdown: "trimDropdown", type: "type", uncheckedTemplate: "uncheckedTemplate", validator: "validator", visibleRows: "visibleRows", width: "width", wordWrap: "wordWrap" }, usesOnChanges: true, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hot-column',
                    template: '',
                }]
        }], ctorParameters: () => [{ type: HotTableComponent }], propDecorators: { allowEmpty: [{
                type: Input
            }], allowHtml: [{
                type: Input
            }], allowInvalid: [{
                type: Input
            }], checkedTemplate: [{
                type: Input
            }], className: [{
                type: Input
            }], columnSorting: [{
                type: Input
            }], colWidths: [{
                type: Input
            }], commentedCellClassName: [{
                type: Input
            }], copyable: [{
                type: Input
            }], correctFormat: [{
                type: Input
            }], data: [{
                type: Input
            }], dateFormat: [{
                type: Input
            }], defaultDate: [{
                type: Input
            }], editor: [{
                type: Input
            }], filteringCaseSensitive: [{
                type: Input
            }], invalidCellClassName: [{
                type: Input
            }], label: [{
                type: Input
            }], language: [{
                type: Input
            }], noWordWrapClassName: [{
                type: Input
            }], numericFormat: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], placeholderCellClassName: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], readOnlyCellClassName: [{
                type: Input
            }], renderer: [{
                type: Input
            }], selectOptions: [{
                type: Input
            }], skipColumnOnPaste: [{
                type: Input
            }], sortByRelevance: [{
                type: Input
            }], source: [{
                type: Input
            }], strict: [{
                type: Input
            }], title: [{
                type: Input
            }], trimDropdown: [{
                type: Input
            }], type: [{
                type: Input
            }], uncheckedTemplate: [{
                type: Input
            }], validator: [{
                type: Input
            }], visibleRows: [{
                type: Input
            }], width: [{
                type: Input
            }], wordWrap: [{
                type: Input
            }] } });

/**
 * Angular prevents use static public getters under NgModule decorator.
 * Moreover, ngc doesn't allow importing `Version` from external file.
 */
class Version {
    static get version() {
        return '0.0.0-VERSION';
    }
}
class HotTableModule extends Version {
    static forRoot() {
        return {
            ngModule: HotTableModule,
            providers: [HotTableRegisterer],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotTableModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: HotTableModule, declarations: [HotTableComponent,
            HotColumnComponent], exports: [HotTableComponent,
            HotColumnComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotTableModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HotTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        HotTableComponent,
                        HotColumnComponent,
                    ],
                    exports: [
                        HotTableComponent,
                        HotColumnComponent,
                    ]
                }]
        }] });

class ItemDetailInformationDirective {
    constructor() {
        this.md = 0;
        this.lineTitle = '';
        this.lineValue = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ItemDetailInformationDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ItemDetailInformationDirective, selector: "[itemDetailInformation]", inputs: { md: "md", lineTitle: "lineTitle", lineValue: "lineValue" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ItemDetailInformationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[itemDetailInformation]'
                }]
        }], propDecorators: { md: [{
                type: Input
            }], lineTitle: [{
                type: Input
            }], lineValue: [{
                type: Input
            }] } });

class ItemDetailInformationComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ItemDetailInformationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ItemDetailInformationComponent, selector: "elo-item-detail-information", inputs: { item: "item" }, ngImport: i0, template: "<div class=\"col-md-{{item.md}}\">\n  <a class=\"list-group-item\">\n    <p class=\"list-group-item-heading\">\n      <span class=\"lineTitle\">{{item.lineTitle}}: </span>\n      <span class=\"lineValue\">{{item.lineValue}}</span>\n    </p>\n  </a>\n</div>\n", styles: [".lineTitle{font-weight:700;color:#226e92;font-size:98%}.lineValue{font-size:100%}.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-xs-1,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9{margin-right:-15px;margin-left:-15px}*{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}*:before,*:after{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ItemDetailInformationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-item-detail-information', template: "<div class=\"col-md-{{item.md}}\">\n  <a class=\"list-group-item\">\n    <p class=\"list-group-item-heading\">\n      <span class=\"lineTitle\">{{item.lineTitle}}: </span>\n      <span class=\"lineValue\">{{item.lineValue}}</span>\n    </p>\n  </a>\n</div>\n", styles: [".lineTitle{font-weight:700;color:#226e92;font-size:98%}.lineValue{font-size:100%}.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-xs-1,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9{margin-right:-15px;margin-left:-15px}*{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}*:before,*:after{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}\n"] }]
        }], propDecorators: { item: [{
                type: Input
            }] } });

class DetailInformationComponent {
    constructor() {
        this.title = '';
        this.items = new QueryList();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DetailInformationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DetailInformationComponent, selector: "elo-detail-information", inputs: { title: "title" }, queries: [{ propertyName: "items", predicate: ItemDetailInformationDirective }], ngImport: i0, template: "<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    {{title}}\n  </div>\n  <div class=\"panel-body\">\n     <div class=\"list-group\">\n        <div *ngFor=\"let item of items\">\n          <elo-item-detail-information [item]=\"item\" ></elo-item-detail-information>\n        </div>\n     </div>\n  </div>\n</div>\n", styles: [".panel{width:90%;margin-top:20px;margin-left:auto;margin-right:auto;padding:5px}.panel-heading{font-weight:700;color:#5d5d5d;font-size:110%}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: ItemDetailInformationComponent, selector: "elo-item-detail-information", inputs: ["item"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DetailInformationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-detail-information', template: "<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    {{title}}\n  </div>\n  <div class=\"panel-body\">\n     <div class=\"list-group\">\n        <div *ngFor=\"let item of items\">\n          <elo-item-detail-information [item]=\"item\" ></elo-item-detail-information>\n        </div>\n     </div>\n  </div>\n</div>\n", styles: [".panel{width:90%;margin-top:20px;margin-left:auto;margin-right:auto;padding:5px}.panel-heading{font-weight:700;color:#5d5d5d;font-size:110%}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], items: [{
                type: ContentChildren,
                args: [ItemDetailInformationDirective]
            }] } });

class DetailInformationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DetailInformationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DetailInformationModule, declarations: [DetailInformationComponent,
            ItemDetailInformationComponent,
            ItemDetailInformationDirective], imports: [CommonModule], exports: [DetailInformationComponent, ItemDetailInformationDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DetailInformationModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DetailInformationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DetailInformationComponent,
                        ItemDetailInformationComponent,
                        ItemDetailInformationDirective
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [DetailInformationComponent, ItemDetailInformationDirective],
                }]
        }] });

class EloTreeComponent {
    constructor() {
        this.actionOnClick = new EventEmitter();
        this.treeActions = [];
    }
    onClickTreeLevel(item, clickEvent) {
        this.selectedItem = item;
        if (this.isTreeActionLine(clickEvent))
            return;
        item.niveis?.length ? this.onCloseExpand(item) : this.actionOnClick.emit(item);
    }
    onCloseExpand(obj) {
        obj.expanded = !obj.expanded;
        obj.niveis.forEach(nivel => nivel['father'] = obj);
    }
    addTreeActions(treeActions) {
        this.treeActions.push(treeActions);
    }
    isTreeActionLine(clickEvent) {
        return clickEvent?.target['id'] === 'header';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTreeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloTreeComponent, selector: "elo-tree", inputs: { tree: "tree", title: "title", subtitle: "subtitle" }, outputs: { actionOnClick: "actionOnClick" }, ngImport: i0, template: "<div class=\"row mt-xs\" *ngIf=\"tree\">\n  <div class=\"col-md-12\">\n    <div class=\"panel table table-responsive\">\n      <div class=\"panel-title\">{{ title }}</div>\n      <div class=\"panel-body\">\n        <div class=\"panel-table-outer\">\n          <table class=\"panel-table tree tree-arrow\">\n            <tbody>\n              <ng-container [ngTemplateOutlet]=\"treeChildrens\" [ngTemplateOutletContext]=\"{ tree: tree, nivel: 1 }\">\n              </ng-container>\n            </tbody>\n          </table>\n        </div>\n        <div class=\"subtitles\">\n          <ng-container *ngIf=\"subtitle\" [ngTemplateOutlet]=\"subtitle\"/>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-template #treeChildrens let-tree=\"tree\" let-nivel=\"nivel\">\n\n  <ng-container *ngFor=\"let node of tree\">\n\n    <tr class=\"level-{{ nivel }} {{ node?.error ? 'error' : '' }} hover-tr\" style=\"cursor: pointer;\"\n        [ngClass]=\"{ 'father': node?.niveis?.length, 'open': node?.expanded }\" (click)=\"onClickTreeLevel(node, $event)\">\n\n      <td [style]=\"node?.id === selectedItem?.id ? 'color: #00AA55;' : ''\"> {{ node?.descricao }}\n      </td>\n\n      <td class=\"has-btn-actions\" *ngIf=\"treeActions.length\">\n        <div class=\"btn-actions\">\n          <div class=\"btn-actions-inner\">\n            <ng-container *ngFor=\"let actions of treeActions\">\n              <button class=\"btn\" id=\"header\" (click)=\"actions.onClick(node)\">\n                <i [class]=\"actions.icon\" id=\"header\"></i>\n                <div class=\"btn-actions-label\">{{ actions.title }}</div>\n              </button>\n            </ng-container>\n          </div>\n        </div>\n      </td>\n\n    </tr>\n\n    <ng-container *ngIf=\"node?.niveis?.length && node?.expanded\">\n      <ng-container [ngTemplateOutlet]=\"treeChildrens\"\n        [ngTemplateOutletContext]=\"{ tree: node?.niveis, nivel: nivel + 1 }\"/>\n    </ng-container>\n\n  </ng-container>\n\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-tree', template: "<div class=\"row mt-xs\" *ngIf=\"tree\">\n  <div class=\"col-md-12\">\n    <div class=\"panel table table-responsive\">\n      <div class=\"panel-title\">{{ title }}</div>\n      <div class=\"panel-body\">\n        <div class=\"panel-table-outer\">\n          <table class=\"panel-table tree tree-arrow\">\n            <tbody>\n              <ng-container [ngTemplateOutlet]=\"treeChildrens\" [ngTemplateOutletContext]=\"{ tree: tree, nivel: 1 }\">\n              </ng-container>\n            </tbody>\n          </table>\n        </div>\n        <div class=\"subtitles\">\n          <ng-container *ngIf=\"subtitle\" [ngTemplateOutlet]=\"subtitle\"/>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-template #treeChildrens let-tree=\"tree\" let-nivel=\"nivel\">\n\n  <ng-container *ngFor=\"let node of tree\">\n\n    <tr class=\"level-{{ nivel }} {{ node?.error ? 'error' : '' }} hover-tr\" style=\"cursor: pointer;\"\n        [ngClass]=\"{ 'father': node?.niveis?.length, 'open': node?.expanded }\" (click)=\"onClickTreeLevel(node, $event)\">\n\n      <td [style]=\"node?.id === selectedItem?.id ? 'color: #00AA55;' : ''\"> {{ node?.descricao }}\n      </td>\n\n      <td class=\"has-btn-actions\" *ngIf=\"treeActions.length\">\n        <div class=\"btn-actions\">\n          <div class=\"btn-actions-inner\">\n            <ng-container *ngFor=\"let actions of treeActions\">\n              <button class=\"btn\" id=\"header\" (click)=\"actions.onClick(node)\">\n                <i [class]=\"actions.icon\" id=\"header\"></i>\n                <div class=\"btn-actions-label\">{{ actions.title }}</div>\n              </button>\n            </ng-container>\n          </div>\n        </div>\n      </td>\n\n    </tr>\n\n    <ng-container *ngIf=\"node?.niveis?.length && node?.expanded\">\n      <ng-container [ngTemplateOutlet]=\"treeChildrens\"\n        [ngTemplateOutletContext]=\"{ tree: node?.niveis, nivel: nivel + 1 }\"/>\n    </ng-container>\n\n  </ng-container>\n\n</ng-template>\n" }]
        }], propDecorators: { tree: [{
                type: Input
            }], title: [{
                type: Input
            }], actionOnClick: [{
                type: Output
            }], subtitle: [{
                type: Input
            }] } });

class EloTreeActionsComponent {
    constructor(tree) {
        this.tree = tree;
        this.onClickEmitter = new EventEmitter();
        this.icon = 'fa fa-filter';
        tree.addTreeActions(this);
    }
    onClick(object) {
        this.onClickEmitter.emit(object);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTreeActionsComponent, deps: [{ token: EloTreeComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloTreeActionsComponent, selector: "elo-tree-actions", inputs: { title: "title", template: "template", icon: "icon" }, outputs: { onClickEmitter: "onClickEmitter" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTreeActionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-tree-actions',
                    template: ''
                }]
        }], ctorParameters: () => [{ type: EloTreeComponent }], propDecorators: { onClickEmitter: [{
                type: Output
            }], title: [{
                type: Input
            }], template: [{
                type: Input
            }], icon: [{
                type: Input
            }] } });

class EloTreeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTreeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloTreeModule, declarations: [EloTreeComponent, EloTreeActionsComponent], imports: [CommonModule], exports: [EloTreeComponent, EloTreeActionsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTreeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTreeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [EloTreeComponent, EloTreeActionsComponent],
                    declarations: [EloTreeComponent, EloTreeActionsComponent],
                    providers: [],
                }]
        }] });

class EntidadeSelectorComponent {
    constructor(authParams) {
        this.authParams = authParams;
        this.onSelectEntidade = new EventEmitter();
        this.expansive = false;
        this.collapsed = false;
        this.title = 'Entidades';
        this.idSelector = 'entidades';
        this.entidades = [];
        this.entidadesPadrao = [];
    }
    ngOnInit() {
        this.entidadeService.findAllUnlimited('', new PageParameters(9999, 0, 'nome'))
            .subscribe(entidades => {
            this.entidades = entidades;
            this.entidadesPadrao = this.entidades.filter(e => e.id === this.authParams.getUsuarioInfo().entidadePadrao.id);
            this.selectEntidade(this.entidadesPadrao);
        });
    }
    selectEntidade(entidadesSelecionadas) {
        this.entidadesPadrao = entidadesSelecionadas;
        this.onSelectEntidade.emit(this.entidadesPadrao.map((entidade) => entidade.id).join('-'));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntidadeSelectorComponent, deps: [{ token: AbstractAuthHttp }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EntidadeSelectorComponent, selector: "entidade-selector", inputs: { entidadeService: "entidadeService", expansive: "expansive", collapsed: "collapsed", title: "title", idSelector: "idSelector" }, outputs: { onSelectEntidade: "onSelectEntidade" }, ngImport: i0, template: "<div class=\"mt-sm\">\n  <elo-panel-expansive [title]=\"title\" [hasTable]=\"true\" [expansive]=\"expansive\" [collapsed]=\"collapsed\">\n    <elo-datatable [selectionModeId]=\"idSelector\" [emptyMessage]=\"'N\u00E3o foi encontrado entidades.'\" [id]=\"idSelector\"\n      selectionMode=\"multiple\" [values]=\"entidades\" (onModifySelection)=\"selectEntidade($event)\"\n      [selection]=\"entidadesPadrao\" [class]=\"'fancy fixed'\">\n      <elo-column field=\"nome\" header=\"Nome\"></elo-column>\n    </elo-datatable>\n  </elo-panel-expansive>\n</div>\n", dependencies: [{ kind: "component", type: PanelExpansiveComponent, selector: "elo-panel-expansive", inputs: ["collapsed", "title", "hasTable", "hasForm", "expansive", "showButton", "disabledButton", "hideButtonNovo", "titleButtonNovo", "extraButtons", "enableScrollX", "isInsideTab", "collapsedCookie", "error"], outputs: ["onExpand", "onNewItem"] }, { kind: "component", type: EloDatatableComponent, selector: "elo-datatable", inputs: ["values", "paramExpandTemplate", "emptyMessage", "selection", "selectionMode", "selectionModeId", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "titleCheckboxDisallowed", "sortable", "pageParameters", "class", "colSpanActions", "isQuickViewOpener", "manyActions", "classEmptyMessage", "rowDoubleClickFunction", "visibleRadioWhenFunction", "enableScrollX", "textTransform", "headerFixo", "showHeader", "selectionModeWithFooter"], outputs: ["onClickCheckbox", "onClickRadioButton", "onSelectOne", "onModifySelection", "onTableHeadClick", "onInputChange", "onRowDoubleClick"] }, { kind: "component", type: EloColumnComponent, selector: "elo-column", inputs: ["field", "header", "headerAlign", "isDecimal", "isPercentual", "digits", "isDate", "isDateTime", "isCnpjCpf", "enumOptions", "col", "class", "isEditable", "isEditing", "dataTable", "hidden", "hiddenTableData", "sortable", "samp", "headerStyle", "dataStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntidadeSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'entidade-selector', template: "<div class=\"mt-sm\">\n  <elo-panel-expansive [title]=\"title\" [hasTable]=\"true\" [expansive]=\"expansive\" [collapsed]=\"collapsed\">\n    <elo-datatable [selectionModeId]=\"idSelector\" [emptyMessage]=\"'N\u00E3o foi encontrado entidades.'\" [id]=\"idSelector\"\n      selectionMode=\"multiple\" [values]=\"entidades\" (onModifySelection)=\"selectEntidade($event)\"\n      [selection]=\"entidadesPadrao\" [class]=\"'fancy fixed'\">\n      <elo-column field=\"nome\" header=\"Nome\"></elo-column>\n    </elo-datatable>\n  </elo-panel-expansive>\n</div>\n" }]
        }], ctorParameters: () => [{ type: AbstractAuthHttp }], propDecorators: { onSelectEntidade: [{
                type: Output
            }], entidadeService: [{
                type: Input
            }], expansive: [{
                type: Input
            }], collapsed: [{
                type: Input
            }], title: [{
                type: Input
            }], idSelector: [{
                type: Input
            }] } });

class EntidadeSelectorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntidadeSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EntidadeSelectorModule, declarations: [EntidadeSelectorComponent], imports: [CommonModule,
            PanelExpansiveModule,
            EloDatatableModule], exports: [EntidadeSelectorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntidadeSelectorModule, imports: [CommonModule,
            PanelExpansiveModule,
            EloDatatableModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntidadeSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PanelExpansiveModule,
                        EloDatatableModule,
                    ],
                    declarations: [
                        EntidadeSelectorComponent
                    ],
                    exports: [
                        EntidadeSelectorComponent
                    ]
                }]
        }] });

class EnviarEmailComponent {
    constructor(_formBuilder) {
        this._formBuilder = _formBuilder;
        this.onEnviar = new EventEmitter();
        this.createForm();
    }
    ngOnInit() {
        this.setarFocoCampoInvalido();
    }
    addItem() {
        const emails = this.form.get('emails');
        emails.push(this.createEmailItem());
        this.setarFocoCampoInvalido();
    }
    removerItem(indice) {
        const emails = this.form.get('emails');
        emails.removeAt(indice);
        this.setarFocoCampoInvalido();
    }
    getEmails() {
        return this.form.get('emails');
    }
    enviar() {
        const emailsForm = this.getEmails();
        const emails = [];
        emailsForm.controls.forEach(email => {
            emails.push(email.value.email);
        });
        this.onEnviar.emit(emails);
    }
    createForm() {
        this.form = this._formBuilder.group({
            'emails': this._formBuilder.array([this.createEmailItem()])
        });
    }
    createEmailItem() {
        return this._formBuilder.group({
            email: [null, Validators.compose([Validators.required, EloValidators.email()])]
        });
    }
    setarFocoCampoInvalido() {
        const self = this;
        setTimeout(() => {
            let index = 0;
            const emails = self.form.get('emails');
            for (let item of emails.controls) {
                if (item.get('email').invalid) {
                    document.getElementById('email_' + index).focus();
                    return;
                }
                index++;
            }
        }, 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnviarEmailComponent, deps: [{ token: i1$2.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EnviarEmailComponent, selector: "enviar-email", outputs: { onEnviar: "onEnviar" }, ngImport: i0, template: "<elo-panel [hasForm]=\"true\" [title]=\"'Informe os emails'\">\n\n  <form [formGroup]=\"form\">\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n\n          <div formArrayName=\"emails\" *ngFor=\"let item of getEmails().controls; let i = index;\">\n\n            <div [formGroupName]=\"i\" class=\"padding-input\">\n              <div class=\"col-xs-9\">\n                <input id=\"email_{{i}}\" formControlName=\"email\" formControlValidationMsg>\n              </div>\n              <div class=\"col-xs-3\">\n                <button id=\"btnRemover_{{i}}\" class=\"btn negative icon icon-left\" (click)=\"removerItem(i)\"\n                  [disabled]=\"getEmails().controls.length === 1\">\n                  <i class=\"fa fa-trash\"></i> Remover\n                </button>\n              </div>\n            </div>\n\n          </div>\n\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <button id=\"btnAdd\" class=\"btn icon-left module-color full-xs inline\" (click)=\"addItem()\">\n            <i class=\"fa fa-plus\"></i> Adicionar outro\n          </button>\n\n          <button id=\"btnEnviarEmail\" class=\"btn icon-left positive full-xs inline\" [disabled]=\"form.invalid\"\n            (click)=\"enviar()\">\n            <i class=\"fa fa-paper-plane\"></i> Enviar\n          </button>\n        </div>\n      </div>\n    </div>\n\n  </form>\n\n</elo-panel>", styles: [".padding-input{padding-bottom:50px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: PanelComponent, selector: "elo-panel", inputs: ["title", "hasTable", "hasForm", "pbNone"] }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i1$2.FormGroupName, selector: "[formGroupName]", inputs: ["formGroupName"] }, { kind: "directive", type: i1$2.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { kind: "directive", type: FormControlValidationMsgDirective, selector: "[formControlValidationMsg]", inputs: ["formControlAttr"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnviarEmailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'enviar-email', template: "<elo-panel [hasForm]=\"true\" [title]=\"'Informe os emails'\">\n\n  <form [formGroup]=\"form\">\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n\n          <div formArrayName=\"emails\" *ngFor=\"let item of getEmails().controls; let i = index;\">\n\n            <div [formGroupName]=\"i\" class=\"padding-input\">\n              <div class=\"col-xs-9\">\n                <input id=\"email_{{i}}\" formControlName=\"email\" formControlValidationMsg>\n              </div>\n              <div class=\"col-xs-3\">\n                <button id=\"btnRemover_{{i}}\" class=\"btn negative icon icon-left\" (click)=\"removerItem(i)\"\n                  [disabled]=\"getEmails().controls.length === 1\">\n                  <i class=\"fa fa-trash\"></i> Remover\n                </button>\n              </div>\n            </div>\n\n          </div>\n\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <button id=\"btnAdd\" class=\"btn icon-left module-color full-xs inline\" (click)=\"addItem()\">\n            <i class=\"fa fa-plus\"></i> Adicionar outro\n          </button>\n\n          <button id=\"btnEnviarEmail\" class=\"btn icon-left positive full-xs inline\" [disabled]=\"form.invalid\"\n            (click)=\"enviar()\">\n            <i class=\"fa fa-paper-plane\"></i> Enviar\n          </button>\n        </div>\n      </div>\n    </div>\n\n  </form>\n\n</elo-panel>", styles: [".padding-input{padding-bottom:50px}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }], propDecorators: { onEnviar: [{
                type: Output
            }] } });

class EnviarEmailModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnviarEmailModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EnviarEmailModule, declarations: [EnviarEmailComponent], imports: [CommonModule,
            PanelModule,
            FormsModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule,
            DirectivesModule], exports: [EnviarEmailComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnviarEmailModule, imports: [CommonModule,
            PanelModule,
            FormsModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule,
            DirectivesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnviarEmailModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PanelModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormControlValidationMsgModule,
                        DirectivesModule
                    ],
                    declarations: [EnviarEmailComponent],
                    exports: [EnviarEmailComponent]
                }]
        }] });

class FancySlideItemComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FancySlideItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FancySlideItemComponent, selector: "fancy-slide-item", inputs: { isItemModalActive: "isItemModalActive", modalItemOption: "modalItemOption" }, ngImport: i0, template: "<div class=\"fancy-slide-item {{modalItemOption}}\" [class.active]=\"isItemModalActive\">\n    <ng-content></ng-content>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FancySlideItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fancy-slide-item', template: "<div class=\"fancy-slide-item {{modalItemOption}}\" [class.active]=\"isItemModalActive\">\n    <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { isItemModalActive: [{
                type: Input
            }], modalItemOption: [{
                type: Input
            }] } });

class FancySlideComponent {
    constructor() {
        this.isModalActive = false;
        this.toggleModal = new EventEmitter();
        this.prevClick = new EventEmitter();
        this.nextClick = new EventEmitter();
    }
    toggleModalHandle() {
        this.toggleModal.emit();
    }
    prevClickHandle() {
        this.prevClick.emit();
    }
    nextClickHandle() {
        this.nextClick.emit();
    }
    handleKeyboardEvent(event) {
        if (event.code === 'Escape' && this.isModalActive) {
            this.toggleModalHandle();
        }
        if (event.code === 'ArrowLeft' && this.isModalActive) {
            this.prevClickHandle();
        }
        if (event.code === 'ArrowRight' && this.isModalActive) {
            this.nextClickHandle();
        }
    }
    onMousedown(event) {
        const element = event.target;
        if (element.classList.contains('fancy-slide') && element.classList.contains('active')) {
            this.toggleModalHandle();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FancySlideComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FancySlideComponent, selector: "fancy-slide", inputs: { isModalActive: "isModalActive" }, outputs: { toggleModal: "toggleModal", prevClick: "prevClick", nextClick: "nextClick" }, host: { listeners: { "document:keydown": "handleKeyboardEvent($event)", "mousedown": "onMousedown($event)" } }, ngImport: i0, template: "<div class=\"fancy-slide\" [class.active]=\"isModalActive\">\n    <div class=\"fancy-container\">\n        <div class=\"panel\">\n            <div class=\"panel-title\">\n                Title\n                <div class=\"fancy-close\">\n                    <em class=\"fa fa-times\" (click)=\"toggleModalHandle()\"></em>\n                </div>\n            </div>\n            <div class=\"panel-body\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n        <div class=\"fancy-nav\">\n            <div class=\"nav-button prev fa fa-chevron-left\" (click)=\"prevClickHandle()\"></div>\n            <div class=\"nav-button next fa fa-chevron-right\" (click)=\"nextClickHandle()\"></div>\n        </div>\n    </div>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FancySlideComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fancy-slide', template: "<div class=\"fancy-slide\" [class.active]=\"isModalActive\">\n    <div class=\"fancy-container\">\n        <div class=\"panel\">\n            <div class=\"panel-title\">\n                Title\n                <div class=\"fancy-close\">\n                    <em class=\"fa fa-times\" (click)=\"toggleModalHandle()\"></em>\n                </div>\n            </div>\n            <div class=\"panel-body\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n        <div class=\"fancy-nav\">\n            <div class=\"nav-button prev fa fa-chevron-left\" (click)=\"prevClickHandle()\"></div>\n            <div class=\"nav-button next fa fa-chevron-right\" (click)=\"nextClickHandle()\"></div>\n        </div>\n    </div>\n</div>\n" }]
        }], propDecorators: { isModalActive: [{
                type: Input
            }], toggleModal: [{
                type: Output
            }], prevClick: [{
                type: Output
            }], nextClick: [{
                type: Output
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }], onMousedown: [{
                type: HostListener,
                args: ['mousedown', ['$event']]
            }] } });

class FancySlideModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FancySlideModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FancySlideModule, declarations: [FancySlideComponent, FancySlideItemComponent], imports: [CommonModule], exports: [FancySlideComponent, FancySlideItemComponent, CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FancySlideModule, imports: [CommonModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FancySlideModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [FancySlideComponent, FancySlideItemComponent, CommonModule],
                    declarations: [FancySlideComponent, FancySlideItemComponent]
                }]
        }] });

class ConfiguracaoEntidadeObservable {
    constructor() {
        this.entidades = of([]);
        this.exercicios = of([]);
        this.competencias = of([]);
    }
}

class FeatureModuleStateService {
    constructor() {
        this.moduleVisibleSource = new Subject();
        this.moduleVisibleObserver = this.moduleVisibleSource.asObservable();
        this.userVisibleSource = new Subject();
        this.userVisibleObserver = this.userVisibleSource.asObservable();
        this.notificationVisibleSource = new Subject();
        this.notificationVisibleObserver = this.notificationVisibleSource.asObservable();
        this.acessibilidadeVisibleSource = new Subject();
        this.acessibilidadeVisibleObserver = this.acessibilidadeVisibleSource.asObservable();
        this.acessibilidadeContrasteVisebleSource = new Subject();
        this.acessibilidadeContrasteVisebleObserver = this.acessibilidadeContrasteVisebleSource.asObservable();
        this.configuracaoEntidadeVisibleSource = new ReplaySubject();
        this.configuracaoEntidadeVisibleObserver = this.configuracaoEntidadeVisibleSource.asObservable();
        this.contribuinteVisibleSource = new Subject();
        this.contribuinteVisibleObserver = this.contribuinteVisibleSource.asObservable();
        this.notificationReportVisibleSource = new Subject();
        this.notificationReportVisibleObserver = this.notificationReportVisibleSource.asObservable();
        this.sobreSistemaVisibleSource = new Subject();
        this.sobreSistemaVisibleObserver = this.sobreSistemaVisibleSource.asObservable();
        this.notificationsSource = new ReplaySubject();
        this.notificationsObserver = this.notificationsSource.asObservable();
        this.workflowTaskListSource = new ReplaySubject();
        this.workflowTaskListObserver = this.workflowTaskListSource.asObservable();
        this.tourCaller = new EventEmitter();
        this.feature = {
            user: 'user',
            module: 'module',
            notification: 'notification',
            acessibilidade: 'acessibilidade',
            configuracaoEntidade: 'configuracaoEntidade',
            contribuinte: 'contribuinte',
            notificationReportJasper: 'notificationReportJasper',
            taskListWorkflow: 'taskListWorkflow',
            acessibilidadeConstraste: 'contraste',
            sobreSistema: 'sobreSistema',
        };
    }
    alternateStatus(feature) {
        switch (feature) {
            case this.feature.user:
                this.userVisibleSource.next(undefined);
                break;
            case this.feature.module:
                this.moduleVisibleSource.next(undefined);
                break;
            case this.feature.notification:
                this.notificationVisibleSource.next(undefined);
                break;
            case this.feature.notificationReportJasper:
                this.notificationReportVisibleSource.next(undefined);
                break;
            case this.feature.acessibilidade:
                this.acessibilidadeVisibleSource.next(undefined);
                break;
            case this.feature.acessibilidadeConstraste:
                this.acessibilidadeContrasteVisebleSource.next(undefined);
                break;
            case this.feature.taskListWorkflow:
                this.workflowTaskListSource.next(undefined);
                break;
            case this.feature.configuracaoEntidade:
                this.configuracaoEntidadeVisibleSource.next(undefined);
                break;
            case this.feature.contribuinte:
                this.contribuinteVisibleSource.next(undefined);
                break;
            case this.feature.sobreSistema:
                this.sobreSistemaVisibleSource.next(undefined);
                break;
        }
    }
    hideMenu(feature) {
        switch (feature) {
            case this.feature.user:
                this.userVisibleSource.next(false);
                break;
            case this.feature.module:
                this.moduleVisibleSource.next(false);
                break;
            case this.feature.notification:
                this.notificationVisibleSource.next(false);
                break;
            case this.feature.notificationReportJasper:
                this.notificationReportVisibleSource.next(false);
                break;
            case this.feature.acessibilidade:
                this.acessibilidadeVisibleSource.next(false);
                break;
            case this.feature.acessibilidadeConstraste:
                this.acessibilidadeContrasteVisebleSource.next(false);
                break;
            case this.feature.taskListWorkflow:
                this.workflowTaskListSource.next(false);
                break;
            case this.feature.configuracaoEntidade:
                this.configuracaoEntidadeVisibleSource.next(false);
                break;
            case this.feature.contribuinte:
                this.contribuinteVisibleSource.next(false);
                break;
            case this.feature.sobreSistema:
                this.sobreSistemaVisibleSource.next(false);
                break;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureModuleStateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureModuleStateService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureModuleStateService, decorators: [{
            type: Injectable
        }] });

class ConfiguracaoEntidadeKeycloakService {
    constructor() {
        this._update = new EventEmitter();
    }
    update() {
        this._update.emit();
    }
    updateListener(action) {
        this._update.subscribe(action);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfiguracaoEntidadeKeycloakService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfiguracaoEntidadeKeycloakService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfiguracaoEntidadeKeycloakService, decorators: [{
            type: Injectable
        }] });

class MonthNamePipe {
    constructor() {
        this.datePipe = new DatePipe('pt');
    }
    transform(value) {
        if (value < 1 || value > 12) {
            return '';
        }
        return StringUtils.capitalizeEachWord(this.datePipe.transform(new Date(2017, value - 1, 1), 'MMMM'));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MonthNamePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: MonthNamePipe, name: "monthname" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MonthNamePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'monthname'
                }]
        }] });

class ConfiguracaoEntidadeKeycloakComponent {
    constructor(_notification, _featureModuleStateService, _abstractAuthHttp, _configuracaoEntidadeKeycloakService) {
        this._notification = _notification;
        this._featureModuleStateService = _featureModuleStateService;
        this._abstractAuthHttp = _abstractAuthHttp;
        this._configuracaoEntidadeKeycloakService = _configuracaoEntidadeKeycloakService;
        this.onGetExercicios = new EventEmitter();
        this.onGetCompetencias = new EventEmitter();
        this.onSetHeaderTitle = new EventEmitter();
        this.configuracaoEntidade = new ConfiguracaoEntidadeObservable();
        this.activeDataOperacaoField = false;
        this.toggled = false;
        this._configuraExercicioAtual = () => {
            this.configuracaoEntidade.exercicios.subscribe((exercicios) => {
                const exercicioAtual = DateUtils.getYearByDate(DateUtils.getDateFromString(DateUtils.format(DateUtils.now(), TO_FORMAT, FROM_FORMAT)));
                this.exercicio = exercicios
                    .filter((exercicio) => exercicio.exercicio === exercicioAtual)
                    .reduce((atual, seguinte) => {
                    if (atual && atual.exercicio === seguinte.exercicio) {
                        return atual;
                    }
                    return seguinte;
                }, null);
                if (this.exercicio && this.exercicio.exercicio) {
                    this.onGetCompetencias.emit({
                        exercicio: this.exercicio,
                        entidade: this.entidade,
                    });
                }
            });
        };
    }
    ngOnInit() {
        this._configuracaoEntidadeKeycloakService.updateListener(() => {
            this.updateConfiguracaoEntidade();
        });
        this.updateConfiguracaoEntidade();
        this._handleCompetenciaStateObserver();
    }
    changeEntidade() {
        this.configuracaoEntidade.competencias = of([]);
        this.configuracaoEntidade.exercicios = of([]);
        this.onGetExercicios.emit(this.entidade);
        this.exercicio = null;
        this.competencia = null;
        this._configuraExercicioAtual();
    }
    voltarAjustes() {
        this._featureModuleStateService.alternateStatus('configuracaoEntidade');
        this._featureModuleStateService.alternateStatus('user');
    }
    changeExercicio() {
        this.configuracaoEntidade.competencias = of([]);
        this.onGetCompetencias.emit({
            exercicio: this.exercicio,
            entidade: this.entidade,
        });
        this.competencia = null;
    }
    comparing() {
        return FormUtils.equals('id');
    }
    comparingByExercicio() {
        return FormUtils.equals('exercicio');
    }
    comparingByMes() {
        return FormUtils.equals('mes');
    }
    resetToCurrentDateOperacaoField() {
        this.dataOperacao = this._getCurrentDate();
        this.confirm();
    }
    confirm() {
        const { entidade, exercicio, competencia, dataOperacao } = this;
        this.dataOperacaoIsCurrentDate =
            dataOperacao === null || dataOperacao === this._getCurrentDate();
        if (entidade && exercicio && competencia) {
            const usuarioInfo = {
                entidadePadrao: entidade,
                exercicioPadrao: exercicio.exercicio,
                mesPadrao: competencia.mes,
                situacaoPadrao: competencia.situacaoDescricao,
                dataOperacao: this.dataOperacaoIsCurrentDate ? null : dataOperacao,
            };
            this._abstractAuthHttp.setUsuarioInfo(usuarioInfo);
            this.close();
            this._notification.success('Definições de entidade', 'Definido com sucesso!');
            window.location.reload();
        }
        else {
            this._notification.error('Definições de entidade', 'Preencha todos os campos para definir!');
        }
    }
    close() {
        this._featureModuleStateService.hideMenu('configuracaoEntidade');
        this.updateBodyOverlay();
    }
    updateConfiguracaoEntidade() {
        if (this._abstractAuthHttp.getUsuarioInfo()) {
            const { entidadePadrao, exercicioPadrao, mesPadrao, situacaoPadrao, dataOperacao, } = this._abstractAuthHttp.getUsuarioInfo();
            if (dataOperacao) {
                this.dataOperacao = dataOperacao;
                this.dataOperacaoIsCurrentDate = false;
            }
            else if (this.activeDataOperacaoField) {
                this.dataOperacao = this._getCurrentDate();
                this.dataOperacaoIsCurrentDate = true;
            }
            if (entidadePadrao) {
                this.entidade = entidadePadrao;
            }
            if (entidadePadrao && exercicioPadrao && mesPadrao) {
                this.exercicio = { exercicio: exercicioPadrao };
                this.competencia = {
                    mes: mesPadrao,
                    situacaoDescricao: situacaoPadrao,
                };
                this.onGetExercicios.emit(this.entidade);
                this.onGetCompetencias.emit({
                    exercicio: this.exercicio,
                    entidade: this.entidade,
                });
            }
        }
    }
    updateBodyOverlay() {
        const body = document.getElementsByTagName('body')[0];
        body.removeAttribute('class');
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents &&
                parents.length > 0 &&
                parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map((parent) => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('features-configuracao-entidade')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.toggled)
                this._featureModuleStateService.hideMenu('configuracaoEntidade');
        }
    }
    _handleCompetenciaStateObserver() {
        this._featureModuleStateService.configuracaoEntidadeVisibleObserver.subscribe((value) => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
    _getCurrentDate() {
        return DateUtils.format(new Date(), TO_FORMAT, FROM_FORMAT);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfiguracaoEntidadeKeycloakComponent, deps: [{ token: EloNotificationService }, { token: FeatureModuleStateService }, { token: AbstractAuthHttp }, { token: ConfiguracaoEntidadeKeycloakService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ConfiguracaoEntidadeKeycloakComponent, selector: "configuracao-entidade-keycloak", inputs: { configuracaoEntidade: "configuracaoEntidade", activeDataOperacaoField: "activeDataOperacaoField" }, outputs: { onGetExercicios: "onGetExercicios", onGetCompetencias: "onGetCompetencias", onSetHeaderTitle: "onSetHeaderTitle" }, host: { listeners: { "document:click": "clickedOutside($event)" } }, viewQueries: [{ propertyName: "datePickerComponent", first: true, predicate: DatePickerComponent, descendants: true }], ngImport: i0, template: "<aside class=\"features-configuracao-entidade overflow-visible\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <div class=\"read hint clean center-left neutral\" (click)=\"voltarAjustes()\"><i\n        class=\"fa fa-chevron-left\"></i>\n      <div class=\"hint-content\">Voltar</div>\n    </div>Defini\u00E7\u00F5es de entidade\n  </h2>\n  <div class=\"user-actions inputs\">\n    <p *ngIf=\"activeDataOperacaoField && !dataOperacaoIsCurrentDate\" class=\"top-helper-message bg-yellow-20\">\n      Data opera\u00E7\u00E3o diferente do dia atual.\n    </p>\n    <a class=\"top-helper-message bg-blue-20\" *ngIf=\"activeDataOperacaoField && !dataOperacaoIsCurrentDate\"\n      href=\"javascript:void(0)\" (click)=\"resetToCurrentDateOperacaoField()\">\n      Clique para voltar a data atual.\n    </a>\n    <div class=\"form-group\">\n      <label for=\"entidade\" class=\"label\">Entidade</label>\n      <select id=\"entidades\" placeholder=\"Selecione a Entidade\" (change)=\"changeEntidade()\" [(ngModel)]=\"entidade\"\n        [compareWith]=\"comparing()\" [required]=\"!entidade\">\n        <option id=\"entidade\" [ngValue]=\"entidade\" *ngFor=\"let entidade of configuracaoEntidade.entidades | async\">\n          {{entidade.nome}}</option>\n      </select>\n    </div>\n\n    <div [class.placeholder-loader]=\"!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)\">\n      <div class=\"form-group\">\n        <label for=\"exercicio\" class=\"label\">Exerc\u00EDcios</label>\n        <select id=\"exercicio\" placeholder=\"Selecione o Exerc\u00EDcio\" (change)=\"changeExercicio()\" [(ngModel)]=\"exercicio\"\n          [compareWith]=\"comparingByExercicio()\" [required]=\"!exercicio\" \n          [disabled]=\"!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)\">\n          <option [ngValue]=\"exercicio\" *ngFor=\"let exercicio of configuracaoEntidade.exercicios | async\">\n            {{exercicio.exercicio}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div [class.placeholder-loader]=\"(!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)) \n                                    || (!(configuracaoEntidade.competencias | async)?.length && !((configuracaoEntidade.competencias | async)?.length === 0))\">\n      <div class=\"form-group\">\n        <label for=\"competencia\" class=\"label\">Compet\u00EAncias</label>\n        <select id=\"competencias\" placeholder=\"Selecione a Compet\u00EAncia\" [(ngModel)]=\"competencia\"\n          [compareWith]=\"comparingByMes()\" [required]=\"!competencia\"\n          [disabled]=\"(!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)) \n          || (!(configuracaoEntidade.competencias | async)?.length && !((configuracaoEntidade.competencias | async)?.length === 0))\">\n          <option id=\"competencia\" [ngValue]=\"competencia\"\n              *ngFor=\"let competencia of configuracaoEntidade.competencias | async\"\n            [disabled]=\"competencia.situacaoDescricao === 'Bloqueado'\">{{competencia.mes | monthname}} -\n            {{competencia.situacaoDescricao}}</option>\n        </select>\n      </div>\n    </div>\n\n    <ng-container *ngIf=\"activeDataOperacaoField\">\n      <div class=\"form-group\">\n        <label for=\"dataOperacao\" class=\"label\"> Data Opera\u00E7\u00E3o</label>\n        <elo-datepicker id=\"dataOperacao\" [(ngModel)]=\"dataOperacao\" formControlValidationMsg\n          [required]=\"!dataOperacao\"></elo-datepicker>\n      </div>\n    </ng-container>\n\n    <div class=\"form-group right\">\n      <button id=\"btnConfirm\" type=\"button\" (click)=\"confirm()\" class=\"btn inline module-color full-xs mr-none\">\n        Definir\n      </button>\n    </div>\n  </div>\n</aside>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: DatePickerComponent, selector: "elo-datepicker", inputs: ["viewFormat", "modelFormat", "id", "disable"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: MonthNamePipe, name: "monthname" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfiguracaoEntidadeKeycloakComponent, decorators: [{
            type: Component,
            args: [{ selector: 'configuracao-entidade-keycloak', template: "<aside class=\"features-configuracao-entidade overflow-visible\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <div class=\"read hint clean center-left neutral\" (click)=\"voltarAjustes()\"><i\n        class=\"fa fa-chevron-left\"></i>\n      <div class=\"hint-content\">Voltar</div>\n    </div>Defini\u00E7\u00F5es de entidade\n  </h2>\n  <div class=\"user-actions inputs\">\n    <p *ngIf=\"activeDataOperacaoField && !dataOperacaoIsCurrentDate\" class=\"top-helper-message bg-yellow-20\">\n      Data opera\u00E7\u00E3o diferente do dia atual.\n    </p>\n    <a class=\"top-helper-message bg-blue-20\" *ngIf=\"activeDataOperacaoField && !dataOperacaoIsCurrentDate\"\n      href=\"javascript:void(0)\" (click)=\"resetToCurrentDateOperacaoField()\">\n      Clique para voltar a data atual.\n    </a>\n    <div class=\"form-group\">\n      <label for=\"entidade\" class=\"label\">Entidade</label>\n      <select id=\"entidades\" placeholder=\"Selecione a Entidade\" (change)=\"changeEntidade()\" [(ngModel)]=\"entidade\"\n        [compareWith]=\"comparing()\" [required]=\"!entidade\">\n        <option id=\"entidade\" [ngValue]=\"entidade\" *ngFor=\"let entidade of configuracaoEntidade.entidades | async\">\n          {{entidade.nome}}</option>\n      </select>\n    </div>\n\n    <div [class.placeholder-loader]=\"!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)\">\n      <div class=\"form-group\">\n        <label for=\"exercicio\" class=\"label\">Exerc\u00EDcios</label>\n        <select id=\"exercicio\" placeholder=\"Selecione o Exerc\u00EDcio\" (change)=\"changeExercicio()\" [(ngModel)]=\"exercicio\"\n          [compareWith]=\"comparingByExercicio()\" [required]=\"!exercicio\" \n          [disabled]=\"!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)\">\n          <option [ngValue]=\"exercicio\" *ngFor=\"let exercicio of configuracaoEntidade.exercicios | async\">\n            {{exercicio.exercicio}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div [class.placeholder-loader]=\"(!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)) \n                                    || (!(configuracaoEntidade.competencias | async)?.length && !((configuracaoEntidade.competencias | async)?.length === 0))\">\n      <div class=\"form-group\">\n        <label for=\"competencia\" class=\"label\">Compet\u00EAncias</label>\n        <select id=\"competencias\" placeholder=\"Selecione a Compet\u00EAncia\" [(ngModel)]=\"competencia\"\n          [compareWith]=\"comparingByMes()\" [required]=\"!competencia\"\n          [disabled]=\"(!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)) \n          || (!(configuracaoEntidade.competencias | async)?.length && !((configuracaoEntidade.competencias | async)?.length === 0))\">\n          <option id=\"competencia\" [ngValue]=\"competencia\"\n              *ngFor=\"let competencia of configuracaoEntidade.competencias | async\"\n            [disabled]=\"competencia.situacaoDescricao === 'Bloqueado'\">{{competencia.mes | monthname}} -\n            {{competencia.situacaoDescricao}}</option>\n        </select>\n      </div>\n    </div>\n\n    <ng-container *ngIf=\"activeDataOperacaoField\">\n      <div class=\"form-group\">\n        <label for=\"dataOperacao\" class=\"label\"> Data Opera\u00E7\u00E3o</label>\n        <elo-datepicker id=\"dataOperacao\" [(ngModel)]=\"dataOperacao\" formControlValidationMsg\n          [required]=\"!dataOperacao\"></elo-datepicker>\n      </div>\n    </ng-container>\n\n    <div class=\"form-group right\">\n      <button id=\"btnConfirm\" type=\"button\" (click)=\"confirm()\" class=\"btn inline module-color full-xs mr-none\">\n        Definir\n      </button>\n    </div>\n  </div>\n</aside>" }]
        }], ctorParameters: () => [{ type: EloNotificationService }, { type: FeatureModuleStateService }, { type: AbstractAuthHttp }, { type: ConfiguracaoEntidadeKeycloakService }], propDecorators: { onGetExercicios: [{
                type: Output
            }], onGetCompetencias: [{
                type: Output
            }], onSetHeaderTitle: [{
                type: Output
            }], configuracaoEntidade: [{
                type: Input
            }], activeDataOperacaoField: [{
                type: Input
            }], datePickerComponent: [{
                type: ViewChild,
                args: [DatePickerComponent]
            }], clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class FeatureAcessibilidadeContrasteComponent {
    constructor(featureModuleStateService) {
        this.featureModuleStateService = featureModuleStateService;
        this.toggled = false;
        this.tipoContraste = {
            normal: 'normal',
            invert: 'invert',
            protanopia: 'protanopia',
            deuteranopia: 'deuteranopia',
            tritanopia: 'tritanopia',
        };
    }
    ngOnInit() {
        this.handleStateObserver();
        this.changeContrasteAtivo(this.tipoContraste.normal);
    }
    voltarParaAcessibilidade() {
        this.featureModuleStateService.alternateStatus('contraste');
        this.featureModuleStateService.alternateStatus('acessibilidade');
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents &&
                parents.length > 0 &&
                parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map((parent) => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('accessibility')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.toggled)
                this.featureModuleStateService.hideMenu('contraste');
        }
    }
    changeContrasteAtivo(tipo) {
        this.contrasteAtivo = tipo;
        document.body.parentElement.classList.remove(this.tipoContraste.invert);
        document.body.parentElement.classList.remove(this.tipoContraste.protanopia);
        document.body.parentElement.classList.remove(this.tipoContraste.deuteranopia);
        document.body.parentElement.classList.remove(this.tipoContraste.tritanopia);
        switch (tipo) {
            case this.tipoContraste.invert:
                document.body.parentElement.classList.add(this.tipoContraste.invert);
                break;
            case this.tipoContraste.protanopia:
                document.body.parentElement.classList.add(this.tipoContraste.protanopia);
                break;
            case this.tipoContraste.deuteranopia:
                document.body.parentElement.classList.add(this.tipoContraste.deuteranopia);
                break;
            case this.tipoContraste.tritanopia:
                document.body.parentElement.classList.add(this.tipoContraste.tritanopia);
                break;
        }
    }
    handleStateObserver() {
        this.featureModuleStateService.acessibilidadeContrasteVisebleObserver.subscribe((value) => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureAcessibilidadeContrasteComponent, deps: [{ token: FeatureModuleStateService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureAcessibilidadeContrasteComponent, selector: "feature-acessibilidade-contraste", host: { listeners: { "document:click": "clickedOutside($event)" } }, ngImport: i0, template: "<div class=\"features-user auto-height accessibility\" [class.active]=\"toggled\">\n    <h2 class=\"title\">\n        <div class=\"read hint clean center-left neutral\" (click)=\"voltarParaAcessibilidade()\"><i class=\"fa fa-chevron-left\"></i>\n            <div class=\"hint-content\" >Voltar</div>\n        </div>Contraste\n    </h2>\n    <div class=\"features-group-container\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.normal)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.normal\"></em><span class=\"switch-caption\">Normal</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.invert)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.invert\"></em><span class=\"switch-caption\">Escuro</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.protanopia)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.protanopia\"></em><span class=\"switch-caption\">Protanopia</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.deuteranopia)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.deuteranopia\"></em><span class=\"switch-caption\">Deuteranopia</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.tritanopia)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.tritanopia\"></em><span class=\"switch-caption\">Tritanopia</span>\n                </div> \n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 form-group\">\n                <button class=\"btn text neutral right\" type=\"button\" (click)=\"changeContrasteAtivo('normal')\">restaurar defini\u00E7\u00F5es</button></div>\n        </div>\n    </div>\n</div>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureAcessibilidadeContrasteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'feature-acessibilidade-contraste', template: "<div class=\"features-user auto-height accessibility\" [class.active]=\"toggled\">\n    <h2 class=\"title\">\n        <div class=\"read hint clean center-left neutral\" (click)=\"voltarParaAcessibilidade()\"><i class=\"fa fa-chevron-left\"></i>\n            <div class=\"hint-content\" >Voltar</div>\n        </div>Contraste\n    </h2>\n    <div class=\"features-group-container\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.normal)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.normal\"></em><span class=\"switch-caption\">Normal</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.invert)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.invert\"></em><span class=\"switch-caption\">Escuro</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.protanopia)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.protanopia\"></em><span class=\"switch-caption\">Protanopia</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.deuteranopia)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.deuteranopia\"></em><span class=\"switch-caption\">Deuteranopia</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.tritanopia)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.tritanopia\"></em><span class=\"switch-caption\">Tritanopia</span>\n                </div> \n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 form-group\">\n                <button class=\"btn text neutral right\" type=\"button\" (click)=\"changeContrasteAtivo('normal')\">restaurar defini\u00E7\u00F5es</button></div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: () => [{ type: FeatureModuleStateService }], propDecorators: { clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class FeatureAcessibilidadeComponent {
    constructor(featureModuleStateService, elementRef) {
        this.featureModuleStateService = featureModuleStateService;
        this.elementRef = elementRef;
        this.toggled = false;
        this.zoomLevel = 0;
        this.defaultProps = {
            className: '',
            reduced: false,
            autoHeight: false,
            hasReadOptions: false,
            scaleIncrement: 0.03,
            zoomIncrement: 5,
            minZoomLevel: -3,
            maxZoomLevel: 3,
        };
    }
    ngOnInit() {
        this.handleStateObserver();
    }
    decrementZoom() {
        this.onChangeZoom(-1);
    }
    incrementZoom() {
        this.onChangeZoom(1);
    }
    clearZoom() {
        this.zoomLevel = 0;
        this.setZoom(0);
    }
    acessibilidadeContraste() {
        this.featureModuleStateService.alternateStatus('contraste');
    }
    clickedOutside(event) {
        if (this.toggled && !this.elementRef.nativeElement.contains(event.target)
            && !event.target?.id?.includes('user')
            && document.body.contains(event.target)) {
            this.featureModuleStateService.hideMenu('acessibilidade');
        }
    }
    setZoom(zoomLevel) {
        const newScale = 1 + zoomLevel * this.defaultProps.scaleIncrement;
        const newZoom = 100 + zoomLevel * this.defaultProps.zoomIncrement;
        document.body.style['-moz-transform'] = `scale(${newScale})`;
        document.body.style['-moz-transform-origin'] = 'top center';
        document.body.style['zoom'] = `${newZoom}%`;
    }
    onChangeZoom(increment) {
        const newZoom = this.zoomLevel + increment;
        if (newZoom >= this.defaultProps.minZoomLevel &&
            newZoom <= this.defaultProps.maxZoomLevel) {
            this.zoomLevel = newZoom;
            this.setZoom(newZoom);
        }
    }
    handleStateObserver() {
        this.featureModuleStateService.acessibilidadeVisibleObserver.subscribe((value) => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureAcessibilidadeComponent, deps: [{ token: FeatureModuleStateService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureAcessibilidadeComponent, selector: "feature-acessibilidade", host: { listeners: { "document:click": "clickedOutside($event)" } }, ngImport: i0, template: "<div class=\"features-user auto-height accessibility\" [class.active]=\"toggled\">\n  <h2 class=\"title\">Acessibilidade</h2>\n  <ul class=\"user-actions\">\n    <li class=\"no-link zoom\"><svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"search\"\n        class=\"svg-inline--fa fa-search fa-w-16 icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 512 512\">\n        <path fill=\"currentColor\"\n          d=\"M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z\">\n        </path>\n      </svg>\n      Zoom\n      <div class=\"btn-group right\">\n        <button class=\"btn neutral pt-none pb-none fa fa-plus\" type=\"button\" (click)=\"incrementZoom()\"></button>\n\n        <button class=\"btn neutral pt-none pb-none fa fa-minus\" type=\"button\" (click)=\"decrementZoom()\"></button>\n\n        <button class=\"btn neutral pt-none pb-none fa fa-expand\"  type=\"button\" (click)=\"clearZoom()\"></button>\n      </div>\n    </li>\n    <li (click)=\"acessibilidadeContraste()\"><svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"adjust\"\n        class=\"svg-inline--fa fa-adjust fa-w-16 icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 512 512\">\n        <path fill=\"currentColor\"\n          d=\"M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z\">\n        </path>\n      </svg>Contraste</li>\n  </ul>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureAcessibilidadeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'feature-acessibilidade', template: "<div class=\"features-user auto-height accessibility\" [class.active]=\"toggled\">\n  <h2 class=\"title\">Acessibilidade</h2>\n  <ul class=\"user-actions\">\n    <li class=\"no-link zoom\"><svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"search\"\n        class=\"svg-inline--fa fa-search fa-w-16 icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 512 512\">\n        <path fill=\"currentColor\"\n          d=\"M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z\">\n        </path>\n      </svg>\n      Zoom\n      <div class=\"btn-group right\">\n        <button class=\"btn neutral pt-none pb-none fa fa-plus\" type=\"button\" (click)=\"incrementZoom()\"></button>\n\n        <button class=\"btn neutral pt-none pb-none fa fa-minus\" type=\"button\" (click)=\"decrementZoom()\"></button>\n\n        <button class=\"btn neutral pt-none pb-none fa fa-expand\"  type=\"button\" (click)=\"clearZoom()\"></button>\n      </div>\n    </li>\n    <li (click)=\"acessibilidadeContraste()\"><svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"adjust\"\n        class=\"svg-inline--fa fa-adjust fa-w-16 icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 512 512\">\n        <path fill=\"currentColor\"\n          d=\"M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z\">\n        </path>\n      </svg>Contraste</li>\n  </ul>\n</div>\n" }]
        }], ctorParameters: () => [{ type: FeatureModuleStateService }, { type: i0.ElementRef }], propDecorators: { clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class ConfiguracaoEntidade {
    constructor() {
        this.onChangeSource = new ReplaySubject();
        this.onChangeObservers = this.onChangeSource.asObservable();
        this._entidades = [];
        this._exercicios = [];
        this._competencias = [];
        this._exerciciosCallTimes = 0;
        this._competenciasCallTimes = 0;
        this._entidadesCallTimes = 0;
    }
    set entidades(value) {
        if (value !== this._entidades) {
            this._entidades = value;
            if (this._entidadesCallTimes === 0) {
                this._entidadesCallTimes++;
                this.onChangeSource.next(this);
            }
        }
    }
    get entidades() {
        return this._entidades;
    }
    set exercicios(value) {
        if (value !== this._exercicios) {
            this._exercicios = value;
            if (this._exerciciosCallTimes === 0) {
                this._exerciciosCallTimes++;
                this.onChangeSource.next(this);
            }
        }
    }
    get exercicios() {
        return this._exercicios;
    }
    set competencias(value) {
        if (value !== this._competencias) {
            this._competencias = value;
            if (this._competenciasCallTimes === 0) {
                this._competenciasCallTimes++;
                this.onChangeSource.next(this);
            }
        }
    }
    get competencias() {
        return this._competencias;
    }
}

class FeatureConfiguracaoEntidadeComponent {
    constructor(notification, featureModuleStateService, authParams) {
        this.notification = notification;
        this.featureModuleStateService = featureModuleStateService;
        this.authParams = authParams;
        this.onGetExercicios = new EventEmitter();
        this.onGetCompetencias = new EventEmitter();
        this.onCompetenciaSelecionada = new EventEmitter();
        this.onSetHeaderTitle = new EventEmitter();
        this.configuracaoEntidade = new ConfiguracaoEntidade();
        this.showCompetencia = true;
        this.showExercicio = true;
        this.toggled = false;
    }
    ngOnInit() {
        this.configuracaoEntidade.onChangeObservers.subscribe(value => this.handleConfiguracaoEntidadeChanges(value));
        this.handleCompetenciaStateObserver();
    }
    handleConfiguracaoEntidadeChanges(config) {
        const usuarioInfo = this.authParams.getUsuarioInfo();
        if (!this.entidade) {
            this.entidade = UsuarioInfoUtils.getEntidadePrincipal(this.authParams.getUsuarioInfo());
        }
        if (this.entidade) {
            if (config.exercicios.length === 0) {
                this.onGetExercicios.emit(this.entidade);
            }
            this.setExercicio(config, usuarioInfo);
        }
        if (this.exercicio) {
            if (config.competencias.length === 0) {
                this.onGetCompetencias.emit({ 'exercicio': this.exercicio, 'entidade': this.entidade });
            }
            if (config.competencias && config.competencias.length > 0 && !this.competencia) {
                this.setCompetencia(config);
            }
        }
    }
    filterCompetencias(config, filter) {
        return config.competencias.filter(competencia => competencia.situacao === filter);
    }
    setMaxCompetencia(competencias) {
        competencias.forEach(competencia => {
            if (!this.competencia || competencia.mes > this.competencia.mes) {
                this.competencia = competencia;
            }
        });
        if (this.authParams.getUsuarioInfo().mesPadrao) {
            this.competencia = competencias.filter(c => c.mes === this.authParams.getUsuarioInfo().mesPadrao)[0];
        }
    }
    setCompetencia(config) {
        const competencias = this.filterCompetencias(config, 'A');
        if (competencias.length !== 0) {
            this.setMaxCompetencia(competencias);
        }
        else {
            this.setMaxCompetencia(this.filterCompetencias(config, 'F'));
        }
        if (!this.authParams.getUsuarioInfo().mesPadrao) {
            this.setUsuarioInfo();
        }
    }
    setUsuarioInfo() {
        const usuarioInfo = this.authParams.getUsuarioInfo();
        if (this.showCompetencia && this.competencia) {
            usuarioInfo.entidadePadrao = this.entidade;
            usuarioInfo.exercicioPadrao = this.exercicio.exercicio;
        }
        if (this.showCompetencia && this.competencia) {
            usuarioInfo.mesPadrao = this.competencia.mes;
            usuarioInfo.situacaoPadrao = this.competencia.situacaoDescricao;
        }
        this.authParams.setUsuarioInfo(usuarioInfo, false);
    }
    setExercicio(config, usuarioInfo) {
        if (config.exercicios && config.exercicios.length > 0 && !this.exercicio) {
            this.exercicio = config.exercicios.find(exercicio => exercicio.exercicio === usuarioInfo.exercicioPadrao);
        }
    }
    changeEntidade(event) {
        let selectedEntidade = event.target.selectedIndex;
        this.configuracaoEntidade.competencias = [];
        this.configuracaoEntidade.exercicios = [];
        this.onGetExercicios.emit(this.configuracaoEntidade.entidades[selectedEntidade]);
        this.exercicio = null;
        this.competencia = null;
    }
    changeExercicio(event) {
        let selectedExercicio = event.target.selectedIndex;
        this.configuracaoEntidade.competencias = [];
        let entidade = this.configuracaoEntidade.entidade || this.entidade;
        this.onGetCompetencias.emit({ 'exercicio': this.configuracaoEntidade.exercicios[selectedExercicio], 'entidade': entidade });
        this.competencia = null;
    }
    comparing() {
        return FormUtils.equals('id');
    }
    comparingByExercicio() {
        return FormUtils.equals('exercicio');
    }
    comparingByMes() {
        return FormUtils.equals('mes');
    }
    confirm() {
        const { entidade, exercicio, competencia } = this;
        if (entidade && (exercicio || !this.showExercicio) && (competencia || !this.showCompetencia)) {
            const usuarioInfo = this.authParams.getUsuarioInfo();
            usuarioInfo.entidadePadrao = entidade;
            if (this.showExercicio) {
                usuarioInfo.exercicioPadrao = exercicio.exercicio;
            }
            if (this.showCompetencia) {
                usuarioInfo.mesPadrao = competencia.mes;
                usuarioInfo.situacaoPadrao = competencia.situacaoDescricao;
            }
            this.authParams.setUsuarioInfo(usuarioInfo, false);
            this.close();
            this.notification.success('Definições de entidade', 'Definido com sucesso!');
            window.location.reload();
        }
        else {
            this.notification.error('Definições de entidade', 'Preencha todos os campos para definir!');
        }
    }
    close() {
        this.featureModuleStateService.hideMenu('configuracaoEntidade');
        this.updateBodyOverlay();
    }
    updateBodyOverlay() {
        const body = document.getElementsByTagName('body')[0];
        body.removeAttribute('class');
    }
    handleCompetenciaStateObserver() {
        this.featureModuleStateService.configuracaoEntidadeVisibleObserver.subscribe(value => {
            if (value === undefined) {
                this.updateBodyOverlay();
                this.toggled = !this.toggled;
            }
            else {
                this.toggled = value;
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureConfiguracaoEntidadeComponent, deps: [{ token: EloNotificationService }, { token: FeatureModuleStateService }, { token: AuthParams }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureConfiguracaoEntidadeComponent, selector: "feature-configuracao-entidade", inputs: { configuracaoEntidade: "configuracaoEntidade", showCompetencia: "showCompetencia", showExercicio: "showExercicio" }, outputs: { onGetExercicios: "onGetExercicios", onGetCompetencias: "onGetCompetencias", onCompetenciaSelecionada: "onCompetenciaSelecionada", onSetHeaderTitle: "onSetHeaderTitle" }, ngImport: i0, template: "<aside class=\"features-configuracao-entidade overflow-visible\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <i aria-hidden=\"true\"></i>Defini\u00E7\u00F5es de entidade\n  </h2>\n  <div class=\"user-actions inputs\">\n    <div class=\"form-group\" *ngIf=\"configuracaoEntidade\">\n      <label for=\"entidade\">Entidade</label>\n      <select id=\"entidades\" placeholder=\"Selecione a Entidade\" (change)=\"changeEntidade($event)\" [(ngModel)]=\"entidade\"\n        [compareWith]=\"comparing()\" required>\n        <option id=\"entidade\" [ngValue]=\"entidade\" *ngFor=\"let entidade of configuracaoEntidade.entidades\">\n          {{entidade.nome}}</option>\n      </select>\n    </div>\n    <div class=\"form-group\" *ngIf=\"configuracaoEntidade && showExercicio\">\n      <label for=\"exercicio\">Exerc\u00EDcio</label>\n      <select id=\"exercicio\" placeholder=\"Selecione o Exerc\u00EDcio\" (change)=\"changeExercicio($event)\"\n        [(ngModel)]=\"exercicio\" [compareWith]=\"comparingByExercicio()\" required>\n        <option [ngValue]=\"exercicio\" *ngFor=\"let exercicio of configuracaoEntidade.exercicios\">{{exercicio.exercicio}}\n        </option>\n      </select>\n    </div>\n    <div class=\"form-group\" *ngIf=\"configuracaoEntidade && showCompetencia\">\n      <label for=\"competencia\">Compet\u00EAncia</label>\n      <select id=\"competencias\" placeholder=\"Selecione a Compet\u00EAncia\" [(ngModel)]=\"competencia\"\n        [compareWith]=\"comparingByMes()\" required>\n        <option id=\"competencia\" [ngValue]=\"competencia\" *ngFor=\"let competencia of configuracaoEntidade.competencias\"\n          [disabled]=\"competencia.situacaoDescricao === 'Bloqueado'\">{{competencia.mes | monthname}} -\n          {{competencia.situacaoDescricao}}</option>\n      </select>\n    </div>\n    <div class=\"form-group\" style=\"display:block\">\n      <button id=\"btnConfirm\" type=\"button\" (click)=\"confirm()\" class=\"btn inline positive full-xs\">\n        Definir\n      </button>\n      <button id=\"btnCancel\" type=\"button\" (click)=\"close()\" class=\"btn inline negative full-xs\">\n        Cancelar\n      </button>\n    </div>\n  </div>\n</aside>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "pipe", type: MonthNamePipe, name: "monthname" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureConfiguracaoEntidadeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'feature-configuracao-entidade', template: "<aside class=\"features-configuracao-entidade overflow-visible\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <i aria-hidden=\"true\"></i>Defini\u00E7\u00F5es de entidade\n  </h2>\n  <div class=\"user-actions inputs\">\n    <div class=\"form-group\" *ngIf=\"configuracaoEntidade\">\n      <label for=\"entidade\">Entidade</label>\n      <select id=\"entidades\" placeholder=\"Selecione a Entidade\" (change)=\"changeEntidade($event)\" [(ngModel)]=\"entidade\"\n        [compareWith]=\"comparing()\" required>\n        <option id=\"entidade\" [ngValue]=\"entidade\" *ngFor=\"let entidade of configuracaoEntidade.entidades\">\n          {{entidade.nome}}</option>\n      </select>\n    </div>\n    <div class=\"form-group\" *ngIf=\"configuracaoEntidade && showExercicio\">\n      <label for=\"exercicio\">Exerc\u00EDcio</label>\n      <select id=\"exercicio\" placeholder=\"Selecione o Exerc\u00EDcio\" (change)=\"changeExercicio($event)\"\n        [(ngModel)]=\"exercicio\" [compareWith]=\"comparingByExercicio()\" required>\n        <option [ngValue]=\"exercicio\" *ngFor=\"let exercicio of configuracaoEntidade.exercicios\">{{exercicio.exercicio}}\n        </option>\n      </select>\n    </div>\n    <div class=\"form-group\" *ngIf=\"configuracaoEntidade && showCompetencia\">\n      <label for=\"competencia\">Compet\u00EAncia</label>\n      <select id=\"competencias\" placeholder=\"Selecione a Compet\u00EAncia\" [(ngModel)]=\"competencia\"\n        [compareWith]=\"comparingByMes()\" required>\n        <option id=\"competencia\" [ngValue]=\"competencia\" *ngFor=\"let competencia of configuracaoEntidade.competencias\"\n          [disabled]=\"competencia.situacaoDescricao === 'Bloqueado'\">{{competencia.mes | monthname}} -\n          {{competencia.situacaoDescricao}}</option>\n      </select>\n    </div>\n    <div class=\"form-group\" style=\"display:block\">\n      <button id=\"btnConfirm\" type=\"button\" (click)=\"confirm()\" class=\"btn inline positive full-xs\">\n        Definir\n      </button>\n      <button id=\"btnCancel\" type=\"button\" (click)=\"close()\" class=\"btn inline negative full-xs\">\n        Cancelar\n      </button>\n    </div>\n  </div>\n</aside>" }]
        }], ctorParameters: () => [{ type: EloNotificationService }, { type: FeatureModuleStateService }, { type: AuthParams }], propDecorators: { onGetExercicios: [{
                type: Output
            }], onGetCompetencias: [{
                type: Output
            }], onCompetenciaSelecionada: [{
                type: Output
            }], onSetHeaderTitle: [{
                type: Output
            }], configuracaoEntidade: [{
                type: Input
            }], showCompetencia: [{
                type: Input
            }], showExercicio: [{
                type: Input
            }] } });

class FeatureContribuinteComponent {
    constructor(_renderer, _featureModuleStateService, _router) {
        this._renderer = _renderer;
        this._featureModuleStateService = _featureModuleStateService;
        this._router = _router;
        this.toggled = false;
        this.feature = {
            contribuinte: 'contribuinte'
        };
    }
    ngOnInit() {
        this.handleGlobalClick();
        this.handleContribuinteStateObserver();
    }
    alterarContribuinte() {
        if (this._router.url.startsWith('/acessar-contribuinte')) {
            return;
        }
        this._router.navigate(['/acessar-contribuinte'], {
            queryParams: {
                redirect: window.location.href
            }
        });
    }
    ngOnDestroy() {
        this.globalClick();
    }
    static notContribuinteButton(event) {
        if (event.target.className.indexOf) {
            return event.target.className.indexOf('contribuinte') < 0;
        }
    }
    handleGlobalClick() {
        this.globalClick = this._renderer.listen('body', 'click', (event) => {
            if (this.toggled) {
                this.hideContribuinteMenu(event);
            }
        });
    }
    handleContribuinteStateObserver() {
        this._featureModuleStateService.contribuinteVisibleObserver.subscribe(value => {
            if (value === undefined) {
                this.toggled = !this.toggled;
            }
            else {
                this.toggled = value;
            }
        });
    }
    hideContribuinteMenu(event) {
        if (FeatureContribuinteComponent.notContribuinteButton(event)) {
            this._featureModuleStateService.hideMenu(this.feature.contribuinte);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureContribuinteComponent, deps: [{ token: i0.Renderer2 }, { token: FeatureModuleStateService }, { token: i1$4.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureContribuinteComponent, selector: "feature-contribuinte", inputs: { contribuinte: "contribuinte" }, ngImport: i0, template: "<aside *ngIf=\"contribuinte\" class=\"features-contribuinte\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <i aria-hidden=\"true\"></i>Contribuinte\n  </h2>\n\n  <div class=\"container contribuinte-actions\">\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">{{contribuinte.cnpjCpf?.length > 14 ? 'Raz\u00E3o Social' : 'Nome'}}</label>\n          <span>{{contribuinte.razaoSocialNome}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">{{contribuinte.cnpjCpf?.length > 14 ? 'CNPJ' : 'CPF'}}</label>\n          <span>{{contribuinte.cnpjCpf}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">Inscri\u00E7\u00E3o Municipal</label>\n          <span>{{contribuinte.cadastro}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">Cidade</label>\n          <span>{{contribuinte.cidade}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">Regime Fiscal</label>\n          <span>{{contribuinte.regimeFiscal}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <button id=\"btnAlterarContribuinte\" class=\"btn module-color icon-left inline full-xs\" (click)=\"alterarContribuinte()\">\n            <i class=\"fa fa-pencil\"></i>\n            Alterar\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n</aside>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureContribuinteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'feature-contribuinte', template: "<aside *ngIf=\"contribuinte\" class=\"features-contribuinte\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <i aria-hidden=\"true\"></i>Contribuinte\n  </h2>\n\n  <div class=\"container contribuinte-actions\">\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">{{contribuinte.cnpjCpf?.length > 14 ? 'Raz\u00E3o Social' : 'Nome'}}</label>\n          <span>{{contribuinte.razaoSocialNome}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">{{contribuinte.cnpjCpf?.length > 14 ? 'CNPJ' : 'CPF'}}</label>\n          <span>{{contribuinte.cnpjCpf}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">Inscri\u00E7\u00E3o Municipal</label>\n          <span>{{contribuinte.cadastro}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">Cidade</label>\n          <span>{{contribuinte.cidade}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">Regime Fiscal</label>\n          <span>{{contribuinte.regimeFiscal}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <button id=\"btnAlterarContribuinte\" class=\"btn module-color icon-left inline full-xs\" (click)=\"alterarContribuinte()\">\n            <i class=\"fa fa-pencil\"></i>\n            Alterar\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n</aside>\n" }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: FeatureModuleStateService }, { type: i1$4.Router }], propDecorators: { contribuinte: [{
                type: Input
            }] } });

function getImageByArea(area) {
    switch (area) {
        case 'ADMINISTRATIVO':
            return 'img/modules/oxy-administrativo.svg';
        case 'ARRECADACAO':
            return 'img/modules/oxy-arrecadacao.svg';
        case 'CONTABIL':
            return 'img/modules/oxy-contabil.svg';
        case 'EDUCACIONAL':
            return 'img/modules/oxy-educacional.svg';
        case 'RECURSOS_HUMANOS':
            return 'img/modules/oxy-rh.svg';
        case 'SOCIAL':
            return 'img/modules/oxy-social.svg';
        default:
            return 'img/modules/oxy-logo.svg';
    }
}

class ElectronModule {
    constructor() {
        this.module = null;
        this.childProcess = null;
        this.desktop = '<%= DESKTOP %>';
    }
    getModule() {
        if (!this.module) {
            // this.module = require('@node/electron');
        }
        return this.module;
    }
    getChildProcess() {
        if (!this.childProcess) {
            //  this.child_process = require('@node/child_process');
        }
        return this.childProcess;
    }
    isElectron() {
        return this.desktop === 'electron';
    }
}

const AREAS = {
    'data': [
        {
            'titulo': 'Geral',
            'cssAdicionalTitulo': 'cadastrounico',
            'iconeTitulo': 'cadastrounico.png',
            'iconeTituloSmall': 'cadastrounico-small.png',
            'iconeTituloBig': 'cadastrounico-big.png',
            'modulos': [
                {
                    'id': 90,
                    'descricao': 'Cadastro único',
                    'icone': 'cadastrounico.png',
                    'iconeSmall': 'cadastrounico-small.png',
                    'iconBig': 'cadastrounico-big.png',
                    'url': ''
                },
            ]
        },
        {
            'titulo': 'Arrecadação',
            'cssAdicionalTitulo': 'arrecadacao',
            'iconeTitulo': 'oxy-arrecadacao.svg',
            'iconeTituloSmall': 'oxy-arrecadacao.svg',
            'modulos': [
                {
                    'id': 26,
                    'descricao': 'Mais ISS',
                    'icone': 'arrecadacao-nfe.png',
                    'iconeSmall': 'arrecadacao-nfe-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 41,
                    'descricao': 'Receitas Não Tributárias',
                    'icone': 'arrecadacao-receitasnaotributarias.png',
                    'iconeSmall': 'arrecadacao-receitasnaotributarias-small.png',
                    'iconBig': 'arrecadacao-receitasnaotributarias-big.png',
                    'url': ''
                },
                {
                    'id': 38,
                    'descricao': 'Cemitério',
                    'icone': 'arrecadacao-cemiterio.png',
                    'iconeSmall': 'arrecadacao-cemiterio-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 39,
                    'descricao': 'Processo Judicial ',
                    'icone': 'arrecadacao-processosjudiciais.png',
                    'iconeSmall': 'arrecadacao-processosjudiciais-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 40,
                    'descricao': 'Alvará On-line',
                    'icone': 'arrecadacao-alvaraonline.png',
                    'iconeSmall': 'arrecadacao-alvaraonline-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 43,
                    'descricao': 'Fiscalização',
                    'icone': 'arrecadacao-fiscalizacao.png',
                    'iconeSmall': 'arrecadacao-fiscalizacao-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 27,
                    'descricao': 'Gerador de Relatórios',
                    'icone': 'arrecadacao.png',
                    'iconeSmall': 'arrecadacao-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        },
        {
            'titulo': 'Contabilidade',
            'cssAdicionalTitulo': 'contabil',
            'iconeTitulo': 'oxy-contabil.svg',
            'iconeTituloSmall': 'oxy-contabil.svg',
            'modulos': [
                {
                    'id': 2,
                    'descricao': 'Planejamento Orçamentário',
                    'icone': 'contabil-planejamentoorcamentario.png',
                    'iconeSmall': 'contabil-planejamentoorcamentario-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 12,
                    'descricao': 'Controle Interno',
                    'icone': 'contabil-controleinterno.png',
                    'iconeSmall': 'contabil-controleinterno-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 20,
                    'descricao': 'LRF',
                    'icone': 'contabil-lrf.png',
                    'iconeSmall': 'contabil-lrf-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 15,
                    'descricao': 'Tesouraria e Gestão Financeira',
                    'icone': 'contabil-tgf.png',
                    'iconeSmall': 'contabil-tgf-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 3,
                    'descricao': 'Contabil',
                    'icone': 'contabil-contabilidadepublica.png',
                    'iconeSmall': 'contabil-contabilidadepublica-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 34,
                    'descricao': 'Portal Transparencia',
                    'icone': 'contabil-portaltransparencia.png',
                    'iconeSmall': 'contabil-portaltransparencia-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 5,
                    'descricao': 'Portal Contribuinte',
                    'icone': 'contabil-portalcontribuinte.png',
                    'iconeSmall': 'contabil-portalcontribuinte-small.png',
                    'iconBig': 'contabil-portalcontribuinte-big.png',
                    'url': ''
                },
            ]
        },
        {
            'titulo': 'Administração',
            'cssAdicionalTitulo': 'administracao',
            'iconeTitulo': 'oxy-administrativo.svg',
            'iconeTituloSmall': 'oxy-administrativo.svg',
            'modulos': [
                {
                    'id': 19,
                    'descricao': 'Almoxarifado e Logística',
                    'icone': 'administracao-almoxarifadologistica.png',
                    'iconeSmall': 'administracao-almoxarifadologistica-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 7,
                    'descricao': 'Patrimônio',
                    'icone': 'administracao-controlepatrimonial.png',
                    'iconeSmall': 'administracao-controlepatrimonial-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 25,
                    'descricao': 'Obras',
                    'icone': 'administracao-controleobras.png',
                    'iconeSmall': 'administracao-controleobras-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 8,
                    'descricao': 'Frotas e Veículos',
                    'icone': 'administracao-frotasveiculos.png',
                    'iconeSmall': 'administracao-frotasveiculos-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 17,
                    'descricao': 'Ouvidoria',
                    'icone': 'administracao-ouvidoria.png',
                    'iconeSmall': 'administracao-ouvidoria-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 18,
                    'descricao': 'Legislação',
                    'icone': 'administracao-legislacao.png',
                    'iconeSmall': 'administracao-legislacao-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 10,
                    'descricao': 'Compras e Licitação',
                    'icone': 'administracao-compraslicitacoes.png',
                    'iconeSmall': 'administracao-compraslicitacoes-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 4,
                    'descricao': 'Controle de Processos',
                    'icone': 'administracao-controleprocessos.png',
                    'iconeSmall': 'administracao-controleprocessos-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        },
        {
            'titulo': 'Recursos Humanos',
            'cssAdicionalTitulo': 'recursoshumanos',
            'iconeTitulo': 'oxy-rh.svg',
            'iconeTituloSmall': 'oxy-rh.svg',
            'modulos': [
                {
                    'id': 67,
                    'descricao': 'Folha de Pagamento',
                    'icone': 'recursoshumanos-folhapagamento.png',
                    'iconeSmall': 'recursoshumanos-folhapagamento-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 30,
                    'descricao': 'eSocial',
                    'icone': 'recursoshumanos-esocial.png',
                    'iconeSmall': 'recursoshumanos-esocial-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 42,
                    'descricao': 'Portal RH (Portal do Servidor)',
                    'icone': 'recursoshumanos-portalservidor.png',
                    'iconeSmall': 'recursoshumanos-portalservidor-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        },
        {
            'titulo': 'Saúde',
            'cssAdicionalTitulo': 'saude',
            'iconeTitulo': 'oxy-social.svg',
            'iconeTituloSmall': 'oxy-social.svg',
            'modulos': [
                {
                    'id': 6,
                    'descricao': 'Saúde',
                    'icone': 'saude.png',
                    'iconeSmall': 'saude-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        },
        {
            'titulo': 'Educacional',
            'cssAdicionalTitulo': 'educacional',
            'iconeTitulo': 'oxy-educacional.svg',
            'iconeTituloSmall': 'oxy-educacional.svg',
            'modulos': [
                {
                    'id': 21,
                    'descricao': 'Educação',
                    'icone': 'educacional.png',
                    'iconeSmall': 'educacional-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 16,
                    'descricao': 'Biblioteca',
                    'icone': 'educacional-biblioteca.png',
                    'iconeSmall': 'educacional-biblioteca-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        }
    ]
};

class ListaModulosService {
    constructor(authHttp, authResourcesConfig) {
        this.authHttp = authHttp;
        this.authResourcesConfig = authResourcesConfig;
        this.electron = new ElectronModule();
    }
    getModulosUsuario() {
        return forkJoin([
            of(AREAS),
            this.authHttp.getUsuarioLogado()
        ]).pipe(map((data) => {
            let areas = data[0].data;
            let usuario = data[1];
            for (let area of areas) {
                for (let moduloDaArea of area.modulos) {
                    moduloDaArea.podeAcessar = this.usuarioPodeAcessarModulo(usuario, moduloDaArea);
                }
            }
            return areas;
        }));
    }
    moduloClick(modulo) {
        let url = this.isDev() ? `${this.authResourcesConfig.hostDev}/${modulo.url}/` : `/${modulo.url}/`;
        window.open(url);
        return false;
    }
    isDev() {
        return this.authResourcesConfig.isDev;
    }
    usuarioPodeAcessarModulo(usuario, moduloDaArea) {
        if (usuario.modulos) {
            for (let modulosDoUsuario of usuario.modulos) {
                if (moduloDaArea.id === modulosDoUsuario.modulo.id) {
                    moduloDaArea.url = modulosDoUsuario.modulo.url;
                    moduloDaArea.path = modulosDoUsuario.modulo.path;
                    return true;
                }
            }
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ListaModulosService, deps: [{ token: AbstractAuthHttp }, { token: AUTH_RESOURCES_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ListaModulosService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ListaModulosService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AbstractAuthHttp }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }] });

class FeatureModulesComponent {
    constructor(authParams, listaModulosService, featureModuleStateService, elementRef, keyCloakService) {
        this.authParams = authParams;
        this.listaModulosService = listaModulosService;
        this.featureModuleStateService = featureModuleStateService;
        this.elementRef = elementRef;
        this.keyCloakService = keyCloakService;
        this.moduleOrFavorite = false;
        this.modulos = [];
        this.areas = [];
        this.toggled = false;
        this.buildModuloUrl = (moduloUri) => {
            return `${window.location.origin}/${moduloUri}`;
        };
    }
    ngOnInit() {
        this.handleStateObserver();
        if (this.keyCloakService) {
            this.keyCloakService.getModulos().subscribe((response) => {
                if (response.length > 0) {
                    this.modulos = response;
                    for (const modulo of response) {
                        const nova = {
                            area: modulo.area,
                            descricaoArea: modulo.descricaoArea,
                            open: true
                        };
                        if (modulo.area === 'COMUM') {
                            this.comum = nova;
                        }
                        else if (!this.areas.find((area) => area.area === nova.area)) {
                            this.areas.push(nova);
                        }
                    }
                    if (this.comum) {
                        this.areas.push(this.comum);
                    }
                }
            }, (erro) => {
                console.warn('Erro ao recuperar modulos: ', erro);
            });
        }
        else {
            this.authParams.onLoginObservers.subscribe(login => {
                if (login) {
                    this.listaModulosService.getModulosUsuario().subscribe(area => this.listModules(area));
                }
                else {
                    this.modulos = [];
                }
            });
        }
    }
    clickedOutside($event) {
        if (this.contentRef && this.contentRef.nativeElement.contains(($event.target))) {
            return;
        }
        if (this.toggled) {
            this.featureModuleStateService.hideMenu('module');
        }
    }
    hideModules(areaSelecionada) {
        areaSelecionada.open = !areaSelecionada.open;
    }
    ShowModulesOrFavorites() {
        this.moduleOrFavorite = !this.moduleOrFavorite;
    }
    showListModules(area) {
        return this.modulos.filter(modulo => modulo.area === area);
    }
    getImage(area) {
        return getImageByArea(area);
    }
    handleStateObserver() {
        this.featureModuleStateService.moduleVisibleObserver.subscribe(value => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
    listModules(areas) {
        this.modulos = [];
        areas.forEach(area => {
            area.modulos.forEach(modulo => {
                if ((modulo.podeAcessar) && (modulo.url)) {
                    this.modulos.push(modulo);
                }
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureModulesComponent, deps: [{ token: AuthParams }, { token: ListaModulosService }, { token: FeatureModuleStateService }, { token: i0.ElementRef }, { token: KeycloakAuthHttp, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureModulesComponent, selector: "feature-modules", host: { listeners: { "document:click": "clickedOutside($event)" } }, viewQueries: [{ propertyName: "contentRef", first: true, predicate: ["contentRef"], descendants: true, static: true }], ngImport: i0, template: "<div #contentRef>\n  <div class=\"features-modules\" [class.active]=\"toggled\">\n    <h2 class=\"title\">M\u00F3dulos</h2>\n    <ul class=\"tab\">\n      <li class=\"active\">\n        <div id=\"divModules\" class=\"features-body\">\n          <ul class=\"module-list no-logo expansible\" [class.open]=\"area.open\" (click)=\"hideModules(area)\" *ngFor=\"let area of areas\">\n            <li class=\"features-section\"><a>\n                <img src=\"{{getImage(area?.area)}}\" aria-hidden class=\"module-color icon\"\n                  style=\"enable-background:new 0 0 566.9 566.9\" />\n                <span>{{area?.descricaoArea}}</span></a></li>\n            <li class='sister' *ngFor=\"let modulo of showListModules(area.area)\">\n              <a target=\"_blank\" rel=\"noopener noreferrer\"\n                [href]=\"buildModuloUrl(modulo?.uri)\"><span>{{modulo?.descricao}}</span></a>\n            </li>\n          </ul>\n        </div>\n      </li>\n    </ul>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureModulesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'feature-modules', template: "<div #contentRef>\n  <div class=\"features-modules\" [class.active]=\"toggled\">\n    <h2 class=\"title\">M\u00F3dulos</h2>\n    <ul class=\"tab\">\n      <li class=\"active\">\n        <div id=\"divModules\" class=\"features-body\">\n          <ul class=\"module-list no-logo expansible\" [class.open]=\"area.open\" (click)=\"hideModules(area)\" *ngFor=\"let area of areas\">\n            <li class=\"features-section\"><a>\n                <img src=\"{{getImage(area?.area)}}\" aria-hidden class=\"module-color icon\"\n                  style=\"enable-background:new 0 0 566.9 566.9\" />\n                <span>{{area?.descricaoArea}}</span></a></li>\n            <li class='sister' *ngFor=\"let modulo of showListModules(area.area)\">\n              <a target=\"_blank\" rel=\"noopener noreferrer\"\n                [href]=\"buildModuloUrl(modulo?.uri)\"><span>{{modulo?.descricao}}</span></a>\n            </li>\n          </ul>\n        </div>\n      </li>\n    </ul>\n  </div>\n</div>" }]
        }], ctorParameters: () => [{ type: AuthParams }, { type: ListaModulosService }, { type: FeatureModuleStateService }, { type: i0.ElementRef }, { type: KeycloakAuthHttp, decorators: [{
                    type: Optional
                }] }], propDecorators: { contentRef: [{
                type: ViewChild,
                args: ['contentRef', { static: true }]
            }], clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class FeatureNotificationMessageComponent {
    constructor() {
        this.messageDetail = false;
        this.onSelectedNotification = new EventEmitter();
    }
    set notification(notification) {
        this._notification = notification;
        switch (notification.status) {
            case 'STARTED':
                this.statusIcon = 'fa fa-circle-o-notch fa-spin';
                this.statusName = notification.statusRename || 'Iniciado';
                break;
            case 'COMPLETED':
                this.statusIcon = 'fa fa-check';
                this.statusName = notification.statusRename || 'Concluído';
                break;
            case 'FAILED':
                this.statusIcon = 'fa fa-times';
                this.statusName = notification.statusRename || 'Falhou';
                break;
            case 'PENDING':
                this.statusIcon = 'fa fa-circle';
                this.statusName = notification.statusRename || 'Pendente';
                break;
            case 'CANCELLED':
                this.statusIcon = 'fa fa-ban';
                this.statusName = notification.statusRename || 'Cancelado';
                break;
        }
    }
    get notification() {
        return this._notification;
    }
    selectedNotificationClick(notification) {
        this.onSelectedNotification.emit(notification);
    }
    getImage(area) {
        return getImageByArea(area);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureNotificationMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureNotificationMessageComponent, selector: "notification-message", inputs: { notification: "notification", messageDetail: "messageDetail" }, outputs: { onSelectedNotification: "onSelectedNotification" }, ngImport: i0, template: "<li class=\"has-icon\" class=\"notification-msg-container\" [class.new-msg]=\"!notification.readed\"\n  (click)=\"selectedNotificationClick(notification)\">\n  <div class=\"notification-msg-icon\">\n    <i class=\"{{notification.iconClass}} module-color\" aria-hidden=\"true\"></i>\n  </div>\n\n  <div class=\"notification-msg-content\">\n    <p class=\"notification-msg-title\">{{notification.message}}</p>\n    <p class=\"notification-msg-details\">{{notification.messageDetail}}</p>\n    <div class=\"notification-msg-module\">\n      <p class=\"module-color\">\n        <img *ngIf=\"getImage(notification?.modulo?.area); let imgModule\" [src]=\"imgModule\" aria-hidden\n          class=\"module-color icon\" />\n        {{notification.modulo?.descricao}}\n      </p>\n    </div>\n  </div>\n\n  <div class=\"notification-msg-side-info\">\n    <span class=\"notification-msg-status {{notification.status | lowercase}}\">\n      <em [class]=\"statusIcon\" style=\"margin-right: 5px\"></em>\n      {{statusName}}\n    </span>\n    <span class=\"font-notification-msg-time\" title=\"{{notification.createOn | date:'dd/MM/yyyy hh:mm:ss' }}\">\n      {{ notification.createOn | timeago }}\n    </span>\n  </div>\n\n</li>", styles: [".notification-msg-container{display:flex;flex-wrap:nowrap;gap:5px;align-items:flex-start}.notification-msg-container.new-msg{background-color:#eaf3ea}.notification-msg-container.new-msg:hover{background-color:#bad6ba9c!important}.notification-msg-container .notification-msg-icon{align-self:center;min-width:37px}.notification-msg-container .notification-msg-icon i{font-size:20px;margin:0 15px 0 5px}.notification-msg-container .notification-msg-content{flex:1}.notification-msg-container .notification-msg-content .notification-msg-title{font-size:13px;font-weight:600}.notification-msg-container .notification-msg-content .notification-msg-details{font-size:12px;font-weight:400;color:gray}.notification-msg-container .notification-msg-content .notification-msg-module{display:flex}.notification-msg-container .notification-msg-content .notification-msg-module p{font-size:10px;padding:0 10px;margin-top:3px;background:#e0e0e0;border-radius:10px}.notification-msg-container .notification-msg-content .notification-msg-module p img{margin-right:5px;height:15px;width:15px}.notification-msg-container .notification-msg-side-info{display:flex;flex-direction:column;align-items:flex-end}.notification-msg-container .notification-msg-side-info .notification-msg-status{border-radius:3px;padding:0 5px;margin:5px 3px;font-weight:500;width:fit-content}.notification-msg-container .notification-msg-side-info .notification-msg-status.started{border:1px solid #2780ce;color:#2780ce}.notification-msg-container .notification-msg-side-info .notification-msg-status.started em{color:#2780ce}.notification-msg-container .notification-msg-side-info .notification-msg-status.completed{border:1px solid #358d30;color:#358d30}.notification-msg-container .notification-msg-side-info .notification-msg-status.completed em{color:#358d30}.notification-msg-container .notification-msg-side-info .notification-msg-status.pending{border:1px solid #d19d00;color:#d19d00}.notification-msg-container .notification-msg-side-info .notification-msg-status.pending em{color:#d19d00}.notification-msg-container .notification-msg-side-info .notification-msg-status.failed{border:1px solid #df362a;color:#df362a}.notification-msg-container .notification-msg-side-info .notification-msg-status.failed em{color:#df362a}.notification-msg-container .notification-msg-side-info .notification-msg-status.cancelled{border:1px solid #9e9e9e;color:#9e9e9e}.notification-msg-container .notification-msg-side-info .notification-msg-status.cancelled em{color:#9e9e9e}.notification-msg-container .notification-msg-side-info .notification-msg-time{font-weight:400;text-wrap:nowrap}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.LowerCasePipe, name: "lowercase" }, { kind: "pipe", type: i1.DatePipe, name: "date" }, { kind: "pipe", type: TimeAgoPipe, name: "timeago" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureNotificationMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'notification-message', template: "<li class=\"has-icon\" class=\"notification-msg-container\" [class.new-msg]=\"!notification.readed\"\n  (click)=\"selectedNotificationClick(notification)\">\n  <div class=\"notification-msg-icon\">\n    <i class=\"{{notification.iconClass}} module-color\" aria-hidden=\"true\"></i>\n  </div>\n\n  <div class=\"notification-msg-content\">\n    <p class=\"notification-msg-title\">{{notification.message}}</p>\n    <p class=\"notification-msg-details\">{{notification.messageDetail}}</p>\n    <div class=\"notification-msg-module\">\n      <p class=\"module-color\">\n        <img *ngIf=\"getImage(notification?.modulo?.area); let imgModule\" [src]=\"imgModule\" aria-hidden\n          class=\"module-color icon\" />\n        {{notification.modulo?.descricao}}\n      </p>\n    </div>\n  </div>\n\n  <div class=\"notification-msg-side-info\">\n    <span class=\"notification-msg-status {{notification.status | lowercase}}\">\n      <em [class]=\"statusIcon\" style=\"margin-right: 5px\"></em>\n      {{statusName}}\n    </span>\n    <span class=\"font-notification-msg-time\" title=\"{{notification.createOn | date:'dd/MM/yyyy hh:mm:ss' }}\">\n      {{ notification.createOn | timeago }}\n    </span>\n  </div>\n\n</li>", styles: [".notification-msg-container{display:flex;flex-wrap:nowrap;gap:5px;align-items:flex-start}.notification-msg-container.new-msg{background-color:#eaf3ea}.notification-msg-container.new-msg:hover{background-color:#bad6ba9c!important}.notification-msg-container .notification-msg-icon{align-self:center;min-width:37px}.notification-msg-container .notification-msg-icon i{font-size:20px;margin:0 15px 0 5px}.notification-msg-container .notification-msg-content{flex:1}.notification-msg-container .notification-msg-content .notification-msg-title{font-size:13px;font-weight:600}.notification-msg-container .notification-msg-content .notification-msg-details{font-size:12px;font-weight:400;color:gray}.notification-msg-container .notification-msg-content .notification-msg-module{display:flex}.notification-msg-container .notification-msg-content .notification-msg-module p{font-size:10px;padding:0 10px;margin-top:3px;background:#e0e0e0;border-radius:10px}.notification-msg-container .notification-msg-content .notification-msg-module p img{margin-right:5px;height:15px;width:15px}.notification-msg-container .notification-msg-side-info{display:flex;flex-direction:column;align-items:flex-end}.notification-msg-container .notification-msg-side-info .notification-msg-status{border-radius:3px;padding:0 5px;margin:5px 3px;font-weight:500;width:fit-content}.notification-msg-container .notification-msg-side-info .notification-msg-status.started{border:1px solid #2780ce;color:#2780ce}.notification-msg-container .notification-msg-side-info .notification-msg-status.started em{color:#2780ce}.notification-msg-container .notification-msg-side-info .notification-msg-status.completed{border:1px solid #358d30;color:#358d30}.notification-msg-container .notification-msg-side-info .notification-msg-status.completed em{color:#358d30}.notification-msg-container .notification-msg-side-info .notification-msg-status.pending{border:1px solid #d19d00;color:#d19d00}.notification-msg-container .notification-msg-side-info .notification-msg-status.pending em{color:#d19d00}.notification-msg-container .notification-msg-side-info .notification-msg-status.failed{border:1px solid #df362a;color:#df362a}.notification-msg-container .notification-msg-side-info .notification-msg-status.failed em{color:#df362a}.notification-msg-container .notification-msg-side-info .notification-msg-status.cancelled{border:1px solid #9e9e9e;color:#9e9e9e}.notification-msg-container .notification-msg-side-info .notification-msg-status.cancelled em{color:#9e9e9e}.notification-msg-container .notification-msg-side-info .notification-msg-time{font-weight:400;text-wrap:nowrap}\n"] }]
        }], propDecorators: { notification: [{
                type: Input
            }], messageDetail: [{
                type: Input
            }], onSelectedNotification: [{
                type: Output
            }] } });

const PAGE_REQUEST = new PageParameters(8, 0, '&sort=createOn,desc');
const NOTIFICATION_CONFIG = new InjectionToken('notification.config');
class NotificationSystemService {
    constructor(httpClient, notificationConfig) {
        this.httpClient = httpClient;
        this.notificationConfig = notificationConfig;
        this.counterChanged = new BehaviorSubject(0);
        this.resource = '/api/notifications';
        this.location = notificationConfig?.apiLocation ? notificationConfig.apiLocation : '/painel-api';
    }
    findPage(pageRequest = PAGE_REQUEST) {
        return this.httpClient.get({
            resource: `${this.resource}`,
            page: pageRequest,
            disableSpinner: true,
            location: this.location
        }).pipe(map(page => page ? page.content : []));
    }
    markAllReaded() {
        return this.httpClient.put({
            resource: `${this.resource}/mark-all-readed`,
            disableSpinner: true,
            location: this.location
        });
    }
    markReaded(ids) {
        return this.httpClient.put({
            resource: `${this.resource}`,
            body: ids,
            disableSpinner: true,
            location: this.location
        });
    }
    countNotReaded() {
        return this.httpClient.get({
            resource: `${this.resource}/count-not-readed`,
            disableSpinner: true,
            location: this.location
        });
    }
    publishMessage(notification) {
        return this.httpClient.post({
            resource: `${this.resource}`,
            body: notification,
            disableSpinner: true,
            location: this.location
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationSystemService, deps: [{ token: HttpClient }, { token: NOTIFICATION_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationSystemService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationSystemService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [NOTIFICATION_CONFIG]
                }] }] });

class FeatureNotificationComponent {
    get hasMessagesToRead() {
        return this.notifications.filter(n => !n.readed).length > 0;
    }
    constructor(featureModuleStateService, elementRef, router, windowService, notificationSystemService) {
        this.featureModuleStateService = featureModuleStateService;
        this.elementRef = elementRef;
        this.router = router;
        this.windowService = windowService;
        this.notificationSystemService = notificationSystemService;
        this.notifications = [];
        this.toggled = false;
        this.currentPage = 0;
        this.loadingMarkAllReaded = false;
        this.loadingMore = false;
    }
    ngOnInit() {
        this.featureModuleStateService.notificationVisibleObserver.subscribe(value => this.updateToggled(value));
        this.featureModuleStateService.notificationsObserver.subscribe(values => {
            this.notifications = values;
            this.currentPage = 0;
        });
    }
    clickedOutside(event) {
        if (this.toggled && !this.elementRef.nativeElement.contains(event.target)
            && !event.target?.id?.includes('notification')
            && document.body.contains(event.target)) {
            this.featureModuleStateService.hideMenu('notification');
        }
    }
    loadNotifications(page = 0) {
        this.currentPage = page;
        this.loadingMore = true;
        this.notificationSystemService.findPage(new PageParameters(5, this.currentPage, '&sort=createOn,desc')).subscribe(notifications => {
            this.loadingMore = false;
            this.notifications = this.notifications.concat(notifications);
        });
    }
    markAllReaded() {
        this.loadingMarkAllReaded = true;
        this.notificationSystemService.markAllReaded().subscribe(() => {
            this.loadingMarkAllReaded = false;
            this.notifications.forEach(n => n.readed = true);
            this.notificationSystemService.counterChanged.next(0);
        });
    }
    showAll() {
        this.featureModuleStateService.hideMenu('notification');
        this.router.navigate(['/notifications']);
    }
    visualize(notification) {
        if (!notification.readed) {
            notification.readed = true;
            this.notificationSystemService.markReaded([notification.id]).subscribe(() => {
                if (this.notificationSystemService.counterChanged.value > 0) {
                    this.notificationSystemService.counterChanged.next(this.notificationSystemService.counterChanged.value - 1);
                }
            });
        }
        if (notification.link) {
            this.windowService.openTab(notification.link);
        }
    }
    updateToggled(value) {
        if (value === undefined) {
            this.toggled = !this.toggled;
        }
        else {
            this.toggled = value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureNotificationComponent, deps: [{ token: FeatureModuleStateService }, { token: i0.ElementRef }, { token: i1$4.Router }, { token: WindowService }, { token: NotificationSystemService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureNotificationComponent, selector: "feature-notification", host: { listeners: { "document:click": "clickedOutside($event)" } }, ngImport: i0, template: "<ng-container *ngIf=\"toggled\">\n  <div class=\"features-notifications reduced auto-height read-options\" [class.active]=\"toggled\">\n    <h2 class=\"title\">\n\n      <ng-container *ngIf=\"loadingMarkAllReaded\">\n        <div class=\"read hint clean\">\n          <em class=\"fa fa-spinner fa-spin\"></em>\n        </div>\n      </ng-container>\n\n      <div *ngIf=\"!loadingMarkAllReaded\" class=\"read hint clean center-left\" (click)=\"hasMessagesToRead ? markAllReaded() : ''\">\n        <ng-container *ngIf=\"hasMessagesToRead;else noMessagesToRead\">\n          <em class=\"fa fa-envelope\"></em>\n          <div class=\"hint-content\" style=\"top: -3px;\">Marcar todas como lidas</div>\n        </ng-container>\n        <ng-template #noMessagesToRead>\n          <em class=\"fa fa-envelope-open\"></em>\n          <div class=\"hint-content\" style=\"top: -3px;\">N\u00E3o h\u00E1 mensagens n\u00E3o lidas</div>\n        </ng-template>\n      </div>\n\n\n      Notifica\u00E7\u00F5es\n    </h2>\n\n    <div class=\"features-body\" infiniteScroll [infiniteScrollDistance]=\"2\" [infiniteScrollThrottle]=\"500\"\n      [scrollWindow]=\"false\" (scrolled)=\"loadNotifications(currentPage + 1)\">\n      <ul class=\"notification-list\">\n        <ng-container *ngFor=\"let notification of notifications\">\n          <notification-message [notification]=\"notification\" (onSelectedNotification)=\"visualize($event)\">\n          </notification-message>\n        </ng-container>\n\n        <li *ngIf=\"notifications.length === 0\">\n          <article>\n            <p id=\"emptyList\" class=\"nowrap\">N\u00E3o existem novas notifica\u00E7\u00F5es</p>\n          </article>\n        </li>\n\n        <li *ngIf=\"loadingMore && notifications.length >= 4\">\n          <em class=\"fa fa-circle-o-notch fa-spin center\"></em>\n        </li>\n      </ul>\n    </div>\n    <ul class=\"notification-list\">\n      <li class=\"more\"><button (click)=\"showAll()\" id=\"btnAll\">Todas as notifica\u00E7\u00F5es<em\n            class=\"fa fa-angle-double-right\"></em></button></li>\n    </ul>\n  </div>\n</ng-container>", styles: [".features-notifications{border-radius:3px;width:400px!important;max-width:calc(100vw - 20px);right:10px!important}.more button{flex-direction:row;gap:5px;min-height:15px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i6$1.InfiniteScrollDirective, selector: "[infiniteScroll], [infinite-scroll], [data-infinite-scroll]", inputs: ["infiniteScrollDistance", "infiniteScrollUpDistance", "infiniteScrollThrottle", "infiniteScrollDisabled", "infiniteScrollContainer", "scrollWindow", "immediateCheck", "horizontal", "alwaysCallback", "fromRoot"], outputs: ["scrolled", "scrolledUp"] }, { kind: "component", type: FeatureNotificationMessageComponent, selector: "notification-message", inputs: ["notification", "messageDetail"], outputs: ["onSelectedNotification"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureNotificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'feature-notification', template: "<ng-container *ngIf=\"toggled\">\n  <div class=\"features-notifications reduced auto-height read-options\" [class.active]=\"toggled\">\n    <h2 class=\"title\">\n\n      <ng-container *ngIf=\"loadingMarkAllReaded\">\n        <div class=\"read hint clean\">\n          <em class=\"fa fa-spinner fa-spin\"></em>\n        </div>\n      </ng-container>\n\n      <div *ngIf=\"!loadingMarkAllReaded\" class=\"read hint clean center-left\" (click)=\"hasMessagesToRead ? markAllReaded() : ''\">\n        <ng-container *ngIf=\"hasMessagesToRead;else noMessagesToRead\">\n          <em class=\"fa fa-envelope\"></em>\n          <div class=\"hint-content\" style=\"top: -3px;\">Marcar todas como lidas</div>\n        </ng-container>\n        <ng-template #noMessagesToRead>\n          <em class=\"fa fa-envelope-open\"></em>\n          <div class=\"hint-content\" style=\"top: -3px;\">N\u00E3o h\u00E1 mensagens n\u00E3o lidas</div>\n        </ng-template>\n      </div>\n\n\n      Notifica\u00E7\u00F5es\n    </h2>\n\n    <div class=\"features-body\" infiniteScroll [infiniteScrollDistance]=\"2\" [infiniteScrollThrottle]=\"500\"\n      [scrollWindow]=\"false\" (scrolled)=\"loadNotifications(currentPage + 1)\">\n      <ul class=\"notification-list\">\n        <ng-container *ngFor=\"let notification of notifications\">\n          <notification-message [notification]=\"notification\" (onSelectedNotification)=\"visualize($event)\">\n          </notification-message>\n        </ng-container>\n\n        <li *ngIf=\"notifications.length === 0\">\n          <article>\n            <p id=\"emptyList\" class=\"nowrap\">N\u00E3o existem novas notifica\u00E7\u00F5es</p>\n          </article>\n        </li>\n\n        <li *ngIf=\"loadingMore && notifications.length >= 4\">\n          <em class=\"fa fa-circle-o-notch fa-spin center\"></em>\n        </li>\n      </ul>\n    </div>\n    <ul class=\"notification-list\">\n      <li class=\"more\"><button (click)=\"showAll()\" id=\"btnAll\">Todas as notifica\u00E7\u00F5es<em\n            class=\"fa fa-angle-double-right\"></em></button></li>\n    </ul>\n  </div>\n</ng-container>", styles: [".features-notifications{border-radius:3px;width:400px!important;max-width:calc(100vw - 20px);right:10px!important}.more button{flex-direction:row;gap:5px;min-height:15px}\n"] }]
        }], ctorParameters: () => [{ type: FeatureModuleStateService }, { type: i0.ElementRef }, { type: i1$4.Router }, { type: WindowService }, { type: NotificationSystemService }], propDecorators: { clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class FeatureSobreSistemaService {
    constructor(httpClient, urlResolver) {
        this.httpClient = httpClient;
        this.urlResolver = urlResolver;
        this.resource = `/actuator/info`;
    }
    getCurrentVersion() {
        return this.httpClient.get(`${this.urlResolver.getUrlResolved()}${this.resource}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureSobreSistemaService, deps: [{ token: i1$1.HttpClient }, { token: UrlResolver }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureSobreSistemaService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureSobreSistemaService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: UrlResolver }] });

class FeatureSobreSistemaComponent {
    constructor(featureSobreSistemaService, featureModuleStateService, elementRef) {
        this.featureSobreSistemaService = featureSobreSistemaService;
        this.featureModuleStateService = featureModuleStateService;
        this.elementRef = elementRef;
        this.getVersaoSobreSistema = undefined;
        this.getTotalAcessosSobreSistema = undefined;
        this.showNovidadesVersao = false;
        this.versaoBuild = undefined;
        this.dataBuild = undefined;
        this.isVersaoDefined = false;
        this.versaoSubscription = undefined;
        this.isTotalAcessosDefined = false;
        this.totalAcessosSubscription = undefined;
        this.toggled = false;
    }
    voltarParaAjustes() {
        this.featureModuleStateService.hideMenu('sobreSistema');
    }
    ngOnInit() {
        this.isTotalAcessosDefined = this.getTotalAcessosSobreSistema !== undefined;
        this.handleStateObserver();
    }
    clickedOutside(event) {
        if (this.toggled && !this.elementRef.nativeElement.contains(event.target)
            && !event.target?.id?.includes('sobre')
            && document.body.contains(event.target)) {
            this.featureModuleStateService.hideMenu('sobreSistema');
        }
    }
    handleStateObserver() {
        this.featureModuleStateService.sobreSistemaVisibleObserver.subscribe((value) => {
            if (value === undefined) {
                this.toggled = !this.toggled;
            }
            else {
                this.toggled = value;
            }
            if (this.toggled) {
                if (!this.getVersaoSobreSistema) {
                    this.versaoSubscription = this.featureSobreSistemaService.getCurrentVersion().subscribe((response) => {
                        this.versaoBuild = response.build.version;
                        this.dataBuild = response.build.time;
                    });
                }
                else {
                    this.versaoSubscription = this.getVersaoSobreSistema().subscribe((response) => {
                        this.versaoBuild = response.build.version;
                        this.dataBuild = response.build.time;
                    });
                }
                if (this.getTotalAcessosSobreSistema) {
                    this.totalAcessosSubscription = this.getTotalAcessosSobreSistema().subscribe((response) => {
                        this.totalAcessos = response;
                    });
                }
            }
            else {
                if (this.versaoSubscription) {
                    this.versaoSubscription.unsubscribe();
                }
                this.versaoSubscription = undefined;
                if (this.totalAcessosSubscription) {
                    this.totalAcessosSubscription.unsubscribe();
                }
                this.totalAcessosSubscription = undefined;
                this.versaoBuild = undefined;
                this.dataBuild = undefined;
                this.totalAcessos = undefined;
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureSobreSistemaComponent, deps: [{ token: FeatureSobreSistemaService }, { token: FeatureModuleStateService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureSobreSistemaComponent, selector: "feature-user-sobre-sistema", inputs: { getVersaoSobreSistema: "getVersaoSobreSistema", getTotalAcessosSobreSistema: "getTotalAcessosSobreSistema", showNovidadesVersao: "showNovidadesVersao", urlNovidades: "urlNovidades" }, host: { listeners: { "document:click": "clickedOutside($event)" } }, ngImport: i0, template: "<div class=\"features-user auto-height usuario\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <div id=\"user\"\n      class=\"read hint clean center-left neutral\"\n      (click)=\"voltarParaAjustes()\"\n    >\n      <i class=\"fa fa-chevron-left\" id=\"user_i\"></i>\n      <div id=\"user_class\" class=\"hint-content\">Voltar</div>\n    </div>\n    Sobre o sistema\n  </h2>\n  <ul class=\"user-actions sobre-sistema\">\n    <div class=\"col-md-12 form-group mb-xs\">\n      <article id=\"versao\">\n        <label>Vers\u00E3o</label>\n        <p>{{ versaoBuild ? versaoBuild : 'Carregando...' }}</p>\n        <label>Data</label>\n        <p>{{ dataBuild ? (dataBuild | datehourformat) : 'Carregando...' }}</p>\n      </article>\n      <article *ngIf=\"isTotalAcessosDefined\" id=\"totalAcessos\">\n        <label>Total de Acessos</label>\n        <p>{{ totalAcessos ? totalAcessos : 'Carregando...' }}</p>\n      </article>\n    </div>\n    <li *ngIf=\"showNovidadesVersao\" class=\"form-group\" id=\"novidades\">\n      <a href=\"{{urlNovidades}}\" target=\"_blank\">\n          <i class=\"fa fa-info-circle icon\"></i>Confira as novidades da vers\u00E3o</a>\n    </li>\n  </ul>\n  <div class=\"footer-oxy-logo hidden-sm hidden-xs\">\n    <svg width=\"1131.886\" height=\"135.779\" viewBox=\"0 0 1131.886 135.779\">\n      <g\n        id=\"Grupo_1234\"\n        data-name=\"Grupo 1234\"\n        transform=\"translate(-128.114 -351.26)\"\n      >\n        <path\n          id=\"Caminho_2\"\n          data-name=\"Caminho 2\"\n          d=\"M4-.319V-6.78H-29.305V-.319h13.056V40.648h7.194V-.319ZM42.5,40.648V34.187H19.389V19.932H39.107V13.537H19.389V-.319H42.5V-6.78H12.2V40.648ZM84.6,26.46H77.343c-1.132,4.8-4.4,8.127-9.659,8.127a9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788S58.358,4.677,60.69,2.146A9.477,9.477,0,0,1,67.684-.719c5.262,0,8.46,3.331,9.592,8.127H84.6C82.938-2.051,76.41-7.18,67.684-7.18A17.187,17.187,0,0,0,55.227-2.117c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.187,17.187,0,0,0,12.457,5.063C76.277,41.048,83,35.919,84.6,26.46Zm45.3,14.189V-6.78h-7.194V26.526L100.791-6.78H94.2V40.648h7.194V7.275l21.916,33.373Zm44.764-23.714c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,157.612-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C174.8,31.322,174.665,26.06,174.665,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C167,4.744,167.471,7.408,167.471,16.934Zm47.895,23.714V34.187H192.517V-6.78h-7.194V40.648ZM254.2,16.934c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,237.148-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C254.334,31.322,254.2,26.06,254.2,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C246.541,4.744,247.007,7.408,247.007,16.934ZM297.5,22.263V15H280.18v6.128h10.125V23.8a10.715,10.715,0,0,1-2.4,7.461,10.054,10.054,0,0,1-7.727,3.331,9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788s.533-12.19,2.864-14.722A9.527,9.527,0,0,1,280.18-.719c5.329,0,8.793,3.064,9.992,8.26h7.261C296.1-.585,290.239-7.18,280.18-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a18.178,18.178,0,0,0,25.513-.333C296.367,32.322,297.5,28.391,297.5,22.263Zm17.786,18.385V-6.78h-7.194V40.648Zm47.3,0L345.195-6.78h-5.8L322.013,40.648h7.661l3.264-9.526h18.718l3.264,9.526ZM349.658,24.994H335.07l7.394-21.05Z\"\n          transform=\"translate(157.419 401.566)\"\n          fill=\"#a8a8a8\"\n        ></path>\n        <g\n          id=\"Grupo_1237\"\n          data-name=\"Grupo 1237\"\n          transform=\"translate(518 307.26)\"\n        >\n          <path\n            id=\"Caminho_132\"\n            data-name=\"Caminho 132\"\n            d=\"M276.665,279.579V244.641H254.529v135.72h22.135V301.714h22.042L311.4,279.579Z\"\n            transform=\"translate(117.787 -200.582)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_133\"\n            data-name=\"Caminho 133\"\n            d=\"M460.674,279.544a50.156,50.156,0,0,0-28.292,8.679V244.607H410.247v135.72h22.135V330.876a28.874,28.874,0,0,1,27.734-29.19,28.26,28.26,0,0,1,28.79,28.254v50.387h22.135v-49.05c0-27.709-22.653-51.716-50.365-51.732\"\n            transform=\"translate(230.958 -200.607)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_134\"\n            data-name=\"Caminho 134\"\n            d=\"M236.808,264.6A50.4,50.4,0,1,0,287.2,315a50.4,50.4,0,0,0-50.4-50.4m3.673,78.424a28.27,28.27,0,1,1,24.355-24.358,28.271,28.271,0,0,1-24.355,24.358\"\n            transform=\"translate(67.949 -185.647)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_135\"\n            data-name=\"Caminho 135\"\n            d=\"M196.675,303.934A50.4,50.4,0,1,0,147.5,365.393H172.05l12.69-22.139H147.5a28.264,28.264,0,1,1,26.038-39.32c.192.453.338.93.508,1.383H147.5a9.682,9.682,0,0,0,0,19.364h49.447a50.3,50.3,0,0,0-.27-20.747\"\n            transform=\"translate(2.904 -185.671)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_136\"\n            data-name=\"Caminho 136\"\n            d=\"M385.676,303.934A50.4,50.4,0,1,0,336.5,365.393h24.55l12.709-22.138H336.5a28.264,28.264,0,1,1,26.038-39.321c.189.453.338.93.505,1.383H336.5a9.682,9.682,0,1,0,0,19.364h49.447a50.253,50.253,0,0,0-.266-20.747\"\n            transform=\"translate(140.546 -185.671)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_137\"\n            data-name=\"Caminho 137\"\n            d=\"M375.375,315a28.285,28.285,0,0,1,28.273-28.27h19.937l12.69-22.129H403.648a50.389,50.389,0,1,0,0,100.778l19.937,0,12.69-22.126H403.648A28.268,28.268,0,0,1,375.375,315\"\n            transform=\"translate(189.621 -185.65)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <rect\n            id=\"Ret\\xE2ngulo_757\"\n            data-name=\"Ret\\xE2ngulo 757\"\n            width=\"22.135\"\n            height=\"135.72\"\n            transform=\"translate(216.234 44)\"\n            fill=\"#b0b0b5\"\n          ></rect>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: DateHourFormatPipe, name: "datehourformat" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureSobreSistemaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'feature-user-sobre-sistema', template: "<div class=\"features-user auto-height usuario\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <div id=\"user\"\n      class=\"read hint clean center-left neutral\"\n      (click)=\"voltarParaAjustes()\"\n    >\n      <i class=\"fa fa-chevron-left\" id=\"user_i\"></i>\n      <div id=\"user_class\" class=\"hint-content\">Voltar</div>\n    </div>\n    Sobre o sistema\n  </h2>\n  <ul class=\"user-actions sobre-sistema\">\n    <div class=\"col-md-12 form-group mb-xs\">\n      <article id=\"versao\">\n        <label>Vers\u00E3o</label>\n        <p>{{ versaoBuild ? versaoBuild : 'Carregando...' }}</p>\n        <label>Data</label>\n        <p>{{ dataBuild ? (dataBuild | datehourformat) : 'Carregando...' }}</p>\n      </article>\n      <article *ngIf=\"isTotalAcessosDefined\" id=\"totalAcessos\">\n        <label>Total de Acessos</label>\n        <p>{{ totalAcessos ? totalAcessos : 'Carregando...' }}</p>\n      </article>\n    </div>\n    <li *ngIf=\"showNovidadesVersao\" class=\"form-group\" id=\"novidades\">\n      <a href=\"{{urlNovidades}}\" target=\"_blank\">\n          <i class=\"fa fa-info-circle icon\"></i>Confira as novidades da vers\u00E3o</a>\n    </li>\n  </ul>\n  <div class=\"footer-oxy-logo hidden-sm hidden-xs\">\n    <svg width=\"1131.886\" height=\"135.779\" viewBox=\"0 0 1131.886 135.779\">\n      <g\n        id=\"Grupo_1234\"\n        data-name=\"Grupo 1234\"\n        transform=\"translate(-128.114 -351.26)\"\n      >\n        <path\n          id=\"Caminho_2\"\n          data-name=\"Caminho 2\"\n          d=\"M4-.319V-6.78H-29.305V-.319h13.056V40.648h7.194V-.319ZM42.5,40.648V34.187H19.389V19.932H39.107V13.537H19.389V-.319H42.5V-6.78H12.2V40.648ZM84.6,26.46H77.343c-1.132,4.8-4.4,8.127-9.659,8.127a9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788S58.358,4.677,60.69,2.146A9.477,9.477,0,0,1,67.684-.719c5.262,0,8.46,3.331,9.592,8.127H84.6C82.938-2.051,76.41-7.18,67.684-7.18A17.187,17.187,0,0,0,55.227-2.117c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.187,17.187,0,0,0,12.457,5.063C76.277,41.048,83,35.919,84.6,26.46Zm45.3,14.189V-6.78h-7.194V26.526L100.791-6.78H94.2V40.648h7.194V7.275l21.916,33.373Zm44.764-23.714c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,157.612-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C174.8,31.322,174.665,26.06,174.665,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C167,4.744,167.471,7.408,167.471,16.934Zm47.895,23.714V34.187H192.517V-6.78h-7.194V40.648ZM254.2,16.934c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,237.148-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C254.334,31.322,254.2,26.06,254.2,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C246.541,4.744,247.007,7.408,247.007,16.934ZM297.5,22.263V15H280.18v6.128h10.125V23.8a10.715,10.715,0,0,1-2.4,7.461,10.054,10.054,0,0,1-7.727,3.331,9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788s.533-12.19,2.864-14.722A9.527,9.527,0,0,1,280.18-.719c5.329,0,8.793,3.064,9.992,8.26h7.261C296.1-.585,290.239-7.18,280.18-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a18.178,18.178,0,0,0,25.513-.333C296.367,32.322,297.5,28.391,297.5,22.263Zm17.786,18.385V-6.78h-7.194V40.648Zm47.3,0L345.195-6.78h-5.8L322.013,40.648h7.661l3.264-9.526h18.718l3.264,9.526ZM349.658,24.994H335.07l7.394-21.05Z\"\n          transform=\"translate(157.419 401.566)\"\n          fill=\"#a8a8a8\"\n        ></path>\n        <g\n          id=\"Grupo_1237\"\n          data-name=\"Grupo 1237\"\n          transform=\"translate(518 307.26)\"\n        >\n          <path\n            id=\"Caminho_132\"\n            data-name=\"Caminho 132\"\n            d=\"M276.665,279.579V244.641H254.529v135.72h22.135V301.714h22.042L311.4,279.579Z\"\n            transform=\"translate(117.787 -200.582)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_133\"\n            data-name=\"Caminho 133\"\n            d=\"M460.674,279.544a50.156,50.156,0,0,0-28.292,8.679V244.607H410.247v135.72h22.135V330.876a28.874,28.874,0,0,1,27.734-29.19,28.26,28.26,0,0,1,28.79,28.254v50.387h22.135v-49.05c0-27.709-22.653-51.716-50.365-51.732\"\n            transform=\"translate(230.958 -200.607)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_134\"\n            data-name=\"Caminho 134\"\n            d=\"M236.808,264.6A50.4,50.4,0,1,0,287.2,315a50.4,50.4,0,0,0-50.4-50.4m3.673,78.424a28.27,28.27,0,1,1,24.355-24.358,28.271,28.271,0,0,1-24.355,24.358\"\n            transform=\"translate(67.949 -185.647)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_135\"\n            data-name=\"Caminho 135\"\n            d=\"M196.675,303.934A50.4,50.4,0,1,0,147.5,365.393H172.05l12.69-22.139H147.5a28.264,28.264,0,1,1,26.038-39.32c.192.453.338.93.508,1.383H147.5a9.682,9.682,0,0,0,0,19.364h49.447a50.3,50.3,0,0,0-.27-20.747\"\n            transform=\"translate(2.904 -185.671)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_136\"\n            data-name=\"Caminho 136\"\n            d=\"M385.676,303.934A50.4,50.4,0,1,0,336.5,365.393h24.55l12.709-22.138H336.5a28.264,28.264,0,1,1,26.038-39.321c.189.453.338.93.505,1.383H336.5a9.682,9.682,0,1,0,0,19.364h49.447a50.253,50.253,0,0,0-.266-20.747\"\n            transform=\"translate(140.546 -185.671)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_137\"\n            data-name=\"Caminho 137\"\n            d=\"M375.375,315a28.285,28.285,0,0,1,28.273-28.27h19.937l12.69-22.129H403.648a50.389,50.389,0,1,0,0,100.778l19.937,0,12.69-22.126H403.648A28.268,28.268,0,0,1,375.375,315\"\n            transform=\"translate(189.621 -185.65)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <rect\n            id=\"Ret\\xE2ngulo_757\"\n            data-name=\"Ret\\xE2ngulo 757\"\n            width=\"22.135\"\n            height=\"135.72\"\n            transform=\"translate(216.234 44)\"\n            fill=\"#b0b0b5\"\n          ></rect>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: FeatureSobreSistemaService }, { type: FeatureModuleStateService }, { type: i0.ElementRef }], propDecorators: { getVersaoSobreSistema: [{
                type: Input
            }], getTotalAcessosSobreSistema: [{
                type: Input
            }], showNovidadesVersao: [{
                type: Input
            }], urlNovidades: [{
                type: Input
            }], clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

const isRebrandingActive = () => !(window.location.hostname.includes('.iss.elotech.com.br') || window.location.hostname.includes('.oxy.elotech.com.br'));
const shouldRenderNewTheme = () => isRebrandingActive()
    ? window.localStorage.getItem('new-theme') === 'true'
    : false;
const switchTheme = () => {
    window.localStorage.setItem('new-theme', String(true));
    window.location.reload();
};

class FeatureUserComponent {
    constructor(featureModuleStateService, authParams, authHttp, elementRef) {
        this.featureModuleStateService = featureModuleStateService;
        this.authParams = authParams;
        this.authHttp = authHttp;
        this.elementRef = elementRef;
        this.showMinhaConta = true;
        this.showCreateUser = false;
        this.logout = new EventEmitter();
        this.routeMe = '/me';
        this.renderParametros = true;
        this.usuarioLogado = true;
        this.showCompetencia = true;
        this.toggled = false;
        this.goMinhaContaFunction = this.goMinhaConta();
    }
    ngOnInit() {
        this.loadUser();
        this.handleUserStateObserver();
        this.getEntidadeCompetencia();
    }
    onLogout() {
        this.logout.emit();
    }
    onChangeTheme() {
        switchTheme();
    }
    isRebrandingActive() {
        return isRebrandingActive();
    }
    shouldRenderParametros() {
        return this.usuarioLogado && this.renderParametros;
    }
    goMinhaConta() {
        if (this.goMinhaContaFunction) {
            return (window.location.href = this.goMinhaContaFunction());
        }
    }
    callTour() {
        this.featureModuleStateService.tourCaller.emit();
    }
    onChangeEntidade() {
        this.featureModuleStateService.alternateStatus('user');
        this.featureModuleStateService.alternateStatus('configuracaoEntidade');
    }
    onClickSobreSistema() {
        this.featureModuleStateService.alternateStatus('sobreSistema');
    }
    clickedOutside(event) {
        if (this.toggled && !this.elementRef.nativeElement.contains(event.target)
            && !event.target?.id?.includes('user')
            && document.body.contains(event.target)) {
            this.featureModuleStateService.hideMenu('user');
        }
    }
    loadUser() {
        if (this.getUsuarioLogado) {
            this.getUsuarioLogado.then((profile) => (this.usuario = { nome: profile.name }));
        }
        else {
            this.authParams.onLoginObservers.subscribe((logged) => {
                if (logged) {
                    this.authHttp.getUsuarioLogado().subscribe((user) => {
                        this.usuario = user;
                    });
                }
                else {
                    this.usuario = null;
                }
            });
        }
    }
    handleUserStateObserver() {
        this.featureModuleStateService.userVisibleObserver.subscribe((value) => {
            if (value === undefined) {
                this.toggled = !this.toggled;
            }
            else {
                this.toggled = value;
            }
        });
    }
    getEntidadeCompetencia() {
        if (this.authHttp.getUsuarioInfo()) {
            const { entidadePadrao, exercicioPadrao, mesPadrao, } = this.authHttp.getUsuarioInfo();
            if (entidadePadrao && exercicioPadrao && mesPadrao) {
                this.entidadePadrao = entidadePadrao.nome;
                this.competenciaExercicioPadrao = `${mesPadrao + '/' + exercicioPadrao}`;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureUserComponent, deps: [{ token: FeatureModuleStateService }, { token: AuthParams }, { token: AbstractAuthHttp }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureUserComponent, selector: "feature-user", inputs: { showMinhaConta: "showMinhaConta", showCreateUser: "showCreateUser", routeMe: "routeMe", routeCreateUser: "routeCreateUser", getUsuarioLogado: "getUsuarioLogado", renderParametros: "renderParametros", usuarioLogado: "usuarioLogado", showCompetencia: "showCompetencia", goMinhaContaFunction: "goMinhaContaFunction" }, outputs: { logout: "logout" }, host: { listeners: { "document:click": "clickedOutside($event)" } }, ngImport: i0, template: "<div class=\"features-user auto-height usuario\" [class.active]=\"toggled\">\n  <h2 class=\"title\">Ajustes</h2>\n  <ul class=\"user-actions\">\n    <li *ngIf=\"usuarioLogado\" class=\"features-section\">Minha Conta</li>\n    <li *ngIf=\"usuarioLogado\" (click)=\"callTour()\">\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"plane-departure\"\n        class=\"svg-inline--fa fa-plane-departure fa-w-20 Icon-sc-26zt4v-0 kjHNoM icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 640 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z\"\n        ></path>\n      </svg>\n      <article id=\"tour\"><label>Fazer o tour novamente.</label></article>\n    </li>\n    <li (click)=\"goMinhaConta()\" *ngIf=\"usuarioLogado && usuario\">\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"user\"\n        class=\"svg-inline--fa fa-user fa-w-14 icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 448 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z\"\n        ></path>\n      </svg>\n      <article id=\"userName\"><label>Usu\u00E1rio</label>{{ usuario?.nome }}</article>\n    </li>\n\n    <a routerLink=\"/auth\" *ngIf=\"usuarioLogado && !usuario\"> \n      <li>\n          <i class=\"fa fa-sign-in icon\"></i> Login\n      </li>\n    </a>\n\n    <li *ngIf=\"shouldRenderParametros()\" class=\"features-section\">\n      Par\u00E2metros\n    </li>\n    <li\n      *ngIf=\"shouldRenderParametros()\"\n      title=\"{{ entidadePadrao }}\"\n      (click)=\"onChangeEntidade()\"\n    >\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"building\"\n        class=\"svg-inline--fa fa-building fa-w-14 icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 448 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z\"\n        ></path>\n      </svg>\n      <article class=\"nowrap\">\n        <label>Entidade</label>{{ entidadePadrao }}\n      </article>\n    </li>\n    <li\n      *ngIf=\"shouldRenderParametros() && showCompetencia\"\n      (click)=\"onChangeEntidade()\"\n    >\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"calendar-alt\"\n        class=\"svg-inline--fa fa-calendar-alt fa-w-14 icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 448 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z\"\n        ></path>\n      </svg>\n      <article class=\"nowrap\">\n        <label>Compet\u00EAncia</label>{{ competenciaExercicioPadrao }}\n      </article>\n    </li>\n    <li  (click)=\"onClickSobreSistema()\" id=\"sobre\">\n      <i class=\"fa fa-info-circle icon\"></i>Sobre o sistema\n    </li>\n    <li class=\"logout\" (click)=\"onLogout()\" *ngIf=\"usuarioLogado && usuario\">\n      <i class=\"fa fa-sign-out icon\"></i>Sair\n    </li>\n  </ul>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureUserComponent, decorators: [{
            type: Component,
            args: [{ selector: 'feature-user', template: "<div class=\"features-user auto-height usuario\" [class.active]=\"toggled\">\n  <h2 class=\"title\">Ajustes</h2>\n  <ul class=\"user-actions\">\n    <li *ngIf=\"usuarioLogado\" class=\"features-section\">Minha Conta</li>\n    <li *ngIf=\"usuarioLogado\" (click)=\"callTour()\">\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"plane-departure\"\n        class=\"svg-inline--fa fa-plane-departure fa-w-20 Icon-sc-26zt4v-0 kjHNoM icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 640 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z\"\n        ></path>\n      </svg>\n      <article id=\"tour\"><label>Fazer o tour novamente.</label></article>\n    </li>\n    <li (click)=\"goMinhaConta()\" *ngIf=\"usuarioLogado && usuario\">\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"user\"\n        class=\"svg-inline--fa fa-user fa-w-14 icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 448 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z\"\n        ></path>\n      </svg>\n      <article id=\"userName\"><label>Usu\u00E1rio</label>{{ usuario?.nome }}</article>\n    </li>\n\n    <a routerLink=\"/auth\" *ngIf=\"usuarioLogado && !usuario\"> \n      <li>\n          <i class=\"fa fa-sign-in icon\"></i> Login\n      </li>\n    </a>\n\n    <li *ngIf=\"shouldRenderParametros()\" class=\"features-section\">\n      Par\u00E2metros\n    </li>\n    <li\n      *ngIf=\"shouldRenderParametros()\"\n      title=\"{{ entidadePadrao }}\"\n      (click)=\"onChangeEntidade()\"\n    >\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"building\"\n        class=\"svg-inline--fa fa-building fa-w-14 icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 448 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z\"\n        ></path>\n      </svg>\n      <article class=\"nowrap\">\n        <label>Entidade</label>{{ entidadePadrao }}\n      </article>\n    </li>\n    <li\n      *ngIf=\"shouldRenderParametros() && showCompetencia\"\n      (click)=\"onChangeEntidade()\"\n    >\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"calendar-alt\"\n        class=\"svg-inline--fa fa-calendar-alt fa-w-14 icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 448 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z\"\n        ></path>\n      </svg>\n      <article class=\"nowrap\">\n        <label>Compet\u00EAncia</label>{{ competenciaExercicioPadrao }}\n      </article>\n    </li>\n    <li  (click)=\"onClickSobreSistema()\" id=\"sobre\">\n      <i class=\"fa fa-info-circle icon\"></i>Sobre o sistema\n    </li>\n    <li class=\"logout\" (click)=\"onLogout()\" *ngIf=\"usuarioLogado && usuario\">\n      <i class=\"fa fa-sign-out icon\"></i>Sair\n    </li>\n  </ul>\n</div>\n" }]
        }], ctorParameters: () => [{ type: FeatureModuleStateService }, { type: AuthParams }, { type: AbstractAuthHttp }, { type: i0.ElementRef }], propDecorators: { showMinhaConta: [{
                type: Input
            }], showCreateUser: [{
                type: Input
            }], logout: [{
                type: Output
            }], routeMe: [{
                type: Input
            }], routeCreateUser: [{
                type: Input
            }], getUsuarioLogado: [{
                type: Input
            }], renderParametros: [{
                type: Input
            }], usuarioLogado: [{
                type: Input
            }], showCompetencia: [{
                type: Input
            }], goMinhaContaFunction: [{
                type: Input
            }], clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class UrlUtils {
    static getMinhaContaUrl() {
        const windowRef = WindowService.getWindow();
        const minhaContaUrl = windowRef.location.href.indexOf('localhost') > -1 || windowRef.location.href.indexOf('localnet') > -1
            ? `${windowRef.location.protocol}//localhost:3050`
            : `${windowRef.location.origin}/minha-conta`;
        return `${minhaContaUrl}?referrer=${encodeURIComponent(document.title)}&referrer_uri=${encodeURIComponent(windowRef.location.href)}`;
    }
    static getHost() {
        const location = WindowService.getWindow().location;
        return location.protocol + '//' + location.hostname;
    }
    static getTenant() {
        const windowRef = WindowService.getWindow();
        const hostname = windowRef.location.hostname;
        return hostname.substring(0, hostname.includes('.') ? hostname.indexOf('.') : hostname.length).replaceAll('-', '_');
    }
}

class FeatureTaskListCounterService {
    constructor() {
        this.counter = new BehaviorSubject(0);
    }
    get counter$() {
        return this.counter.asObservable();
    }
    setCounter(value) {
        this.counter.next(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureTaskListCounterService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureTaskListCounterService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureTaskListCounterService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class FeatureTaskListWorkflowComponent {
    constructor(authResource, featureModuleStateService, keycloakService, elementRef, featureTaskListCounterService) {
        this.featureModuleStateService = featureModuleStateService;
        this.keycloakService = keycloakService;
        this.elementRef = elementRef;
        this.featureTaskListCounterService = featureTaskListCounterService;
        this.toggled = false;
        this.host = '';
        this.host = authResource.isDev ? 'https://elotech.dev.elotech.com.br' : UrlUtils.getHost();
    }
    ngOnInit() {
        this.featureModuleStateService.workflowTaskListObserver
            .subscribe(value => this.updateToggled(value));
    }
    clickedOutside(event) {
        if (this.toggled && !this.elementRef?.nativeElement?.contains(event.target) && !event.target?.id?.includes('tasks') && document.body.contains(event.target)) {
            this.featureModuleStateService.hideMenu('taskListWorkflow');
        }
    }
    updateCounter(counter) {
        this.featureTaskListCounterService.setCounter(counter);
    }
    updateToggled(value) {
        if (value === undefined) {
            this.toggled = !this.toggled;
        }
        else {
            this.toggled = value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureTaskListWorkflowComponent, deps: [{ token: AUTH_RESOURCES_CONFIG }, { token: FeatureModuleStateService }, { token: KeycloakAuthHttp }, { token: i0.ElementRef }, { token: FeatureTaskListCounterService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeatureTaskListWorkflowComponent, isStandalone: true, selector: "workflow-task-list", host: { listeners: { "document:click": "clickedOutside($event)" } }, providers: [KeycloakAuthHttp, AuthParams], ngImport: i0, template: `
      <div style="z-index: 99999; position: relative;" id="tasks-list">
        <elo-task-list-modal id="tasks-list" 
          [active]="toggled" 
          [host]="host" 
          [token]="keycloakService.getToken()" 
          (countItemsPending)="updateCounter($event)"/>
      </div>
    `, isInline: true, dependencies: [{ kind: "component", type: TaskListModalComponent, selector: "elo-task-list-modal", inputs: ["host", "token", "active"], outputs: ["countItemsPending", "activeChange", "outsideClick"] }, { kind: "ngmodule", type: HttpClientModule }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeatureTaskListWorkflowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'workflow-task-list',
                    template: `
      <div style="z-index: 99999; position: relative;" id="tasks-list">
        <elo-task-list-modal id="tasks-list" 
          [active]="toggled" 
          [host]="host" 
          [token]="keycloakService.getToken()" 
          (countItemsPending)="updateCounter($event)"/>
      </div>
    `,
                    standalone: true,
                    imports: [
                        TaskListModalComponent,
                        HttpClientModule,
                    ],
                    providers: [KeycloakAuthHttp, AuthParams]
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }, { type: FeatureModuleStateService }, { type: KeycloakAuthHttp }, { type: i0.ElementRef }, { type: FeatureTaskListCounterService }], propDecorators: { clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class JasperService {
    static { this.EXECUTION_URL = '/jasperserver/rest_v2/reportExecutions'; }
    static { this.SERVER_INFO = '/jasperserver/rest_v2/serverInfo'; }
    static { this.SEARCH_URL = '/jasperserver/rest_v2/resources'; }
    constructor(authResourcesConfig, httpClient, eloNotificationService) {
        this.authResourcesConfig = authResourcesConfig;
        this.httpClient = httpClient;
        this.eloNotificationService = eloNotificationService;
        this.reports = [];
        this.onChangeReport = new Subject();
        this.onChangeObservable = this.onChangeReport.asObservable();
        this.sessionActive = false;
    }
    executeReport(request) {
        const headers = new HttpHeaders()
            .append('Content-Type', 'application/x-www-form-urlencoded')
            .append('Accept', 'application/xml');
        return this.httpClient.post('/jasperserver/rest_v2/login?j_username=jasperadmin&j_password=jasperadmin', null, { headers: headers, observe: 'response' }) // TODO INCLUDE LOGIN SSO
            .pipe(map(resp => {
            if (resp.url.includes('error')) {
                throw 'login error!';
            }
        }), mergeMap(() => this.searchRequestWithTenant(request).pipe(mergeMap(useTenant => this.internalExecuteReport(request, useTenant, false)
            .pipe(map((resp) => `${JasperService.EXECUTION_URL}/${resp.requestId}/exports/${resp.exports[0].id}/outputResource`))))));
    }
    executeAsyncReport(reportName, request, callback) {
        iif(() => this.sessionActive, of(''), this.login()).pipe(switchMap(() => this.searchRequestWithTenant(request).pipe(mergeMap(useTenant => this.internalExecuteReport(request, useTenant, true))))).subscribe((resp) => {
            this.eloNotificationService.info(`${reportName} está sendo gerado`, 'Verifique a fila de relatórios.');
            this.addAsyncReport(resp, reportName, callback);
        });
    }
    getRequestReportOutputURL(requestID, exportID) {
        return `${JasperService.EXECUTION_URL}/${requestID}/exports/${exportID}/outputResource`;
    }
    requestReportOutput(requestID, exportID) {
        return this.httpClient.get(this.getRequestReportOutputURL(requestID, exportID), { observe: 'response', responseType: 'arraybuffer' });
    }
    clearReports() {
        this.reports = this.reports.filter(r => r.status === 'execution');
        this.onChangeReport.next(this.reports);
    }
    login() {
        const headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded')
            .append('Accept', 'application/json');
        return this.httpClient.post('/jasperserver/rest_v2/login?j_username=jasperadmin&j_password=jasperadmin', null, { headers: headers, observe: 'response' }) // TODO INCLUDE LOGIN SSO
            .pipe(map(resp => {
            if (resp.url.includes('error')) {
                this.sessionActive = false;
                throw 'login error!';
            }
            this.sessionActive = true;
            this.subscriptionInterval = interval(900000).pipe(switchMap(() => this.serveInfo())).subscribe();
        }));
    }
    polling() {
        const validStatus = ['queued', 'execution'];
        this.subscriptionPolling = interval(1000)
            .pipe(takeWhile(() => this.reports.filter(r => validStatus.includes(r.status)).length > 0)).subscribe(() => this.reports.filter(r => r.status !== 'ready' && r.status !== 'failed').forEach(r => {
            this.httpClient.get(`${JasperService.EXECUTION_URL}/${r.requestId}`, { headers: new HttpHeaders({ 'Accept': 'application/json' }) })
                .subscribe((result) => {
                r.status = result && result.status;
                if (r.status === 'ready') {
                    this.eloNotificationService.success(`${r.reportName} foi concluído`, 'Verifique a fila de relatórios.');
                }
                if (r.status === 'failed') {
                    let errorMessage = { message: '' };
                    try {
                        errorMessage = JSON.parse(result.errorDescriptor.message);
                    }
                    catch {
                        errorMessage = { message: result.errorDescriptor.message };
                    }
                    this.eloNotificationService.error(`${r.reportName}`, errorMessage.message);
                    r.messageDetail = `Falha na geração: ${errorMessage.message}`;
                }
                this.onChangeReport.next(this.reports);
            }, () => {
                r.status = 'error';
                r.messageDetail = 'Não foi possível gerar, tente novamente.';
            });
        }));
    }
    getJasperRequestUriParamsFrom(request) {
        const indexLast = request.uri.lastIndexOf('/');
        return { folder: request.uri.substr(0, indexLast), file: request.uri.substr(indexLast + 1) };
    }
    searchRequestWithTenant(request) {
        const jasperRequestUriParams = this.getJasperRequestUriParamsFrom(request);
        const tenant = UrlUtils.getTenant();
        return this.httpClient
            .get(`${JasperService.SEARCH_URL}?folderUri=${jasperRequestUriParams.folder}&q=${jasperRequestUriParams.file}.${tenant}`, { observe: 'response' })
            .pipe(map(resp => resp.status === 200));
    }
    internalExecuteReport(request, useTenant, async) {
        const headersExecute = new HttpHeaders().append('X-REMOTE-DOMAIN', '1');
        const tenant = UrlUtils.getTenant();
        return this.httpClient.post(JasperService.EXECUTION_URL, {
            reportUnitUri: useTenant ? `${request.uri}.${tenant}` : request.uri,
            outputFormat: request.format,
            async: async,
            parameters: {
                reportParameter: this.mountParams(request.params)
            }
        }, { headers: headersExecute });
    }
    serveInfo() {
        return this.httpClient.get(`${JasperService.SERVER_INFO}`);
    }
    addAsyncReport(response, reportName, callback) {
        this.reports.push({ ...response, reportName, reportDate: `${DateUtils.now()} às ${DateUtils.nowHour()}`, callback });
        this.polling();
    }
    mountParams(params) {
        const overrideParams = [{ name: 'HOST_ORIGIN', value: location.hostname }];
        if (this.authResourcesConfig.isDev) {
            overrideParams.push({ name: 'EUREKA_HOST', value: location.protocol + '//' + this.authResourcesConfig.eurekaHost + ':8761' });
        }
        return [...params, ...overrideParams].map(p => ({ name: p.name, value: [p.value] }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: JasperService, deps: [{ token: AUTH_RESOURCES_CONFIG }, { token: i1$1.HttpClient }, { token: EloNotificationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: JasperService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: JasperService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }, { type: i1$1.HttpClient }, { type: EloNotificationService }] });

class DigitalCertificateComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.onAssinar = new EventEmitter();
        this.createForm();
    }
    assinar() {
        this.onAssinar.emit(this.form.value);
    }
    createForm() {
        this.form = this.formBuilder.group({
            path: ['/A1_PMPG_2020.pfx', Validators.required],
            alias: ['a1_pmpg_2020', Validators.required],
            password: ['123456', Validators.required]
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DigitalCertificateComponent, deps: [{ token: i1$2.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DigitalCertificateComponent, selector: "digital-certificate", outputs: { onAssinar: "onAssinar" }, ngImport: i0, template: "<div [formGroup]=\"form\">\n  <elo-panel class=\"panel\" [hasForm]=\"true\" [title]=\"'Certificado Digital'\">\n\n    <div class=\"row\">\n      <elo-form-label-column label=\"Local do certificado\" column=\"12\">\n        <input id=\"path\" formControlName=\"path\" maxlength=\"255\" placeholder=\"Informe o local do certificado\"\n          formControlValidationMsg>\n      </elo-form-label-column>\n    </div>\n\n    <div class=\"row\">\n      <elo-form-label-column label=\"Alias\" column=\"6\">\n        <input id=\"alias\" formControlName=\"alias\" maxlength=\"255\" placeholder=\"Informe o alias\"\n          formControlValidationMsg>\n      </elo-form-label-column>\n\n      <elo-form-label-column label=\"Senha\" column=\"6\">\n        <input id=\"password\" formControlName=\"password\" class=\"password\" type=\"password\" maxlength=\"255\"\n          placeholder=\"Informe a senha\" formControlValidationMsg>\n      </elo-form-label-column>\n    </div>\n\n    <div class=\"row\">\n      <elo-form-label-column column=\"12\" class=\"pull-right\">\n        <button id=\"btnAssinar\" class=\"btn module-color icon-left mb-xs inline\" type=\"button\" (click)=\"assinar()\"\n          [disabled]=\"form.invalid\">\n          Assinar\n        </button>\n      </elo-form-label-column>\n    </div>\n\n  </elo-panel>\n</div>", dependencies: [{ kind: "component", type: PanelComponent, selector: "elo-panel", inputs: ["title", "hasTable", "hasForm", "pbNone"] }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: FormControlValidationMsgDirective, selector: "[formControlValidationMsg]", inputs: ["formControlAttr"] }, { kind: "component", type: FormLabelColumnComponent, selector: "elo-form-label-column", inputs: ["label", "color", "column", "offset", "hintMessage", "hintPosition", "hintIconLeftAlign", "linkTitle", "showLink", "icon"], outputs: ["onClickLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DigitalCertificateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'digital-certificate', template: "<div [formGroup]=\"form\">\n  <elo-panel class=\"panel\" [hasForm]=\"true\" [title]=\"'Certificado Digital'\">\n\n    <div class=\"row\">\n      <elo-form-label-column label=\"Local do certificado\" column=\"12\">\n        <input id=\"path\" formControlName=\"path\" maxlength=\"255\" placeholder=\"Informe o local do certificado\"\n          formControlValidationMsg>\n      </elo-form-label-column>\n    </div>\n\n    <div class=\"row\">\n      <elo-form-label-column label=\"Alias\" column=\"6\">\n        <input id=\"alias\" formControlName=\"alias\" maxlength=\"255\" placeholder=\"Informe o alias\"\n          formControlValidationMsg>\n      </elo-form-label-column>\n\n      <elo-form-label-column label=\"Senha\" column=\"6\">\n        <input id=\"password\" formControlName=\"password\" class=\"password\" type=\"password\" maxlength=\"255\"\n          placeholder=\"Informe a senha\" formControlValidationMsg>\n      </elo-form-label-column>\n    </div>\n\n    <div class=\"row\">\n      <elo-form-label-column column=\"12\" class=\"pull-right\">\n        <button id=\"btnAssinar\" class=\"btn module-color icon-left mb-xs inline\" type=\"button\" (click)=\"assinar()\"\n          [disabled]=\"form.invalid\">\n          Assinar\n        </button>\n      </elo-form-label-column>\n    </div>\n\n  </elo-panel>\n</div>" }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }], propDecorators: { onAssinar: [{
                type: Output
            }] } });

class EloModalComponent {
    constructor() {
        this.isOpen = false;
        this.openClose = new EventEmitter();
        this.isCentralized = false;
        this.preventClose = false;
        this.switchOpenClose = () => {
            this.isOpen = !this.isOpen;
            this.openClose.emit(this.isOpen);
        };
    }
    handleKeyboardEvent(event) {
        if (event.code === 'Escape' && this.isOpen && !this.preventClose) {
            this.switchOpenClose();
        }
    }
    onMousedown(event) {
        const element = event.target;
        if (element.classList.contains('modal') && element.classList.contains('open') && !this.preventClose) {
            this.switchOpenClose();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloModalComponent, selector: "elo-modal", inputs: { isOpen: "isOpen", customWidth: "customWidth", isCentralized: "isCentralized", preventClose: "preventClose" }, outputs: { openClose: "openClose" }, host: { listeners: { "document:keydown": "handleKeyboardEvent($event)", "mousedown": "onMousedown($event)" } }, ngImport: i0, template: "<div class=\"modal modalIndex\" [class.open]=\"isOpen\" [class.centralized]=\"isCentralized\">\n\n  <div class=\"container\" [ngStyle]=\"{'width': customWidth}\">\n    <span class=\"close close-modal\" (click)=\"switchOpenClose()\" title=\"Fechar\"></span>\n    <ng-content></ng-content>\n  </div>\n\n</div>\n", styles: [".modalIndex{z-index:9999!important}\n"], dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-modal', template: "<div class=\"modal modalIndex\" [class.open]=\"isOpen\" [class.centralized]=\"isCentralized\">\n\n  <div class=\"container\" [ngStyle]=\"{'width': customWidth}\">\n    <span class=\"close close-modal\" (click)=\"switchOpenClose()\" title=\"Fechar\"></span>\n    <ng-content></ng-content>\n  </div>\n\n</div>\n", styles: [".modalIndex{z-index:9999!important}\n"] }]
        }], propDecorators: { isOpen: [{
                type: Input
            }], customWidth: [{
                type: Input
            }], openClose: [{
                type: Output
            }], isCentralized: [{
                type: Input
            }], preventClose: [{
                type: Input
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }], onMousedown: [{
                type: HostListener,
                args: ['mousedown', ['$event']]
            }] } });

class NotificationReportJasperComponent {
    constructor(featureModuleStateService, jasperService) {
        this.featureModuleStateService = featureModuleStateService;
        this.jasperService = jasperService;
        this.toggled = false;
        this.reports = [];
        this.showDialogAssinar = false;
        this.showDigitalCertificateForm = false;
    }
    ngOnInit() {
        this.handleStateObserver();
        this.jasperService.onChangeObservable.subscribe(reports => this.reports = reports);
    }
    onClick(report) {
        if (report.status === 'ready') {
            if (report.callback) {
                this.clickedReport = report;
                this.showDialogAssinar = true;
            }
            else {
                this.getReport(report);
            }
            this.toggled = false;
        }
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents && parents.length > 0 && parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map(parent => {
                if (parent && parent.classList && parent.classList.value
                    && parent.classList.value.includes('notification-report-jasper')) {
                    isFeatureOpen = true;
                }
            });
            if (!isFeatureOpen && this.toggled)
                this.featureModuleStateService.hideMenu('notificationReportJasper');
        }
    }
    clearReports() {
        this.jasperService.clearReports();
    }
    onAssinarOk() {
        this.showDialogAssinar = false;
        this.showDigitalCertificateForm = true;
    }
    onAssinarCancel() {
        this.showDialogAssinar = false;
        this.getReport(this.clickedReport);
    }
    onAssinar(digitalCertificate) {
        this.jasperService.requestReportOutput(this.clickedReport.requestId, this.clickedReport.exports[0].id)
            .subscribe(response => {
            this.clickedReport.callback(response, digitalCertificate);
            this.showDigitalCertificateForm = false;
        });
    }
    onOpenCloseModal(isOpen) {
        this.showDigitalCertificateForm = isOpen;
    }
    getReport(report) {
        window.open(this.jasperService.getRequestReportOutputURL(report.requestId, report.exports[0].id), '_blank');
    }
    handleStateObserver() {
        this.featureModuleStateService.notificationReportVisibleObserver.subscribe(value => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationReportJasperComponent, deps: [{ token: FeatureModuleStateService }, { token: JasperService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NotificationReportJasperComponent, selector: "notification-report-jasper", host: { listeners: { "document:click": "clickedOutside($event)" } }, ngImport: i0, template: "<div class=\"features-notifications reduced auto-height read-options\" [class.active]=\"toggled\">\n\n    <h2 class=\"title\">\n\n        <div id=\"clearReports\" *ngIf=\"reports.length\" class=\"read hint clean center-left neutral\"\n            (click)=\"clearReports()\">\n            <em class=\"fa fa-eraser\"></em>\n            <div class=\"hint-content\">Limpar notifica\u00E7\u00F5es</div>\n        </div>\n\n        Relat\u00F3rios\n    </h2>\n\n    <div class=\"features-body\">\n        <ul class=\"notification-list\">\n            <li *ngFor=\"let report of reports\" class=\"has-icon\" id=\"report_{{report.requestId}}\"\n                (click)=\"onClick(report)\" title=\"{{report.messageDetail ? report.messageDetail : report.reportName}}\">\n                <div class=\"typography-medium\">{{report?.reportName}}</div>\n                <div class=\"datehour\" *ngIf=\"report?.reportDate\">\n                    <span>{{report?.reportDate}}</span>\n                </div>\n                <article class=\"nowrap\">\n                    <p *ngIf=\"report.status === 'error' || report.status === 'failed'\">\n                        Falha\n                    </p>\n                    <p *ngIf=\"report.status === 'ready'\">\n                        Click para baixar\n                    </p>\n                    <p *ngIf=\"report.status === 'execution'\">\n                        Executando\n                    </p>\n                    <p *ngIf=\"report.status === 'queued'\">\n                        Aguardando Execu\u00E7\u00E3o\n                    </p>\n                </article>\n                <em class=\"fa fa-times-circle negative\"\n                    *ngIf=\"report.status === 'error' || report.status === 'failed'\"></em>\n                <em class=\"fa fa-check-circle positive\" *ngIf=\"report.status === 'ready'\"></em>\n                <em class=\"fa fa-circle-o-notch fa-spin module-color\" *ngIf=\"report.status === 'execution'\"></em>\n                <em class=\"fa fa-hourglass-1 module-color\" *ngIf=\"report.status === 'queued'\"></em>\n            </li>\n            <li *ngIf=\"!reports.length\">\n                <article id=\"reportsEmpty\" class=\"nowrap center\"> Nenhum relat\u00F3rio dispon\u00EDvel. </article>\n            </li>\n        </ul>\n    </div>\n</div>\n\n<elo-dialog [show]=\"showDialogAssinar\" [tittleOk]=\"'Sim'\" [tittleCancel]=\"'N\u00E3o'\" (onOkEvent)=\"onAssinarOk()\"\n    (onCancelEvent)=\"onAssinarCancel()\">\n    Deseja assinar o documento com certificado digital?\n</elo-dialog>\n\n<elo-modal *ngIf=\"showDigitalCertificateForm\" [isOpen]=\"showDigitalCertificateForm\"\n    (openClose)=\"onOpenCloseModal($event)\" [customWidth]=\"'30%'\">\n    <digital-certificate (onAssinar)=\"onAssinar($event)\"></digital-certificate>\n</elo-modal>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DigitalCertificateComponent, selector: "digital-certificate", outputs: ["onAssinar"] }, { kind: "component", type: DialogComponent, selector: "elo-dialog", inputs: ["show", "showCancel", "classType", "tittleCancel", "tittleOk", "title", "disableOkButton", "debounceTime"], outputs: ["onOkEvent", "onCancelEvent"] }, { kind: "component", type: EloModalComponent, selector: "elo-modal", inputs: ["isOpen", "customWidth", "isCentralized", "preventClose"], outputs: ["openClose"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationReportJasperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'notification-report-jasper', template: "<div class=\"features-notifications reduced auto-height read-options\" [class.active]=\"toggled\">\n\n    <h2 class=\"title\">\n\n        <div id=\"clearReports\" *ngIf=\"reports.length\" class=\"read hint clean center-left neutral\"\n            (click)=\"clearReports()\">\n            <em class=\"fa fa-eraser\"></em>\n            <div class=\"hint-content\">Limpar notifica\u00E7\u00F5es</div>\n        </div>\n\n        Relat\u00F3rios\n    </h2>\n\n    <div class=\"features-body\">\n        <ul class=\"notification-list\">\n            <li *ngFor=\"let report of reports\" class=\"has-icon\" id=\"report_{{report.requestId}}\"\n                (click)=\"onClick(report)\" title=\"{{report.messageDetail ? report.messageDetail : report.reportName}}\">\n                <div class=\"typography-medium\">{{report?.reportName}}</div>\n                <div class=\"datehour\" *ngIf=\"report?.reportDate\">\n                    <span>{{report?.reportDate}}</span>\n                </div>\n                <article class=\"nowrap\">\n                    <p *ngIf=\"report.status === 'error' || report.status === 'failed'\">\n                        Falha\n                    </p>\n                    <p *ngIf=\"report.status === 'ready'\">\n                        Click para baixar\n                    </p>\n                    <p *ngIf=\"report.status === 'execution'\">\n                        Executando\n                    </p>\n                    <p *ngIf=\"report.status === 'queued'\">\n                        Aguardando Execu\u00E7\u00E3o\n                    </p>\n                </article>\n                <em class=\"fa fa-times-circle negative\"\n                    *ngIf=\"report.status === 'error' || report.status === 'failed'\"></em>\n                <em class=\"fa fa-check-circle positive\" *ngIf=\"report.status === 'ready'\"></em>\n                <em class=\"fa fa-circle-o-notch fa-spin module-color\" *ngIf=\"report.status === 'execution'\"></em>\n                <em class=\"fa fa-hourglass-1 module-color\" *ngIf=\"report.status === 'queued'\"></em>\n            </li>\n            <li *ngIf=\"!reports.length\">\n                <article id=\"reportsEmpty\" class=\"nowrap center\"> Nenhum relat\u00F3rio dispon\u00EDvel. </article>\n            </li>\n        </ul>\n    </div>\n</div>\n\n<elo-dialog [show]=\"showDialogAssinar\" [tittleOk]=\"'Sim'\" [tittleCancel]=\"'N\u00E3o'\" (onOkEvent)=\"onAssinarOk()\"\n    (onCancelEvent)=\"onAssinarCancel()\">\n    Deseja assinar o documento com certificado digital?\n</elo-dialog>\n\n<elo-modal *ngIf=\"showDigitalCertificateForm\" [isOpen]=\"showDigitalCertificateForm\"\n    (openClose)=\"onOpenCloseModal($event)\" [customWidth]=\"'30%'\">\n    <digital-certificate (onAssinar)=\"onAssinar($event)\"></digital-certificate>\n</elo-modal>" }]
        }], ctorParameters: () => [{ type: FeatureModuleStateService }, { type: JasperService }], propDecorators: { clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class FeaturesGroupComponent {
    constructor() {
        this.logout = new EventEmitter();
        this.onGetExercicios = new EventEmitter();
        this.onGetCompetencias = new EventEmitter();
        this.onCompetenciaSelecionada = new EventEmitter();
        this.showMinhaConta = true;
        this.routeMe = '/me';
        this.showCreateUser = false;
        this.showCompetencia = true;
        this.showExercicio = true;
        this.configuracaoEntidadeKeycloak = false;
        this.showNotificationReport = false;
        this.activeDataOperacaoField = false;
        this.renderParametros = true;
        this.showModulos = true;
        this.goMinhaContaFunction = this.goMinhaConta();
        this.usuarioLogado = true;
        this.getVersaoSobreSistema = undefined;
        this.getTotalAcessosSobreSistema = undefined;
        this.showNovidadesVersao = false;
        this.urlNovidades = '';
        this.isModuloWorkflowAtivo = false;
    }
    onLogout() {
        this.logout.emit();
    }
    getExercicios(entidade) {
        this.onGetExercicios.emit(entidade);
    }
    getCompetencias(object) {
        this.onGetCompetencias.emit({ exercicio: object.exercicio, entidade: object.entidade });
    }
    competenciaSelecionada(object) {
        this.onCompetenciaSelecionada.emit(object);
    }
    goMinhaConta() {
        return () => UrlUtils.getMinhaContaUrl();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeaturesGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FeaturesGroupComponent, selector: "elo-features-group", inputs: { configuracaoEntidade: "configuracaoEntidade", usuario: "usuario", showMinhaConta: "showMinhaConta", routeMe: "routeMe", contribuinte: "contribuinte", showCreateUser: "showCreateUser", routeCreateUser: "routeCreateUser", getUsuarioLogado: "getUsuarioLogado", showCompetencia: "showCompetencia", showExercicio: "showExercicio", configuracaoEntidadeKeycloak: "configuracaoEntidadeKeycloak", showNotificationReport: "showNotificationReport", activeDataOperacaoField: "activeDataOperacaoField", renderParametros: "renderParametros", showModulos: "showModulos", goMinhaContaFunction: "goMinhaContaFunction", usuarioLogado: "usuarioLogado", getVersaoSobreSistema: "getVersaoSobreSistema", getTotalAcessosSobreSistema: "getTotalAcessosSobreSistema", showNovidadesVersao: "showNovidadesVersao", urlNovidades: "urlNovidades", isModuloWorkflowAtivo: "isModuloWorkflowAtivo" }, outputs: { logout: "logout", onGetExercicios: "onGetExercicios", onGetCompetencias: "onGetCompetencias", onCompetenciaSelecionada: "onCompetenciaSelecionada" }, ngImport: i0, template: "<div class=\"features-group\" [class.new]=\"true\">\n  <feature-modules *ngIf=\"usuarioLogado && showModulos\"></feature-modules>\n  <feature-notification *ngIf=\"usuarioLogado\"></feature-notification>\n  <feature-acessibilidade></feature-acessibilidade>\n  <feature-acessibilidade-contraste></feature-acessibilidade-contraste>\n  <workflow-task-list *ngIf=\"usuarioLogado && isModuloWorkflowAtivo\"/>\n  <notification-report-jasper *ngIf=\"showNotificationReport\"></notification-report-jasper>\n  <feature-user [showMinhaConta]=\"showMinhaConta\" [routeMe]=\"routeMe\" [getUsuarioLogado]=\"getUsuarioLogado\"\n    (logout)=\"onLogout()\" [showCreateUser]=\"showCreateUser\" [showCompetencia]=\"showCompetencia\"\n    [routeCreateUser]=\"routeCreateUser\" [renderParametros]=\"renderParametros\"\n    [goMinhaContaFunction]=\"goMinhaContaFunction\" [usuarioLogado]=\"usuarioLogado\">\n  </feature-user>\n  <feature-configuracao-entidade *ngIf=\"usuarioLogado && !configuracaoEntidadeKeycloak && renderParametros\"\n    [configuracaoEntidade]=\"configuracaoEntidade\" (onGetExercicios)=\"getExercicios($event)\"\n    (onCompetenciaSelecionada)=\"competenciaSelecionada($event)\" (onGetCompetencias)=\"getCompetencias($event)\"\n    [showCompetencia]=\"showCompetencia\" [showExercicio]=\"showExercicio\"></feature-configuracao-entidade>\n  <configuracao-entidade-keycloak *ngIf=\"usuarioLogado && configuracaoEntidadeKeycloak\"\n    [configuracaoEntidade]=\"configuracaoEntidade\" (onGetExercicios)=\"getExercicios($event)\"\n    (onGetCompetencias)=\"getCompetencias($event)\" [activeDataOperacaoField]=\"activeDataOperacaoField\">\n  </configuracao-entidade-keycloak>\n  <feature-contribuinte *ngIf=\"usuarioLogado\" [contribuinte]=\"contribuinte\"></feature-contribuinte>\n  <feature-user-sobre-sistema [getVersaoSobreSistema]=\"getVersaoSobreSistema\"\n    [getTotalAcessosSobreSistema]=\"getTotalAcessosSobreSistema\" [showNovidadesVersao]=\"true\"\n    [urlNovidades]=\"urlNovidades\">\n  </feature-user-sobre-sistema>\n</div>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FeatureTaskListWorkflowComponent, selector: "workflow-task-list" }, { kind: "component", type: FeatureUserComponent, selector: "feature-user", inputs: ["showMinhaConta", "showCreateUser", "routeMe", "routeCreateUser", "getUsuarioLogado", "renderParametros", "usuarioLogado", "showCompetencia", "goMinhaContaFunction"], outputs: ["logout"] }, { kind: "component", type: FeatureConfiguracaoEntidadeComponent, selector: "feature-configuracao-entidade", inputs: ["configuracaoEntidade", "showCompetencia", "showExercicio"], outputs: ["onGetExercicios", "onGetCompetencias", "onCompetenciaSelecionada", "onSetHeaderTitle"] }, { kind: "component", type: FeatureNotificationComponent, selector: "feature-notification" }, { kind: "component", type: ConfiguracaoEntidadeKeycloakComponent, selector: "configuracao-entidade-keycloak", inputs: ["configuracaoEntidade", "activeDataOperacaoField"], outputs: ["onGetExercicios", "onGetCompetencias", "onSetHeaderTitle"] }, { kind: "component", type: FeatureModulesComponent, selector: "feature-modules" }, { kind: "component", type: FeatureContribuinteComponent, selector: "feature-contribuinte", inputs: ["contribuinte"] }, { kind: "component", type: FeatureAcessibilidadeComponent, selector: "feature-acessibilidade" }, { kind: "component", type: FeatureAcessibilidadeContrasteComponent, selector: "feature-acessibilidade-contraste" }, { kind: "component", type: NotificationReportJasperComponent, selector: "notification-report-jasper" }, { kind: "component", type: FeatureSobreSistemaComponent, selector: "feature-user-sobre-sistema", inputs: ["getVersaoSobreSistema", "getTotalAcessosSobreSistema", "showNovidadesVersao", "urlNovidades"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeaturesGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-features-group', template: "<div class=\"features-group\" [class.new]=\"true\">\n  <feature-modules *ngIf=\"usuarioLogado && showModulos\"></feature-modules>\n  <feature-notification *ngIf=\"usuarioLogado\"></feature-notification>\n  <feature-acessibilidade></feature-acessibilidade>\n  <feature-acessibilidade-contraste></feature-acessibilidade-contraste>\n  <workflow-task-list *ngIf=\"usuarioLogado && isModuloWorkflowAtivo\"/>\n  <notification-report-jasper *ngIf=\"showNotificationReport\"></notification-report-jasper>\n  <feature-user [showMinhaConta]=\"showMinhaConta\" [routeMe]=\"routeMe\" [getUsuarioLogado]=\"getUsuarioLogado\"\n    (logout)=\"onLogout()\" [showCreateUser]=\"showCreateUser\" [showCompetencia]=\"showCompetencia\"\n    [routeCreateUser]=\"routeCreateUser\" [renderParametros]=\"renderParametros\"\n    [goMinhaContaFunction]=\"goMinhaContaFunction\" [usuarioLogado]=\"usuarioLogado\">\n  </feature-user>\n  <feature-configuracao-entidade *ngIf=\"usuarioLogado && !configuracaoEntidadeKeycloak && renderParametros\"\n    [configuracaoEntidade]=\"configuracaoEntidade\" (onGetExercicios)=\"getExercicios($event)\"\n    (onCompetenciaSelecionada)=\"competenciaSelecionada($event)\" (onGetCompetencias)=\"getCompetencias($event)\"\n    [showCompetencia]=\"showCompetencia\" [showExercicio]=\"showExercicio\"></feature-configuracao-entidade>\n  <configuracao-entidade-keycloak *ngIf=\"usuarioLogado && configuracaoEntidadeKeycloak\"\n    [configuracaoEntidade]=\"configuracaoEntidade\" (onGetExercicios)=\"getExercicios($event)\"\n    (onGetCompetencias)=\"getCompetencias($event)\" [activeDataOperacaoField]=\"activeDataOperacaoField\">\n  </configuracao-entidade-keycloak>\n  <feature-contribuinte *ngIf=\"usuarioLogado\" [contribuinte]=\"contribuinte\"></feature-contribuinte>\n  <feature-user-sobre-sistema [getVersaoSobreSistema]=\"getVersaoSobreSistema\"\n    [getTotalAcessosSobreSistema]=\"getTotalAcessosSobreSistema\" [showNovidadesVersao]=\"true\"\n    [urlNovidades]=\"urlNovidades\">\n  </feature-user-sobre-sistema>\n</div>" }]
        }], propDecorators: { logout: [{
                type: Output
            }], onGetExercicios: [{
                type: Output
            }], onGetCompetencias: [{
                type: Output
            }], onCompetenciaSelecionada: [{
                type: Output
            }], configuracaoEntidade: [{
                type: Input
            }], usuario: [{
                type: Input
            }], showMinhaConta: [{
                type: Input
            }], routeMe: [{
                type: Input
            }], contribuinte: [{
                type: Input
            }], showCreateUser: [{
                type: Input
            }], routeCreateUser: [{
                type: Input
            }], getUsuarioLogado: [{
                type: Input
            }], showCompetencia: [{
                type: Input
            }], showExercicio: [{
                type: Input
            }], configuracaoEntidadeKeycloak: [{
                type: Input
            }], showNotificationReport: [{
                type: Input
            }], activeDataOperacaoField: [{
                type: Input
            }], renderParametros: [{
                type: Input
            }], showModulos: [{
                type: Input
            }], goMinhaContaFunction: [{
                type: Input
            }], usuarioLogado: [{
                type: Input
            }], getVersaoSobreSistema: [{
                type: Input
            }], getTotalAcessosSobreSistema: [{
                type: Input
            }], showNovidadesVersao: [{
                type: Input
            }], urlNovidades: [{
                type: Input
            }], isModuloWorkflowAtivo: [{
                type: Input
            }] } });

class MonthNamePipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MonthNamePipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: MonthNamePipeModule, declarations: [MonthNamePipe], imports: [CommonModule], exports: [MonthNamePipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MonthNamePipeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MonthNamePipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [MonthNamePipe],
                    exports: [MonthNamePipe]
                }]
        }] });

class DigitalCertificateModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DigitalCertificateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DigitalCertificateModule, declarations: [DigitalCertificateComponent], imports: [CommonModule,
            PanelModule,
            FormsModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule,
            FormLabelColumnModule,
            DirectivesModule], exports: [DigitalCertificateComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DigitalCertificateModule, imports: [CommonModule,
            PanelModule,
            FormsModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule,
            FormLabelColumnModule,
            DirectivesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DigitalCertificateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PanelModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormControlValidationMsgModule,
                        FormLabelColumnModule,
                        DirectivesModule
                    ],
                    declarations: [DigitalCertificateComponent],
                    exports: [DigitalCertificateComponent]
                }]
        }] });

class EloModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloModalModule, declarations: [EloModalComponent], imports: [CommonModule], exports: [EloModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloModalModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [EloModalComponent],
                    exports: [EloModalComponent],
                    providers: [],
                }]
        }] });

class EloNotificationComponent {
    constructor(eloNotificationService, _zone) {
        this.eloNotificationService = eloNotificationService;
        this._zone = _zone;
        this.notifications = [];
        this.timeOut = 5000;
        this.eloNotificationService.notificationObservers.subscribe(notification => {
            this._zone.run(() => {
                this.notifications.push(notification);
                of(notification).pipe(delay(this.timeOut)).subscribe(notification => this.removeNotification(notification));
            });
        });
    }
    removeNotification(notification) {
        this.notifications.splice(this.notifications.indexOf(notification), 1);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNotificationComponent, deps: [{ token: EloNotificationService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloNotificationComponent, selector: "elo-notification", inputs: { timeOut: "timeOut" }, ngImport: i0, template: "<div class=\"notification-box\" style=\"z-index: 999999\">\n  <div *ngFor=\"let notification of notifications\" [class.positive]=\"notification.type === 0\"\n    [class.negative]=\"notification.type === 1\" [class.neutral]=\"notification.type === 2\"\n    class=\"notification-box-iten open\">\n    <span class=\"close\" (click)=\"removeNotification(notification)\"></span>\n\n    <h1 class=\"notification-box-title\" id=\"idNotificationBoxTitle\">\n      {{notification.title}}\n    </h1>\n    <p class=\"notification-box-text\" id=\"idNotificationBoxText\">\n      {{notification.content}}\n    </p>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNotificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-notification', template: "<div class=\"notification-box\" style=\"z-index: 999999\">\n  <div *ngFor=\"let notification of notifications\" [class.positive]=\"notification.type === 0\"\n    [class.negative]=\"notification.type === 1\" [class.neutral]=\"notification.type === 2\"\n    class=\"notification-box-iten open\">\n    <span class=\"close\" (click)=\"removeNotification(notification)\"></span>\n\n    <h1 class=\"notification-box-title\" id=\"idNotificationBoxTitle\">\n      {{notification.title}}\n    </h1>\n    <p class=\"notification-box-text\" id=\"idNotificationBoxText\">\n      {{notification.content}}\n    </p>\n  </div>\n</div>" }]
        }], ctorParameters: () => [{ type: EloNotificationService }, { type: i0.NgZone }], propDecorators: { timeOut: [{
                type: Input
            }] } });

class EloNotificationsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNotificationsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloNotificationsModule, declarations: [EloNotificationComponent], imports: [CommonModule], exports: [EloNotificationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNotificationsModule, providers: [EloNotificationService], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloNotificationsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [EloNotificationComponent],
                    providers: [EloNotificationService],
                    exports: [EloNotificationComponent]
                }]
        }] });

class FeaturesGroupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeaturesGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FeaturesGroupModule, declarations: [FeaturesGroupComponent,
            FeatureUserComponent,
            FeatureConfiguracaoEntidadeComponent,
            FeatureNotificationComponent,
            FeatureNotificationMessageComponent,
            ConfiguracaoEntidadeKeycloakComponent,
            FeatureModulesComponent,
            FeatureContribuinteComponent,
            FeatureAcessibilidadeComponent,
            FeatureAcessibilidadeContrasteComponent,
            NotificationReportJasperComponent,
            FeatureSobreSistemaComponent], imports: [CommonModule,
            MonthNamePipeModule,
            HttpClientModule,
            DigitalCertificateModule,
            DialogModule,
            RouterModule,
            EloModalModule,
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            EloNotificationsModule,
            DatePickerModule,
            PipeModule,
            InfiniteScrollModule,
            FeatureTaskListWorkflowComponent], exports: [FeaturesGroupComponent,
            FeatureModulesComponent,
            FeatureUserComponent,
            FeatureConfiguracaoEntidadeComponent,
            ConfiguracaoEntidadeKeycloakComponent,
            FeatureNotificationComponent,
            FeatureNotificationMessageComponent,
            FeatureContribuinteComponent,
            FeatureAcessibilidadeComponent,
            FeatureAcessibilidadeContrasteComponent,
            NotificationReportJasperComponent,
            FeatureSobreSistemaComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeaturesGroupModule, providers: [ListaModulosService, ConfiguracaoEntidadeKeycloakService, FeatureSobreSistemaService], imports: [CommonModule,
            MonthNamePipeModule,
            HttpClientModule,
            DigitalCertificateModule,
            DialogModule,
            RouterModule,
            EloModalModule,
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            EloNotificationsModule,
            DatePickerModule,
            PipeModule,
            InfiniteScrollModule,
            FeatureTaskListWorkflowComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FeaturesGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MonthNamePipeModule,
                        HttpClientModule,
                        DigitalCertificateModule,
                        DialogModule,
                        RouterModule,
                        EloModalModule,
                        BrowserModule,
                        FormsModule,
                        ReactiveFormsModule,
                        EloNotificationsModule,
                        DatePickerModule,
                        PipeModule,
                        InfiniteScrollModule,
                        FeatureTaskListWorkflowComponent
                    ],
                    declarations: [
                        FeaturesGroupComponent,
                        FeatureUserComponent,
                        FeatureConfiguracaoEntidadeComponent,
                        FeatureNotificationComponent,
                        FeatureNotificationMessageComponent,
                        ConfiguracaoEntidadeKeycloakComponent,
                        FeatureModulesComponent,
                        FeatureContribuinteComponent,
                        FeatureAcessibilidadeComponent,
                        FeatureAcessibilidadeContrasteComponent,
                        NotificationReportJasperComponent,
                        FeatureSobreSistemaComponent,
                    ],
                    providers: [ListaModulosService, ConfiguracaoEntidadeKeycloakService, FeatureSobreSistemaService],
                    exports: [
                        FeaturesGroupComponent,
                        FeatureModulesComponent,
                        FeatureUserComponent,
                        FeatureConfiguracaoEntidadeComponent,
                        ConfiguracaoEntidadeKeycloakComponent,
                        FeatureNotificationComponent,
                        FeatureNotificationMessageComponent,
                        FeatureContribuinteComponent,
                        FeatureAcessibilidadeComponent,
                        FeatureAcessibilidadeContrasteComponent,
                        NotificationReportJasperComponent,
                        FeatureSobreSistemaComponent,
                    ],
                }]
        }] });

class FileUploadComponent {
    constructor(eloNotificationService) {
        this.eloNotificationService = eloNotificationService;
        this.requiredMessage = '(requerido)';
        this.invalid = false;
        this.invalidMessage = 'Tipo do arquivo não permitido';
        this.fileSelected = null;
        this.allowedFileType = [];
        this.required = false;
        this.maxLengthNameFile = 28;
        this.multipartForm = false;
        this.defaultMessage = 'Clique ou arraste para anexar';
        this.onChangeFile = new EventEmitter();
        this.onChange = null;
        this.onTouched = null;
    }
    ngOnInit() {
        this.showRequiredMessage = this.required;
    }
    handleInputChange(event) {
        const file = event.target.files[0];
        if (file) {
            let name = file.name;
            let extension = name.substr(name.lastIndexOf('.') + 1);
            if (this.allowedFileType.length) {
                let allowFileTypeFormatted = this.formatAllowedFileType();
                let isSuccess = this.allowedFileType.indexOf(extension) > -1;
                if (!isSuccess) {
                    this.eloNotificationService.error('Tipo de arquivo não permitido!', 'Tipos aceitos: ' + allowFileTypeFormatted);
                    this.invalid = true;
                    this.clear();
                    return;
                }
            }
            let reader = new FileReader();
            reader.onloadend = () => {
                let name = file.name;
                this.fileSelected = {};
                this.fileSelected.name = name;
                this.fileSelected.fileNameFormated = name && name.length > this.maxLengthNameFile ?
                    this.formatString(name) : name;
                const result = reader.result;
                this.fileSelected.file = result.substring(result.indexOf(',') + 1, result.length);
                this.showRequiredMessage = (this.required &&
                    this.fileSelected.name.toString().length <= 0);
                if (this.multipartForm) {
                    this.emitOnChangeFile(file);
                }
                else {
                    this.emitOnChangeFile(this.fileSelected);
                }
            };
            this.reset();
            reader.readAsDataURL(file);
        }
    }
    formatString(nameFile) {
        let extension = nameFile.substr(nameFile.lastIndexOf('.') + 1);
        return nameFile.substr(0, (this.maxLengthNameFile - extension.length)) + '.' + extension;
    }
    formatAllowedFileType() {
        let allowedFileTypeFormatted = '';
        this.allowedFileType.map((type, index) => {
            if (index === 0) {
                allowedFileTypeFormatted += type;
            }
            else if (index === this.allowedFileType.length - 1) {
                allowedFileTypeFormatted += ' e ' + type + '.';
            }
            else {
                allowedFileTypeFormatted = allowedFileTypeFormatted ? allowedFileTypeFormatted += ', ' + type : type;
            }
        });
        return allowedFileTypeFormatted;
    }
    clear() {
        const hasFileSelected = !!this.fileSelected;
        this.showRequiredMessage = this.required;
        this.fileSelected = null;
        this.fileInput.nativeElement.value = '';
        if (hasFileSelected) {
            this.emitOnChangeFile(this.fileSelected);
        }
    }
    reset() {
        this.invalid = false;
    }
    writeValue(obj) {
        if (obj) {
            this.fileSelected = obj;
        }
        else {
            this.fileSelected = null;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    emitOnChangeFile(value) {
        this.onChange(value);
        this.onChangeFile.emit(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadComponent, deps: [{ token: EloNotificationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FileUploadComponent, selector: "file-upload", inputs: { showRequiredMessage: "showRequiredMessage", allowedFileType: "allowedFileType", required: "required", maxLengthNameFile: "maxLengthNameFile", multipartForm: "multipartForm", defaultMessage: "defaultMessage" }, outputs: { onChangeFile: "onChangeFile" }, providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: FileUploadComponent }
        ], viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["file"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"file-uploader\" [class.error]=\"invalid\" [class.onselect]=\"fileSelected\">\n    <input #file type=\"file\" class=\"file-uploader-input\" id=\"inputFile\" (change)=\"handleInputChange($event)\" [attr.data-title]=\"fileSelected ? fileSelected.fileNameFormated : defaultMessage\" [title]=\"fileSelected ? fileSelected.fileNameFormated : defaultMessage\">\n    <label\n        for=\"inputFile\"\n        class=\"input\"\n        [attr.data-title]=\"fileSelected ? fileSelected.fileNameFormated : defaultMessage\"\n    ></label>\n    <label for=\"inputFile\" class=\"file-uploader-icon\" (click)=\"clear()\"></label>\n</div>\n<span class=\"help-message\" *ngIf=\"showRequiredMessage || invalid\"> {{ invalid ? invalidMessage : showRequiredMessage ? requiredMessage : '' }} </span>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'file-upload', providers: [
                        { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: FileUploadComponent }
                    ], template: "<div class=\"file-uploader\" [class.error]=\"invalid\" [class.onselect]=\"fileSelected\">\n    <input #file type=\"file\" class=\"file-uploader-input\" id=\"inputFile\" (change)=\"handleInputChange($event)\" [attr.data-title]=\"fileSelected ? fileSelected.fileNameFormated : defaultMessage\" [title]=\"fileSelected ? fileSelected.fileNameFormated : defaultMessage\">\n    <label\n        for=\"inputFile\"\n        class=\"input\"\n        [attr.data-title]=\"fileSelected ? fileSelected.fileNameFormated : defaultMessage\"\n    ></label>\n    <label for=\"inputFile\" class=\"file-uploader-icon\" (click)=\"clear()\"></label>\n</div>\n<span class=\"help-message\" *ngIf=\"showRequiredMessage || invalid\"> {{ invalid ? invalidMessage : showRequiredMessage ? requiredMessage : '' }} </span>\n" }]
        }], ctorParameters: () => [{ type: EloNotificationService }], propDecorators: { showRequiredMessage: [{
                type: Input
            }], fileInput: [{
                type: ViewChild,
                args: ['file', { static: true }]
            }], allowedFileType: [{
                type: Input
            }], required: [{
                type: Input
            }], maxLengthNameFile: [{
                type: Input
            }], multipartForm: [{
                type: Input
            }], defaultMessage: [{
                type: Input
            }], onChangeFile: [{
                type: Output
            }] } });

class FileUploadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FileUploadModule, declarations: [FileUploadComponent], imports: [CommonModule], exports: [FileUploadComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [FileUploadComponent],
                    exports: [FileUploadComponent]
                }]
        }] });

class EloSimpleFilterComponent {
    constructor() {
        this.placeHolder = 'Digite o filtro...';
        this.buttonDescription = 'Filtrar';
        this.classFilter = 'filter'; // 'filter' | 'search';
        this.maxlength = null;
        /**
         Permite apenas que números positivos sejam digitados, não permite caracteres especiais, letras, ou números negativos
         */
        this.onlyPositiveNumber = false;
        this.required = false;
        this.inputType = 'text';
        this.onClickButtonFilter = new EventEmitter();
        /**
         * Evento disparado ao digitar algo no input
         */
        this.onChangeInput = new EventEmitter();
    }
    clickButtonFiltrar() {
        this.onClickButtonFilter.emit(this.inputFilter);
    }
    changeInput(inputChanged) {
        this.inputFilter = inputChanged;
        this.onChangeInput.emit(inputChanged);
    }
    keyPressEnter() {
        if (this.required && !this.inputFilter) {
            return;
        }
        this.clickButtonFiltrar();
    }
    ngAfterViewChecked() {
        if (document.getElementById('btnFilter')) {
            let btnWidth = document.getElementById('btnFilter').clientWidth;
            document.getElementById('input-filter').style.width = 'calc(100% - ' + btnWidth + 'px)';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloSimpleFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloSimpleFilterComponent, selector: "elo-simple-filter", inputs: { placeHolder: "placeHolder", buttonDescription: "buttonDescription", classFilter: "classFilter", maxlength: "maxlength", onlyPositiveNumber: "onlyPositiveNumber", required: "required", inputType: "inputType", inputFilter: "inputFilter" }, outputs: { onClickButtonFilter: "onClickButtonFilter", onChangeInput: "onChangeInput" }, ngImport: i0, template: "<div>\n  <input\n    [class.hidden]=\"onlyPositiveNumber\"\n    autofocus\n    id=\"input-filter\"\n    placeholder=\"{{placeHolder}}\"\n    [(ngModel)]=\"inputFilter\"\n    class=\"button-input\"\n    [required]=\"required\"\n    (ngModelChange)=\"changeInput($event)\"\n    (keyup.enter)=\"keyPressEnter()\"\n    maxlength=\"{{maxlength}}\"\n    type=\"{{inputType}}\">\n\n  <input\n    [class.hidden]=\"!onlyPositiveNumber\"\n    type=\"text\"\n    eloNumber\n    [thousands]=\"''\"\n    [align]=\"'left'\" id=\"input-filter\"\n    class=\"button-input\"\n    autofocus\n    placeholder=\"{{placeHolder}}\"\n    [(ngModel)]=\"inputFilter\"\n    [required]=\"required\"\n    (ngModelChange)=\"changeInput($event)\" (keyup.enter)=\"keyPressEnter()\" maxlength=\"{{maxlength}}\">\n\n  <button id=\"btnFilter\" class=\"btn {{classFilter}}\" [disabled]=\"required && !inputFilter\" (click)=\"clickButtonFiltrar()\">{{buttonDescription}}</button>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1$2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: EloNumberDirective, selector: "[eloNumber]", inputs: ["allowNegative", "prefix", "suffix", "align", "precision", "thousands"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloSimpleFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-simple-filter', template: "<div>\n  <input\n    [class.hidden]=\"onlyPositiveNumber\"\n    autofocus\n    id=\"input-filter\"\n    placeholder=\"{{placeHolder}}\"\n    [(ngModel)]=\"inputFilter\"\n    class=\"button-input\"\n    [required]=\"required\"\n    (ngModelChange)=\"changeInput($event)\"\n    (keyup.enter)=\"keyPressEnter()\"\n    maxlength=\"{{maxlength}}\"\n    type=\"{{inputType}}\">\n\n  <input\n    [class.hidden]=\"!onlyPositiveNumber\"\n    type=\"text\"\n    eloNumber\n    [thousands]=\"''\"\n    [align]=\"'left'\" id=\"input-filter\"\n    class=\"button-input\"\n    autofocus\n    placeholder=\"{{placeHolder}}\"\n    [(ngModel)]=\"inputFilter\"\n    [required]=\"required\"\n    (ngModelChange)=\"changeInput($event)\" (keyup.enter)=\"keyPressEnter()\" maxlength=\"{{maxlength}}\">\n\n  <button id=\"btnFilter\" class=\"btn {{classFilter}}\" [disabled]=\"required && !inputFilter\" (click)=\"clickButtonFiltrar()\">{{buttonDescription}}</button>\n</div>\n" }]
        }], propDecorators: { placeHolder: [{
                type: Input
            }], buttonDescription: [{
                type: Input
            }], classFilter: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], onlyPositiveNumber: [{
                type: Input
            }], required: [{
                type: Input
            }], inputType: [{
                type: Input
            }], onClickButtonFilter: [{
                type: Output
            }], onChangeInput: [{
                type: Output
            }], inputFilter: [{
                type: Input
            }] } });

class EloFilterComponent {
    constructor() {
        /**
         Permite apenas que números positivos sejam digitados, não permite caracteres especiais, letras, ou números negativos
         */
        this.onlyPositiveNumber = false;
        this.required = false;
        this.classFilter = 'filter'; // 'filter' | 'search';
        this.buttonDescription = 'Filtrar';
        this.maxlength = 18;
        this.onClickButtonFilter = new EventEmitter();
        this.placeHolder = 'Digite o filtro...';
        this.inputType = 'text';
        this.inputFilter = '';
        /**
         * Evento disparado ao alterar o select (combobox)
         */
        this.onChangeSelect = new EventEmitter();
        /**
         * Evento disparado ao alterar o input
         */
        this.onChangeInput = new EventEmitter();
        /**
         * Evento disparado ao alterar tanto o select quanto o input text
         */
        this.onChange = new EventEmitter();
    }
    clickButtonFiltrar() {
        let filter = { selectedValue: this.selectedValue, inputFilter: this.inputFilter };
        this.onClickButtonFilter.emit(filter);
    }
    selectChange(selectedValue) {
        this.selectedValue = selectedValue;
        this.onChangeSelect.emit(selectedValue);
        this.onChange.emit(selectedValue);
    }
    changeInput(changeInput) {
        this.inputFilter = changeInput;
        this.onChangeInput.emit(changeInput);
        this.onChange.emit(changeInput);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloFilterComponent, selector: "elo-filter", inputs: { onlyPositiveNumber: "onlyPositiveNumber", required: "required", classFilter: "classFilter", options: "options", selectedValue: "selectedValue", buttonDescription: "buttonDescription", maxlength: "maxlength", placeHolder: "placeHolder", table: "table", inputType: "inputType", inputFilter: "inputFilter" }, outputs: { onClickButtonFilter: "onClickButtonFilter", onChangeSelect: "onChangeSelect", onChangeInput: "onChangeInput", onChange: "onChange" }, ngImport: i0, template: "<div [ngClass]=\"{'panel-table-filter': table, 'panel-filter' : !table}\">\n  <div class=\"row\">\n\n    <div class=\"col-sm-4\">\n      <div class=\"form-group\">\n        <elo-select [options]=\"options\"\n                    [selectedValue]=\"selectedValue\"\n                    (onSelectChange)=\"selectChange($event)\">\n        </elo-select>\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\">\n      <div class=\"form-group\">\n        <elo-simple-filter\n          [onlyPositiveNumber]=\"onlyPositiveNumber\"\n          [classFilter]=\"classFilter\"\n          [maxlength]=\"maxlength\"\n          [required]=\"required\"\n          [placeHolder]=\"placeHolder\"\n          [inputFilter]=\"inputFilter\"\n          (onClickButtonFilter)=\"clickButtonFiltrar()\"\n          (onChangeInput)=\"changeInput($event)\"\n          buttonDescription= {{buttonDescription}}\n          [inputType]=\"inputType\">\n        </elo-simple-filter>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: EloSelectComponent, selector: "elo-select", inputs: ["selectedValue", "options", "required", "compareWith"], outputs: ["onSelectChange"] }, { kind: "component", type: EloSimpleFilterComponent, selector: "elo-simple-filter", inputs: ["placeHolder", "buttonDescription", "classFilter", "maxlength", "onlyPositiveNumber", "required", "inputType", "inputFilter"], outputs: ["onClickButtonFilter", "onChangeInput"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-filter', template: "<div [ngClass]=\"{'panel-table-filter': table, 'panel-filter' : !table}\">\n  <div class=\"row\">\n\n    <div class=\"col-sm-4\">\n      <div class=\"form-group\">\n        <elo-select [options]=\"options\"\n                    [selectedValue]=\"selectedValue\"\n                    (onSelectChange)=\"selectChange($event)\">\n        </elo-select>\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\">\n      <div class=\"form-group\">\n        <elo-simple-filter\n          [onlyPositiveNumber]=\"onlyPositiveNumber\"\n          [classFilter]=\"classFilter\"\n          [maxlength]=\"maxlength\"\n          [required]=\"required\"\n          [placeHolder]=\"placeHolder\"\n          [inputFilter]=\"inputFilter\"\n          (onClickButtonFilter)=\"clickButtonFiltrar()\"\n          (onChangeInput)=\"changeInput($event)\"\n          buttonDescription= {{buttonDescription}}\n          [inputType]=\"inputType\">\n        </elo-simple-filter>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n" }]
        }], propDecorators: { onlyPositiveNumber: [{
                type: Input
            }], required: [{
                type: Input
            }], classFilter: [{
                type: Input
            }], options: [{
                type: Input
            }], selectedValue: [{
                type: Input
            }], buttonDescription: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], onClickButtonFilter: [{
                type: Output
            }], placeHolder: [{
                type: Input
            }], table: [{
                type: Input
            }], inputType: [{
                type: Input
            }], inputFilter: [{
                type: Input
            }], onChangeSelect: [{
                type: Output
            }], onChangeInput: [{
                type: Output
            }], onChange: [{
                type: Output
            }] } });

class EloFilterModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloFilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloFilterModule, declarations: [EloFilterComponent, EloSimpleFilterComponent], imports: [CommonModule, FormsModule, ReactiveFormsModule, EloSelectModule, DirectivesModule], exports: [EloFilterComponent, EloSimpleFilterComponent, EloSelectModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloFilterModule, imports: [CommonModule, FormsModule, ReactiveFormsModule, EloSelectModule, DirectivesModule, EloSelectModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloFilterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, ReactiveFormsModule, EloSelectModule, DirectivesModule],
                    declarations: [EloFilterComponent, EloSimpleFilterComponent],
                    exports: [EloFilterComponent, EloSimpleFilterComponent, EloSelectModule],
                    providers: []
                }]
        }] });

class FloatButtonComponent {
    constructor() {
        this.hover = false;
    }
    clickMenu() {
        this.hover = !this.hover;
    }
    mouseEnter() {
        if (window.innerWidth > 991)
            this.hover = true;
    }
    mouseLeave() {
        this.hover = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FloatButtonComponent, selector: "float-button", inputs: { hintContent: "hintContent" }, ngImport: i0, template: "<div id=\"idFloatButton\" class=\"btn-save vertical-options\" (click)=\"clickMenu()\" (mouseenter)='mouseEnter()'\n  (mouseleave)=\"mouseLeave()\" [class.hover]=\"hover\">\n  <div class=\"options\">\n    <ng-content></ng-content>\n  </div>\n  <button class=\"btn hint fa fa-ellipsis-v module-color hideHintOnMobile\" type=\"button\">\n    <div class=\"hint-content\" *ngIf=\"hintContent\">{{ hintContent }}</div>\n  </button>\n</div>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'float-button', template: "<div id=\"idFloatButton\" class=\"btn-save vertical-options\" (click)=\"clickMenu()\" (mouseenter)='mouseEnter()'\n  (mouseleave)=\"mouseLeave()\" [class.hover]=\"hover\">\n  <div class=\"options\">\n    <ng-content></ng-content>\n  </div>\n  <button class=\"btn hint fa fa-ellipsis-v module-color hideHintOnMobile\" type=\"button\">\n    <div class=\"hint-content\" *ngIf=\"hintContent\">{{ hintContent }}</div>\n  </button>\n</div>" }]
        }], propDecorators: { hintContent: [{
                type: Input
            }] } });

class FloatButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FloatButtonModule, declarations: [FloatButtonComponent], imports: [CommonModule], exports: [FloatButtonComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatButtonModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [FloatButtonComponent],
                    exports: [FloatButtonComponent]
                }]
        }] });

class FloatSidebarService {
    constructor() {
        this.onOpenSideBar = new Subject();
        this.onEventToOpen = this.onOpenSideBar.asObservable();
    }
    openFloatSideBar() {
        this.onOpenSideBar.next({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatSidebarService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatSidebarService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatSidebarService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

class FloatSideBarComponent {
    static { this.DISTANCIA_MAX_MOUSE = 50; }
    constructor(floatSidebarService) {
        this.floatSidebarService = floatSidebarService;
        this.titleDef = '';
        this.icon = '';
        this.active = false;
        this.moving = false;
        this.currentY = 0;
        this.initialY = 0;
        this.initialX = 0;
        this.hasMoved = false;
    }
    ngOnInit() {
        this.floatSidebarService.onEventToOpen.subscribe(() => setTimeout(() => this.active = true, 0));
    }
    showSideBar() {
        if (!this.hasMoved) {
            this.active = !this.active;
        }
        this.hasMoved = false;
    }
    onResize() {
        this.openButton.nativeElement.style.top = '0px';
    }
    mouseDown(e) {
        this.initialX = e.clientX;
        this.initialY = e.clientY;
        this.moving = true;
    }
    mouseMove(e) {
        if (this.moving) {
            e.preventDefault();
            const sidebar = this.floatSidebar.nativeElement;
            if (e.clientY < sidebar.clientHeight + sidebar.offsetTop
                && e.clientX > this.initialX - FloatSideBarComponent.DISTANCIA_MAX_MOUSE
                && e.clientY > sidebar.offsetTop + FloatSideBarComponent.DISTANCIA_MAX_MOUSE) {
                this.currentY = this.initialY - e.clientY;
                this.initialY = e.clientY;
                this._calcularPosicao();
                if (e.clientX !== this.initialX)
                    this.hasMoved = true;
            }
            else {
                this.hasMoved = false;
                this.moving = false;
            }
        }
    }
    onClick(event) {
        if (this.active) {
            const { offsetTop, offsetLeft } = this.floatSidebar.nativeElement;
            const clickedInside = event.clientX + 35 > offsetLeft && event.clientY > offsetTop;
            if (!clickedInside) {
                this.active = false;
            }
        }
    }
    _calcularPosicao() {
        const offsetFinal = (this.openButton.nativeElement.offsetTop - this.currentY);
        const limiteTopo = ((window.innerHeight - 230) / 2) + offsetFinal;
        const limiteRodape = ((window.innerHeight + 130) / 2) + offsetFinal;
        const offSetAnterior = this.openButton.nativeElement.style.top.replace('px', '');
        if (offSetAnterior !== offsetFinal && limiteTopo > 0 && limiteRodape < window.innerHeight) {
            this.openButton.nativeElement.style.top = offsetFinal + 'px';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatSideBarComponent, deps: [{ token: FloatSidebarService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FloatSideBarComponent, selector: "float-sidebar", inputs: { titleDef: "titleDef", icon: "icon", hintTemplate: "hintTemplate", containerTemplate: "containerTemplate" }, host: { listeners: { "window:resize": "onResize()", "document:mousemove": "mouseMove($event)", "document:click": "onClick($event)" } }, viewQueries: [{ propertyName: "openButton", first: true, predicate: ["openButton"], descendants: true, static: true }, { propertyName: "floatSidebar", first: true, predicate: ["floatSidebar"], descendants: true, static: true }, { propertyName: "container", first: true, predicate: ["container"], descendants: true }], ngImport: i0, template: "<div #floatSidebar class=\"float-sidebar\" [class.active]=\"active\">\n  <div id=\"open-button\" #openButton [ngClass]=\"icon\" class=\"float-button hint center-right module-color\"\n    (click)=\"showSideBar()\" (mousedown)=\"mouseDown($event)\" (mouseup)=\"moving = false\">\n    <div class=\"hint-content\">\n      <ng-container *ngTemplateOutlet=\"hintTemplate\"></ng-container>\n    </div>\n  </div>\n  <div class=\"title\">{{ titleDef }}</div>\n  <div class=\"container\">\n    <ng-container *ngTemplateOutlet=\"containerTemplate\"></ng-container>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatSideBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'float-sidebar', template: "<div #floatSidebar class=\"float-sidebar\" [class.active]=\"active\">\n  <div id=\"open-button\" #openButton [ngClass]=\"icon\" class=\"float-button hint center-right module-color\"\n    (click)=\"showSideBar()\" (mousedown)=\"mouseDown($event)\" (mouseup)=\"moving = false\">\n    <div class=\"hint-content\">\n      <ng-container *ngTemplateOutlet=\"hintTemplate\"></ng-container>\n    </div>\n  </div>\n  <div class=\"title\">{{ titleDef }}</div>\n  <div class=\"container\">\n    <ng-container *ngTemplateOutlet=\"containerTemplate\"></ng-container>\n  </div>\n</div>" }]
        }], ctorParameters: () => [{ type: FloatSidebarService }], propDecorators: { titleDef: [{
                type: Input
            }], icon: [{
                type: Input
            }], hintTemplate: [{
                type: Input
            }], containerTemplate: [{
                type: Input
            }], openButton: [{
                type: ViewChild,
                args: ['openButton', { static: true }]
            }], floatSidebar: [{
                type: ViewChild,
                args: ['floatSidebar', { static: true }]
            }], container: [{
                type: ViewChild,
                args: ['container']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }], mouseMove: [{
                type: HostListener,
                args: ['document:mousemove', ['$event']]
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class FloatSideBarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatSideBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FloatSideBarModule, declarations: [FloatSideBarComponent], imports: [CommonModule], exports: [FloatSideBarComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatSideBarModule, providers: [FloatSidebarService], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FloatSideBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule,],
                    declarations: [FloatSideBarComponent],
                    exports: [FloatSideBarComponent],
                    providers: [FloatSidebarService]
                }]
        }] });

class FooterService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.resource = '/actuator/info';
    }
    findBuildVersion() {
        return this.httpClient.get({ resource: this.resource });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FooterService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FooterService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FooterService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

class HeaderTitle {
    toString() {
        let headerTitleToString = '';
        if (this.nomeEntidade) {
            headerTitleToString = headerTitleToString + this.nomeEntidade;
        }
        if (this.competencia) {
            headerTitleToString = headerTitleToString + ' - ' + this.competencia;
        }
        if (this.exercicio) {
            headerTitleToString = headerTitleToString + '/' + this.exercicio;
        }
        return headerTitleToString;
    }
}

class SubscriptionWebsocket {
    constructor(socket, key) {
        this.socket = socket;
        this.key = key;
    }
    subscribe(callback) {
        this.subscribeStatus = true;
        this.socket.getInstance().on(this.key, response => {
            const obj = JSON.parse(response[0]);
            callback(obj);
        });
        return this;
    }
    unsubscribe() {
        this.subscribeStatus = false;
        this.socket.getInstance().off(this.key);
    }
    get isSubscribed() {
        return this.subscribed;
    }
    set subscribeStatus(subscribed) {
        this.subscribed = subscribed;
    }
}

class WebsocketService {
    constructor() {
        this.ioFunction = io;
    }
    static { this.socketInstance = null; }
    getInstance() {
        if (!WebsocketService.socketInstance) {
            WebsocketService.socketInstance = this.ioFunction('', {
                path: '/socket_api_socket',
                transports: ['websocket'],
                auth: { 'id': '1511ae76' }
            });
        }
        return WebsocketService.socketInstance;
    }
    fromEvent(key) {
        return new SubscriptionWebsocket(this, key);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WebsocketService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WebsocketService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WebsocketService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/* eslint-disable @angular-eslint/component-selector */
class NotificationSystemComponent {
    constructor(featureModuleStateService, notificationSystemService, abstractAuthHttp, websocketService) {
        this.featureModuleStateService = featureModuleStateService;
        this.notificationSystemService = notificationSystemService;
        this.abstractAuthHttp = abstractAuthHttp;
        this.websocketService = websocketService;
        this.notReadedCounter = 0;
        this.loadMessagesCallBack = () => this.loadMessages();
    }
    ngOnInit() {
        this.abstractAuthHttp.getUsuario().then(usuario => this.initListening(usuario));
        this.notificationSystemService.counterChanged.subscribe(counter => this.notReadedCounter = counter);
    }
    initListening(user) {
        this.websocketService.getInstance().on(this.topicFromUser(user), this.loadMessagesCallBack);
        this.loadMessages();
    }
    topicFromUser(user) {
        return `${UrlUtils.getTenant()}_${user.username ? user.username : user.preferred_username}`;
    }
    loadMessages() {
        combineLatest([this.notificationSystemService.findPage(), this.notificationSystemService.countNotReaded()])
            .subscribe(data => this.attrNotifications(data[0], data[1]?.count));
    }
    attrNotifications(notifications, counter) {
        this.notificationSystemService.counterChanged.next(counter);
        this.featureModuleStateService.notificationsSource.next(notifications);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationSystemComponent, deps: [{ token: FeatureModuleStateService }, { token: NotificationSystemService }, { token: AbstractAuthHttp }, { token: WebsocketService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NotificationSystemComponent, selector: "[notification-system]", ngImport: i0, template: "<i id=\"class-notification\" class=\"fa fa-bell\"></i>\n<span *ngIf=\"notReadedCounter\" id=\"span-notification\" class=\"bubble-notification\" style=\"left: calc(50% - 19px);\">{{notReadedCounter}}</span>\n<small id=\"text-notification\" class=\"hidden-xs\">Notifica\u00E7\u00F5es</small>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationSystemComponent, decorators: [{
            type: Component,
            args: [{ selector: '[notification-system]', template: "<i id=\"class-notification\" class=\"fa fa-bell\"></i>\n<span *ngIf=\"notReadedCounter\" id=\"span-notification\" class=\"bubble-notification\" style=\"left: calc(50% - 19px);\">{{notReadedCounter}}</span>\n<small id=\"text-notification\" class=\"hidden-xs\">Notifica\u00E7\u00F5es</small>" }]
        }], ctorParameters: () => [{ type: FeatureModuleStateService }, { type: NotificationSystemService }, { type: AbstractAuthHttp }, { type: WebsocketService }] });

class TaskListPendingCounterComponent {
    constructor(featureTaskCounterService) {
        this.featureTaskCounterService = featureTaskCounterService;
        this.pendingTasks = 0;
        this.$destroy = new Subject();
    }
    ngOnDestroy() {
        this.$destroy.next();
        this.$destroy.complete();
    }
    ngOnInit() {
        this.featureTaskCounterService.counter$
            .pipe(takeUntil(this.$destroy))
            .subscribe(counter => this.pendingTasks = counter);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TaskListPendingCounterComponent, deps: [{ token: FeatureTaskListCounterService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TaskListPendingCounterComponent, isStandalone: true, selector: "[taskListPendingCounter]", ngImport: i0, template: `
        <i class="fa fa-tasks" id="tasks" aria-hidden="true"></i>
        <span *ngIf="pendingTasks != 0" id="tasks" class="bubble-notification" style="left: calc(50% - 19px);">{{ pendingTasks }}</span>
        <small class="hidden-xs" id="tasks">Tarefas</small>
    `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TaskListPendingCounterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[taskListPendingCounter]',
                    standalone: true,
                    imports: [
                        CommonModule
                    ],
                    template: `
        <i class="fa fa-tasks" id="tasks" aria-hidden="true"></i>
        <span *ngIf="pendingTasks != 0" id="tasks" class="bubble-notification" style="left: calc(50% - 19px);">{{ pendingTasks }}</span>
        <small class="hidden-xs" id="tasks">Tarefas</small>
    `
                }]
        }], ctorParameters: () => [{ type: FeatureTaskListCounterService }] });

class HeaderComponent {
    constructor(featureModuleStateService, sanitizer, httpClient) {
        this.featureModuleStateService = featureModuleStateService;
        this.sanitizer = sanitizer;
        this.httpClient = httpClient;
        this.headerTitle = '';
        this.headerSubtitle = '';
        this.nomeCidadeEntidade = new HeaderTitle();
        this.toggled = false;
        this.visibleUser = false;
        this.visibleContribuinte = false;
        this.visibleConfiguracaoEntidadeMenu = false;
        this.visibleModules = false;
        this.visibleAcessibilidade = false;
        this.visibleNotifications = false;
        this.visibleNotificationsReportJasper = false;
        this.visibleTaskListWorkflow = false;
        this.visibleNotificationConfiguracaoEntidade = false;
        this.visibleConfigEntidade = false;
        this.flex = false;
        this.activeOldColor = false;
        this.onClickToToggled = new EventEmitter();
        this.defaultHeaderClickFeature = 'configuracaoEntidade';
        this.logoOxy = false;
        this.fancy = false;
    }
    ngOnInit() {
        if (this.imgModuleRebranding) {
            let httpHeader = new HttpHeaders({
                'Content-Type': 'image/svg+xml'
            });
            this.httpClient.get(this.imgModuleRebranding, { headers: httpHeader, responseType: 'text' }).subscribe(data => {
                this.htmlRender = this.sanitizer.bypassSecurityTrustHtml(data);
            });
        }
    }
    onClickToggledButton() {
        this.onClickToToggled.emit();
    }
    onClick(feature) {
        this.item = feature;
        this.featureModuleStateService.alternateStatus(feature);
    }
    clickedOutside($event) {
        if (this.item) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents && parents.length > 0 && parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map(parent => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('features')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.item !== '')
                this.item = '';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderComponent, deps: [{ token: FeatureModuleStateService }, { token: i1$3.DomSanitizer }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: HeaderComponent, selector: "elo-header", inputs: { headerTitle: "headerTitle", headerSubtitle: "headerSubtitle", nomeCidadeEntidade: "nomeCidadeEntidade", toggled: "toggled", visibleUser: "visibleUser", visibleContribuinte: "visibleContribuinte", visibleConfiguracaoEntidadeMenu: "visibleConfiguracaoEntidadeMenu", visibleModules: "visibleModules", visibleAcessibilidade: "visibleAcessibilidade", visibleNotifications: "visibleNotifications", visibleNotificationsReportJasper: "visibleNotificationsReportJasper", visibleTaskListWorkflow: "visibleTaskListWorkflow", visibleNotificationConfiguracaoEntidade: "visibleNotificationConfiguracaoEntidade", brasaoByteArray: "brasaoByteArray", visibleConfigEntidade: "visibleConfigEntidade", flex: "flex", activeOldColor: "activeOldColor", imgModuleMain: "imgModuleMain", imgModule: "imgModule", imgModuleRebranding: "imgModuleRebranding", nameModule: "nameModule", defaultHeaderClickFeature: "defaultHeaderClickFeature", logoOxy: "logoOxy", fancy: "fancy" }, outputs: { onClickToToggled: "onClickToToggled" }, host: { listeners: { "document:click": "clickedOutside($event)" } }, ngImport: i0, template: "<header class=\"flex header sidebar-toggle new\" [class.fancy]=\"fancy\">\n  <div class=\"header-content\" [class.bg-primary-color]=\"fancy\">\n    <div class=\"logo\" [class.logo-oxy]=\"logoOxy\">\n      <div id=\"svgRender\" [innerHTML]=\"htmlRender\"></div>\n      {{nameModule}}\n    </div>\n\n    <button class=\"header-toggle-sidebar toggle-control sidebar-toggle hidden-lg hidden-md hidden-sm\"\n      aria-label=\"Expandir menu\" (click)=\"onClickToggledButton()\">\n      <em class=\"fa fa-bars\"></em>\n    </button>\n\n    <div class=\"header-title hidden-xs\">\n      <div class=\"content-title\">\n        <figure *ngIf=\"brasaoByteArray\" class=\"brasao\">\n          <img id=\"headerBrasao\" onerror=\"this.style.display='none'\"\n            src=\"{{ 'data:image/jpg;base64,' + brasaoByteArray }}\" />\n        </figure>\n        <span (click)=\"onClick(defaultHeaderClickFeature)\">{{ headerTitle?.toString() }}\n          <label class=\"label\" *ngIf=\"headerSubtitle\">{{ headerSubtitle }}</label>\n        </span>\n      </div>\n    </div>\n    <ul class=\"header-features\">\n      <li *ngIf=\"visibleTaskListWorkflow\" \n        [class.active]=\"item === 'taskListWorkflow'\" \n        (click)=\"onClick('taskListWorkflow')\" \n        id=\"tasks\" \n        taskListPendingCounter>\n      </li>\n      <li *ngIf=\"visibleNotificationsReportJasper\" [class.active]=\"item==='notificationReportJasper'\"\n        (click)=\"onClick('notificationReportJasper')\"><i class=\"fa fa-download\"></i><small\n          class=\"hidden-xs\">Relat\u00F3rios</small></li>\n      <li *ngIf=\"visibleContribuinte\" id=\"contribuinte\" (click)=\"onClick('contribuinte')\"><i\n          class=\"contribuinte\"></i><small class=\"hidden-xs\">Contribuinte</small></li>\n      <li *ngIf=\"visibleAcessibilidade\" id=\"acessibilidade\" [class.active]=\"item==='acessibilidade'\" title=\"Acessibilidade\"\n        (click)=\"onClick('acessibilidade')\"><i class=\"fa fa-wheelchair\"></i><small\n          class=\"hidden-xs\">Acessibilidade</small></li>\n      <li *ngIf=\"visibleNotifications\" id=\"notification\" [class.active]=\"item==='notification'\" title=\"Notifica\u00E7\u00F5es\"\n        (click)=\"onClick('notification')\" notification-system>\n      </li>\n      <li *ngIf=\"visibleUser\" [class.active]=\"item==='user'\" title=\"Ajustes\" id=\"user\" (click)=\"onClick('user')\">\n        <svg\n          aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"tools\" id=\"user_svg\"\n          class=\"svg-inline--fa fa-tools fa-w-16 icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 512 512\">\n          <path fill=\"currentColor\"\n            d=\"M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z\">\n          </path>\n        </svg><small class=\"hidden-xs\" id=\"user_small\" >Ajustes</small></li>\n     \n        <li *ngIf=\"visibleModules\" [class.active]=\"item==='module'\" title=\"M\u00F3dulos\" (click)=\"onClick('module')\"><i\n          class=\"fa fa-th\"></i><small class=\"hidden-xs\">M\u00F3dulos</small></li>\n    </ul>\n  </div>\n\n  <div class=\"header-content-mobile hidden-lg hidden-md hidden-sm\">\n    <div class=\"header-title\">\n      <div class=\"content-title\" [class.bg-primary-color]=\"fancy\">\n        <figure *ngIf=\"brasaoByteArray\" class=\"brasao\">\n          <img id=\"headerBrasao\" onerror=\"this.style.display='none'\"\n            src=\"{{ 'data:image/jpg;base64,' + brasaoByteArray }}\" />\n        </figure>\n        <span (click)=\"onClick(defaultHeaderClickFeature)\">{{ headerTitle?.toString() }}\n          <label class=\"label\" *ngIf=\"headerSubtitle\">{{ headerSubtitle }}</label>\n        </span>\n      </div>\n    </div>\n  </div>\n</header>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: NotificationSystemComponent, selector: "[notification-system]" }, { kind: "component", type: TaskListPendingCounterComponent, selector: "[taskListPendingCounter]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-header', template: "<header class=\"flex header sidebar-toggle new\" [class.fancy]=\"fancy\">\n  <div class=\"header-content\" [class.bg-primary-color]=\"fancy\">\n    <div class=\"logo\" [class.logo-oxy]=\"logoOxy\">\n      <div id=\"svgRender\" [innerHTML]=\"htmlRender\"></div>\n      {{nameModule}}\n    </div>\n\n    <button class=\"header-toggle-sidebar toggle-control sidebar-toggle hidden-lg hidden-md hidden-sm\"\n      aria-label=\"Expandir menu\" (click)=\"onClickToggledButton()\">\n      <em class=\"fa fa-bars\"></em>\n    </button>\n\n    <div class=\"header-title hidden-xs\">\n      <div class=\"content-title\">\n        <figure *ngIf=\"brasaoByteArray\" class=\"brasao\">\n          <img id=\"headerBrasao\" onerror=\"this.style.display='none'\"\n            src=\"{{ 'data:image/jpg;base64,' + brasaoByteArray }}\" />\n        </figure>\n        <span (click)=\"onClick(defaultHeaderClickFeature)\">{{ headerTitle?.toString() }}\n          <label class=\"label\" *ngIf=\"headerSubtitle\">{{ headerSubtitle }}</label>\n        </span>\n      </div>\n    </div>\n    <ul class=\"header-features\">\n      <li *ngIf=\"visibleTaskListWorkflow\" \n        [class.active]=\"item === 'taskListWorkflow'\" \n        (click)=\"onClick('taskListWorkflow')\" \n        id=\"tasks\" \n        taskListPendingCounter>\n      </li>\n      <li *ngIf=\"visibleNotificationsReportJasper\" [class.active]=\"item==='notificationReportJasper'\"\n        (click)=\"onClick('notificationReportJasper')\"><i class=\"fa fa-download\"></i><small\n          class=\"hidden-xs\">Relat\u00F3rios</small></li>\n      <li *ngIf=\"visibleContribuinte\" id=\"contribuinte\" (click)=\"onClick('contribuinte')\"><i\n          class=\"contribuinte\"></i><small class=\"hidden-xs\">Contribuinte</small></li>\n      <li *ngIf=\"visibleAcessibilidade\" id=\"acessibilidade\" [class.active]=\"item==='acessibilidade'\" title=\"Acessibilidade\"\n        (click)=\"onClick('acessibilidade')\"><i class=\"fa fa-wheelchair\"></i><small\n          class=\"hidden-xs\">Acessibilidade</small></li>\n      <li *ngIf=\"visibleNotifications\" id=\"notification\" [class.active]=\"item==='notification'\" title=\"Notifica\u00E7\u00F5es\"\n        (click)=\"onClick('notification')\" notification-system>\n      </li>\n      <li *ngIf=\"visibleUser\" [class.active]=\"item==='user'\" title=\"Ajustes\" id=\"user\" (click)=\"onClick('user')\">\n        <svg\n          aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"tools\" id=\"user_svg\"\n          class=\"svg-inline--fa fa-tools fa-w-16 icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 512 512\">\n          <path fill=\"currentColor\"\n            d=\"M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z\">\n          </path>\n        </svg><small class=\"hidden-xs\" id=\"user_small\" >Ajustes</small></li>\n     \n        <li *ngIf=\"visibleModules\" [class.active]=\"item==='module'\" title=\"M\u00F3dulos\" (click)=\"onClick('module')\"><i\n          class=\"fa fa-th\"></i><small class=\"hidden-xs\">M\u00F3dulos</small></li>\n    </ul>\n  </div>\n\n  <div class=\"header-content-mobile hidden-lg hidden-md hidden-sm\">\n    <div class=\"header-title\">\n      <div class=\"content-title\" [class.bg-primary-color]=\"fancy\">\n        <figure *ngIf=\"brasaoByteArray\" class=\"brasao\">\n          <img id=\"headerBrasao\" onerror=\"this.style.display='none'\"\n            src=\"{{ 'data:image/jpg;base64,' + brasaoByteArray }}\" />\n        </figure>\n        <span (click)=\"onClick(defaultHeaderClickFeature)\">{{ headerTitle?.toString() }}\n          <label class=\"label\" *ngIf=\"headerSubtitle\">{{ headerSubtitle }}</label>\n        </span>\n      </div>\n    </div>\n  </div>\n</header>" }]
        }], ctorParameters: () => [{ type: FeatureModuleStateService }, { type: i1$3.DomSanitizer }, { type: i1$1.HttpClient }], propDecorators: { headerTitle: [{
                type: Input
            }], headerSubtitle: [{
                type: Input
            }], nomeCidadeEntidade: [{
                type: Input
            }], toggled: [{
                type: Input
            }], visibleUser: [{
                type: Input
            }], visibleContribuinte: [{
                type: Input
            }], visibleConfiguracaoEntidadeMenu: [{
                type: Input
            }], visibleModules: [{
                type: Input
            }], visibleAcessibilidade: [{
                type: Input
            }], visibleNotifications: [{
                type: Input
            }], visibleNotificationsReportJasper: [{
                type: Input
            }], visibleTaskListWorkflow: [{
                type: Input
            }], visibleNotificationConfiguracaoEntidade: [{
                type: Input
            }], brasaoByteArray: [{
                type: Input
            }], visibleConfigEntidade: [{
                type: Input
            }], flex: [{
                type: Input
            }], activeOldColor: [{
                type: Input
            }], onClickToToggled: [{
                type: Output
            }], imgModuleMain: [{
                type: Input
            }], imgModule: [{
                type: Input
            }], imgModuleRebranding: [{
                type: Input
            }], nameModule: [{
                type: Input
            }], defaultHeaderClickFeature: [{
                type: Input
            }], logoOxy: [{
                type: Input
            }], fancy: [{
                type: Input
            }], clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class NotificationSystemModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationSystemModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: NotificationSystemModule, declarations: [NotificationSystemComponent], imports: [CommonModule], exports: [NotificationSystemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationSystemModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NotificationSystemModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [NotificationSystemComponent],
                    declarations: [NotificationSystemComponent]
                }]
        }] });

class HeaderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: HeaderModule, declarations: [HeaderComponent], imports: [CommonModule, HttpClientModule, NotificationSystemModule, TaskListPendingCounterComponent], exports: [HeaderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderModule, imports: [CommonModule, HttpClientModule, NotificationSystemModule, TaskListPendingCounterComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, HttpClientModule, NotificationSystemModule, TaskListPendingCounterComponent],
                    declarations: [HeaderComponent],
                    exports: [HeaderComponent]
                }]
        }] });

class IFrameComponent {
    constructor(sanitizer, _store) {
        this.sanitizer = sanitizer;
        this._store = _store;
        this.bypassSecurity = true;
        this.mainH = 0;
        this.mainW = 0;
    }
    ngOnInit() {
        if (!this.url) {
            throw 'Não foi informado a URL do iframe';
        }
        if (this._store) {
            this._store.hasIframe = true;
        }
        if (this.bypassSecurity) {
            this.resultingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
        }
        else {
            this.resultingUrl = this.url;
        }
        this.iframe = document.querySelector('iframe');
        this.onResize();
    }
    ngOnDestroy() {
        if (this._store) {
            this._store.hasIframe = false;
        }
    }
    onResize() {
        this.mainH = window.innerHeight;
        this.mainW = window.innerWidth;
        if (this.mainW > 768) {
            this.iframe.style.height = (this.mainH - 113) + 'px';
        }
        else if (this.mainW <= 768) {
            this.iframe.style.height = (this.mainH - 156) + 'px';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IFrameComponent, deps: [{ token: i1$3.DomSanitizer }, { token: IFrameStore, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: IFrameComponent, selector: "iframe-component", inputs: { url: "url", bypassSecurity: "bypassSecurity" }, host: { listeners: { "window:resize": "onResize()" } }, ngImport: i0, template: `
      <iframe [src]="resultingUrl"></iframe>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IFrameComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iframe-component',
                    template: `
      <iframe [src]="resultingUrl"></iframe>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$3.DomSanitizer }, { type: IFrameStore, decorators: [{
                    type: Optional
                }] }], propDecorators: { url: [{
                type: Input
            }], bypassSecurity: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

class IFrameModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IFrameModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: IFrameModule, declarations: [IFrameComponent], imports: [CommonModule], exports: [IFrameComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IFrameModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IFrameModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        IFrameComponent
                    ],
                    exports: [
                        IFrameComponent,
                    ]
                }]
        }] });

class ImageUploadComponent {
    static { this.BASE64 = 'data:image/jpeg;base64,'; }
    static { this.FILE_TYPES = ['image/jpg', 'image/jpeg', 'image/png']; }
    constructor(eloNotificationService) {
        this.eloNotificationService = eloNotificationService;
        this.imageSelected = null;
        this.onChange = null;
        this.onTouched = null;
    }
    handleInputChange(event) {
        let extension = event.target.files[0].type;
        let isSuccess = ImageUploadComponent.FILE_TYPES.indexOf(extension) > -1;
        if (!isSuccess) {
            this.eloNotificationService.error('Tipo de arquivo não permitido!', 'Tipos aceitos: jpg, jpeg e png.');
            return;
        }
        const file = event.target.files[0];
        if (this.maxUploadSize && file.size > this.maxUploadSize) {
            this.eloNotificationService.error('Tamanho do arquivo excedido!', this.messageErroMaxUploadSize);
            return;
        }
        let reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;
            const removedPrefix = result.substring(result.indexOf(',') + 1, result.length);
            this.imageSelected = result;
            this.onChange(removedPrefix);
        };
        reader.readAsDataURL(file);
    }
    clear() {
        this.imageSelected = null;
        this.onChange(this.imageSelected);
        this.file.nativeElement.value = '';
    }
    writeValue(obj) {
        if (obj) {
            this.imageSelected = ImageUploadComponent.BASE64 + obj;
        }
        else {
            this.imageSelected = null;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageUploadComponent, deps: [{ token: EloNotificationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ImageUploadComponent, selector: "image-upload", inputs: { maxUploadSize: "maxUploadSize", messageErroMaxUploadSize: "messageErroMaxUploadSize" }, providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: ImageUploadComponent }
        ], viewQueries: [{ propertyName: "file", first: true, predicate: ["file"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"image-uploader\">\n  <label class=\"image-uploader-label\"></label>\n  <input #file type=\"file\" class=\"image-uploader-input\" accept=\"image/*\" (change)=\"handleInputChange($event)\">\n  <em class=\"image-uploader-remove\" (click)=\"clear()\"></em>\n  <img *ngIf=\"imageSelected\" class=\"image-uploader-image\" [src]=\"imageSelected\">\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'image-upload', providers: [
                        { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: ImageUploadComponent }
                    ], template: "<div class=\"image-uploader\">\n  <label class=\"image-uploader-label\"></label>\n  <input #file type=\"file\" class=\"image-uploader-input\" accept=\"image/*\" (change)=\"handleInputChange($event)\">\n  <em class=\"image-uploader-remove\" (click)=\"clear()\"></em>\n  <img *ngIf=\"imageSelected\" class=\"image-uploader-image\" [src]=\"imageSelected\">\n</div>\n" }]
        }], ctorParameters: () => [{ type: EloNotificationService }], propDecorators: { file: [{
                type: ViewChild,
                args: ['file', { static: true }]
            }], maxUploadSize: [{
                type: Input
            }], messageErroMaxUploadSize: [{
                type: Input
            }] } });

class ImageUploadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ImageUploadModule, declarations: [ImageUploadComponent], imports: [CommonModule], exports: [ImageUploadComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageUploadModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ImageUploadComponent],
                    exports: [ImageUploadComponent]
                }]
        }] });

class InformationComponent {
    constructor() {
        this.condition = true;
        this.type = 'info';
        this.classInformation = '';
        this.buttonName = 'Informação';
        this.enableButton = false;
        this.buttonAction = new EventEmitter();
    }
    get icon() {
        switch (this.type) {
            case 'info':
                return 'fa fa-info-circle';
            case 'positive':
                return 'fa fa-check-circle';
            case 'negative':
                return 'fa fa-times-circle';
            case 'warning':
                return 'fa fa-exclamation-triangle';
            default:
                return 'fa fa-info-circle';
        }
    }
    buttonClick() {
        this.buttonAction.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InformationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: InformationComponent, selector: "elo-information", inputs: { title: "title", condition: "condition", type: "type", classInformation: "classInformation", buttonName: "buttonName", enableButton: "enableButton" }, outputs: { buttonAction: "buttonAction" }, ngImport: i0, template: "<div class=\"info primary icon mb-xs {{classInformation}}\" [ngClass]=\"type\" *ngIf=\"condition\">\n\n  <div class=\"icon\" id=\"informationMessageIcon\">\n    <em [ngClass]=\"icon\"></em>\n  </div>\n\n  <article>\n    <h4 id=\"informationMessageTitle\">{{title}}</h4>\n    <div id=\"informationMessageArea\">\n      <ng-content></ng-content>\n    </div>\n  </article>\n\n  <button id=\"btnInformation\" *ngIf=\"enableButton\" class=\"btn right module-color\"\n    (click)=\"buttonClick()\">{{buttonName}}</button>\n\n</div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InformationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-information', template: "<div class=\"info primary icon mb-xs {{classInformation}}\" [ngClass]=\"type\" *ngIf=\"condition\">\n\n  <div class=\"icon\" id=\"informationMessageIcon\">\n    <em [ngClass]=\"icon\"></em>\n  </div>\n\n  <article>\n    <h4 id=\"informationMessageTitle\">{{title}}</h4>\n    <div id=\"informationMessageArea\">\n      <ng-content></ng-content>\n    </div>\n  </article>\n\n  <button id=\"btnInformation\" *ngIf=\"enableButton\" class=\"btn right module-color\"\n    (click)=\"buttonClick()\">{{buttonName}}</button>\n\n</div>" }]
        }], propDecorators: { title: [{
                type: Input
            }], condition: [{
                type: Input
            }], type: [{
                type: Input
            }], classInformation: [{
                type: Input
            }], buttonName: [{
                type: Input
            }], enableButton: [{
                type: Input
            }], buttonAction: [{
                type: Output
            }] } });

class InformationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InformationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: InformationModule, declarations: [InformationComponent], imports: [CommonModule], exports: [InformationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InformationModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InformationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [InformationComponent],
                    declarations: [InformationComponent]
                }]
        }] });

class LeisAtosAutoCompleteModalComponent {
    constructor(controlContainer) {
        this.controlContainer = controlContainer;
        this.isDisabled = false;
        this.findToOptions = null;
        this.objToOptions = null;
        this.showLeisAtos = true;
        this.fieldsToFilter = ['id', 'numero', 'exercicio', 'escopo.descricao', 'tipoLeiDocumento.descricao', 'idTCE'];
        this.fieldsToDisplay = ['id', 'numero', 'exercicio', 'escopo.codigo', 'escopo.descricao', 'tipoLeiDocumento.descricao', 'idTCE'];
        this.isActiveModal = false;
    }
    ngOnInit() {
        this.form = this.controlContainer.control;
        AssertUtilsApp.assert(this.form, 'Informe o form do leis atos.');
    }
    openModal() {
        this.isActiveModal = !this.isActiveModal;
    }
    selecionarLeisAtos(leisatos) {
        this.form.get(this.controlName).patchValue(leisatos);
        this.openModal();
        this.form.markAsDirty();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeisAtosAutoCompleteModalComponent, deps: [{ token: i1$2.ControlContainer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: LeisAtosAutoCompleteModalComponent, selector: "leis-atos-autocomplete-modal", inputs: { label: "label", service: "service", controlName: "controlName", column: "column", isDisabled: "isDisabled", findToOptions: "findToOptions", objToOptions: "objToOptions", showLeisAtos: "showLeisAtos", filterDefault: "filterDefault", hintMessage: "hintMessage" }, ngImport: i0, template: "<ng-container id=\"leisatos\" [formGroup]=\"form\" *ngIf=\"showLeisAtos\">\n  <elo-form-label-column [label]=\"label\" [column]=\"column\" [hintMessage]=\"hintMessage\">\n    <elo-autocomplete id=\"leisatos\" placeholder=\"Selecione uma lei\" [service]=\"service\" [formControlName]=\"controlName\"\n      formControlValidationMsg [searchModal]=\"true\" (onSearchModal)=\"openModal()\" [isDisabled]=\"isDisabled\"\n      [findToOptions]=\"findToOptions\">\n    </elo-autocomplete>\n  </elo-form-label-column>\n\n  <elo-modal [isOpen]=\"isActiveModal\" (openClose)=\"openModal()\" *ngIf=\"isActiveModal\">\n    <elo-panel [hasTable]=true [title]=\"'Pesquisa de Leis/Atos'\">\n      <crud-search crudResource='/leis-atos' [fieldsToFilter]=\"fieldsToFilter\" [fieldsToDisplay]=\"fieldsToDisplay\"\n        [entityService]=\"service\" (eventSelected)=\"selecionarLeisAtos($event)\" [enableCreate]=\"false\"\n        [searchSelect]=\"true\" [enableRemove]=\"true\" [changeLocationOnFilter]=\"false\" [orderBy]=\"'id,asc'\"\n        [filterDefault]=\"filterDefault\">\n        <ng-template #eloColumns let-dataTable=\"dataTable\">\n          <elo-column field=\"id\" header=\"C\u00F3digo\" [dataTable]=\"dataTable\"></elo-column>\n          <elo-column field=\"numero\" header=\"Leis/Atos\" [dataTable]=\"dataTable\">\n            <ng-template #dataTableCell let-object=\"object\">\n              {{ object.numero }}/{{ object.exercicio }}\n            </ng-template>\n          </elo-column>\n          <elo-column field=\"escopo.descricao\" header=\"Escopo\" [dataTable]=\"dataTable\"></elo-column>\n          <elo-column field=\"tipoLeiDocumento.descricao\" header=\"Tipo Documento\" [dataTable]=\"dataTable\"></elo-column>\n          <elo-column field=\"idTCE\" header=\"C\u00F3digo TCE\" [dataTable]=\"dataTable\"></elo-column>\n        </ng-template>\n      </crud-search>\n    </elo-panel>\n  </elo-modal>\n</ng-container>", dependencies: [{ kind: "component", type: PanelComponent, selector: "elo-panel", inputs: ["title", "hasTable", "hasForm", "pbNone"] }, { kind: "component", type: CrudSearchComponent, selector: "crud-search", inputs: ["shouldReuseFilter", "caption", "crudResource", "entityService", "fieldsToDisplay", "fieldsToFilter", "updateFieldsToFilter", "defaultValueOperators", "fieldsToPrint", "defaultField", "orderBy", "sortable", "enableRemove", "enableRemoveNotRole", "messageDialogDelete", "showDetailPage", "showSearchFilter", "enableEdit", "enableLogs", "enableView", "enableCreate", "enableTablePrint", "removeVisibleWhenAttribute", "visibleWhenAttribute", "visibleWhenFunction", "searchSelect", "refreshEmit", "changeLocationOnFilter", "filterDefault", "deleteFunction", "editFunction", "role", "disableSpinner", "quickViewOpener", "titleNewButton", "manyActions", "callServiceFunction", "classDataTable", "expansivePanel", "showButtonPanel", "selection", "selectionMode", "dataTableFooterDynamic", "dataTableSubtitlesDynamic", "hasLinks", "getLinks", "visibleWhenFunctionLink", "titleButtonNovo", "modelName", "labelModelName", "fieldsToDisplayForModelName", "enableRemoveAll", "fixedSizeWhenMultipleSelection", "useQueryParams", "classInputFilter", "customPagesSize", "pageParameters", "filters", "beforeExtraElement", "rowDoubleClickFunction", "enableDefaultRowDoubleClickFunction", "allowSearch", "enableScrollX", "navigationExtras", "showDeleteMessage", "listenToRouteChanges", "selectionModeId", "emptyMessage", "headerFixo", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "visibleRadioWhenFunction", "findEntitiesOnInit", "notHasExtraFilter", "enableCustomHeader", "customHeaderStyle", "showAuditInfoButton", "showAuditInfoFilters", "selectionModeWithFooter"], outputs: ["eventSelected", "onClickRadioButton", "onSearchFilterObject", "onReceivePage", "onNewItem", "onSearchEmitFilter", "onIconClicked", "removeAllClicked", "rowDoubleClickEventEmitter", "onAuditInfoButtonClick"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: AutoCompleteComponent, selector: "elo-autocomplete", inputs: ["multiplo", "multipleSelected", "id", "options", "error", "service", "placeholder", "noResultsMessage", "urlCreate", "searchModal", "isDisabled", "findToOptions", "objToOption", "objToOptionViewMultiple", "debounceTime", "autoSelect", "isEnabledCreateRecord", "descriptionNewRecord", "validateDeps", "insertIcon", "extraInfos", "emptyRecord", "removeDot"], outputs: ["onChangeMultipleValue", "onChangeValue", "onSearchModal", "onInsertButton", "onCreateRecord"] }, { kind: "component", type: EloColumnComponent, selector: "elo-column", inputs: ["field", "header", "headerAlign", "isDecimal", "isPercentual", "digits", "isDate", "isDateTime", "isCnpjCpf", "enumOptions", "col", "class", "isEditable", "isEditing", "dataTable", "hidden", "hiddenTableData", "sortable", "samp", "headerStyle", "dataStyle"] }, { kind: "component", type: FormLabelColumnComponent, selector: "elo-form-label-column", inputs: ["label", "color", "column", "offset", "hintMessage", "hintPosition", "hintIconLeftAlign", "linkTitle", "showLink", "icon"], outputs: ["onClickLink"] }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: FormControlValidationMsgDirective, selector: "[formControlValidationMsg]", inputs: ["formControlAttr"] }, { kind: "component", type: EloModalComponent, selector: "elo-modal", inputs: ["isOpen", "customWidth", "isCentralized", "preventClose"], outputs: ["openClose"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeisAtosAutoCompleteModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'leis-atos-autocomplete-modal', template: "<ng-container id=\"leisatos\" [formGroup]=\"form\" *ngIf=\"showLeisAtos\">\n  <elo-form-label-column [label]=\"label\" [column]=\"column\" [hintMessage]=\"hintMessage\">\n    <elo-autocomplete id=\"leisatos\" placeholder=\"Selecione uma lei\" [service]=\"service\" [formControlName]=\"controlName\"\n      formControlValidationMsg [searchModal]=\"true\" (onSearchModal)=\"openModal()\" [isDisabled]=\"isDisabled\"\n      [findToOptions]=\"findToOptions\">\n    </elo-autocomplete>\n  </elo-form-label-column>\n\n  <elo-modal [isOpen]=\"isActiveModal\" (openClose)=\"openModal()\" *ngIf=\"isActiveModal\">\n    <elo-panel [hasTable]=true [title]=\"'Pesquisa de Leis/Atos'\">\n      <crud-search crudResource='/leis-atos' [fieldsToFilter]=\"fieldsToFilter\" [fieldsToDisplay]=\"fieldsToDisplay\"\n        [entityService]=\"service\" (eventSelected)=\"selecionarLeisAtos($event)\" [enableCreate]=\"false\"\n        [searchSelect]=\"true\" [enableRemove]=\"true\" [changeLocationOnFilter]=\"false\" [orderBy]=\"'id,asc'\"\n        [filterDefault]=\"filterDefault\">\n        <ng-template #eloColumns let-dataTable=\"dataTable\">\n          <elo-column field=\"id\" header=\"C\u00F3digo\" [dataTable]=\"dataTable\"></elo-column>\n          <elo-column field=\"numero\" header=\"Leis/Atos\" [dataTable]=\"dataTable\">\n            <ng-template #dataTableCell let-object=\"object\">\n              {{ object.numero }}/{{ object.exercicio }}\n            </ng-template>\n          </elo-column>\n          <elo-column field=\"escopo.descricao\" header=\"Escopo\" [dataTable]=\"dataTable\"></elo-column>\n          <elo-column field=\"tipoLeiDocumento.descricao\" header=\"Tipo Documento\" [dataTable]=\"dataTable\"></elo-column>\n          <elo-column field=\"idTCE\" header=\"C\u00F3digo TCE\" [dataTable]=\"dataTable\"></elo-column>\n        </ng-template>\n      </crud-search>\n    </elo-panel>\n  </elo-modal>\n</ng-container>" }]
        }], ctorParameters: () => [{ type: i1$2.ControlContainer }], propDecorators: { label: [{
                type: Input
            }], service: [{
                type: Input
            }], controlName: [{
                type: Input
            }], column: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], findToOptions: [{
                type: Input
            }], objToOptions: [{
                type: Input
            }], showLeisAtos: [{
                type: Input
            }], filterDefault: [{
                type: Input
            }], hintMessage: [{
                type: Input
            }] } });

class LeisAtosAutoCompleteModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeisAtosAutoCompleteModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: LeisAtosAutoCompleteModalModule, declarations: [LeisAtosAutoCompleteModalComponent], imports: [PanelModule,
            CrudSearchModule,
            FormsModule,
            CommonModule,
            AutoCompleteModule,
            EloDatatableModule,
            FormLabelColumnModule,
            CrudFormModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule,
            EloModalModule], exports: [LeisAtosAutoCompleteModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeisAtosAutoCompleteModalModule, imports: [PanelModule,
            CrudSearchModule,
            FormsModule,
            CommonModule,
            AutoCompleteModule,
            EloDatatableModule,
            FormLabelColumnModule,
            CrudFormModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule,
            EloModalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeisAtosAutoCompleteModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        PanelModule,
                        CrudSearchModule,
                        FormsModule,
                        CommonModule,
                        AutoCompleteModule,
                        EloDatatableModule,
                        FormLabelColumnModule,
                        CrudFormModule,
                        ReactiveFormsModule,
                        FormControlValidationMsgModule,
                        EloModalModule
                    ],
                    declarations: [LeisAtosAutoCompleteModalComponent],
                    exports: [LeisAtosAutoCompleteModalComponent]
                }]
        }] });

class ModalFormInsertComponent {
    constructor(eloNotificationService) {
        this.eloNotificationService = eloNotificationService;
        this.isOpen = false;
        this.openClose = new EventEmitter();
    }
    ngOnInit() {
        this.subcrition = this.eloNotificationService.notificationObservers.subscribe(notification => {
            if (notification.type === NotificationType.positive && this.isOpen) {
                this.onOpenClose();
            }
        });
    }
    onOpenClose() {
        this.openClose.emit();
    }
    ngOnDestroy() {
        this.subcrition.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalFormInsertComponent, deps: [{ token: EloNotificationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ModalFormInsertComponent, selector: "modal-form-insert", inputs: { isOpen: "isOpen", crudTemplateRef: "crudTemplateRef" }, outputs: { openClose: "openClose" }, ngImport: i0, template: "<div *ngIf=\"isOpen\">\n  <elo-modal [isOpen]=\"isOpen\" (openClose)=\"onOpenClose()\">\n    <ng-container  *ngTemplateOutlet=\"crudTemplateRef\">\n     </ng-container>\n  </elo-modal>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: EloModalComponent, selector: "elo-modal", inputs: ["isOpen", "customWidth", "isCentralized", "preventClose"], outputs: ["openClose"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalFormInsertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'modal-form-insert', template: "<div *ngIf=\"isOpen\">\n  <elo-modal [isOpen]=\"isOpen\" (openClose)=\"onOpenClose()\">\n    <ng-container  *ngTemplateOutlet=\"crudTemplateRef\">\n     </ng-container>\n  </elo-modal>\n</div>\n" }]
        }], ctorParameters: () => [{ type: EloNotificationService }], propDecorators: { isOpen: [{
                type: Input
            }], crudTemplateRef: [{
                type: Input
            }], openClose: [{
                type: Output
            }] } });

class ModalFormInsertModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalFormInsertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ModalFormInsertModule, declarations: [ModalFormInsertComponent], imports: [CommonModule, EloModalModule], exports: [ModalFormInsertComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalFormInsertModule, imports: [CommonModule, EloModalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalFormInsertModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, EloModalModule],
                    declarations: [ModalFormInsertComponent],
                    exports: [ModalFormInsertComponent]
                }]
        }] });

class ModalMenuComponent {
    constructor() {
        this.title = 'Informações';
        this.isOpen = false;
        this.openClose = new EventEmitter();
        this.informations = [];
        this.menuOptions = [];
    }
    switchOpenClose() {
        this.isOpen = !this.isOpen;
        this.openClose.emit(this.isOpen);
    }
    addOption(option) {
        this.menuOptions.push(option);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ModalMenuComponent, selector: "elo-modal-menu", inputs: { title: "title", isOpen: "isOpen", informations: "informations" }, outputs: { openClose: "openClose" }, ngImport: i0, template: "<elo-modal [isOpen]=\"isOpen\" (openClose)=\"switchOpenClose()\">\n\n  <div class=\"panel panel-menu-opcoes\">\n\n    <div class=\"panel-body\">\n\n      <elo-panel-expansive title=\"{{ title }}\" [collapsed]=\"true\">\n\n        <ul class=\"opcoes-info\">\n          <li *ngFor=\"let item of informations\"><b>{{ item.label }}:</b> <span> {{ item.value }}</span></li>\n        </ul>\n\n      </elo-panel-expansive>\n\n      <div class=\"btn-opcoes-flutuante\">\n\n        <ul id=\"options\" class=\"row\">\n          <li *ngFor=\"let item of menuOptions\" class=\"col-xs-4\">\n            <button class=\"btn icon-left\" (click)=\"item.onClickOption(item)\">\n              <i class=\"{{ item.icon }} module-color\"></i>\n              {{ item.titulo }}\n            </button>\n          </li>\n\n        </ul>\n      </div><!--/btn-opcoes-flutuante-->\n\n    </div><!--/panel-body-->\n\n  </div><!--/panel-->\n\n</elo-modal>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: EloModalComponent, selector: "elo-modal", inputs: ["isOpen", "customWidth", "isCentralized", "preventClose"], outputs: ["openClose"] }, { kind: "component", type: PanelExpansiveComponent, selector: "elo-panel-expansive", inputs: ["collapsed", "title", "hasTable", "hasForm", "expansive", "showButton", "disabledButton", "hideButtonNovo", "titleButtonNovo", "extraButtons", "enableScrollX", "isInsideTab", "collapsedCookie", "error"], outputs: ["onExpand", "onNewItem"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-modal-menu', template: "<elo-modal [isOpen]=\"isOpen\" (openClose)=\"switchOpenClose()\">\n\n  <div class=\"panel panel-menu-opcoes\">\n\n    <div class=\"panel-body\">\n\n      <elo-panel-expansive title=\"{{ title }}\" [collapsed]=\"true\">\n\n        <ul class=\"opcoes-info\">\n          <li *ngFor=\"let item of informations\"><b>{{ item.label }}:</b> <span> {{ item.value }}</span></li>\n        </ul>\n\n      </elo-panel-expansive>\n\n      <div class=\"btn-opcoes-flutuante\">\n\n        <ul id=\"options\" class=\"row\">\n          <li *ngFor=\"let item of menuOptions\" class=\"col-xs-4\">\n            <button class=\"btn icon-left\" (click)=\"item.onClickOption(item)\">\n              <i class=\"{{ item.icon }} module-color\"></i>\n              {{ item.titulo }}\n            </button>\n          </li>\n\n        </ul>\n      </div><!--/btn-opcoes-flutuante-->\n\n    </div><!--/panel-body-->\n\n  </div><!--/panel-->\n\n</elo-modal>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], isOpen: [{
                type: Input
            }], openClose: [{
                type: Output
            }], informations: [{
                type: Input
            }] } });

class ModalMenuOptionComponent {
    constructor(modalMenu) {
        this.onClick = new EventEmitter();
        modalMenu.addOption(this);
    }
    onClickOption(event) {
        this.onClick.emit(event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalMenuOptionComponent, deps: [{ token: ModalMenuComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ModalMenuOptionComponent, selector: "elo-modal-menu-option", inputs: { icon: "icon", titulo: "titulo" }, outputs: { onClick: "onClick" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalMenuOptionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-modal-menu-option',
                    template: ''
                }]
        }], ctorParameters: () => [{ type: ModalMenuComponent }], propDecorators: { icon: [{
                type: Input
            }], titulo: [{
                type: Input
            }], onClick: [{
                type: Output
            }] } });

class ModalMenuModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ModalMenuModule, declarations: [ModalMenuComponent, ModalMenuOptionComponent], imports: [CommonModule, EloModalModule, PanelExpansiveModule], exports: [ModalMenuComponent, ModalMenuOptionComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalMenuModule, imports: [CommonModule, EloModalModule, PanelExpansiveModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ModalMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, EloModalModule, PanelExpansiveModule],
                    declarations: [ModalMenuComponent, ModalMenuOptionComponent],
                    exports: [ModalMenuComponent, ModalMenuOptionComponent],
                    providers: [],
                }]
        }] });

/**
 * Creates a button of the specified type, with the given classes and text
 *
 * @param button.type The type of button cancel, back, or next
 * @param button.classes Classes to apply to the button
 * @param button.text The text for the button
 * @param button.action The action to call
 */
function makeButton(button) {
    const { classes, disabled, label, secondary, type, text } = button;
    const builtInButtonTypes = ['back', 'cancel', 'next', 'complete'];
    if (!type) {
        return button;
    }
    if (builtInButtonTypes.indexOf(type) === -1) {
        throw new Error(`'type' property must be one of 'back', 'cancel', or 'next'`);
    }
    return {
        action: this[type] && this[type].bind(this),
        classes,
        disabled,
        label,
        secondary,
        text
    };
}

class OnBoardingComponent {
    constructor(_keycloakService, _featureModuleStateService) {
        this._keycloakService = _keycloakService;
        this._featureModuleStateService = _featureModuleStateService;
        this.loadUserProfile = (handler) => {
            this._keycloakService.getUserProfile().then((keycloakProfile) => {
                handler(keycloakProfile);
            }).catch(error => {
                error(msg => {
                    throw msg;
                });
            });
        };
        this.isPrimeiroAcesso = user => !user.attributes.primeiro_acesso || user.attributes.primeiro_acesso[0] === 'TRUE';
        this.updatePrimeiroAcesso = (user, value) => {
            const newUser = { ...user.attributes, primeiro_acesso: [value] };
            return this._keycloakService.sobrescreverAttributos(newUser)
                .subscribe(_ => undefined);
        };
        this.tour = this._createTour();
    }
    ngOnDestroy() {
        this.tour.cancel();
    }
    ngAfterViewInit() {
        const currSteps = this.steps || steps;
        this.startTourPrimeiroAcesso(currSteps);
        this._featureModuleStateService.tourCaller.subscribe(() => {
            this.startTour(currSteps);
        });
    }
    startTourPrimeiroAcesso(steps) {
        this.loadUserProfile((user) => {
            if (!this.isPrimeiroAcesso(user)) {
                return;
            }
            this.innerStartTour(steps, user);
        });
    }
    startTour(steps) {
        this.loadUserProfile((user) => {
            this.innerStartTour(steps, user);
        });
    }
    innerStartTour(steps, user) {
        if (!steps || !Array.isArray(steps) || steps.length === 0) {
            throw 'Não foi encontrado a variavel steps';
        }
        this._initializeSteps(steps);
        this.tour.once('complete', () => this.updatePrimeiroAcesso(user, 'FALSE'));
        this.tour.start();
    }
    _initializeSteps(steps) {
        steps.forEach((step) => {
            if (step.buttons) {
                step.buttons = step.buttons.map(makeButton.bind(this.tour), this.tour);
            }
            this.tour.addStep(step);
        });
    }
    _createTour() {
        return new Shepherd.Tour({
            defaultStepOptions: {
                cancelIcon: {
                    enabled: true
                }
            },
            exitOnEsc: true,
            useModalOverlay: true
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OnBoardingComponent, deps: [{ token: KeycloakAuthHttp }, { token: FeatureModuleStateService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: OnBoardingComponent, selector: "onboarding-component", inputs: { steps: "steps" }, ngImport: i0, template: `<div></div>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OnBoardingComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'onboarding-component',
                    template: `<div></div>`
                }]
        }], ctorParameters: () => [{ type: KeycloakAuthHttp }, { type: FeatureModuleStateService }], propDecorators: { steps: [{
                type: Input
            }] } });

class OnBoardingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OnBoardingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: OnBoardingModule, declarations: [OnBoardingComponent], exports: [OnBoardingComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OnBoardingModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OnBoardingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        OnBoardingComponent,
                    ],
                    exports: [
                        OnBoardingComponent
                    ]
                }]
        }] });

class PageCustomizedComponent {
    constructor() {
        this.title = 'Título';
        this.text = 'Texto';
        this.btnName = 'Botão';
        this.icon = 'fa fa-cogs';
        this.btnFunction = null;
    }
    buttonClick() {
        this.btnFunction();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageCustomizedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageCustomizedComponent, selector: "elo-page-customized", inputs: { title: "title", text: "text", btnName: "btnName", icon: "icon", btnFunction: "btnFunction" }, ngImport: i0, template: "<div class=\"not-found\">\n\t<span id=\"page-customized-icon\" [ngClass]=\"icon\"></span>\n\t<h2 id=\"page-customized-title\">\n\t\t{{ title }}\n\t</h2>\n\t<small id=\"page-customized-text\">\n\t\t{{ text }}\n\t</small>\n\n\t<button *ngIf=\"btnFunction\" (click)=\"buttonClick()\" id=\"page-customized-btn\"\n\t\tclass=\"btn module-color icon-right center mt-xs\">{{btnName}}</button>\n\n</div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageCustomizedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-page-customized', template: "<div class=\"not-found\">\n\t<span id=\"page-customized-icon\" [ngClass]=\"icon\"></span>\n\t<h2 id=\"page-customized-title\">\n\t\t{{ title }}\n\t</h2>\n\t<small id=\"page-customized-text\">\n\t\t{{ text }}\n\t</small>\n\n\t<button *ngIf=\"btnFunction\" (click)=\"buttonClick()\" id=\"page-customized-btn\"\n\t\tclass=\"btn module-color icon-right center mt-xs\">{{btnName}}</button>\n\n</div>" }]
        }], propDecorators: { title: [{
                type: Input
            }], text: [{
                type: Input
            }], btnName: [{
                type: Input
            }], icon: [{
                type: Input
            }], btnFunction: [{
                type: Input
            }] } });

class PageCustomizedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageCustomizedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PageCustomizedModule, declarations: [PageCustomizedComponent], imports: [CommonModule], exports: [PageCustomizedComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageCustomizedModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageCustomizedModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [PageCustomizedComponent],
                    exports: [PageCustomizedComponent]
                }]
        }] });

class PageBlockedComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBlockedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageBlockedComponent, selector: "page-blocked", ngImport: i0, template: "<div class=\"not-found\">\n  <h1>\n    <em class=\"fa fa-ban\"></em>\n  </h1>\n  <h2>\n    Desculpe, mas esta p\u00E1gina foi temporariamente bloqueada pelo administrador do sistema.\n  </h2>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBlockedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'page-blocked', template: "<div class=\"not-found\">\n  <h1>\n    <em class=\"fa fa-ban\"></em>\n  </h1>\n  <h2>\n    Desculpe, mas esta p\u00E1gina foi temporariamente bloqueada pelo administrador do sistema.\n  </h2>\n</div>\n" }]
        }] });

class PageBlockedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBlockedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PageBlockedModule, declarations: [PageBlockedComponent], imports: [CommonModule], exports: [PageBlockedComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBlockedModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBlockedModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [PageBlockedComponent],
                    exports: [PageBlockedComponent]
                }]
        }] });

class PageForbiddenComponent {
    constructor(_location) {
        this._location = _location;
        this.baseHref = this._location.prepareExternalUrl('');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageForbiddenComponent, deps: [{ token: i1.Location }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageForbiddenComponent, selector: "page-forbidden", ngImport: i0, template: "<div class=\"not-found\">\n\t<h1>\n\t\t<em class=\"fa fa-lock\"></em>\n\t</h1>\n\t<h2>\n\t\tVoc\u00EA n\u00E3o possui permiss\u00E3o para acessar esta p\u00E1gina.\n\t</h2>\n\t<small>\n\t\t403\n\t</small>\n\t<a href=\"{{baseHref}}\">\n\t\t<button class=\"btn module-color icon-right center mt-xs\">\n\t\t\tVolte ao In\u00EDcio <em class=\"fa fa-home\"></em>\n\t\t</button>\n\t</a>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageForbiddenComponent, decorators: [{
            type: Component,
            args: [{ selector: 'page-forbidden', template: "<div class=\"not-found\">\n\t<h1>\n\t\t<em class=\"fa fa-lock\"></em>\n\t</h1>\n\t<h2>\n\t\tVoc\u00EA n\u00E3o possui permiss\u00E3o para acessar esta p\u00E1gina.\n\t</h2>\n\t<small>\n\t\t403\n\t</small>\n\t<a href=\"{{baseHref}}\">\n\t\t<button class=\"btn module-color icon-right center mt-xs\">\n\t\t\tVolte ao In\u00EDcio <em class=\"fa fa-home\"></em>\n\t\t</button>\n\t</a>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.Location }] });

class PageForbiddenModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageForbiddenModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PageForbiddenModule, declarations: [PageForbiddenComponent], imports: [CommonModule], exports: [PageForbiddenComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageForbiddenModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageForbiddenModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [PageForbiddenComponent],
                    exports: [PageForbiddenComponent]
                }]
        }] });

class PageNotFoundComponent {
    constructor(_location) {
        this._location = _location;
        this.baseHref = this._location.prepareExternalUrl('');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageNotFoundComponent, deps: [{ token: i1.Location }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageNotFoundComponent, selector: "not-found", ngImport: i0, template: "<div class=\"not-found\">\n\t<h1>\n\t\t<em class=\"fa fa-frown-o\"></em>\n\t</h1>\n\t<h2>\n\t\tDesculpe, n\u00E3o conseguimos encontrar o que voc\u00EA est\u00E1 procurando.\n\t</h2>\n\t<small>\n\t\t404\n\t</small>\n\t<a href=\"{{baseHref}}\">\n\t\t<button class=\"btn module-color icon-right center mt-xs\">\n\t\t\tVolte ao In\u00EDcio <em class=\"fa fa-home\"></em>\n\t\t</button>\n\t</a>\n</div>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageNotFoundComponent, decorators: [{
            type: Component,
            args: [{ selector: 'not-found', template: "<div class=\"not-found\">\n\t<h1>\n\t\t<em class=\"fa fa-frown-o\"></em>\n\t</h1>\n\t<h2>\n\t\tDesculpe, n\u00E3o conseguimos encontrar o que voc\u00EA est\u00E1 procurando.\n\t</h2>\n\t<small>\n\t\t404\n\t</small>\n\t<a href=\"{{baseHref}}\">\n\t\t<button class=\"btn module-color icon-right center mt-xs\">\n\t\t\tVolte ao In\u00EDcio <em class=\"fa fa-home\"></em>\n\t\t</button>\n\t</a>\n</div>" }]
        }], ctorParameters: () => [{ type: i1.Location }] });

class PageNotFoundModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageNotFoundModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PageNotFoundModule, declarations: [PageNotFoundComponent], imports: [CommonModule], exports: [PageNotFoundComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageNotFoundModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageNotFoundModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [PageNotFoundComponent],
                    exports: [PageNotFoundComponent]
                }]
        }] });

class PageUnavailableComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() {
        this.router.navigateByUrl('/unavailable');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageUnavailableComponent, deps: [{ token: i1$4.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageUnavailableComponent, selector: "page-unavailable", ngImport: i0, template: "<div class=\"not-found\">\n\t<h1>\n\t\t<em class=\"fa fa-exclamation-triangle\"></em>\n\t</h1>\n\t<h2>\n\t\tDesculpe, esta p\u00E1gina n\u00E3o est\u00E1 dispon\u00EDvel no momento.\n\t</h2>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageUnavailableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'page-unavailable', template: "<div class=\"not-found\">\n\t<h1>\n\t\t<em class=\"fa fa-exclamation-triangle\"></em>\n\t</h1>\n\t<h2>\n\t\tDesculpe, esta p\u00E1gina n\u00E3o est\u00E1 dispon\u00EDvel no momento.\n\t</h2>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1$4.Router }] });

class PageUnavailableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageUnavailableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PageUnavailableModule, declarations: [PageUnavailableComponent], imports: [CommonModule], exports: [PageUnavailableComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageUnavailableModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageUnavailableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [PageUnavailableComponent],
                    exports: [PageUnavailableComponent]
                }]
        }] });

class PreviewBlockItemComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreviewBlockItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PreviewBlockItemComponent, selector: "elo-preview-block-item", inputs: { caption: "caption", value: "value" }, ngImport: i0, template: "<li>\n    <i>{{caption}}</i>\n    {{value}}\n</li>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreviewBlockItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-preview-block-item', template: "<li>\n    <i>{{caption}}</i>\n    {{value}}\n</li>" }]
        }], propDecorators: { caption: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class PreviewBlockComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreviewBlockComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PreviewBlockComponent, selector: "elo-preview-block", inputs: { title: "title" }, ngImport: i0, template: "<div class=\"title-block\">\n    <p>{{title}}</p>\n</div>\n\n<ul class=\"desc\">\n   <ng-content></ng-content>\n</ul>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreviewBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-preview-block', template: "<div class=\"title-block\">\n    <p>{{title}}</p>\n</div>\n\n<ul class=\"desc\">\n   <ng-content></ng-content>\n</ul>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }] } });

class PreviewComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreviewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PreviewComponent, selector: "elo-preview", inputs: { column: "column", class: "class" }, ngImport: i0, template: "<div class=\"preview {{column}} {{class}}\">\n    <ng-content></ng-content>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreviewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-preview', template: "<div class=\"preview {{column}} {{class}}\">\n    <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { column: [{
                type: Input
            }], class: [{
                type: Input
            }] } });

class PreviewModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreviewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PreviewModule, declarations: [PreviewComponent, PreviewBlockComponent, PreviewBlockItemComponent], imports: [CommonModule], exports: [PreviewComponent, PreviewBlockComponent, PreviewBlockItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreviewModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PreviewModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [PreviewComponent, PreviewBlockComponent, PreviewBlockItemComponent],
                    declarations: [PreviewComponent, PreviewBlockComponent, PreviewBlockItemComponent]
                }]
        }] });

class QueryBuilderItemComponent {
    constructor() {
        this.ONLY_NUMBER_LETTER_COMMA_WHITESPACE_ACCENT_EXP = /[^\s0-9,a-zA-ZÀ-úÇç_+-]/g;
        this.queryValue = { 'condition': 'and', 'rules': [] };
        this.config = { fields: {} };
        this.onChangeQueryValue = new EventEmitter();
    }
    onSwitchButton(event, ruleset) {
        ruleset.condition = event.selectedButton.value;
        this.updateQueryValue(this.queryValue);
    }
    updateQueryValue(value) {
        this.onChangeQueryValue.emit(value);
    }
    validateValue(rule) {
        if (this.isKeyboardCharacterValid(rule)) {
            rule.value = rule.value.replace(this.ONLY_NUMBER_LETTER_COMMA_WHITESPACE_ACCENT_EXP, '');
        }
        this.updateQueryValue(this.queryValue);
    }
    isKeyboardCharacterValid(rule) {
        return rule.value !== undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QueryBuilderItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: QueryBuilderItemComponent, selector: "elo-query-builder-item", inputs: { queryValue: "queryValue", config: "config" }, outputs: { onChangeQueryValue: "onChangeQueryValue" }, ngImport: i0, template: "<div class=\"mt-sm\">\n  <query-builder [ngModel]=\"queryValue\" (ngModelChange)=\"updateQueryValue($event)\" [config]=\"config\"\n    emptyMessage=\"A condi\u00E7\u00E3o grupo n\u00E3o pode ser vazia\">\n    <ng-container\n      *queryButtonGroup=\"let ruleset; let addRule=addRule; let addRuleSet=addRuleSet; let removeRuleSet=removeRuleSet\">\n      <div>\n        <button id=\"buttonAddRuleSet\" class=\"btn module-color inline icon-left\" type=\"button\" (click)=\"addRuleSet()\">\n          <em class=\"fa fa-plus\"></em>\n          Grupo\n        </button>\n        <button id=\"buttonAddRule\" class=\"btn module-color inline icon-left\" type=\"button\" (click)=\"addRule()\">\n          <em class=\"fa fa-plus\"></em>\n          Condi\u00E7\u00E3o\n        </button>\n        <button *ngIf=\"removeRuleSet\" id=\"buttonRemoveConditionSet\" class=\"btn negative inline\" type=\"button\"\n          (click)=\"removeRuleSet()\">\n          <em class=\"fa fa-trash\"></em>\n        </button>\n      </div>\n    </ng-container>\n\n    <ng-container *queryRemoveButton=\"let rule; let removeRule=removeRule\">\n      <button id=\"buttonRemoveRule\" class=\"btn negative inline\" type=\"button\" (click)=\"removeRule(rule)\">\n        <em class=\"fa fa-trash\"></em></button>\n    </ng-container>\n\n    <ng-container *querySwitchGroup=\"let ruleset\">\n      <elo-switch-button (onSelected)=\"onSwitchButton($event, ruleset)\">\n        <elo-switch-button-item title=\"E\" value=\"and\" [selected]=\"ruleset?.condition === 'and'\">\n        </elo-switch-button-item>\n        <elo-switch-button-item title=\"Ou\" value=\"or\" [selected]=\"ruleset?.condition === 'or'\">\n        </elo-switch-button-item>\n      </elo-switch-button>\n    </ng-container>\n\n    <ng-container *queryInput=\"let rule; type: 'textarea'\">\n      <textarea id=\"ruleInput\" [(ngModel)]=\"rule.value\" (keyup)=\"validateValue(rule)\"\n        style=\"margin-top: 10px; resize: vertical;\"></textarea>\n\n    </ng-container>\n\n  </query-builder>\n</div>", styles: ["query-builder .q-tree{padding-left:40px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i3$1.QueryBuilderComponent, selector: "query-builder", inputs: ["disabled", "data", "allowRuleset", "allowCollapse", "emptyMessage", "classNames", "operatorMap", "parentValue", "config", "parentArrowIconTemplate", "parentInputTemplates", "parentOperatorTemplate", "parentFieldTemplate", "parentEntityTemplate", "parentSwitchGroupTemplate", "parentButtonGroupTemplate", "parentRemoveButtonTemplate", "parentEmptyWarningTemplate", "parentChangeCallback", "parentTouchedCallback", "persistValueOnFieldChange", "value"] }, { kind: "directive", type: i3$1.QueryInputDirective, selector: "[queryInput]", inputs: ["queryInputType"] }, { kind: "directive", type: i3$1.QueryButtonGroupDirective, selector: "[queryButtonGroup]" }, { kind: "directive", type: i3$1.QuerySwitchGroupDirective, selector: "[querySwitchGroup]" }, { kind: "directive", type: i3$1.QueryRemoveButtonDirective, selector: "[queryRemoveButton]" }, { kind: "component", type: SwitchButtonComponent, selector: "elo-switch-button", inputs: ["flat", "propertyNameCompare"], outputs: ["onSelected"] }, { kind: "component", type: SwitchButtonItemComponent, selector: "elo-switch-button-item", inputs: ["title", "selected", "value", "isDisabled"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QueryBuilderItemComponent, decorators: [{
            type: Component,
            args: [{ encapsulation: ViewEncapsulation.None, selector: 'elo-query-builder-item', template: "<div class=\"mt-sm\">\n  <query-builder [ngModel]=\"queryValue\" (ngModelChange)=\"updateQueryValue($event)\" [config]=\"config\"\n    emptyMessage=\"A condi\u00E7\u00E3o grupo n\u00E3o pode ser vazia\">\n    <ng-container\n      *queryButtonGroup=\"let ruleset; let addRule=addRule; let addRuleSet=addRuleSet; let removeRuleSet=removeRuleSet\">\n      <div>\n        <button id=\"buttonAddRuleSet\" class=\"btn module-color inline icon-left\" type=\"button\" (click)=\"addRuleSet()\">\n          <em class=\"fa fa-plus\"></em>\n          Grupo\n        </button>\n        <button id=\"buttonAddRule\" class=\"btn module-color inline icon-left\" type=\"button\" (click)=\"addRule()\">\n          <em class=\"fa fa-plus\"></em>\n          Condi\u00E7\u00E3o\n        </button>\n        <button *ngIf=\"removeRuleSet\" id=\"buttonRemoveConditionSet\" class=\"btn negative inline\" type=\"button\"\n          (click)=\"removeRuleSet()\">\n          <em class=\"fa fa-trash\"></em>\n        </button>\n      </div>\n    </ng-container>\n\n    <ng-container *queryRemoveButton=\"let rule; let removeRule=removeRule\">\n      <button id=\"buttonRemoveRule\" class=\"btn negative inline\" type=\"button\" (click)=\"removeRule(rule)\">\n        <em class=\"fa fa-trash\"></em></button>\n    </ng-container>\n\n    <ng-container *querySwitchGroup=\"let ruleset\">\n      <elo-switch-button (onSelected)=\"onSwitchButton($event, ruleset)\">\n        <elo-switch-button-item title=\"E\" value=\"and\" [selected]=\"ruleset?.condition === 'and'\">\n        </elo-switch-button-item>\n        <elo-switch-button-item title=\"Ou\" value=\"or\" [selected]=\"ruleset?.condition === 'or'\">\n        </elo-switch-button-item>\n      </elo-switch-button>\n    </ng-container>\n\n    <ng-container *queryInput=\"let rule; type: 'textarea'\">\n      <textarea id=\"ruleInput\" [(ngModel)]=\"rule.value\" (keyup)=\"validateValue(rule)\"\n        style=\"margin-top: 10px; resize: vertical;\"></textarea>\n\n    </ng-container>\n\n  </query-builder>\n</div>", styles: ["query-builder .q-tree{padding-left:40px}\n"] }]
        }], propDecorators: { queryValue: [{
                type: Input
            }], config: [{
                type: Input
            }], onChangeQueryValue: [{
                type: Output
            }] } });

class QueryBuilderTranslatorComponent {
    constructor() {
        this.queryBuilderValue = '';
        this.createContext = () => ({ queryBuilderValueTranslate: this.queryBuilderValueTranslator });
    }
    static queryBuilderValueTranslator(queryBuilderValue) {
        if (queryBuilderValue) {
            return QueryBuilderTranslatorComponent.internalQueryBuilderValueTranslator(queryBuilderValue.condition, queryBuilderValue.rules);
        }
        return '';
    }
    static internalQueryBuilderValueTranslator(condition, rules) {
        return `(${rules.map(rule => {
            if (rule.condition) {
                return QueryBuilderTranslatorComponent.internalQueryBuilderValueTranslator(rule.condition, rule.rules);
            }
            return `${rule.field.replace(/#\d+/, '')} ${rule.operator} ${rule.value ? rule.value : ''}`;
        }).join(` ${condition === 'and' ? 'e' : 'ou'} `)})`;
    }
    get queryBuilderValueTranslator() {
        return QueryBuilderTranslatorComponent.queryBuilderValueTranslator(this.queryBuilderValue);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QueryBuilderTranslatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: QueryBuilderTranslatorComponent, selector: "elo-query-builder-translator", inputs: { queryBuilderValue: "queryBuilderValue", template: "template" }, ngImport: i0, template: "<ng-container *ngTemplateOutlet=\"template;context:createContext()\"></ng-container>", dependencies: [{ kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QueryBuilderTranslatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-query-builder-translator', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngTemplateOutlet=\"template;context:createContext()\"></ng-container>" }]
        }], propDecorators: { queryBuilderValue: [{
                type: Input
            }], template: [{
                type: Input
            }] } });

class EnumService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
    }
    getSelectItems(resource) {
        let options = [];
        this.httpClient.get({ resource: resource }).subscribe(data => data.forEach((item) => options.push({
            label: item.descricao,
            value: item.codigo
        })));
        return options;
    }
    getEnumValues(resource) {
        return this.httpClient.get({ resource: resource, disableSpinner: true });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

const queryBuilderValueEmpty = { 'condition': 'and', 'rules': [] };
const validQueryBuilderValue = () => {
    return (control) => {
        if (!control.value) {
            return null;
        }
        return control.value?.rules?.length > 0 ? null : { 'semRules': 'condições vazia' };
    };
};
class QueryBuilderComponent {
    constructor(enumService) {
        this.enumService = enumService;
        this.showQueryBuilder = true;
        this.required = false;
        this.fields = [{}];
        this.onReset = new EventEmitter();
        this.queryBuilderConfig = { fields: {} };
        this.queryBuilderValue = Object.assign({}, queryBuilderValueEmpty);
    }
    ngOnInit() {
        if (this.required) {
            setTimeout(() => {
                this.form.get('queryBuilderValue').setValidators(Validators.compose([Validators.required, validQueryBuilderValue()]));
            });
        }
        if (this.fields.length === 0) {
            this.fields = [{}];
        }
        this.applyConfig(null);
        this.onReset.subscribe((entity) => {
            this.formReset(entity);
        });
    }
    formReset(entity) {
        if (this.form.get('id')) {
            this.form.get('id').setValue(entity?.id);
        }
        this.form.get('queryBuilderValue').setValue(entity?.queryBuilderValue);
        this.applyConfig(entity);
    }
    createQueryBuilderConfig(operators) {
        const config = { fields: {} };
        const operatorsMap = operators.map(op => op.descricao);
        this.fields.forEach(field => config.fields[`${field.descricao}#${field.codigo ? field.codigo : field.id}`] = {
            name: field.descricao,
            type: 'textarea',
            operators: operatorsMap
        });
        return config;
    }
    onChangeQueryValue(queryValue) {
        this.form.get('queryBuilderValue').setValue(Object.assign({}, queryValue));
        this.form.markAsDirty();
        if (this.isInvalidQuery(queryValue)) {
            this.form.get('queryBuilderValue').setErrors({ condicaoInvalida: 'Não é permitido grupos sem condições ou condições sem valor.' });
        }
        else if (this.isTrimInvalidQuery(queryValue)) {
            this.form.get('queryBuilderValue').setErrors({ condicaoInvalida: 'Remova os espaços existentes no início e/ou no final do valor.' });
        }
    }
    isTrimInvalidQuery(queryValue) {
        if (queryValue.condition) {
            return !queryValue.rules?.length
                || queryValue.rules?.filter((r) => this.isTrimInvalidQuery(r)).length > 0;
        }
        return queryValue.value?.length !== queryValue.value?.trim().length;
    }
    isInvalidQuery(queryValue) {
        if (!queryValue.condition && !queryValue.value) {
            return this.required;
        }
        return this.isInvalid(queryValue);
    }
    isInvalid(queryValue) {
        if (queryValue.condition) {
            return !queryValue.rules.length
                || queryValue.rules.filter((r) => this.isInvalid(r)).length > 0;
        }
        return !queryValue.value;
    }
    applyConfig(entity) {
        this.enumService.getEnumValues('/api/operadores-condicoes')
            .subscribe(result => {
            this.queryBuilderConfig = this.createQueryBuilderConfig(result);
            this.queryBuilderValue = Object.assign({}, queryBuilderValueEmpty);
            if (entity && entity.queryBuilderValue) {
                this.queryBuilderValue = entity.queryBuilderValue;
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QueryBuilderComponent, deps: [{ token: EnumService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: QueryBuilderComponent, selector: "elo-query-builder", inputs: { showQueryBuilder: "showQueryBuilder", required: "required", fields: "fields", form: "form", onReset: "onReset" }, ngImport: i0, template: "<div [formGroup]=\"form\" inputs>\n\n  <elo-query-builder-item *ngIf=\"showQueryBuilder\" [queryValue]=\"queryBuilderValue\" [config]=\"queryBuilderConfig\"\n    (onChangeQueryValue)=\"onChangeQueryValue($event)\">\n  </elo-query-builder-item>\n\n  <div class=\"align-group\"\n    *ngIf=\"form.get('queryBuilderValue')?.errors && form.get('queryBuilderValue')?.errors['condicaoInvalida']\">\n    <span class=\"help-message\">{{form.get('queryBuilderValue')['errors']['condicaoInvalida']}}</span>\n  </div>\n\n</div>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: QueryBuilderItemComponent, selector: "elo-query-builder-item", inputs: ["queryValue", "config"], outputs: ["onChangeQueryValue"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QueryBuilderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-query-builder', template: "<div [formGroup]=\"form\" inputs>\n\n  <elo-query-builder-item *ngIf=\"showQueryBuilder\" [queryValue]=\"queryBuilderValue\" [config]=\"queryBuilderConfig\"\n    (onChangeQueryValue)=\"onChangeQueryValue($event)\">\n  </elo-query-builder-item>\n\n  <div class=\"align-group\"\n    *ngIf=\"form.get('queryBuilderValue')?.errors && form.get('queryBuilderValue')?.errors['condicaoInvalida']\">\n    <span class=\"help-message\">{{form.get('queryBuilderValue')['errors']['condicaoInvalida']}}</span>\n  </div>\n\n</div>" }]
        }], ctorParameters: () => [{ type: EnumService }], propDecorators: { showQueryBuilder: [{
                type: Input
            }], required: [{
                type: Input
            }], fields: [{
                type: Input
            }], form: [{
                type: Input
            }], onReset: [{
                type: Input
            }] } });

class EloQueryBuilderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQueryBuilderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloQueryBuilderModule, declarations: [QueryBuilderComponent,
            QueryBuilderTranslatorComponent,
            QueryBuilderItemComponent], imports: [CommonModule,
            FormControlValidationMsgModule,
            FormsModule,
            FormLabelColumnModule,
            DirectivesModule,
            NgxAngularQueryBuilderModule,
            SwitchButtonModule], exports: [QueryBuilderComponent,
            QueryBuilderTranslatorComponent,
            QueryBuilderItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQueryBuilderModule, providers: [
            EnumService
        ], imports: [CommonModule,
            FormControlValidationMsgModule,
            FormsModule,
            FormLabelColumnModule,
            DirectivesModule,
            NgxAngularQueryBuilderModule,
            SwitchButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQueryBuilderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormControlValidationMsgModule,
                        FormsModule,
                        FormLabelColumnModule,
                        DirectivesModule,
                        NgxAngularQueryBuilderModule,
                        SwitchButtonModule,
                    ],
                    exports: [
                        QueryBuilderComponent,
                        QueryBuilderTranslatorComponent,
                        QueryBuilderItemComponent
                    ],
                    declarations: [
                        QueryBuilderComponent,
                        QueryBuilderTranslatorComponent,
                        QueryBuilderItemComponent
                    ],
                    providers: [
                        EnumService
                    ]
                }]
        }] });

class EloQuickAccessButtonComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloQuickAccessButtonComponent, selector: "elo-quick-access-button", inputs: { routerLink: "routerLink", icon: "icon", title: "title" }, ngImport: i0, template: "<li class=\"col-sm-3 col-md-2\">\n    <a routerLink=\"{{routerLink}}\"><em class=\"{{icon}}\"></em>{{title}}</a>\n</li>\n", dependencies: [{ kind: "directive", type: i1$4.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-quick-access-button', template: "<li class=\"col-sm-3 col-md-2\">\n    <a routerLink=\"{{routerLink}}\"><em class=\"{{icon}}\"></em>{{title}}</a>\n</li>\n" }]
        }], propDecorators: { routerLink: [{
                type: Input
            }], icon: [{
                type: Input
            }], title: [{
                type: Input
            }] } });

class EloQuickAccessButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessButtonModule, declarations: [EloQuickAccessButtonComponent], imports: [CommonModule, RouterModule], exports: [EloQuickAccessButtonComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessButtonModule, imports: [CommonModule, RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule],
                    declarations: [EloQuickAccessButtonComponent],
                    exports: [EloQuickAccessButtonComponent],
                    providers: [],
                }]
        }] });

class EloQuickAccessComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloQuickAccessComponent, selector: "elo-quick-access", inputs: { title: "title" }, ngImport: i0, template: "<div class=\"module-access-seperator\">\n  <h1 class=\"mas-inner\">{{title}}</h1>\n</div>\n\n<ul class=\"quick-access row hidden-xs\">\n    <ng-content selector=\"quick-access-button\"></ng-content>\n</ul>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-quick-access', template: "<div class=\"module-access-seperator\">\n  <h1 class=\"mas-inner\">{{title}}</h1>\n</div>\n\n<ul class=\"quick-access row hidden-xs\">\n    <ng-content selector=\"quick-access-button\"></ng-content>\n</ul>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }] } });

class EloQuickAccessModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessModule, declarations: [EloQuickAccessComponent], imports: [CommonModule, EloQuickAccessButtonModule], exports: [EloQuickAccessComponent, EloQuickAccessButtonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessModule, imports: [CommonModule, EloQuickAccessButtonModule, EloQuickAccessButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloQuickAccessModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, EloQuickAccessButtonModule],
                    declarations: [EloQuickAccessComponent],
                    exports: [EloQuickAccessComponent, EloQuickAccessButtonModule],
                    providers: [],
                }]
        }] });

class QuickViewComponent {
    constructor() {
        this.onClosed = new EventEmitter();
        this.open = false;
        this.width = undefined;
        this.fixed = false;
    }
    close() {
        this.open = false;
        this.onClosed.emit();
    }
    clickedOutside($event) {
        if (this.open) {
            let parents = $event.path;
            let isQuickViewOpenerElement = false;
            parents.map(parent => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('quickViewOpener') ||
                        parent.classList.value.includes('preview') ||
                        parent.classList.value.includes('quick-view')) {
                        isQuickViewOpenerElement = true;
                    }
                }
            });
            if (!isQuickViewOpenerElement && this.open)
                this.close();
        }
    }
    handleKeyboardEvent(event) {
        if (event.code === 'Escape' && this.open) {
            this.close();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuickViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: QuickViewComponent, selector: "elo-quick-view", inputs: { open: "open", width: "width", fixed: "fixed" }, outputs: { onClosed: "onClosed" }, host: { listeners: { "document click": "clickedOutside($event)", "document:keydown": "handleKeyboardEvent($event)" } }, ngImport: i0, template: "<div class=\"quick-view\" [class.open]=\"open\" [style.width]=\"width ? width : ''\" [class.fixed]=\"fixed\">\n  <i class=\"fa fa-close no-print\" (click)=\"close()\"></i>\n  <ng-content></ng-content>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuickViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-quick-view', template: "<div class=\"quick-view\" [class.open]=\"open\" [style.width]=\"width ? width : ''\" [class.fixed]=\"fixed\">\n  <i class=\"fa fa-close no-print\" (click)=\"close()\"></i>\n  <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { onClosed: [{
                type: Output
            }], open: [{
                type: Input
            }], width: [{
                type: Input
            }], fixed: [{
                type: Input
            }], clickedOutside: [{
                type: HostListener,
                args: ['document click', ['$event']]
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class QuickViewModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuickViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: QuickViewModule, declarations: [QuickViewComponent], imports: [CommonModule], exports: [QuickViewComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuickViewModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuickViewModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [QuickViewComponent],
                    declarations: [QuickViewComponent]
                }]
        }] });

class ReportFormatComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.readonly = false;
        this.onSelectFormat = new EventEmitter();
        this.onChangeFormat = null;
        this.formatTypes = [
            'pdf', 'html', 'xls', 'xlsx', 'rtf', 'csv', 'xml', 'docx', 'odt', 'ods'
        ];
    }
    ngOnInit() {
        if (!this.form) {
            this.form = this.createForm();
        }
        this.onSelect({ target: { value: 'pdf' } });
        this.subscribeOnChangeFormat();
    }
    createForm() {
        const form = this.formBuilder.group({
            'formatType': ['pdf'],
        });
        return form;
    }
    subscribeOnChangeFormat() {
        if (this.onChangeFormat) {
            this.onChangeFormat.subscribe((type) => {
                this.form.patchValue({ formatType: type });
                this.onSelect({ target: { value: type } });
            });
        }
    }
    onSelect(formatType) {
        this.onSelectFormat.emit(formatType.target.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportFormatComponent, deps: [{ token: i1$2.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ReportFormatComponent, selector: "report-format", inputs: { readonly: "readonly", onChangeFormat: "onChangeFormat", form: "form" }, outputs: { onSelectFormat: "onSelectFormat" }, ngImport: i0, template: "<form [formGroup]=\"form\" inputs>\n    <elo-form-label-column label='Formato do Relat\u00F3rio' column=\"2\">\n        <select id=\"formatType\" formControlName=\"formatType\" (change)=\"onSelect($event)\" [class.readonly]=\"readonly\">\n            <option *ngFor=\"let formatType of formatTypes\" [value]=\"formatType\">{{ formatType }}</option>\n        </select>\n    </elo-form-label-column>\n</form>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: FormLabelColumnComponent, selector: "elo-form-label-column", inputs: ["label", "color", "column", "offset", "hintMessage", "hintPosition", "hintIconLeftAlign", "linkTitle", "showLink", "icon"], outputs: ["onClickLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportFormatComponent, decorators: [{
            type: Component,
            args: [{ selector: 'report-format', template: "<form [formGroup]=\"form\" inputs>\n    <elo-form-label-column label='Formato do Relat\u00F3rio' column=\"2\">\n        <select id=\"formatType\" formControlName=\"formatType\" (change)=\"onSelect($event)\" [class.readonly]=\"readonly\">\n            <option *ngFor=\"let formatType of formatTypes\" [value]=\"formatType\">{{ formatType }}</option>\n        </select>\n    </elo-form-label-column>\n</form>" }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }], propDecorators: { readonly: [{
                type: Input
            }], onSelectFormat: [{
                type: Output
            }], onChangeFormat: [{
                type: Input
            }], form: [{
                type: Input
            }] } });

class ReportFormatModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportFormatModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ReportFormatModule, declarations: [ReportFormatComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FormLabelColumnModule,
            FormsModule], exports: [ReportFormatComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportFormatModule, imports: [CommonModule,
            ReactiveFormsModule,
            FormLabelColumnModule,
            FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportFormatModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormLabelColumnModule,
                        FormsModule
                    ],
                    declarations: [ReportFormatComponent],
                    exports: [ReportFormatComponent]
                }]
        }] });

class ReportSelectorComponent {
    constructor() {
        this.findToOptions = null;
        this.objToOption = null;
        this.onModGroupParent = new EventEmitter();
        this.onSelectReport = new EventEmitter();
        this.onSelectGroup = new EventEmitter();
    }
    ngOnInit() {
        this.onModGroupParent.subscribe(() => {
            this.grupoRelatorio = null;
        });
    }
    onSelect(reportSelected) {
        this.onSelectReport.emit(reportSelected);
        this.relatorioSelecionado = reportSelected;
    }
    onChangeGrupo() {
        this.relatorioSelecionado = null;
        if (this.grupoRelatorio) {
            this.onSelectGroup.emit(this.grupoRelatorio);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ReportSelectorComponent, selector: "report-selector", inputs: { grupoRelatorio: "grupoRelatorio", relatorioSelecionado: "relatorioSelecionado", findToOptions: "findToOptions", objToOption: "objToOption", relatorios: "relatorios", onModGroupParent: "onModGroupParent" }, outputs: { onSelectReport: "onSelectReport", onSelectGroup: "onSelectGroup" }, ngImport: i0, template: "<elo-panel [hasForm]=\"true\" [hasTable]=\"true\" [title]=\"'Selecione o relat\u00F3rio desejado'\">\n  <div class=\"row mb-xs\">\n\n    <elo-form-label-column *ngIf=\"findToOptions !== null && objToOption !== null \" label='Grupo' column=\"12\">\n      <elo-autocomplete id=\"grupoRelatorio\" [(ngModel)]=\"grupoRelatorio\" [findToOptions]=\"findToOptions()\"\n        [objToOption]=\"objToOption()\" (onChangeValue)=\"onChangeGrupo()\">\n      </elo-autocomplete>\n    </elo-form-label-column>\n  </div>\n\n  <elo-panel id=\"childs\" *ngIf=\"relatorios && !relatorioSelecionado\" [title]=\"''\">\n    <elo-datatable [class]=\"relatorios?.length > 6 ? 'fixed'  : ''\" [values]=\"relatorios\" [colSpanActions]=\"'1'\"\n      [emptyMessage]=\"'N\u00E3o foram encontrados tipos de relat\u00F3rio.'\">\n\n      <elo-column [field]=\"'codigo'\" [header]=\"'C\u00F3digo'\" [col]=\"'1'\"></elo-column>\n      <elo-column [field]=\"'descricao'\" [header]=\"'Descri\u00E7\u00E3o'\" [col]=\"'10'\"></elo-column>\n      <elo-table-actions [title]=\"'Selecionar'\" icon='fa fa-print' id=\"selectReport\"\n        (onClickIconButton)=\"onSelect($event)\"></elo-table-actions>\n\n    </elo-datatable>\n  </elo-panel>\n</elo-panel>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AutoCompleteComponent, selector: "elo-autocomplete", inputs: ["multiplo", "multipleSelected", "id", "options", "error", "service", "placeholder", "noResultsMessage", "urlCreate", "searchModal", "isDisabled", "findToOptions", "objToOption", "objToOptionViewMultiple", "debounceTime", "autoSelect", "isEnabledCreateRecord", "descriptionNewRecord", "validateDeps", "insertIcon", "extraInfos", "emptyRecord", "removeDot"], outputs: ["onChangeMultipleValue", "onChangeValue", "onSearchModal", "onInsertButton", "onCreateRecord"] }, { kind: "component", type: FormLabelColumnComponent, selector: "elo-form-label-column", inputs: ["label", "color", "column", "offset", "hintMessage", "hintPosition", "hintIconLeftAlign", "linkTitle", "showLink", "icon"], outputs: ["onClickLink"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: PanelComponent, selector: "elo-panel", inputs: ["title", "hasTable", "hasForm", "pbNone"] }, { kind: "component", type: EloDatatableComponent, selector: "elo-datatable", inputs: ["values", "paramExpandTemplate", "emptyMessage", "selection", "selectionMode", "selectionModeId", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "titleCheckboxDisallowed", "sortable", "pageParameters", "class", "colSpanActions", "isQuickViewOpener", "manyActions", "classEmptyMessage", "rowDoubleClickFunction", "visibleRadioWhenFunction", "enableScrollX", "textTransform", "headerFixo", "showHeader", "selectionModeWithFooter"], outputs: ["onClickCheckbox", "onClickRadioButton", "onSelectOne", "onModifySelection", "onTableHeadClick", "onInputChange", "onRowDoubleClick"] }, { kind: "component", type: EloColumnComponent, selector: "elo-column", inputs: ["field", "header", "headerAlign", "isDecimal", "isPercentual", "digits", "isDate", "isDateTime", "isCnpjCpf", "enumOptions", "col", "class", "isEditable", "isEditing", "dataTable", "hidden", "hiddenTableData", "sortable", "samp", "headerStyle", "dataStyle"] }, { kind: "component", type: EloTableActionsComponent, selector: "elo-table-actions", inputs: ["showError", "hasLinks", "links", "linksFunction", "quickViewOpener", "removeAutoFocus"], outputs: ["onClickLink", "onClickIconButton", "onHoverIconButton"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'report-selector', template: "<elo-panel [hasForm]=\"true\" [hasTable]=\"true\" [title]=\"'Selecione o relat\u00F3rio desejado'\">\n  <div class=\"row mb-xs\">\n\n    <elo-form-label-column *ngIf=\"findToOptions !== null && objToOption !== null \" label='Grupo' column=\"12\">\n      <elo-autocomplete id=\"grupoRelatorio\" [(ngModel)]=\"grupoRelatorio\" [findToOptions]=\"findToOptions()\"\n        [objToOption]=\"objToOption()\" (onChangeValue)=\"onChangeGrupo()\">\n      </elo-autocomplete>\n    </elo-form-label-column>\n  </div>\n\n  <elo-panel id=\"childs\" *ngIf=\"relatorios && !relatorioSelecionado\" [title]=\"''\">\n    <elo-datatable [class]=\"relatorios?.length > 6 ? 'fixed'  : ''\" [values]=\"relatorios\" [colSpanActions]=\"'1'\"\n      [emptyMessage]=\"'N\u00E3o foram encontrados tipos de relat\u00F3rio.'\">\n\n      <elo-column [field]=\"'codigo'\" [header]=\"'C\u00F3digo'\" [col]=\"'1'\"></elo-column>\n      <elo-column [field]=\"'descricao'\" [header]=\"'Descri\u00E7\u00E3o'\" [col]=\"'10'\"></elo-column>\n      <elo-table-actions [title]=\"'Selecionar'\" icon='fa fa-print' id=\"selectReport\"\n        (onClickIconButton)=\"onSelect($event)\"></elo-table-actions>\n\n    </elo-datatable>\n  </elo-panel>\n</elo-panel>" }]
        }], propDecorators: { grupoRelatorio: [{
                type: Input
            }], relatorioSelecionado: [{
                type: Input
            }], findToOptions: [{
                type: Input
            }], objToOption: [{
                type: Input
            }], relatorios: [{
                type: Input
            }], onModGroupParent: [{
                type: Input
            }], onSelectReport: [{
                type: Output
            }], onSelectGroup: [{
                type: Output
            }] } });

class ReportSelectorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ReportSelectorModule, declarations: [ReportSelectorComponent], imports: [CommonModule,
            AutoCompleteModule,
            FormLabelColumnModule,
            FormsModule,
            EloModalModule,
            PanelModule,
            EloDatatableModule,
            PanelExpansiveModule], exports: [ReportSelectorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportSelectorModule, imports: [CommonModule,
            AutoCompleteModule,
            FormLabelColumnModule,
            FormsModule,
            EloModalModule,
            PanelModule,
            EloDatatableModule,
            PanelExpansiveModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        AutoCompleteModule,
                        FormLabelColumnModule,
                        FormsModule,
                        EloModalModule,
                        PanelModule,
                        EloDatatableModule,
                        PanelExpansiveModule
                    ],
                    declarations: [ReportSelectorComponent],
                    exports: [ReportSelectorComponent]
                }]
        }] });

class RotaFavoritaService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.atalhos = new Array(8).fill({});
        this.quantidadeMax = true;
        this.resource = '/api/rota-favorita';
    }
    isRotaFavorita(route) {
        if (this.atalhos.find(atalho => atalho.rota === route)) {
            return true;
        }
        return false;
    }
    refresh() {
        return new Promise((resolve) => {
            this.httpClient.get({
                resource: `${this.resource}/me`,
            }).subscribe(rotas => {
                this.atalhos = rotas;
                this.quantidadeMax = true;
                while (this.atalhos.length < 8) {
                    this.quantidadeMax = false;
                    this.atalhos.push({ icone: 'fa fa-star-o' });
                }
                resolve(true);
            });
        });
    }
    getMinhasRotasFavoritas() {
        return this.atalhos;
    }
    create(rotaFavorita) {
        return this.httpClient.post({
            resource: `${this.resource}/add`,
            body: rotaFavorita,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RotaFavoritaService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RotaFavoritaService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RotaFavoritaService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

class RodaAtalhosComponent {
    constructor(_rotaFavoritaService, _router) {
        this._rotaFavoritaService = _rotaFavoritaService;
        this._router = _router;
        this.enabled = true;
        this.atalhos = new Array(8).fill({});
        this.active = false;
        this.atalhoSelecionado = {};
    }
    ngOnInit() {
        this._carregarAtalhos();
    }
    handleKeyboardEvent(event) {
        if (this.enabled && this.ctrlAlt(event)) {
            this.openCloseTheBar();
            return;
        }
        if (event.code === 'Escape' && this.active) {
            this._close();
            return;
        }
    }
    openCloseTheBar() {
        this._carregarAtalhos();
        this.active = !this.active;
    }
    ocultarRodaEventosQuandoForaItemMenu(evento) {
        if (evento.target.className === 'shortcut-wheel' || evento.target.className === 'shortcut-wheel-container') {
            this._close();
        }
    }
    navegarPara(atalho) {
        if (!atalho.rota) {
            return;
        }
        this._router.navigate([atalho.rota]).then(() => {
            this.active = false;
        });
    }
    mouseEnter(atalho) {
        this.atalhoSelecionado = atalho;
        if (!this.atalhoSelecionado.id) {
            this.atalhoSelecionado.descricao = 'Posição não utilizada';
        }
    }
    mouseLeave() {
        this.atalhoSelecionado = {};
    }
    _carregarAtalhos() {
        this.atalhos = this._rotaFavoritaService.getMinhasRotasFavoritas();
    }
    ctrlAlt(event) {
        return event.ctrlKey &&
            event.altKey;
    }
    _close() {
        this.active = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RodaAtalhosComponent, deps: [{ token: RotaFavoritaService }, { token: i1$4.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: RodaAtalhosComponent, selector: "roda-atalhos", inputs: { enabled: "enabled" }, host: { listeners: { "document:keydown": "handleKeyboardEvent($event)" } }, ngImport: i0, template: "<div class=\"shortcut-wheel-container\" (click)=\"ocultarRodaEventosQuandoForaItemMenu($event)\" [class.hidden]=\"!active\">\n  <div class=\"shortcut-wheel\">\n\n    <div class=\"shortcut-wheel-item\"\n         *ngFor=\"let atalho of atalhos\"\n         (click)=\"navegarPara(atalho)\"\n         (mouseenter)=\"mouseEnter(atalho)\"\n         (mouseleave)=\"mouseLeave()\"><i class=\"{{atalho.icone}}\"></i>\n      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 179.02 91.18\">\n        <g id=\"Camada_2\" data-name=\"Camada 2\">\n          <g id=\"Camada_1-2\" data-name=\"Camada 1\">\n            <path\n              d=\"M176.33,15A247.08,247.08,0,0,0,2.63,16.53,4.08,4.08,0,0,0,.32,21.92l1.13,2.65a4,4,0,0,1,2.32-5.16,243.91,243.91,0,0,1,171.41-1.5,4,4,0,0,1,2.37,5.28L151.4,87.9a2.29,2.29,0,0,0,.14-.27l27.18-67.27A4.07,4.07,0,0,0,176.33,15Z\"></path>\n            <path\n              d=\"M175.18,17.91A243.91,243.91,0,0,0,3.77,19.41a4,4,0,0,0-2.32,5.16L28.67,88.7a4,4,0,0,0,5.1,2.23,166.78,166.78,0,0,1,112.7-1,4,4,0,0,0,4.93-2l26.15-64.71A4,4,0,0,0,175.18,17.91Z\"></path>\n            <path\n              d=\"M175.18,17.91A243.91,243.91,0,0,0,3.77,19.41a4,4,0,0,0-2.32,5.16L28.67,88.7a4,4,0,0,0,5.1,2.23,166.78,166.78,0,0,1,112.7-1,4,4,0,0,0,4.93-2l26.15-64.71A4,4,0,0,0,175.18,17.91Z\"></path>\n          </g>\n        </g>\n      </svg>\n    </div>\n\n    <p class=\"shortcut-wheel-description\" *ngIf=\"!atalhoSelecionado\">Selecione ou digite o n\u00FAmero da op\u00E7\u00E3o desejada</p>\n    <p class=\"shortcut-wheel-description\" *ngIf=\"atalhoSelecionado\">{{atalhoSelecionado.descricao}}</p>\n  </div>\n</div> \n", styles: [":host ::ng-deep i:after{content:none!important}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RodaAtalhosComponent, decorators: [{
            type: Component,
            args: [{ selector: 'roda-atalhos', template: "<div class=\"shortcut-wheel-container\" (click)=\"ocultarRodaEventosQuandoForaItemMenu($event)\" [class.hidden]=\"!active\">\n  <div class=\"shortcut-wheel\">\n\n    <div class=\"shortcut-wheel-item\"\n         *ngFor=\"let atalho of atalhos\"\n         (click)=\"navegarPara(atalho)\"\n         (mouseenter)=\"mouseEnter(atalho)\"\n         (mouseleave)=\"mouseLeave()\"><i class=\"{{atalho.icone}}\"></i>\n      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 179.02 91.18\">\n        <g id=\"Camada_2\" data-name=\"Camada 2\">\n          <g id=\"Camada_1-2\" data-name=\"Camada 1\">\n            <path\n              d=\"M176.33,15A247.08,247.08,0,0,0,2.63,16.53,4.08,4.08,0,0,0,.32,21.92l1.13,2.65a4,4,0,0,1,2.32-5.16,243.91,243.91,0,0,1,171.41-1.5,4,4,0,0,1,2.37,5.28L151.4,87.9a2.29,2.29,0,0,0,.14-.27l27.18-67.27A4.07,4.07,0,0,0,176.33,15Z\"></path>\n            <path\n              d=\"M175.18,17.91A243.91,243.91,0,0,0,3.77,19.41a4,4,0,0,0-2.32,5.16L28.67,88.7a4,4,0,0,0,5.1,2.23,166.78,166.78,0,0,1,112.7-1,4,4,0,0,0,4.93-2l26.15-64.71A4,4,0,0,0,175.18,17.91Z\"></path>\n            <path\n              d=\"M175.18,17.91A243.91,243.91,0,0,0,3.77,19.41a4,4,0,0,0-2.32,5.16L28.67,88.7a4,4,0,0,0,5.1,2.23,166.78,166.78,0,0,1,112.7-1,4,4,0,0,0,4.93-2l26.15-64.71A4,4,0,0,0,175.18,17.91Z\"></path>\n          </g>\n        </g>\n      </svg>\n    </div>\n\n    <p class=\"shortcut-wheel-description\" *ngIf=\"!atalhoSelecionado\">Selecione ou digite o n\u00FAmero da op\u00E7\u00E3o desejada</p>\n    <p class=\"shortcut-wheel-description\" *ngIf=\"atalhoSelecionado\">{{atalhoSelecionado.descricao}}</p>\n  </div>\n</div> \n", styles: [":host ::ng-deep i:after{content:none!important}\n"] }]
        }], ctorParameters: () => [{ type: RotaFavoritaService }, { type: i1$4.Router }], propDecorators: { enabled: [{
                type: Input
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class RodaAtalhosModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RodaAtalhosModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: RodaAtalhosModule, declarations: [RodaAtalhosComponent], imports: [CommonModule], exports: [RodaAtalhosComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RodaAtalhosModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RodaAtalhosModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        RodaAtalhosComponent,
                    ],
                    exports: [
                        RodaAtalhosComponent,
                    ]
                }]
        }] });

class SectionDirective {
    constructor(sectionService) {
        this.sectionService = sectionService;
        this.route = '';
        this.icon = '';
        this.name = '';
    }
    ngOnInit() {
        this.sectionService.registerContent({ route: this.route, icon: this.icon, name: this.name });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionDirective, deps: [{ token: SectionService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SectionDirective, selector: "[sectionContent]", inputs: { route: "route", icon: "icon", name: "name" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sectionContent]' }]
        }], ctorParameters: () => [{ type: SectionService }], propDecorators: { route: [{
                type: Input
            }], icon: [{
                type: Input
            }], name: [{
                type: Input
            }] } });

class SectionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SectionModule, declarations: [SectionComponent, SectionDirective], imports: [RouterModule, CommonModule, BreadcrumbModule], exports: [SectionComponent, SectionDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionModule, providers: [
            SectionService,
            IFrameStore
        ], imports: [RouterModule, CommonModule, BreadcrumbModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule, CommonModule, BreadcrumbModule],
                    declarations: [SectionComponent, SectionDirective],
                    exports: [SectionComponent, SectionDirective],
                    providers: [
                        SectionService,
                        IFrameStore
                    ]
                }]
        }] });

class DeviceUtils {
    static isMobile() {
        return innerWidth < 800;
    }
}

class SideBarItemDirective {
    constructor(parent) {
        this.parent = parent;
        this.enabled = true;
        this.active = false;
        this.external = false;
        this.toggleMenuOnClick = false;
        this.open = false;
        this.onClickToToggled = new EventEmitter();
        this.items = [];
        if (this.parent) {
            this.parent.items.push(this);
        }
        else {
            this.sidebar?.addItem(this);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SideBarItemDirective, deps: [{ token: SideBarItemDirective, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SideBarItemDirective, selector: "[sidebaritem]", inputs: { name: "name", icon: "icon", route: "route", params: "params", hidden: "hidden", enabled: "enabled", recurso: "recurso", count: "count", active: "active", external: "external", toggleMenuOnClick: "toggleMenuOnClick", open: "open" }, outputs: { onClickToToggled: "onClickToToggled" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SideBarItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[sidebaritem]'
                }]
        }], ctorParameters: () => [{ type: SideBarItemDirective, decorators: [{
                    type: SkipSelf
                }, {
                    type: Optional
                }] }], propDecorators: { name: [{
                type: Input
            }], icon: [{
                type: Input
            }], route: [{
                type: Input
            }], params: [{
                type: Input
            }], hidden: [{
                type: Input
            }], enabled: [{
                type: Input
            }], recurso: [{
                type: Input
            }], count: [{
                type: Input
            }], active: [{
                type: Input
            }], external: [{
                type: Input
            }], toggleMenuOnClick: [{
                type: Input
            }], open: [{
                type: Input
            }], onClickToToggled: [{
                type: Output
            }] } });

class SidebarItemComponent {
    constructor(authHttp, router, location, authResourcesConfig) {
        this.authHttp = authHttp;
        this.router = router;
        this.location = location;
        this.authResourcesConfig = authResourcesConfig;
        this.render = true;
        this.hasChildWithAccess = of(true);
        this.hasAccess = of(true);
        this.onOpenSubMenu = new EventEmitter();
        this.onClearActivedMenus = new EventEmitter();
        this.onCloseNotActivedMenus = new EventEmitter();
    }
    set searchValue(value) {
        this.internalSearchValue = value;
        this.render = this.existsOnSearch(this.item);
    }
    ngOnInit() {
        if (this.authHttp.isLogged()) {
            this.hasChildWithAccess = from(this.item.items)
                .pipe(mergeMap(item => this.authHttp.hasPermissionByRoute(item.route)), filter(val => val), defaultIfEmpty(false));
            this.hasAccess = this.authHttp.hasPermissionByRoute(this.item.route);
        }
        const currentUrl = this.location.path().split('/')[1];
        if (this.item.route && currentUrl === this.item.route) {
            this.activeSidebarsPaths();
        }
    }
    onClickSubMenu() {
        this.item.open = !this.item.open;
        if (this.item.open && this.checkVisibleSubMenu()) {
            this.openSubMenu();
        }
    }
    checkVisibleSubMenu() {
        return !this.floatType && window.innerWidth > 1024 || window.innerWidth < 1025 || this.floatType && this.focusedSearchInput;
    }
    handleMouseEnterMenuFloatType($event) {
        if (this.floatType && window.innerWidth > 1024 && !this.focusedSearchInput) {
            document.querySelector('aside.sidebar-toggle').classList.add('hover');
            let child = $event.target.querySelector('ul');
            if (child) {
                let childHeight = child.offsetHeight;
                let bounding = $event.target.getBoundingClientRect();
                let offsetTop = bounding.y;
                let windowHeight = window.innerHeight;
                if (childHeight > windowHeight) {
                    childHeight = windowHeight - 310;
                }
                if (offsetTop + childHeight > windowHeight) {
                    offsetTop = offsetTop - ((offsetTop + childHeight) - windowHeight) - 5;
                }
                child.style.left = bounding.x + bounding.width + 'px';
                child.style.maxHeight = childHeight + 'px';
                child.style.top = offsetTop + 'px';
            }
        }
    }
    handleMouseLeaveMenuFloatType($event) {
        if (this.floatType && window.innerWidth > 1024 && !this.focusedSearchInput) {
            let child = $event.target.querySelector('ul');
            $event.stopPropagation();
            if (child) {
                $event.target.querySelector('ul').style.top = 0;
            }
            document.querySelector('aside.sidebar-toggle').classList.remove('hover');
        }
    }
    openSubMenu() {
        this.onOpenSubMenu.emit();
    }
    clearActivedMenus() {
        this.onClearActivedMenus.emit();
    }
    closeNotActivedMenus() {
        this.onCloseNotActivedMenus.emit();
    }
    clickLink(event) {
        if (!event.ctrlKey) {
            this.onClearActivedMenus.emit();
            this.activeSidebarsPaths();
            if (this.item.external) {
                const host = this.authResourcesConfig.isDev ? this.authResourcesConfig.hostDev : window.location.origin;
                window.open(host + this.item.route);
                return;
            }
            if (!this.item.enabled) {
                this.router.navigate(['page-blocked']);
                event.stopPropagation();
                return;
            }
            if (this.item.toggleMenuOnClick) {
                this.item.onClickToToggled.emit();
            }
            this.router.navigate([this.item.route], this.item.params);
            this.clickLinkSubMenu();
        }
    }
    activeSidebarsPaths() {
        setTimeout(() => {
            this.item.active = true;
            if (this.item.parent) {
                this.item.parent.open = true;
                this.item.parent.active = true;
                if (this.item.parent.parent) {
                    this.item.parent.parent.open = true;
                    this.item.parent.parent.active = true;
                }
            }
            this.closeNotActivedMenus();
        }, 200);
    }
    existsOnSearch(sidebarItem) {
        if (!this.internalSearchValue) {
            return true;
        }
        if (sidebarItem.items.length > 0) {
            this.item.open = this.searchMatchFilterItems(sidebarItem);
            return this.item.open;
        }
        else {
            return this.searchMatchFilter(sidebarItem);
        }
    }
    searchMatchFilterItems(sidebarItem) {
        let exists = false;
        sidebarItem.items.forEach(item => {
            if (!exists) {
                exists = this.existsOnSearch(item);
            }
        });
        return exists;
    }
    searchMatchFilter(sidebarItem) {
        return StringUtils.removeAccent(sidebarItem.name).toUpperCase().includes(StringUtils.removeAccent(this.internalSearchValue).toUpperCase());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarItemComponent, deps: [{ token: AbstractAuthHttp }, { token: i1$4.Router }, { token: i1.Location }, { token: AUTH_RESOURCES_CONFIG }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SidebarItemComponent, selector: "elo-sidebar-item", inputs: { item: "item", toggled: "toggled", floatType: "floatType", focusedSearchInput: "focusedSearchInput", clickLinkSubMenu: "clickLinkSubMenu", searchValue: "searchValue" }, outputs: { onOpenSubMenu: "onOpenSubMenu", onClearActivedMenus: "onClearActivedMenus", onCloseNotActivedMenus: "onCloseNotActivedMenus" }, ngImport: i0, template: "<div *ngIf=\"render && hasAccess | async\">\n  <li [hidden]=\"item.hidden\" *ngIf=\"item.items.length === 0\" [class.on]=\"item.active\"\n    (mouseenter)=\"handleMouseEnterMenuFloatType($event)\" (mouseleave)=\"handleMouseLeaveMenuFloatType($event)\">\n    <a [class.disabled]=\"!item.enabled\" (click)=\"clickLink($event)\" [routerLink]=\"'/' + item.route\"\n      style=\"cursor: pointer\">\n      <i class=\"{{item.enabled ? item.icon : 'fa fa-ban'}}\"></i>\n      <span class=\"count\" *ngIf=\"item.count\">{{item.count}}</span>\n      <b>{{item.name}}</b>\n    </a>\n  </li>\n  <ng-container *ngIf=\"item.items.length > 0 && hasChildWithAccess | async\">\n    <li [hidden]=\"item.hidden\" [class.top]=\"item.open\" (mouseenter)=\"handleMouseEnterMenuFloatType($event)\"\n      (mouseleave)=\"handleMouseLeaveMenuFloatType($event)\" [class.on]=\"item.active\">\n      <a (click)=\"onClickSubMenu()\" class=\"dropdown-arrow\" [class.open]=\"item.open\">\n        <i class=\"{{item.icon}}\"></i>\n        <b> {{item.name}}</b>\n      </a>\n      <ul ref=\"slide\" [attr.attr-parent]=\"item.name\"\n        [class.visible-block]=\"this.item.open && this.checkVisibleSubMenu()\">\n        <elo-sidebar-item *ngFor=\"let itemChild of item.items\" [item]=\"itemChild\" [searchValue]=\"internalSearchValue\"\n          (onClearActivedMenus)=\"clearActivedMenus()\" (onCloseNotActivedMenus)=\"closeNotActivedMenus()\"\n          [toggled]=\"toggled\" [floatType]=\"floatType\" [focusedSearchInput]=\"focusedSearchInput\"\n          [clickLinkSubMenu]=\"clickLinkSubMenu\">\n        </elo-sidebar-item>\n      </ul>\n    </li>\n  </ng-container>\n</div>", styles: [".disabled{background-color:#ddd!important;margin-bottom:-1px;cursor:pointer!important}.disabled b{text-decoration:line-through}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: SidebarItemComponent, selector: "elo-sidebar-item", inputs: ["item", "toggled", "floatType", "focusedSearchInput", "clickLinkSubMenu", "searchValue"], outputs: ["onOpenSubMenu", "onClearActivedMenus", "onCloseNotActivedMenus"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-sidebar-item', template: "<div *ngIf=\"render && hasAccess | async\">\n  <li [hidden]=\"item.hidden\" *ngIf=\"item.items.length === 0\" [class.on]=\"item.active\"\n    (mouseenter)=\"handleMouseEnterMenuFloatType($event)\" (mouseleave)=\"handleMouseLeaveMenuFloatType($event)\">\n    <a [class.disabled]=\"!item.enabled\" (click)=\"clickLink($event)\" [routerLink]=\"'/' + item.route\"\n      style=\"cursor: pointer\">\n      <i class=\"{{item.enabled ? item.icon : 'fa fa-ban'}}\"></i>\n      <span class=\"count\" *ngIf=\"item.count\">{{item.count}}</span>\n      <b>{{item.name}}</b>\n    </a>\n  </li>\n  <ng-container *ngIf=\"item.items.length > 0 && hasChildWithAccess | async\">\n    <li [hidden]=\"item.hidden\" [class.top]=\"item.open\" (mouseenter)=\"handleMouseEnterMenuFloatType($event)\"\n      (mouseleave)=\"handleMouseLeaveMenuFloatType($event)\" [class.on]=\"item.active\">\n      <a (click)=\"onClickSubMenu()\" class=\"dropdown-arrow\" [class.open]=\"item.open\">\n        <i class=\"{{item.icon}}\"></i>\n        <b> {{item.name}}</b>\n      </a>\n      <ul ref=\"slide\" [attr.attr-parent]=\"item.name\"\n        [class.visible-block]=\"this.item.open && this.checkVisibleSubMenu()\">\n        <elo-sidebar-item *ngFor=\"let itemChild of item.items\" [item]=\"itemChild\" [searchValue]=\"internalSearchValue\"\n          (onClearActivedMenus)=\"clearActivedMenus()\" (onCloseNotActivedMenus)=\"closeNotActivedMenus()\"\n          [toggled]=\"toggled\" [floatType]=\"floatType\" [focusedSearchInput]=\"focusedSearchInput\"\n          [clickLinkSubMenu]=\"clickLinkSubMenu\">\n        </elo-sidebar-item>\n      </ul>\n    </li>\n  </ng-container>\n</div>", styles: [".disabled{background-color:#ddd!important;margin-bottom:-1px;cursor:pointer!important}.disabled b{text-decoration:line-through}\n"] }]
        }], ctorParameters: () => [{ type: AbstractAuthHttp }, { type: i1$4.Router }, { type: i1.Location }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }], propDecorators: { item: [{
                type: Input
            }], toggled: [{
                type: Input
            }], floatType: [{
                type: Input
            }], focusedSearchInput: [{
                type: Input
            }], clickLinkSubMenu: [{
                type: Input
            }], onOpenSubMenu: [{
                type: Output
            }], onClearActivedMenus: [{
                type: Output
            }], onCloseNotActivedMenus: [{
                type: Output
            }], searchValue: [{
                type: Input
            }] } });

class SidebarComponent {
    constructor(renderer, sidebarService) {
        this.renderer = renderer;
        this.sidebarService = sidebarService;
        this.toggled = true;
        this.floatType = false;
        this.focusedSearchInput = false;
        this.fancy = false;
        this.enableShortcut = false;
        this.hideAll = false;
        this.openClose = new EventEmitter();
        this.onOpenSubMenu = new EventEmitter();
        this.onInit = new EventEmitter();
        this.onClickSubMenu = new EventEmitter();
        this.onHideRequest = new EventEmitter();
        this.onClickToToggled = new EventEmitter();
        this.items = new QueryList();
        this.clicked = false;
        this.clickLinkSubMenu = () => {
            this.onClickSubMenu.emit();
            this.hideRequestIfMobile();
            this.clearSearchInput();
            if (this.focusedSearchInput) {
                this.floatType = true;
                this.focusedSearchInput = false;
            }
        };
    }
    ngAfterViewInit() {
        this.sidebarService.sidebars = this.getSidebarTree();
        setTimeout(() => {
            this.onInit.emit(this.getSidebarTree());
        });
    }
    onMouseEnter() {
        this.clicked = false;
    }
    getSidebarTree() {
        return this.items.toArray();
    }
    addItem(item) {
        item.sidebar = this;
    }
    onClickToggledButton() {
        this.onClickToToggled.emit();
    }
    ngOnInit() {
        if (this.fancy) {
            this.usuarioLogado.then(profile => this._imgPerfil = { url: profile.picture });
        }
    }
    clickedOutside($event) {
        if (!this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFuncionarioSidebarOpen = false;
            if (parents && parents.length > 0 && parents[0].localName === 'app-root') {
                isFuncionarioSidebarOpen = true;
            }
            parents.map(parent => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('sidebar')) {
                        isFuncionarioSidebarOpen = true;
                    }
                }
            });
            if (!isFuncionarioSidebarOpen) {
                if (DeviceUtils.isMobile()) {
                    this.onHideRequest.emit();
                }
            }
        }
        if (this.focusedSearchInput) {
            if ($event.target.classList.contains('main-content') || $event.target.closest('.main-content')) {
                this.floatType = true;
                this.focusedSearchInput = false;
            }
        }
    }
    handleKeyboardEvent(event) {
        if (this.hideAll) {
            return;
        }
        const element = this.renderer.selectRootElement('#sidebar-search-input');
        if (this.isEscape(event)) {
            setTimeout(() => element.blur(), 0);
            this.clearSearchInput();
            if (!this.toggled) {
                this.openClose.emit();
            }
        }
        if (this.enableShortcut && this.isCtrlShiftF(event)) {
            this.openClose.emit();
            setTimeout(() => element.focus(), 0);
        }
    }
    handleOnFocus() {
        if (this.floatType) {
            this.floatType = false;
            this.focusedSearchInput = true;
            setTimeout(() => {
                const input = this.renderer.selectRootElement('#sidebar-search-input');
                input.focus();
            }, 500);
        }
    }
    handleOnBlur() {
        if (this.floatType) {
            setTimeout(() => {
                this.focusedSearchInput = false;
            }, 500);
        }
    }
    clearActivedMenus() {
        this.clicked = true;
        this.items.map((item) => {
            item.active = false;
            item.items.map((child) => {
                child.active = false;
                child.items.map((childOfChild) => {
                    childOfChild.active = false;
                });
            });
        });
    }
    closeNotActivedMenus() {
        this.items.map((item) => {
            item.open = false;
            item.items.map((child) => {
                child.open = false;
                if (child.active) {
                    item.open = true;
                }
                child.items.map((childOfChild) => {
                    if (childOfChild.active) {
                        item.open = true;
                        child.open = true;
                    }
                });
            });
        });
    }
    hideRequestIfMobile() {
        if (DeviceUtils.isMobile()) {
            this.onHideRequest.emit();
        }
    }
    clearSearchInput() {
        this.searchValue = '';
    }
    isCtrlShiftF(event) {
        return event.ctrlKey && event.shiftKey && event.code === 'KeyF';
    }
    isEscape(event) {
        return event.code === 'Escape';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarComponent, deps: [{ token: i0.Renderer2 }, { token: SidebarService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SidebarComponent, selector: "elo-sidebar", inputs: { title: "title", toggled: "toggled", floatType: "floatType", focusedSearchInput: "focusedSearchInput", fancy: "fancy", userName: "userName", imgModuleMain: "imgModuleMain", imgModule: "imgModule", imgModuleRebranding: "imgModuleRebranding", usuarioLogado: "usuarioLogado", enableShortcut: "enableShortcut", hideAll: "hideAll" }, outputs: { openClose: "openClose", onOpenSubMenu: "onOpenSubMenu", onInit: "onInit", onClickSubMenu: "onClickSubMenu", onHideRequest: "onHideRequest", onClickToToggled: "onClickToToggled" }, host: { listeners: { "document:click": "clickedOutside($event)", "document:keydown": "handleKeyboardEvent($event)" } }, queries: [{ propertyName: "items", predicate: SideBarItemDirective }], ngImport: i0, template: "<aside *ngIf=\"!hideAll\" class=\"sidebar new\" [class.sidebar-toggle]=\"toggled\" [class.float-type]=\"toggled\"\n  [class.focused-search]=\"focusedSearchInput\" (mouseenter)=\"onMouseEnter()\" [class.clicked]=\"clicked\"\n  [class.fancy]=\"fancy\">\n\n  <header class=\"sidebar-header\">\n    <div class=\"sidebar-module\"><img *ngIf=\"imgModule\" class=\"module-main\" src=\"{{imgModuleRebranding}}\"></div>\n    <div class=\"sidebar-title\">{{title}}</div>\n  </header>\n\n  <div class=\"sidebar-search\">\n    <input id=\"sidebar-search-input\" placeholder=\"Buscar em Menu..\" [(ngModel)]=\"searchValue\" (focus)=\"handleOnFocus()\"\n      autocomplete=\"off\">\n    <i class=\"fa fa-search\" aria-hidden=\"true\" (click)=\"handleOnFocus()\"></i>\n  </div>\n\n  <ul class=\"sidebar-itens\">\n    <div *ngFor=\"let item of items\">\n      <elo-sidebar-item data-id=\"parent\" [item]=\"item\" [searchValue]=\"searchValue\"\n        (onClearActivedMenus)=\"clearActivedMenus()\" (onCloseNotActivedMenus)=\"closeNotActivedMenus()\"\n        [toggled]=\"toggled\" [floatType]=\"floatType\" [focusedSearchInput]=\"focusedSearchInput\"\n        [clickLinkSubMenu]=\"clickLinkSubMenu\">\n      </elo-sidebar-item>\n    </div>\n  </ul>\n\n  <button class=\"header-toggle-sidebar toggle-control hidden-xs hidden-sm\" aria-label=\"Bot\u00E3o para expandir o menu\"\n    (click)=\"onClickToggledButton()\">\n    <div *ngIf=\"toggled\" class=\"fa fa-angle-double-right\"></div>\n\n    <ng-container *ngIf=\"!toggled\">\n      <div class=\"mr-xs fa fa-angle-double-left\"></div>\n      Recolher Menu\n    </ng-container>\n  </button>\n</aside>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SidebarItemComponent, selector: "elo-sidebar-item", inputs: ["item", "toggled", "floatType", "focusedSearchInput", "clickLinkSubMenu", "searchValue"], outputs: ["onOpenSubMenu", "onClearActivedMenus", "onCloseNotActivedMenus"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-sidebar', template: "<aside *ngIf=\"!hideAll\" class=\"sidebar new\" [class.sidebar-toggle]=\"toggled\" [class.float-type]=\"toggled\"\n  [class.focused-search]=\"focusedSearchInput\" (mouseenter)=\"onMouseEnter()\" [class.clicked]=\"clicked\"\n  [class.fancy]=\"fancy\">\n\n  <header class=\"sidebar-header\">\n    <div class=\"sidebar-module\"><img *ngIf=\"imgModule\" class=\"module-main\" src=\"{{imgModuleRebranding}}\"></div>\n    <div class=\"sidebar-title\">{{title}}</div>\n  </header>\n\n  <div class=\"sidebar-search\">\n    <input id=\"sidebar-search-input\" placeholder=\"Buscar em Menu..\" [(ngModel)]=\"searchValue\" (focus)=\"handleOnFocus()\"\n      autocomplete=\"off\">\n    <i class=\"fa fa-search\" aria-hidden=\"true\" (click)=\"handleOnFocus()\"></i>\n  </div>\n\n  <ul class=\"sidebar-itens\">\n    <div *ngFor=\"let item of items\">\n      <elo-sidebar-item data-id=\"parent\" [item]=\"item\" [searchValue]=\"searchValue\"\n        (onClearActivedMenus)=\"clearActivedMenus()\" (onCloseNotActivedMenus)=\"closeNotActivedMenus()\"\n        [toggled]=\"toggled\" [floatType]=\"floatType\" [focusedSearchInput]=\"focusedSearchInput\"\n        [clickLinkSubMenu]=\"clickLinkSubMenu\">\n      </elo-sidebar-item>\n    </div>\n  </ul>\n\n  <button class=\"header-toggle-sidebar toggle-control hidden-xs hidden-sm\" aria-label=\"Bot\u00E3o para expandir o menu\"\n    (click)=\"onClickToggledButton()\">\n    <div *ngIf=\"toggled\" class=\"fa fa-angle-double-right\"></div>\n\n    <ng-container *ngIf=\"!toggled\">\n      <div class=\"mr-xs fa fa-angle-double-left\"></div>\n      Recolher Menu\n    </ng-container>\n  </button>\n</aside>" }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: SidebarService }], propDecorators: { title: [{
                type: Input
            }], toggled: [{
                type: Input
            }], floatType: [{
                type: Input
            }], focusedSearchInput: [{
                type: Input
            }], fancy: [{
                type: Input
            }], userName: [{
                type: Input
            }], imgModuleMain: [{
                type: Input
            }], imgModule: [{
                type: Input
            }], imgModuleRebranding: [{
                type: Input
            }], usuarioLogado: [{
                type: Input
            }], enableShortcut: [{
                type: Input
            }], hideAll: [{
                type: Input
            }], openClose: [{
                type: Output
            }], onOpenSubMenu: [{
                type: Output
            }], onInit: [{
                type: Output
            }], onClickSubMenu: [{
                type: Output
            }], onHideRequest: [{
                type: Output
            }], onClickToToggled: [{
                type: Output
            }], items: [{
                type: ContentChildren,
                args: [SideBarItemDirective]
            }], clickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class SidebarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SidebarModule, declarations: [SidebarComponent, SideBarItemDirective, SidebarItemComponent], imports: [CommonModule, RouterModule, FormsModule], exports: [SidebarComponent, SideBarItemDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarModule, providers: [SidebarService], imports: [CommonModule, RouterModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SidebarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule, FormsModule],
                    exports: [SidebarComponent, SideBarItemDirective],
                    declarations: [SidebarComponent, SideBarItemDirective, SidebarItemComponent],
                    providers: [SidebarService]
                }]
        }] });

class SortParameters {
    static newSortParameters(field, order) {
        return new SortParameters(field, order);
    }
    constructor(field, order) {
        this.field = '';
        this.order = '';
        this.field = field;
        this.order = order;
    }
    toUrlParameters() {
        let params = new URLSearchParams();
        params.set(this.field, this.order);
        return params;
    }
}

class SortableHeaderComponent {
    constructor() {
        this.onClickToOrder = new EventEmitter();
        this.label = '';
        this.ordem = '';
        this.field = '';
    }
    clickToOrder() {
        this.onClickToOrder.emit(new SortParameters(this.field, (this.ordem === 'asc' ? 'desc' : 'asc')));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortableHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SortableHeaderComponent, selector: "sortable-header", inputs: { label: "label", ordem: "ordem", field: "field" }, outputs: { onClickToOrder: "onClickToOrder" }, ngImport: i0, template: "<span class=\"header-link\"\n      (click)=\"clickToOrder()\">\n  {{label}}\n\n  <i class=\"fa fa-sort\" aria-hidden=\"true\" *ngIf=\"ordem !== 'asc' && ordem !== 'desc'\"></i>\n  <i class=\"fa fa-sort-asc\" aria-hidden=\"true\" *ngIf=\"ordem === 'asc'\"></i>\n  <i class=\"fa fa-sort-desc\" aria-hidden=\"true\" *ngIf=\"ordem === 'desc'\"></i>\n</span>\n", styles: [".header-link{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortableHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sortable-header', template: "<span class=\"header-link\"\n      (click)=\"clickToOrder()\">\n  {{label}}\n\n  <i class=\"fa fa-sort\" aria-hidden=\"true\" *ngIf=\"ordem !== 'asc' && ordem !== 'desc'\"></i>\n  <i class=\"fa fa-sort-asc\" aria-hidden=\"true\" *ngIf=\"ordem === 'asc'\"></i>\n  <i class=\"fa fa-sort-desc\" aria-hidden=\"true\" *ngIf=\"ordem === 'desc'\"></i>\n</span>\n", styles: [".header-link{cursor:pointer}\n"] }]
        }], propDecorators: { onClickToOrder: [{
                type: Output
            }], label: [{
                type: Input
            }], ordem: [{
                type: Input
            }], field: [{
                type: Input
            }] } });

class SortableHeaderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortableHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SortableHeaderModule, declarations: [SortableHeaderComponent], imports: [CommonModule], exports: [SortableHeaderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortableHeaderModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortableHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        SortableHeaderComponent
                    ],
                    exports: [
                        SortableHeaderComponent
                    ],
                    providers: []
                }]
        }] });

class GlobalExceptionHandlerService extends ErrorHandler {
    constructor(ngZone) {
        super();
        this.ngZone = ngZone;
        this.errorSource = new Subject();
        this.observers = this.errorSource.asObservable();
    }
    getWindow() {
        return window;
    }
    handleError(error) {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (error && error.message && chunkFailedMessage.test(error.message)) {
            this.getWindow().location.reload();
        }
        else {
            this.emitException(error);
        }
    }
    emitException(error) {
        if (!error) {
            return;
        }
        if (!('__karma__' in window)) {
            console.error('error ->', error);
        }
        this.ngZone.run(() => this.errorSource.next(error));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GlobalExceptionHandlerService, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GlobalExceptionHandlerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GlobalExceptionHandlerService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i0.NgZone }] });

/**
 * Created by anderson on 21/10/16.
 */
class SpinnerService {
    constructor() {
        this.show = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

/**
 * Created by anderson on 21/10/16.
 */
class SpinnerComponent {
    constructor(spinnerService, exceptionHandler) {
        this.spinnerService = spinnerService;
        this.exceptionHandler = exceptionHandler;
        this.show = false;
        this.delayValue = 500;
        this.flag = 0;
        this.subscription = null;
    }
    ngOnInit() {
        this.spinnerService.show.subscribe((show) => this.showOrHideSpinner(show));
        if (this.exceptionHandler instanceof GlobalExceptionHandlerService) {
            this.exceptionHandler.observers.subscribe(() => {
                this.show = false;
            });
        }
    }
    showOrHideSpinner(show) {
        if (show) {
            this.flag++;
        }
        else {
            this.flag--;
        }
        if (this.flag < 0) {
            this.flag = 0;
        }
        const delayValueToUse = this.flag === 0 ? 0 : this.delayValue;
        if (this.subscription && !this.subscription.closed) {
            this.subscription.unsubscribe();
        }
        this.subscription = of(show).pipe(delay(delayValueToUse))
            .subscribe(() => this.updateShowvalue());
    }
    updateShowvalue() {
        this.show = this.flag > 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerComponent, deps: [{ token: SpinnerService }, { token: i0.ErrorHandler }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SpinnerComponent, selector: "elo-spinner", inputs: { show: "show", delayValue: "delayValue" }, ngImport: i0, template: "<div class=\"content-loader loadOxy contain\" [class.hide]=\"!show\">\n  <svg version=\"1.2\" class=\"content-align\" baseProfile=\"tiny\" xmlns=\"http://www.w3.org/2000/svg\" xlink=\"http://www.w3.org/1999/xlink\">\n    <defs>\n      <g class=\"animateDraw drawText\" id=\"Logo-Text\">\n        <path id=\"Caminho_129\" data-name=\"Caminho 129\" d=\"M206.58,240.235a19.448,19.448,0,1,0,19.448,19.448,19.448,19.448,0,0,0-19.448-19.448M208,270.5a10.909,10.909,0,1,1,9.4-9.4,10.914,10.914,0,0,1-9.4,9.4\" transform=\"translate(-187.132 -240.234)\"></path>\n        <path id=\"Caminho_130\" data-name=\"Caminho 130\" d=\"M352.5,240.234v19.43a10.906,10.906,0,1,1-21.811,0V245.131l-8.54-4.9v19.43A19.448,19.448,0,0,0,352.5,275.77v3.344a10.91,10.91,0,0,1-10.911,10.9H327.216l4.9,8.543h9.474a19.45,19.45,0,0,0,19.451-19.447V245.131Z\" transform=\"translate(-231.064 -240.234)\"></path>\n        <path id=\"Caminho_131\" data-name=\"Caminho 131\" d=\"M266.245,259.675l-11.96,8.825v10.615l19.154-14.132,19.155,14.132V268.5l-11.961-8.825,11.961-8.825V240.235l-19.155,14.132-19.154-14.132V250.85Z\" transform=\"translate(-208.982 -240.234)\"></path>\n      </g>\n    </defs>\n    <svg class=\"logo_loading\" viewBox=\"0 0 100 100\" space=\"preserveAspectRatio\">\n      <use id=\"Draw-Text\" class=\"drawText animateDraw\" href=\"#Logo-Text\"></use>\n    </svg>\n  </svg>\n</div>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-spinner', template: "<div class=\"content-loader loadOxy contain\" [class.hide]=\"!show\">\n  <svg version=\"1.2\" class=\"content-align\" baseProfile=\"tiny\" xmlns=\"http://www.w3.org/2000/svg\" xlink=\"http://www.w3.org/1999/xlink\">\n    <defs>\n      <g class=\"animateDraw drawText\" id=\"Logo-Text\">\n        <path id=\"Caminho_129\" data-name=\"Caminho 129\" d=\"M206.58,240.235a19.448,19.448,0,1,0,19.448,19.448,19.448,19.448,0,0,0-19.448-19.448M208,270.5a10.909,10.909,0,1,1,9.4-9.4,10.914,10.914,0,0,1-9.4,9.4\" transform=\"translate(-187.132 -240.234)\"></path>\n        <path id=\"Caminho_130\" data-name=\"Caminho 130\" d=\"M352.5,240.234v19.43a10.906,10.906,0,1,1-21.811,0V245.131l-8.54-4.9v19.43A19.448,19.448,0,0,0,352.5,275.77v3.344a10.91,10.91,0,0,1-10.911,10.9H327.216l4.9,8.543h9.474a19.45,19.45,0,0,0,19.451-19.447V245.131Z\" transform=\"translate(-231.064 -240.234)\"></path>\n        <path id=\"Caminho_131\" data-name=\"Caminho 131\" d=\"M266.245,259.675l-11.96,8.825v10.615l19.154-14.132,19.155,14.132V268.5l-11.961-8.825,11.961-8.825V240.235l-19.155,14.132-19.154-14.132V250.85Z\" transform=\"translate(-208.982 -240.234)\"></path>\n      </g>\n    </defs>\n    <svg class=\"logo_loading\" viewBox=\"0 0 100 100\" space=\"preserveAspectRatio\">\n      <use id=\"Draw-Text\" class=\"drawText animateDraw\" href=\"#Logo-Text\"></use>\n    </svg>\n  </svg>\n</div>" }]
        }], ctorParameters: () => [{ type: SpinnerService }, { type: i0.ErrorHandler }], propDecorators: { show: [{
                type: Input
            }], delayValue: [{
                type: Input
            }] } });

/**
 * Created by anderson on 25/10/16.
 */
class SpinnerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SpinnerModule, declarations: [SpinnerComponent], imports: [CommonModule], exports: [SpinnerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerModule, providers: [SpinnerService], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SpinnerComponent],
                    exports: [SpinnerComponent],
                    providers: [SpinnerService]
                }]
        }] });

class SwitchComponent {
    constructor() {
        this.disabled = false;
        this.hintPosition = 'center-right';
        this.onChangeValue = new EventEmitter();
        this.onChange = noop;
        this.onTouched = noop;
    }
    switchClickEvent() {
        if (!this.disabled) {
            this.active = !this.active;
            if (this.onChange) {
                this.onChange(this.active);
            }
            this.onChangeValue.emit(this.active);
        }
    }
    writeValue(obj) {
        this.active = obj;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SwitchComponent, selector: "elo-switch", inputs: { active: "active", disabled: "disabled", caption: "caption", size: "size", hintMessage: "hintMessage", hintPosition: "hintPosition" }, outputs: { onChangeValue: "onChangeValue" }, providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: SwitchComponent }
        ], ngImport: i0, template: "<div class=\"switch-container\">\n  <em class=\"switch {{size}}\" [class.active]=\"active\" (click)=\"switchClickEvent()\" [class.disabled]=\"disabled\"></em>\n  <span [class.disabled]=\"disabled\" class=\"switch-caption {{size}}\" (click)=\"switchClickEvent()\">\n    {{caption}}\n    <div *ngIf=\"hintMessage\" class=\"hint sm clean fa-question-circle module-color inline {{ hintPosition }}\">\n      <div class=\"hint-content\">{{ hintMessage }}</div>\n    </div>\n  </span>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-switch', providers: [
                        { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: SwitchComponent }
                    ], template: "<div class=\"switch-container\">\n  <em class=\"switch {{size}}\" [class.active]=\"active\" (click)=\"switchClickEvent()\" [class.disabled]=\"disabled\"></em>\n  <span [class.disabled]=\"disabled\" class=\"switch-caption {{size}}\" (click)=\"switchClickEvent()\">\n    {{caption}}\n    <div *ngIf=\"hintMessage\" class=\"hint sm clean fa-question-circle module-color inline {{ hintPosition }}\">\n      <div class=\"hint-content\">{{ hintMessage }}</div>\n    </div>\n  </span>\n</div>\n" }]
        }], propDecorators: { active: [{
                type: Input
            }], disabled: [{
                type: Input
            }], caption: [{
                type: Input
            }], size: [{
                type: Input
            }], hintMessage: [{
                type: Input
            }], hintPosition: [{
                type: Input
            }], onChangeValue: [{
                type: Output
            }] } });

/**
 * Created by anderson on 25/10/16.
 */
class SwitchModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, declarations: [SwitchComponent], imports: [FormsModule, ReactiveFormsModule, CommonModule], exports: [SwitchComponent, FormsModule, ReactiveFormsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, imports: [FormsModule, ReactiveFormsModule, CommonModule, FormsModule, ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, ReactiveFormsModule, CommonModule],
                    declarations: [SwitchComponent],
                    exports: [SwitchComponent, FormsModule, ReactiveFormsModule]
                }]
        }] });

class TabItemComponent {
    constructor() {
        this.selected = false;
        this.visible = true;
        this.invalid = false;
        this.table = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TabItemComponent, selector: "elo-tab-item", inputs: { title: "title", selected: "selected", visible: "visible", invalid: "invalid", table: "table", badge: "badge" }, ngImport: i0, template: "<div  class=\"tab-item-content mt-mb-none\" [class.active]=\"selected\" [class.table]=\"table\" data-position=\"0\" [hidden]=\"!selected\">\n   <ng-content></ng-content>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-tab-item', template: "<div  class=\"tab-item-content mt-mb-none\" [class.active]=\"selected\" [class.table]=\"table\" data-position=\"0\" [hidden]=\"!selected\">\n   <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], selected: [{
                type: Input
            }], visible: [{
                type: Input
            }], invalid: [{
                type: Input
            }], table: [{
                type: Input
            }], badge: [{
                type: Input
            }] } });

class TabControlComponent {
    constructor() {
        this.hasTableWithRecords = false;
        this.onSelected = new EventEmitter();
        this.hasBadge = false;
    }
    ngAfterContentInit() {
        let selectedTabs = this.tabs.filter(tab => tab.selected);
        if (selectedTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }
        else {
            this.selectTab(selectedTabs[0]);
        }
        this.hasBadge = this.tabs.some(this.existsBadge);
    }
    selectTab(tab) {
        this.tabs.forEach(tab => tab.selected = false);
        tab.selected = true;
        this.onSelected.emit({ selectedTab: tab });
    }
    selectTabByIndex(index) {
        let tabs = this.tabs.toArray();
        if (index in tabs) {
            this.selectTab(tabs[index]);
            return true;
        }
        else {
            return false;
        }
    }
    currentIndex() {
        for (let index in this.tabs.toArray()) {
            if (this.tabs.toArray()[index].selected) {
                return Number(index);
            }
        }
        return null;
    }
    selectTabOffset(offset) {
        let currentIndex = this.currentIndex();
        if (currentIndex === null)
            return false;
        if ((currentIndex + offset) in this.tabs.toArray()) {
            this.selectTabByIndex(currentIndex + offset);
            return true;
        }
        else {
            return false;
        }
    }
    selectTabNext(offset = 1) {
        return this.selectTabOffset(offset);
    }
    selectTabPrev(offset = 1) {
        return this.selectTabOffset(-offset);
    }
    get visibleTabs() {
        return this.tabs.filter(tab => tab.visible);
    }
    existsBadge(tab) {
        return typeof tab.badge === 'number' && tab.badge >= 0 || (tab.badge !== undefined && tab.badge !== null && tab.badge.length > 0);
    }
    getTabClass(tab) {
        return { 'active': tab.selected, 'invalid': tab.invalid, 'table': tab.table, 'has-badge': this.existsBadge(tab) };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabControlComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TabControlComponent, selector: "elo-tab-control", inputs: { class: "class", hasTableWithRecords: "hasTableWithRecords" }, outputs: { onSelected: "onSelected" }, queries: [{ propertyName: "tabs", predicate: TabItemComponent }], ngImport: i0, template: "<div class=\"panel-body\" [ngClass]=\"{'pb-none': hasTableWithRecords}\">\n  <div class=\"panel-tab {{class}}\">\n    <div class=\"panel-tab-selector\" [ngClass]=\"{'has-badge': hasBadge}\">\n      <div *ngFor=\"let tab of visibleTabs\"\n           (click)=\"selectTab(tab)\"\n           class=\"tab-item-selector table \"\n           [ngClass]=\"getTabClass(tab)\">\n        {{tab.title}}\n        <span *ngIf=\"tab.badge\" class=\"badge\">{{tab.badge}}</span>\n      </div>\n      <ng-content select=\"[buttons]\"></ng-content>\n    </div>\n    <div class=\"panel-tab-content\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-tab-control', template: "<div class=\"panel-body\" [ngClass]=\"{'pb-none': hasTableWithRecords}\">\n  <div class=\"panel-tab {{class}}\">\n    <div class=\"panel-tab-selector\" [ngClass]=\"{'has-badge': hasBadge}\">\n      <div *ngFor=\"let tab of visibleTabs\"\n           (click)=\"selectTab(tab)\"\n           class=\"tab-item-selector table \"\n           [ngClass]=\"getTabClass(tab)\">\n        {{tab.title}}\n        <span *ngIf=\"tab.badge\" class=\"badge\">{{tab.badge}}</span>\n      </div>\n      <ng-content select=\"[buttons]\"></ng-content>\n    </div>\n    <div class=\"panel-tab-content\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n" }]
        }], propDecorators: { tabs: [{
                type: ContentChildren,
                args: [TabItemComponent]
            }], class: [{
                type: Input
            }], hasTableWithRecords: [{
                type: Input
            }], onSelected: [{
                type: Output
            }] } });

class TabControlModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TabControlModule, declarations: [TabControlComponent, TabItemComponent], imports: [CommonModule], exports: [TabControlComponent, TabItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabControlModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabControlModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [TabControlComponent, TabItemComponent],
                    declarations: [TabControlComponent, TabItemComponent]
                }]
        }] });

class EloTableDrilldownComponent {
    constructor() {
        this.showSecondField = false;
        this.headerSecondField = 'Valor Divisor';
        this.onClickElement = new EventEmitter();
        this.fieldHasChilds = 'hasChilds';
    }
    onClick(e) {
        e.open = !e.open;
        this.onClickElement.emit(e);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableDrilldownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloTableDrilldownComponent, selector: "elo-table-drilldown", inputs: { data: "data", columns: "columns", showSecondField: "showSecondField", headerSecondField: "headerSecondField", fieldHasChilds: "fieldHasChilds" }, outputs: { onClickElement: "onClickElement" }, ngImport: i0, template: "<div class=\"table-editable tree\" *ngIf=\"data?.length\">\n  <div class=\"table-editable-header \">\n\n    <div class=\"row\">\n      <div class=\"colunm col-sm-{{col?.col}}\" *ngFor=\"let col of columns;\" [class.right]=\"col?.isDecimal\">\n        <span>{{col?.header}}</span>\n      </div>\n    </div>\n\n  </div>\n\n  <div class=\"table-editable-content\">\n    <ng-template #recursiveList let-data let-padding=\"padding\">\n      <ng-container *ngFor=\"let item of data; let i = index;\">\n\n        <div class=\"row reduced {{item[fieldHasChilds] ? 'father' : ''}} level-{{padding}} {{item?.open ? 'open' : ''}}\"\n          [ngStyle]=\"{ 'cursor': item[fieldHasChilds] ? 'pointer' : '' }\">\n\n          <ng-container *ngFor=\"let col of columns; let j = index;\">\n\n            <div class=\"column col-sm-{{col?.col}} direction-row right\" *ngIf=\"col?.isDecimal;else colWithoutDigits\"\n              (click)=\"onClick(item)\" [class.center-father]=\"j === 0\" [ngStyle]=\"{'justify-content': 'flex-end'}\">\n\n              <div *ngIf=\"showSecondField && col?.secondField\"\n                class=\"hint clean fa-exclamation-circle  center-right module-color sm ml-xs\">\n                <div class=\"hint-content\"> {{headerSecondField}} : {{ item[col.secondField] || 0 | decimalformat : \"1.2-2\" }}</div>\n              </div>\n\n              {{ item[col.field] || 0 | decimalformat : \"1.2-2\"}}\n\n            </div>\n\n            <ng-template #colWithoutDigits>\n              <div class=\"column col-sm-{{col?.col}}\" (click)=\"onClick(item)\" [class.center-father]=\"j === 0\">\n                {{item[col.field]}}\n              </div>\n\n            </ng-template>\n\n          </ng-container>\n\n        </div>\n\n        <ng-container *ngIf=\"item?.data?.length\">\n          <ng-container *ngTemplateOutlet=\"recursiveList; context:{ $implicit: item.data, padding: padding + 1}\">\n          </ng-container>\n        </ng-container>\n\n      </ng-container>\n    </ng-template>\n\n    <ng-container *ngTemplateOutlet=\"recursiveList; context:{ $implicit: data, padding: 1  }\">\n    </ng-container>\n  </div>\n</div>\n", styles: [".center-father{margin:auto 0}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: DecimalFormatPipe, name: "decimalformat" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableDrilldownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-table-drilldown', template: "<div class=\"table-editable tree\" *ngIf=\"data?.length\">\n  <div class=\"table-editable-header \">\n\n    <div class=\"row\">\n      <div class=\"colunm col-sm-{{col?.col}}\" *ngFor=\"let col of columns;\" [class.right]=\"col?.isDecimal\">\n        <span>{{col?.header}}</span>\n      </div>\n    </div>\n\n  </div>\n\n  <div class=\"table-editable-content\">\n    <ng-template #recursiveList let-data let-padding=\"padding\">\n      <ng-container *ngFor=\"let item of data; let i = index;\">\n\n        <div class=\"row reduced {{item[fieldHasChilds] ? 'father' : ''}} level-{{padding}} {{item?.open ? 'open' : ''}}\"\n          [ngStyle]=\"{ 'cursor': item[fieldHasChilds] ? 'pointer' : '' }\">\n\n          <ng-container *ngFor=\"let col of columns; let j = index;\">\n\n            <div class=\"column col-sm-{{col?.col}} direction-row right\" *ngIf=\"col?.isDecimal;else colWithoutDigits\"\n              (click)=\"onClick(item)\" [class.center-father]=\"j === 0\" [ngStyle]=\"{'justify-content': 'flex-end'}\">\n\n              <div *ngIf=\"showSecondField && col?.secondField\"\n                class=\"hint clean fa-exclamation-circle  center-right module-color sm ml-xs\">\n                <div class=\"hint-content\"> {{headerSecondField}} : {{ item[col.secondField] || 0 | decimalformat : \"1.2-2\" }}</div>\n              </div>\n\n              {{ item[col.field] || 0 | decimalformat : \"1.2-2\"}}\n\n            </div>\n\n            <ng-template #colWithoutDigits>\n              <div class=\"column col-sm-{{col?.col}}\" (click)=\"onClick(item)\" [class.center-father]=\"j === 0\">\n                {{item[col.field]}}\n              </div>\n\n            </ng-template>\n\n          </ng-container>\n\n        </div>\n\n        <ng-container *ngIf=\"item?.data?.length\">\n          <ng-container *ngTemplateOutlet=\"recursiveList; context:{ $implicit: item.data, padding: padding + 1}\">\n          </ng-container>\n        </ng-container>\n\n      </ng-container>\n    </ng-template>\n\n    <ng-container *ngTemplateOutlet=\"recursiveList; context:{ $implicit: data, padding: 1  }\">\n    </ng-container>\n  </div>\n</div>\n", styles: [".center-father{margin:auto 0}\n"] }]
        }], propDecorators: { data: [{
                type: Input
            }], columns: [{
                type: Input
            }], showSecondField: [{
                type: Input
            }], headerSecondField: [{
                type: Input
            }], onClickElement: [{
                type: Output
            }], fieldHasChilds: [{
                type: Input
            }] } });

class EloTableDrilldownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableDrilldownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloTableDrilldownModule, declarations: [EloTableDrilldownComponent], imports: [CommonModule,
            PipeModule], exports: [EloTableDrilldownComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableDrilldownModule, imports: [CommonModule,
            PipeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTableDrilldownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PipeModule,
                    ],
                    declarations: [EloTableDrilldownComponent],
                    exports: [EloTableDrilldownComponent],
                }]
        }] });

class EloTimelineHorizontalComponent {
    constructor() {
        this.dates = [];
        this.description = 'Inserir nova data';
        this.onSelected = new EventEmitter();
        this.onRemove = new EventEmitter();
        this.onClone = new EventEmitter();
        this.showCalendar = false;
        this.showDialogRemove = false;
        this.showModalClone = false;
        this.datasRevisoesBeforeEdit = [];
        this.newRevision = { isNew: false, itens: [] };
        this.findToOptionsClone = (search) => of(this.datasRevisoesBeforeEdit.filter(a => DateUtils.format(new Date(a), FROM_FORMAT, TO_FORMAT).includes(search)));
    }
    onClickIncluirData() {
        this.showCalendar = !this.showCalendar;
    }
    onSelectDate(selectedDate) {
        const dataFormatada = DateUtils.format(selectedDate, TO_FORMAT, FROM_FORMAT);
        this.dates.forEach(data => data.selected = false);
        if (this.dates.map(d => d.data).includes(dataFormatada)) {
            let dateFound = this.dates.find(d => d.data === dataFormatada);
            dateFound.selected = true;
            this.onSelected.emit(dateFound);
        }
        else {
            this.datasRevisoesBeforeEdit = this.dates.map(r => r.data).filter(date => dataFormatada !== date);
            let newDateObj = { data: dataFormatada, selected: true };
            this.newRevision.isNew = true;
            this.newRevision.itens.push(newDateObj);
            this.dates.push(newDateObj);
            this.onSelected.emit(newDateObj);
        }
        this.dates.sort((a, b) => DateUtils.differenceBetweenDays(DateUtils.getDateFromString(a.data), b.data));
        this.showCalendar = !this.showCalendar;
    }
    onClickDate(event) {
        this.dates.forEach(d => d.selected = false);
        this.dataRevisaoClonar = null;
        this.verifyIfRevisionIsNew(event);
        event.selected = true;
        this.onSelected.emit(event);
    }
    onCloneDate() {
        this.onClone.emit(this.dataRevisaoClonar);
        this.onOpenClonar();
    }
    objToOptions(data) {
        return DateUtils.format(new Date(data), FROM_FORMAT, TO_FORMAT);
    }
    onRemoveDate() {
        let indexToRemove = this.dates.findIndex(d => d.selected);
        if (indexToRemove > -1) {
            this.onRemove.emit(this.dates.find(d => d.selected));
            this.dates.splice(indexToRemove, 1);
            this.onClickDate(this.dates[0]);
        }
        this.showDialogRemove = !this.showDialogRemove;
    }
    onOpenClonar() {
        this.showModalClone = !this.showModalClone;
    }
    verifyIfRevisionIsNew(event) {
        let checkItem = this.newRevision.itens.filter(d => d.data === event.data);
        if (!checkItem.length) {
            this.newRevision.isNew = false;
        }
        else {
            this.newRevision.isNew = true;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTimelineHorizontalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EloTimelineHorizontalComponent, selector: "elo-timeline-horizontal", inputs: { dates: "dates", description: "description" }, outputs: { onSelected: "onSelected", onRemove: "onRemove", onClone: "onClone" }, ngImport: i0, template: "<div class=\"row\">\n  <div class=\"timeline-horizontal-container\">\n    <ul>\n      <li id=\"liInsertRevisao\" style=\"cursor: pointer\" (click)=\"onClickIncluirData()\">\n        <div class=\"caption\">{{description}}</div>\n      </li>\n      <li *ngFor=\"let d of dates;\" (click)=\"onClickDate(d)\"\n        [ngClass]=\"d.selected ? 'bg-gray-20' : ''\" style=\"cursor: pointer\">\n        <div class=\"values\">\n          <div class=\"value mt-md\"></div>\n        </div>\n        <div [ngClass]=\"d.selected ? 'caption bg-primary-color gray-5' : 'caption'\">\n          {{ d.data | dateformat }}\n        </div>\n      </li>\n    </ul>\n  </div>\n</div>\n\n<div class=\"row\" *ngIf=\"dates.length\">\n\n  <elo-form-label-column column=\"6\">\n    <button id=\"btnCloneRevisao\" class=\"btn positive icon-left inline\" type=\"button\" [title]=\"'Clonar revis\u00E3o'\" (click)=\"onOpenClonar()\" *ngIf=\"newRevision.isNew\"> \n      <i class=\"fa fa-upload\"></i>\n      Clonar Revis\u00E3o  \n    </button>\n\n    <button id=\"btnRemoveRevisao\" class=\"btn negative icon-left inline\" type=\"button\" [title]=\"'Remover revis\u00E3o'\"\n      (click)=\"showDialogRemove = !showDialogRemove\">\n      <i class=\"fa fa-trash\"></i>\n      Remover Revis\u00E3o\n    </button>\n  </elo-form-label-column>\n\n</div>\n\n<elo-calendar [show]=\"showCalendar\" (onSelectDate)=\"onSelectDate($event)\"></elo-calendar>\n\n<elo-dialog [show]=\"showDialogRemove\" (onOkEvent)=\"onRemoveDate()\" (onCancelEvent)=\"showDialogRemove = !showDialogRemove\">\n  A Revis\u00E3o do Divisor ser\u00E1 apagada. Deseja continuar?\n</elo-dialog>\n\n<elo-modal id=\"modalClonar\" [isOpen]=\"showModalClone\" (openClose)=\"onOpenClonar()\" *ngIf=\"showModalClone\">\n  <elo-panel [hasTable]=\"true\" [hasForm]=\"true\" [title]=\"'Clonar itens de revis\u00E3o'\">\n\n    <div class=\"row\">\n      <elo-form-label-column label=\"Revis\u00E3o\" column=\"3\">\n        <elo-autocomplete id=\"dataRevisaoClonar\" [options]=\"datasRevisoesBeforeEdit\" [(ngModel)]=\"dataRevisaoClonar\"\n          placeholder=\"Selecione uma Revis\u00E3o\" [findToOptions]=\"findToOptionsClone\" [objToOption]=\"objToOptions\" >\n        </elo-autocomplete>\n      </elo-form-label-column>\n\n      <elo-form-label-column column=\"2\">\n        <button id=\"btnClonar\" class=\"btn module-color icon-left\" type=\"button\" [title]=\"'Clonar revis\u00E3o'\"\n          (click)=\"onCloneDate()\" [disabled]=\"!dataRevisaoClonar\">\n          <i class=\"fa fa-upload\"></i>\n          Clonar\n        </button>\n      </elo-form-label-column>\n\n    </div>\n  </elo-panel>\n</elo-modal>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: FormLabelColumnComponent, selector: "elo-form-label-column", inputs: ["label", "color", "column", "offset", "hintMessage", "hintPosition", "hintIconLeftAlign", "linkTitle", "showLink", "icon"], outputs: ["onClickLink"] }, { kind: "component", type: CalendarComponent, selector: "elo-calendar", inputs: ["changeYear", "extraElement", "subtitles", "multiple", "selectedMultiple", "visible", "viewFormat", "show", "onTop", "onRight", "selectedDate", "locale", "updateCalendar"], outputs: ["onSelectDate", "onGenerateCalendar"] }, { kind: "component", type: DialogComponent, selector: "elo-dialog", inputs: ["show", "showCancel", "classType", "tittleCancel", "tittleOk", "title", "disableOkButton", "debounceTime"], outputs: ["onOkEvent", "onCancelEvent"] }, { kind: "component", type: EloModalComponent, selector: "elo-modal", inputs: ["isOpen", "customWidth", "isCentralized", "preventClose"], outputs: ["openClose"] }, { kind: "component", type: AutoCompleteComponent, selector: "elo-autocomplete", inputs: ["multiplo", "multipleSelected", "id", "options", "error", "service", "placeholder", "noResultsMessage", "urlCreate", "searchModal", "isDisabled", "findToOptions", "objToOption", "objToOptionViewMultiple", "debounceTime", "autoSelect", "isEnabledCreateRecord", "descriptionNewRecord", "validateDeps", "insertIcon", "extraInfos", "emptyRecord", "removeDot"], outputs: ["onChangeMultipleValue", "onChangeValue", "onSearchModal", "onInsertButton", "onCreateRecord"] }, { kind: "component", type: PanelComponent, selector: "elo-panel", inputs: ["title", "hasTable", "hasForm", "pbNone"] }, { kind: "pipe", type: DateFormatPipe, name: "dateformat" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTimelineHorizontalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-timeline-horizontal', template: "<div class=\"row\">\n  <div class=\"timeline-horizontal-container\">\n    <ul>\n      <li id=\"liInsertRevisao\" style=\"cursor: pointer\" (click)=\"onClickIncluirData()\">\n        <div class=\"caption\">{{description}}</div>\n      </li>\n      <li *ngFor=\"let d of dates;\" (click)=\"onClickDate(d)\"\n        [ngClass]=\"d.selected ? 'bg-gray-20' : ''\" style=\"cursor: pointer\">\n        <div class=\"values\">\n          <div class=\"value mt-md\"></div>\n        </div>\n        <div [ngClass]=\"d.selected ? 'caption bg-primary-color gray-5' : 'caption'\">\n          {{ d.data | dateformat }}\n        </div>\n      </li>\n    </ul>\n  </div>\n</div>\n\n<div class=\"row\" *ngIf=\"dates.length\">\n\n  <elo-form-label-column column=\"6\">\n    <button id=\"btnCloneRevisao\" class=\"btn positive icon-left inline\" type=\"button\" [title]=\"'Clonar revis\u00E3o'\" (click)=\"onOpenClonar()\" *ngIf=\"newRevision.isNew\"> \n      <i class=\"fa fa-upload\"></i>\n      Clonar Revis\u00E3o  \n    </button>\n\n    <button id=\"btnRemoveRevisao\" class=\"btn negative icon-left inline\" type=\"button\" [title]=\"'Remover revis\u00E3o'\"\n      (click)=\"showDialogRemove = !showDialogRemove\">\n      <i class=\"fa fa-trash\"></i>\n      Remover Revis\u00E3o\n    </button>\n  </elo-form-label-column>\n\n</div>\n\n<elo-calendar [show]=\"showCalendar\" (onSelectDate)=\"onSelectDate($event)\"></elo-calendar>\n\n<elo-dialog [show]=\"showDialogRemove\" (onOkEvent)=\"onRemoveDate()\" (onCancelEvent)=\"showDialogRemove = !showDialogRemove\">\n  A Revis\u00E3o do Divisor ser\u00E1 apagada. Deseja continuar?\n</elo-dialog>\n\n<elo-modal id=\"modalClonar\" [isOpen]=\"showModalClone\" (openClose)=\"onOpenClonar()\" *ngIf=\"showModalClone\">\n  <elo-panel [hasTable]=\"true\" [hasForm]=\"true\" [title]=\"'Clonar itens de revis\u00E3o'\">\n\n    <div class=\"row\">\n      <elo-form-label-column label=\"Revis\u00E3o\" column=\"3\">\n        <elo-autocomplete id=\"dataRevisaoClonar\" [options]=\"datasRevisoesBeforeEdit\" [(ngModel)]=\"dataRevisaoClonar\"\n          placeholder=\"Selecione uma Revis\u00E3o\" [findToOptions]=\"findToOptionsClone\" [objToOption]=\"objToOptions\" >\n        </elo-autocomplete>\n      </elo-form-label-column>\n\n      <elo-form-label-column column=\"2\">\n        <button id=\"btnClonar\" class=\"btn module-color icon-left\" type=\"button\" [title]=\"'Clonar revis\u00E3o'\"\n          (click)=\"onCloneDate()\" [disabled]=\"!dataRevisaoClonar\">\n          <i class=\"fa fa-upload\"></i>\n          Clonar\n        </button>\n      </elo-form-label-column>\n\n    </div>\n  </elo-panel>\n</elo-modal>" }]
        }], propDecorators: { dates: [{
                type: Input
            }], description: [{
                type: Input
            }], onSelected: [{
                type: Output
            }], onRemove: [{
                type: Output
            }], onClone: [{
                type: Output
            }] } });

class EloTimelineHorizontalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTimelineHorizontalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EloTimelineHorizontalModule, declarations: [EloTimelineHorizontalComponent], imports: [CommonModule,
            FormsModule,
            FormLabelColumnModule,
            PipeModule,
            CalendarModule,
            DialogModule,
            EloModalModule,
            AutoCompleteModule,
            PanelModule], exports: [EloTimelineHorizontalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTimelineHorizontalModule, imports: [CommonModule,
            FormsModule,
            FormLabelColumnModule,
            PipeModule,
            CalendarModule,
            DialogModule,
            EloModalModule,
            AutoCompleteModule,
            PanelModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EloTimelineHorizontalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        FormLabelColumnModule,
                        PipeModule,
                        CalendarModule,
                        DialogModule,
                        EloModalModule,
                        AutoCompleteModule,
                        PanelModule
                    ],
                    declarations: [EloTimelineHorizontalComponent],
                    exports: [EloTimelineHorizontalComponent],
                }]
        }] });

class ActuatorService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.resource = '/actuator';
    }
    getInfo() {
        return this.httpClient.get({
            resource: `${this.resource}/info`,
            disableSpinner: true
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ActuatorService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ActuatorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ActuatorService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

class VersionReloadHandlerComponent {
    constructor(actuatorService, windowService) {
        this.actuatorService = actuatorService;
        this.windowService = windowService;
        this.DEFAULT_VALUE_VERSION = null;
        this.currentVersion = this.DEFAULT_VALUE_VERSION;
    }
    ngOnInit() {
        this.versionHandler();
    }
    closeDialog() {
        this.currentVersion = false;
    }
    refreshVersion() {
        this.windowService.refresh();
    }
    versionHandler() {
        this.verifyVersion = interval(60000).subscribe(() => {
            this.actuatorService.getInfo().subscribe(api => {
                if (!this.version) {
                    this.version = api?.build?.version || this.DEFAULT_VALUE_VERSION;
                }
                else if (this.version !== api?.build?.version) {
                    this.currentVersion = api?.build?.version || this.DEFAULT_VALUE_VERSION;
                }
            }, (error) => {
                console.error('Error ao buscar versão', error);
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VersionReloadHandlerComponent, deps: [{ token: ActuatorService }, { token: WindowService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: VersionReloadHandlerComponent, selector: "version-reload-handler", ngImport: i0, template: "<elo-dialog [tittleOk]=\"'Reiniciar a p\u00E1gina (F5)'\" [show]=\"!!currentVersion\"\n   (onOkEvent)=\"refreshVersion()\" [tittleCancel]=\"'N\u00E3o reiniciar'\"\n  (onCancelEvent)=\"closeDialog()\">\n\n  <div style=\"text-align: center\">\n    <h3>Vers\u00E3o do sistema atualizada</h3>\n    <hr>\n    <span class=\"red-60 typography-bold\">Reinicie a p\u00E1gina para evitar diverg\u00EAncia de dados</span>\n  </div>\n  <hr>\n  <div class=\"mt-xs\">\n    <p class=\"mt-xs\">Vers\u00E3o atual: <b>{{version}}</b></p>\n    <p>Vers\u00E3o nova: <b>{{currentVersion}}</b></p>\n  </div>\n\n</elo-dialog>", dependencies: [{ kind: "component", type: DialogComponent, selector: "elo-dialog", inputs: ["show", "showCancel", "classType", "tittleCancel", "tittleOk", "title", "disableOkButton", "debounceTime"], outputs: ["onOkEvent", "onCancelEvent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VersionReloadHandlerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'version-reload-handler', template: "<elo-dialog [tittleOk]=\"'Reiniciar a p\u00E1gina (F5)'\" [show]=\"!!currentVersion\"\n   (onOkEvent)=\"refreshVersion()\" [tittleCancel]=\"'N\u00E3o reiniciar'\"\n  (onCancelEvent)=\"closeDialog()\">\n\n  <div style=\"text-align: center\">\n    <h3>Vers\u00E3o do sistema atualizada</h3>\n    <hr>\n    <span class=\"red-60 typography-bold\">Reinicie a p\u00E1gina para evitar diverg\u00EAncia de dados</span>\n  </div>\n  <hr>\n  <div class=\"mt-xs\">\n    <p class=\"mt-xs\">Vers\u00E3o atual: <b>{{version}}</b></p>\n    <p>Vers\u00E3o nova: <b>{{currentVersion}}</b></p>\n  </div>\n\n</elo-dialog>" }]
        }], ctorParameters: () => [{ type: ActuatorService }, { type: WindowService }] });

class VersionReloadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VersionReloadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: VersionReloadModule, declarations: [VersionReloadHandlerComponent], imports: [CommonModule,
            DialogModule], exports: [VersionReloadHandlerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VersionReloadModule, providers: [ActuatorService], imports: [CommonModule,
            DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VersionReloadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        DialogModule
                    ],
                    exports: [
                        VersionReloadHandlerComponent
                    ],
                    declarations: [VersionReloadHandlerComponent],
                    providers: [ActuatorService]
                }]
        }] });

/**
 * Simple calculator for a virtual render area
 */
class VirtualRenderArea {
    constructor() {
        this._scrollPos = 0;
        this._viewerHeight = 0;
        this._itemCount = 0;
        this._itemHeight = 0;
        this._visibleCount = 0;
        this._visibleStart = 0;
        this._topBuffer = 0;
        this._totalHeight = 0;
    }
    set itemHeight(value) {
        if (this._itemHeight !== value) {
            this._itemHeight = value;
            this.invalidateViewRange();
            this.invalidateTotalHeight();
            this.invalidateScrollPos();
        }
    }
    get itemHeight() {
        return this._itemHeight;
    }
    set itemCount(value) {
        if (this._itemCount !== value) {
            this._itemCount = value;
            this.invalidateViewRange();
            this.invalidateTotalHeight();
        }
    }
    get itemCount() {
        return this._itemCount;
    }
    set scrollPos(value) {
        if (this._scrollPos !== value) {
            this._scrollPos = value;
            this.invalidateViewRange();
        }
    }
    get scrollPos() {
        return this._scrollPos;
    }
    set viewerHeight(value) {
        if (this._viewerHeight !== value) {
            this._viewerHeight = value;
            this.invalidateViewRange();
            this.invalidateScrollPos();
        }
    }
    get viewerHeight() {
        return this._viewerHeight;
    }
    get visibleCount() {
        return this._visibleCount;
    }
    get visibleStart() {
        return this._visibleStart;
    }
    get topBuffer() {
        return this._topBuffer;
    }
    get totalHeight() {
        return this._totalHeight;
    }
    invalidateViewRange() {
        const maxItems = Math.ceil(this._viewerHeight / this._itemHeight) + 1;
        this._visibleStart = Math.floor(this._scrollPos / this._itemHeight);
        this._visibleCount = Math.min(this._itemCount - this._visibleStart, maxItems);
        this._topBuffer = this._visibleStart * this._itemHeight;
    }
    invalidateTotalHeight() {
        this._totalHeight = this._itemHeight * this._itemCount;
    }
    invalidateScrollPos() {
        this._scrollPos = Math.min(Math.max(0, this._totalHeight - this._viewerHeight), this._scrollPos);
    }
}

class OfVirtualTreeComponent {
    /**
     * An instance of an OfVirtualTree<T> configured to your dataset
     */
    set model(value) {
        this._model = value;
        this.listenForDataChange(value);
    }
    get model() {
        return this._model;
    }
    /**
     * Height each item in the tree
     */
    set itemHeight(value) {
        this.renderArea.itemHeight = value;
    }
    get itemHeight() {
        return this.renderArea.itemHeight;
    }
    /**
     * @ignore
     */
    get topBuffer() {
        return this.renderArea.topBuffer;
    }
    /**
     * @ignore
     */
    get totalHeight() {
        return this.renderArea.totalHeight;
    }
    constructor(cdr, element) {
        this.cdr = cdr;
        this.element = element;
        this.disposers = [];
        this.renderArea = new VirtualRenderArea();
        /**
         * @ignore
         */
        this.tabIndex = 0;
        /**
         * @ignore
         */
        this.visibleItems = [];
    }
    /**
     * @ignore
     */
    ngAfterViewInit() {
        this.handleDataChange();
        this.invalidateSize();
        this.syncScrollPos();
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this.dispose();
    }
    /**
     * @ignore
     */
    handleKeydown(evt) {
        if (evt.key === 'Enter') {
            this.model.selectHighlightedItem();
        }
        else if (evt.key.startsWith('Arrow')) {
            const direction = evt.key.replace('Arrow', ''), nextHighlightedIndex = this.model.navigate(direction);
            if (nextHighlightedIndex !== undefined) {
                this.scrollToIndex(nextHighlightedIndex);
            }
            evt.preventDefault();
        }
    }
    /**
     * @ignore
     */
    handleScrollChange() {
        if (this.element.nativeElement) {
            this.renderArea.scrollPos = this.element.nativeElement.scrollTop;
            this.updateVisibleItems();
        }
    }
    /**
     * @ignore
     */
    handleWindowResize() {
        this.invalidateSize();
    }
    /**
     * Fix issues occurring from tree container's height has changed
     */
    invalidateSize() {
        if (this.element.nativeElement) {
            const bounds = this.element.nativeElement.getBoundingClientRect();
            this.renderArea.viewerHeight = bounds.height;
            if (this.renderArea.itemCount !== this.visibleItems.length) {
                this.updateVisibleItems();
            }
        }
    }
    /**
     * Scroll the container until the selected item is in view. If the selected item is already in view, do nothing.
     */
    scrollToSelected() {
        const selectedIndex = this.model.getSelectedIndex();
        if (typeof selectedIndex === 'number') {
            this.scrollToIndex(selectedIndex);
        }
    }
    /**
     * Scroll to a certain position
     * @param offset In pixels, the scroll position to jump to
     */
    scrollTo(offset) {
        const { nativeElement } = this.element;
        if (nativeElement) {
            nativeElement.scrollTop = offset;
        }
    }
    /**
     * Scroll the container until the item is in view. If the item is already in view, do nothing.
     */
    scrollToItem(item) {
        const selectedIndex = this.model.getItemIndex(item);
        if (typeof selectedIndex === 'number' && selectedIndex > -1) {
            this.scrollToIndex(selectedIndex);
        }
    }
    /**
     * Scroll the container until the item at the index is in view. If the item at the index is already in view, do nothing.
     */
    scrollToIndex(index) {
        const { nativeElement } = this.element;
        if (nativeElement) {
            const { viewerHeight, itemHeight } = this.renderArea, itemTop = index * itemHeight, itemBottom = itemTop + itemHeight;
            if (itemTop < nativeElement.scrollTop) {
                nativeElement.scrollTop = itemTop;
            }
            else if (itemBottom > nativeElement.scrollTop + viewerHeight) {
                nativeElement.scrollTop = itemBottom - viewerHeight;
            }
        }
    }
    /**
     * Get the current scroll offset, pixels
     */
    getScrollPos() {
        return this.renderArea.scrollPos;
    }
    /**
     * Adjust the DOM scroll position to match the VirtualRenderArea scroll postion, and vice versa.
     * This can fix some issues that occur after DOM height changes
     */
    syncScrollPos() {
        const { nativeElement } = this.element;
        if (nativeElement) {
            if (nativeElement.scrollTop !== this.renderArea.scrollPos) {
                nativeElement.scrollTop = this.renderArea.scrollPos;
                this.renderArea.scrollPos = nativeElement.scrollTop;
            }
        }
    }
    listenForDataChange(model) {
        this.dispose();
        const subscription = model.onDataInvalidated.subscribe(() => this.handleDataChange());
        this.disposers.push(() => subscription.unsubscribe());
    }
    dispose() {
        for (const disposer of this.disposers) {
            disposer();
        }
    }
    handleDataChange() {
        this.renderArea.itemCount = this.model.items.length;
        this.updateVisibleItems();
        this.cdr.detectChanges();
    }
    updateVisibleItems() {
        this.visibleItems = this.model.items.slice(this.renderArea.visibleStart, this.renderArea.visibleStart + this.renderArea.visibleCount);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OfVirtualTreeComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: OfVirtualTreeComponent, selector: "of-virtual-tree", inputs: { model: "model", itemHeight: "itemHeight" }, host: { listeners: { "keydown": "handleKeydown($event)", "scroll": "handleScrollChange()", "window:resize": "handleWindowResize()" }, properties: { "tabIndex": "this.tabIndex" } }, queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: `
        <ng-content select="[tree-before]"></ng-content>
        <div class="vt-bottom-space" [style.top.px]="totalHeight"></div>
        <div class="vt-container" [style.top.px]="topBuffer">
            <ng-template ngFor [ngForOf]="visibleItems" [ngForTemplate]="template"></ng-template>
        </div>
        <ng-content select="[tree-after]"></ng-content>
    `, isInline: true, styles: [":host{outline:none;display:block;height:100%;overflow:auto;position:relative}.vt-container{min-width:100%}.vt-container,.vt-bottom-space{position:absolute}.vt-bottom-space{width:1px;height:1px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OfVirtualTreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'of-virtual-tree', template: `
        <ng-content select="[tree-before]"></ng-content>
        <div class="vt-bottom-space" [style.top.px]="totalHeight"></div>
        <div class="vt-container" [style.top.px]="topBuffer">
            <ng-template ngFor [ngForOf]="visibleItems" [ngForTemplate]="template"></ng-template>
        </div>
        <ng-content select="[tree-after]"></ng-content>
    `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{outline:none;display:block;height:100%;overflow:auto;position:relative}.vt-container{min-width:100%}.vt-container,.vt-bottom-space{position:absolute}.vt-bottom-space{width:1px;height:1px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }], propDecorators: { tabIndex: [{
                type: HostBinding,
                args: ['tabIndex']
            }], template: [{
                type: ContentChild,
                args: [TemplateRef]
            }], model: [{
                type: Input
            }], itemHeight: [{
                type: Input
            }], handleKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], handleScrollChange: [{
                type: HostListener,
                args: ['scroll']
            }], handleWindowResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

/**
 * Node wraps each item in a hierarchy of data, providing relationship info about the items place in the hierarchy
 */
class Node {
    /**
     * The forward sibling to this node
     */
    get next() {
        return this._next;
    }
    /**
     * Check whether lazy loaded children have been loaded
     */
    get childrenLoaded() {
        return !!this._children;
    }
    /**
     * The children of this node
     */
    get children() {
        return this._children ? this._children : (this._children = this._childrenAccessor());
    }
    /**
     * Bool indicating whether this node has children
     */
    get hasChildren() {
        return !!this.children.length;
    }
    /**
     * Bool indicating whether this is the last among its siblings
     */
    get isLastChild() {
        return !this.next;
    }
    /**
     * Bool indicating whether this is the first among its siblings
     */
    get isFirstChild() {
        return !this.prev;
    }
    /**
     * Bool indicating if this is a root node
     */
    get isRoot() {
        return !this.parent;
    }
    /**
     * Gets the first of this node's children
     */
    get firstChild() {
        return this.children[0];
    }
    /**
     * Gets the last of this node's children
     */
    get lastChild() {
        return this.children[this.children.length - 1];
    }
    /**
     * Creates an iterator of this node's ancestors nearest first
     */
    ancestors() {
        const self = this;
        return (function* () {
            let current = self;
            while ((current = current.parent) !== undefined) {
                yield current;
            }
        })();
    }
    /**
     * Get the root node of this node
     */
    getRoot() {
        let node = this;
        while (node && !node.isRoot) {
            node = node.parent;
        }
        return node;
    }
    /**
     * Get the nearest next sibling among ancestor nodes
     */
    ancestorForward() {
        let result;
        for (const ancestor of this.ancestors()) {
            if (ancestor.next) {
                result = ancestor.next;
                break;
            }
            else if (ancestor.isRoot) {
                result = ancestor;
                break;
            }
        }
        return result;
    }
    /**
     * Get the nearest next node.
     * If this is the last of its siblings, the nearest ancestor's next sibling is returned.
     * If wrap is true and if this is the last node of the tree, the root is next.
     * If wrap is false and if this is the last node of the tree, undefined is next.
     * If next is this node, then undefined is returned.
     * @param wrap if true, then the root node is returned for the last node of the tree
     */
    forwardNode(wrap) {
        let next = this.firstChild || this.next;
        if (!next) {
            next = this.ancestorForward();
        }
        if (next && next.isRoot && !wrap) {
            next = undefined;
        }
        return next === this ? undefined : next;
    }
    reverseNode(wrap) {
        let next = this.prev ? this.prev.lastDescendant() : this.parent;
        if (!next && wrap) {
            const root = this.getRoot();
            next = root ? root.lastDescendant() : undefined;
        }
        return next === this ? undefined : next;
    }
    lastDescendant() {
        let result = this, current = this;
        while ((current = current.lastChild) !== undefined) {
            result = current;
        }
        return result;
    }
    invalidateChildren(reloadNow) {
        this._children = undefined;
        if (reloadNow) {
            this._children = this._childrenAccessor();
        }
    }
    visitSubtree(visitor) {
        visitor(this);
        if (this.childrenLoaded) {
            for (const child of this.children) {
                child.visitSubtree(visitor);
            }
        }
    }
    constructor(
    /**
     * The previous sibling of this node
     */
    prev, 
    /**
     * The parent node of this node
     */
    parent, 
    /**
     * The depth of this node or the number of its ancestors
     */
    depth, 
    /**
     * The data item which this node wraps
     */
    item, 
    /**
     * Index relative to the parent
     */
    index, children) {
        this.prev = prev;
        this.parent = parent;
        this.depth = depth;
        this.item = item;
        this.index = index;
        if (prev) {
            prev._next = this;
        }
        this._childrenAccessor = children;
    }
}

/**
 * Wraps arbitrary hierarchical data in a tree structure with depth, parent, children
 * sibling properties, normalizing hierarchical data so that it can be traversed and
 * queried easily.
 */
class TreeQuery {
    /**
     * Create a tree query, starting with an arbitrary data set, and a delegate for loading child items
     * @param items Any arbitrary array of data
     * @param childAccessor A delegate which, given an arbitrary data item, should return that items children, or undefined if the item has no children
     * @param eagerLoad If true, will descend the entire items hierarchy immediately
     */
    static init(items, childAccessor, eagerLoad = true) {
        const query = new TreeQuery(), rootItem = { items }, accessor = childAccessor || (() => []);
        const createNode = (item, depth, parent, prev, index) => {
            let providedChildren = [];
            const childProvider = () => {
                const childItems = item === rootItem ? rootItem.items : accessor(item), children = [];
                query.cleanLookup(providedChildren);
                if (childItems) {
                    let previous;
                    for (let i = 0; i < childItems.length; i++) {
                        const childItem = childItems[i], child = createNode(childItem, depth + 1, result, previous, i);
                        children.push(child);
                        previous = child;
                    }
                }
                return (providedChildren = children);
            }, result = new Node(prev, parent, depth, item, index || 0, childProvider);
            query.nodeLookup.set(item, result);
            result.invalidateChildren(eagerLoad);
            return result;
        };
        query.rootNode = createNode(rootItem, -1);
        return query;
    }
    constructor(iterator) {
        this.nodeLookup = new Map();
        this.customMove = (_current, def) => def();
        this.iterate = iterator ? iterator : this.forwardIterator();
    }
    extend(iterator) {
        const result = new TreeQuery(iterator);
        result.rootNode = this.rootNode;
        result.nodeLookup = this.nodeLookup;
        return result;
    }
    /**
     * Pagination-like, skip past a number of items. Iterarting will not yield that number of items
     * @param count Number of items to skip through
     */
    skip(count) {
        const iterator = this.iterate;
        return this.extend(function* () {
            let i = 0;
            for (const node of iterator()) {
                if (i >= count) {
                    yield node;
                }
                i++;
            }
        });
    }
    /**
     * Pagination-like, iterate through an exact number of items. Iteration ends after that number is reached
     * @param count Number of items to iterate through
     */
    take(count) {
        const iterator = this.iterate;
        return this.extend(function* () {
            let i = 0;
            for (const node of iterator()) {
                if (i >= count) {
                    break;
                }
                yield node;
                i++;
            }
        });
    }
    /**
     * Apply filter by node, so that only nodes passing the filter are yielded during iteration
     * @param filter A delegate returning bool, true if the node should be iterable
     */
    whereNode(filter) {
        const iterator = this.iterate;
        return this.extend(function* () {
            for (const node of iterator()) {
                if (filter(node)) {
                    yield node;
                }
            }
        });
    }
    /**
     * Apply a filter by item which yields the nodes which have descendants matching the filter
     * @param filter A delegate returning bool, true if its ancestors should be iterable
     * @param excludeMatch False to yield items that match the filter
     */
    hasDescendant(filter, excludeMatch = false) {
        return this.hasDescendantNode(n => filter(n.item), excludeMatch);
    }
    /**
     * Apply a filter by node which yields the nodes which have descendants matching the filter
     * @param filter A delegate returning bool, true if its ancestors should be iterable
     * @param excludeMatch False to yield items that match the filter
     */
    hasDescendantNode(filter, excludeMatch = false) {
        const iterator = this.iterate, self = this;
        return this.extend(function* () {
            const matches = new Set();
            for (const node of self.ascend()) {
                if (!matches.has(node) && filter(node)) {
                    if (!excludeMatch) {
                        matches.add(node);
                    }
                    for (const p of node.ancestors()) {
                        matches.add(p);
                    }
                }
            }
            for (const node of iterator()) {
                if (matches.has(node)) {
                    yield node;
                }
            }
        });
    }
    /**
     * Get the number of items in the hierarchy
     */
    count() {
        let result = 0;
        for (const _node of this.iterate()) {
            result++;
        }
        return result;
    }
    /**
     * Get a single item at the given index
     * @param n The overall index of the item in the hierarchy
     */
    nth(n) {
        const result = this.skip(n)
            .take(1)
            .toArray()
            .find(() => true);
        return result;
    }
    /**
     * Apply filter by item, so that only items passing the filter are yielded during iteration
     * @param filter A delegate returning bool, true if the node should be iterable
     */
    where(filter) {
        return this.whereNode(n => filter(n.item));
    }
    /**
     * Get the first item
     */
    first() {
        for (const result of this) {
            return result.item;
        }
        return undefined;
    }
    /**
     * Visit items in the hierarchy in order from top to bottom regardless of depth
     * @param from Where to start ascending from
     * @param wrap True to start back at the last item after reach the root 0th item
     */
    ascend(from, wrap) {
        const node = (from && this.findNode(from)) || undefined;
        return this.extend(this.reverseIterator(node, wrap));
    }
    /**
     * Depth first, visit items in the hierarchy in order from top to bottom
     * @param from Where to start descending from
     * @param wrap True to start back at the root 0th item after reaching the last item
     */
    descend(from, wrap) {
        const node = (from && this.findNode(from)) || undefined;
        return this.extend(this.forwardIterator(node, wrap));
    }
    /**
     * Control descend behavior and skip iterating branches
     * @param provider A delegate which accepts the current node and should return the node to follow
     */
    provideNext(provider) {
        this.customMove = provider;
        return this;
    }
    /**
     * Control descend behavior and override any preexisting descend behavior
     * @param provider A delegate which accepts the current node and should return the node to follow
     */
    forwardOverride(provider) {
        return this.descend()
            .provideNext(provider)
            .descend();
    }
    /**
     * Convenience method for iterating and returning the iterated items as an array
     */
    toArray() {
        const result = [];
        for (const item of this) {
            result.push(item);
        }
        return result;
    }
    /**
     * @ignore
     */
    [Symbol.iterator]() {
        return this.iterate();
    }
    /**
     * Get the root node of this tree. The root node is a container of other nodes.
     */
    getRootNode() {
        return this.rootNode;
    }
    /**
     * O(1) return the node of the passed item, or undefined if the item is not loaded in this hierarchy
     * @param item
     */
    findNode(item) {
        return this.nodeLookup.get(item);
    }
    reverseIterator(from, wrap) {
        const self = this;
        return function* () {
            const start = from || self.rootNode.lastDescendant();
            let current = start, defaultNext;
            const nextAccessor = () => defaultNext || (defaultNext = current.reverseNode(wrap));
            while (!!current) {
                if (!current.isRoot) {
                    yield current;
                }
                current = self.customMove(current, nextAccessor);
                defaultNext = undefined;
                if (current === start) {
                    break;
                }
            }
        };
    }
    forwardIterator(from, wrap) {
        const self = this;
        return function* () {
            const start = from || self.rootNode;
            let current = start, defaultNext;
            const nextAccessor = () => defaultNext || (defaultNext = current.forwardNode(wrap));
            while (!!current) {
                if (!current.isRoot) {
                    yield current;
                }
                current = self.customMove(current, nextAccessor);
                defaultNext = undefined;
                if (current === start) {
                    break;
                }
            }
        };
    }
    cleanLookup(nodes) {
        for (const node of nodes) {
            node.visitSubtree(n => this.nodeLookup.delete(n.item));
        }
    }
}
/** @ignore */
class TreeConfig {
    constructor(childAccessor, eagerLoad = true) {
        this.childAccessor = childAccessor;
        this.eagerLoad = eagerLoad;
    }
    query(items) {
        return TreeQuery.init(items, this.childAccessor, this.eagerLoad);
    }
}

class OfVirtualTree {
    get query() {
        return this._query;
    }
    constructor(config, query) {
        this.config = config;
        this.expandedItems = new Set();
        this.onDataInvalidated = new EventEmitter();
        this.onSelectionChanged = new EventEmitter();
        this.onHighlightChanged = new EventEmitter();
        this.items = [];
        if (query) {
            this._query = query;
        }
        else {
            this._query = new TreeConfig(this.config.childAccessor, !this.config.lazyLoad).query([]);
        }
    }
    updateConfig(value) {
        this.config = value;
    }
    isFiltered() {
        return this.filter !== undefined;
    }
    isSelected(item) {
        return this.selectedItem === item;
    }
    isExpanded(item) {
        return this.expandedItems.has(item);
    }
    isHighlighted(item) {
        return this.highlighted === item;
    }
    highlightByIndex(index) {
        const item = index === undefined || this.items[index] === undefined ? undefined : this.items[index].item;
        this.highlight(item);
    }
    getSelectedIndex() {
        const selectedNode = this.selectedItem ? this.query.findNode(this.selectedItem) : undefined, result = selectedNode ? this.items.indexOf(selectedNode) : undefined;
        return result;
    }
    getItemIndex(item) {
        const node = this.query.findNode(item);
        return node ? this.items.indexOf(node) : -1;
    }
    /**
     * Get the TreeQuery's node for the passed item
     * @param item item for which to get the node
     */
    getTreeNode(item) {
        return this.query.findNode(item);
    }
    /**
     * Set the currently highlighted item
     * @param item item to select
     */
    select(item) {
        if (this.selectedItem !== item) {
            this.selectedItem = item;
            this.onSelectionChanged.emit(item);
        }
    }
    /**
     * Set the currently highlighted item
     * @param item item to highlight, undefined to unset the highlighted item
     */
    highlight(item) {
        if (this.highlighted !== item) {
            this.highlighted = item;
            this.onHighlightChanged.emit(item);
        }
    }
    /**
     * Set the passed item as the currently selected and highlighted item
     * @param item item to select & highlight
     */
    selectAndHighlight(item) {
        this.select(item);
        this.highlight(item);
    }
    /**
     * Get the item that is currently selected
     */
    getSelectedItem() {
        return this.selectedItem;
    }
    /**
     * Get the item that is currently highlighted
     */
    getHighlightedItem() {
        return this.highlighted;
    }
    getExpandedItems() {
        return this.expandedItems;
    }
    /**
     * Selects the highlighted node, and toggles its expand state
     */
    selectHighlightedItem() {
        let didChange = false;
        if (this.highlighted) {
            this.toggle(this.highlighted);
            didChange = this.selectedItem !== this.highlighted;
            this.select(this.highlighted);
        }
        return didChange;
    }
    /**
     * Expand all ancestry of the currently selected item
     */
    expandToSelectedItem() {
        if (this.selectedItem) {
            this.expandToItem(this.selectedItem);
            this.invalidateData();
        }
    }
    /**
     * Expand all ancestry of the passed item
     * @param item item to expand to
     */
    expandToItem(item) {
        const node = this.query.findNode(item);
        if (node) {
            for (const parent of node.ancestors()) {
                if (!parent.isRoot) {
                    this.expandedItems.add(parent.item);
                }
            }
        }
    }
    /**
     * Toggle the expanded state of the passed item
     * @param item item to toggle
     */
    toggle(item) {
        if (this.isExpandable(item)) {
            if (this.isExpanded(item)) {
                this.expandedItems.delete(item);
            }
            else {
                this.expandedItems.add(item);
            }
            this.invalidateData();
        }
    }
    /**
     * Set the expanded state of an item. This does nothing if the item is not expandable or already in the desired state
     * This does not update the UI. Expect to call invalidateData/invalidateItem to see the effect.
     * @param item item to expanded or collapse
     * @param expanded true to expand, false to collapse
     */
    setExpanded(item, expanded) {
        if (this.isExpandable(item)) {
            const isExpanded = this.isExpanded(item);
            if (isExpanded && !expanded) {
                this.expandedItems.delete(item);
            }
            else if (!isExpanded && expanded) {
                this.expandedItems.add(item);
            }
        }
    }
    expandAll() {
        for (const node of this.query) {
            if (this.isExpandable(node.item)) {
                this.expandedItems.add(node.item);
            }
        }
        this.invalidateData();
    }
    collapseAll() {
        this.expandedItems.clear();
        this.invalidateData();
    }
    /**
     * Apply a filter that ignore expand state and makes visible all nodes that either
     * match the predicate or contain a child that matches the predicate
     * @param filter predicate, true to make a node visible
     */
    setFilter(filter) {
        this.filter = filter;
        this.invalidateData();
    }
    /**
     * Returns true if the passed item is expandable
     * @param item item to check
     */
    isExpandable(item) {
        let result = false;
        if (!this.filter && this.config.canExpand) {
            result = this.config.canExpand(item);
        }
        else {
            const node = this.query.findNode(item);
            result = !!node && node.hasChildren;
        }
        return result;
    }
    /**
     * Update data from the root
     * @param items Data to load
     */
    load(items) {
        this._query = new TreeConfig(this.config.childAccessor, !this.config.lazyLoad).query(items);
        this.invalidateData();
    }
    /**
     * Signal children to be reloaded for a particular node.
     * Has no effect if the passed parent has not been loaded
     * @param parent item to reload
     */
    reloadChildren(parent) {
        const node = parent ? this.query.findNode(parent) : this.query.getRootNode();
        if (node) {
            node.invalidateChildren(!this.config.lazyLoad);
            this.invalidateData();
        }
    }
    /**
     * Signal the tree to reload all data
     */
    reloadTree() {
        const root = this.query.getRootNode();
        root.invalidateChildren(!this.config.lazyLoad);
        this.invalidateData();
    }
    /**
     * Change the highlighted node by the given direction.
     * 'Left' will collapse before navigation.
     * 'Right' will expand before navigation.
     * @param direction 'Left' | 'Up' | 'Down' | 'Right'
     */
    navigate(direction) {
        const selectedNode = this.highlighted ? this.query.findNode(this.highlighted) : undefined, index = selectedNode ? this.items.indexOf(selectedNode) : undefined;
        let nextSelectedIndex;
        if (direction === 'Up') {
            nextSelectedIndex = index === undefined ? this.items.length - 1 : index === 0 ? undefined : index - 1;
        }
        else if (direction === 'Down' ||
            (direction === 'Right' && this.highlighted && (!this.isExpandable(this.highlighted) || this.isExpanded(this.highlighted)))) {
            nextSelectedIndex = index === undefined ? 0 : index === this.items.length - 1 ? undefined : index + 1;
        }
        else if (direction === 'Left' && selectedNode) {
            if (this.highlighted && this.isExpanded(this.highlighted)) {
                this.toggle(this.highlighted);
                nextSelectedIndex = index;
            }
            else if (selectedNode.parent) {
                nextSelectedIndex = this.items.indexOf(selectedNode.parent);
            }
        }
        else if (direction === 'Right') {
            if (this.highlighted && !this.isExpanded(this.highlighted)) {
                this.toggle(this.highlighted);
                nextSelectedIndex = index;
            }
        }
        this.highlightByIndex(nextSelectedIndex);
        return nextSelectedIndex;
    }
    /**
     * Signal that the state has changed and the tree needs to be revisited
     */
    invalidateData() {
        if (this.filter) {
            this.items = this.query
                .descend()
                .hasDescendant(this.filter)
                .toArray();
        }
        else {
            this.items = this.query
                .forwardOverride((curr, fallback) => !curr.isRoot && !this.isExpanded(curr.item) ? curr.next || curr.ancestorForward() : fallback())
                .whereNode(n => this.isExpanded(n.parent.item) || n.parent.isRoot)
                .toArray();
        }
        this.onDataInvalidated.emit();
    }
    /**
     * Signal that the children of a node have changed and the node needs to have the children reloaded
     * @param item item whose children should be reloaded
     * @param reloadImmediately true to update children immediate, not on-demand
     */
    invalidateItem(item, reloadImmediately = true) {
        if (item) {
            const node = this.getTreeNode(item);
            if (node) {
                node.invalidateChildren(reloadImmediately);
                this.invalidateData();
            }
        }
    }
}

class VirtualTreeViewComponent {
    constructor(fb) {
        this.fb = fb;
        this.showSearch = false;
        this.showBtnExpandCollapse = true;
        this.itemHeight = 200;
        this.refreshEmit = null;
        this.expandAllEmit = null;
        this.collapseAllEmit = null;
        this.treeViewEmit = null;
        this.callLoadDataFunction = null;
        this.callMergeDataFunction = null;
        this.callTreeViewFunction = null;
        this.invalidSizeEmit = new EventEmitter();
        this.onExpandAllEvent = new EventEmitter();
        this.onCollapseAllEvent = new EventEmitter();
        this.treeModel = new OfVirtualTree({
            canExpand: item => item.childrens && item.childrens.length > 0,
            childAccessor: item => item.childrens
        });
    }
    ngOnInit() {
        if (this.showSearch) {
            this.createFormFilter();
        }
        if (this.refreshEmit) {
            this.refreshEmit.subscribe(item => {
                if (item && this.callMergeDataFunction) {
                    this.callMergeDataFunction({ treeModel: this.treeModel, data: item });
                }
                else {
                    this.loadData();
                }
            });
        }
        if (this.collapseAllEmit) {
            this.collapseAllEmit.subscribe(() => this.onCollapseAll());
        }
        if (this.expandAllEmit) {
            this.expandAllEmit.subscribe(() => this.onExpandAll());
        }
        if (this.treeViewEmit) {
            this.treeViewEmit.subscribe(reg => this.callTreeViewFunction({ treeModel: this.treeModel, evento: reg.evento, data: reg.data }));
        }
        this.loadData();
        this.invalidSizeEmit.subscribe(() => {
            this.ofVirtualTreeComponent.invalidateSize();
        });
    }
    onExpandAll() {
        this.treeModel.expandAll();
        this.onExpandAllEvent.emit(this.treeModel);
    }
    onCollapseAll() {
        this.treeModel.collapseAll();
        this.onCollapseAllEvent.emit(this.treeModel);
    }
    onToggle(item) {
        if (this.callTreeViewFunction) {
            this.callTreeViewFunction({ treeModel: this.treeModel, evento: 'TOGGLE', data: item });
        }
        else {
            this.treeModel.toggle(item);
        }
    }
    loadData() {
        this.callLoadDataFunction().subscribe(data => {
            if (data) {
                this.itemHeight = data.length;
                this.treeModel.load(data);
                setTimeout(() => {
                    this.treeModel.collapseAll();
                }, 1000);
            }
        });
    }
    createFormFilter() {
        this.formularioFiltro = this.fb.group({
            search: ''
        });
        this.formularioFiltro.get('search').valueChanges.subscribe(value => {
            if (value?.length > 0) {
                this.treeModel.setFilter(item => item.codigo.includes(value));
            }
            else {
                this.treeModel.setFilter(undefined);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VirtualTreeViewComponent, deps: [{ token: i1$2.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: VirtualTreeViewComponent, selector: "elo-virtual-tree-view[callLoadDataFunction][invalidSizeEmit]", inputs: { showSearch: "showSearch", showBtnExpandCollapse: "showBtnExpandCollapse", itemHeight: "itemHeight", refreshEmit: "refreshEmit", expandAllEmit: "expandAllEmit", collapseAllEmit: "collapseAllEmit", treeViewEmit: "treeViewEmit", callLoadDataFunction: "callLoadDataFunction", callMergeDataFunction: "callMergeDataFunction", callTreeViewFunction: "callTreeViewFunction", contentTemplate: "contentTemplate", invalidSizeEmit: "invalidSizeEmit" }, outputs: { onExpandAllEvent: "onExpandAllEvent", onCollapseAllEvent: "onCollapseAllEvent" }, viewQueries: [{ propertyName: "ofVirtualTreeComponent", first: true, predicate: OfVirtualTreeComponent, descendants: true }], ngImport: i0, template: "<div class=\"row\">\n    <div class=\"col-md-3 btn-actions-tree flex-display\" *ngIf=\"showBtnExpandCollapse\">\n        <button id=\"btnExpand\" class=\"btn circle\" type=\"button\" (click)=\"onExpandAll()\">\n            <i class=\"fa fa-plus\"></i>\n            <div class=\"btn-actions-label\">Expandir todos</div>\n        </button>\n        <button id=\"btnCollapse\" class=\"btn circle\" type=\"button\" (click)=\"onCollapseAll()\">\n            <i class=\"fa fa-minus\"></i>\n            <div class=\"btn-actions-label\">Recolher todos</div>\n        </button>\n    </div>\n    <div id=\"txtFilter\" class=\"col-md-9\" [formGroup]=\"formularioFiltro\" *ngIf=\"showSearch\">\n        <input id=\"search\" type=\"text\" placeholder=\"Filtrar\" formControlName=\"search\">\n    </div>\n</div>\n<div class=\"container\">\n    <of-virtual-tree id=\"tree-view\" [model]=\"treeModel\" [itemHeight]=\"itemHeight\">\n        <ng-template let-node>\n            <div class=\"tree-view check-box\" [style.paddingLeft.px]=\"(node.depth * 15) + 10\">\n                <div class=\"toggle\" *ngIf=\"treeModel.isExpandable(node.item)\">\n                    <i class=\"fa fa-angle-right\" *ngIf=\"!treeModel.isExpanded(node.item)\"\n                        (click)=\"onToggle(node.item)\" [style.marginLeft.px]=\"node.depth * 15\"></i>\n                    <i class=\"fa fa-angle-down\" *ngIf=\"treeModel.isExpanded(node.item)\"\n                        (click)=\"onToggle(node.item)\" [style.marginLeft.px]=\"node.depth * 15\"></i>\n                </div>\n\n\n                <ng-container [ngTemplateOutlet]=\"contentTemplate || defaultTemplate\"\n                    [ngTemplateOutletContext]=\"{ $implicit: node }\"></ng-container>\n\n            </div>\n\n        </ng-template>\n    </of-virtual-tree>\n    <ng-content select=\"div.subtitles\"></ng-content>\n</div>\n\n<ng-template #defaultTemplate let-node>\n    <span>{{node.item.descricao}}</span>\n</ng-template>", styles: [".btn-actions-tree .btn{min-width:20px;width:20px;height:20px;font-size:12px;margin-top:4px}.item-selected{background-color:#e4e4e4}.panel-body .panel-table.fixed tbody{max-height:calc(100vh - 300px)!important}.chip-container{margin:0 5px 0 0!important;height:13px!important}.chip-container p{margin:0 5px!important;font-size:10px!important}.tree-view label{min-height:20px;margin-right:20px;margin-bottom:0;font-weight:400;white-space:nowrap;cursor:pointer}.tree-view label span{padding:5px}.tree-view label i{padding-left:2px}.tree-view>div.toggle{position:absolute;left:0;height:0}.container{border:1px solid #d6d6d6;border-radius:3px;height:calc(100vh - 345px);margin:10px 0 0;padding:10px 0 0 15px;width:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: OfVirtualTreeComponent, selector: "of-virtual-tree", inputs: ["model", "itemHeight"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VirtualTreeViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-virtual-tree-view[callLoadDataFunction][invalidSizeEmit]', template: "<div class=\"row\">\n    <div class=\"col-md-3 btn-actions-tree flex-display\" *ngIf=\"showBtnExpandCollapse\">\n        <button id=\"btnExpand\" class=\"btn circle\" type=\"button\" (click)=\"onExpandAll()\">\n            <i class=\"fa fa-plus\"></i>\n            <div class=\"btn-actions-label\">Expandir todos</div>\n        </button>\n        <button id=\"btnCollapse\" class=\"btn circle\" type=\"button\" (click)=\"onCollapseAll()\">\n            <i class=\"fa fa-minus\"></i>\n            <div class=\"btn-actions-label\">Recolher todos</div>\n        </button>\n    </div>\n    <div id=\"txtFilter\" class=\"col-md-9\" [formGroup]=\"formularioFiltro\" *ngIf=\"showSearch\">\n        <input id=\"search\" type=\"text\" placeholder=\"Filtrar\" formControlName=\"search\">\n    </div>\n</div>\n<div class=\"container\">\n    <of-virtual-tree id=\"tree-view\" [model]=\"treeModel\" [itemHeight]=\"itemHeight\">\n        <ng-template let-node>\n            <div class=\"tree-view check-box\" [style.paddingLeft.px]=\"(node.depth * 15) + 10\">\n                <div class=\"toggle\" *ngIf=\"treeModel.isExpandable(node.item)\">\n                    <i class=\"fa fa-angle-right\" *ngIf=\"!treeModel.isExpanded(node.item)\"\n                        (click)=\"onToggle(node.item)\" [style.marginLeft.px]=\"node.depth * 15\"></i>\n                    <i class=\"fa fa-angle-down\" *ngIf=\"treeModel.isExpanded(node.item)\"\n                        (click)=\"onToggle(node.item)\" [style.marginLeft.px]=\"node.depth * 15\"></i>\n                </div>\n\n\n                <ng-container [ngTemplateOutlet]=\"contentTemplate || defaultTemplate\"\n                    [ngTemplateOutletContext]=\"{ $implicit: node }\"></ng-container>\n\n            </div>\n\n        </ng-template>\n    </of-virtual-tree>\n    <ng-content select=\"div.subtitles\"></ng-content>\n</div>\n\n<ng-template #defaultTemplate let-node>\n    <span>{{node.item.descricao}}</span>\n</ng-template>", styles: [".btn-actions-tree .btn{min-width:20px;width:20px;height:20px;font-size:12px;margin-top:4px}.item-selected{background-color:#e4e4e4}.panel-body .panel-table.fixed tbody{max-height:calc(100vh - 300px)!important}.chip-container{margin:0 5px 0 0!important;height:13px!important}.chip-container p{margin:0 5px!important;font-size:10px!important}.tree-view label{min-height:20px;margin-right:20px;margin-bottom:0;font-weight:400;white-space:nowrap;cursor:pointer}.tree-view label span{padding:5px}.tree-view label i{padding-left:2px}.tree-view>div.toggle{position:absolute;left:0;height:0}.container{border:1px solid #d6d6d6;border-radius:3px;height:calc(100vh - 345px);margin:10px 0 0;padding:10px 0 0 15px;width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }], propDecorators: { showSearch: [{
                type: Input
            }], showBtnExpandCollapse: [{
                type: Input
            }], itemHeight: [{
                type: Input
            }], refreshEmit: [{
                type: Input
            }], expandAllEmit: [{
                type: Input
            }], collapseAllEmit: [{
                type: Input
            }], treeViewEmit: [{
                type: Input
            }], callLoadDataFunction: [{
                type: Input
            }], callMergeDataFunction: [{
                type: Input
            }], callTreeViewFunction: [{
                type: Input
            }], contentTemplate: [{
                type: Input
            }], invalidSizeEmit: [{
                type: Input
            }], onExpandAllEvent: [{
                type: Output
            }], onCollapseAllEvent: [{
                type: Output
            }], ofVirtualTreeComponent: [{
                type: ViewChild,
                args: [OfVirtualTreeComponent]
            }] } });

class SetAttrsDirective {
    set attrs(value) {
        this._attrs = value;
        this.applyAttributes();
    }
    constructor(el) {
        this.el = el;
        this._attrs = undefined;
        this.applyAttributes();
    }
    applyAttributes() {
        const attrs = this._attrs, el = this.el.nativeElement;
        if (attrs && el) {
            for (const name of Object.keys(attrs)) {
                el.setAttribute(name, attrs[name]);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SetAttrsDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SetAttrsDirective, selector: "[ofSetAttrs]", inputs: { attrs: ["ofSetAttrs", "attrs"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SetAttrsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ofSetAttrs]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { attrs: [{
                type: Input,
                args: ['ofSetAttrs']
            }] } });

var DefaultIcons;
(function (DefaultIcons) {
    DefaultIcons["file"] = "of-file-text";
    DefaultIcons["folder"] = "of-folder";
    DefaultIcons["folderOpen"] = "of-folder-open";
})(DefaultIcons || (DefaultIcons = {}));
class OfBasicTreeComponent {
    /**
     * Allows applying an arbitrary filter to the tree. This overrides filterText
     */
    set filter(value) {
        this.model.setFilter(value);
    }
    /**
     * Filter the tree with default text filter, case insenstive contains on item names
     */
    set filterText(value) {
        this.handleFilterTextChange(value);
    }
    /**
     * The config for the tree
     */
    set config(value) {
        this.childAccessor = value.childAccessor || this.childAccessor;
        this._config = { ...this._config, ...value, childAccessor: this.config.childAccessor };
        this.model.updateConfig(this.config);
    }
    get config() {
        return this._config;
    }
    /**
     * returns true if filterText or a filter function is applied
     */
    get isFiltered() {
        return this.model.isFiltered();
    }
    /**
     * Get the current model or set a custom model for the tree
     */
    set model(value) {
        this._model = value;
        this.bindModelEvents();
    }
    get model() {
        return this._model;
    }
    /**
     * Input for loading data into the tree
     */
    set data(items) {
        this.model.load(items);
    }
    /**
     * Input for the selected item
     */
    set selection(value) {
        if (!this.model.isSelected(value)) {
            this.model.select(value);
            this.navigateToSelection();
        }
    }
    constructor(host) {
        this.host = host;
        this.disposers = [];
        this._filterText = '';
        this.loadingItems = new Set();
        this.ownId = Math.random().toString();
        this.dragExpand = {};
        this.stateProvider = Object.seal({
            isExpanded: (item) => this.model.isExpanded(item),
            isSelected: (item) => this.model.isSelected(item),
            isHighlighted: (item) => this.model.isHighlighted(item),
            isLoading: (item) => this.isItemLoading(item)
        });
        this._config = {
            childAccessor: (item) => this.getChildren(item),
            getIcon: (item) => item.type !== 'd' && item.type !== 'Folder'
                ? item.icon || this.config.itemIcon
                : this.model.isExpanded(item)
                    ? DefaultIcons.folderOpen
                    : DefaultIcons.folder,
            getName: (item) => item.name,
            getDomNodeAttr: () => undefined,
            itemIcon: DefaultIcons.file,
            filterThrottle: 500,
            filterTextMinLength: 2,
            lazyLoad: true,
            canDrag: () => false,
            canDrop: () => false,
            move: () => Promise.resolve(),
            getDragData: () => '{}'
        };
        /**
         * Fires on change of the selected item, [selection]
         */
        this.selectionChange = new EventEmitter();
        /**
         * ContextMenu event on tree rows, allows custom right-click menus
         */
        this.itemContextMenu = new EventEmitter();
        /**
         * Click event that fires on click of the icon portion of a tree row
         */
        this.iconClick = new EventEmitter();
        /**
         * Click event that fires on click of the label portion of a tree row
         */
        this.labelClick = new EventEmitter();
        /**
         * Click event that fires on click of any part of a tree row
         */
        this.rowClick = new EventEmitter();
        /**
         * @ignore
         */
        this.isDraggingOver = false;
        this.childAccessor = (item) => item.children;
        this._model = new OfVirtualTree(this.config);
        this.bindModelEvents();
        this.itemHeight = 1.5 * parseFloat(window.getComputedStyle(document.body).fontSize || '16');
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.tree.invalidateSize();
            this.model.invalidateData();
        }, 1);
    }
    ngOnDestroy() {
        this.disposeSubscriptions();
    }
    /** @ignore */
    handleContextMenu(evt, item) {
        this.itemContextMenu.emit({ event: evt, item });
    }
    /** @ignore */
    handleRowClick(evt, item) {
        this.model.selectAndHighlight(item);
        this.rowClick.emit({ event: evt, item });
    }
    /**
     * Scrolls and expands nodes so that the selected item is visible in the tree
     */
    navigateToSelection() {
        this.model.expandToSelectedItem();
        return this.tree.scrollToSelected();
    }
    /**
     * Scrolls and expands nodes so that the passed item is visible in the tree
     */
    navigateToItem(item) {
        this.model.expandToItem(item);
        return this.tree.scrollToItem(item);
    }
    /** @ignore */
    getIcon(node) {
        return `of-icon ${this.config.getIcon(node.item, node, this.stateProvider)}`;
    }
    /** @ignore */
    getDomNodeAttr(node) {
        return this.config.getDomNodeAttr ? this.config.getDomNodeAttr(node.item, node, this.stateProvider) : undefined;
    }
    /** @ignore */
    getName(item) {
        return this.config.getName(item, this.stateProvider) || '';
    }
    /** @ignore */
    getExpanderIcon(item) {
        const iconType = this.model.isExpanded(item) ? 'down' : 'right';
        return `of-expander of-expander-${iconType}`;
    }
    /** @ignore */
    handleDragstart(evt, node) {
        this.ownDragItem = node;
        if (this.canDrag(node.item)) {
            if (evt.dataTransfer) {
                evt.dataTransfer.dropEffect = 'move';
                evt.dataTransfer.setData('application/json.of-tree-item', this.getDragData(node.item));
                evt.dataTransfer.setData(`text/plain.${this.ownId}`, '{}');
            }
        }
    }
    /** @ignore */
    handleDragover(evt) {
        this.isDraggingOver = true;
        if (evt.dataTransfer && evt.dataTransfer.types.includes('application/json.of-tree-item')) {
            const dropInfo = this.getDropInfo(evt, false);
            if (dropInfo.canDrop()) {
                this.adjustDragOverlay(dropInfo);
                evt.preventDefault();
            }
            if (dropInfo.draggedItem !== dropInfo.parent) {
                this.tryDragExpand(dropInfo);
            }
        }
    }
    /** @ignore */
    handleDragleave() {
        this.isDraggingOver = false;
    }
    /** @ignore */
    handleDrop(evt) {
        this.isDraggingOver = false;
        if (evt.dataTransfer && evt.dataTransfer.types.includes('application/json.of-tree-item')) {
            const dropInfo = this.getDropInfo(evt, true);
            if (dropInfo.canDrop()) {
                this.move(dropInfo.draggedItem, dropInfo.parent, dropInfo.index);
            }
        }
    }
    /** @ignore */
    canDrag(item) {
        return this.config.canDrag(item);
    }
    tryDragExpand(dropInfo) {
        if (dropInfo.area !== 'on' || this.dragExpand.item !== dropInfo.parent) {
            clearTimeout(this.dragExpand.timeout);
        }
        if (this.dragExpand.item !== dropInfo.parent && dropInfo.parent && dropInfo.area === 'on') {
            this.dragExpand.item = dropInfo.parent;
            this.dragExpand.timeout = window.setTimeout(() => {
                this.model.setExpanded(dropInfo.parent.item, true);
                this.model.invalidateData();
            }, 600);
        }
    }
    async move(item, parent, index) {
        if (this.config.move) {
            const itemNode = item instanceof Node ? item : undefined, itemData = itemNode ? itemNode.item : item, parentItem = parent ? parent.item : undefined, fromParent = itemNode && itemNode.parent ? itemNode.parent.item : undefined;
            await this.config.move({
                itemNode,
                parentNode: parent,
                item: itemData,
                parent: parentItem,
                index
            });
            this.model.invalidateItem(fromParent);
            this.model.invalidateItem(parent.item);
        }
    }
    getDropInfo(evt, readExternalData) {
        const box = this.getHostBox(), boxY = box ? box.top : 0, yPos = evt.pageY - boxY, target = this.getItemPosition(yPos), draggedItem = evt.dataTransfer.types.includes(`text/plain.${this.ownId}`)
            ? this.ownDragItem
            : readExternalData && evt.dataTransfer
                ? JSON.parse(evt.dataTransfer.getData('application/json.oce-tree-item'))
                : undefined;
        return {
            draggedItem,
            index: target.itemIndex,
            parent: target.item,
            flatIndex: target.flatIndex,
            area: target.area,
            canDrop: () => {
                const item = draggedItem instanceof Node ? draggedItem.item : draggedItem, itemNode = this.model.getTreeNode(item), parentNode = target.item, parent = target.item ? target.item.item : undefined, index = target.itemIndex;
                return this.canDrop(itemNode, parentNode, item, parent, index);
            }
        };
    }
    getItemPosition(yPos) {
        const scroll = this.tree.getScrollPos(), flatIndex = Math.floor((yPos + scroll) / this.itemHeight), itemPos = flatIndex * this.itemHeight - scroll, buffer = this.itemHeight / 4, area = itemPos + buffer > yPos ? 'before' : itemPos + this.itemHeight - buffer < yPos ? 'after' : 'on', itemAtIndex = this.model.items[flatIndex], itemIndex = !itemAtIndex || !itemAtIndex.parent
            ? undefined
            : area === 'before'
                ? itemAtIndex.index
                : area === 'after'
                    ? itemAtIndex.index + 1
                    : undefined, item = !itemAtIndex ? undefined : area === 'on' ? itemAtIndex : itemAtIndex.parent;
        return { flatIndex, itemIndex, item, area };
    }
    getHostBox() {
        if (!this.hostBox && this.host.nativeElement) {
            this.hostBox = this.host.nativeElement.getBoundingClientRect();
            setTimeout(() => (this.hostBox = undefined), 1000);
        }
        return this.hostBox;
    }
    getDragData(item) {
        return this.config.getDragData(item);
    }
    canDrop(itemNode, parentNode, item, parent, index) {
        if (this.config.canDrop) {
            return this.config.canDrop({ itemNode, parentNode, item, parent, index });
        }
        return false;
    }
    adjustDragOverlay(dropInfo) {
        if (this.dragOverlay && this.dragOverlay.nativeElement) {
            const el = this.dragOverlay.nativeElement;
            if (dropInfo) {
                const buffer = this.itemHeight / 4, baseY = dropInfo.flatIndex * this.itemHeight, y = dropInfo.area === 'before' ? baseY - buffer : dropInfo.area === 'after' ? baseY + this.itemHeight - buffer : baseY, h = dropInfo.area === 'on' ? this.itemHeight : buffer * 2;
                el.style.top = y + 'px';
                el.style.height = h + 'px';
                if (dropInfo.area === 'on') {
                    el.classList.remove('vbt-dragoverlay-between');
                }
                else {
                    el.classList.add('vbt-dragoverlay-between');
                }
            }
            else {
                el.style.height = '0px';
            }
        }
    }
    getChildren(item) {
        const result = this.childAccessor(item);
        if (result instanceof Promise) {
            this.loadChildren(item, result);
            return undefined;
        }
        return result;
    }
    async loadChildren(item, childrenPromise) {
        this.loadingItems.add(item);
        try {
            await childrenPromise;
            this.model.invalidateItem(item);
        }
        finally {
            this.loadingItems.delete(item);
        }
    }
    isItemLoading(item) {
        return this.loadingItems.has(item);
    }
    bindModelEvents() {
        const selectionHandler = (item) => this.selectionChange.emit(item), subscription = this.model.onSelectionChanged.subscribe(selectionHandler);
        this.disposeSubscriptions();
        this.disposers.push(() => subscription.unsubscribe());
    }
    disposeSubscriptions() {
        this.disposers.forEach(d => d());
    }
    handleFilterTextChange(value) {
        if (value && value.length > this.config.filterTextMinLength) {
            this.setTextFilter(value);
        }
        else {
            this.clearTextFilter();
        }
        this._filterText = value;
    }
    setTextFilter(value) {
        const text = value.toLowerCase();
        clearTimeout(this.filterTextThrottle);
        this.filterTextThrottle = setTimeout(() => this.model.setFilter(item => this.getName(item)
            .toLowerCase()
            .indexOf(text) >= 0), this.config.filterThrottle);
    }
    clearTextFilter() {
        if (this._filterText && this._filterText.length > this.config.filterTextMinLength) {
            clearTimeout(this.filterTextThrottle);
            this.model.setFilter(undefined);
            this.model.expandToSelectedItem();
            this.tree.scrollToSelected();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OfBasicTreeComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: OfBasicTreeComponent, selector: "of-basic-tree", inputs: { itemHeight: "itemHeight", filter: "filter", filterText: "filterText", config: "config", model: "model", data: "data", selection: "selection" }, outputs: { selectionChange: "selectionChange", itemContextMenu: "itemContextMenu", iconClick: "iconClick", labelClick: "labelClick", rowClick: "rowClick" }, host: { listeners: { "dragover": "handleDragover($event)", "dragleave": "handleDragleave()", "drop": "handleDrop($event)" } }, viewQueries: [{ propertyName: "tree", first: true, predicate: OfVirtualTreeComponent, descendants: true }, { propertyName: "dragOverlay", first: true, predicate: ["dragOverlay"], descendants: true }], ngImport: i0, template: "<of-virtual-tree [itemHeight]=\"itemHeight\" [model]=\"model\">\n    <ng-template let-node>\n        <div\n            class=\"of-node\"\n            [style.paddingLeft.rem]=\"1.5 * (node.depth + 1)\"\n            [style.height.px]=\"itemHeight\"\n            [ofSetAttrs]=\"getDomNodeAttr(node)\"\n            (contextmenu)=\"handleContextMenu($event, node.item)\"\n        >\n            <i\n                *ngIf=\"model.isExpandable(node.item) && !isFiltered\"\n                (click)=\"model.toggle(node.item)\"\n                [class]=\"getExpanderIcon(node.item)\"\n            ></i>\n            <div\n                class=\"of-node-title\"\n                [draggable]=\"canDrag(node.item)\"\n                (dragstart)=\"handleDragstart($event, node)\"\n                (click)=\"handleRowClick($event, node.item)\"\n            >\n                <i [class]=\"getIcon(node)\" (click)=\"iconClick.emit({ event: $event, item: node.item })\"></i>\n                <div\n                    class=\"of-label\"\n                    (click)=\"labelClick.emit({ event: $event, item: node.item })\"\n                    [class.of-highlight]=\"model.isHighlighted(node.item)\"\n                    [class.of-selected]=\"model.isSelected(node.item)\"\n                >\n                    {{ getName(node.item) }}\n                </div>\n            </div>\n        </div>\n    </ng-template>\n    <div #dragOverlay tree-before class=\"of-dragoverlay\" [style.display]=\"isDraggingOver ? 'block' : 'none'\"></div>\n</of-virtual-tree>\n", styles: [":host{height:100%;display:block;position:relative}:host ::ng-deep .vt-container{min-width:auto}.of-node{display:flex;white-space:nowrap;align-items:center}.of-expander{margin-left:-1.5rem;width:1.5rem;cursor:pointer;display:block;height:1rem;background-size:contain;background-position-x:50%;background-repeat:no-repeat}.of-expander.of-expander-right{background-image:url('data:image/svg+xml;utf8,<svg width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1152 896q0 26-19 45l-448 448q-19 19-45 19t-45-19-19-45v-896q0-26 19-45t45-19 45 19l448 448q19 19 19 45z\"/></svg>')}.of-expander.of-expander-down{background-image:url('data:image/svg+xml;utf8,<svg width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z\"/></svg>')}.of-icon{width:1rem;height:1rem;display:block;background-size:contain;background-position:50%}.of-icon.of-folder{background-image:url('data:image/svg+xml;utf8,<svg width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1600 1312v-704q0-40-28-68t-68-28h-704q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v960q0 40 28 68t68 28h1216q40 0 68-28t28-68zm128-704v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z\"/></svg>')}.of-icon.of-folder-open{background-image:url('data:image/svg+xml;utf8,<svg width=\"2048\" height=\"1792\" viewBox=\"0 0 2048 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1845 931q0-35-53-35h-1088q-40 0-85.5 21.5t-71.5 52.5l-294 363q-18 24-18 40 0 35 53 35h1088q40 0 86-22t71-53l294-363q18-22 18-39zm-1141-163h768v-160q0-40-28-68t-68-28h-576q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v853l256-315q44-53 116-87.5t140-34.5zm1269 163q0 62-46 120l-295 363q-43 53-116 87.5t-140 34.5h-1088q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158v160h192q54 0 99 24.5t67 70.5q15 32 15 68z\"/></svg>')}.of-icon.of-file-text{background-image:url('data:image/svg+xml;utf8,<svg width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-1024-864q0-14 9-23t23-9h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64zm736 224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704zm0 256q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704z\"/></svg>')}.of-node-title{cursor:pointer;display:flex;align-items:center;flex:1 1 100%}.of-label{white-space:nowrap;padding:0 .25rem;line-height:1.5rem}.of-label:hover{background:#c9def5}.of-label.of-selected{background:#88afd7}.of-highlight{outline:solid 1px orange}.of-dragoverlay{position:absolute;background:#c9def5;left:0;width:100%}.of-dragoverlay.of-dragoverlay-between:before{content:\"\";height:2px;margin-top:-1px;top:50%;width:100%;background:#6899ce;position:absolute}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: OfVirtualTreeComponent, selector: "of-virtual-tree", inputs: ["model", "itemHeight"] }, { kind: "directive", type: SetAttrsDirective, selector: "[ofSetAttrs]", inputs: ["ofSetAttrs"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OfBasicTreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'of-basic-tree', template: "<of-virtual-tree [itemHeight]=\"itemHeight\" [model]=\"model\">\n    <ng-template let-node>\n        <div\n            class=\"of-node\"\n            [style.paddingLeft.rem]=\"1.5 * (node.depth + 1)\"\n            [style.height.px]=\"itemHeight\"\n            [ofSetAttrs]=\"getDomNodeAttr(node)\"\n            (contextmenu)=\"handleContextMenu($event, node.item)\"\n        >\n            <i\n                *ngIf=\"model.isExpandable(node.item) && !isFiltered\"\n                (click)=\"model.toggle(node.item)\"\n                [class]=\"getExpanderIcon(node.item)\"\n            ></i>\n            <div\n                class=\"of-node-title\"\n                [draggable]=\"canDrag(node.item)\"\n                (dragstart)=\"handleDragstart($event, node)\"\n                (click)=\"handleRowClick($event, node.item)\"\n            >\n                <i [class]=\"getIcon(node)\" (click)=\"iconClick.emit({ event: $event, item: node.item })\"></i>\n                <div\n                    class=\"of-label\"\n                    (click)=\"labelClick.emit({ event: $event, item: node.item })\"\n                    [class.of-highlight]=\"model.isHighlighted(node.item)\"\n                    [class.of-selected]=\"model.isSelected(node.item)\"\n                >\n                    {{ getName(node.item) }}\n                </div>\n            </div>\n        </div>\n    </ng-template>\n    <div #dragOverlay tree-before class=\"of-dragoverlay\" [style.display]=\"isDraggingOver ? 'block' : 'none'\"></div>\n</of-virtual-tree>\n", styles: [":host{height:100%;display:block;position:relative}:host ::ng-deep .vt-container{min-width:auto}.of-node{display:flex;white-space:nowrap;align-items:center}.of-expander{margin-left:-1.5rem;width:1.5rem;cursor:pointer;display:block;height:1rem;background-size:contain;background-position-x:50%;background-repeat:no-repeat}.of-expander.of-expander-right{background-image:url('data:image/svg+xml;utf8,<svg width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1152 896q0 26-19 45l-448 448q-19 19-45 19t-45-19-19-45v-896q0-26 19-45t45-19 45 19l448 448q19 19 19 45z\"/></svg>')}.of-expander.of-expander-down{background-image:url('data:image/svg+xml;utf8,<svg width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z\"/></svg>')}.of-icon{width:1rem;height:1rem;display:block;background-size:contain;background-position:50%}.of-icon.of-folder{background-image:url('data:image/svg+xml;utf8,<svg width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1600 1312v-704q0-40-28-68t-68-28h-704q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v960q0 40 28 68t68 28h1216q40 0 68-28t28-68zm128-704v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z\"/></svg>')}.of-icon.of-folder-open{background-image:url('data:image/svg+xml;utf8,<svg width=\"2048\" height=\"1792\" viewBox=\"0 0 2048 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1845 931q0-35-53-35h-1088q-40 0-85.5 21.5t-71.5 52.5l-294 363q-18 24-18 40 0 35 53 35h1088q40 0 86-22t71-53l294-363q18-22 18-39zm-1141-163h768v-160q0-40-28-68t-68-28h-576q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v853l256-315q44-53 116-87.5t140-34.5zm1269 163q0 62-46 120l-295 363q-43 53-116 87.5t-140 34.5h-1088q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158v160h192q54 0 99 24.5t67 70.5q15 32 15 68z\"/></svg>')}.of-icon.of-file-text{background-image:url('data:image/svg+xml;utf8,<svg width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-1024-864q0-14 9-23t23-9h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64zm736 224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704zm0 256q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704z\"/></svg>')}.of-node-title{cursor:pointer;display:flex;align-items:center;flex:1 1 100%}.of-label{white-space:nowrap;padding:0 .25rem;line-height:1.5rem}.of-label:hover{background:#c9def5}.of-label.of-selected{background:#88afd7}.of-highlight{outline:solid 1px orange}.of-dragoverlay{position:absolute;background:#c9def5;left:0;width:100%}.of-dragoverlay.of-dragoverlay-between:before{content:\"\";height:2px;margin-top:-1px;top:50%;width:100%;background:#6899ce;position:absolute}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { tree: [{
                type: ViewChild,
                args: [OfVirtualTreeComponent]
            }], selectionChange: [{
                type: Output
            }], itemContextMenu: [{
                type: Output
            }], iconClick: [{
                type: Output
            }], labelClick: [{
                type: Output
            }], rowClick: [{
                type: Output
            }], itemHeight: [{
                type: Input
            }], dragOverlay: [{
                type: ViewChild,
                args: ['dragOverlay']
            }], filter: [{
                type: Input
            }], filterText: [{
                type: Input
            }], config: [{
                type: Input
            }], model: [{
                type: Input
            }], data: [{
                type: Input
            }], selection: [{
                type: Input
            }], handleDragover: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], handleDragleave: [{
                type: HostListener,
                args: ['dragleave']
            }], handleDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });

class OfVirtualTreeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OfVirtualTreeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: OfVirtualTreeModule, declarations: [OfVirtualTreeComponent, OfBasicTreeComponent, SetAttrsDirective], imports: [CommonModule], exports: [OfVirtualTreeComponent, OfBasicTreeComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OfVirtualTreeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OfVirtualTreeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OfVirtualTreeComponent, OfBasicTreeComponent, SetAttrsDirective],
                    imports: [CommonModule],
                    exports: [OfVirtualTreeComponent, OfBasicTreeComponent]
                }]
        }] });

class VirtualTreeViewModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VirtualTreeViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: VirtualTreeViewModule, declarations: [VirtualTreeViewComponent], imports: [CommonModule,
            ReactiveFormsModule,
            OfVirtualTreeModule], exports: [VirtualTreeViewComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VirtualTreeViewModule, imports: [CommonModule,
            ReactiveFormsModule,
            OfVirtualTreeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VirtualTreeViewModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [VirtualTreeViewComponent],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        OfVirtualTreeModule
                    ],
                    exports: [VirtualTreeViewComponent]
                }]
        }] });

class WidgetFrequentlyItemComponent {
    constructor(authHttp) {
        this.authHttp = authHttp;
    }
    ngOnInit() {
        this.hasPermission = this.authHttp.hasPermissionByRoute(this.routerLink);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyItemComponent, deps: [{ token: AbstractAuthHttp }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WidgetFrequentlyItemComponent, selector: "widget-frequently-item", inputs: { routerLink: "routerLink", icone: "icone", title: "title", subTitle: "subTitle" }, ngImport: i0, template: "<li class=\"item\" *ngIf=\"hasPermission | async\">\n    <a [routerLink]=\"routerLink\">\n        <em class=\"{{icone}}\"></em>\n        <div class=\"text\">\n            <div class=\"text-inner\">\n                <span class=\"father\">\n                    {{title}}\n                </span>\n                <div class=\"children\">\n                    {{subTitle}}\n                </div>\n            </div>\n        </div>\n    </a>\n</li>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'widget-frequently-item', template: "<li class=\"item\" *ngIf=\"hasPermission | async\">\n    <a [routerLink]=\"routerLink\">\n        <em class=\"{{icone}}\"></em>\n        <div class=\"text\">\n            <div class=\"text-inner\">\n                <span class=\"father\">\n                    {{title}}\n                </span>\n                <div class=\"children\">\n                    {{subTitle}}\n                </div>\n            </div>\n        </div>\n    </a>\n</li>" }]
        }], ctorParameters: () => [{ type: AbstractAuthHttp }], propDecorators: { routerLink: [{
                type: Input
            }], icone: [{
                type: Input
            }], title: [{
                type: Input
            }], subTitle: [{
                type: Input
            }] } });

class WidgetFrequentlyItemModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyItemModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyItemModule, declarations: [WidgetFrequentlyItemComponent], imports: [CommonModule, RouterModule], exports: [WidgetFrequentlyItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyItemModule, imports: [CommonModule, RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyItemModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule],
                    declarations: [WidgetFrequentlyItemComponent],
                    exports: [WidgetFrequentlyItemComponent],
                    providers: [],
                }]
        }] });

class WidgetFrequentlyComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WidgetFrequentlyComponent, selector: "widget-frequently", ngImport: i0, template: "<div class=\"cms-frequently\">\n    <ul class=\"cms-frequently-list\">\n        <ng-content selector=\"widget-frequently-item\"></ng-content>\n    </ul>\n</div>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'widget-frequently', template: "<div class=\"cms-frequently\">\n    <ul class=\"cms-frequently-list\">\n        <ng-content selector=\"widget-frequently-item\"></ng-content>\n    </ul>\n</div>" }]
        }] });

class WidgetFrequentlyModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyModule, declarations: [WidgetFrequentlyComponent], imports: [CommonModule, WidgetFrequentlyItemModule], exports: [WidgetFrequentlyComponent, WidgetFrequentlyItemModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyModule, imports: [CommonModule, WidgetFrequentlyItemModule, WidgetFrequentlyItemModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetFrequentlyModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, WidgetFrequentlyItemModule],
                    declarations: [WidgetFrequentlyComponent],
                    exports: [WidgetFrequentlyComponent, WidgetFrequentlyItemModule],
                    providers: [],
                }]
        }] });

class WidgetAreaComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetAreaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WidgetAreaComponent, selector: "elo-widget-area", ngImport: i0, template: "<div class=\"row widget-area\">\n  <ng-content selector=\"elo-widget-panel\"></ng-content>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetAreaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-widget-area', template: "<div class=\"row widget-area\">\n  <ng-content selector=\"elo-widget-panel\"></ng-content>\n</div>\n" }]
        }] });

class WidgetHighlightComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetHighlightComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WidgetHighlightComponent, selector: "elo-widget-highlight", inputs: { text: "text", subtitle: "subtitle" }, ngImport: i0, template: "  <article class=\"widget-highlight\" widget-body>\n    <b class=\"widget-highlight-text\">{{text}}</b>\n    <p class=\"widget-highlight-subtitle\">{{subtitle}}</p>\n    <div class=\"widget-highlight-detail\">\n      <ng-content select=\"[highlight-detail]\"></ng-content>\n    </div>\n  </article>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetHighlightComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-widget-highlight', template: "  <article class=\"widget-highlight\" widget-body>\n    <b class=\"widget-highlight-text\">{{text}}</b>\n    <p class=\"widget-highlight-subtitle\">{{subtitle}}</p>\n    <div class=\"widget-highlight-detail\">\n      <ng-content select=\"[highlight-detail]\"></ng-content>\n    </div>\n  </article>\n" }]
        }], propDecorators: { text: [{
                type: Input
            }], subtitle: [{
                type: Input
            }] } });

class WidgetNumericComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetNumericComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WidgetNumericComponent, selector: "elo-widget-numeric", inputs: { numeric: "numeric", subtitle: "subtitle" }, ngImport: i0, template: "  <article class=\"widget-numeric\" widget-body>\n    <b class=\"widget-numeric-number\">{{numeric}}</b>\n    <p class=\"widget-numeric-subtitle\">{{subtitle}}</p>\n  </article>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetNumericComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-widget-numeric', template: "  <article class=\"widget-numeric\" widget-body>\n    <b class=\"widget-numeric-number\">{{numeric}}</b>\n    <p class=\"widget-numeric-subtitle\">{{subtitle}}</p>\n  </article>\n" }]
        }], propDecorators: { numeric: [{
                type: Input
            }], subtitle: [{
                type: Input
            }] } });

class WidgetPanelComponent {
    constructor() {
        this.smCols = 6;
        this.mdCols = 4;
        this.smOffsetCols = 3;
        this.mdOffsetCols = 4;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WidgetPanelComponent, selector: "elo-widget-panel", inputs: { smCols: "smCols", mdCols: "mdCols", smOffsetCols: "smOffsetCols", mdOffsetCols: "mdOffsetCols", iconClass: "iconClass" }, ngImport: i0, template: "<div class=\"col-sm-{{smCols}} col-md-{{mdCols}} col-md-offset-{{mdOffsetCols}} col-sm-offset-{{smOffsetCols}}\">\n  <div class='panel widget'>\n    <span *ngIf='iconClass' class='widget-icon'>\n\t\t\t\t\t\t<em class=\"{{iconClass}}\"></em>\n\t\t\t\t\t</span>\n\n    <div class='panel-title'>\n      <ng-content select=\"[widget-title]\"></ng-content>\n    </div>\n\n    <div class='panel-body'>\n      <ng-content select=\"[widget-body]\"></ng-content>\n    </div>\n\n    <ng-content select=\"[widget-footer]\">\n    </ng-content>\n\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-widget-panel', template: "<div class=\"col-sm-{{smCols}} col-md-{{mdCols}} col-md-offset-{{mdOffsetCols}} col-sm-offset-{{smOffsetCols}}\">\n  <div class='panel widget'>\n    <span *ngIf='iconClass' class='widget-icon'>\n\t\t\t\t\t\t<em class=\"{{iconClass}}\"></em>\n\t\t\t\t\t</span>\n\n    <div class='panel-title'>\n      <ng-content select=\"[widget-title]\"></ng-content>\n    </div>\n\n    <div class='panel-body'>\n      <ng-content select=\"[widget-body]\"></ng-content>\n    </div>\n\n    <ng-content select=\"[widget-footer]\">\n    </ng-content>\n\n  </div>\n</div>\n" }]
        }], propDecorators: { smCols: [{
                type: Input
            }], mdCols: [{
                type: Input
            }], smOffsetCols: [{
                type: Input
            }], mdOffsetCols: [{
                type: Input
            }], iconClass: [{
                type: Input
            }] } });

class WidgetProgressComponent {
    constructor() {
        /**
        * @param classType positive, negative or neutral
        */
        this.classType = 'neutral';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetProgressComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WidgetProgressComponent, selector: "elo-widget-progress", inputs: { classType: "classType", progress: "progress", title: "title", subtitle: "subtitle" }, ngImport: i0, template: "<div id=\"widgetProgress\" class=\"panel widget widget-same-height mt-none\">\n  <div class=\"panel-body center\">\n    <article class=\"widget-numeric\">\n      <div id=\"progressbarCenter\" class=\"progressbar-circle center {{classType}}\">\n        <div id=\"progress\" class=\"reach-{{progress}} progressbar-circle-reacher\"></div>\n        <div class=\"progressbar-circle-content-outer\">\n          <div class=\"progressbar-circle-content\">\n            <h2 id=\"title\" class=\"progressbar-circle-title\">{{title}}</h2>\n          </div>\n        </div>\n      </div>\n      <p id=\"subtitle\" class=\"widget-numeric-subtitle\">{{subtitle}}</p>\n    </article>\n  </div>\n\n  <ng-content select=\"[progress-detail]\"></ng-content>\n\n</div>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetProgressComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-widget-progress', template: "<div id=\"widgetProgress\" class=\"panel widget widget-same-height mt-none\">\n  <div class=\"panel-body center\">\n    <article class=\"widget-numeric\">\n      <div id=\"progressbarCenter\" class=\"progressbar-circle center {{classType}}\">\n        <div id=\"progress\" class=\"reach-{{progress}} progressbar-circle-reacher\"></div>\n        <div class=\"progressbar-circle-content-outer\">\n          <div class=\"progressbar-circle-content\">\n            <h2 id=\"title\" class=\"progressbar-circle-title\">{{title}}</h2>\n          </div>\n        </div>\n      </div>\n      <p id=\"subtitle\" class=\"widget-numeric-subtitle\">{{subtitle}}</p>\n    </article>\n  </div>\n\n  <ng-content select=\"[progress-detail]\"></ng-content>\n\n</div>" }]
        }], propDecorators: { classType: [{
                type: Input
            }], progress: [{
                type: Input
            }], title: [{
                type: Input
            }], subtitle: [{
                type: Input
            }] } });

class WidgetModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: WidgetModule, declarations: [WidgetAreaComponent,
            WidgetPanelComponent,
            WidgetNumericComponent,
            WidgetHighlightComponent,
            WidgetProgressComponent], imports: [CommonModule], exports: [WidgetAreaComponent,
            WidgetPanelComponent,
            WidgetNumericComponent,
            WidgetHighlightComponent,
            WidgetProgressComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WidgetModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [
                        WidgetAreaComponent,
                        WidgetPanelComponent,
                        WidgetNumericComponent,
                        WidgetHighlightComponent,
                        WidgetProgressComponent
                    ],
                    declarations: [
                        WidgetAreaComponent,
                        WidgetPanelComponent,
                        WidgetNumericComponent,
                        WidgetHighlightComponent,
                        WidgetProgressComponent
                    ]
                }]
        }] });

class WizardStepComponent {
    constructor() {
        this.selected = false;
        this.visible = true;
        this.valid = true;
        this.triedToValidate = false;
        this.done = false;
        this.showErrorMessage = false;
        this.validateStep = () => of(true);
    }
    resetState() {
        this.valid = true;
        this.triedToValidate = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WizardStepComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WizardStepComponent, selector: "elo-wizard-step", inputs: { title: "title", selected: "selected", visible: "visible", valid: "valid", invalidMessage: "invalidMessage", triedToValidate: "triedToValidate", icon: "icon", done: "done", showErrorMessage: "showErrorMessage", order: "order", validateStep: "validateStep" }, ngImport: i0, template: "<div [hidden]=\"!selected\">\n    <ng-content></ng-content>\n </div>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WizardStepComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-wizard-step', template: "<div [hidden]=\"!selected\">\n    <ng-content></ng-content>\n </div>" }]
        }], propDecorators: { title: [{
                type: Input
            }], selected: [{
                type: Input
            }], visible: [{
                type: Input
            }], valid: [{
                type: Input
            }], invalidMessage: [{
                type: Input
            }], triedToValidate: [{
                type: Input
            }], icon: [{
                type: Input
            }], done: [{
                type: Input
            }], showErrorMessage: [{
                type: Input
            }], order: [{
                type: Input
            }], validateStep: [{
                type: Input
            }] } });

class WizardControlComponent {
    constructor() {
        this.onSelected = new EventEmitter();
        this.onClosed = new EventEmitter();
        this.onFinalized = new EventEmitter();
        this.saveAnyStep = false;
        this.previousButtonOn = false;
        this.nextButtonOn = true;
        this.cancelButtonOn = true;
        this.finishButtonOn = true;
        this.showSave = true;
        this.showBackButton = true;
        this.useDynamicOrder = false;
        this.saveButtonOn = false;
    }
    ngAfterContentInit() {
        if (this.useDynamicOrder) {
            const invalidOrder = this.steps.toArray().find(item => !item.order || isNaN(item.order));
            if (invalidOrder) {
                throw new Error('Obrigatório informar [order] para todos os steps');
            }
            this.steps.reset(this.steps.toArray().sort((a, b) => a.order - b.order));
        }
        this.saveButtonOn = this.finishButtonOn;
        let selectedStep = this.steps.filter(step => step.selected);
        if (!selectedStep.length) {
            this.selectStep(this.steps.first);
        }
        else {
            this.selectStep(selectedStep[0]);
        }
    }
    selectStep(step, button) {
        let positionSelectedStep;
        let selectedStep = this.steps.filter((step, index) => {
            if (step.selected) {
                positionSelectedStep = index;
                return step.selected;
            }
        });
        let positionCurrentStep = this.steps.toArray().indexOf(step);
        if (selectedStep.length) {
            if (positionCurrentStep !== positionSelectedStep) {
                let index;
                if (button === 'previous' && this.previousButtonOn || positionCurrentStep >= 0 && positionCurrentStep < positionSelectedStep) {
                    index = button ? positionSelectedStep - 1 : positionCurrentStep;
                    selectedStep[0].done = false;
                    if (!selectedStep[0].valid && selectedStep[0].showErrorMessage) {
                        selectedStep[0].showErrorMessage = false;
                    }
                    this.steps.forEach((step, s) => {
                        if (s >= index) {
                            step.done = false;
                        }
                    });
                }
                if (button === 'next' || positionCurrentStep > positionSelectedStep) {
                    selectedStep[0]
                        .validateStep()
                        .subscribe(isValid => {
                        if (!isValid) {
                            return;
                        }
                        if (selectedStep[0].valid) {
                            index = button ? positionSelectedStep + 1 : positionCurrentStep;
                            if (this.steps.toArray()[index]) {
                                selectedStep[0].done = true;
                                this.steps.forEach((step, s) => {
                                    if (s < index) {
                                        if (step.valid) {
                                            step.done = true;
                                        }
                                        else {
                                            index = s;
                                            this.steps.toArray()[index].triedToValidate = true;
                                            this.validation(this.steps.toArray()[index]);
                                        }
                                    }
                                });
                            }
                        }
                        else {
                            this.validation(selectedStep[0]);
                        }
                        if (this.steps.toArray()[index]) {
                            selectedStep[0].selected = false;
                            this.steps.toArray()[index].selected = true;
                            this.steps.toArray()[index].done = false;
                            this.onSelected.emit({ selectedStep: this.steps.toArray()[index] });
                        }
                        this.updateButtons();
                    });
                }
                else {
                    if (this.steps.toArray()[index]) {
                        selectedStep[0].selected = false;
                        this.steps.toArray()[index].selected = true;
                        this.steps.toArray()[index].done = false;
                        this.onSelected.emit({ selectedStep: this.steps.toArray()[index] });
                    }
                    this.updateButtons();
                }
            }
            else {
                this.validation(selectedStep[0]);
            }
        }
        else {
            step.selected = true;
            this.onSelected.emit({ selectedStep: step });
            this.updateButtons();
        }
    }
    closeButtonClick() {
        let selectedStep = this.steps.filter(step => step.selected);
        this.onClosed.emit({ currentStep: selectedStep[0] });
    }
    finalizeButtonClick() {
        let invalidStep = this.steps.filter(step => !step.valid);
        if (!invalidStep.length) {
            let selectedStep = this.steps.filter(step => step.selected);
            this.onFinalized.emit({ currentStep: selectedStep[0] });
        }
        else {
            return false;
        }
    }
    validation(step) {
        step.triedToValidate = true;
        setTimeout(() => {
            setTimeout(() => {
                step.showErrorMessage = false;
            }, 4000);
            step.showErrorMessage = true;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 200);
    }
    updateButtons() {
        let stepsDone = this.steps.filter((step) => step.done);
        if (stepsDone.length) {
            this.previousButtonOn = true;
        }
        else {
            this.previousButtonOn = false;
            this.nextButtonOn = true;
        }
        if (stepsDone.length === this.steps.toArray().length - 1) {
            this.nextButtonOn = false;
            this.saveButtonOn = true;
        }
        else {
            this.nextButtonOn = true;
            if (!this.saveAnyStep) {
                this.saveButtonOn = false;
            }
        }
    }
    get allSteps() {
        return this.steps.filter(step => step.visible);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WizardControlComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WizardControlComponent, selector: "elo-wizard-control", inputs: { saveAnyStep: "saveAnyStep", previousButtonOn: "previousButtonOn", nextButtonOn: "nextButtonOn", cancelButtonOn: "cancelButtonOn", finishButtonOn: "finishButtonOn", showSave: "showSave", showBackButton: "showBackButton", useDynamicOrder: "useDynamicOrder", extraButtonsTemplate: "extraButtonsTemplate" }, outputs: { onSelected: "onSelected", onClosed: "onClosed", onFinalized: "onFinalized" }, queries: [{ propertyName: "steps", predicate: WizardStepComponent }], ngImport: i0, template: "<elo-panel>\n  <div class=\"wizard title\">\n    <ul class=\"wizard-header\">\n      <li class=\"step\" *ngFor=\"let step of allSteps\" [class.active]=\"step.selected || step.done\"\n        [class.on]=\"step.showErrorMessage\" (click)=\"selectStep(step)\"\n        [attr.data-error]=\"!step.valid && step.triedToValidate\">\n        <em [class]=\"step.icon\"></em>\n        <p class=\"error-content\" *ngIf=\"!step.valid && step.triedToValidate\">{{step.invalidMessage}}</p>\n        <div class=\"title\" id=\"idStep_{{steps?.toArray()?.indexOf(step)}}\">\n          {{step.title}}\n        </div>\n      </li>\n    </ul>\n    <ul class=\"wizard-content\">\n      <ng-content></ng-content>\n    </ul>\n    <!-- wizard -->\n    <div class=\"footer-wizard\">\n\n      <button (click)=\"selectStep(null, 'previous')\" type=\"button\" id=\"previousButton\"\n        class=\"btn btn-step-backward neutral inline\" [disabled]=\"!previousButtonOn\">Anterior</button>\n      <button *ngIf=\"nextButtonOn\" (click)=\"selectStep(null, 'next')\" id=\"nextButton\" type=\"button\"\n        class=\"btn btn-step-forward module-color\" [disabled]=\"!nextButtonOn\">Pr\u00F3ximo</button>\n      <button *ngIf=\"!nextButtonOn && saveButtonOn\" id=\"saveButton\" (click)=\"finalizeButtonClick()\" type=\"button\"\n        class=\"btn btn-step-forward module-color\" [disabled]=\"!finishButtonOn\" singleClickButton>Finalizar</button>\n\n      <div class=\"extra-buttons\" role=\"group\" *ngIf=\"extraButtonsTemplate\" id=\"extraButtonsTemplate\">\n        <ng-container *ngTemplateOutlet=\"extraButtonsTemplate\"></ng-container>\n      </div>\n\n    </div>\n  </div>\n</elo-panel>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: PanelComponent, selector: "elo-panel", inputs: ["title", "hasTable", "hasForm", "pbNone"] }, { kind: "directive", type: SingleClickButtonDirective, selector: "[singleClickButton]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WizardControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-wizard-control', template: "<elo-panel>\n  <div class=\"wizard title\">\n    <ul class=\"wizard-header\">\n      <li class=\"step\" *ngFor=\"let step of allSteps\" [class.active]=\"step.selected || step.done\"\n        [class.on]=\"step.showErrorMessage\" (click)=\"selectStep(step)\"\n        [attr.data-error]=\"!step.valid && step.triedToValidate\">\n        <em [class]=\"step.icon\"></em>\n        <p class=\"error-content\" *ngIf=\"!step.valid && step.triedToValidate\">{{step.invalidMessage}}</p>\n        <div class=\"title\" id=\"idStep_{{steps?.toArray()?.indexOf(step)}}\">\n          {{step.title}}\n        </div>\n      </li>\n    </ul>\n    <ul class=\"wizard-content\">\n      <ng-content></ng-content>\n    </ul>\n    <!-- wizard -->\n    <div class=\"footer-wizard\">\n\n      <button (click)=\"selectStep(null, 'previous')\" type=\"button\" id=\"previousButton\"\n        class=\"btn btn-step-backward neutral inline\" [disabled]=\"!previousButtonOn\">Anterior</button>\n      <button *ngIf=\"nextButtonOn\" (click)=\"selectStep(null, 'next')\" id=\"nextButton\" type=\"button\"\n        class=\"btn btn-step-forward module-color\" [disabled]=\"!nextButtonOn\">Pr\u00F3ximo</button>\n      <button *ngIf=\"!nextButtonOn && saveButtonOn\" id=\"saveButton\" (click)=\"finalizeButtonClick()\" type=\"button\"\n        class=\"btn btn-step-forward module-color\" [disabled]=\"!finishButtonOn\" singleClickButton>Finalizar</button>\n\n      <div class=\"extra-buttons\" role=\"group\" *ngIf=\"extraButtonsTemplate\" id=\"extraButtonsTemplate\">\n        <ng-container *ngTemplateOutlet=\"extraButtonsTemplate\"></ng-container>\n      </div>\n\n    </div>\n  </div>\n</elo-panel>" }]
        }], propDecorators: { steps: [{
                type: ContentChildren,
                args: [WizardStepComponent]
            }], onSelected: [{
                type: Output
            }], onClosed: [{
                type: Output
            }], onFinalized: [{
                type: Output
            }], saveAnyStep: [{
                type: Input
            }], previousButtonOn: [{
                type: Input
            }], nextButtonOn: [{
                type: Input
            }], cancelButtonOn: [{
                type: Input
            }], finishButtonOn: [{
                type: Input
            }], showSave: [{
                type: Input
            }], showBackButton: [{
                type: Input
            }], useDynamicOrder: [{
                type: Input
            }], extraButtonsTemplate: [{
                type: Input
            }] } });

class WizardControlModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WizardControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: WizardControlModule, declarations: [WizardControlComponent, WizardStepComponent], imports: [CommonModule, PanelModule, DirectivesModule], exports: [WizardControlComponent, WizardStepComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WizardControlModule, imports: [CommonModule, PanelModule, DirectivesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WizardControlModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PanelModule, DirectivesModule],
                    exports: [WizardControlComponent, WizardStepComponent],
                    declarations: [WizardControlComponent, WizardStepComponent]
                }]
        }] });

class ProgressbarComponent {
    constructor() {
        this.labelInicial = 'Iniciando...';
        this.labelGeracao = 'Gerando...';
        this.quantidadeEsperada = 0;
        this.quantidadeFinalizado = 0;
        this.isCompleted = () => this.quantidadeEsperada != 0 && this.quantidadeFinalizado === this.quantidadeEsperada;
    }
    getPercentual() {
        return Math.round((this.quantidadeFinalizado / this.quantidadeEsperada) * 100);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProgressbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ProgressbarComponent, selector: "elo-progressbar", inputs: { labelInicial: "labelInicial", labelGeracao: "labelGeracao", quantidadeEsperada: "quantidadeEsperada", quantidadeFinalizado: "quantidadeFinalizado", isCompleted: "isCompleted" }, ngImport: i0, template: "<div class=\"progressbar\">\n\n  <div *ngIf=\"quantidadeFinalizado === 0\"\n       class=\"bg-yellow-60 reach-100 animated progressbar-reacher striped\">\n    {{ labelInicial }}\n  </div>\n\n  <div\n    *ngIf=\"quantidadeFinalizado > 0\"\n    class=\"reach-{{getPercentual()}} animated progressbar-reacher {{isCompleted() ? '' : 'positive striped'}}\">\n    {{ quantidadeFinalizado }} de {{ quantidadeEsperada }} {{ labelGeracao }}\n  </div>\n\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProgressbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-progressbar', template: "<div class=\"progressbar\">\n\n  <div *ngIf=\"quantidadeFinalizado === 0\"\n       class=\"bg-yellow-60 reach-100 animated progressbar-reacher striped\">\n    {{ labelInicial }}\n  </div>\n\n  <div\n    *ngIf=\"quantidadeFinalizado > 0\"\n    class=\"reach-{{getPercentual()}} animated progressbar-reacher {{isCompleted() ? '' : 'positive striped'}}\">\n    {{ quantidadeFinalizado }} de {{ quantidadeEsperada }} {{ labelGeracao }}\n  </div>\n\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { labelInicial: [{
                type: Input
            }], labelGeracao: [{
                type: Input
            }], quantidadeEsperada: [{
                type: Input
            }], quantidadeFinalizado: [{
                type: Input
            }], isCompleted: [{
                type: Input
            }] } });

class ProgressbarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProgressbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ProgressbarModule, declarations: [ProgressbarComponent], imports: [CommonModule], exports: [ProgressbarComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProgressbarModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProgressbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        ProgressbarComponent
                    ],
                    exports: [
                        ProgressbarComponent
                    ]
                }]
        }] });

class ExtracaoImportacaoDisplayComponent {
    constructor(webSocketService) {
        this.webSocketService = webSocketService;
        this.displayPadrao = true;
        this.showFinished = true;
        this.onFinishImport = new EventEmitter();
        this.onUpdateImport = new EventEmitter();
        this.dadosImportados = new Map();
    }
    ngOnInit() {
        if (this.status?.values) {
            this.createDadosToList();
        }
        this.initWebSocket();
    }
    ngOnDestroy() {
        this.webSocketService.getInstance().off(this.topic);
    }
    ngOnChanges() {
        this.createDadosToList();
    }
    initWebSocket() {
        this.webSocketService.getInstance().on(this.topic, message => this.handleWebSocketMessage(message));
    }
    handleWebSocketMessage(message) {
        this.status = JSON.parse(message[0]);
        if (this.status.importado) {
            this.onFinishImport.emit(this.topic);
        }
        else {
            this.onUpdateImport.emit(this.status);
        }
    }
    createDadosToList() {
        this.status?.values?.forEach(result => {
            const descricao = result?.status?.descricao;
            const descricaoValues = this.dadosImportados.get(descricao);
            if (!descricaoValues) {
                this.dadosImportados.set(descricao, [result]);
            }
            else {
                descricaoValues.push(result);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoDisplayComponent, deps: [{ token: WebsocketService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ExtracaoImportacaoDisplayComponent, selector: "extracao-importacao-display", inputs: { topic: "topic", fieldsToDisplay: "fieldsToDisplay", status: "status", displayPadrao: "displayPadrao", showFinished: "showFinished" }, outputs: { onFinishImport: "onFinishImport", onUpdateImport: "onUpdateImport" }, usesOnChanges: true, ngImport: i0, template: "<elo-panel title=\"Dados Importados\" *ngIf=\"displayPadrao\">\n  <ng-template [ngTemplateOutlet]=\"display\"/>\n</elo-panel>\n\n<div *ngIf=\"!displayPadrao\">\n  <ng-template [ngTemplateOutlet]=\"display\"/>\n</div>\n\n<ng-template #display>\n  <div class=\"mt-xs\">\n\n    <div class=\"row\" *ngIf=\"!status\">\n      <div class=\"col-md-12\">\n        <div class=\"card placeholder-loader\">\n          <div class=\"loading\"></div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\" *ngIf=\"(status && !status?.values) || !showFinished else showDados;\">\n      <elo-form-label-column label=\"Quantidade Executada\" column=\"2\">\n        <div class=\"loading\"></div>\n        {{status?.quantidadeExecutada}} de {{status?.quantidadeTotal}}\n      </elo-form-label-column>\n\n      <elo-form-label-column label=\"Progresso\" column=\"10\">\n        <div class=\"progressbar\">\n          <div class=\"reach-{{status?.percentual}} progressbar-reacher positive \">\n          </div>\n        </div>\n      </elo-form-label-column>\n    </div>\n\n  </div>\n\n  <ng-template #showDados>\n\n    <ng-container *ngIf=\"status?.quantidadeExecutada\">\n\n      <elo-panel-expansive *ngFor=\"let mapDados of dadosImportados | keyvalue\" [title]='mapDados.key'\n                           [collapsed]=\"true\">\n\n        <elo-datatable [values]=\"mapDados.value\" [class]=\"'border fancy'\"\n                       [emptyMessage]=\"'N\u00E3o foi importado nenhum dado.'\" [headerFixo]=\"true\">\n\n          <elo-column *ngFor=\"let field of fieldsToDisplay\" [hidden]=\"field.field == 'errorMessage' && mapDados.key != 'Inconsistente' && mapDados.key != 'N\u00E3o importado'\"\n                      [field]=\"field.field\" [header]=\"field.header\">\n          </elo-column>\n\n        </elo-datatable>\n\n      </elo-panel-expansive>\n    </ng-container>\n\n  </ng-template>\n\n</ng-template>\n", dependencies: [{ kind: "component", type: PanelComponent, selector: "elo-panel", inputs: ["title", "hasTable", "hasForm", "pbNone"] }, { kind: "component", type: FormLabelColumnComponent, selector: "elo-form-label-column", inputs: ["label", "color", "column", "offset", "hintMessage", "hintPosition", "hintIconLeftAlign", "linkTitle", "showLink", "icon"], outputs: ["onClickLink"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: EloDatatableComponent, selector: "elo-datatable", inputs: ["values", "paramExpandTemplate", "emptyMessage", "selection", "selectionMode", "selectionModeId", "fieldShowCheckbox", "checkboxDisabledWhenFunction", "titleCheckboxDisallowed", "sortable", "pageParameters", "class", "colSpanActions", "isQuickViewOpener", "manyActions", "classEmptyMessage", "rowDoubleClickFunction", "visibleRadioWhenFunction", "enableScrollX", "textTransform", "headerFixo", "showHeader", "selectionModeWithFooter"], outputs: ["onClickCheckbox", "onClickRadioButton", "onSelectOne", "onModifySelection", "onTableHeadClick", "onInputChange", "onRowDoubleClick"] }, { kind: "component", type: EloColumnComponent, selector: "elo-column", inputs: ["field", "header", "headerAlign", "isDecimal", "isPercentual", "digits", "isDate", "isDateTime", "isCnpjCpf", "enumOptions", "col", "class", "isEditable", "isEditing", "dataTable", "hidden", "hiddenTableData", "sortable", "samp", "headerStyle", "dataStyle"] }, { kind: "component", type: PanelExpansiveComponent, selector: "elo-panel-expansive", inputs: ["collapsed", "title", "hasTable", "hasForm", "expansive", "showButton", "disabledButton", "hideButtonNovo", "titleButtonNovo", "extraButtons", "enableScrollX", "isInsideTab", "collapsedCookie", "error"], outputs: ["onExpand", "onNewItem"] }, { kind: "pipe", type: i1.KeyValuePipe, name: "keyvalue" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoDisplayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'extracao-importacao-display', template: "<elo-panel title=\"Dados Importados\" *ngIf=\"displayPadrao\">\n  <ng-template [ngTemplateOutlet]=\"display\"/>\n</elo-panel>\n\n<div *ngIf=\"!displayPadrao\">\n  <ng-template [ngTemplateOutlet]=\"display\"/>\n</div>\n\n<ng-template #display>\n  <div class=\"mt-xs\">\n\n    <div class=\"row\" *ngIf=\"!status\">\n      <div class=\"col-md-12\">\n        <div class=\"card placeholder-loader\">\n          <div class=\"loading\"></div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\" *ngIf=\"(status && !status?.values) || !showFinished else showDados;\">\n      <elo-form-label-column label=\"Quantidade Executada\" column=\"2\">\n        <div class=\"loading\"></div>\n        {{status?.quantidadeExecutada}} de {{status?.quantidadeTotal}}\n      </elo-form-label-column>\n\n      <elo-form-label-column label=\"Progresso\" column=\"10\">\n        <div class=\"progressbar\">\n          <div class=\"reach-{{status?.percentual}} progressbar-reacher positive \">\n          </div>\n        </div>\n      </elo-form-label-column>\n    </div>\n\n  </div>\n\n  <ng-template #showDados>\n\n    <ng-container *ngIf=\"status?.quantidadeExecutada\">\n\n      <elo-panel-expansive *ngFor=\"let mapDados of dadosImportados | keyvalue\" [title]='mapDados.key'\n                           [collapsed]=\"true\">\n\n        <elo-datatable [values]=\"mapDados.value\" [class]=\"'border fancy'\"\n                       [emptyMessage]=\"'N\u00E3o foi importado nenhum dado.'\" [headerFixo]=\"true\">\n\n          <elo-column *ngFor=\"let field of fieldsToDisplay\" [hidden]=\"field.field == 'errorMessage' && mapDados.key != 'Inconsistente' && mapDados.key != 'N\u00E3o importado'\"\n                      [field]=\"field.field\" [header]=\"field.header\">\n          </elo-column>\n\n        </elo-datatable>\n\n      </elo-panel-expansive>\n    </ng-container>\n\n  </ng-template>\n\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: WebsocketService }], propDecorators: { topic: [{
                type: Input,
                args: [{ required: true }]
            }], fieldsToDisplay: [{
                type: Input
            }], status: [{
                type: Input
            }], displayPadrao: [{
                type: Input
            }], showFinished: [{
                type: Input
            }], onFinishImport: [{
                type: Output
            }], onUpdateImport: [{
                type: Output
            }] } });

class ExtracaoImportacaoComponent {
    constructor(formBuilder, windowService) {
        this.formBuilder = formBuilder;
        this.windowService = windowService;
        this.fieldsToDisplay = [];
        this.onCloseModal = new EventEmitter();
        this.nomeArquivo = 'arquivo';
        this.showFormArquivo = false;
        this.openModalDados = false;
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.service, 'service not found in ExtracaoImportacaoComponent');
        this.form = this.formBuilder.group({
            arquivo: ['', Validators.required]
        });
        this.getTopic();
        this.verifyStatus();
    }
    onImportar() {
        this.showFormArquivo = true;
    }
    importar() {
        this.showFormArquivo = false;
        this.service.importar(this.form.get('arquivo').value).subscribe();
        this.openModal();
        this.form.reset();
    }
    onExportar() {
        this.service.exportar(this.evento).subscribe(result => {
            this.windowService.downloadBlob(URL.createObjectURL(new Blob([result], { type: 'application/text;charset=utf-8' })), `${this.nomeArquivo}.json`);
        });
    }
    handleFileInput(files) {
        this.form.get('arquivo').patchValue(files.item(0));
    }
    openModal() {
        this.openModalDados = !this.openModalDados;
        if (!this.openModalDados) {
            this.onCloseModal.emit();
            this.verifyStatus();
        }
    }
    getTopic() {
        this.service.getImportacaoTopic().subscribe(topic => {
            this.topic = topic;
        });
    }
    verifyStatus() {
        this.service.getStatus().subscribe(status => {
            if (status?.quantidadeExecutada !== status?.quantidadeTotal) {
                this.openModalDados = true;
            }
        });
    }
    finishImport() {
        this.service.getStatus().subscribe(status => {
            this.status = status;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoComponent, deps: [{ token: i1$2.UntypedFormBuilder }, { token: WindowService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ExtracaoImportacaoComponent, selector: "extracao-importacao", inputs: { service: "service", fieldsToDisplay: "fieldsToDisplay", title: "title", evento: "evento", nomeArquivo: "nomeArquivo" }, outputs: { onCloseModal: "onCloseModal" }, ngImport: i0, template: "<float-button>\n\n  <button class=\"btn hint clean module-color lg\" type=\"button\" title=\"Exportar\" (click)=\"onExportar()\">\n    <i class=\"fa fa-sign-out\"></i>\n    <div class=\"hint-content\">Exportar</div>\n  </button>\n\n\n  <button class=\"btn hint clean module-color lg\" type=\"button\" title=\"Importar\" (click)=\"onImportar()\">\n    <i class=\"fa fa-sign-in\"></i>\n    <div class=\"hint-content\">Importar</div>\n  </button>\n\n  <ng-content></ng-content>\n\n</float-button>\n\n<elo-dialog [title]=\"title\" [show]=\"showFormArquivo\" (onOkEvent)=\"importar()\" (onCancelEvent)=\"showFormArquivo=false\"\n  classType=\"positive\" [disableOkButton]=\"this.form.invalid\">\n\n  <form [formGroup]=\"form\">\n\n    <div class=\"row\">\n      <div class=\"col-md-12 \">\n        <div class=\"form-group\">\n          <file-upload id=\"arquivo\" formControlName=\"arquivo\" [multipartForm]=\"true\" [required]=\"true\"\n            [allowedFileType]=\"['json']\">\n          </file-upload>\n        </div>\n      </div>\n    </div>\n  </form>\n\n</elo-dialog>\n\n<elo-modal [isOpen]=\"openModalDados\" (openClose)=\"openModal()\" *ngIf=\"openModalDados\">\n\n  <extracao-importacao-display [topic]=\"topic\" [fieldsToDisplay]=\"fieldsToDisplay\"\n    (onFinishImport)=\"finishImport()\" [status]=\"status\"/>\n\n</elo-modal>\n", dependencies: [{ kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: FloatButtonComponent, selector: "float-button", inputs: ["hintContent"] }, { kind: "component", type: DialogComponent, selector: "elo-dialog", inputs: ["show", "showCancel", "classType", "tittleCancel", "tittleOk", "title", "disableOkButton", "debounceTime"], outputs: ["onOkEvent", "onCancelEvent"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: EloModalComponent, selector: "elo-modal", inputs: ["isOpen", "customWidth", "isCentralized", "preventClose"], outputs: ["openClose"] }, { kind: "component", type: FileUploadComponent, selector: "file-upload", inputs: ["showRequiredMessage", "allowedFileType", "required", "maxLengthNameFile", "multipartForm", "defaultMessage"], outputs: ["onChangeFile"] }, { kind: "component", type: ExtracaoImportacaoDisplayComponent, selector: "extracao-importacao-display", inputs: ["topic", "fieldsToDisplay", "status", "displayPadrao", "showFinished"], outputs: ["onFinishImport", "onUpdateImport"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'extracao-importacao', template: "<float-button>\n\n  <button class=\"btn hint clean module-color lg\" type=\"button\" title=\"Exportar\" (click)=\"onExportar()\">\n    <i class=\"fa fa-sign-out\"></i>\n    <div class=\"hint-content\">Exportar</div>\n  </button>\n\n\n  <button class=\"btn hint clean module-color lg\" type=\"button\" title=\"Importar\" (click)=\"onImportar()\">\n    <i class=\"fa fa-sign-in\"></i>\n    <div class=\"hint-content\">Importar</div>\n  </button>\n\n  <ng-content></ng-content>\n\n</float-button>\n\n<elo-dialog [title]=\"title\" [show]=\"showFormArquivo\" (onOkEvent)=\"importar()\" (onCancelEvent)=\"showFormArquivo=false\"\n  classType=\"positive\" [disableOkButton]=\"this.form.invalid\">\n\n  <form [formGroup]=\"form\">\n\n    <div class=\"row\">\n      <div class=\"col-md-12 \">\n        <div class=\"form-group\">\n          <file-upload id=\"arquivo\" formControlName=\"arquivo\" [multipartForm]=\"true\" [required]=\"true\"\n            [allowedFileType]=\"['json']\">\n          </file-upload>\n        </div>\n      </div>\n    </div>\n  </form>\n\n</elo-dialog>\n\n<elo-modal [isOpen]=\"openModalDados\" (openClose)=\"openModal()\" *ngIf=\"openModalDados\">\n\n  <extracao-importacao-display [topic]=\"topic\" [fieldsToDisplay]=\"fieldsToDisplay\"\n    (onFinishImport)=\"finishImport()\" [status]=\"status\"/>\n\n</elo-modal>\n" }]
        }], ctorParameters: () => [{ type: i1$2.UntypedFormBuilder }, { type: WindowService }], propDecorators: { service: [{
                type: Input
            }], fieldsToDisplay: [{
                type: Input
            }], title: [{
                type: Input
            }], evento: [{
                type: Input
            }], onCloseModal: [{
                type: Output
            }], nomeArquivo: [{
                type: Input
            }] } });

class ExtracaoImportacaoService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
    }
    exportar(filter) {
        return this.httpClient.post({
            resource: `${this.resource}/exportar`,
            responseType: 'blob',
            body: {
                search: filter
            }
        });
    }
    importar(arquivo) {
        const formData = new FormData();
        formData.append('file', arquivo, arquivo.name);
        return this.httpClient.post({
            resource: `${this.resource}/importar`,
            body: formData,
            headersExtra: new HttpHeaders().append('ContentType', 'multipart/form-data'),
            disableSpinner: false
        });
    }
    getStatus() {
        return this.httpClient.get({
            resource: `${this.resource}/status`,
            disableSpinner: true
        });
    }
    getImportacaoTopic() {
        return this.httpClient.get({
            resource: `${this.resource}/topic`,
            disableSpinner: true,
            responseType: 'text'
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

class ExtracaoImportacaoModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoModule, declarations: [ExtracaoImportacaoComponent,
            ExtracaoImportacaoDisplayComponent], imports: [ReactiveFormsModule,
            FormControlValidationMsgModule,
            PanelModule,
            FormLabelColumnModule,
            FloatButtonModule,
            DialogModule,
            EloDatatableModule,
            EloModalModule,
            PanelExpansiveModule,
            FileUploadModule], exports: [ExtracaoImportacaoComponent,
            ExtracaoImportacaoDisplayComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoModule, providers: [ExtracaoImportacaoService], imports: [ReactiveFormsModule,
            FormControlValidationMsgModule,
            PanelModule,
            FormLabelColumnModule,
            FloatButtonModule,
            DialogModule,
            EloDatatableModule,
            EloModalModule,
            PanelExpansiveModule,
            FileUploadModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExtracaoImportacaoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        ReactiveFormsModule,
                        FormControlValidationMsgModule,
                        PanelModule,
                        FormLabelColumnModule,
                        FloatButtonModule,
                        DialogModule,
                        EloDatatableModule,
                        EloModalModule,
                        PanelExpansiveModule,
                        FileUploadModule
                    ],
                    declarations: [
                        ExtracaoImportacaoComponent,
                        ExtracaoImportacaoDisplayComponent
                    ],
                    exports: [
                        ExtracaoImportacaoComponent,
                        ExtracaoImportacaoDisplayComponent
                    ],
                    providers: [ExtracaoImportacaoService]
                }]
        }] });

class Area {
    constructor(titulo, cssAdicionalTitulo, iconeTitulo, modulos, isUnico) {
        this.titulo = titulo;
        this.cssAdicionalTitulo = cssAdicionalTitulo;
        this.iconeTitulo = iconeTitulo;
        this.modulos = modulos;
        this.isUnico = isUnico;
    }
}

class ColumnDrilldown {
}

class Column {
}

/**
 * Created by douglas on 16/06/2016.
 */
class Page {
    constructor() {
        this.content = [];
    }
}

class Periodo {
    constructor(dataInicial, dataFinal) {
        this.dataInicial = dataInicial;
        this.dataFinal = dataFinal;
    }
    conflicts(periodo) {
        if (!periodo)
            return null;
        return DateUtils.isBeforeOrEquals(this.dataInicial, periodo.dataFinal)
            && DateUtils.isAfterOrEquals(this.dataFinal, periodo.dataInicial);
    }
}

class ExceptionHandlerComponent {
    constructor(exceptionHandler, authHttp, notification, baseHref) {
        this.exceptionHandler = exceptionHandler;
        this.authHttp = authHttp;
        this.notification = notification;
        this.baseHref = baseHref;
        this.errorFKtoNotification = false;
        this.http500 = 500;
        this.http401Unauthorized = 401;
        this.isHttpError = false;
        this.sameError = null;
        this.showReiniciarButton = false;
        this.showError = false;
        this.suggestion = false;
        this.existSuggestion = false;
        if (typeof (this.baseHref) === 'undefined' || this.baseHref === null) {
            this.baseHref = '/';
        }
        if (this.exceptionHandler instanceof GlobalExceptionHandlerService) {
            this.subscribe(this.exceptionHandler);
        }
    }
    subscribe(globalExceptionHandlerService) {
        this.subscription = globalExceptionHandlerService.observers.subscribe((error) => {
            this.moreInfo = false;
            this.handleException(error);
            if (this.validExistSuggestion(error)) {
                this.existSuggestion = true;
            }
            else {
                this.suggestion = false;
                this.existSuggestion = false;
            }
        });
    }
    onBack() {
        location.replace(this.baseHref);
    }
    onClose() {
        this.showError = false;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    onClickMoreInfo() {
        this.suggestion = false;
        this.moreInfo = !this.moreInfo;
    }
    onClickSuggestion() {
        this.suggestion = !this.suggestion;
        this.moreInfo = false;
    }
    handleException(error) {
        this.error = error;
        this.isHttpError = this.error instanceof HttpError;
        if (this.isHttpError && this.error.status === this.http401Unauthorized) {
            this.showError = false;
            console.debug('logoutAndGoToAuthForm by server exception');
            this.authHttp.logoutAndGoToAuthForm();
        }
        else if (this.isHttpError && this.errorFKtoNotification && this.isError500FK(this.error)) {
            this.showError = false;
            this.notification.error('Este registro não pode ser excluído', 'Existem outros registros que dependem dele.');
        }
        else {
            if (this.sameError && this.sameError.name === this.error.name && !this.isHttpError) {
                this.showReiniciarButton = true;
            }
            else {
                this.sameError = this.error;
            }
            this.showError = true;
        }
        if (this.showError) {
            //   document.getElementById('okButton').focus();
        }
    }
    validExistSuggestion(error) {
        let exist = false;
        if (error && error.violations) {
            error.violations.forEach(violation => {
                if (violation.suggestion) {
                    exist = true;
                }
            });
        }
        return exist;
    }
    isError500FK(error) {
        if (error && error.message === 'Este registro não pode ser excluído. Existem outros registros que dependem dele.'
            && this.error.status === this.http500) {
            return true;
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExceptionHandlerComponent, deps: [{ token: i0.ErrorHandler }, { token: AbstractAuthHttp }, { token: EloNotificationService }, { token: APP_BASE_HREF, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ExceptionHandlerComponent, selector: "exception-handler", inputs: { errorFKtoNotification: "errorFKtoNotification" }, ngImport: i0, template: "<article (keyup.esc)=\"onClose()\" *ngIf=\"showError\" class=\"dialoguebox negative open big indexException\">\n  <div id=\"exceptionMessageContainer\" class=\"message\" *ngIf=\"isHttpError\">\n    <h3 *ngIf=\"error.timestamp\" class=\"mb-xs\"> Data e Hora: {{error.timestamp | date: 'dd/MM/yyyy HH:mm:ss'}} </h3>\n    <p id=\"exceptionMessageParagraph\" *ngIf=\"!error.violations || error.violations.length <= 0\"\n      style=\"white-space: pre-line;\"> {{error.message}} </p>\n    <li id=\"exceptionMessageViolations\" *ngFor=\"let violation of error.violations\">\n      {{violation.field}} {{violation.message}}\n    </li>\n    <div>\n      <button class=\"more-message-opener mt-xs\" style=\"display : unset; margin-right: 5px;\" (click)=\"onClickMoreInfo()\">\n        Mais Detalhes\n      </button>\n      <button id=\"suggestionButton\" *ngIf=\"existSuggestion\" class=\"more-message-opener mt-xs\" style=\"display : unset;\"\n        (click)=\"onClickSuggestion()\">\n        Poss\u00EDvel Solu\u00E7\u00E3o\n      </button>\n    </div>\n    <div *ngIf=\"moreInfo\">\n      <p class=\"more-message\" style=\"display : block;\">\n        Status: {{error.status}} <br> Error: {{error.error}} <br> Exception: {{error.exception}}\n        <br> Path: {{error.path}} <br> Detail: {{error.detail}}\n      </p>\n    </div>\n    <div *ngIf=\"suggestion\">\n      <p class=\"more-message\" style=\"display : block;\">\n        <li *ngFor=\"let violation of error.violations\">\n          {{violation.suggestion}}\n        </li>\n      </p>\n    </div>\n  </div>\n\n  <div *ngIf=\"!isHttpError\" id=\"exceptionMessageContainer\" class=\"message\">\n    <div>\n      <p id=\"exceptionMessageParagraph\">\n        Desculpe, isso n\u00E3o est\u00E1 funcionando corretamente. Agora sabemos sobre esse erro e estamos trabalhando para\n        corrigi-lo.!\n      </p>\n      <div>\n        <button class=\"more-message-opener mt-xs\" style=\"display : unset; margin-right: 5px;\"\n          (click)=\"onClickMoreInfo()\">\n          Mais Detalhes\n        </button>\n      </div>\n      <div *ngIf=\"moreInfo\">\n        <p class=\"more-message\" style=\"display : block;\">\n          {{error}}\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <span id=\"reiniciarButton\" class=\"btn negative close-dialoguebox\" *ngIf=\"showReiniciarButton\" (click)=\"onBack()\">\n    Reiniciar </span>\n  <span id=\"okButton\" class=\"btn negative close-dialoguebox\" (click)=\"onClose()\"> Ok</span>\n</article>", styles: [".indexException{z-index:9999999}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExceptionHandlerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'exception-handler', template: "<article (keyup.esc)=\"onClose()\" *ngIf=\"showError\" class=\"dialoguebox negative open big indexException\">\n  <div id=\"exceptionMessageContainer\" class=\"message\" *ngIf=\"isHttpError\">\n    <h3 *ngIf=\"error.timestamp\" class=\"mb-xs\"> Data e Hora: {{error.timestamp | date: 'dd/MM/yyyy HH:mm:ss'}} </h3>\n    <p id=\"exceptionMessageParagraph\" *ngIf=\"!error.violations || error.violations.length <= 0\"\n      style=\"white-space: pre-line;\"> {{error.message}} </p>\n    <li id=\"exceptionMessageViolations\" *ngFor=\"let violation of error.violations\">\n      {{violation.field}} {{violation.message}}\n    </li>\n    <div>\n      <button class=\"more-message-opener mt-xs\" style=\"display : unset; margin-right: 5px;\" (click)=\"onClickMoreInfo()\">\n        Mais Detalhes\n      </button>\n      <button id=\"suggestionButton\" *ngIf=\"existSuggestion\" class=\"more-message-opener mt-xs\" style=\"display : unset;\"\n        (click)=\"onClickSuggestion()\">\n        Poss\u00EDvel Solu\u00E7\u00E3o\n      </button>\n    </div>\n    <div *ngIf=\"moreInfo\">\n      <p class=\"more-message\" style=\"display : block;\">\n        Status: {{error.status}} <br> Error: {{error.error}} <br> Exception: {{error.exception}}\n        <br> Path: {{error.path}} <br> Detail: {{error.detail}}\n      </p>\n    </div>\n    <div *ngIf=\"suggestion\">\n      <p class=\"more-message\" style=\"display : block;\">\n        <li *ngFor=\"let violation of error.violations\">\n          {{violation.suggestion}}\n        </li>\n      </p>\n    </div>\n  </div>\n\n  <div *ngIf=\"!isHttpError\" id=\"exceptionMessageContainer\" class=\"message\">\n    <div>\n      <p id=\"exceptionMessageParagraph\">\n        Desculpe, isso n\u00E3o est\u00E1 funcionando corretamente. Agora sabemos sobre esse erro e estamos trabalhando para\n        corrigi-lo.!\n      </p>\n      <div>\n        <button class=\"more-message-opener mt-xs\" style=\"display : unset; margin-right: 5px;\"\n          (click)=\"onClickMoreInfo()\">\n          Mais Detalhes\n        </button>\n      </div>\n      <div *ngIf=\"moreInfo\">\n        <p class=\"more-message\" style=\"display : block;\">\n          {{error}}\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <span id=\"reiniciarButton\" class=\"btn negative close-dialoguebox\" *ngIf=\"showReiniciarButton\" (click)=\"onBack()\">\n    Reiniciar </span>\n  <span id=\"okButton\" class=\"btn negative close-dialoguebox\" (click)=\"onClose()\"> Ok</span>\n</article>", styles: [".indexException{z-index:9999999}\n"] }]
        }], ctorParameters: () => [{ type: i0.ErrorHandler }, { type: AbstractAuthHttp }, { type: EloNotificationService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [APP_BASE_HREF]
                }] }], propDecorators: { errorFKtoNotification: [{
                type: Input
            }] } });

class ErrorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ErrorModule, declarations: [ExceptionHandlerComponent], imports: [CommonModule, PanelExpansiveModule, PanelModule], exports: [ExceptionHandlerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorModule, providers: [EloNotificationService], imports: [CommonModule, PanelExpansiveModule, PanelModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PanelExpansiveModule, PanelModule],
                    declarations: [ExceptionHandlerComponent],
                    exports: [ExceptionHandlerComponent],
                    providers: [EloNotificationService]
                }]
        }] });

class CanActivateKeyCloak {
    constructor(keycloakAuthHttp, _router) {
        this.keycloakAuthHttp = keycloakAuthHttp;
        this._router = _router;
    }
    getPath(route, path = '') {
        if (route.parent) {
            let pathThisRoute = route.routeConfig.path;
            if (route.params) {
                pathThisRoute = route.params.id === 'new' ? pathThisRoute.replace(':id', 'new') : pathThisRoute;
            }
            pathThisRoute = path ? pathThisRoute + '/' + path : pathThisRoute;
            return this.getPath(route.parent, pathThisRoute);
        }
        return path;
    }
    canActivate(route, state) {
        if (!this.keycloakAuthHttp.isLogged()) {
            return false;
        }
        return this.keycloakAuthHttp.hasPermissionByRoute(this.getPath(route))
            .pipe(tap(hasPermission => {
            if (!hasPermission) {
                this._router.navigate(['/forbidden']);
            }
            return hasPermission;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CanActivateKeyCloak, deps: [{ token: KeycloakAuthHttp }, { token: i1$4.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CanActivateKeyCloak }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CanActivateKeyCloak, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: KeycloakAuthHttp }, { type: i1$4.Router }] });

class ErrorViolation {
}

class AuthInterceptor {
    constructor(authParams) {
        this.authParams = authParams;
    }
    interceptRequest(httpParams) {
        return of(httpParams).pipe(map(params => {
            if (this.authParams.isLogged()) {
                HttpClientUtils.addToken(params, this.authParams.getToken());
            }
            return params;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthInterceptor, deps: [{ token: AuthParams }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthParams }] });

const CACHE_SIZE = 100;
class ETagInterceptor {
    constructor() {
        this.etagDataCache = new LRUCache(CACHE_SIZE);
        this.etagCache = new LRUCache(CACHE_SIZE);
    }
    interceptRequest(httpParams) {
        return of(httpParams).pipe(map(params => {
            const url = HttpClientUtils.buildUrlWithBase(params, '');
            const etag = this.etagCache.get(url);
            if (etag && params.requestMethod === 'GET') {
                params.headersExtra = params.headersExtra.append('If-None-Match', etag);
            }
            return params;
        }));
    }
    interceptResponse(httpParams, response) {
        return of(response).pipe(tap((response) => {
            if (response.status === 200 && response.headers) {
                const responseEtag = response.headers.get('Etag');
                const url = HttpClientUtils.buildUrlWithBase(httpParams, '');
                if (responseEtag) {
                    this.etagDataCache.set(url, response.clone({ body: deepCopy(response.body) }));
                    this.etagCache.set(url, responseEtag);
                }
            }
        }));
    }
    catchError(httpParams, error) {
        if (error.status === 304) {
            const url = HttpClientUtils.buildUrlWithBase(httpParams, '');
            const cachedResponse = this.etagDataCache.get(url);
            return of(cachedResponse.clone({ body: deepCopy(cachedResponse.body) }));
        }
        else {
            throw error;
        }
    }
    hasETagForUrl(url) {
        return !!this.etagCache.get(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ETagInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ETagInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ETagInterceptor, decorators: [{
            type: Injectable
        }] });

class HeaderParamsKeycloakInterceptor {
    constructor(keycloakService, urlResolver, httpClient) {
        this.keycloakService = keycloakService;
        this.urlResolver = urlResolver;
        this.httpClient = httpClient;
    }
    interceptRequest(httpParams) {
        if (this.keycloakService.isLogged()) {
            let usuarioInfo = this.keycloakService.getUsuarioInfo();
            if (usuarioInfo) {
                return of(httpParams).pipe(tap(() => this.loadUsuarioInfoToHttpParams(httpParams, usuarioInfo)));
            }
            else {
                return this.createHttpGetRequest().pipe(map(usuarioInfo => {
                    this.keycloakService.setUsuarioInfo(usuarioInfo);
                    this.loadUsuarioInfoToHttpParams(httpParams, usuarioInfo);
                    return httpParams;
                }));
            }
        }
        return of(httpParams);
    }
    loadUsuarioInfoToHttpParams(httpParams, usuarioInfo) {
        if (usuarioInfo.dataOperacao) {
            httpParams.headersExtra = httpParams.headersExtra.set('DATA_OPERACAO', usuarioInfo.dataOperacao.toString());
        }
        if (usuarioInfo.exercicioPadrao) {
            httpParams.headersExtra = httpParams.headersExtra.set('EXERCICIO', usuarioInfo.exercicioPadrao.toString());
        }
        if (usuarioInfo.mesPadrao) {
            httpParams.headersExtra = httpParams.headersExtra.set('COMPETENCIA', usuarioInfo.mesPadrao.toString());
        }
        let entidadeInfo = UsuarioInfoUtils.getEntidadePrincipal(usuarioInfo);
        if (entidadeInfo) {
            httpParams.headersExtra = httpParams.headersExtra.set('ENTIDADE', entidadeInfo.id && entidadeInfo.id.toString())
                .set('ENTIDADE_NOME', entidadeInfo.nome);
        }
    }
    createHttpGetRequest() {
        if (this.usuarioInfoGet) {
            return this.usuarioInfoGet;
        }
        let interceptParams = {
            resource: this.urlResolver.getUrlUserInfo(),
            headersExtra: new HttpHeaders()
        };
        HttpClientUtils.addToken(interceptParams, this.keycloakService.getToken());
        this.usuarioInfoGet = this.httpClient.get(HttpClientUtils.buildUrl(interceptParams, this.urlResolver), { headers: interceptParams.headersExtra }).pipe(shareReplay());
        return this.usuarioInfoGet;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderParamsKeycloakInterceptor, deps: [{ token: KeycloakAuthHttp }, { token: UrlResolver }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderParamsKeycloakInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderParamsKeycloakInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: KeycloakAuthHttp }, { type: UrlResolver }, { type: i1$1.HttpClient }] });

const ENDPOINT_USERINFO = '/api/app-info/usuario';
class HeaderParamsInterceptor {
    constructor(httpClient, urlResolver, authParams) {
        this.httpClient = httpClient;
        this.urlResolver = urlResolver;
        this.authParams = authParams;
    }
    interceptRequest(httpParams) {
        if (this.authParams.isLogged()) {
            if (this.authParams.hasUsuarioInfo()) {
                let usuarioInfo = this.authParams.getUsuarioInfo();
                return of(httpParams).pipe(map(params => {
                    this.loadUsuarioInfoToHttpParams(httpParams, usuarioInfo);
                    return params;
                }));
            }
            return this.createHttpGetRequest().pipe(map(usuarioInfo => {
                this.authParams.setUsuarioInfo(usuarioInfo);
                this.loadUsuarioInfoToHttpParams(httpParams, usuarioInfo);
                return httpParams;
            }));
        }
        return of(httpParams);
    }
    loadUsuarioInfoToHttpParams(httpParams, usuarioInfo) {
        if (usuarioInfo.exercicioPadrao) {
            httpParams.headersExtra = httpParams.headersExtra.set('EXERCICIO', usuarioInfo.exercicioPadrao.toString());
        }
        if (usuarioInfo.mesPadrao) {
            httpParams.headersExtra = httpParams.headersExtra.set('COMPETENCIA', usuarioInfo.mesPadrao.toString());
        }
        let entidadeInfo = UsuarioInfoUtils.getEntidadePrincipal(usuarioInfo);
        if (entidadeInfo) {
            httpParams.headersExtra = httpParams.headersExtra.set('ENTIDADE', entidadeInfo.id.toString());
            httpParams.headersExtra = httpParams.headersExtra.set('ENTIDADE_NOME', entidadeInfo.descricao);
        }
        let moduloInfo = UsuarioInfoUtils.getModuloPrincipal(usuarioInfo, this.authParams.getInitialModuloFromUrl());
        if (moduloInfo) {
            httpParams.headersExtra = httpParams.headersExtra.set('MODULO', moduloInfo.id);
        }
    }
    createHttpGetRequest() {
        let interceptParams = { resource: ENDPOINT_USERINFO, headersExtra: new HttpHeaders() };
        HttpClientUtils.addToken(interceptParams, this.authParams.getToken());
        return this.httpClient.get(HttpClientUtils.buildUrl(interceptParams, this.urlResolver), { headers: interceptParams.headersExtra }).pipe(shareReplay());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderParamsInterceptor, deps: [{ token: i1$1.HttpClient }, { token: UrlResolver }, { token: AuthParams }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderParamsInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderParamsInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: UrlResolver }, { type: AuthParams }] });

class RouterInterceptor {
    constructor(router) {
        this.router = router;
    }
    interceptRequest(httpParams) {
        return of(httpParams).pipe(map(params => {
            params.headersExtra = params.headersExtra.append('active_view', this.router.url);
            return params;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RouterInterceptor, deps: [{ token: i1$4.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RouterInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RouterInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$4.Router }] });

class SpinnerInterceptor {
    constructor(spinnerService) {
        this.spinnerService = spinnerService;
    }
    interceptRequest(httpParams) {
        return of(httpParams).pipe(tap(() => this.showSpinner(true, httpParams)));
    }
    finally(httpParams) {
        this.showSpinner(false, httpParams);
    }
    showSpinner(show, httpParams) {
        if (!httpParams.disableSpinner) {
            this.spinnerService.show.emit(show);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerInterceptor, deps: [{ token: SpinnerService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: SpinnerService }] });

class InterceptorsProviders {
    static providers() {
        return [
            AuthInterceptor,
            {
                provide: HttpClientInterceptorToken,
                useExisting: AuthInterceptor,
                multi: true
            },
            ...InterceptorsProviders.providersKeycloak()
        ];
    }
    static providersKeycloak() {
        return [
            SpinnerInterceptor,
            RouterInterceptor,
            ETagInterceptor,
            {
                provide: HttpClientInterceptorToken,
                useExisting: ETagInterceptor,
                multi: true
            },
            {
                provide: HttpClientInterceptorToken,
                useExisting: SpinnerInterceptor,
                multi: true
            },
            {
                provide: HttpClientInterceptorToken,
                useExisting: RouterInterceptor,
                multi: true
            }
        ];
    }
    static providersWithHeaderParams() {
        return [
            ...InterceptorsProviders.providers(),
            HeaderParamsInterceptor,
            {
                provide: HttpClientInterceptorToken,
                useExisting: HeaderParamsInterceptor,
                multi: true
            }
        ];
    }
}

const KeycloakToken = new InjectionToken('KeycloakToken');

class KeycloakInterceptor {
    constructor(_router, _keycloak) {
        this._router = _router;
        this._keycloak = _keycloak;
    }
    interceptRequest(httpParams) {
        return from(this._keycloak.refreshToken()).pipe(map(() => {
            if (this._keycloak.isLogged()) {
                HttpClientUtils.addToken(httpParams, this._keycloak.getToken());
            }
            return httpParams;
        }));
    }
    catchError(httpParams, error) {
        if (error && error.status === 403) {
            this._router.navigate(['/forbidden']);
            return of({});
        }
        else {
            throw error;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KeycloakInterceptor, deps: [{ token: i1$4.Router }, { token: KeycloakToken }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KeycloakInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KeycloakInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$4.Router }, { type: KeycloakAuthHttp, decorators: [{
                    type: Inject,
                    args: [KeycloakToken]
                }] }] });

class Role {
}

var NotificationSystemStatus;
(function (NotificationSystemStatus) {
    NotificationSystemStatus["STARTED"] = "STARTED";
    NotificationSystemStatus["COMPLETED"] = "COMPLETED";
    NotificationSystemStatus["FAILED"] = "FAILED";
    NotificationSystemStatus["PENDING"] = "PENDING";
    NotificationSystemStatus["CANCELLED"] = "CANCELLED";
})(NotificationSystemStatus || (NotificationSystemStatus = {}));

class JasperNotificationService {
    static { this.EXECUTION_URL = '/jasperserver/rest_v2/reportExecutions'; }
    static { this.SERVER_INFO = '/jasperserver/rest_v2/serverInfo'; }
    static { this.SEARCH_URL = '/jasperserver/rest_v2/resources'; }
    constructor(authResourcesConfig, httpClient, eloNotificationService, notificationSystemService) {
        this.authResourcesConfig = authResourcesConfig;
        this.httpClient = httpClient;
        this.eloNotificationService = eloNotificationService;
        this.notificationSystemService = notificationSystemService;
        this.reports = [];
        this.sessionActive = false;
        this.context = BaseHref.extract();
    }
    executeReport(request) {
        const headers = new HttpHeaders()
            .append('Content-Type', 'application/x-www-form-urlencoded')
            .append('Accept', 'application/xml');
        return this.httpClient.post('/jasperserver/rest_v2/login?j_username=jasperadmin&j_password=jasperadmin', null, { headers: headers, observe: 'response' }) // TODO INCLUDE LOGIN SSO
            .pipe(map(resp => {
            if (resp.url.includes('error')) {
                throw 'login error!';
            }
        }), mergeMap(() => this.buildRequestReport(request)
            .pipe(mergeMap((useTenantEntidade) => this.internalExecuteReport(request, useTenantEntidade, false)
            .pipe(map((resp) => `${JasperNotificationService.EXECUTION_URL}/${resp.requestId}/exports/${resp.exports[0].id}/outputResource`))))));
    }
    executeAsyncReport(reportName, request, callback) {
        iif(() => this.sessionActive, of(''), this.login()).pipe(switchMap(() => this.buildRequestReport(request)
            .pipe(mergeMap((useTenantEntidade) => this.internalExecuteReport(request, useTenantEntidade, true))))).subscribe((resp) => {
            this.addAsyncReport(resp, reportName, callback);
        });
    }
    getRequestReportOutputURL(requestID, exportID) {
        return `${JasperNotificationService.EXECUTION_URL}/${requestID}/exports/${exportID}/outputResource`;
    }
    requestReportOutput(requestID, exportID) {
        return this.httpClient.get(this.getRequestReportOutputURL(requestID, exportID), { observe: 'response', responseType: 'arraybuffer' });
    }
    clearReports() {
        this.reports = this.reports.filter(r => r.status === 'execution');
    }
    login() {
        const headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded')
            .append('Accept', 'application/json');
        return this.httpClient.post('/jasperserver/rest_v2/login?j_username=jasperadmin&j_password=jasperadmin', null, { headers: headers, observe: 'response' }) // TODO INCLUDE LOGIN SSO
            .pipe(map(resp => {
            if (resp.url.includes('error')) {
                this.sessionActive = false;
                throw 'login error!';
            }
            this.sessionActive = true;
            this.subscriptionInterval = interval(900000).pipe(switchMap(() => this.serveInfo())).subscribe();
        }));
    }
    polling(callback) {
        const validStatus = ['queued', 'execution'];
        this.subscriptionPolling = interval(1000)
            .pipe(takeWhile(() => this.reports.filter(r => validStatus.includes(r.status)).length > 0)).subscribe(() => this.reports.filter(r => r.status !== 'ready' && r.status !== 'failed').forEach(r => {
            this.httpClient.get(`${JasperNotificationService.EXECUTION_URL}/${r.requestId}`, { headers: new HttpHeaders({ 'Accept': 'application/json' }) })
                .subscribe((result) => {
                r.status = result && result.status && result.exports[0].status;
                if (r.status === 'ready') {
                    r.messageDetail = `Relatório emitido com sucesso`;
                    this.publishNotification(r, NotificationSystemStatus.COMPLETED, this.getRequestReportOutputURL(r.requestId, r.exports[0].id))
                        .subscribe(_ => {
                        let type = result.exports[0].outputResource.contentType;
                        if (type === 'application/pdf') {
                            let url = this.getRequestReportOutputURL(r.requestId, r.exports[0].id);
                            this.openNewTab(url);
                        }
                        else {
                            this.eloNotificationService.success(`${r.reportName} foi concluído`, 'Verifique as notificações.');
                        }
                    });
                    if (callback) {
                        callback();
                    }
                }
                if (r.status === 'failed') {
                    let errorMessage = { message: '' };
                    try {
                        errorMessage = JSON.parse(result.errorDescriptor.message);
                    }
                    catch {
                        errorMessage = { message: result.errorDescriptor.message };
                    }
                    r.messageDetail = errorMessage.message;
                    this.publishNotification(r, NotificationSystemStatus.FAILED)
                        .subscribe(_ => {
                        this.eloNotificationService.error(`${r.reportName}`, errorMessage.message);
                    });
                }
            }, () => {
                r.status = 'error';
                r.messageDetail = 'Não foi possível gerar, tente novamente.';
                this.publishNotification(r, NotificationSystemStatus.FAILED);
            });
        }));
    }
    getJasperRequestUriParamsFrom(request) {
        const indexLast = request.uri.lastIndexOf('/');
        return { folder: request.uri.substr(0, indexLast), file: request.uri.substr(indexLast + 1) };
    }
    buildRequestReport(request) {
        return this.searchRequestWithTenant(request)
            .pipe(mergeMap(tenant => this.searchRequestWithEntidade(request, tenant)
            .pipe(map(entidade => ({ entidade: entidade, tenant: tenant })))));
    }
    searchRequestWithTenant(request) {
        const jasperRequestUriParams = this.getJasperRequestUriParamsFrom(request);
        const tenant = UrlUtils.getTenant();
        return this.httpClient
            .get(`${JasperNotificationService.SEARCH_URL}?folderUri=${jasperRequestUriParams.folder}&q=${jasperRequestUriParams.file}.${tenant}`, { observe: 'response' })
            .pipe(map(resp => resp.status === 200));
    }
    searchRequestWithEntidade(request, useTenant) {
        const jasperRequestUriParams = this.getJasperRequestUriParamsFrom(request);
        const tenant = UrlUtils.getTenant();
        const entidade = this.context.entidade;
        return this.httpClient
            .get(`${JasperNotificationService.SEARCH_URL}?folderUri=${jasperRequestUriParams.folder}&q=${jasperRequestUriParams.file}.${useTenant ? `${tenant}.${entidade}` : entidade}`, { observe: 'response' })
            .pipe(map(resp => resp.status === 200));
    }
    internalExecuteReport(request, useTenantAndOrEntidade, async) {
        const headersExecute = new HttpHeaders().append('X-REMOTE-DOMAIN', '1');
        const tenant = UrlUtils.getTenant();
        const entidade = this.context.entidade;
        const reportUnitUri = useTenantAndOrEntidade.tenant ? `${request.uri}.${tenant}` : request.uri;
        return this.httpClient.post(JasperNotificationService.EXECUTION_URL, {
            reportUnitUri: useTenantAndOrEntidade.entidade ? `${reportUnitUri}.${entidade}` : reportUnitUri,
            outputFormat: request.format,
            async: async,
            parameters: {
                reportParameter: this.mountParams(request.params)
            }
        }, { headers: headersExecute });
    }
    serveInfo() {
        return this.httpClient.get(`${JasperNotificationService.SERVER_INFO}`);
    }
    addAsyncReport(response, reportName, callback) {
        let report = { ...response, reportName, reportDate: `${DateUtils.now()} às ${DateUtils.nowHour()}`, callback, messageDetail: `${reportName} está sendo gerado.` };
        this.publishNotification(report, NotificationSystemStatus.STARTED)
            .subscribe(notf => {
            report.messageId = notf.id;
            this.reports.push(report);
            this.polling(callback);
            this.eloNotificationService.info(`${reportName} está sendo gerado`, 'Verifique as notificações.');
        });
    }
    mountParams(params) {
        const overrideParams = [{ name: 'HOST_ORIGIN', value: location.hostname }];
        if (this.authResourcesConfig.isDev) {
            overrideParams.push({ name: 'EUREKA_HOST', value: location.protocol + '//' + this.authResourcesConfig.eurekaHost + ':8761' });
        }
        return [...params, ...overrideParams].map(p => ({ name: p.name, value: [p.value] }));
    }
    publishNotification(report, status, link = null) {
        return this.notificationSystemService.publishMessage({
            'id': report.messageId,
            'message': report.reportName,
            'messageDetail': report.messageDetail,
            'status': status,
            'link': link,
            'type': 'report',
            'modulo': 'OXY_CONTABILIDADE'
        });
    }
    openNewTab(url) {
        const options = { responseType: 'Blob' };
        return this.httpClient.get(url, options)
            .subscribe(res => {
            const fileUrl = URL.createObjectURL(res);
            window.open(fileUrl, '_blank');
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: JasperNotificationService, deps: [{ token: AUTH_RESOURCES_CONFIG }, { token: i1$1.HttpClient }, { token: EloNotificationService }, { token: NotificationSystemService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: JasperNotificationService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: JasperNotificationService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }, { type: i1$1.HttpClient }, { type: EloNotificationService }, { type: NotificationSystemService }] });

class CanActivateRoute {
}

/**
 * Created by pdi on 12/07/16.
 */
class CanActivateRouteService extends CanActivateRoute {
    constructor(authHttp, router) {
        super();
        this.authHttp = authHttp;
        this.router = router;
    }
    getPath(route, path = '') {
        if (route.parent) {
            let pathThisRoute = route.routeConfig.path;
            if (route.params) {
                pathThisRoute = route.params.id === 'new' ? pathThisRoute.replace(':id', 'new') : pathThisRoute;
            }
            pathThisRoute = path ? pathThisRoute + '/' + path : pathThisRoute;
            return this.getPath(route.parent, pathThisRoute);
        }
        return path;
    }
    canActivate(route, state) {
        if (this.authHttp.authParams.isLogged()) {
            return this.authHttp
                .getUsuarioLogado().pipe(map(usuario => {
                const path = this.getPath(route);
                const permissaoRota = permissions.find(p => p.route === path);
                if (permissaoRota && !usuario.recursos.includes(permissaoRota.recurso)) {
                    this.router.navigate(['/forbidden']);
                    return false;
                }
                return true;
            }));
        }
        else {
            console.debug('logoutAndGoToAuthForm by actived');
            this.authHttp.goToAuthFormIfExists(window.location.origin + state.url);
            return false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CanActivateRouteService, deps: [{ token: AuthHttp }, { token: i1$4.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CanActivateRouteService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CanActivateRouteService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthHttp }, { type: i1$4.Router }] });

class RouteUtils {
    static createCrudRoutes(route, crudSearchClass, crudFormClass, canActivateServices = [CanActivateRoute]) {
        const routes = [
            { path: route, component: crudSearchClass, canActivate: canActivateServices },
            {
                path: route + '/:id', component: crudFormClass, canDeactivate: [CanDeactivateGuard],
                canActivate: canActivateServices
            }
        ];
        return RouterModule.forChild(routes);
    }
    /**
     * @deprecated Voce tambpem pode utilizar o metodo createCrudViewLazyRoutes() em vez disso.
     */
    static createCrudLazyRoutes(crudSearchClass, crudFormClass, canActivateServices = [CanActivateRoute]) {
        return [
            { path: '', component: crudSearchClass, canActivate: canActivateServices },
            {
                path: ':id', component: crudFormClass, canDeactivate: [CanDeactivateGuard],
                canActivate: canActivateServices
            }
        ];
    }
    static createCrudViewLazyRoutes(crudSearchClass, crudFormClass, crudViewClass, canActivateServices = [CanActivateRoute]) {
        return RouterModule.forChild([
            {
                path: '',
                component: crudSearchClass,
                canActivate: canActivateServices
            },
            {
                path: 'new',
                component: crudFormClass,
                canActivate: canActivateServices
            },
            {
                path: ':id',
                component: crudFormClass,
                canActivate: canActivateServices,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: ':id/view',
                component: crudViewClass,
                canActivate: canActivateServices
            },
        ]);
    }
    static addRoute(route, component, canActivateServices = [CanActivateRoute]) {
        const routes = [{ path: route, component: component, canActivate: canActivateServices }];
        return RouterModule.forChild(routes);
    }
}

class AcessibilityService {
    constructor() {
        this.subjectOnInverterCores = new Subject();
        this.onInverterCores = this.subjectOnInverterCores.asObservable();
        this.invert = '';
    }
    inverterCores() {
        if (this.invert === 'invert') {
            this.invert = '';
        }
        else {
            this.invert = 'invert';
        }
        this.subjectOnInverterCores.next(this.invert);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AcessibilityService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AcessibilityService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AcessibilityService, decorators: [{
            type: Injectable
        }] });

class AgendamentoService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.resource = '/api/agendamentos';
        this.location = '/agendamento-api';
    }
    createSchedule(agendamento) {
        return this.httpClient.post({
            resource: `${this.resource}/create-schedule`,
            body: agendamento,
            location: this.location
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AgendamentoService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AgendamentoService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AgendamentoService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

class AppService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.resource = '/api/app';
    }
    getApiVersion() {
        return this.httpClient.get({
            resource: `${this.resource}/api-version`,
        });
    }
    getClientVersion() {
        return this.httpClient.get({ resource: 'app/version', requestOrigin: true });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppService, deps: [{ token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }] });

class BaseUrlService {
    constructor(authResourcesConfig) {
        this.authResourcesConfig = authResourcesConfig;
    }
    getBaseUrl() {
        return this.isDev() ? this.dev() : this.origin();
    }
    isDev() {
        return this.authResourcesConfig.isDev;
    }
    origin() {
        return window.location.origin;
    }
    dev() {
        return this.authResourcesConfig.hostDev;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BaseUrlService, deps: [{ token: AUTH_RESOURCES_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BaseUrlService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BaseUrlService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_RESOURCES_CONFIG]
                }] }] });

class BodyZoomService {
    constructor(document) {
        this.document = document;
        this.zoomAtual = 100 /* Zoom.NORMAL */;
        this.scaleAtual = 1 /* Scale.NORMAL */;
        this.body = this.document.body;
    }
    normal() {
        this.zoomAtual = 100 /* Zoom.NORMAL */;
        this.body.style['zoom'] = this.zoomAtual + '%';
        this.normalMozila();
    }
    aumentaTamanho() {
        this.aumentaZoom();
        this.aumentaScale();
    }
    diminuiTamanho() {
        this.diminuiZoom();
        this.diminuiScale();
    }
    normalMozila() {
        this.scaleAtual = 1 /* Scale.NORMAL */;
        this.defineMozilaScale();
    }
    aumentaZoom() {
        this.body.style['zoom'] = this.incrementaZoom() + '%';
    }
    incrementaZoom() {
        if (this.zoomAtual <= 110 /* Zoom.MAX */) {
            this.zoomAtual = this.zoomAtual + 5 /* Zoom.INCREMENTO */;
        }
        return this.zoomAtual;
    }
    aumentaScale() {
        this.incrementaScale();
        this.defineMozilaScale();
    }
    incrementaScale() {
        if (this.scaleAtual <= 1.15 /* Scale.MAX */) {
            this.scaleAtual = this.scaleAtual + 0.03 /* Scale.INCREMENTO */;
        }
    }
    diminuiZoom() {
        this.body.style['zoom'] = this.decrementaZoom() + '%';
    }
    decrementaZoom() {
        if (this.zoomAtual >= 86 /* Zoom.MIN */) {
            this.zoomAtual = this.zoomAtual - 5 /* Zoom.DECREMENTO */;
        }
        return this.zoomAtual;
    }
    diminuiScale() {
        this.decrementaScale();
        this.defineMozilaScale();
    }
    decrementaScale() {
        if (this.scaleAtual >= 0.8 /* Scale.MIN */) {
            this.scaleAtual = this.scaleAtual - 0.03 /* Scale.DECREMENTO */;
        }
    }
    // Tudo que tem o prefixo  -moz só funciona no mozila, logo já existe um if (mozila).
    defineMozilaScale() {
        this.body.style['-moz-transform'] = 'scale(' + this.scaleAtual + ')';
        this.body.style['-moz-transform-origin'] = 'top center';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BodyZoomService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BodyZoomService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BodyZoomService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

class EntidadeService extends EntityService {
    constructor(httpClient, urlResolver) {
        super(httpClient);
        this.httpClient = httpClient;
        this.urlResolver = urlResolver;
        this.resource = '/api/entidades';
    }
    getEntidadePrincipal(includeBrasao) {
        const fields = ['nome', 'cidade.descricao', 'cidade.uf.sigla', 'cidade.unidadeFederacao.sigla'];
        if (includeBrasao) {
            fields.push('brasao');
        }
        return this.httpClient.get({
            resource: `${this.resource}/principal/entidade`,
            fields: fields.toString()
        });
    }
    getCidade() {
        return this.httpClient.get({ resource: `${this.resource}/principal/entidade`, fields: ['cidade.descricao', 'cidade.uf.sigla'].toString() });
    }
    getUrlBrasao() {
        return `${this.urlResolver.getUrlResolved()}${this.resource}/principal/brasao`;
    }
    findUserInfo() {
        return this.httpClient.get({
            resource: `/api/entidades/userInfo`,
            disableSpinner: true
        });
    }
    getNomeEntidade() {
        return this.httpClient.get({ resource: `${this.resource}/principal/entidade`, fields: 'nome' });
    }
    findToOptions(searchValue) {
        return this.findToAutoComplete(this.getSearch(searchValue)).pipe(map(page => page.content));
    }
    objToOption(entidade) {
        return `${entidade.id} - ${entidade.nome}`;
    }
    getSearch(searchValue) {
        return `nome == "*${searchValue}*"` + `${NumberUtils.isNumeric(searchValue) ? ',id==' + NumberUtils.onlyNumbers(searchValue) : ''}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntidadeService, deps: [{ token: HttpClient }, { token: UrlResolver }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntidadeService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EntidadeService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpClient }, { type: UrlResolver }] });

class TestingUtils {
    static dispatchEvent(element, eventType) {
        element.dispatchEvent(new Event(eventType));
    }
}

var EntidadeTipo;
(function (EntidadeTipo) {
    EntidadeTipo["EXECUTIVO"] = "E";
    EntidadeTipo["LEGISLATIVO"] = "L";
    EntidadeTipo["ADMINISTRACAO_INDIRETA"] = "A";
    EntidadeTipo["RPPS"] = "R";
    EntidadeTipo["ADMINISTRACAO_DIRETA"] = "D";
    EntidadeTipo["CONSORCIO"] = "C";
})(EntidadeTipo || (EntidadeTipo = {}));

// @dynamic
class ArrayUtil {
    /**
     *  Remove objetos duplicados, olhando apenas para um único atributo do objeto.
     *
     * @param myArr array de objetos
     * @param prop propriedade do objeto
     */
    static removeDuplicates(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
            return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
        });
    }
    /**
     * Compara dois arrays e retorna se os mesmos possuem elementos distintos.
     *
     * @param currentArray array base da comparação
     * @param comparisonArray array de comparação
     */
    static diffArrays(currentArray, comparisonArray) {
        return currentArray.some(e => !comparisonArray.includes(e));
    }
    /**
     * Agrupa o array pelo atributo determinado do array
     *
     * @example
     *  [
     *    {nome: "dummy1", cidade: "Maringá" },
     *    {nome: "Elton", cidade: "Floresta"},
     *    {nome: "dummy2", cidade: "Maringá"}
     *  ]
     *
     *  Group by cidade
     *
     *  [
     *    [{nome: "dummy1", cidade: "Maringá" }, {nome: "dummy2", cidade: "Maringá"}],
     *    [{nome: "Elton", cidade: "Floresta"}]
     *  ]
     *
     *  @param array array antes do agrupamento
     *  @param f funcao que retorna o atributo que sera agrupado (function(dummy) { return [dummy.cidade]} )
     */
    static groupBy(array, f) {
        let groups = {};
        array.forEach((object) => {
            let group = JSON.stringify(f(object));
            groups[group] = groups[group] || [];
            groups[group].push(object);
        });
        return Object.keys(groups).map((group) => {
            return groups[group];
        });
    }
    /**
     * Verifica se existe duplicados no array
     *
     * @param currentArray array da verificação
     */
    static existsDuplicates(currentArray) {
        return (new Set(currentArray)).size !== currentArray.length;
    }
}

class Desktop {
    static isDesktop() {
        return innerWidth >= 992 /* Resolucao.RESOLUCAO_DESKTOP */;
    }
}

// @dynamic
class FocusUtil {
    static { this.focus = (id) => {
        setTimeout(() => {
            const input = document.querySelector(`#${id}`);
            if (input) {
                input.focus();
            }
        }, 0);
    }; }
    static { this.focusWithIndex = (index, id) => {
        setTimeout(() => {
            const input = document.querySelector(`#${id}_${index}`);
            if (input) {
                input.focus();
            }
        }, 0);
    }; }
    static { this.focusWithIndexAndSelectTextInput = (controlName, id, index) => {
        setTimeout(() => {
            const input = document.querySelector(`#${controlName}_${id}_${index}`);
            if (input) {
                input.select();
            }
        }, 0);
    }; }
}

class ObjectParseService {
    /**
     * Encodes a text string as a valid component of a Uniform Resource Identifier (URI)
     */
    encodeData(data) {
        if (!data) {
            return '';
        }
        return Object.keys(data).map((key) => {
            return [key, data[key]].map(encodeURIComponent).join('=');
        }).join('&');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ObjectParseService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ObjectParseService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ObjectParseService, decorators: [{
            type: Injectable
        }] });

/**
 * Check and return true if an object is type of string
 */
function isString(obj) {
    return typeof obj === 'string';
}
/**
 * Check and return true if an object is type of number
 */
function isNumber(obj) {
    return typeof obj === 'number';
}
/**
 * Check and return true if an object is type of Function
 */
function isFunction(obj) {
    return typeof obj === 'function';
}

class AssertUtils {
    static assert(value, description) {
        if (!value) {
            throw new Error('Assert fails ' + description);
        }
    }
    static config(fixture) {
        AssertUtils.assert(fixture, 'Fixture is null. Use method AssertUtils.config(fixture) with a fixture instance.');
        return new AssertUtils(fixture);
    }
    constructor(fixture) {
        this.fixture = fixture;
    }
    assertRender(component) {
        AssertUtils.assert(this.fixture.debugElement.query(By.css(component)), `${component} not found`);
        return this;
    }
    assertNotRender(component) {
        AssertUtils.assert(!this.fixture.debugElement.query(By.css(component)), `${component} found`);
        return this;
    }
    /**
     * Usar esta função para testar componentes HTML input. Tipos suportados: select, checkbox e text.
     * @param inputId - Id do input a ser testado
     * @param predicate - consulta a ser passada à fixture.debugElement.query (geralmente o retorno de `By.css`)
     * @param expected - valor experado no input
     * @returns
     */
    assertInputByCss(inputId, predicate, expected) {
        const inputElement = this.fixture.debugElement.query(predicate);
        AssertUtils.assert(inputElement, `${inputId} not found`);
        let element = inputElement.nativeElement;
        if (element.type === 'select') {
            AssertUtils.assert(inputElement.componentInstance.value === expected, inputId);
        }
        else if (element.type === 'checkbox') {
            AssertUtils.assert(element.checked === expected, inputId);
        }
        else {
            AssertUtils.assert(element.value === expected, inputId);
        }
        return this;
    }
    /**
     * Usar esta função para testar componentes HTML input. Tipos suportados: select, checkbox e text.
     * Caso haja mais de um componente com o mesmo id na mesma fixture (por exemplo, um mesmo componente
     * renderizado mais de uma vez), utilize a função `assertInputByCss`
     * @param inputId - Id do input a ser testado
     * @param expected - valor experado no input
     * @returns
     */
    assertInput(inputId, expected) {
        return this.assertInputByCss(inputId, By.css(`#${inputId}`), expected);
    }
    /**
     * Usar esta função para testar se componentes HTML input está desabilitado.
     * @param inputId
     * @returns
     */
    assertInputDisabled(inputId, failedMessage = 'should be disabled') {
        const inputElement = this.fixture.debugElement.query(By.css(`#${inputId}`));
        AssertUtils.assert(inputElement, `Input with id #${inputId} not found`);
        AssertUtils.assert(inputElement.nativeElement.disabled, `${inputId} ${failedMessage}`);
        return this;
    }
    /**
     * Usar esta função para testar se componentes HTML input está habilitado.
     * @param inputId
     * @returns
     */
    assertInputEnabled(inputId) {
        const inputElement = this.fixture.debugElement.query(By.css(`#${inputId}`));
        AssertUtils.assert(inputElement, 'inputElement');
        AssertUtils.assert(!inputElement.nativeElement.disabled, `${inputId} should be enabled`);
        return this;
    }
    /**
   * Usar esta função para testar o componente HTML select;
   * @param selectId
   * @param expectedIndex
   * @returns
   */
    assertHtmlSelect(selectId, expectedIndex) {
        const selectElement = this.fixture.debugElement.query(By.css(`#${selectId}`)).nativeElement;
        AssertUtils.assert(selectElement, `${selectId} not found`);
        AssertUtils.assert(selectElement.selectedIndex === expectedIndex, selectId);
        return this;
    }
    /**
     * Usar esta função para testar o componente elo-select;
     * @param selectId
     * @param expectedIndex
     * @returns
     */
    assertSelect(selectId, expectedIndex) {
        const selectElement = this.fixture.debugElement.query(By.css(`#${selectId}`));
        AssertUtils.assert(selectElement, `${selectId} not found`);
        AssertUtils.assert(selectElement.componentInstance.value === expectedIndex, selectId);
        return this;
    }
    /**
     * Usar esta função para testar o componente elo-autocomplete.
     * @param inputId
     * @param expected
     * @returns
     */
    assertComplete(inputId, expected) {
        return this.assertInput(`${inputId}_input`, expected);
    }
    /**
     * Usar esta função para testar o componente elo-switch.
     * @param switchId
     * @param expected
     * @returns
     */
    assertSwitch(switchId, expected) {
        const eloSwitch = this.fixture.debugElement.query(By.css(`#${switchId}`));
        AssertUtils.assert(eloSwitch, `${switchId} not found`);
        AssertUtils.assert(eloSwitch.componentInstance.active === expected, 'active');
        return this;
    }
}

const bimestreNames = ['1° bimestre', '2° bimestre', '3° bimestre', '4° bimestre', '5° bimestre', '6° bimestre'];
class BimestreUtils {
    static getBimestreName(bimestre) {
        return bimestreNames[bimestre - 1];
    }
    static getBimestres() {
        return bimestreNames;
    }
    static getMesInicial(bimestre) {
        return bimestre * 2 - 1;
    }
    static getMesFinal(bimestre) {
        return bimestre * 2;
    }
}

const quadrimestreNames = ['1° quadrimestre', '2° quadrimestre', '3° quadrimestre'];
class QuadrimestreUtils {
    static getQuadrimestreName(quadrimestre) {
        return quadrimestreNames[quadrimestre - 1];
    }
    static getQuadrimestres() {
        return quadrimestreNames;
    }
    static getMesInicial(quadrimestre) {
        return quadrimestre * 4 - 3;
    }
    static getMesFinal(quadrimestre) {
        return quadrimestre * 4;
    }
}

class RateioUtils {
    static doRateio(valor, vezes) {
        let rateio = [];
        let soma = 0;
        let parcela = NumberUtils.round(valor / vezes);
        for (let i = 0; i < (vezes - 1); i++) {
            rateio.push(parcela);
            soma += parcela;
        }
        let lastValue = NumberUtils.round(valor - soma);
        rateio.push(lastValue);
        return rateio;
    }
}

class RsqlBuilder {
    constructor() {
        this.rsql = 'search=';
    }
    static create() {
        return new RsqlBuilder();
    }
    and() {
        if (!this.terminaCom(' and ') && this.rsql !== 'search=') {
            this.rsql += ' and ';
        }
        return this;
    }
    or() {
        if (!this.terminaCom(' or ') && this.rsql !== 'search=') {
            this.rsql += ' or ';
        }
        return this;
    }
    equal(column, filter) {
        this.addExpression(`${column} == ${filter}`, filter);
        return this;
    }
    equalString(column, filter) {
        this.addExpression(`${column} == '${filter}'`, filter);
        return this;
    }
    diff(column, filter) {
        this.addExpression(`${column} != ${filter}`, filter);
        return this;
    }
    diffString(column, filter) {
        this.addExpression(`${column} != '${filter}'`, filter);
        return this;
    }
    greaterThanEqual(column, filter) {
        this.addExpression(`${column} >= '${filter}'`, filter);
        return this;
    }
    lowerThanEqual(column, filter) {
        this.addExpression(`${column} <= '${filter}'`, filter);
        return this;
    }
    like(column, filter) {
        this.addExpression(`${column} == '*${filter}*'`, filter);
        return this;
    }
    build() {
        this.removeTerminadoCom(' and ');
        this.removeTerminadoCom(' or ');
        if (this.rsql === 'search=') {
            return '';
        }
        return this.rsql;
    }
    addExpression(expression, value) {
        if (value) {
            this.rsql += expression;
        }
        else {
            this.removeTerminadoCom(' and ');
            this.removeTerminadoCom(' or ');
        }
    }
    terminaCom(value) {
        return this.rsql.substr(this.rsql.length - value.length, this.rsql.length - 1) === value;
    }
    removeTerminadoCom(value) {
        if (this.terminaCom(value)) {
            this.rsql = this.rsql.slice(0, this.rsql.length - value.length);
        }
    }
}

const semestreNames = ['1° semestre', '2° semestre'];
class SemestreUtils {
    static getSemestreName(semestre) {
        return semestreNames[semestre - 1];
    }
    static getSemestres() {
        return semestreNames;
    }
    static getMesInicial(semestre) {
        return semestre * 6 - 5;
    }
    static getMesFinal(semestre) {
        return semestre * 6;
    }
}

// @dynamic
class SortUtils {
    static sortNumberAsc(fieldPath) {
        return (a, b) => {
            const valueFromA = this.getValueFromFieldPath(a, fieldPath);
            const valueFromB = this.getValueFromFieldPath(b, fieldPath);
            if (valueFromA > valueFromB) {
                return 1;
            }
            else if (valueFromA < valueFromB) {
                return -1;
            }
            return 0;
        };
    }
    static sortNumberDesc(fieldPath) {
        return (a, b) => {
            const valueFromA = this.getValueFromFieldPath(a, fieldPath);
            const valueFromB = this.getValueFromFieldPath(b, fieldPath);
            if (valueFromB > valueFromA) {
                return 1;
            }
            else if (valueFromB < valueFromA) {
                return -1;
            }
            return 0;
        };
    }
    static sortStringAsc(fieldPath) {
        return (a, b) => {
            const valueFromA = this.getValueFromFieldPath(a, fieldPath);
            const valueFromB = this.getValueFromFieldPath(b, fieldPath);
            return (valueFromA ? valueFromA.toString() : '').localeCompare(valueFromB ? valueFromB.toString() : '');
        };
    }
    static sortStringDesc(fieldPath) {
        return (a, b) => {
            const valueFromA = this.getValueFromFieldPath(a, fieldPath);
            const valueFromB = this.getValueFromFieldPath(b, fieldPath);
            return (valueFromB ? valueFromB.toString() : '').localeCompare(valueFromA ? valueFromA.toString() : '');
        };
    }
    static getValueFromFieldPath(obj, fieldPath) {
        let value = obj;
        fieldPath.split('.').forEach(fieldPart => {
            if (!value) {
                return;
            }
            value = value[fieldPart];
        });
        return value;
    }
}

function createAuthResource() {
    return Object.assign(AUTH_RESOURCES_CONFIG_UNICO);
}
function createHttpClientMock() {
    const httpMock = {
        get: () => of([]),
        post: () => of({}),
        patch: () => of({}),
        del: () => of({})
    };
    return httpMock;
}
function createAuthHttpMock() {
    const authHttpMock = { getPermissionsByRole: () => of(['DELETE', 'UPDATE', 'CREATE', 'READ']) };
    return authHttpMock;
}
function createRouterMock() {
    return {};
}
class CrudFormTestingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormTestingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CrudFormTestingModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormTestingModule, providers: [RouterService,
            { provide: Location, useClass: SpyLocation },
            { provide: ActivatedRoute, useValue: { snapshot: { params: { id: 'new' } } } },
            { provide: HttpClient, useFactory: createHttpClientMock },
            { provide: Router, useFactory: createRouterMock },
            { provide: AbstractAuthHttp, useFactory: createAuthHttpMock },
            {
                provide: AUTH_RESOURCES_CONFIG,
                useFactory: createAuthResource
            },
            { provide: EloNotificationService, useValue: new EloNotificationService() }
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CrudFormTestingModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [RouterService,
                        { provide: Location, useClass: SpyLocation },
                        { provide: ActivatedRoute, useValue: { snapshot: { params: { id: 'new' } } } },
                        { provide: HttpClient, useFactory: createHttpClientMock },
                        { provide: Router, useFactory: createRouterMock },
                        { provide: AbstractAuthHttp, useFactory: createAuthHttpMock },
                        {
                            provide: AUTH_RESOURCES_CONFIG,
                            useFactory: createAuthResource
                        },
                        { provide: EloNotificationService, useValue: new EloNotificationService() }
                    ]
                }]
        }] });

class TestUtils {
    static { this.resetTestingModule = TestBed.resetTestingModule; }
    static configure(module, crudForm, options = {}) {
        TestBed.configureTestingModule({
            imports: [module, CrudFormTestingModule],
            declarations: options.declarations,
            providers: options.providers,
            teardown: { destroyAfterEach: false }
        });
        return TestBed.compileComponents().then(() => {
            let fixture = TestBed.createComponent(crudForm);
            fixture.detectChanges();
            return fixture;
        });
    }
    static configureOnce(module, options = {}) {
        TestBed.resetTestingModule();
        const modulesDefault = [module, CrudFormTestingModule];
        TestBed.configureTestingModule({
            imports: options.modules ? [...options.modules, ...modulesDefault] : modulesDefault,
            declarations: options.declarations,
            providers: options.providers,
            teardown: { destroyAfterEach: false }
        });
        TestBed.resetTestingModule = () => TestBed;
        return TestBed.compileComponents();
    }
    static teardown() {
        TestBed.resetTestingModule = TestUtils.resetTestingModule;
        TestBed.resetTestingModule();
    }
}

const trimestreNames = ['1° trimestre', '2° trimestre', '3° trimestre', '4° trimestre'];
class TrimestreUtils {
    static getTrimestreName(trimestre) {
        return trimestreNames[trimestre - 1];
    }
    static getTrimestres() {
        return trimestreNames;
    }
    static getMesInicial(trimestre) {
        return trimestre * 3 - 2;
    }
    static getMesFinal(trimestre) {
        return trimestre * 3;
    }
}

// Public API Surface of common

/**
 * Generated bundle index. Do not edit.
 */

export { APPLICATION_JSON_PATCH, AREAS, AUTH_RESOURCES_CONFIG, AUTH_RESOURCES_CONFIG_ISS, AUTH_RESOURCES_CONFIG_PORTAL_SERVICOS, AUTH_RESOURCES_CONFIG_UNICO, AbstractAuthHttp, AccordionComponent, AccordionItemComponent, AccordionModule, AcessibilityService, AgendamentoService, AppConfigService, AppService, Area, ArquivoComponent, ArquivoModule, ArrayUtil, ArvoreAvancadaChildrenSummaryComponent, ArvoreAvancadaComponent, ArvoreAvancadaModule, ArvoreAvancadaNodeComponent, ArvoreAvancadaNodeFormComponent, ArvoreAvancadaNodeHeaderComponent, AssertUtils, AssertUtilsApp, AssinaturaSelectorComponent, AssinaturaSelectorModule, AuthHttp, AuthInterceptor, AuthParams, AuthenticationComponent, AuthenticationModule, AutoCompleteComponent, AutoCompleteModule, AutofocusDirective, BackConfirmComponent, BackConfirmModule, BaseHref, BaseUrlService, BimestreUtils, BlobPopupComponent, BlobPopupExecutorFactory, BlobPopupModule, BlobPopupService, BlockContentComponent, BlockContentModule, BodyZoomService, BooleanTextPipe, BreadcrumbComponent, BreadcrumbIframeService, BreadcrumbModule, ButtonLogComponent, ButtonLogModule, ButtonSelectOneComponent, ButtonSelectOneModule, CONTAINED_IN_CAPTION, CONTAINED_IN_OPERATION, CONTAINS_CAPTION, CONTAINS_OPERATION, CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR, CURRENCY_MASK_CONFIG, CadastroUnicoComponent, CadastroUnicoModule, CalendarColor, CalendarComponent, CalendarDate, CalendarModule, CampoTipoEnum, CamposDinamicosComponent, CamposDinamicosModule, CamposDinamicosRespostasComponent, CamposDinamicosViewComponent, CanActivateKeyCloak, CanActivateRoute, CanActivateRouteService, CanDeactivateGuard, CapitalizePipe, CepDirective, CepPipe, ChipComponent, ChipModule, ClipboardDirective, CnpjCpfDirective, CnpjCpfPipe, CnpjDirective, Column, ColumnDrilldown, Competencia, CompetenciaDirective, CompetenciaUtils, ConfiguracaoEntidade, ConfiguracaoEntidadeKeycloakComponent, ConfiguracaoEntidadeKeycloakService, ConfiguracaoEntidadeObservable, ConsultaDinamicaComponent, ConsultaDinamicaModule, CountdownPipe, CpfDirective, CrudButtonsComponent, CrudButtonsModule, CrudButtonsOperationsComponent, CrudButtonsOperationsModule, CrudDetailInlineComponent, CrudDetailInlineModule, CrudFormComponent, CrudFormDetailComponent, CrudFormDetailModule, CrudFormModule, CrudFormSimpleChildPaginatedComponent, CrudFormSimpleChildPaginatedModule, CrudOnePageEditableComponent, CrudOnePageEditableModule, CrudSearchComponent, CrudSearchLogComponent, CrudSearchLogModule, CrudSearchModule, CrudTreeComponent, CrudTreeModule, CurrencyFormatPipe, CurrencyMaskDirective, DATEHOURMODELFORMAT, DATEHOURVIEWFORMAT, DATEMODELFORMAT, DATEVIEWFORMAT, DAYS_EXPIRES_REMEMBER, DIA_1, DIA_30, DOMINGO, DROPDOWN_VALUE_ACCESSOR, DateFormatPipe, DateHourFormatPipe, DatePickerComponent, DatePickerModule, DateUtils, DecimalFormatPipe, Desktop, DetailInformationComponent, DetailInformationModule, DeviceUtils, DialogComponent, DialogModule, DiasFormatPipe, DiasPorExtensoPipe, DirectivesModule, DisableControlDirective, DomHandlerService, DoubleClickCopyDirective, ELOTECH_DOMAIN, EMPTY_MESSAGE, ENDS_WITH_CAPTION, ENDS_WITH_OPERATION, EQUAL_OPERATION, ETagInterceptor, EloCheckboxComponent, EloCheckboxModule, EloColumnComponent, EloDataTableRowComponent, EloDatatableComponent, EloDatatableModule, EloDecimalDirective, EloFilterComponent, EloFilterModule, EloHeaderActionsComponent, EloModalComponent, EloModalModule, EloNotificationComponent, EloNotificationService, EloNotificationsModule, EloNumberDirective, EloQueryBuilderModule, EloQuickAccessButtonComponent, EloQuickAccessButtonModule, EloQuickAccessComponent, EloQuickAccessModule, EloRadioButtonComponent, EloRadioButtonModule, EloSelectComponent, EloSelectModule, EloSimpleFilterComponent, EloTableAction, EloTableActionLinkComponent, EloTableActionType, EloTableActionsComponent, EloTableDrilldownComponent, EloTableDrilldownModule, EloTableSubtitleComponent, EloTimelineHorizontalComponent, EloTimelineHorizontalModule, EloTreeActionsComponent, EloTreeComponent, EloTreeModule, EloValidators, EntidadeSelectorComponent, EntidadeSelectorModule, EntidadeService, EntidadeTipo, EntityLogService, EntityService, EnumService, EnviarEmailComponent, EnviarEmailModule, ErrorModule, ErrorViolation, ExceptionHandlerComponent, ExtracaoImportacaoComponent, ExtracaoImportacaoDisplayComponent, ExtracaoImportacaoModule, ExtracaoImportacaoService, FROM_FORMAT, FancySlideComponent, FancySlideItemComponent, FancySlideModule, FeatureAcessibilidadeComponent, FeatureAcessibilidadeContrasteComponent, FeatureConfiguracaoEntidadeComponent, FeatureContribuinteComponent, FeatureModuleStateService, FeatureModulesComponent, FeatureNotificationComponent, FeatureNotificationMessageComponent, FeatureSobreSistemaComponent, FeatureUserComponent, FeaturesGroupComponent, FeaturesGroupModule, FileUploadComponent, FileUploadModule, FilterPipe, FloatButtonComponent, FloatButtonModule, FloatSideBarComponent, FloatSideBarModule, FloatSidebarService, FocusRemoverDirective, FocusUtil, FooterService, FormControlValidationMsgDirective, FormControlValidationMsgModule, FormLabelColumnComponent, FormLabelColumnModule, FormUtils, GREATER_OPERATION, GREATER_OR_EQUAL_OPERATION, GROUP_ADMIN, GlobalExceptionHandlerService, HTTP_ERROR_LIST, HeaderComponent, HeaderModule, HeaderParamsInterceptor, HeaderParamsKeycloakInterceptor, HeaderTitle, HoraDirective, HoraLancamentoDirective, HotColumnComponent, HotTableComponent, HotTableModule, HttpClient, HttpClientInterceptorToken, HttpClientUtils, HttpError, IFrameComponent, IFrameModule, IFrameStore, ImageUploadComponent, ImageUploadModule, InformationComponent, InformationModule, InterceptorsProviders, ItemDetailInformationComponent, ItemDetailInformationDirective, JasperNotificationService, JasperService, JsonPatchUtil, JsonUpdateOperation, JsonUpdatePartial, JsonUtil, KEYCLOAK_AUTH_RESOURCES_CONFIG, KEY_CODE, KeycloakAuthHttp, KeycloakInterceptor, KeycloakToken, LESS_OPERATION, LESS_OR_EQUAL_OPERATION, LeisAtosAutoCompleteModalComponent, LeisAtosAutoCompleteModalModule, ListaModulosService, MODULO_KEY, MaskFormatDirective, MaskUtils, ModalFormInsertComponent, ModalFormInsertModule, ModalMenuComponent, ModalMenuModule, ModalMenuOptionComponent, MonthUtils, NOTIFICATION_CONFIG, NOT_CONTAINED_IN_CAPTION, NOT_CONTAINED_IN_OPERATION, NOT_CONTAINS_CAPTION, NOT_CONTAINS_OPERATION, NOT_EQUAL_OPERATION, NavigateUtils, NonNegativeDirective, NotificationReportJasperComponent, NotificationSystemService, NumberUtils, ObjectParseService, ObjectUtilService, OnBoardingComponent, OnBoardingModule, PAGE_REQUEST, PAGE_SIZE, PIPE_ENCODED, Page, PageBlockedComponent, PageBlockedModule, PageCustomizedComponent, PageCustomizedModule, PageForbiddenComponent, PageForbiddenModule, PageNotFoundComponent, PageNotFoundModule, PageParameters, PageUnavailableComponent, PageUnavailableModule, PaginationComponent, PaginationModule, PanelComponent, PanelExpansiveComponent, PanelExpansiveModule, PanelModule, PercentageFormatPipe, Periodo, PipeModule, PlacaDirective, PreventMultiClickDirective, PreviewBlockComponent, PreviewBlockItemComponent, PreviewComponent, PreviewModule, ProgressbarComponent, ProgressbarModule, QuadrimestreUtils, QueryBuilderComponent, QueryBuilderItemComponent, QueryBuilderTranslatorComponent, QuickViewComponent, QuickViewModule, RateioUtils, ReportFormatComponent, ReportFormatModule, ReportSelectorComponent, ReportSelectorModule, RevisionCompare, RodaAtalhosComponent, RodaAtalhosModule, Role, RolesCache, RotaFavoritaService, RouteUtils, RouterInterceptor, RouterService, RouterUtils, RsqlBuilder, SABADO, STARTS_WITH_CAPTION, STARTS_WITH_OPERATION, SafeUrlPipe, SearchFilter, SearchFilterComponent, SectionComponent, SectionDirective, SectionModule, SectionService, SelectOnFocusDirective, SemestreUtils, SideBarItemDirective, SidebarComponent, SidebarModule, SidebarService, SimNaoPipe, SingleClickButtonDirective, SortParameters, SortUtils, SortableHeaderComponent, SortableHeaderModule, SpinnerComponent, SpinnerInterceptor, SpinnerModule, SpinnerService, StringUtils, SubTipoPipe, SubscriptionWebsocket, SwitchButtonComponent, SwitchButtonItemComponent, SwitchButtonModule, SwitchComponent, SwitchModule, TO_FORMAT, TabControlComponent, TabControlModule, TabItemComponent, TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportModule, TableReportTotalComponent, TelefoneDirective, TelefonePipe, TestUtils, TestingUtils, TimeAgoPipe, TipoValidacaoEnum, TrimestreUtils, UrlResolver, UrlUtils, Usuario, UsuarioInfoUtils, UsuarioTrocaSenha, VIEWFORMAT, Version, VersionReloadHandlerComponent, VersionReloadModule, VirtualTreeViewComponent, VirtualTreeViewModule, WebsocketService, WidgetAreaComponent, WidgetFrequentlyComponent, WidgetFrequentlyItemComponent, WidgetFrequentlyItemModule, WidgetFrequentlyModule, WidgetHighlightComponent, WidgetModule, WidgetNumericComponent, WidgetPanelComponent, WidgetProgressComponent, WindowService, WizardControlComponent, WizardControlModule, WizardStepComponent, ZeroWhenEmptyDirective, autoCompleteValidator, bimestreNames, buildRespostasFromGrupoRespostaDTO, changeRespostasEntityFormArray, datePickerValidator, deepCopy, deepEqual, fieldNameGruposDefault, fieldNameRespostaDefault, initGruposRespostaForm, isFunction, isNumber, isRebrandingActive, isString, isUserAdmin, limparRespostas, makeButton, moment, monthNames, operatorsFilter, permissions, quadrimestreNames, queryBuilderValueEmpty, semestreNames, shouldRenderNewTheme, suffixNameElementCampoMultiplaEscolha, suffixNameElementCampoValor, switchTheme, trimestreNames, validQueryBuilderValue, validateCamposDinamicos };
